export const HEADER_TITLE_TRANSLATION_KEYS = {
  company: 'company.title',
  financial: 'financial.title',
  shipTo: 'shipTo.title',
  review: 'review.title'
};

export const HEADER_SUBTITLE_TRANSLATION_KEYS = {
  company: 'company.subtitle',
  review: 'review.subtitle',
  welcome: 'dashboard.greeting'
};

export const PAGE_ROUTES = {
  company: 'company',
  financial: 'financial',
  shipTo: 'shipTo',
  review: 'review',
  tracker: 'tracker',
  help: 'help',
  dashboard: 'dashboard',
  faq: 'FaqPage',
  faqPage: 'faqpage'
};

export const TAB_TITLE = {
  company: 'company',
  shipTo: 'ship to',
  financial: 'financial',
  review: 'review',
  tracker: 'tracker',
  dashboard: 'dashboard'
};

export const CONTROL_TYPE = {
  checkbox: 'checkbox',
  text: 'text',
  radio: 'radio',
  address: 'address',
  addressField: 'addressField',
  password: 'password',
  numberFormat: 'numberFormat',
  requiredGroup: 'requiredGroup',
  selectWithChildren: 'selectWithChildren',
  attachmentList: 'attachmentList',
  addressAutoComplete: 'addressAutoComplete',
  select: 'select',
  textarea: 'textarea',
  inputWithTags: 'inputWithTags',
  stateSelect: 'stateSelect',
  citySelect: 'citySelect'
};

const coa = 'coa.email';
const packingList = 'packingList.email';
const orderConfirmation = 'orderConfirmation.email';
const invoiceDelivery = 'invoiceDelivery.email';
export const CARD_TYPE = [coa, packingList, orderConfirmation, invoiceDelivery];

//Cases to ignore while showing request to customer
export const INVALID_COMBINATIONS = [
  { region: 'LATAM', countryCode: 'MX', business: 'GEOS MX' },
  { region: 'LATAM', countryCode: 'MX', business: 'CSST MX' },
  { region: 'LATAM', countryCode: 'MX', business: 'CBI MX' },
  { region: 'EMEA', countryCode: 'TR', business: 'GEOS TR' },
  { region: 'EMEA', countryCode: 'TR', business: 'CBI TR' },
  { region: 'EMEA', countryCode: 'TR', business: 'CSST TR' }
];

// Honeycomb request status
export const HC_STATUS = {
  initiated: 'initiated',
  draft: 'draft',
  submitted: 'submitted',
  pending: 'pending',
  masterDataCreation: 'masterDataCreation',
  informationProcessing: 'informationProcessing',
  financialReview: 'financialReview',
  completed: 'completed'
};

// Honeycomb request type for determining if the user is new or existing
export const HC_REQUEST_TYPE = {
  create: 'Create',
  maintain: 'Maintain'
};

// Honeycomb record type for determining the request subtype
export const HC_RECORD_TYPE = {
  billTo: 'Bill To',
  fullCustomer: 'Customer Set Up',
  payer: 'Payer',
  shipTo: 'Ship To',
  soldTo: 'Sold To'
};

export const NUMBER_FORMAT = {
  telephone: '###-###-####'
};

export const BRACKET_REGEX = /\[([^\]]*)\]/;

export const BUTTON_TITLE_TRANSLATION_KEYS = {
  back: 'buttons.back',
  next: 'buttons.next',
  review: 'buttons.review',
  submit: 'buttons.submit',
  sendMessage: 'buttons.sendMessage',
  contactSupport: 'buttons.contactSupport',
  backToSignIn: 'buttons.backToSignIn',
  goBack: 'buttons.goBack',
  save: 'buttons.save',
  remove: 'remove',
  close: 'buttons.close'
};

export const DIALOG_TITLE_TRANSLATION_KEYS = {
  survey: 'dialogs.survey.title',
  errorRequestingData: 'dialogs.errorRequestingData.title',
  errorOnSubmission: 'dialogs.errorOnSubmission.title',
  errorNoRequest: 'dialogs.errorNoRequest.title',
  generalError: 'dialogs.generalError.title',
  errorOnUpload: 'dialogs.errorOnUpload.title',
  errorOnUploadFileSize: 'dialogs.errorOnUploadFileSize.title',
  errorSignature: 'dialogs.errorSignature.title',
  taxExemptUpload: 'dialogs.taxExemptUpload.title',
  removeFile: 'dialogs.removeFile.title',
  errorAutoSave: 'dialogs.errorAutoSave.title',
  deleteShipTo: 'dialogs.deleteShipTo.title'
};

export const DIALOG_SUBTITLE_TRANSLATION_KEYS = {
  errorRequestingData: 'dialogs.errorRequestingData.body',
  errorOnSubmission: 'dialogs.errorOnSubmission.body',
  errorNoRequest: 'dialogs.errorNoRequest.body',
  generalError: 'dialogs.generalError.body',
  errorOnUpload: 'dialogs.errorOnUpload.body',
  errorOnUploadFileSize: 'dialogs.errorOnUploadFileSize.subtitle',
  errorSignature: 'dialogs.errorSignature.body'
};

export const cities = [
  {
    stateKey: 'AC',
    value: 'ACRELANDIA',
    label: 'ACRELANDIA'
  },
  {
    stateKey: 'AC',
    value: 'FEIJO',
    label: 'FEIJO'
  },
  {
    stateKey: 'AC',
    value: 'MANOEL URBANO',
    label: 'MANOEL URBANO'
  },
  {
    stateKey: 'AC',
    value: 'PLACIDO DE CASTRO',
    label: 'PLACIDO DE CASTRO'
  },
  {
    stateKey: 'AC',
    value: 'PORTO ACRE',
    label: 'PORTO ACRE'
  },
  {
    stateKey: 'AC',
    value: 'PORTO WALTER',
    label: 'PORTO WALTER'
  },
  {
    stateKey: 'AC',
    value: 'RIO BRANCO',
    label: 'RIO BRANCO'
  },
  {
    stateKey: 'AC',
    value: 'RODRIGUES ALVES',
    label: 'RODRIGUES ALVES'
  },
  {
    stateKey: 'AC',
    value: 'SANTA ROSA',
    label: 'SANTA ROSA'
  },
  {
    stateKey: 'AC',
    value: 'ASSIS BRASIL',
    label: 'ASSIS BRASIL'
  },
  {
    stateKey: 'AC',
    value: 'BRASILEIA',
    label: 'BRASILEIA'
  },
  {
    stateKey: 'AC',
    value: 'CAPIXABA',
    label: 'CAPIXABA'
  },
  {
    stateKey: 'AC',
    value: 'CRUZEIRO DO SUL',
    label: 'CRUZEIRO DO SUL'
  },
  {
    stateKey: 'AC',
    value: 'EPITACIOLANDIA',
    label: 'EPITACIOLANDIA'
  },
  {
    stateKey: 'AC',
    value: 'JORDAO',
    label: 'JORDAO'
  },
  {
    stateKey: 'AC',
    value: 'MANCIO LIMA',
    label: 'MANCIO LIMA'
  },
  {
    stateKey: 'AC',
    value: 'MARECHAL THAUMATURGO',
    label: 'MARECHAL THAUMATURGO'
  },
  {
    stateKey: 'AC',
    value: 'SENA MADUREIRA',
    label: 'SENA MADUREIRA'
  },
  {
    stateKey: 'AC',
    value: 'SENADOR GUIOMARD',
    label: 'SENADOR GUIOMARD'
  },
  {
    stateKey: 'AC',
    value: 'TARAUACA',
    label: 'TARAUACA'
  },
  {
    stateKey: 'AC',
    value: 'XAPURI',
    label: 'XAPURI'
  },
  {
    stateKey: 'AC',
    value: 'BUJARI',
    label: 'BUJARI'
  },
  {
    stateKey: 'AL',
    value: 'BARRA DE SANTO ANTONIO',
    label: 'BARRA DE SANTO ANTONIO'
  },
  {
    stateKey: 'AL',
    value: 'BATALHA',
    label: 'BATALHA'
  },
  {
    stateKey: 'AL',
    value: 'BELEM',
    label: 'BELEM'
  },
  {
    stateKey: 'AL',
    value: 'BELO MONTE',
    label: 'BELO MONTE'
  },
  {
    stateKey: 'AL',
    value: 'BOCA DA MATA',
    label: 'BOCA DA MATA'
  },
  {
    stateKey: 'AL',
    value: 'CACIMBINHAS',
    label: 'CACIMBINHAS'
  },
  {
    stateKey: 'AL',
    value: 'CAJUEIRO',
    label: 'CAJUEIRO'
  },
  {
    stateKey: 'AL',
    value: 'CAMPESTRE',
    label: 'CAMPESTRE'
  },
  {
    stateKey: 'AL',
    value: 'CAMPO GRANDE',
    label: 'CAMPO GRANDE'
  },
  {
    stateKey: 'AL',
    value: 'CAPELA',
    label: 'CAPELA'
  },
  {
    stateKey: 'AL',
    value: 'CARNEIROS',
    label: 'CARNEIROS'
  },
  {
    stateKey: 'AL',
    value: 'CHA PRETA',
    label: 'CHA PRETA'
  },
  {
    stateKey: 'AL',
    value: 'COITE DO NOIA',
    label: 'COITE DO NOIA'
  },
  {
    stateKey: 'AL',
    value: 'COLONIA LEOPOLDINA',
    label: 'COLONIA LEOPOLDINA'
  },
  {
    stateKey: 'AL',
    value: 'COQUEIRO SECO',
    label: 'COQUEIRO SECO'
  },
  {
    stateKey: 'AL',
    value: 'CORURIPE',
    label: 'CORURIPE'
  },
  {
    stateKey: 'AL',
    value: 'CRAIBAS',
    label: 'CRAIBAS'
  },
  {
    stateKey: 'AL',
    value: 'DELMIRO GOUVEIA',
    label: 'DELMIRO GOUVEIA'
  },
  {
    stateKey: 'AL',
    value: 'DOIS RIACHOS',
    label: 'DOIS RIACHOS'
  },
  {
    stateKey: 'AL',
    value: 'ESTRELA DE ALAGOAS',
    label: 'ESTRELA DE ALAGOAS'
  },
  {
    stateKey: 'AL',
    value: 'FEIRA GRANDE',
    label: 'FEIRA GRANDE'
  },
  {
    stateKey: 'AL',
    value: 'FELIZ DESERTO',
    label: 'FELIZ DESERTO'
  },
  {
    stateKey: 'AL',
    value: 'FLEXEIRAS',
    label: 'FLEXEIRAS'
  },
  {
    stateKey: 'AL',
    value: 'GIRAU DO PONCIANO',
    label: 'GIRAU DO PONCIANO'
  },
  {
    stateKey: 'AL',
    value: 'IBATEGUARA',
    label: 'IBATEGUARA'
  },
  {
    stateKey: 'AL',
    value: 'IGACI',
    label: 'IGACI'
  },
  {
    stateKey: 'AL',
    value: 'IGREJA NOVA',
    label: 'IGREJA NOVA'
  },
  {
    stateKey: 'AL',
    value: 'INHAPI',
    label: 'INHAPI'
  },
  {
    stateKey: 'AL',
    value: 'JACARE DOS HOMENS',
    label: 'JACARE DOS HOMENS'
  },
  {
    stateKey: 'AL',
    value: 'JAPARATINGA',
    label: 'JAPARATINGA'
  },
  {
    stateKey: 'AL',
    value: 'JOAQUIM GOMES',
    label: 'JOAQUIM GOMES'
  },
  {
    stateKey: 'AL',
    value: 'JUNDIA',
    label: 'JUNDIA'
  },
  {
    stateKey: 'AL',
    value: 'JUNQUEIRO',
    label: 'JUNQUEIRO'
  },
  {
    stateKey: 'AL',
    value: 'LAGOA DA CANOA',
    label: 'LAGOA DA CANOA'
  },
  {
    stateKey: 'AL',
    value: 'LIMOEIRO DE ANADIA',
    label: 'LIMOEIRO DE ANADIA'
  },
  {
    stateKey: 'AL',
    value: 'MACEIO',
    label: 'MACEIO'
  },
  {
    stateKey: 'AL',
    value: 'MAJOR ISIDORO',
    label: 'MAJOR ISIDORO'
  },
  {
    stateKey: 'AL',
    value: 'MAR VERMELHO',
    label: 'MAR VERMELHO'
  },
  {
    stateKey: 'AL',
    value: 'MARAGOGI',
    label: 'MARAGOGI'
  },
  {
    stateKey: 'AL',
    value: 'MARAVILHA',
    label: 'MARAVILHA'
  },
  {
    stateKey: 'AL',
    value: 'MARECHAL DEODORO',
    label: 'MARECHAL DEODORO'
  },
  {
    stateKey: 'AL',
    value: 'MARIBONDO',
    label: 'MARIBONDO'
  },
  {
    stateKey: 'AL',
    value: 'MONTEIROPOLIS',
    label: 'MONTEIROPOLIS'
  },
  {
    stateKey: 'AL',
    value: 'NOVO LINO',
    label: 'NOVO LINO'
  },
  {
    stateKey: 'AL',
    value: "OLHO D'AGUA DAS FLORES",
    label: "OLHO D'AGUA DAS FLORES"
  },
  {
    stateKey: 'AL',
    value: 'OLIVENCA',
    label: 'OLIVENCA'
  },
  {
    stateKey: 'AL',
    value: 'OURO BRANCO',
    label: 'OURO BRANCO'
  },
  {
    stateKey: 'AL',
    value: 'PAO DE ACUCAR',
    label: 'PAO DE ACUCAR'
  },
  {
    stateKey: 'AL',
    value: 'PARIPUEIRA',
    label: 'PARIPUEIRA'
  },
  {
    stateKey: 'AL',
    value: 'PAULO JACINTO',
    label: 'PAULO JACINTO'
  },
  {
    stateKey: 'AL',
    value: 'PENEDO',
    label: 'PENEDO'
  },
  {
    stateKey: 'AL',
    value: 'PILAR',
    label: 'PILAR'
  },
  {
    stateKey: 'AL',
    value: 'PINDOBA',
    label: 'PINDOBA'
  },
  {
    stateKey: 'AL',
    value: 'PIRANHAS',
    label: 'PIRANHAS'
  },
  {
    stateKey: 'AL',
    value: 'POCO DAS TRINCHEIRAS',
    label: 'POCO DAS TRINCHEIRAS'
  },
  {
    stateKey: 'AL',
    value: 'PORTO CALVO',
    label: 'PORTO CALVO'
  },
  {
    stateKey: 'AL',
    value: 'PORTO DE PEDRAS',
    label: 'PORTO DE PEDRAS'
  },
  {
    stateKey: 'AL',
    value: 'PORTO REAL DO COLEGIO',
    label: 'PORTO REAL DO COLEGIO'
  },
  {
    stateKey: 'AL',
    value: 'QUEBRANGULO',
    label: 'QUEBRANGULO'
  },
  {
    stateKey: 'AL',
    value: 'RIO LARGO',
    label: 'RIO LARGO'
  },
  {
    stateKey: 'AL',
    value: 'ROTEIRO',
    label: 'ROTEIRO'
  },
  {
    stateKey: 'AL',
    value: 'SANTA LUZIA DO NORTE',
    label: 'SANTA LUZIA DO NORTE'
  },
  {
    stateKey: 'AL',
    value: 'SANTANA DO IPANEMA',
    label: 'SANTANA DO IPANEMA'
  },
  {
    stateKey: 'AL',
    value: 'SANTANA DO MUNDAU',
    label: 'SANTANA DO MUNDAU'
  },
  {
    stateKey: 'AL',
    value: 'SAO BRAS',
    label: 'SAO BRAS'
  },
  {
    stateKey: 'AL',
    value: 'SAO JOSE DA LAJE',
    label: 'SAO JOSE DA LAJE'
  },
  {
    stateKey: 'AL',
    value: 'SAO LUIS DO QUITUNDE',
    label: 'SAO LUIS DO QUITUNDE'
  },
  {
    stateKey: 'AL',
    value: 'SAO MIGUEL DOS MILAGRES',
    label: 'SAO MIGUEL DOS MILAGRES'
  },
  {
    stateKey: 'AL',
    value: 'SATUBA',
    label: 'SATUBA'
  },
  {
    stateKey: 'AL',
    value: 'SENADOR RUI PALMEIRA',
    label: 'SENADOR RUI PALMEIRA'
  },
  {
    stateKey: 'AL',
    value: "TANQUE D'ARCA",
    label: "TANQUE D'ARCA"
  },
  {
    stateKey: 'AL',
    value: 'TAQUARANA',
    label: 'TAQUARANA'
  },
  {
    stateKey: 'AL',
    value: 'TEOTONIO VILELA',
    label: 'TEOTONIO VILELA'
  },
  {
    stateKey: 'AL',
    value: 'TRAIPU',
    label: 'TRAIPU'
  },
  {
    stateKey: 'AL',
    value: 'UNIAO DOS PALMARES',
    label: 'UNIAO DOS PALMARES'
  },
  {
    stateKey: 'AL',
    value: 'VICOSA',
    label: 'VICOSA'
  },
  {
    stateKey: 'AL',
    value: 'AGUA BRANCA',
    label: 'AGUA BRANCA'
  },
  {
    stateKey: 'AL',
    value: 'ANADIA',
    label: 'ANADIA'
  },
  {
    stateKey: 'AL',
    value: 'ARAPIRACA',
    label: 'ARAPIRACA'
  },
  {
    stateKey: 'AL',
    value: 'ATALAIA',
    label: 'ATALAIA'
  },
  {
    stateKey: 'AL',
    value: 'BARRA DE SAO MIGUEL',
    label: 'BARRA DE SAO MIGUEL'
  },
  {
    stateKey: 'AL',
    value: 'BRANQUINHA',
    label: 'BRANQUINHA'
  },
  {
    stateKey: 'AL',
    value: 'CAMPO ALEGRE',
    label: 'CAMPO ALEGRE'
  },
  {
    stateKey: 'AL',
    value: 'CANAPI',
    label: 'CANAPI'
  },
  {
    stateKey: 'AL',
    value: 'JACUIPE',
    label: 'JACUIPE'
  },
  {
    stateKey: 'AL',
    value: 'JARAMATAIA',
    label: 'JARAMATAIA'
  },
  {
    stateKey: 'AL',
    value: 'MATA GRANDE',
    label: 'MATA GRANDE'
  },
  {
    stateKey: 'AL',
    value: 'MATRIZ DE CAMARAGIBE',
    label: 'MATRIZ DE CAMARAGIBE'
  },
  {
    stateKey: 'AL',
    value: 'MESSIAS',
    label: 'MESSIAS'
  },
  {
    stateKey: 'AL',
    value: 'MINADOR DO NEGRAO',
    label: 'MINADOR DO NEGRAO'
  },
  {
    stateKey: 'AL',
    value: 'MURICI',
    label: 'MURICI'
  },
  {
    stateKey: 'AL',
    value: "OLHO D'AGUA DO CASADO",
    label: "OLHO D'AGUA DO CASADO"
  },
  {
    stateKey: 'AL',
    value: 'PALESTINA',
    label: 'PALESTINA'
  },
  {
    stateKey: 'AL',
    value: 'PALMEIRA DOS INDIOS',
    label: 'PALMEIRA DOS INDIOS'
  },
  {
    stateKey: 'AL',
    value: 'PARICONHA',
    label: 'PARICONHA'
  },
  {
    stateKey: 'AL',
    value: 'PASSO DE CAMARAGIBE',
    label: 'PASSO DE CAMARAGIBE'
  },
  {
    stateKey: 'AL',
    value: 'PIACABUCU',
    label: 'PIACABUCU'
  },
  {
    stateKey: 'AL',
    value: 'SAO JOSE DA TAPERA',
    label: 'SAO JOSE DA TAPERA'
  },
  {
    stateKey: 'AL',
    value: 'SAO MIGUEL DOS CAMPOS',
    label: 'SAO MIGUEL DOS CAMPOS'
  },
  {
    stateKey: 'AL',
    value: 'SAO SEBASTIAO',
    label: 'SAO SEBASTIAO'
  },
  {
    stateKey: 'AL',
    value: 'Jequiá da Praia',
    label: 'Jequiá da Praia'
  },
  {
    stateKey: 'AL',
    value: "OLHO D'AGUA GRANDE",
    label: "OLHO D'AGUA GRANDE"
  },
  {
    stateKey: 'AP',
    value: 'AMAPA',
    label: 'AMAPA'
  },
  {
    stateKey: 'AP',
    value: 'CALCOENE',
    label: 'CALCOENE'
  },
  {
    stateKey: 'AP',
    value: 'CUTIAS',
    label: 'CUTIAS'
  },
  {
    stateKey: 'AP',
    value: 'FERREIRA GOMES',
    label: 'FERREIRA GOMES'
  },
  {
    stateKey: 'AP',
    value: 'ITAUBAL',
    label: 'ITAUBAL'
  },
  {
    stateKey: 'AP',
    value: 'LARANJAL DO JARI',
    label: 'LARANJAL DO JARI'
  },
  {
    stateKey: 'AP',
    value: 'MACAPA',
    label: 'MACAPA'
  },
  {
    stateKey: 'AP',
    value: 'MAZAGAO',
    label: 'MAZAGAO'
  },
  {
    stateKey: 'AP',
    value: 'OIAPOQUE',
    label: 'OIAPOQUE'
  },
  {
    stateKey: 'AP',
    value: 'PORTO GRANDE',
    label: 'PORTO GRANDE'
  },
  {
    stateKey: 'AP',
    value: 'PRACUUBA',
    label: 'PRACUUBA'
  },
  {
    stateKey: 'AP',
    value: 'SANTANA',
    label: 'SANTANA'
  },
  {
    stateKey: 'AP',
    value: 'TARTARUGALZINHO',
    label: 'TARTARUGALZINHO'
  },
  {
    stateKey: 'AP',
    value: 'VITORIA DO JARI',
    label: 'VITORIA DO JARI'
  },
  {
    stateKey: 'AP',
    value: 'Pedra Branca do Amapari',
    label: 'Pedra Branca do Amapari'
  },
  {
    stateKey: 'AP',
    value: 'SERRA DO NAVIO',
    label: 'SERRA DO NAVIO'
  },
  {
    stateKey: 'AM',
    value: 'ALVARAES',
    label: 'ALVARAES'
  },
  {
    stateKey: 'AM',
    value: 'AMATURA',
    label: 'AMATURA'
  },
  {
    stateKey: 'AM',
    value: 'ANAMA',
    label: 'ANAMA'
  },
  {
    stateKey: 'AM',
    value: 'APORI',
    label: 'APORI'
  },
  {
    stateKey: 'AM',
    value: 'APUI',
    label: 'APUI'
  },
  {
    stateKey: 'AM',
    value: 'ATALAIA DO NORTE',
    label: 'ATALAIA DO NORTE'
  },
  {
    stateKey: 'AM',
    value: 'AUTAZES',
    label: 'AUTAZES'
  },
  {
    stateKey: 'AM',
    value: 'BARREIRINHA',
    label: 'BARREIRINHA'
  },
  {
    stateKey: 'AM',
    value: 'BERURI',
    label: 'BERURI'
  },
  {
    stateKey: 'AM',
    value: 'BOA VISTA DO RAMOS',
    label: 'BOA VISTA DO RAMOS'
  },
  {
    stateKey: 'AM',
    value: 'BORBA',
    label: 'BORBA'
  },
  {
    stateKey: 'AM',
    value: 'CANUTAMA',
    label: 'CANUTAMA'
  },
  {
    stateKey: 'AM',
    value: 'CARAUARI',
    label: 'CARAUARI'
  },
  {
    stateKey: 'AM',
    value: 'CAREIRO ',
    label: 'CAREIRO'
  },
  {
    stateKey: 'AM',
    value: 'CAREIRO DA VARZEA',
    label: 'CAREIRO DA VARZEA'
  },
  {
    stateKey: 'AM',
    value: 'COARI',
    label: 'COARI'
  },
  {
    stateKey: 'AM',
    value: 'CODAJAS',
    label: 'CODAJAS'
  },
  {
    stateKey: 'AM',
    value: 'ENVIRA',
    label: 'ENVIRA'
  },
  {
    stateKey: 'AM',
    value: 'GUAJARA',
    label: 'GUAJARA'
  },
  {
    stateKey: 'AM',
    value: 'HUMAITA',
    label: 'HUMAITA'
  },
  {
    stateKey: 'AM',
    value: 'IPIXUNA',
    label: 'IPIXUNA'
  },
  {
    stateKey: 'AM',
    value: 'ITACOATIARA',
    label: 'ITACOATIARA'
  },
  {
    stateKey: 'AM',
    value: 'ITAMARATI',
    label: 'ITAMARATI'
  },
  {
    stateKey: 'AM',
    value: 'ITAPIRANGA',
    label: 'ITAPIRANGA'
  },
  {
    stateKey: 'AM',
    value: 'JURUA',
    label: 'JURUA'
  },
  {
    stateKey: 'AM',
    value: 'LABREA',
    label: 'LABREA'
  },
  {
    stateKey: 'AM',
    value: 'MANAQUIRI',
    label: 'MANAQUIRI'
  },
  {
    stateKey: 'AM',
    value: 'MANAUS',
    label: 'MANAUS'
  },
  {
    stateKey: 'AM',
    value: 'MANICORE',
    label: 'MANICORE'
  },
  {
    stateKey: 'AM',
    value: 'MARAA',
    label: 'MARAA'
  },
  {
    stateKey: 'AM',
    value: 'MAUES',
    label: 'MAUES'
  },
  {
    stateKey: 'AM',
    value: 'BARCELOS',
    label: 'BARCELOS'
  },
  {
    stateKey: 'AM',
    value: 'BENJAMIN CONSTANT',
    label: 'BENJAMIN CONSTANT'
  },
  {
    stateKey: 'AM',
    value: 'BOCA DO ACRE',
    label: 'BOCA DO ACRE'
  },
  {
    stateKey: 'AM',
    value: 'CAAPIRANGA',
    label: 'CAAPIRANGA'
  },
  {
    stateKey: 'AM',
    value: 'EIRUNEPE',
    label: 'EIRUNEPE'
  },
  {
    stateKey: 'AM',
    value: 'FONTE BOA',
    label: 'FONTE BOA'
  },
  {
    stateKey: 'AM',
    value: 'IRANDUBA',
    label: 'IRANDUBA'
  },
  {
    stateKey: 'AM',
    value: 'JAPURA',
    label: 'JAPURA'
  },
  {
    stateKey: 'AM',
    value: 'JUTAI',
    label: 'JUTAI'
  },
  {
    stateKey: 'AM',
    value: 'MANACAPURU',
    label: 'MANACAPURU'
  },
  {
    stateKey: 'AM',
    value: 'NHAMUNDA',
    label: 'NHAMUNDA'
  },
  {
    stateKey: 'AM',
    value: 'NOVA OLINDA DO NORTE',
    label: 'NOVA OLINDA DO NORTE'
  },
  {
    stateKey: 'AM',
    value: 'NOVO AIRAO',
    label: 'NOVO AIRAO'
  },
  {
    stateKey: 'AM',
    value: 'NOVO ARIPUANA',
    label: 'NOVO ARIPUANA'
  },
  {
    stateKey: 'AM',
    value: 'PARINTINS',
    label: 'PARINTINS'
  },
  {
    stateKey: 'AM',
    value: 'PAUINI',
    label: 'PAUINI'
  },
  {
    stateKey: 'AM',
    value: 'PRESIDENTE FIGUEIREDO',
    label: 'PRESIDENTE FIGUEIREDO'
  },
  {
    stateKey: 'AM',
    value: 'RIO PRETO DA EVA',
    label: 'RIO PRETO DA EVA'
  },
  {
    stateKey: 'AM',
    value: 'SANTA IZABEL DO RIO NEGRO',
    label: 'SANTA IZABEL DO RIO NEGRO'
  },
  {
    stateKey: 'AM',
    value: 'SANTO ANTONIO DO ICA',
    label: 'SANTO ANTONIO DO ICA'
  },
  {
    stateKey: 'AM',
    value: 'SAO GABRIEL DA CACHOEIRA',
    label: 'SAO GABRIEL DA CACHOEIRA'
  },
  {
    stateKey: 'AM',
    value: 'SAO PAULO DE OLIVENCA',
    label: 'SAO PAULO DE OLIVENCA'
  },
  {
    stateKey: 'AM',
    value: 'SAO SEBASTIAO DO UATUMA',
    label: 'SAO SEBASTIAO DO UATUMA'
  },
  {
    stateKey: 'AM',
    value: 'SILVES',
    label: 'SILVES'
  },
  {
    stateKey: 'AM',
    value: 'TABATINGA',
    label: 'TABATINGA'
  },
  {
    stateKey: 'AM',
    value: 'TAPAUA',
    label: 'TAPAUA'
  },
  {
    stateKey: 'AM',
    value: 'TEFE',
    label: 'TEFE'
  },
  {
    stateKey: 'AM',
    value: 'TONANTINS',
    label: 'TONANTINS'
  },
  {
    stateKey: 'AM',
    value: 'UARINI',
    label: 'UARINI'
  },
  {
    stateKey: 'AM',
    value: 'URUCARA',
    label: 'URUCARA'
  },
  {
    stateKey: 'AM',
    value: 'URUCURITUBA',
    label: 'URUCURITUBA'
  },
  {
    stateKey: 'AM',
    value: 'Anori',
    label: 'Anori'
  },
  {
    stateKey: 'AM',
    value: 'AMATARI',
    label: 'AMATARI'
  },
  {
    stateKey: 'AM',
    value: 'IAUARETE',
    label: 'IAUARETE'
  },
  {
    stateKey: 'AM',
    value: 'MOURA',
    label: 'MOURA'
  },
  {
    stateKey: 'AM',
    value: 'AXININ',
    label: 'AXININ'
  },
  {
    stateKey: 'AM',
    value: 'SUCUNDURI',
    label: 'SUCUNDURI'
  },
  {
    stateKey: 'AM',
    value: 'AUXILIADORA',
    label: 'AUXILIADORA'
  },
  {
    stateKey: 'AM',
    value: 'BITTENCOURT',
    label: 'BITTENCOURT'
  },
  {
    stateKey: 'AM',
    value: 'TAMANIQUA',
    label: 'TAMANIQUA'
  },
  {
    stateKey: 'AM',
    value: 'CANAMARI',
    label: 'CANAMARI'
  },
  {
    stateKey: 'AM',
    value: 'ESTIRAO DO EQUADOR',
    label: 'ESTIRAO DO EQUADOR'
  },
  {
    stateKey: 'AM',
    value: 'CAMARUA',
    label: 'CAMARUA'
  },
  {
    stateKey: 'BA',
    value: 'ABAIRA',
    label: 'ABAIRA'
  },
  {
    stateKey: 'BA',
    value: 'ABARE',
    label: 'ABARE'
  },
  {
    stateKey: 'BA',
    value: 'ACAJUTIBA',
    label: 'ACAJUTIBA'
  },
  {
    stateKey: 'BA',
    value: 'ADUSTINA',
    label: 'ADUSTINA'
  },
  {
    stateKey: 'BA',
    value: 'AGUA FRIA',
    label: 'AGUA FRIA'
  },
  {
    stateKey: 'BA',
    value: 'AIQUARA',
    label: 'AIQUARA'
  },
  {
    stateKey: 'BA',
    value: 'ALAGOINHAS',
    label: 'ALAGOINHAS'
  },
  {
    stateKey: 'BA',
    value: 'ALCOBACA',
    label: 'ALCOBACA'
  },
  {
    stateKey: 'BA',
    value: 'ALMADINA',
    label: 'ALMADINA'
  },
  {
    stateKey: 'BA',
    value: 'AMARGOSA',
    label: 'AMARGOSA'
  },
  {
    stateKey: 'BA',
    value: 'AMELIA RODRIGUES',
    label: 'AMELIA RODRIGUES'
  },
  {
    stateKey: 'BA',
    value: 'AMERICA DOURADA',
    label: 'AMERICA DOURADA'
  },
  {
    stateKey: 'BA',
    value: 'ANAGE',
    label: 'ANAGE'
  },
  {
    stateKey: 'BA',
    value: 'ANDARAI',
    label: 'ANDARAI'
  },
  {
    stateKey: 'BA',
    value: 'ANDORINHA',
    label: 'ANDORINHA'
  },
  {
    stateKey: 'BA',
    value: 'ANGICAL',
    label: 'ANGICAL'
  },
  {
    stateKey: 'BA',
    value: 'ANGUERA',
    label: 'ANGUERA'
  },
  {
    stateKey: 'BA',
    value: 'ANTAS',
    label: 'ANTAS'
  },
  {
    stateKey: 'BA',
    value: 'ANTONIO CARDOSO',
    label: 'ANTONIO CARDOSO'
  },
  {
    stateKey: 'BA',
    value: 'ANTONIO GONCALVES',
    label: 'ANTONIO GONCALVES'
  },
  {
    stateKey: 'BA',
    value: 'APORA ',
    label: 'APORA'
  },
  {
    stateKey: 'BA',
    value: 'APUAREMA',
    label: 'APUAREMA'
  },
  {
    stateKey: 'BA',
    value: 'ARACAS',
    label: 'ARACAS'
  },
  {
    stateKey: 'BA',
    value: 'ARACATU',
    label: 'ARACATU'
  },
  {
    stateKey: 'BA',
    value: 'ARACI',
    label: 'ARACI'
  },
  {
    stateKey: 'BA',
    value: 'ARAMARI',
    label: 'ARAMARI'
  },
  {
    stateKey: 'BA',
    value: 'ARATACA',
    label: 'ARATACA'
  },
  {
    stateKey: 'BA',
    value: 'ARATUIPE',
    label: 'ARATUIPE'
  },
  {
    stateKey: 'BA',
    value: 'AURELINO LEAL',
    label: 'AURELINO LEAL'
  },
  {
    stateKey: 'BA',
    value: 'BAIANOPOLIS',
    label: 'BAIANOPOLIS'
  },
  {
    stateKey: 'BA',
    value: 'BAIXA GRANDE',
    label: 'BAIXA GRANDE'
  },
  {
    stateKey: 'BA',
    value: 'BANZAE',
    label: 'BANZAE'
  },
  {
    stateKey: 'BA',
    value: 'BARRA',
    label: 'BARRA'
  },
  {
    stateKey: 'BA',
    value: 'BARRA DA ESTIVA',
    label: 'BARRA DA ESTIVA'
  },
  {
    stateKey: 'BA',
    value: 'BARRA DO CHOCA',
    label: 'BARRA DO CHOCA'
  },
  {
    stateKey: 'BA',
    value: 'BARRA DO MENDES',
    label: 'BARRA DO MENDES'
  },
  {
    stateKey: 'BA',
    value: 'BARRA DO ROCHA',
    label: 'BARRA DO ROCHA'
  },
  {
    stateKey: 'BA',
    value: 'BARREIRAS',
    label: 'BARREIRAS'
  },
  {
    stateKey: 'BA',
    value: 'BARRO ALTO',
    label: 'BARRO ALTO'
  },
  {
    stateKey: 'BA',
    value: 'BARRO PRETO',
    label: 'BARRO PRETO'
  },
  {
    stateKey: 'BA',
    value: 'BELMONTE',
    label: 'BELMONTE'
  },
  {
    stateKey: 'BA',
    value: 'BELO CAMPO',
    label: 'BELO CAMPO'
  },
  {
    stateKey: 'BA',
    value: 'BIRITINGA',
    label: 'BIRITINGA'
  },
  {
    stateKey: 'BA',
    value: 'BOA NOVA',
    label: 'BOA NOVA'
  },
  {
    stateKey: 'BA',
    value: 'BOA VISTA DO TUPIM',
    label: 'BOA VISTA DO TUPIM'
  },
  {
    stateKey: 'BA',
    value: 'BOM JESUS DA LAPA',
    label: 'BOM JESUS DA LAPA'
  },
  {
    stateKey: 'BA',
    value: 'BOM JESUS DA SERRA',
    label: 'BOM JESUS DA SERRA'
  },
  {
    stateKey: 'BA',
    value: 'BONINAL',
    label: 'BONINAL'
  },
  {
    stateKey: 'BA',
    value: 'BONITO',
    label: 'BONITO'
  },
  {
    stateKey: 'BA',
    value: 'BOQUIRA',
    label: 'BOQUIRA'
  },
  {
    stateKey: 'BA',
    value: 'BOTUPORA',
    label: 'BOTUPORA'
  },
  {
    stateKey: 'BA',
    value: 'BREJOES',
    label: 'BREJOES'
  },
  {
    stateKey: 'BA',
    value: 'BREJOLANDIA',
    label: 'BREJOLANDIA'
  },
  {
    stateKey: 'BA',
    value: 'BROTAS DE MACAUBAS',
    label: 'BROTAS DE MACAUBAS'
  },
  {
    stateKey: 'BA',
    value: 'BRUMADO',
    label: 'BRUMADO'
  },
  {
    stateKey: 'BA',
    value: 'BUERAREMA',
    label: 'BUERAREMA'
  },
  {
    stateKey: 'BA',
    value: 'BURITIRAMA',
    label: 'BURITIRAMA'
  },
  {
    stateKey: 'BA',
    value: 'CAATIBA',
    label: 'CAATIBA'
  },
  {
    stateKey: 'BA',
    value: 'CABECEIRAS DO PARAGUACU',
    label: 'CABECEIRAS DO PARAGUACU'
  },
  {
    stateKey: 'BA',
    value: 'CACHOEIRA',
    label: 'CACHOEIRA'
  },
  {
    stateKey: 'BA',
    value: 'CACULE',
    label: 'CACULE'
  },
  {
    stateKey: 'BA',
    value: 'CAEM',
    label: 'CAEM'
  },
  {
    stateKey: 'BA',
    value: 'CAETANOS',
    label: 'CAETANOS'
  },
  {
    stateKey: 'BA',
    value: 'CAETITE',
    label: 'CAETITE'
  },
  {
    stateKey: 'BA',
    value: 'CAFARNAUM',
    label: 'CAFARNAUM'
  },
  {
    stateKey: 'BA',
    value: 'CAIRU',
    label: 'CAIRU'
  },
  {
    stateKey: 'BA',
    value: 'CALDEIRAO GRANDE',
    label: 'CALDEIRAO GRANDE'
  },
  {
    stateKey: 'BA',
    value: 'CAMACA',
    label: 'CAMACA'
  },
  {
    stateKey: 'BA',
    value: 'CAMACARI',
    label: 'CAMACARI'
  },
  {
    stateKey: 'BA',
    value: 'CAMAMU',
    label: 'CAMAMU'
  },
  {
    stateKey: 'BA',
    value: 'CAMPO ALEGRE DE LOURDES',
    label: 'CAMPO ALEGRE DE LOURDES'
  },
  {
    stateKey: 'BA',
    value: 'CAMPO FORMOSO',
    label: 'CAMPO FORMOSO'
  },
  {
    stateKey: 'BA',
    value: 'CANAPOLIS',
    label: 'CANAPOLIS'
  },
  {
    stateKey: 'BA',
    value: 'CANARANA',
    label: 'CANARANA'
  },
  {
    stateKey: 'BA',
    value: 'CANAVIEIRAS',
    label: 'CANAVIEIRAS'
  },
  {
    stateKey: 'BA',
    value: 'CANDEAL',
    label: 'CANDEAL'
  },
  {
    stateKey: 'BA',
    value: 'CANDEIAS',
    label: 'CANDEIAS'
  },
  {
    stateKey: 'BA',
    value: 'CANDIBA',
    label: 'CANDIBA'
  },
  {
    stateKey: 'BA',
    value: 'CANDIDO SALES',
    label: 'CANDIDO SALES'
  },
  {
    stateKey: 'BA',
    value: 'CANSANCAO',
    label: 'CANSANCAO'
  },
  {
    stateKey: 'BA',
    value: 'CANUDOS',
    label: 'CANUDOS'
  },
  {
    stateKey: 'BA',
    value: 'CAPELA DO ALTO ALEGRE',
    label: 'CAPELA DO ALTO ALEGRE'
  },
  {
    stateKey: 'BA',
    value: 'CAPIM GROSSO',
    label: 'CAPIM GROSSO'
  },
  {
    stateKey: 'BA',
    value: 'CARAIBAS',
    label: 'CARAIBAS'
  },
  {
    stateKey: 'BA',
    value: 'CARAVELAS',
    label: 'CARAVELAS'
  },
  {
    stateKey: 'BA',
    value: 'CARDEAL DA SILVA',
    label: 'CARDEAL DA SILVA'
  },
  {
    stateKey: 'BA',
    value: 'CARINHANHA',
    label: 'CARINHANHA'
  },
  {
    stateKey: 'BA',
    value: 'CASA NOVA',
    label: 'CASA NOVA'
  },
  {
    stateKey: 'BA',
    value: 'CASTRO ALVES',
    label: 'CASTRO ALVES'
  },
  {
    stateKey: 'BA',
    value: 'CATOLANDIA',
    label: 'CATOLANDIA'
  },
  {
    stateKey: 'BA',
    value: 'CATU',
    label: 'CATU'
  },
  {
    stateKey: 'BA',
    value: 'CATURAMA',
    label: 'CATURAMA'
  },
  {
    stateKey: 'BA',
    value: 'CENTRAL',
    label: 'CENTRAL'
  },
  {
    stateKey: 'BA',
    value: 'CHORROCHO',
    label: 'CHORROCHO'
  },
  {
    stateKey: 'BA',
    value: 'CICERO DANTAS',
    label: 'CICERO DANTAS'
  },
  {
    stateKey: 'BA',
    value: 'CIPO',
    label: 'CIPO'
  },
  {
    stateKey: 'BA',
    value: 'COARACI',
    label: 'COARACI'
  },
  {
    stateKey: 'BA',
    value: 'COCOS',
    label: 'COCOS'
  },
  {
    stateKey: 'BA',
    value: 'CONCEICAO DA FEIRA',
    label: 'CONCEICAO DA FEIRA'
  },
  {
    stateKey: 'BA',
    value: 'CONCEICAO DO COITE',
    label: 'CONCEICAO DO COITE'
  },
  {
    stateKey: 'BA',
    value: 'CONCEICAO DO JACUIPE',
    label: 'CONCEICAO DO JACUIPE'
  },
  {
    stateKey: 'BA',
    value: 'CONDE',
    label: 'CONDE'
  },
  {
    stateKey: 'BA',
    value: 'CONDEUBA',
    label: 'CONDEUBA'
  },
  {
    stateKey: 'BA',
    value: 'CONTENDAS DO SINCORA',
    label: 'CONTENDAS DO SINCORA'
  },
  {
    stateKey: 'BA',
    value: 'CORACAO DE MARIA',
    label: 'CORACAO DE MARIA'
  },
  {
    stateKey: 'BA',
    value: 'CORDEIROS',
    label: 'CORDEIROS'
  },
  {
    stateKey: 'BA',
    value: 'CORIBE',
    label: 'CORIBE'
  },
  {
    stateKey: 'BA',
    value: 'CORONEL JOAO SA',
    label: 'CORONEL JOAO SA'
  },
  {
    stateKey: 'BA',
    value: 'CORRENTINA',
    label: 'CORRENTINA'
  },
  {
    stateKey: 'BA',
    value: 'COTEGIPE',
    label: 'COTEGIPE'
  },
  {
    stateKey: 'BA',
    value: 'CRAVOLANDIA',
    label: 'CRAVOLANDIA'
  },
  {
    stateKey: 'BA',
    value: 'CRISOPOLIS',
    label: 'CRISOPOLIS'
  },
  {
    stateKey: 'BA',
    value: 'CRISTOPOLIS',
    label: 'CRISTOPOLIS'
  },
  {
    stateKey: 'BA',
    value: 'CRUZ DAS ALMAS',
    label: 'CRUZ DAS ALMAS'
  },
  {
    stateKey: 'BA',
    value: 'CURACA',
    label: 'CURACA'
  },
  {
    stateKey: 'BA',
    value: 'DARIO MEIRA',
    label: 'DARIO MEIRA'
  },
  {
    stateKey: 'BA',
    value: 'DOM BASILIO',
    label: 'DOM BASILIO'
  },
  {
    stateKey: 'BA',
    value: 'DOM MACEDO COSTA',
    label: 'DOM MACEDO COSTA'
  },
  {
    stateKey: 'BA',
    value: 'ELISIO MEDRADO',
    label: 'ELISIO MEDRADO'
  },
  {
    stateKey: 'BA',
    value: 'ENCRUZILHADA',
    label: 'ENCRUZILHADA'
  },
  {
    stateKey: 'BA',
    value: 'ENTRE RIOS',
    label: 'ENTRE RIOS'
  },
  {
    stateKey: 'BA',
    value: 'ESPLANADA',
    label: 'ESPLANADA'
  },
  {
    stateKey: 'BA',
    value: 'EUCLIDES DA CUNHA',
    label: 'EUCLIDES DA CUNHA'
  },
  {
    stateKey: 'BA',
    value: 'EUNAPOLIS',
    label: 'EUNAPOLIS'
  },
  {
    stateKey: 'BA',
    value: 'FATIMA',
    label: 'FATIMA'
  },
  {
    stateKey: 'BA',
    value: 'FEIRA DA MATA ',
    label: 'FEIRA DA MATA'
  },
  {
    stateKey: 'BA',
    value: 'FEIRA DE SANTANA',
    label: 'FEIRA DE SANTANA'
  },
  {
    stateKey: 'BA',
    value: 'FILADELFIA',
    label: 'FILADELFIA'
  },
  {
    stateKey: 'BA',
    value: 'FIRMINO ALVES',
    label: 'FIRMINO ALVES'
  },
  {
    stateKey: 'BA',
    value: 'FLORESTA AZUL',
    label: 'FLORESTA AZUL'
  },
  {
    stateKey: 'BA',
    value: 'FORMOSA DO RIO PRETO',
    label: 'FORMOSA DO RIO PRETO'
  },
  {
    stateKey: 'BA',
    value: 'GANDU',
    label: 'GANDU'
  },
  {
    stateKey: 'BA',
    value: 'GAVIAO',
    label: 'GAVIAO'
  },
  {
    stateKey: 'BA',
    value: 'GENTIO DO OURO',
    label: 'GENTIO DO OURO'
  },
  {
    stateKey: 'BA',
    value: 'GLORIA',
    label: 'GLORIA'
  },
  {
    stateKey: 'BA',
    value: 'GONGOGI',
    label: 'GONGOGI'
  },
  {
    stateKey: 'BA',
    value: 'GOVERNADOR MANGABEIRA',
    label: 'GOVERNADOR MANGABEIRA'
  },
  {
    stateKey: 'BA',
    value: 'GUAJERU',
    label: 'GUAJERU'
  },
  {
    stateKey: 'BA',
    value: 'GUANAMBI',
    label: 'GUANAMBI'
  },
  {
    stateKey: 'BA',
    value: 'GUARATINGA',
    label: 'GUARATINGA'
  },
  {
    stateKey: 'BA',
    value: 'HELIOPOLIS',
    label: 'HELIOPOLIS'
  },
  {
    stateKey: 'BA',
    value: 'IACU',
    label: 'IACU'
  },
  {
    stateKey: 'BA',
    value: 'IBIASSUCE',
    label: 'IBIASSUCE'
  },
  {
    stateKey: 'BA',
    value: 'IBICARAI',
    label: 'IBICARAI'
  },
  {
    stateKey: 'BA',
    value: 'IBICOARA',
    label: 'IBICOARA'
  },
  {
    stateKey: 'BA',
    value: 'IBICUI',
    label: 'IBICUI'
  },
  {
    stateKey: 'BA',
    value: 'IBIPEBA',
    label: 'IBIPEBA'
  },
  {
    stateKey: 'BA',
    value: 'IBIPITANGA',
    label: 'IBIPITANGA'
  },
  {
    stateKey: 'BA',
    value: 'IBIQUERA',
    label: 'IBIQUERA'
  },
  {
    stateKey: 'BA',
    value: 'IBIRAPITANGA',
    label: 'IBIRAPITANGA'
  },
  {
    stateKey: 'BA',
    value: 'IBIRAPUA',
    label: 'IBIRAPUA'
  },
  {
    stateKey: 'BA',
    value: 'IBIRATAIA',
    label: 'IBIRATAIA'
  },
  {
    stateKey: 'BA',
    value: 'IBITIARA',
    label: 'IBITIARA'
  },
  {
    stateKey: 'BA',
    value: 'IBITITA',
    label: 'IBITITA'
  },
  {
    stateKey: 'BA',
    value: 'IBOTIRAMA',
    label: 'IBOTIRAMA'
  },
  {
    stateKey: 'BA',
    value: 'ICHU',
    label: 'ICHU'
  },
  {
    stateKey: 'BA',
    value: 'IGAPORA',
    label: 'IGAPORA'
  },
  {
    stateKey: 'BA',
    value: 'IGRAPIUNA',
    label: 'IGRAPIUNA'
  },
  {
    stateKey: 'BA',
    value: 'IGUAI',
    label: 'IGUAI'
  },
  {
    stateKey: 'BA',
    value: 'ILHEUS',
    label: 'ILHEUS'
  },
  {
    stateKey: 'BA',
    value: 'INHAMBUPE',
    label: 'INHAMBUPE'
  },
  {
    stateKey: 'BA',
    value: 'IPECAETA',
    label: 'IPECAETA'
  },
  {
    stateKey: 'BA',
    value: 'IPIAU',
    label: 'IPIAU'
  },
  {
    stateKey: 'BA',
    value: 'IPIRA',
    label: 'IPIRA'
  },
  {
    stateKey: 'BA',
    value: 'IPUPIARA',
    label: 'IPUPIARA'
  },
  {
    stateKey: 'BA',
    value: 'IRAJUBA',
    label: 'IRAJUBA'
  },
  {
    stateKey: 'BA',
    value: 'IRAMAIA',
    label: 'IRAMAIA'
  },
  {
    stateKey: 'BA',
    value: 'IRAQUARA',
    label: 'IRAQUARA'
  },
  {
    stateKey: 'BA',
    value: 'IRARA',
    label: 'IRARA'
  },
  {
    stateKey: 'BA',
    value: 'IRECE',
    label: 'IRECE'
  },
  {
    stateKey: 'BA',
    value: 'ITABELA',
    label: 'ITABELA'
  },
  {
    stateKey: 'BA',
    value: 'ITABERABA',
    label: 'ITABERABA'
  },
  {
    stateKey: 'BA',
    value: 'ITABUNA',
    label: 'ITABUNA'
  },
  {
    stateKey: 'BA',
    value: 'ITACARE',
    label: 'ITACARE'
  },
  {
    stateKey: 'BA',
    value: 'ITAETE',
    label: 'ITAETE'
  },
  {
    stateKey: 'BA',
    value: 'ITAGI',
    label: 'ITAGI'
  },
  {
    stateKey: 'BA',
    value: 'ITAGIBA',
    label: 'ITAGIBA'
  },
  {
    stateKey: 'BA',
    value: 'ITAGIMIRIM',
    label: 'ITAGIMIRIM'
  },
  {
    stateKey: 'BA',
    value: 'ITAGUACU DA BAHIA',
    label: 'ITAGUACU DA BAHIA'
  },
  {
    stateKey: 'BA',
    value: 'ITAJU DO COLONIA',
    label: 'ITAJU DO COLONIA'
  },
  {
    stateKey: 'BA',
    value: 'ITAJUIPE',
    label: 'ITAJUIPE'
  },
  {
    stateKey: 'BA',
    value: 'ITAMARAJU',
    label: 'ITAMARAJU'
  },
  {
    stateKey: 'BA',
    value: 'ITAMARI',
    label: 'ITAMARI'
  },
  {
    stateKey: 'BA',
    value: 'ITAMBE',
    label: 'ITAMBE'
  },
  {
    stateKey: 'BA',
    value: 'ITANAGRA',
    label: 'ITANAGRA'
  },
  {
    stateKey: 'BA',
    value: 'ITANHEM',
    label: 'ITANHEM'
  },
  {
    stateKey: 'BA',
    value: 'ITAPARICA',
    label: 'ITAPARICA'
  },
  {
    stateKey: 'BA',
    value: 'ITAPE',
    label: 'ITAPE'
  },
  {
    stateKey: 'BA',
    value: 'ITAPEBI',
    label: 'ITAPEBI'
  },
  {
    stateKey: 'BA',
    value: 'ITAPETINGA',
    label: 'ITAPETINGA'
  },
  {
    stateKey: 'BA',
    value: 'ITAPICURU',
    label: 'ITAPICURU'
  },
  {
    stateKey: 'BA',
    value: 'ITAPITANGA',
    label: 'ITAPITANGA'
  },
  {
    stateKey: 'BA',
    value: 'ITAQUARA',
    label: 'ITAQUARA'
  },
  {
    stateKey: 'BA',
    value: 'ITARANTIM',
    label: 'ITARANTIM'
  },
  {
    stateKey: 'BA',
    value: 'ITATIM',
    label: 'ITATIM'
  },
  {
    stateKey: 'BA',
    value: 'ITIRUCU',
    label: 'ITIRUCU'
  },
  {
    stateKey: 'BA',
    value: 'ITIUBA',
    label: 'ITIUBA'
  },
  {
    stateKey: 'BA',
    value: 'ITORORO',
    label: 'ITORORO'
  },
  {
    stateKey: 'BA',
    value: 'ITUACU',
    label: 'ITUACU'
  },
  {
    stateKey: 'BA',
    value: 'ITUBERA',
    label: 'ITUBERA'
  },
  {
    stateKey: 'BA',
    value: 'IUIU',
    label: 'IUIU'
  },
  {
    stateKey: 'BA',
    value: 'JABORANDI',
    label: 'JABORANDI'
  },
  {
    stateKey: 'BA',
    value: 'JACARACI',
    label: 'JACARACI'
  },
  {
    stateKey: 'BA',
    value: 'JACOBINA',
    label: 'JACOBINA'
  },
  {
    stateKey: 'BA',
    value: 'JAGUAQUARA',
    label: 'JAGUAQUARA'
  },
  {
    stateKey: 'BA',
    value: 'JAGUARARI',
    label: 'JAGUARARI'
  },
  {
    stateKey: 'BA',
    value: 'JAGUARIPE',
    label: 'JAGUARIPE'
  },
  {
    stateKey: 'BA',
    value: 'JANDAIRA',
    label: 'JANDAIRA'
  },
  {
    stateKey: 'BA',
    value: 'JEQUIE',
    label: 'JEQUIE'
  },
  {
    stateKey: 'BA',
    value: 'JEREMOABO',
    label: 'JEREMOABO'
  },
  {
    stateKey: 'BA',
    value: 'JITAUNA',
    label: 'JITAUNA'
  },
  {
    stateKey: 'BA',
    value: 'JOAO DOURADO',
    label: 'JOAO DOURADO'
  },
  {
    stateKey: 'BA',
    value: 'JUAZEIRO',
    label: 'JUAZEIRO'
  },
  {
    stateKey: 'BA',
    value: 'JUCURUCU',
    label: 'JUCURUCU'
  },
  {
    stateKey: 'BA',
    value: 'JUSSARA',
    label: 'JUSSARA'
  },
  {
    stateKey: 'BA',
    value: 'JUSSARI',
    label: 'JUSSARI'
  },
  {
    stateKey: 'BA',
    value: 'JUSSIAPE',
    label: 'JUSSIAPE'
  },
  {
    stateKey: 'BA',
    value: 'LAFAIETE COUTINHO',
    label: 'LAFAIETE COUTINHO'
  },
  {
    stateKey: 'BA',
    value: 'LAGOA REAL',
    label: 'LAGOA REAL'
  },
  {
    stateKey: 'BA',
    value: 'LAJE',
    label: 'LAJE'
  },
  {
    stateKey: 'BA',
    value: 'LAJEDAO',
    label: 'LAJEDAO'
  },
  {
    stateKey: 'BA',
    value: 'LAJEDINHO',
    label: 'LAJEDINHO'
  },
  {
    stateKey: 'BA',
    value: 'LAGEDO DO TABOCAL',
    label: 'LAGEDO DO TABOCAL'
  },
  {
    stateKey: 'BA',
    value: 'LAMARAO',
    label: 'LAMARAO'
  },
  {
    stateKey: 'BA',
    value: 'LAPAO',
    label: 'LAPAO'
  },
  {
    stateKey: 'BA',
    value: 'LAURO DE FREITAS',
    label: 'LAURO DE FREITAS'
  },
  {
    stateKey: 'BA',
    value: 'LENCOIS',
    label: 'LENCOIS'
  },
  {
    stateKey: 'BA',
    value: 'LICINIO DE ALMEIDA',
    label: 'LICINIO DE ALMEIDA'
  },
  {
    stateKey: 'BA',
    value: 'MACAJUBA',
    label: 'MACAJUBA'
  },
  {
    stateKey: 'BA',
    value: 'MACARANI',
    label: 'MACARANI'
  },
  {
    stateKey: 'BA',
    value: 'MACAUBAS ',
    label: 'MACAUBAS'
  },
  {
    stateKey: 'BA',
    value: 'MACURURE',
    label: 'MACURURE'
  },
  {
    stateKey: 'BA',
    value: 'MADRE DE DEUS',
    label: 'MADRE DE DEUS'
  },
  {
    stateKey: 'BA',
    value: 'MAETINGA',
    label: 'MAETINGA'
  },
  {
    stateKey: 'BA',
    value: 'MAIQUINIQUE',
    label: 'MAIQUINIQUE'
  },
  {
    stateKey: 'BA',
    value: 'MAIRI',
    label: 'MAIRI'
  },
  {
    stateKey: 'BA',
    value: 'MALHADA',
    label: 'MALHADA'
  },
  {
    stateKey: 'BA',
    value: 'MALHADA DE PEDRAS',
    label: 'MALHADA DE PEDRAS'
  },
  {
    stateKey: 'BA',
    value: 'MANOEL VITORINO',
    label: 'MANOEL VITORINO'
  },
  {
    stateKey: 'BA',
    value: 'MANSIDAO',
    label: 'MANSIDAO'
  },
  {
    stateKey: 'BA',
    value: 'MARACAS',
    label: 'MARACAS'
  },
  {
    stateKey: 'BA',
    value: 'MARAGOGIPE',
    label: 'MARAGOGIPE'
  },
  {
    stateKey: 'BA',
    value: 'MARAU',
    label: 'MARAU'
  },
  {
    stateKey: 'BA',
    value: 'MARCIONILIO SOUZA',
    label: 'MARCIONILIO SOUZA'
  },
  {
    stateKey: 'BA',
    value: 'MASCOTE',
    label: 'MASCOTE'
  },
  {
    stateKey: 'BA',
    value: 'MATA DE SAO JOAO',
    label: 'MATA DE SAO JOAO'
  },
  {
    stateKey: 'BA',
    value: 'MATINA',
    label: 'MATINA'
  },
  {
    stateKey: 'BA',
    value: 'MEDEIROS NETO',
    label: 'MEDEIROS NETO'
  },
  {
    stateKey: 'BA',
    value: 'MIGUEL CALMON',
    label: 'MIGUEL CALMON'
  },
  {
    stateKey: 'BA',
    value: 'MILAGRES',
    label: 'MILAGRES'
  },
  {
    stateKey: 'BA',
    value: 'MIRANGABA',
    label: 'MIRANGABA'
  },
  {
    stateKey: 'BA',
    value: 'MIRANTE',
    label: 'MIRANTE'
  },
  {
    stateKey: 'BA',
    value: 'MONTE SANTO',
    label: 'MONTE SANTO'
  },
  {
    stateKey: 'BA',
    value: 'MORPARA',
    label: 'MORPARA'
  },
  {
    stateKey: 'BA',
    value: 'MORRO DO CHAPEU',
    label: 'MORRO DO CHAPEU'
  },
  {
    stateKey: 'BA',
    value: 'MORTUGABA',
    label: 'MORTUGABA'
  },
  {
    stateKey: 'BA',
    value: 'MUCUGE',
    label: 'MUCUGE'
  },
  {
    stateKey: 'BA',
    value: 'MUCURI',
    label: 'MUCURI'
  },
  {
    stateKey: 'BA',
    value: 'MULUNGU DO MORRO',
    label: 'MULUNGU DO MORRO'
  },
  {
    stateKey: 'BA',
    value: 'MUNDO NOVO',
    label: 'MUNDO NOVO'
  },
  {
    stateKey: 'BA',
    value: 'MUNIZ FERREIRA',
    label: 'MUNIZ FERREIRA'
  },
  {
    stateKey: 'BA',
    value: 'MUQUEM DO SAO FRANCISCO',
    label: 'MUQUEM DO SAO FRANCISCO'
  },
  {
    stateKey: 'BA',
    value: 'MURITIBA',
    label: 'MURITIBA'
  },
  {
    stateKey: 'BA',
    value: 'MUTUIPE',
    label: 'MUTUIPE'
  },
  {
    stateKey: 'BA',
    value: 'NAZARE',
    label: 'NAZARE'
  },
  {
    stateKey: 'BA',
    value: 'NILO PECANHA',
    label: 'NILO PECANHA'
  },
  {
    stateKey: 'BA',
    value: 'NORDESTINA',
    label: 'NORDESTINA'
  },
  {
    stateKey: 'BA',
    value: 'NOVA CANAA',
    label: 'NOVA CANAA'
  },
  {
    stateKey: 'BA',
    value: 'NOVA FATIMA',
    label: 'NOVA FATIMA'
  },
  {
    stateKey: 'BA',
    value: 'NOVA IBIA',
    label: 'NOVA IBIA'
  },
  {
    stateKey: 'BA',
    value: 'NOVA ITARANA',
    label: 'NOVA ITARANA'
  },
  {
    stateKey: 'BA',
    value: 'NOVA REDENCAO',
    label: 'NOVA REDENCAO'
  },
  {
    stateKey: 'BA',
    value: 'NOVA SOURE',
    label: 'NOVA SOURE'
  },
  {
    stateKey: 'BA',
    value: 'NOVA VICOSA',
    label: 'NOVA VICOSA'
  },
  {
    stateKey: 'BA',
    value: 'NOVO HORIZONTE',
    label: 'NOVO HORIZONTE'
  },
  {
    stateKey: 'BA',
    value: 'NOVO TRIUNFO',
    label: 'NOVO TRIUNFO'
  },
  {
    stateKey: 'BA',
    value: 'OLINDINA',
    label: 'OLINDINA'
  },
  {
    stateKey: 'BA',
    value: 'OLIVEIRA DOS BREJINHOS',
    label: 'OLIVEIRA DOS BREJINHOS'
  },
  {
    stateKey: 'BA',
    value: 'OURICANGAS',
    label: 'OURICANGAS'
  },
  {
    stateKey: 'BA',
    value: 'OUROLANDIA',
    label: 'OUROLANDIA'
  },
  {
    stateKey: 'BA',
    value: 'PALMAS DE MONTE ALTO',
    label: 'PALMAS DE MONTE ALTO'
  },
  {
    stateKey: 'BA',
    value: 'PALMEIRAS',
    label: 'PALMEIRAS'
  },
  {
    stateKey: 'BA',
    value: 'PARAMIRIM',
    label: 'PARAMIRIM'
  },
  {
    stateKey: 'BA',
    value: 'PARATINGA',
    label: 'PARATINGA'
  },
  {
    stateKey: 'BA',
    value: 'PARIPIRANGA',
    label: 'PARIPIRANGA'
  },
  {
    stateKey: 'BA',
    value: 'PAU BRASIL',
    label: 'PAU BRASIL'
  },
  {
    stateKey: 'BA',
    value: 'PAULO AFONSO',
    label: 'PAULO AFONSO'
  },
  {
    stateKey: 'BA',
    value: 'PE DE SERRA',
    label: 'PE DE SERRA'
  },
  {
    stateKey: 'BA',
    value: 'PEDRAO',
    label: 'PEDRAO'
  },
  {
    stateKey: 'BA',
    value: 'PEDRO ALEXANDRE',
    label: 'PEDRO ALEXANDRE'
  },
  {
    stateKey: 'BA',
    value: 'PIATA',
    label: 'PIATA'
  },
  {
    stateKey: 'BA',
    value: 'PILAO ARCADO',
    label: 'PILAO ARCADO'
  },
  {
    stateKey: 'BA',
    value: 'PINDAI',
    label: 'PINDAI'
  },
  {
    stateKey: 'BA',
    value: 'PINDOBACU',
    label: 'PINDOBACU'
  },
  {
    stateKey: 'BA',
    value: 'PINTADAS',
    label: 'PINTADAS'
  },
  {
    stateKey: 'BA',
    value: 'PIRAI DO NORTE',
    label: 'PIRAI DO NORTE'
  },
  {
    stateKey: 'BA',
    value: 'PIRIPA',
    label: 'PIRIPA'
  },
  {
    stateKey: 'BA',
    value: 'PIRITIBA',
    label: 'PIRITIBA'
  },
  {
    stateKey: 'BA',
    value: 'PLANALTINO',
    label: 'PLANALTINO'
  },
  {
    stateKey: 'BA',
    value: 'PLANALTO',
    label: 'PLANALTO'
  },
  {
    stateKey: 'BA',
    value: 'POCOES',
    label: 'POCOES'
  },
  {
    stateKey: 'BA',
    value: 'POJUCA',
    label: 'POJUCA'
  },
  {
    stateKey: 'BA',
    value: 'PONTO NOVO',
    label: 'PONTO NOVO'
  },
  {
    stateKey: 'BA',
    value: 'PORTO SEGURO',
    label: 'PORTO SEGURO'
  },
  {
    stateKey: 'BA',
    value: 'POTIRAGUA',
    label: 'POTIRAGUA'
  },
  {
    stateKey: 'BA',
    value: 'PRADO',
    label: 'PRADO'
  },
  {
    stateKey: 'BA',
    value: 'PRESIDENTE DUTRA',
    label: 'PRESIDENTE DUTRA'
  },
  {
    stateKey: 'BA',
    value: 'PRESIDENTE JANIO QUADROS',
    label: 'PRESIDENTE JANIO QUADROS'
  },
  {
    stateKey: 'BA',
    value: 'PRESIDENTE TANCREDO NEVES',
    label: 'PRESIDENTE TANCREDO NEVES'
  },
  {
    stateKey: 'BA',
    value: 'QUEIMADAS',
    label: 'QUEIMADAS'
  },
  {
    stateKey: 'BA',
    value: 'QUIJINGUE',
    label: 'QUIJINGUE'
  },
  {
    stateKey: 'BA',
    value: 'QUIXABEIRA',
    label: 'QUIXABEIRA'
  },
  {
    stateKey: 'BA',
    value: 'RAFAEL JAMBEIRO',
    label: 'RAFAEL JAMBEIRO'
  },
  {
    stateKey: 'BA',
    value: 'REMANSO',
    label: 'REMANSO'
  },
  {
    stateKey: 'BA',
    value: 'RETIROLANDIA',
    label: 'RETIROLANDIA'
  },
  {
    stateKey: 'BA',
    value: 'RIACHAO DAS NEVES',
    label: 'RIACHAO DAS NEVES'
  },
  {
    stateKey: 'BA',
    value: 'RIACHAO DO JACUIPE',
    label: 'RIACHAO DO JACUIPE'
  },
  {
    stateKey: 'BA',
    value: 'RIACHO DE SANTANA',
    label: 'RIACHO DE SANTANA'
  },
  {
    stateKey: 'BA',
    value: 'RIBEIRA DO AMPARO',
    label: 'RIBEIRA DO AMPARO'
  },
  {
    stateKey: 'BA',
    value: 'RIBEIRA DO POMBAL',
    label: 'RIBEIRA DO POMBAL'
  },
  {
    stateKey: 'BA',
    value: 'RIBEIRAO DO LARGO',
    label: 'RIBEIRAO DO LARGO'
  },
  {
    stateKey: 'BA',
    value: 'RIO DE CONTAS',
    label: 'RIO DE CONTAS'
  },
  {
    stateKey: 'BA',
    value: 'RIO DO ANTONIO',
    label: 'RIO DO ANTONIO'
  },
  {
    stateKey: 'BA',
    value: 'RIO DO PIRES',
    label: 'RIO DO PIRES'
  },
  {
    stateKey: 'BA',
    value: 'RIO REAL',
    label: 'RIO REAL'
  },
  {
    stateKey: 'BA',
    value: 'RODELAS',
    label: 'RODELAS'
  },
  {
    stateKey: 'BA',
    value: 'RUY BARBOSA',
    label: 'RUY BARBOSA'
  },
  {
    stateKey: 'BA',
    value: 'SALINAS DA MARGARIDA',
    label: 'SALINAS DA MARGARIDA'
  },
  {
    stateKey: 'BA',
    value: 'SALVADOR',
    label: 'SALVADOR'
  },
  {
    stateKey: 'BA',
    value: 'SANTA BARBARA',
    label: 'SANTA BARBARA'
  },
  {
    stateKey: 'BA',
    value: 'SANTA BRIGIDA',
    label: 'SANTA BRIGIDA'
  },
  {
    stateKey: 'BA',
    value: 'SANTA CRUZ CABRALIA',
    label: 'SANTA CRUZ CABRALIA'
  },
  {
    stateKey: 'BA',
    value: 'SANTA CRUZ DA VITORIA',
    label: 'SANTA CRUZ DA VITORIA'
  },
  {
    stateKey: 'BA',
    value: 'SANTA INES',
    label: 'SANTA INES'
  },
  {
    stateKey: 'BA',
    value: 'SANTA LUZIA',
    label: 'SANTA LUZIA'
  },
  {
    stateKey: 'BA',
    value: 'SANTA MARIA DA VITORIA ',
    label: 'SANTA MARIA DA VITORIA'
  },
  {
    stateKey: 'BA',
    value: 'SANTA RITA DE CASSIA',
    label: 'SANTA RITA DE CASSIA'
  },
  {
    stateKey: 'BA',
    value: 'SANTA TERESINHA',
    label: 'SANTA TERESINHA'
  },
  {
    stateKey: 'BA',
    value: 'SANTALUZ',
    label: 'SANTALUZ'
  },
  {
    stateKey: 'BA',
    value: 'SANTANA',
    label: 'SANTANA'
  },
  {
    stateKey: 'BA',
    value: 'SANTANOPOLIS',
    label: 'SANTANOPOLIS'
  },
  {
    stateKey: 'BA',
    value: 'SANTO AMARO',
    label: 'SANTO AMARO'
  },
  {
    stateKey: 'BA',
    value: 'SANTO ANTONIO DE JESUS',
    label: 'SANTO ANTONIO DE JESUS'
  },
  {
    stateKey: 'BA',
    value: 'SANTO ESTEVAO',
    label: 'SANTO ESTEVAO'
  },
  {
    stateKey: 'BA',
    value: 'SAO DESIDERIO',
    label: 'SAO DESIDERIO'
  },
  {
    stateKey: 'BA',
    value: 'SAO DOMINGOS',
    label: 'SAO DOMINGOS'
  },
  {
    stateKey: 'BA',
    value: 'SAO FELIPE',
    label: 'SAO FELIPE'
  },
  {
    stateKey: 'BA',
    value: 'SAO FELIX',
    label: 'SAO FELIX'
  },
  {
    stateKey: 'BA',
    value: 'SAO FELIX DO CORIBE',
    label: 'SAO FELIX DO CORIBE'
  },
  {
    stateKey: 'BA',
    value: 'SAO FRANCISCO DO CONDE',
    label: 'SAO FRANCISCO DO CONDE'
  },
  {
    stateKey: 'BA',
    value: 'SAO GABRIEL',
    label: 'SAO GABRIEL'
  },
  {
    stateKey: 'BA',
    value: 'SAO GONCALO DOS CAMPOS',
    label: 'SAO GONCALO DOS CAMPOS'
  },
  {
    stateKey: 'BA',
    value: 'SAO JOSE DA VITORIA',
    label: 'SAO JOSE DA VITORIA'
  },
  {
    stateKey: 'BA',
    value: 'SAO JOSE DO JACUIPE',
    label: 'SAO JOSE DO JACUIPE'
  },
  {
    stateKey: 'BA',
    value: 'SAO MIGUEL DAS MATAS',
    label: 'SAO MIGUEL DAS MATAS'
  },
  {
    stateKey: 'BA',
    value: 'SAO SEBASTIAO DO PASSE',
    label: 'SAO SEBASTIAO DO PASSE'
  },
  {
    stateKey: 'BA',
    value: 'SAPEACU',
    label: 'SAPEACU'
  },
  {
    stateKey: 'BA',
    value: 'SATIRO DIAS',
    label: 'SATIRO DIAS'
  },
  {
    stateKey: 'BA',
    value: 'SAUBARA',
    label: 'SAUBARA'
  },
  {
    stateKey: 'BA',
    value: 'SAUDE',
    label: 'SAUDE'
  },
  {
    stateKey: 'BA',
    value: 'SEABRA',
    label: 'SEABRA'
  },
  {
    stateKey: 'BA',
    value: 'SEBASTIAO LARANJEIRAS',
    label: 'SEBASTIAO LARANJEIRAS'
  },
  {
    stateKey: 'BA',
    value: 'SENHOR DO BONFIM',
    label: 'SENHOR DO BONFIM'
  },
  {
    stateKey: 'BA',
    value: 'SENTO SE',
    label: 'SENTO SE'
  },
  {
    stateKey: 'BA',
    value: 'SERRA DO RAMALHO',
    label: 'SERRA DO RAMALHO'
  },
  {
    stateKey: 'BA',
    value: 'SERRA DOURADA',
    label: 'SERRA DOURADA'
  },
  {
    stateKey: 'BA',
    value: 'SERRA PRETA',
    label: 'SERRA PRETA'
  },
  {
    stateKey: 'BA',
    value: 'SERRINHA',
    label: 'SERRINHA'
  },
  {
    stateKey: 'BA',
    value: 'SERROLANDIA',
    label: 'SERROLANDIA'
  },
  {
    stateKey: 'BA',
    value: 'SIMOES FILHO',
    label: 'SIMOES FILHO'
  },
  {
    stateKey: 'BA',
    value: 'SITIO DO MATO',
    label: 'SITIO DO MATO'
  },
  {
    stateKey: 'BA',
    value: 'SITIO DO QUINTO',
    label: 'SITIO DO QUINTO'
  },
  {
    stateKey: 'BA',
    value: 'SOBRADINHO',
    label: 'SOBRADINHO'
  },
  {
    stateKey: 'BA',
    value: 'SOUTO SOARES',
    label: 'SOUTO SOARES'
  },
  {
    stateKey: 'BA',
    value: 'TABOCAS DO BREJO VELHO',
    label: 'TABOCAS DO BREJO VELHO'
  },
  {
    stateKey: 'BA',
    value: 'TANHACU',
    label: 'TANHACU'
  },
  {
    stateKey: 'BA',
    value: 'TANQUE NOVO',
    label: 'TANQUE NOVO'
  },
  {
    stateKey: 'BA',
    value: 'TANQUINHO',
    label: 'TANQUINHO'
  },
  {
    stateKey: 'BA',
    value: 'TAPEROA',
    label: 'TAPEROA'
  },
  {
    stateKey: 'BA',
    value: 'TAPIRAMUTA',
    label: 'TAPIRAMUTA'
  },
  {
    stateKey: 'BA',
    value: 'TEIXEIRA DE FREITAS',
    label: 'TEIXEIRA DE FREITAS'
  },
  {
    stateKey: 'BA',
    value: 'TEODORO SAMPAIO',
    label: 'TEODORO SAMPAIO'
  },
  {
    stateKey: 'BA',
    value: 'TEOFILANDIA',
    label: 'TEOFILANDIA'
  },
  {
    stateKey: 'BA',
    value: 'TEOLANDIA',
    label: 'TEOLANDIA'
  },
  {
    stateKey: 'BA',
    value: 'TERRA NOVA',
    label: 'TERRA NOVA'
  },
  {
    stateKey: 'BA',
    value: 'TREMEDAL',
    label: 'TREMEDAL'
  },
  {
    stateKey: 'BA',
    value: 'TUCANO',
    label: 'TUCANO'
  },
  {
    stateKey: 'BA',
    value: 'UAUA',
    label: 'UAUA'
  },
  {
    stateKey: 'BA',
    value: 'UBAIRA',
    label: 'UBAIRA'
  },
  {
    stateKey: 'BA',
    value: 'UBAITABA',
    label: 'UBAITABA'
  },
  {
    stateKey: 'BA',
    value: 'UBATA',
    label: 'UBATA'
  },
  {
    stateKey: 'BA',
    value: 'UIBAI',
    label: 'UIBAI'
  },
  {
    stateKey: 'BA',
    value: 'UMBURANAS',
    label: 'UMBURANAS'
  },
  {
    stateKey: 'BA',
    value: 'UNA',
    label: 'UNA'
  },
  {
    stateKey: 'BA',
    value: 'URANDI',
    label: 'URANDI'
  },
  {
    stateKey: 'BA',
    value: 'URUCUCA',
    label: 'URUCUCA'
  },
  {
    stateKey: 'BA',
    value: 'UTINGA',
    label: 'UTINGA'
  },
  {
    stateKey: 'BA',
    value: 'VALENCA',
    label: 'VALENCA'
  },
  {
    stateKey: 'BA',
    value: 'VALENTE',
    label: 'VALENTE'
  },
  {
    stateKey: 'BA',
    value: 'VARZEA DA ROCA',
    label: 'VARZEA DA ROCA'
  },
  {
    stateKey: 'BA',
    value: 'VARZEA DO POCO',
    label: 'VARZEA DO POCO'
  },
  {
    stateKey: 'BA',
    value: 'VARZEA NOVA',
    label: 'VARZEA NOVA'
  },
  {
    stateKey: 'BA',
    value: 'VARZEDO',
    label: 'VARZEDO'
  },
  {
    stateKey: 'BA',
    value: 'VERA CRUZ',
    label: 'VERA CRUZ'
  },
  {
    stateKey: 'BA',
    value: 'VEREDA',
    label: 'VEREDA'
  },
  {
    stateKey: 'BA',
    value: 'VITORIA DA CONQUISTA',
    label: 'VITORIA DA CONQUISTA'
  },
  {
    stateKey: 'BA',
    value: 'WAGNER',
    label: 'WAGNER'
  },
  {
    stateKey: 'BA',
    value: 'WANDERLEY',
    label: 'WANDERLEY'
  },
  {
    stateKey: 'BA',
    value: 'WENCESLAU GUIMARAES',
    label: 'WENCESLAU GUIMARAES'
  },
  {
    stateKey: 'BA',
    value: 'XIQUE-XIQUE',
    label: 'XIQUE-XIQUE'
  },
  {
    stateKey: 'BA',
    value: 'Érico Cardoso',
    label: 'Érico Cardoso'
  },
  {
    stateKey: 'BA',
    value: 'Filadélfia',
    label: 'Filadélfia'
  },
  {
    stateKey: 'BA',
    value: 'BARROCAS',
    label: 'BARROCAS'
  },
  {
    stateKey: 'BA',
    value: 'MIMOSO DO OESTE',
    label: 'MIMOSO DO OESTE'
  },
  {
    stateKey: 'BA',
    value: 'SAO JOAO DA VITORIA',
    label: 'SAO JOAO DA VITORIA'
  },
  {
    stateKey: 'BA',
    value: 'CONCEICAO DO ALMEIDA',
    label: 'CONCEICAO DO ALMEIDA'
  },
  {
    stateKey: 'BA',
    value: 'JIQUIRICA',
    label: 'JIQUIRICA'
  },
  {
    stateKey: 'BA',
    value: "DIAS D'AVILA",
    label: "DIAS D'AVILA"
  },
  {
    stateKey: 'BA',
    value: 'LUIS EDUARDO MAGALHAES',
    label: 'LUIS EDUARDO MAGALHAES'
  },
  {
    stateKey: 'BA',
    value: 'LIVRAMENTO DE NOSSA SENHORA-BA',
    label: 'LIVRAMENTO DE NOSSA SENHORA-BA'
  },
  {
    stateKey: 'BA',
    value: 'ERICO CARDOSO',
    label: 'ERICO CARDOSO'
  },
  {
    stateKey: 'BA',
    value: "DIAS D'AVILA",
    label: "DIAS D'AVILA"
  },
  {
    stateKey: 'BA',
    value: 'BAHIA',
    label: 'BAHIA'
  },
  {
    stateKey: 'Cargill',
    value: 'empty',
    label: 'empty'
  },
  {
    stateKey: 'CE',
    value: 'ABAIARA',
    label: 'ABAIARA'
  },
  {
    stateKey: 'CE',
    value: 'ACARAPE',
    label: 'ACARAPE'
  },
  {
    stateKey: 'CE',
    value: 'ACARAU',
    label: 'ACARAU'
  },
  {
    stateKey: 'CE',
    value: 'ACOPIARA',
    label: 'ACOPIARA'
  },
  {
    stateKey: 'CE',
    value: 'AIUABA',
    label: 'AIUABA'
  },
  {
    stateKey: 'CE',
    value: 'ALCANTARAS',
    label: 'ALCANTARAS'
  },
  {
    stateKey: 'CE',
    value: 'ALTANEIRA',
    label: 'ALTANEIRA'
  },
  {
    stateKey: 'CE',
    value: 'ALTO SANTO',
    label: 'ALTO SANTO'
  },
  {
    stateKey: 'CE',
    value: 'AMONTADA',
    label: 'AMONTADA'
  },
  {
    stateKey: 'CE',
    value: 'ANTONINA DO NORTE',
    label: 'ANTONINA DO NORTE'
  },
  {
    stateKey: 'CE',
    value: 'APUIARES',
    label: 'APUIARES'
  },
  {
    stateKey: 'CE',
    value: 'AQUIRAZ',
    label: 'AQUIRAZ'
  },
  {
    stateKey: 'CE',
    value: 'ARACATI',
    label: 'ARACATI'
  },
  {
    stateKey: 'CE',
    value: 'ARACOIABA',
    label: 'ARACOIABA'
  },
  {
    stateKey: 'CE',
    value: 'ARARENDA',
    label: 'ARARENDA'
  },
  {
    stateKey: 'CE',
    value: 'ARARIPE',
    label: 'ARARIPE'
  },
  {
    stateKey: 'CE',
    value: 'ARATUBA',
    label: 'ARATUBA'
  },
  {
    stateKey: 'CE',
    value: 'ARNEIROZ',
    label: 'ARNEIROZ'
  },
  {
    stateKey: 'CE',
    value: 'ASSARE',
    label: 'ASSARE'
  },
  {
    stateKey: 'CE',
    value: 'AURORA',
    label: 'AURORA'
  },
  {
    stateKey: 'CE',
    value: 'BAIXIO',
    label: 'BAIXIO'
  },
  {
    stateKey: 'CE',
    value: 'BANABUIU',
    label: 'BANABUIU'
  },
  {
    stateKey: 'CE',
    value: 'BARBALHA',
    label: 'BARBALHA'
  },
  {
    stateKey: 'CE',
    value: 'BARREIRA',
    label: 'BARREIRA'
  },
  {
    stateKey: 'CE',
    value: 'BARRO',
    label: 'BARRO'
  },
  {
    stateKey: 'CE',
    value: 'BARROQUINHA',
    label: 'BARROQUINHA'
  },
  {
    stateKey: 'CE',
    value: 'BATURITE',
    label: 'BATURITE'
  },
  {
    stateKey: 'CE',
    value: 'BEBERIBE',
    label: 'BEBERIBE'
  },
  {
    stateKey: 'CE',
    value: 'BELA CRUZ',
    label: 'BELA CRUZ'
  },
  {
    stateKey: 'CE',
    value: 'BOA VIAGEM',
    label: 'BOA VIAGEM'
  },
  {
    stateKey: 'CE',
    value: 'BREJO SANTO ',
    label: 'BREJO SANTO'
  },
  {
    stateKey: 'CE',
    value: 'CAMOCIM',
    label: 'CAMOCIM'
  },
  {
    stateKey: 'CE',
    value: 'CAMPOS SALES',
    label: 'CAMPOS SALES'
  },
  {
    stateKey: 'CE',
    value: 'CANINDE',
    label: 'CANINDE'
  },
  {
    stateKey: 'CE',
    value: 'CAPISTRANO',
    label: 'CAPISTRANO'
  },
  {
    stateKey: 'CE',
    value: 'CARIDADE',
    label: 'CARIDADE'
  },
  {
    stateKey: 'CE',
    value: 'CARIRE',
    label: 'CARIRE'
  },
  {
    stateKey: 'CE',
    value: 'CARIRIACU',
    label: 'CARIRIACU'
  },
  {
    stateKey: 'CE',
    value: 'CARIUS',
    label: 'CARIUS'
  },
  {
    stateKey: 'CE',
    value: 'CARNAUBAL',
    label: 'CARNAUBAL'
  },
  {
    stateKey: 'CE',
    value: 'CASCAVEL',
    label: 'CASCAVEL'
  },
  {
    stateKey: 'CE',
    value: 'CATARINA',
    label: 'CATARINA'
  },
  {
    stateKey: 'CE',
    value: 'CATUNDA',
    label: 'CATUNDA'
  },
  {
    stateKey: 'CE',
    value: 'CAUCAIA',
    label: 'CAUCAIA'
  },
  {
    stateKey: 'CE',
    value: 'CEDRO',
    label: 'CEDRO'
  },
  {
    stateKey: 'CE',
    value: 'CHAVAL',
    label: 'CHAVAL'
  },
  {
    stateKey: 'CE',
    value: 'CHORO',
    label: 'CHORO'
  },
  {
    stateKey: 'CE',
    value: 'CHOROZINHO',
    label: 'CHOROZINHO'
  },
  {
    stateKey: 'CE',
    value: 'COREAU',
    label: 'COREAU'
  },
  {
    stateKey: 'CE',
    value: 'CRATEUS',
    label: 'CRATEUS'
  },
  {
    stateKey: 'CE',
    value: 'CRATO',
    label: 'CRATO'
  },
  {
    stateKey: 'CE',
    value: 'CROATA',
    label: 'CROATA'
  },
  {
    stateKey: 'CE',
    value: 'CRUZ',
    label: 'CRUZ'
  },
  {
    stateKey: 'CE',
    value: 'DEPUTADO IRAPUAN PINHEIRO',
    label: 'DEPUTADO IRAPUAN PINHEIRO'
  },
  {
    stateKey: 'CE',
    value: 'ERERE',
    label: 'ERERE'
  },
  {
    stateKey: 'CE',
    value: 'EUSEBIO',
    label: 'EUSEBIO'
  },
  {
    stateKey: 'CE',
    value: 'FARIAS BRITO',
    label: 'FARIAS BRITO'
  },
  {
    stateKey: 'CE',
    value: 'FORQUILHA',
    label: 'FORQUILHA'
  },
  {
    stateKey: 'CE',
    value: 'FORTALEZA',
    label: 'FORTALEZA'
  },
  {
    stateKey: 'CE',
    value: 'FORTIM',
    label: 'FORTIM'
  },
  {
    stateKey: 'CE',
    value: 'FRECHEIRINHA',
    label: 'FRECHEIRINHA'
  },
  {
    stateKey: 'CE',
    value: 'GENERAL SAMPAIO',
    label: 'GENERAL SAMPAIO'
  },
  {
    stateKey: 'CE',
    value: 'GRACA',
    label: 'GRACA'
  },
  {
    stateKey: 'CE',
    value: 'GRANJA',
    label: 'GRANJA'
  },
  {
    stateKey: 'CE',
    value: 'GRANJEIRO',
    label: 'GRANJEIRO'
  },
  {
    stateKey: 'CE',
    value: 'GROAIRAS',
    label: 'GROAIRAS'
  },
  {
    stateKey: 'CE',
    value: 'GUAIUBA',
    label: 'GUAIUBA'
  },
  {
    stateKey: 'CE',
    value: 'GUARACIABA DO NORTE',
    label: 'GUARACIABA DO NORTE'
  },
  {
    stateKey: 'CE',
    value: 'GUARAMIRANGA',
    label: 'GUARAMIRANGA'
  },
  {
    stateKey: 'CE',
    value: 'HIDROLANDIA',
    label: 'HIDROLANDIA'
  },
  {
    stateKey: 'CE',
    value: 'HORIZONTE',
    label: 'HORIZONTE'
  },
  {
    stateKey: 'CE',
    value: 'IBARETAMA',
    label: 'IBARETAMA'
  },
  {
    stateKey: 'CE',
    value: 'IBIAPINA',
    label: 'IBIAPINA'
  },
  {
    stateKey: 'CE',
    value: 'IBICUITINGA',
    label: 'IBICUITINGA'
  },
  {
    stateKey: 'CE',
    value: 'ICAPUI',
    label: 'ICAPUI'
  },
  {
    stateKey: 'CE',
    value: 'ICO',
    label: 'ICO'
  },
  {
    stateKey: 'CE',
    value: 'IGUATU',
    label: 'IGUATU'
  },
  {
    stateKey: 'CE',
    value: 'INDEPENDENCIA',
    label: 'INDEPENDENCIA'
  },
  {
    stateKey: 'CE',
    value: 'IPAPORANGA',
    label: 'IPAPORANGA'
  },
  {
    stateKey: 'CE',
    value: 'IPAUMIRIM',
    label: 'IPAUMIRIM'
  },
  {
    stateKey: 'CE',
    value: 'IPU',
    label: 'IPU'
  },
  {
    stateKey: 'CE',
    value: 'IPUEIRAS',
    label: 'IPUEIRAS'
  },
  {
    stateKey: 'CE',
    value: 'IRACEMA',
    label: 'IRACEMA'
  },
  {
    stateKey: 'CE',
    value: 'IRAUCUBA',
    label: 'IRAUCUBA'
  },
  {
    stateKey: 'CE',
    value: 'ITAICABA',
    label: 'ITAICABA'
  },
  {
    stateKey: 'CE',
    value: 'ITAITINGA',
    label: 'ITAITINGA'
  },
  {
    stateKey: 'CE',
    value: 'ITAPAGE',
    label: 'ITAPAGE'
  },
  {
    stateKey: 'CE',
    value: 'ITAPIPOCA',
    label: 'ITAPIPOCA'
  },
  {
    stateKey: 'CE',
    value: 'ITAPIUNA',
    label: 'ITAPIUNA'
  },
  {
    stateKey: 'CE',
    value: 'ITAREMA',
    label: 'ITAREMA'
  },
  {
    stateKey: 'CE',
    value: 'ITATIRA',
    label: 'ITATIRA'
  },
  {
    stateKey: 'CE',
    value: 'JAGUARETAMA',
    label: 'JAGUARETAMA'
  },
  {
    stateKey: 'CE',
    value: 'JAGUARIBARA',
    label: 'JAGUARIBARA'
  },
  {
    stateKey: 'CE',
    value: 'JAGUARIBE',
    label: 'JAGUARIBE'
  },
  {
    stateKey: 'CE',
    value: 'JAGUARUANA',
    label: 'JAGUARUANA'
  },
  {
    stateKey: 'CE',
    value: 'JARDIM',
    label: 'JARDIM'
  },
  {
    stateKey: 'CE',
    value: 'JATI',
    label: 'JATI'
  },
  {
    stateKey: 'CE',
    value: 'JIJOCA DE JERICOACOARA',
    label: 'JIJOCA DE JERICOACOARA'
  },
  {
    stateKey: 'CE',
    value: 'JUAZEIRO DO NORTE',
    label: 'JUAZEIRO DO NORTE'
  },
  {
    stateKey: 'CE',
    value: 'JUCAS',
    label: 'JUCAS'
  },
  {
    stateKey: 'CE',
    value: 'LAVRAS DA MANGABEIRA',
    label: 'LAVRAS DA MANGABEIRA'
  },
  {
    stateKey: 'CE',
    value: 'LIMOEIRO DO NORTE',
    label: 'LIMOEIRO DO NORTE'
  },
  {
    stateKey: 'CE',
    value: 'MADALENA',
    label: 'MADALENA'
  },
  {
    stateKey: 'CE',
    value: 'MARACANAU',
    label: 'MARACANAU'
  },
  {
    stateKey: 'CE',
    value: 'MARANGUAPE',
    label: 'MARANGUAPE'
  },
  {
    stateKey: 'CE',
    value: 'MARCO',
    label: 'MARCO'
  },
  {
    stateKey: 'CE',
    value: 'MARTINOPOLE',
    label: 'MARTINOPOLE'
  },
  {
    stateKey: 'CE',
    value: 'MASSAPE',
    label: 'MASSAPE'
  },
  {
    stateKey: 'CE',
    value: 'MAURITI',
    label: 'MAURITI'
  },
  {
    stateKey: 'CE',
    value: 'MERUOCA',
    label: 'MERUOCA'
  },
  {
    stateKey: 'CE',
    value: 'MILAGRES',
    label: 'MILAGRES'
  },
  {
    stateKey: 'CE',
    value: 'MILHA',
    label: 'MILHA'
  },
  {
    stateKey: 'CE',
    value: 'MIRAIMA',
    label: 'MIRAIMA'
  },
  {
    stateKey: 'CE',
    value: 'MISSAO VELHA',
    label: 'MISSAO VELHA'
  },
  {
    stateKey: 'CE',
    value: 'MOMBACA',
    label: 'MOMBACA'
  },
  {
    stateKey: 'CE',
    value: 'MONSENHOR TABOSA',
    label: 'MONSENHOR TABOSA'
  },
  {
    stateKey: 'CE',
    value: 'MORADA NOVA',
    label: 'MORADA NOVA'
  },
  {
    stateKey: 'CE',
    value: 'MORAUJO',
    label: 'MORAUJO'
  },
  {
    stateKey: 'CE',
    value: 'MORRINHOS',
    label: 'MORRINHOS'
  },
  {
    stateKey: 'CE',
    value: 'MUCAMBO',
    label: 'MUCAMBO'
  },
  {
    stateKey: 'CE',
    value: 'MULUNGU',
    label: 'MULUNGU'
  },
  {
    stateKey: 'CE',
    value: 'NOVA OLINDA',
    label: 'NOVA OLINDA'
  },
  {
    stateKey: 'CE',
    value: 'NOVA RUSSAS',
    label: 'NOVA RUSSAS'
  },
  {
    stateKey: 'CE',
    value: 'NOVO ORIENTE',
    label: 'NOVO ORIENTE'
  },
  {
    stateKey: 'CE',
    value: 'OCARA',
    label: 'OCARA'
  },
  {
    stateKey: 'CE',
    value: 'OROS',
    label: 'OROS'
  },
  {
    stateKey: 'CE',
    value: 'PACAJUS',
    label: 'PACAJUS'
  },
  {
    stateKey: 'CE',
    value: 'PACATUBA',
    label: 'PACATUBA'
  },
  {
    stateKey: 'CE',
    value: 'PACOTI',
    label: 'PACOTI'
  },
  {
    stateKey: 'CE',
    value: 'PACUJA',
    label: 'PACUJA'
  },
  {
    stateKey: 'CE',
    value: 'PALHANO',
    label: 'PALHANO'
  },
  {
    stateKey: 'CE',
    value: 'PALMACIA',
    label: 'PALMACIA'
  },
  {
    stateKey: 'CE',
    value: 'PARACURU',
    label: 'PARACURU'
  },
  {
    stateKey: 'CE',
    value: 'PARAIPABA',
    label: 'PARAIPABA'
  },
  {
    stateKey: 'CE',
    value: 'PARAMBU',
    label: 'PARAMBU '
  },
  {
    stateKey: 'CE',
    value: 'PARAMOTI',
    label: 'PARAMOTI'
  },
  {
    stateKey: 'CE',
    value: 'PEDRA BRANCA',
    label: 'PEDRA BRANCA'
  },
  {
    stateKey: 'CE',
    value: 'PENAFORTE',
    label: 'PENAFORTE'
  },
  {
    stateKey: 'CE',
    value: 'PENTECOSTE',
    label: 'PENTECOSTE'
  },
  {
    stateKey: 'CE',
    value: 'PEREIRO',
    label: 'PEREIRO'
  },
  {
    stateKey: 'CE',
    value: 'PINDORETAMA',
    label: 'PINDORETAMA'
  },
  {
    stateKey: 'CE',
    value: 'PIQUET CARNEIRO',
    label: 'PIQUET CARNEIRO'
  },
  {
    stateKey: 'CE',
    value: 'PIRES FERREIRA',
    label: 'PIRES FERREIRA'
  },
  {
    stateKey: 'CE',
    value: 'PORANGA',
    label: 'PORANGA'
  },
  {
    stateKey: 'CE',
    value: 'PORTEIRAS',
    label: 'PORTEIRAS'
  },
  {
    stateKey: 'CE',
    value: 'POTENGI',
    label: 'POTENGI'
  },
  {
    stateKey: 'CE',
    value: 'POTIRETAMA',
    label: 'POTIRETAMA'
  },
  {
    stateKey: 'CE',
    value: 'QUITERIANOPOLIS',
    label: 'QUITERIANOPOLIS'
  },
  {
    stateKey: 'CE',
    value: 'QUIXADA',
    label: 'QUIXADA'
  },
  {
    stateKey: 'CE',
    value: 'QUIXELO',
    label: 'QUIXELO'
  },
  {
    stateKey: 'CE',
    value: 'QUIXERAMOBIM',
    label: 'QUIXERAMOBIM'
  },
  {
    stateKey: 'CE',
    value: 'QUIXERE',
    label: 'QUIXERE'
  },
  {
    stateKey: 'CE',
    value: 'REDENCAO',
    label: 'REDENCAO'
  },
  {
    stateKey: 'CE',
    value: 'RERIUTABA',
    label: 'RERIUTABA'
  },
  {
    stateKey: 'CE',
    value: 'RUSSAS',
    label: 'RUSSAS'
  },
  {
    stateKey: 'CE',
    value: 'SABOEIRO',
    label: 'SABOEIRO'
  },
  {
    stateKey: 'CE',
    value: 'SALITRE',
    label: 'SALITRE'
  },
  {
    stateKey: 'CE',
    value: 'SANTA QUITERIA',
    label: 'SANTA QUITERIA'
  },
  {
    stateKey: 'CE',
    value: 'SANTANA DO ACARAU',
    label: 'SANTANA DO ACARAU'
  },
  {
    stateKey: 'CE',
    value: 'SANTANA DO CARIRI',
    label: 'SANTANA DO CARIRI'
  },
  {
    stateKey: 'CE',
    value: 'SAO BENEDITO',
    label: 'SAO BENEDITO'
  },
  {
    stateKey: 'CE',
    value: 'SAO GONCALO DO AMARANTE',
    label: 'SAO GONCALO DO AMARANTE'
  },
  {
    stateKey: 'CE',
    value: 'SAO JOAO DO JAGUARIBE',
    label: 'SAO JOAO DO JAGUARIBE'
  },
  {
    stateKey: 'CE',
    value: 'SAO LUIS DO CURU',
    label: 'SAO LUIS DO CURU'
  },
  {
    stateKey: 'CE',
    value: 'SENADOR POMPEU',
    label: 'SENADOR POMPEU'
  },
  {
    stateKey: 'CE',
    value: 'SENADOR SA',
    label: 'SENADOR SA'
  },
  {
    stateKey: 'CE',
    value: 'SOBRAL',
    label: 'SOBRAL'
  },
  {
    stateKey: 'CE',
    value: 'SOLONOPOLE',
    label: 'SOLONOPOLE'
  },
  {
    stateKey: 'CE',
    value: 'TABULEIRO DO NORTE',
    label: 'TABULEIRO DO NORTE'
  },
  {
    stateKey: 'CE',
    value: 'TAMBORIL',
    label: 'TAMBORIL'
  },
  {
    stateKey: 'CE',
    value: 'TARRAFAS',
    label: 'TARRAFAS'
  },
  {
    stateKey: 'CE',
    value: 'TAUA',
    label: 'TAUA'
  },
  {
    stateKey: 'CE',
    value: 'TEJUCUOCA',
    label: 'TEJUCUOCA'
  },
  {
    stateKey: 'CE',
    value: 'TIANGUA',
    label: 'TIANGUA'
  },
  {
    stateKey: 'CE',
    value: 'TRAIRI',
    label: 'TRAIRI'
  },
  {
    stateKey: 'CE',
    value: 'TURURU',
    label: 'TURURU'
  },
  {
    stateKey: 'CE',
    value: 'UBAJARA',
    label: 'UBAJARA'
  },
  {
    stateKey: 'CE',
    value: 'UMARI',
    label: 'UMARI'
  },
  {
    stateKey: 'CE',
    value: 'UMIRIM',
    label: 'UMIRIM'
  },
  {
    stateKey: 'CE',
    value: 'URUBURETAMA',
    label: 'URUBURETAMA'
  },
  {
    stateKey: 'CE',
    value: 'URUOCA',
    label: 'URUOCA'
  },
  {
    stateKey: 'CE',
    value: 'VARJOTA',
    label: 'VARJOTA'
  },
  {
    stateKey: 'CE',
    value: 'VARZEA ALEGRE',
    label: 'VARZEA ALEGRE'
  },
  {
    stateKey: 'CE',
    value: 'VICOSA DO CEARA',
    label: 'VICOSA DO CEARA'
  },
  {
    stateKey: 'DF',
    value: 'BRASILIA',
    label: 'BRASILIA'
  },
  {
    stateKey: 'DF',
    value: 'BRASILIA (CANDANGOLANDIA)',
    label: 'BRASILIA (CANDANGOLANDIA)'
  },
  {
    stateKey: 'DF',
    value: 'BRASILIA (CRUZEIRO)',
    label: 'BRASILIA (CRUZEIRO)'
  },
  {
    stateKey: 'DF',
    value: 'BRASILIA (PARANOA)',
    label: 'BRASILIA (PARANOA)'
  },
  {
    stateKey: 'DF',
    value: 'BRASILIA (RECANTO DAS EMAS- DF',
    label: 'BRASILIA (RECANTO DAS EMAS- DF'
  },
  {
    stateKey: 'DF',
    value: 'BRASILIA (RIACHO FUNDO)',
    label: 'BRASILIA (RIACHO FUNDO)'
  },
  {
    stateKey: 'DF',
    value: 'BRASILIA (SAMAMBAIA)',
    label: 'BRASILIA (SAMAMBAIA)'
  },
  {
    stateKey: 'DF',
    value: 'BRASILIA (SANTA MARIA)',
    label: 'BRASILIA (SANTA MARIA)'
  },
  {
    stateKey: 'DF',
    value: 'BRASILIA (SAO SEBASTIAO)',
    label: 'BRASILIA (SAO SEBASTIAO)'
  },
  {
    stateKey: 'DF',
    value: 'BRASILIA (TAGUATINGA)',
    label: 'BRASILIA (TAGUATINGA)'
  },
  {
    stateKey: 'DF',
    value: 'BRASILIA (GAMA)',
    label: 'BRASILIA (GAMA)'
  },
  {
    stateKey: 'DF',
    value: 'BRASILIA (GUARA)',
    label: 'BRASILIA (GUARA)'
  },
  {
    stateKey: 'DF',
    value: 'BRASILIA (BRAZLANDIA)',
    label: 'BRASILIA (BRAZLANDIA)'
  },
  {
    stateKey: 'DF',
    value: 'BRASILIA (CEILANDIA)',
    label: 'BRASILIA (CEILANDIA)'
  },
  {
    stateKey: 'DF',
    value: 'BRASILIA (PLANALTINA)',
    label: 'BRASILIA (PLANALTINA)'
  },
  {
    stateKey: 'DF',
    value: 'BRASILIA (SOBRADINHO)',
    label: 'BRASILIA (SOBRADINHO)'
  },
  {
    stateKey: 'DF',
    value: 'BRASILIA (NUCLEO BANDEIRAN- DF',
    label: 'BRASILIA (NUCLEO BANDEIRAN- DF'
  },
  {
    stateKey: 'DF',
    value: 'GAMA',
    label: 'GAMA'
  },
  {
    stateKey: 'ES',
    value: 'AFONSO CLAUDIO',
    label: 'AFONSO CLAUDIO'
  },
  {
    stateKey: 'ES',
    value: 'AGUA DOCE DO NORTE',
    label: 'AGUA DOCE DO NORTE'
  },
  {
    stateKey: 'ES',
    value: 'AGUIA BRANCA',
    label: 'AGUIA BRANCA'
  },
  {
    stateKey: 'ES',
    value: 'ALEGRE',
    label: 'ALEGRE'
  },
  {
    stateKey: 'ES',
    value: 'ALFREDO CHAVES',
    label: 'ALFREDO CHAVES'
  },
  {
    stateKey: 'ES',
    value: 'ALTO RIO NOVO',
    label: 'ALTO RIO NOVO'
  },
  {
    stateKey: 'ES',
    value: 'ANCHIETA',
    label: 'ANCHIETA'
  },
  {
    stateKey: 'ES',
    value: 'APIACA',
    label: 'APIACA'
  },
  {
    stateKey: 'ES',
    value: 'ARACRUZ',
    label: 'ARACRUZ'
  },
  {
    stateKey: 'ES',
    value: 'BAIXO GUANDU',
    label: 'BAIXO GUANDU'
  },
  {
    stateKey: 'ES',
    value: 'BARRA DE SAO FRANCISCO',
    label: 'BARRA DE SAO FRANCISCO'
  },
  {
    stateKey: 'ES',
    value: 'BOA ESPERANCA',
    label: 'BOA ESPERANCA'
  },
  {
    stateKey: 'ES',
    value: 'BOM JESUS DO NORTE',
    label: 'BOM JESUS DO NORTE'
  },
  {
    stateKey: 'ES',
    value: 'BREJETUBA',
    label: 'BREJETUBA'
  },
  {
    stateKey: 'ES',
    value: 'CACHOEIRO DE ITAPEMIRIM',
    label: 'CACHOEIRO DE ITAPEMIRIM'
  },
  {
    stateKey: 'ES',
    value: 'CARIACICA',
    label: 'CARIACICA'
  },
  {
    stateKey: 'ES',
    value: 'CASTELO',
    label: 'CASTELO'
  },
  {
    stateKey: 'ES',
    value: 'COLATINA',
    label: 'COLATINA'
  },
  {
    stateKey: 'ES',
    value: 'CONCEICAO DA BARRA',
    label: 'CONCEICAO DA BARRA'
  },
  {
    stateKey: 'ES',
    value: 'CONCEICAO DO CASTELO',
    label: 'CONCEICAO DO CASTELO'
  },
  {
    stateKey: 'ES',
    value: 'DIVINO DE SAO LOURENCO',
    label: 'DIVINO DE SAO LOURENCO'
  },
  {
    stateKey: 'ES',
    value: 'DOMINGOS MARTINS',
    label: 'DOMINGOS MARTINS'
  },
  {
    stateKey: 'ES',
    value: 'DORES DO RIO PRETO',
    label: 'DORES DO RIO PRETO'
  },
  {
    stateKey: 'ES',
    value: 'ECOPORANGA',
    label: 'ECOPORANGA'
  },
  {
    stateKey: 'ES',
    value: 'FUNDAO',
    label: 'FUNDAO'
  },
  {
    stateKey: 'ES',
    value: 'GUACUI',
    label: 'GUACUI'
  },
  {
    stateKey: 'ES',
    value: 'GUARAPARI',
    label: 'GUARAPARI'
  },
  {
    stateKey: 'ES',
    value: 'IBATIBA',
    label: 'IBATIBA'
  },
  {
    stateKey: 'ES',
    value: 'IBIRACU',
    label: 'IBIRACU'
  },
  {
    stateKey: 'ES',
    value: 'IBITIRAMA',
    label: 'IBITIRAMA'
  },
  {
    stateKey: 'ES',
    value: 'ICONHA',
    label: 'ICONHA'
  },
  {
    stateKey: 'ES',
    value: 'IRUPI',
    label: 'IRUPI'
  },
  {
    stateKey: 'ES',
    value: 'ITAGUACU',
    label: 'ITAGUACU'
  },
  {
    stateKey: 'ES',
    value: 'ITAPEMIRIM',
    label: 'ITAPEMIRIM'
  },
  {
    stateKey: 'ES',
    value: 'ITARANA',
    label: 'ITARANA'
  },
  {
    stateKey: 'ES',
    value: 'IUNA',
    label: 'IUNA'
  },
  {
    stateKey: 'ES',
    value: 'JAGUARE',
    label: 'JAGUARE'
  },
  {
    stateKey: 'ES',
    value: 'JERONIMO MONTEIRO',
    label: 'JERONIMO MONTEIRO'
  },
  {
    stateKey: 'ES',
    value: 'JOAO NEIVA',
    label: 'JOAO NEIVA'
  },
  {
    stateKey: 'ES',
    value: 'LARANJA DA TERRA',
    label: 'LARANJA DA TERRA'
  },
  {
    stateKey: 'ES',
    value: 'LINHARES',
    label: 'LINHARES'
  },
  {
    stateKey: 'ES',
    value: 'MANTENOPOLIS',
    label: 'MANTENOPOLIS'
  },
  {
    stateKey: 'ES',
    value: 'MARATAIZES',
    label: 'MARATAIZES'
  },
  {
    stateKey: 'ES',
    value: 'MARECHAL FLORIANO',
    label: 'MARECHAL FLORIANO'
  },
  {
    stateKey: 'ES',
    value: 'MARILANDIA',
    label: 'MARILANDIA'
  },
  {
    stateKey: 'ES',
    value: 'MIMOSO DO SUL',
    label: 'MIMOSO DO SUL'
  },
  {
    stateKey: 'ES',
    value: 'MONTANHA',
    label: 'MONTANHA'
  },
  {
    stateKey: 'ES',
    value: 'MUCURICI',
    label: 'MUCURICI'
  },
  {
    stateKey: 'ES',
    value: 'MUNIZ FREIRE',
    label: 'MUNIZ FREIRE'
  },
  {
    stateKey: 'ES',
    value: 'MUQUI',
    label: 'MUQUI'
  },
  {
    stateKey: 'ES',
    value: 'NOVA VENECIA',
    label: 'NOVA VENECIA'
  },
  {
    stateKey: 'ES',
    value: 'PANCAS',
    label: 'PANCAS'
  },
  {
    stateKey: 'ES',
    value: 'PEDRO CANARIO',
    label: 'PEDRO CANARIO'
  },
  {
    stateKey: 'ES',
    value: 'PINHEIROS',
    label: 'PINHEIROS'
  },
  {
    stateKey: 'ES',
    value: 'PIUMA',
    label: 'PIUMA'
  },
  {
    stateKey: 'ES',
    value: 'PONTO BELO',
    label: 'PONTO BELO'
  },
  {
    stateKey: 'ES',
    value: 'PRESIDENTE KENNEDY',
    label: 'PRESIDENTE KENNEDY'
  },
  {
    stateKey: 'ES',
    value: 'RIO BANANAL',
    label: 'RIO BANANAL'
  },
  {
    stateKey: 'ES',
    value: 'RIO NOVO DO SUL',
    label: 'RIO NOVO DO SUL'
  },
  {
    stateKey: 'ES',
    value: 'SANTA LEOPOLDINA',
    label: 'SANTA LEOPOLDINA'
  },
  {
    stateKey: 'ES',
    value: 'SANTA MARIA DE JETIBA',
    label: 'SANTA MARIA DE JETIBA'
  },
  {
    stateKey: 'ES',
    value: 'SANTA TERESA',
    label: 'SANTA TERESA'
  },
  {
    stateKey: 'ES',
    value: 'SAO DOMINGOS DO NORTE',
    label: 'SAO DOMINGOS DO NORTE'
  },
  {
    stateKey: 'ES',
    value: 'SAO GABRIEL DA PALHA',
    label: 'SAO GABRIEL DA PALHA'
  },
  {
    stateKey: 'ES',
    value: 'SAO JOSE DO CALCADO',
    label: 'SAO JOSE DO CALCADO'
  },
  {
    stateKey: 'ES',
    value: 'SAO MATEUS',
    label: 'SAO MATEUS'
  },
  {
    stateKey: 'ES',
    value: 'SERRA',
    label: 'SERRA'
  },
  {
    stateKey: 'ES',
    value: 'SOORETAMA',
    label: 'SOORETAMA'
  },
  {
    stateKey: 'ES',
    value: 'VARGEM ALTA',
    label: 'VARGEM ALTA'
  },
  {
    stateKey: 'ES',
    value: 'VENDA NOVA DO IMIGRANTE',
    label: 'VENDA NOVA DO IMIGRANTE'
  },
  {
    stateKey: 'ES',
    value: 'VIANA',
    label: 'VIANA'
  },
  {
    stateKey: 'ES',
    value: 'VILA PAVAO',
    label: 'VILA PAVAO'
  },
  {
    stateKey: 'ES',
    value: 'VILA VALERIO',
    label: 'VILA VALERIO'
  },
  {
    stateKey: 'ES',
    value: 'VILA VELHA',
    label: 'VILA VELHA'
  },
  {
    stateKey: 'ES',
    value: 'VITORIA',
    label: 'VITORIA'
  },
  {
    stateKey: 'ES',
    value: 'SAO ROQUE DO CANAA',
    label: 'SAO ROQUE DO CANAA'
  },
  {
    stateKey: 'ES',
    value: 'ATILIO VIVACQUA',
    label: 'ATILIO VIVACQUA'
  },
  {
    stateKey: 'ES',
    value: 'GOVERNADOR LINDEMBERG',
    label: 'GOVERNADOR LINDEMBERG'
  },
  {
    stateKey: 'ES',
    value: 'SAO ROQUE DO CANAA',
    label: 'SAO ROQUE DO CANAA'
  },
  {
    stateKey: 'ES',
    value: 'ATILIO VIVACQUA',
    label: 'ATILIO VIVACQUA'
  },
  {
    stateKey: 'Exterior',
    value: 'empty',
    label: 'empty'
  },
  {
    stateKey: 'GO',
    value: 'ABADIA DE GOIAS',
    label: 'ABADIA DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'ABADIANIA',
    label: 'ABADIANIA'
  },
  {
    stateKey: 'GO',
    value: 'ACREUNA',
    label: 'ACREUNA'
  },
  {
    stateKey: 'GO',
    value: 'ADELANDIA',
    label: 'ADELANDIA'
  },
  {
    stateKey: 'GO',
    value: 'AGUA FRIA DE GOIAS',
    label: 'AGUA FRIA DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'AGUA LIMPA',
    label: 'AGUA LIMPA'
  },
  {
    stateKey: 'GO',
    value: 'AGUAS LINDAS DE GOIAS',
    label: 'AGUAS LINDAS DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'ALEXANIA',
    label: 'ALEXANIA'
  },
  {
    stateKey: 'GO',
    value: 'ALOANDIA',
    label: 'ALOANDIA'
  },
  {
    stateKey: 'GO',
    value: 'ALTO HORIZONTE',
    label: 'ALTO HORIZONTE'
  },
  {
    stateKey: 'GO',
    value: 'ALTO PARAISO DE GOIAS',
    label: 'ALTO PARAISO DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'ALVORADA DO NORTE',
    label: 'ALVORADA DO NORTE'
  },
  {
    stateKey: 'GO',
    value: 'AMARALINA',
    label: 'AMARALINA'
  },
  {
    stateKey: 'GO',
    value: 'AMERICANO DO BRASIL',
    label: 'AMERICANO DO BRASIL'
  },
  {
    stateKey: 'GO',
    value: 'AMORINOPOLIS',
    label: 'AMORINOPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'ANAPOLIS',
    label: 'ANAPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'ANHANGUERA',
    label: 'ANHANGUERA'
  },
  {
    stateKey: 'GO',
    value: 'ANICUNS',
    label: 'ANICUNS'
  },
  {
    stateKey: 'GO',
    value: 'APARECIDA DE GOIANIA',
    label: 'APARECIDA DE GOIANIA'
  },
  {
    stateKey: 'GO',
    value: 'APARECIDA DO RIO DOCE',
    label: 'APARECIDA DO RIO DOCE'
  },
  {
    stateKey: 'GO',
    value: 'APORE',
    label: 'APORE'
  },
  {
    stateKey: 'GO',
    value: 'ARACU',
    label: 'ARACU'
  },
  {
    stateKey: 'GO',
    value: 'ARAGARCAS',
    label: 'ARAGARCAS'
  },
  {
    stateKey: 'GO',
    value: 'ARAGOIANIA',
    label: 'ARAGOIANIA'
  },
  {
    stateKey: 'GO',
    value: 'ARAGUAPAZ',
    label: 'ARAGUAPAZ'
  },
  {
    stateKey: 'GO',
    value: 'ARENOPOLIS',
    label: 'ARENOPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'ARUANA',
    label: 'ARUANA'
  },
  {
    stateKey: 'GO',
    value: 'AURILANDIA',
    label: 'AURILANDIA '
  },
  {
    stateKey: 'GO',
    value: 'AVELINOPOLIS',
    label: 'AVELINOPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'BALIZA',
    label: 'BALIZA'
  },
  {
    stateKey: 'GO',
    value: 'BARRO ALTO',
    label: 'BARRO ALTO'
  },
  {
    stateKey: 'GO',
    value: 'BELA VISTA DE GOIAS',
    label: 'BELA VISTA DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'BOM JARDIM DE GOIAS',
    label: 'BOM JARDIM DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'BOM JESUS DE GOIAS',
    label: 'BOM JESUS DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'BONFINOPOLIS',
    label: 'BONFINOPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'BONOPOLIS',
    label: 'BONOPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'BRAZABRANTES',
    label: 'BRAZABRANTES'
  },
  {
    stateKey: 'GO',
    value: 'BRITANIA',
    label: 'BRITANIA'
  },
  {
    stateKey: 'GO',
    value: 'BURITI ALEGRE',
    label: 'BURITI ALEGRE'
  },
  {
    stateKey: 'GO',
    value: 'BURITINOPOLIS',
    label: 'BURITINOPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'CABECEIRAS',
    label: 'CABECEIRAS'
  },
  {
    stateKey: 'GO',
    value: 'CACHOEIRA ALTA',
    label: 'CACHOEIRA ALTA'
  },
  {
    stateKey: 'GO',
    value: 'CACHOEIRA DE GOIAS',
    label: 'CACHOEIRA DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'CACHOEIRA DOURADA',
    label: 'CACHOEIRA DOURADA'
  },
  {
    stateKey: 'GO',
    value: 'CACU',
    label: 'CACU'
  },
  {
    stateKey: 'GO',
    value: 'CAIAPONIA',
    label: 'CAIAPONIA'
  },
  {
    stateKey: 'GO',
    value: 'CALDAS NOVAS',
    label: 'CALDAS NOVAS'
  },
  {
    stateKey: 'GO',
    value: 'CALDAZINHA',
    label: 'CALDAZINHA'
  },
  {
    stateKey: 'GO',
    value: 'CAMPESTRE DE GOIAS',
    label: 'CAMPESTRE DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'CAMPINACU',
    label: 'CAMPINACU'
  },
  {
    stateKey: 'GO',
    value: 'CAMPINORTE',
    label: 'CAMPINORTE'
  },
  {
    stateKey: 'GO',
    value: 'CAMPO ALEGRE DE GOIAS',
    label: 'CAMPO ALEGRE DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'CAMPOS BELOS',
    label: 'CAMPOS BELOS'
  },
  {
    stateKey: 'GO',
    value: 'CAMPOS VERDES',
    label: 'CAMPOS VERDES'
  },
  {
    stateKey: 'GO',
    value: 'CARMO DO RIO VERDE',
    label: 'CARMO DO RIO VERDE'
  },
  {
    stateKey: 'GO',
    value: 'CATALAO',
    label: 'CATALAO'
  },
  {
    stateKey: 'GO',
    value: 'CATURAI',
    label: 'CATURAI'
  },
  {
    stateKey: 'GO',
    value: 'CAVALCANTE',
    label: 'CAVALCANTE'
  },
  {
    stateKey: 'GO',
    value: 'CERES',
    label: 'CERES'
  },
  {
    stateKey: 'GO',
    value: 'CEZARINA',
    label: 'CEZARINA'
  },
  {
    stateKey: 'GO',
    value: 'CHAPADAO DO CEU',
    label: 'CHAPADAO DO CEU'
  },
  {
    stateKey: 'GO',
    value: 'CIDADE OCIDENTAL',
    label: 'CIDADE OCIDENTAL'
  },
  {
    stateKey: 'GO',
    value: 'COLINAS DO SUL',
    label: 'COLINAS DO SUL'
  },
  {
    stateKey: 'GO',
    value: 'CORREGO DO OURO',
    label: 'CORREGO DO OURO'
  },
  {
    stateKey: 'GO',
    value: 'CORUMBA DE GOIAS',
    label: 'CORUMBA DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'CORUMBAIBA',
    label: 'CORUMBAIBA'
  },
  {
    stateKey: 'GO',
    value: 'CRISTALINA',
    label: 'CRISTALINA'
  },
  {
    stateKey: 'GO',
    value: 'CRISTIANOPOLIS',
    label: 'CRISTIANOPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'CRIXAS',
    label: 'CRIXAS'
  },
  {
    stateKey: 'GO',
    value: 'CROMINIA',
    label: 'CROMINIA'
  },
  {
    stateKey: 'GO',
    value: 'CUMARI',
    label: 'CUMARI'
  },
  {
    stateKey: 'GO',
    value: 'DAMIANOPOLIS',
    label: 'DAMIANOPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'DAMOLANDIA',
    label: 'DAMOLANDIA'
  },
  {
    stateKey: 'GO',
    value: 'DAVINOPOLIS',
    label: 'DAVINOPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'DIORAMA',
    label: 'DIORAMA'
  },
  {
    stateKey: 'GO',
    value: 'DOVERLANDIA',
    label: 'DOVERLANDIA'
  },
  {
    stateKey: 'GO',
    value: 'EDEALINA',
    label: 'EDEALINA'
  },
  {
    stateKey: 'GO',
    value: 'EDEIA',
    label: 'EDEIA'
  },
  {
    stateKey: 'GO',
    value: 'ESTRELA DO NORTE',
    label: 'ESTRELA DO NORTE'
  },
  {
    stateKey: 'GO',
    value: 'FAINA',
    label: 'FAINA'
  },
  {
    stateKey: 'GO',
    value: 'FAZENDA NOVA',
    label: 'FAZENDA NOVA'
  },
  {
    stateKey: 'GO',
    value: 'FIRMINOPOLIS',
    label: 'FIRMINOPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'FLORES DE GOIAS',
    label: 'FLORES DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'FORMOSA',
    label: 'FORMOSA'
  },
  {
    stateKey: 'GO',
    value: 'FORMOSO',
    label: 'FORMOSO'
  },
  {
    stateKey: 'GO',
    value: 'GOIANAPOLIS',
    label: 'GOIANAPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'GOIANDIRA',
    label: 'GOIANDIRA'
  },
  {
    stateKey: 'GO',
    value: 'GOIANESIA',
    label: 'GOIANESIA'
  },
  {
    stateKey: 'GO',
    value: 'GOIANIA',
    label: 'GOIANIA'
  },
  {
    stateKey: 'GO',
    value: 'GOIANIRA',
    label: 'GOIANIRA'
  },
  {
    stateKey: 'GO',
    value: 'GOIAS',
    label: 'GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'GOIATUBA',
    label: 'GOIATUBA'
  },
  {
    stateKey: 'GO',
    value: 'GOUVELANDIA',
    label: 'GOUVELANDIA'
  },
  {
    stateKey: 'GO',
    value: 'GUAPO',
    label: 'GUAPO'
  },
  {
    stateKey: 'GO',
    value: 'GUARAITA',
    label: 'GUARAITA'
  },
  {
    stateKey: 'GO',
    value: 'GUARANI DE GOIAS',
    label: 'GUARANI DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'GUARINOS',
    label: 'GUARINOS'
  },
  {
    stateKey: 'GO',
    value: 'HEITORAI',
    label: 'HEITORAI'
  },
  {
    stateKey: 'GO',
    value: 'HIDROLANDIA',
    label: 'HIDROLANDIA'
  },
  {
    stateKey: 'GO',
    value: 'HIDROLINA',
    label: 'HIDROLINA'
  },
  {
    stateKey: 'GO',
    value: 'IACIARA',
    label: 'IACIARA'
  },
  {
    stateKey: 'GO',
    value: 'INACIOLANDIA',
    label: 'INACIOLANDIA'
  },
  {
    stateKey: 'GO',
    value: 'INDIARA',
    label: 'INDIARA'
  },
  {
    stateKey: 'GO',
    value: 'INHUMAS',
    label: 'INHUMAS'
  },
  {
    stateKey: 'GO',
    value: 'IPAMERI',
    label: 'IPAMERI'
  },
  {
    stateKey: 'GO',
    value: 'IPORA',
    label: 'IPORA'
  },
  {
    stateKey: 'GO',
    value: 'ISRAELANDIA',
    label: 'ISRAELANDIA'
  },
  {
    stateKey: 'GO',
    value: 'ITABERAI',
    label: 'ITABERAI'
  },
  {
    stateKey: 'GO',
    value: 'ITAGUARI',
    label: 'ITAGUARI'
  },
  {
    stateKey: 'GO',
    value: 'ITAGUARU',
    label: 'ITAGUARU'
  },
  {
    stateKey: 'GO',
    value: 'ITAJA',
    label: 'ITAJA'
  },
  {
    stateKey: 'GO',
    value: 'ITAPACI',
    label: 'ITAPACI'
  },
  {
    stateKey: 'GO',
    value: 'ITAPIRAPUA',
    label: 'ITAPIRAPUA'
  },
  {
    stateKey: 'GO',
    value: 'ITAPURANGA',
    label: 'ITAPURANGA'
  },
  {
    stateKey: 'GO',
    value: 'ITARUMA',
    label: 'ITARUMA'
  },
  {
    stateKey: 'GO',
    value: 'ITAUCU',
    label: 'ITAUCU'
  },
  {
    stateKey: 'GO',
    value: 'ITUMBIARA',
    label: 'ITUMBIARA'
  },
  {
    stateKey: 'GO',
    value: 'IVOLANDIA',
    label: 'IVOLANDIA'
  },
  {
    stateKey: 'GO',
    value: 'JANDAIA',
    label: 'JANDAIA'
  },
  {
    stateKey: 'GO',
    value: 'JARAGUA',
    label: 'JARAGUA'
  },
  {
    stateKey: 'GO',
    value: 'JATAI',
    label: 'JATAI'
  },
  {
    stateKey: 'GO',
    value: 'JAUPACI',
    label: 'JAUPACI'
  },
  {
    stateKey: 'GO',
    value: 'JESUPOLIS',
    label: 'JESUPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'JOVIANIA',
    label: 'JOVIANIA'
  },
  {
    stateKey: 'GO',
    value: 'JUSSARA',
    label: 'JUSSARA'
  },
  {
    stateKey: 'GO',
    value: 'LEOPOLDO DE BULHOES',
    label: 'LEOPOLDO DE BULHOES'
  },
  {
    stateKey: 'GO',
    value: 'LUZIANIA',
    label: 'LUZIANIA'
  },
  {
    stateKey: 'GO',
    value: 'MAIRIPOTABA',
    label: 'MAIRIPOTABA'
  },
  {
    stateKey: 'GO',
    value: 'MAMBAI',
    label: 'MAMBAI'
  },
  {
    stateKey: 'GO',
    value: 'MARA ROSA',
    label: 'MARA ROSA'
  },
  {
    stateKey: 'GO',
    value: 'MARZAGAO',
    label: 'MARZAGAO'
  },
  {
    stateKey: 'GO',
    value: 'MATRINCHA',
    label: 'MATRINCHA'
  },
  {
    stateKey: 'GO',
    value: 'MAURILANDIA',
    label: 'MAURILANDIA'
  },
  {
    stateKey: 'GO',
    value: 'MIMOSO DE GOIAS',
    label: 'MIMOSO DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'MINACU',
    label: 'MINACU'
  },
  {
    stateKey: 'GO',
    value: 'MINEIROS',
    label: 'MINEIROS'
  },
  {
    stateKey: 'GO',
    value: 'MOIPORA',
    label: 'MOIPORA'
  },
  {
    stateKey: 'GO',
    value: 'MONTE ALEGRE DE GOIAS',
    label: 'MONTE ALEGRE DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'MONTES CLAROS DE GOIAS',
    label: 'MONTES CLAROS DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'MONTIVIDIU',
    label: 'MONTIVIDIU'
  },
  {
    stateKey: 'GO',
    value: 'MORRINHOS',
    label: 'MORRINHOS'
  },
  {
    stateKey: 'GO',
    value: 'MORRO AGUDO DE GOIAS',
    label: 'MORRO AGUDO DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'MOSSAMEDES',
    label: 'MOSSAMEDES'
  },
  {
    stateKey: 'GO',
    value: 'MOZARLANDIA',
    label: 'MOZARLANDIA'
  },
  {
    stateKey: 'GO',
    value: 'MUNDO NOVO',
    label: 'MUNDO NOVO'
  },
  {
    stateKey: 'GO',
    value: 'MUTUNOPOLIS',
    label: 'MUTUNOPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'NAZARIO',
    label: 'NAZARIO'
  },
  {
    stateKey: 'GO',
    value: 'NEROPOLIS',
    label: 'NEROPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'NIQUELANDIA',
    label: 'NIQUELANDIA'
  },
  {
    stateKey: 'GO',
    value: 'NOVA AMERICA',
    label: 'NOVA AMERICA'
  },
  {
    stateKey: 'GO',
    value: 'NOVA AURORA',
    label: 'NOVA AURORA'
  },
  {
    stateKey: 'GO',
    value: 'NOVA CRIXAS',
    label: 'NOVA CRIXAS'
  },
  {
    stateKey: 'GO',
    value: 'NOVA GLORIA',
    label: 'NOVA GLORIA'
  },
  {
    stateKey: 'GO',
    value: 'NOVA IGUACU DE GOIAS',
    label: 'NOVA IGUACU DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'NOVA ROMA',
    label: 'NOVA ROMA'
  },
  {
    stateKey: 'GO',
    value: 'NOVA VENEZA',
    label: 'NOVA VENEZA'
  },
  {
    stateKey: 'GO',
    value: 'NOVO BRASIL',
    label: 'NOVO BRASIL'
  },
  {
    stateKey: 'GO',
    value: 'NOVO GAMA',
    label: 'NOVO GAMA'
  },
  {
    stateKey: 'GO',
    value: 'NOVO PLANALTO',
    label: 'NOVO PLANALTO'
  },
  {
    stateKey: 'GO',
    value: 'ORIZONA',
    label: 'ORIZONA'
  },
  {
    stateKey: 'GO',
    value: 'OURO VERDE DE GOIAS',
    label: 'OURO VERDE DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'OUVIDOR',
    label: 'OUVIDOR'
  },
  {
    stateKey: 'GO',
    value: 'PADRE BERNARDO',
    label: 'PADRE BERNARDO'
  },
  {
    stateKey: 'GO',
    value: 'PALESTINA DE GOIAS',
    label: 'PALESTINA DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'PALMEIRAS DE GOIAS',
    label: 'PALMEIRAS DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'PALMELO',
    label: 'PALMELO'
  },
  {
    stateKey: 'GO',
    value: 'PALMINOPOLIS',
    label: 'PALMINOPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'PANAMA',
    label: 'PANAMA'
  },
  {
    stateKey: 'GO',
    value: 'PARANAIGUARA',
    label: 'PARANAIGUARA'
  },
  {
    stateKey: 'GO',
    value: 'PARAUNA',
    label: 'PARAUNA'
  },
  {
    stateKey: 'GO',
    value: 'PEROLANDIA',
    label: 'PEROLANDIA'
  },
  {
    stateKey: 'GO',
    value: 'PETROLINA DE GOIAS',
    label: 'PETROLINA DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'PILAR DE GOIAS',
    label: 'PILAR DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'PIRACANJUBA',
    label: 'PIRACANJUBA'
  },
  {
    stateKey: 'GO',
    value: 'PIRANHAS',
    label: 'PIRANHAS'
  },
  {
    stateKey: 'GO',
    value: 'PIRENOPOLIS',
    label: 'PIRENOPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'PIRES DO RIO',
    label: 'PIRES DO RIO'
  },
  {
    stateKey: 'GO',
    value: 'PLANALTINA',
    label: 'PLANALTINA'
  },
  {
    stateKey: 'GO',
    value: 'PONTALINA',
    label: 'PONTALINA'
  },
  {
    stateKey: 'GO',
    value: 'PORANGATU',
    label: 'PORANGATU'
  },
  {
    stateKey: 'GO',
    value: 'PORTEIRAO',
    label: 'PORTEIRAO'
  },
  {
    stateKey: 'GO',
    value: 'POSSE',
    label: 'POSSE'
  },
  {
    stateKey: 'GO',
    value: 'PROFESSOR JAMIL',
    label: 'PROFESSOR JAMIL'
  },
  {
    stateKey: 'GO',
    value: 'QUIRINOPOLIS',
    label: 'QUIRINOPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'RIALMA',
    label: 'RIALMA'
  },
  {
    stateKey: 'GO',
    value: 'RIANAPOLIS',
    label: 'RIANAPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'RIO QUENTE',
    label: 'RIO QUENTE'
  },
  {
    stateKey: 'GO',
    value: 'RIO VERDE',
    label: 'RIO VERDE'
  },
  {
    stateKey: 'GO',
    value: 'RUBIATABA',
    label: 'RUBIATABA'
  },
  {
    stateKey: 'GO',
    value: 'SANCLERLANDIA',
    label: 'SANCLERLANDIA'
  },
  {
    stateKey: 'GO',
    value: 'SANTA BARBARA DE GOIAS',
    label: 'SANTA BARBARA DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'SANTA CRUZ DE GOIAS',
    label: 'SANTA CRUZ DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'SANTA FE DE GOIAS',
    label: 'SANTA FE DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'SANTA HELENA DE GOIAS',
    label: 'SANTA HELENA DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'SANTA ISABEL',
    label: 'SANTA ISABEL'
  },
  {
    stateKey: 'GO',
    value: 'SANTA RITA DO ARAGUAIA',
    label: 'SANTA RITA DO ARAGUAIA'
  },
  {
    stateKey: 'GO',
    value: 'SANTA RITA DO NOVO DESTINO',
    label: 'SANTA RITA DO NOVO DESTINO'
  },
  {
    stateKey: 'GO',
    value: 'SANTA ROSA DE GOIAS',
    label: 'SANTA ROSA DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'SANTA TEREZA DE GOIAS',
    label: 'SANTA TEREZA DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'SANTA TEREZINHA DE GOIAS',
    label: 'SANTA TEREZINHA DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'SANTO ANTONIO DA BARRA',
    label: 'SANTO ANTONIO DA BARRA'
  },
  {
    stateKey: 'GO',
    value: 'SANTO ANTONIO DO DESCOBERT',
    label: 'SANTO ANTONIO DO DESCOBERT'
  },
  {
    stateKey: 'GO',
    value: 'SAO DOMINGOS',
    label: 'SAO DOMINGOS'
  },
  {
    stateKey: 'GO',
    value: 'SAO FRANCISCO DE GOIAS',
    label: 'SAO FRANCISCO DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: "SAO JOAO D'ALIANCA",
    label: "SAO JOAO D'ALIANCA"
  },
  {
    stateKey: 'GO',
    value: 'SAO JOAO DA PARAUNA',
    label: 'SAO JOAO DA PARAUNA'
  },
  {
    stateKey: 'GO',
    value: 'SAO LUIS DE MONTES BELOS',
    label: 'SAO LUIS DE MONTES BELOS'
  },
  {
    stateKey: 'GO',
    value: 'SAO LUIZ DO NORTE',
    label: 'SAO LUIZ DO NORTE'
  },
  {
    stateKey: 'GO',
    value: 'SAO MIGUEL DO ARAGUAIA',
    label: 'SAO MIGUEL DO ARAGUAIA'
  },
  {
    stateKey: 'GO',
    value: 'SAO MIGUEL DO PASSA QUATRO-',
    label: 'SAO MIGUEL DO PASSA QUATRO'
  },
  {
    stateKey: 'GO',
    value: 'SAO PATRICIO',
    label: 'SAO PATRICIO'
  },
  {
    stateKey: 'GO',
    value: 'SAO SIMAO',
    label: 'SAO SIMAO'
  },
  {
    stateKey: 'GO',
    value: 'SENADOR CANEDO',
    label: 'SENADOR CANEDO'
  },
  {
    stateKey: 'GO',
    value: 'SERRANOPOLIS',
    label: 'SERRANOPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'SILVANIA',
    label: 'SILVANIA'
  },
  {
    stateKey: 'GO',
    value: 'SIMOLANDIA',
    label: 'SIMOLANDIA'
  },
  {
    stateKey: 'GO',
    value: "SITIO D'ABADIA",
    label: "SITIO D'ABADIA"
  },
  {
    stateKey: 'GO',
    value: 'TAQUARAL DE GOIAS',
    label: 'TAQUARAL DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'TERESINA DE GOIAS',
    label: 'TERESINA DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'TEREZOPOLIS DE GOIAS',
    label: 'TEREZOPOLIS DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'TRES RANCHOS',
    label: 'TRES RANCHOS'
  },
  {
    stateKey: 'GO',
    value: 'TRINDADE',
    label: 'TRINDADE'
  },
  {
    stateKey: 'GO',
    value: 'TROMBAS',
    label: 'TROMBAS'
  },
  {
    stateKey: 'GO',
    value: 'TURVANIA',
    label: 'TURVANIA'
  },
  {
    stateKey: 'GO',
    value: 'TURVELANDIA',
    label: 'TURVELANDIA'
  },
  {
    stateKey: 'GO',
    value: 'UIRAPURU',
    label: 'UIRAPURU'
  },
  {
    stateKey: 'GO',
    value: 'URUACU',
    label: 'URUACU'
  },
  {
    stateKey: 'GO',
    value: 'URUANA',
    label: 'URUANA'
  },
  {
    stateKey: 'GO',
    value: 'URUTAI',
    label: 'URUTAI'
  },
  {
    stateKey: 'GO',
    value: 'VALPARAISO DE GOIAS',
    label: 'VALPARAISO DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'VARJAO',
    label: 'VARJAO'
  },
  {
    stateKey: 'GO',
    value: 'VIANOPOLIS',
    label: 'VIANOPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'VICENTINOPOLIS',
    label: 'VICENTINOPOLIS'
  },
  {
    stateKey: 'GO',
    value: 'VILA BOA',
    label: 'VILA BOA'
  },
  {
    stateKey: 'GO',
    value: 'VILA PROPICIO',
    label: 'VILA PROPICIO'
  },
  {
    stateKey: 'GO',
    value: 'Divinópolis de GO',
    label: 'Divinópolis de GO'
  },
  {
    stateKey: 'GO',
    value: 'Ipiranga de GO',
    label: 'Ipiranga de GO'
  },
  {
    stateKey: 'GO',
    value: 'Lagoa Santa',
    label: 'Lagoa Santa'
  },
  {
    stateKey: 'GO',
    value: 'Montividiu do Norte',
    label: 'Montividiu do Norte'
  },
  {
    stateKey: 'GO',
    value: 'BURITI DE GOIAS',
    label: 'BURITI DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'CAMPO LIMPO DE GOIAS',
    label: 'CAMPO LIMPO DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'COCALZINHO DO GOIAS',
    label: 'COCALZINHO DO GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'CASTELANDIA',
    label: 'CASTELANDIA'
  },
  {
    stateKey: 'GO',
    value: 'PORTELANDIA',
    label: 'PORTELANDIA'
  },
  {
    stateKey: 'GO',
    value: 'GAMELEIRA DE GOIAS',
    label: 'GAMELEIRA DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'BUENOLANDIA',
    label: 'BUENOLANDIA'
  },
  {
    stateKey: 'GO',
    value: 'SANTO ANTONIO DE GOIAS',
    label: 'SANTO ANTONIO DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'IPIRANGA DE GOIAS',
    label: 'IPIRANGA DE GOIAS'
  },
  {
    stateKey: 'GO',
    value: 'MONTIVIDIU DO NORTE',
    label: 'MONTIVIDIU DO NORTE'
  },
  {
    stateKey: 'MA',
    value: 'ACAILANDIA',
    label: 'ACAILANDIA'
  },
  {
    stateKey: 'MA',
    value: 'AFONSO CUNHA',
    label: 'AFONSO CUNHA'
  },
  {
    stateKey: 'MA',
    value: 'AGUA DOCE DO MARANHAO',
    label: 'AGUA DOCE DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'ALCANTARA',
    label: 'ALCANTARA'
  },
  {
    stateKey: 'MA',
    value: 'ALDEIAS ALTAS',
    label: 'ALDEIAS ALTAS'
  },
  {
    stateKey: 'MA',
    value: 'ALTAMIRA DO MARANHAO',
    label: 'ALTAMIRA DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'ALTO ALEGRE DO MARANHAO',
    label: 'ALTO ALEGRE DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'ALTO ALEGRE DO PINDARE',
    label: 'ALTO ALEGRE DO PINDARE'
  },
  {
    stateKey: 'MA',
    value: 'ALTO PARNAIBA',
    label: 'ALTO PARNAIBA'
  },
  {
    stateKey: 'MA',
    value: 'AMARANTE DO MARANHAO',
    label: 'AMARANTE DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'ANAJATUBA',
    label: 'ANAJATUBA'
  },
  {
    stateKey: 'MA',
    value: 'ANAPURUS',
    label: 'ANAPURUS'
  },
  {
    stateKey: 'MA',
    value: 'APICUM-ACU',
    label: 'APICUM-ACU'
  },
  {
    stateKey: 'MA',
    value: 'ARAGUANA',
    label: 'ARAGUANA'
  },
  {
    stateKey: 'MA',
    value: 'ARAIOSES',
    label: 'ARAIOSES'
  },
  {
    stateKey: 'MA',
    value: 'ARAME',
    label: 'ARAME'
  },
  {
    stateKey: 'MA',
    value: 'ARARI',
    label: 'ARARI'
  },
  {
    stateKey: 'MA',
    value: 'AXIXA',
    label: 'AXIXA'
  },
  {
    stateKey: 'MA',
    value: 'BACABAL',
    label: 'BACABAL'
  },
  {
    stateKey: 'MA',
    value: 'BACABEIRA',
    label: 'BACABEIRA'
  },
  {
    stateKey: 'MA',
    value: 'BACURI',
    label: 'BACURI'
  },
  {
    stateKey: 'MA',
    value: 'BACURITUBA',
    label: 'BACURITUBA'
  },
  {
    stateKey: 'MA',
    value: 'BALSAS',
    label: 'BALSAS'
  },
  {
    stateKey: 'MA',
    value: 'BARAO DE GRAJAU',
    label: 'BARAO DE GRAJAU'
  },
  {
    stateKey: 'MA',
    value: 'BARRA DO CORDA',
    label: 'BARRA DO CORDA'
  },
  {
    stateKey: 'MA',
    value: 'BARREIRINHAS',
    label: 'BARREIRINHAS'
  },
  {
    stateKey: 'MA',
    value: 'BELA VISTA DO MARANHAO',
    label: 'BELA VISTA DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'BELAGUA',
    label: 'BELAGUA'
  },
  {
    stateKey: 'MA',
    value: 'BENEDITO LEITE',
    label: 'BENEDITO LEITE'
  },
  {
    stateKey: 'MA',
    value: 'BEQUIMAO',
    label: 'BEQUIMAO'
  },
  {
    stateKey: 'MA',
    value: 'BERNARDO DO MEARIM',
    label: 'BERNARDO DO MEARIM'
  },
  {
    stateKey: 'MA',
    value: 'BOM JARDIM',
    label: 'BOM JARDIM'
  },
  {
    stateKey: 'MA',
    value: 'BOM JESUS DAS SELVAS',
    label: 'BOM JESUS DAS SELVAS'
  },
  {
    stateKey: 'MA',
    value: 'BOM LUGAR',
    label: 'BOM LUGAR'
  },
  {
    stateKey: 'MA',
    value: 'BREJO',
    label: 'BREJO'
  },
  {
    stateKey: 'MA',
    value: 'BREJO DE AREIA',
    label: 'BREJO DE AREIA'
  },
  {
    stateKey: 'MA',
    value: 'BURITI',
    label: 'BURITI'
  },
  {
    stateKey: 'MA',
    value: 'BURITI BRAVO',
    label: 'BURITI BRAVO'
  },
  {
    stateKey: 'MA',
    value: 'BURITICUPU',
    label: 'BURITICUPU'
  },
  {
    stateKey: 'MA',
    value: 'BURITIRANA',
    label: 'BURITIRANA'
  },
  {
    stateKey: 'MA',
    value: 'CACHOEIRA GRANDE',
    label: 'CACHOEIRA GRANDE'
  },
  {
    stateKey: 'MA',
    value: 'CAJAPIO',
    label: 'CAJAPIO'
  },
  {
    stateKey: 'MA',
    value: 'CAJARI',
    label: 'CAJARI'
  },
  {
    stateKey: 'MA',
    value: 'CAMPESTRE DO MARANHAO',
    label: 'CAMPESTRE DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'CANDIDO MENDES',
    label: 'CANDIDO MENDES'
  },
  {
    stateKey: 'MA',
    value: 'CANTANHEDE',
    label: 'CANTANHEDE'
  },
  {
    stateKey: 'MA',
    value: 'CAPINZAL DO NORTE',
    label: 'CAPINZAL DO NORTE'
  },
  {
    stateKey: 'MA',
    value: 'CAROLINA',
    label: 'CAROLINA'
  },
  {
    stateKey: 'MA',
    value: 'CARUTAPERA',
    label: 'CARUTAPERA'
  },
  {
    stateKey: 'MA',
    value: 'CAXIAS',
    label: 'CAXIAS'
  },
  {
    stateKey: 'MA',
    value: 'CEDRAL',
    label: 'CEDRAL'
  },
  {
    stateKey: 'MA',
    value: 'CENTRAL DO MARANHAO',
    label: 'CENTRAL DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'CENTRO DO GUILHERME',
    label: 'CENTRO DO GUILHERME'
  },
  {
    stateKey: 'MA',
    value: 'CENTRO NOVO DO MARANHAO',
    label: 'CENTRO NOVO DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'CHAPADINHA',
    label: 'CHAPADINHA'
  },
  {
    stateKey: 'MA',
    value: 'CIDELANDIA',
    label: 'CIDELANDIA'
  },
  {
    stateKey: 'MA',
    value: 'CODO',
    label: 'CODO'
  },
  {
    stateKey: 'MA',
    value: 'COELHO NETO',
    label: 'COELHO NETO'
  },
  {
    stateKey: 'MA',
    value: 'COLINAS',
    label: 'COLINAS'
  },
  {
    stateKey: 'MA',
    value: 'CONCEICAO DO LAGO-ACU',
    label: 'CONCEICAO DO LAGO-ACU'
  },
  {
    stateKey: 'MA',
    value: 'COROATA',
    label: 'COROATA'
  },
  {
    stateKey: 'MA',
    value: 'CURURUPU',
    label: 'CURURUPU'
  },
  {
    stateKey: 'MA',
    value: 'DOM PEDRO',
    label: 'DOM PEDRO'
  },
  {
    stateKey: 'MA',
    value: 'DUQUE BACELAR',
    label: 'DUQUE BACELAR'
  },
  {
    stateKey: 'MA',
    value: 'ESPERANTINOPOLIS',
    label: 'ESPERANTINOPOLIS'
  },
  {
    stateKey: 'MA',
    value: 'ESTREITO',
    label: 'ESTREITO'
  },
  {
    stateKey: 'MA',
    value: 'FEIRA NOVA DO MARANHAO',
    label: 'FEIRA NOVA DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'FERNANDO FALCAO',
    label: 'FERNANDO FALCAO'
  },
  {
    stateKey: 'MA',
    value: 'FORMOSA DA SERRA NEGRA',
    label: 'FORMOSA DA SERRA NEGRA'
  },
  {
    stateKey: 'MA',
    value: 'FORTALEZA DOS NOGUEIRAS',
    label: 'FORTALEZA DOS NOGUEIRAS'
  },
  {
    stateKey: 'MA',
    value: 'FORTUNA',
    label: 'FORTUNA'
  },
  {
    stateKey: 'MA',
    value: 'GODOFREDO VIANA',
    label: 'GODOFREDO VIANA'
  },
  {
    stateKey: 'MA',
    value: 'GONCALVES DIAS',
    label: 'GONCALVES DIAS'
  },
  {
    stateKey: 'MA',
    value: 'GOVERNADOR ARCHER',
    label: 'GOVERNADOR ARCHER'
  },
  {
    stateKey: 'MA',
    value: 'GOVERNADOR EUGENIO BARROS',
    label: 'GOVERNADOR EUGENIO BARROS'
  },
  {
    stateKey: 'MA',
    value: 'GOVERNADOR LUIZ ROCHA',
    label: 'GOVERNADOR LUIZ ROCHA'
  },
  {
    stateKey: 'MA',
    value: 'GOVERNADOR NUNES FREIRE',
    label: 'GOVERNADOR NUNES FREIRE'
  },
  {
    stateKey: 'MA',
    value: 'GRACA ARANHA',
    label: 'GRACA ARANHA'
  },
  {
    stateKey: 'MA',
    value: 'GRAJAU',
    label: 'GRAJAU'
  },
  {
    stateKey: 'MA',
    value: 'GUIMARAES',
    label: 'GUIMARAES'
  },
  {
    stateKey: 'MA',
    value: 'HUMBERTO DE CAMPOS',
    label: 'HUMBERTO DE CAMPOS'
  },
  {
    stateKey: 'MA',
    value: 'ICATU',
    label: 'ICATU'
  },
  {
    stateKey: 'MA',
    value: 'IGARAPE GRANDE',
    label: 'IGARAPE GRANDE'
  },
  {
    stateKey: 'MA',
    value: 'IMPERATRIZ',
    label: 'IMPERATRIZ'
  },
  {
    stateKey: 'MA',
    value: 'ITAIPAVA DO GRAJAU',
    label: 'ITAIPAVA DO GRAJAU'
  },
  {
    stateKey: 'MA',
    value: 'ITAPECURU MIRIM',
    label: 'ITAPECURU MIRIM'
  },
  {
    stateKey: 'MA',
    value: 'ITINGA DO MARANHAO',
    label: 'ITINGA DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'JATOBA',
    label: 'JATOBA'
  },
  {
    stateKey: 'MA',
    value: 'JENIPAPO DOS VIEIRAS',
    label: 'JENIPAPO DOS VIEIRAS'
  },
  {
    stateKey: 'MA',
    value: 'JOAO LISBOA',
    label: 'JOAO LISBOA'
  },
  {
    stateKey: 'MA',
    value: 'JOSELANDIA',
    label: 'JOSELANDIA'
  },
  {
    stateKey: 'MA',
    value: 'JUNCO DO MARANHAO',
    label: 'JUNCO DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'LAGO DA PEDRA',
    label: 'LAGO DA PEDRA'
  },
  {
    stateKey: 'MA',
    value: 'LAGO DO JUNCO',
    label: 'LAGO DO JUNCO'
  },
  {
    stateKey: 'MA',
    value: 'LAGO DOS RODRIGUES',
    label: 'LAGO DOS RODRIGUES'
  },
  {
    stateKey: 'MA',
    value: 'LAGO VERDE',
    label: 'LAGO VERDE'
  },
  {
    stateKey: 'MA',
    value: 'LAGOA DO MATO',
    label: 'LAGOA DO MATO'
  },
  {
    stateKey: 'MA',
    value: 'LAJEADO NOVO',
    label: 'LAJEADO NOVO'
  },
  {
    stateKey: 'MA',
    value: 'LIMA CAMPOS',
    label: 'LIMA CAMPOS'
  },
  {
    stateKey: 'MA',
    value: 'LORETO',
    label: 'LORETO'
  },
  {
    stateKey: 'MA',
    value: 'LUIS DOMINGUES',
    label: 'LUIS DOMINGUES'
  },
  {
    stateKey: 'MA',
    value: 'MAGALHAES DE ALMEIDA',
    label: 'MAGALHAES DE ALMEIDA'
  },
  {
    stateKey: 'MA',
    value: 'MARACACUME',
    label: 'MARACACUME'
  },
  {
    stateKey: 'MA',
    value: 'MARAJA DO SENA',
    label: 'MARAJA DO SENA'
  },
  {
    stateKey: 'MA',
    value: 'MARANHAOZINHO',
    label: 'MARANHAOZINHO'
  },
  {
    stateKey: 'MA',
    value: 'MATA ROMA',
    label: 'MATA ROMA'
  },
  {
    stateKey: 'MA',
    value: 'MATINHA',
    label: 'MATINHA'
  },
  {
    stateKey: 'MA',
    value: 'MATOES',
    label: 'MATOES'
  },
  {
    stateKey: 'MA',
    value: 'MATOES DO NORTE',
    label: 'MATOES DO NORTE'
  },
  {
    stateKey: 'MA',
    value: 'MILAGRES DO MARANHAO',
    label: 'MILAGRES DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'MIRADOR',
    label: 'MIRADOR'
  },
  {
    stateKey: 'MA',
    value: 'MIRANDA DO NORTE',
    label: 'MIRANDA DO NORTE'
  },
  {
    stateKey: 'MA',
    value: 'MIRINZAL',
    label: 'MIRINZAL'
  },
  {
    stateKey: 'MA',
    value: 'MONCAO',
    label: 'MONCAO'
  },
  {
    stateKey: 'MA',
    value: 'MORROS',
    label: 'MORROS'
  },
  {
    stateKey: 'MA',
    value: 'NINA RODRIGUES',
    label: 'NINA RODRIGUES'
  },
  {
    stateKey: 'MA',
    value: 'NOVA COLINAS',
    label: 'NOVA COLINAS'
  },
  {
    stateKey: 'MA',
    value: 'NOVA IORQUE',
    label: 'NOVA IORQUE'
  },
  {
    stateKey: 'MA',
    value: "OLHO D'AGUA DAS CUNHAS",
    label: "OLHO D'AGUA DAS CUNHAS"
  },
  {
    stateKey: 'MA',
    value: 'OLINDA NOVA DO MARANHAO',
    label: 'OLINDA NOVA DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'PACO DO LUMIAR',
    label: 'PACO DO LUMIAR'
  },
  {
    stateKey: 'MA',
    value: 'PALMEIRANDIA',
    label: 'PALMEIRANDIA'
  },
  {
    stateKey: 'MA',
    value: 'PARAIBANO',
    label: 'PARAIBANO'
  },
  {
    stateKey: 'MA',
    value: 'PARNARAMA',
    label: 'PARNARAMA '
  },
  {
    stateKey: 'MA',
    value: 'PASSAGEM FRANCA',
    label: 'PASSAGEM FRANCA'
  },
  {
    stateKey: 'MA',
    value: 'PASTOS BONS',
    label: 'PASTOS BONS'
  },
  {
    stateKey: 'MA',
    value: 'PAULINO NEVES',
    label: 'PAULINO NEVES'
  },
  {
    stateKey: 'MA',
    value: 'PAULO RAMOS',
    label: 'PAULO RAMOS'
  },
  {
    stateKey: 'MA',
    value: 'PEDREIRAS',
    label: 'PEDREIRAS'
  },
  {
    stateKey: 'MA',
    value: 'PENALVA',
    label: 'PENALVA'
  },
  {
    stateKey: 'MA',
    value: 'PERI MIRIM',
    label: 'PERI MIRIM'
  },
  {
    stateKey: 'MA',
    value: 'PERITORO',
    label: 'PERITORO'
  },
  {
    stateKey: 'MA',
    value: 'PINDARE MIRIM',
    label: 'PINDARE MIRIM'
  },
  {
    stateKey: 'MA',
    value: 'PINHEIRO',
    label: 'PINHEIRO'
  },
  {
    stateKey: 'MA',
    value: 'PIO XII',
    label: 'PIO XII'
  },
  {
    stateKey: 'MA',
    value: 'PIRAPEMAS',
    label: 'PIRAPEMAS'
  },
  {
    stateKey: 'MA',
    value: 'POCAO DE PEDRAS',
    label: 'POCAO DE PEDRAS'
  },
  {
    stateKey: 'MA',
    value: 'PORTO FRANCO',
    label: 'PORTO FRANCO'
  },
  {
    stateKey: 'MA',
    value: 'PORTO RICO DO MARANHAO',
    label: 'PORTO RICO DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'PRESIDENTE DUTRA',
    label: 'PRESIDENTE DUTRA'
  },
  {
    stateKey: 'MA',
    value: 'PRESIDENTE JUSCELINO',
    label: 'PRESIDENTE JUSCELINO'
  },
  {
    stateKey: 'MA',
    value: 'PRESIDENTE MEDICI',
    label: 'PRESIDENTE MEDICI'
  },
  {
    stateKey: 'MA',
    value: 'PRESIDENTE SARNEY',
    label: 'PRESIDENTE SARNEY'
  },
  {
    stateKey: 'MA',
    value: 'PRESIDENTE VARGAS',
    label: 'PRESIDENTE VARGAS'
  },
  {
    stateKey: 'MA',
    value: 'PRIMEIRA CRUZ',
    label: 'PRIMEIRA CRUZ'
  },
  {
    stateKey: 'MA',
    value: 'RAPOSA',
    label: 'RAPOSA'
  },
  {
    stateKey: 'MA',
    value: 'RIACHAO',
    label: 'RIACHAO'
  },
  {
    stateKey: 'MA',
    value: 'RIBAMAR FIQUENE',
    label: 'RIBAMAR FIQUENE'
  },
  {
    stateKey: 'MA',
    value: 'ROSARIO',
    label: 'ROSARIO'
  },
  {
    stateKey: 'MA',
    value: 'SAMBAIBA',
    label: 'SAMBAIBA '
  },
  {
    stateKey: 'MA',
    value: 'SANTA FILOMENA',
    label: 'SANTA FILOMENA'
  },
  {
    stateKey: 'MA',
    value: 'SANTA HELENA',
    label: 'SANTA HELENA'
  },
  {
    stateKey: 'MA',
    value: 'SANTA INES',
    label: 'SANTA INES'
  },
  {
    stateKey: 'MA',
    value: 'SANTA LUZIA',
    label: 'SANTA LUZIA'
  },
  {
    stateKey: 'MA',
    value: 'SANTA LUZIA DO PARUA',
    label: 'SANTA LUZIA DO PARUA'
  },
  {
    stateKey: 'MA',
    value: 'SANTA QUITERIA DO MARANHAO',
    label: 'SANTA QUITERIA DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'SANTA RITA',
    label: 'SANTA RITA'
  },
  {
    stateKey: 'MA',
    value: 'SANTANA DO MARANHAO',
    label: 'SANTANA DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'SANTO AMARO DO MARANHAO',
    label: 'SANTO AMARO DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'SANTO ANTONIO DOS LOPES',
    label: 'SANTO ANTONIO DOS LOPES'
  },
  {
    stateKey: 'MA',
    value: 'SAO BENEDITO DO RIO PRETO',
    label: 'SAO BENEDITO DO RIO PRETO'
  },
  {
    stateKey: 'MA',
    value: 'SAO BENTO',
    label: 'SAO BENTO'
  },
  {
    stateKey: 'MA',
    value: 'SAO BERNARDO',
    label: 'SAO BERNARDO'
  },
  {
    stateKey: 'MA',
    value: 'SAO DOMINGOS DO AZEITAO',
    label: 'SAO DOMINGOS DO AZEITAO'
  },
  {
    stateKey: 'MA',
    value: 'SAO DOMINGOS DO MARANHAO',
    label: 'SAO DOMINGOS DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'SAO FELIX DE BALSAS',
    label: 'SAO FELIX DE BALSAS'
  },
  {
    stateKey: 'MA',
    value: 'SAO FRANCISCO DO BREJAO',
    label: 'SAO FRANCISCO DO BREJAO'
  },
  {
    stateKey: 'MA',
    value: 'SAO FRANCISCO DO MARANHAO',
    label: 'SAO FRANCISCO DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'SAO JOAO BATISTA',
    label: 'SAO JOAO BATISTA'
  },
  {
    stateKey: 'MA',
    value: 'SAO JOAO DO CARU',
    label: 'SAO JOAO DO CARU'
  },
  {
    stateKey: 'MA',
    value: 'SAO JOAO DO PARAISO',
    label: 'SAO JOAO DO PARAISO'
  },
  {
    stateKey: 'MA',
    value: 'SAO JOAO DO SOTER',
    label: 'SAO JOAO DO SOTER'
  },
  {
    stateKey: 'MA',
    value: 'SAO JOAO DOS PATOS',
    label: 'SAO JOAO DOS PATOS'
  },
  {
    stateKey: 'MA',
    value: 'SAO JOSE DE RIBAMAR',
    label: 'SAO JOSE DE RIBAMAR'
  },
  {
    stateKey: 'MA',
    value: 'SAO JOSE DOS BASILIOS',
    label: 'SAO JOSE DOS BASILIOS'
  },
  {
    stateKey: 'MA',
    value: 'SAO LUIS',
    label: 'SAO LUIS'
  },
  {
    stateKey: 'MA',
    value: 'SAO MATEUS DO MARANHAO',
    label: 'SAO MATEUS DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'SAO PEDRO DA AGUA BRANCA',
    label: 'SAO PEDRO DA AGUA BRANCA'
  },
  {
    stateKey: 'MA',
    value: 'SAO PEDRO DOS CRENTES',
    label: 'SAO PEDRO DOS CRENTES'
  },
  {
    stateKey: 'MA',
    value: 'SAO RAIMUNDO DOCA BEZERRA',
    label: 'SAO RAIMUNDO DOCA BEZERRA'
  },
  {
    stateKey: 'MA',
    value: 'SAO ROBERTO',
    label: 'SAO ROBERTO'
  },
  {
    stateKey: 'MA',
    value: 'SAO VICENTE FERRER',
    label: 'SAO VICENTE FERRER'
  },
  {
    stateKey: 'MA',
    value: 'SATUBINHA',
    label: 'SATUBINHA'
  },
  {
    stateKey: 'MA',
    value: 'SENADOR ALEXANDRE COSTA',
    label: 'SENADOR ALEXANDRE COSTA'
  },
  {
    stateKey: 'MA',
    value: 'SENADOR LA ROCQUE',
    label: 'SENADOR LA ROCQUE'
  },
  {
    stateKey: 'MA',
    value: 'SERRANO DO MARANHAO',
    label: 'SERRANO DO MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'SITIO NOVO',
    label: 'SITIO NOVO'
  },
  {
    stateKey: 'MA',
    value: 'SUCUPIRA DO NORTE',
    label: 'SUCUPIRA DO NORTE'
  },
  {
    stateKey: 'MA',
    value: 'SUCUPIRA DO RIACHAO',
    label: 'SUCUPIRA DO RIACHAO'
  },
  {
    stateKey: 'MA',
    value: 'TASSO FRAGOSO',
    label: 'TASSO FRAGOSO'
  },
  {
    stateKey: 'MA',
    value: 'TIMBIRAS',
    label: 'TIMBIRAS'
  },
  {
    stateKey: 'MA',
    value: 'TIMON',
    label: 'TIMON'
  },
  {
    stateKey: 'MA',
    value: 'TRIZIDELA DO VALE',
    label: 'TRIZIDELA DO VALE'
  },
  {
    stateKey: 'MA',
    value: 'TUFILANDIA',
    label: 'TUFILANDIA'
  },
  {
    stateKey: 'MA',
    value: 'TUNTUM',
    label: 'TUNTUM'
  },
  {
    stateKey: 'MA',
    value: 'TURIACU',
    label: 'TURIACU'
  },
  {
    stateKey: 'MA',
    value: 'TURILANDIA',
    label: 'TURILANDIA'
  },
  {
    stateKey: 'MA',
    value: 'TUTOIA',
    label: 'TUTOIA'
  },
  {
    stateKey: 'MA',
    value: 'URBANO SANTOS',
    label: 'URBANO SANTOS'
  },
  {
    stateKey: 'MA',
    value: 'VARGEM GRANDE',
    label: 'VARGEM GRANDE'
  },
  {
    stateKey: 'MA',
    value: 'VIANA',
    label: 'VIANA'
  },
  {
    stateKey: 'MA',
    value: 'VILA NOVA DOS MARTIRIOS',
    label: 'VILA NOVA DOS MARTIRIOS'
  },
  {
    stateKey: 'MA',
    value: 'VITORIA DO MEARIM',
    label: 'VITORIA DO MEARIM'
  },
  {
    stateKey: 'MA',
    value: 'VITORINO FREIRE',
    label: 'VITORINO FREIRE'
  },
  {
    stateKey: 'MA',
    value: 'ZE DOCA',
    label: 'ZE DOCA'
  },
  {
    stateKey: 'MA',
    value: 'AP do MA',
    label: 'AP do MA'
  },
  {
    stateKey: 'MA',
    value: 'Boa Vista do Gurupi',
    label: 'Boa Vista do Gurupi'
  },
  {
    stateKey: 'MA',
    value: 'Governador Newton Bello',
    label: 'Governador Newton Bello'
  },
  {
    stateKey: 'MA',
    value: 'Igarapé do Meio',
    label: 'Igarapé do Meio'
  },
  {
    stateKey: 'MA',
    value: 'Lagoa Grande do MA',
    label: 'Lagoa Grande do MA'
  },
  {
    stateKey: 'MA',
    value: 'Nova Olinda do MA',
    label: 'Nova Olinda do MA'
  },
  {
    stateKey: 'MA',
    value: 'Pedro do Rosário',
    label: 'Pedro do Rosário'
  },
  {
    stateKey: 'MA',
    value: 'DAVINÓPOLIS',
    label: 'DAVINÓPOLIS'
  },
  {
    stateKey: 'MA',
    value: 'MONTES ALTOS',
    label: 'MONTES ALTOS'
  },
  {
    stateKey: 'MA',
    value: 'SAO LUIZ GONZAGA MARANHAO',
    label: 'SAO LUIZ GONZAGA MARANHAO'
  },
  {
    stateKey: 'MA',
    value: 'SAO RAIMUNDO MANGABEIRAS',
    label: 'SAO RAIMUNDO MANGABEIRAS'
  },
  {
    stateKey: 'MA',
    value: 'GOVERNADOR EDSON LOBAO',
    label: 'GOVERNADOR EDSON LOBAO'
  },
  {
    stateKey: 'MT',
    value: 'STA RITA DO TRIVELATO',
    label: 'STA RITA DO TRIVELATO'
  },
  {
    stateKey: 'MT',
    value: 'VL BELA SANTISSIMA TRINDAD',
    label: 'VL BELA SANTISSIMA TRINDAD'
  },
  {
    stateKey: 'MT',
    value: 'IPIRANGA DO NORTE',
    label: 'IPIRANGA DO NORTE'
  },
  {
    stateKey: 'MT',
    value: 'NOVA NAZARE',
    label: 'NOVA NAZARE'
  },
  {
    stateKey: 'MT',
    value: 'Curvelândia',
    label: 'Curvelândia'
  },
  {
    stateKey: 'MT',
    value: 'ITANHANGA',
    label: 'ITANHANGA'
  },
  {
    stateKey: 'MT',
    value: 'ACORIZAL',
    label: 'ACORIZAL'
  },
  {
    stateKey: 'MT',
    value: 'AGUA BOA',
    label: 'AGUA BOA'
  },
  {
    stateKey: 'MT',
    value: 'ALTA FLORESTA',
    label: 'ALTA FLORESTA'
  },
  {
    stateKey: 'MT',
    value: 'ALTO ARAGUAIA',
    label: 'ALTO ARAGUAIA'
  },
  {
    stateKey: 'MT',
    value: 'ALTO BOA VISTA',
    label: 'ALTO BOA VISTA'
  },
  {
    stateKey: 'MT',
    value: 'ALTO GARCAS',
    label: 'ALTO GARCAS'
  },
  {
    stateKey: 'MT',
    value: 'ALTO PARAGUAI',
    label: 'ALTO PARAGUAI'
  },
  {
    stateKey: 'MT',
    value: 'ALTO TAQUARI',
    label: 'ALTO TAQUARI'
  },
  {
    stateKey: 'MT',
    value: 'APIACAS',
    label: 'APIACAS'
  },
  {
    stateKey: 'MT',
    value: 'ARAGUAIANA',
    label: 'ARAGUAIANA'
  },
  {
    stateKey: 'MT',
    value: 'ARAGUAINHA',
    label: 'ARAGUAINHA'
  },
  {
    stateKey: 'MT',
    value: 'ARAPUTANGA',
    label: 'ARAPUTANGA'
  },
  {
    stateKey: 'MT',
    value: 'ARENAPOLIS',
    label: 'ARENAPOLIS'
  },
  {
    stateKey: 'MT',
    value: 'ARIPUANA',
    label: 'ARIPUANA'
  },
  {
    stateKey: 'MT',
    value: 'BARAO DE MELGACO',
    label: 'BARAO DE MELGACO'
  },
  {
    stateKey: 'MT',
    value: 'BARRA DO BUGRES',
    label: 'BARRA DO BUGRES'
  },
  {
    stateKey: 'MT',
    value: 'BARRA DO GARCAS',
    label: 'BARRA DO GARCAS'
  },
  {
    stateKey: 'MT',
    value: 'BRASNORTE',
    label: 'BRASNORTE'
  },
  {
    stateKey: 'MT',
    value: 'CACERES',
    label: 'CACERES'
  },
  {
    stateKey: 'MT',
    value: 'CAMPINAPOLIS',
    label: 'CAMPINAPOLIS'
  },
  {
    stateKey: 'MT',
    value: 'CAMPO NOVO DO PARECIS',
    label: 'CAMPO NOVO DO PARECIS'
  },
  {
    stateKey: 'MT',
    value: 'CAMPO VERDE',
    label: 'CAMPO VERDE'
  },
  {
    stateKey: 'MT',
    value: 'CAMPOS DE JULIO',
    label: 'CAMPOS DE JULIO'
  },
  {
    stateKey: 'MT',
    value: 'CANABRAVA DO NORTE',
    label: 'CANABRAVA DO NORTE'
  },
  {
    stateKey: 'MT',
    value: 'CANARANA',
    label: 'CANARANA'
  },
  {
    stateKey: 'MT',
    value: 'CARLINDA',
    label: 'CARLINDA'
  },
  {
    stateKey: 'MT',
    value: 'CASTANHEIRA',
    label: 'CASTANHEIRA'
  },
  {
    stateKey: 'MT',
    value: 'CHAPADA DOS GUIMARAES',
    label: 'CHAPADA DOS GUIMARAES'
  },
  {
    stateKey: 'MT',
    value: 'CLAUDIA',
    label: 'CLAUDIA'
  },
  {
    stateKey: 'MT',
    value: 'COCALINHO',
    label: 'COCALINHO'
  },
  {
    stateKey: 'MT',
    value: 'COLIDER',
    label: 'COLIDER'
  },
  {
    stateKey: 'MT',
    value: 'COMODORO',
    label: 'COMODORO'
  },
  {
    stateKey: 'MT',
    value: 'CONFRESA',
    label: 'CONFRESA'
  },
  {
    stateKey: 'MT',
    value: 'COTRIGUACU',
    label: 'COTRIGUACU'
  },
  {
    stateKey: 'MT',
    value: 'CUIABA',
    label: 'CUIABA'
  },
  {
    stateKey: 'MT',
    value: 'DENISE',
    label: 'DENISE'
  },
  {
    stateKey: 'MT',
    value: 'DIAMANTINO',
    label: 'DIAMANTINO'
  },
  {
    stateKey: 'MT',
    value: 'DOM AQUINO',
    label: 'DOM AQUINO'
  },
  {
    stateKey: 'MT',
    value: 'FELIZ NATAL',
    label: 'FELIZ NATAL'
  },
  {
    stateKey: 'MT',
    value: 'GAUCHA DO NORTE',
    label: 'GAUCHA DO NORTE'
  },
  {
    stateKey: 'MT',
    value: 'GENERAL CARNEIRO',
    label: 'GENERAL CARNEIRO'
  },
  {
    stateKey: 'MT',
    value: "GLORIA D'OESTE",
    label: "GLORIA D'OESTE"
  },
  {
    stateKey: 'MT',
    value: 'GUARANTA DO NORTE',
    label: 'GUARANTA DO NORTE'
  },
  {
    stateKey: 'MT',
    value: 'GUIRATINGA',
    label: 'GUIRATINGA'
  },
  {
    stateKey: 'MT',
    value: 'INDIAVAI',
    label: 'INDIAVAI'
  },
  {
    stateKey: 'MT',
    value: 'ITAUBA',
    label: 'ITAUBA'
  },
  {
    stateKey: 'MT',
    value: 'ITIQUIRA',
    label: 'ITIQUIRA'
  },
  {
    stateKey: 'MT',
    value: 'JACIARA',
    label: 'JACIARA'
  },
  {
    stateKey: 'MT',
    value: 'JANGADA',
    label: 'JANGADA'
  },
  {
    stateKey: 'MT',
    value: 'JAURU',
    label: 'JAURU'
  },
  {
    stateKey: 'MT',
    value: 'JUARA',
    label: 'JUARA'
  },
  {
    stateKey: 'MT',
    value: 'JUINA',
    label: 'JUINA'
  },
  {
    stateKey: 'MT',
    value: 'JURUENA',
    label: 'JURUENA'
  },
  {
    stateKey: 'MT',
    value: 'JUSCIMEIRA',
    label: 'JUSCIMEIRA'
  },
  {
    stateKey: 'MT',
    value: "LAMBARI D'OESTE",
    label: "LAMBARI D'OESTE"
  },
  {
    stateKey: 'MT',
    value: 'LUCAS DO RIO VERDE',
    label: 'LUCAS DO RIO VERDE'
  },
  {
    stateKey: 'MT',
    value: 'LUCIARA',
    label: 'LUCIARA'
  },
  {
    stateKey: 'MT',
    value: 'MARCELANDIA',
    label: 'MARCELANDIA'
  },
  {
    stateKey: 'MT',
    value: 'MATUPA',
    label: 'MATUPA'
  },
  {
    stateKey: 'MT',
    value: "MIRASSOL D'OESTE ",
    label: "MIRASSOL D'OESTE"
  },
  {
    stateKey: 'MT',
    value: 'NOBRES',
    label: 'NOBRES'
  },
  {
    stateKey: 'MT',
    value: 'NORTELANDIA',
    label: 'NORTELANDIA'
  },
  {
    stateKey: 'MT',
    value: 'NOSSA SENHORA DO LIVRAMENT',
    label: 'NOSSA SENHORA DO LIVRAMENT'
  },
  {
    stateKey: 'MT',
    value: 'NOVA BANDEIRANTES',
    label: 'NOVA BANDEIRANTES'
  },
  {
    stateKey: 'MT',
    value: 'NOVA BRASILANDIA',
    label: 'NOVA BRASILANDIA'
  },
  {
    stateKey: 'MT',
    value: 'NOVA CANAA DO NORTE',
    label: 'NOVA CANAA DO NORTE'
  },
  {
    stateKey: 'MT',
    value: 'NOVA GUARITA',
    label: 'NOVA GUARITA'
  },
  {
    stateKey: 'MT',
    value: 'NOVA LACERDA',
    label: 'NOVA LACERDA'
  },
  {
    stateKey: 'MT',
    value: 'NOVA MARILANDIA',
    label: 'NOVA MARILANDIA'
  },
  {
    stateKey: 'MT',
    value: 'NOVA MARINGA',
    label: 'NOVA MARINGA'
  },
  {
    stateKey: 'MT',
    value: 'NOVA MONTE VERDE',
    label: 'NOVA MONTE VERDE'
  },
  {
    stateKey: 'MT',
    value: 'NOVA MUTUM',
    label: 'NOVA MUTUM'
  },
  {
    stateKey: 'MT',
    value: 'NOVA OLIMPIA',
    label: 'NOVA OLIMPIA'
  },
  {
    stateKey: 'MT',
    value: 'NOVA UBIRATA',
    label: 'NOVA UBIRATA'
  },
  {
    stateKey: 'MT',
    value: 'NOVA XAVANTINA',
    label: 'NOVA XAVANTINA'
  },
  {
    stateKey: 'MT',
    value: 'NOVO HORIZONTE DO NORTE',
    label: 'NOVO HORIZONTE DO NORTE'
  },
  {
    stateKey: 'MT',
    value: 'NOVO MUNDO',
    label: 'NOVO MUNDO'
  },
  {
    stateKey: 'MT',
    value: 'NOVO SAO JOAQUIM',
    label: 'NOVO SAO JOAQUIM'
  },
  {
    stateKey: 'MT',
    value: 'PARANAITA',
    label: 'PARANAITA'
  },
  {
    stateKey: 'MT',
    value: 'PARANATINGA',
    label: 'PARANATINGA'
  },
  {
    stateKey: 'MT',
    value: 'PEDRA PRETA',
    label: 'PEDRA PRETA'
  },
  {
    stateKey: 'MT',
    value: 'PEIXOTO DE AZEVEDO',
    label: 'PEIXOTO DE AZEVEDO'
  },
  {
    stateKey: 'MT',
    value: 'PLANALTO DA SERRA',
    label: 'PLANALTO DA SERRA'
  },
  {
    stateKey: 'MT',
    value: 'POCONE',
    label: 'POCONE'
  },
  {
    stateKey: 'MT',
    value: 'PONTAL DO ARAGUAIA',
    label: 'PONTAL DO ARAGUAIA'
  },
  {
    stateKey: 'MT',
    value: 'PONTE BRANCA',
    label: 'PONTE BRANCA'
  },
  {
    stateKey: 'MT',
    value: 'PONTES E LACERDA',
    label: 'PONTES E LACERDA'
  },
  {
    stateKey: 'MT',
    value: 'PORTO ALEGRE DO NORTE',
    label: 'PORTO ALEGRE DO NORTE'
  },
  {
    stateKey: 'MT',
    value: 'PORTO DOS GAUCHOS',
    label: 'PORTO DOS GAUCHOS'
  },
  {
    stateKey: 'MT',
    value: 'PORTO ESPERIDIAO',
    label: 'PORTO ESPERIDIAO'
  },
  {
    stateKey: 'MT',
    value: 'PORTO ESTRELA',
    label: 'PORTO ESTRELA'
  },
  {
    stateKey: 'MT',
    value: 'POXOREU',
    label: 'POXOREU'
  },
  {
    stateKey: 'MT',
    value: 'PRIMAVERA DO LESTE',
    label: 'PRIMAVERA DO LESTE'
  },
  {
    stateKey: 'MT',
    value: 'QUERENCIA',
    label: 'QUERENCIA'
  },
  {
    stateKey: 'MT',
    value: 'RESERVA DO CABACAL',
    label: 'RESERVA DO CABACAL'
  },
  {
    stateKey: 'MT',
    value: 'RIBEIRAO CASCALHEIRA',
    label: 'RIBEIRAO CASCALHEIRA'
  },
  {
    stateKey: 'MT',
    value: 'RIBEIRAOZINHO',
    label: 'RIBEIRAOZINHO'
  },
  {
    stateKey: 'MT',
    value: 'RONDONOPOLIS',
    label: 'RONDONOPOLIS'
  },
  {
    stateKey: 'MT',
    value: 'ROSARIO OESTE',
    label: 'ROSARIO OESTE'
  },
  {
    stateKey: 'MT',
    value: 'SALTO DO CEU',
    label: 'SALTO DO CEU'
  },
  {
    stateKey: 'MT',
    value: 'SANTA CARMEM',
    label: 'SANTA CARMEM'
  },
  {
    stateKey: 'MT',
    value: 'SANTA TEREZINHA',
    label: 'SANTA TEREZINHA'
  },
  {
    stateKey: 'MT',
    value: 'SANTO AFONSO',
    label: 'SANTO AFONSO'
  },
  {
    stateKey: 'MT',
    value: 'SANTO ANTONIO DO LEVERGER',
    label: 'SANTO ANTONIO DO LEVERGER'
  },
  {
    stateKey: 'MT',
    value: 'SAO FELIX DO ARAGUAIA',
    label: 'SAO FELIX DO ARAGUAIA'
  },
  {
    stateKey: 'MT',
    value: 'SAO JOSE DO POVO',
    label: 'SAO JOSE DO POVO'
  },
  {
    stateKey: 'MT',
    value: 'SAO JOSE DO XINGU',
    label: 'SAO JOSE DO XINGU'
  },
  {
    stateKey: 'MT',
    value: 'SAO PEDRO DA CIPA',
    label: 'SAO PEDRO DA CIPA'
  },
  {
    stateKey: 'MT',
    value: 'SAPEZAL',
    label: 'SAPEZAL'
  },
  {
    stateKey: 'MT',
    value: 'SINOP',
    label: 'SINOP'
  },
  {
    stateKey: 'MT',
    value: 'SORRISO',
    label: 'SORRISO'
  },
  {
    stateKey: 'MT',
    value: 'TABAPORA',
    label: 'TABAPORA'
  },
  {
    stateKey: 'MT',
    value: 'TANGARA DA SERRA',
    label: 'TANGARA DA SERRA'
  },
  {
    stateKey: 'MT',
    value: 'TAPURAH',
    label: 'TAPURAH'
  },
  {
    stateKey: 'MT',
    value: 'TERRA NOVA DO NORTE',
    label: 'TERRA NOVA DO NORTE'
  },
  {
    stateKey: 'MT',
    value: 'TESOURO',
    label: 'TESOURO'
  },
  {
    stateKey: 'MT',
    value: 'VARZEA GRANDE',
    label: 'VARZEA GRANDE'
  },
  {
    stateKey: 'MT',
    value: 'VERA',
    label: 'VERA'
  },
  {
    stateKey: 'MT',
    value: 'VILA RICA',
    label: 'VILA RICA'
  },
  {
    stateKey: 'MT',
    value: 'Novo Santo Antônio',
    label: 'Novo Santo Antônio'
  },
  {
    stateKey: 'MT',
    value: 'Rondolândia',
    label: 'Rondolândia'
  },
  {
    stateKey: 'MT',
    value: 'NOVA SANTA HELENA',
    label: 'NOVA SANTA HELENA'
  },
  {
    stateKey: 'MT',
    value: 'SERRA NOVA DOURADA',
    label: 'SERRA NOVA DOURADA'
  },
  {
    stateKey: 'MT',
    value: 'SÃO JOSÉ DOS QUATRO MARCOS MT',
    label: 'SÃO JOSÉ DOS QUATRO MARCOS MT'
  },
  {
    stateKey: 'MT',
    value: 'SANTA CRUZ DO XINGU',
    label: 'SANTA CRUZ DO XINGU'
  },
  {
    stateKey: 'MT',
    value: 'TORIXOREU',
    label: 'TORIXOREU'
  },
  {
    stateKey: 'MT',
    value: 'UNIAO DO SUL',
    label: 'UNIAO DO SUL'
  },
  {
    stateKey: 'MT',
    value: 'VALE DE SAO DOMINGOS',
    label: 'VALE DE SAO DOMINGOS'
  },
  {
    stateKey: 'MT',
    value: 'RIO BRANCO',
    label: 'RIO BRANCO'
  },
  {
    stateKey: 'MT',
    value: "FIGUEIROPOLIS D'OESTE",
    label: "FIGUEIROPOLIS D'OESTE"
  },
  {
    stateKey: 'MT',
    value: 'SAO JOSE DO RIO CLARO',
    label: 'SAO JOSE DO RIO CLARO'
  },
  {
    stateKey: 'MT',
    value: 'SANTO ANTONIO DO LESTE',
    label: 'SANTO ANTONIO DO LESTE'
  },
  {
    stateKey: 'MT',
    value: 'BOM JESUS DO ARAGUAIA',
    label: 'BOM JESUS DO ARAGUAIA'
  },
  {
    stateKey: 'MT',
    value: "CONQUISTA D'OESTE",
    label: "CONQUISTA D'OESTE"
  },
  {
    stateKey: 'MS',
    value: 'TERENOS',
    label: 'TERENOS'
  },
  {
    stateKey: 'MS',
    value: 'LADARIO',
    label: 'LADARIO'
  },
  {
    stateKey: 'MS',
    value: 'BODOQUENA',
    label: 'BODOQUENA'
  },
  {
    stateKey: 'MS',
    value: 'MIRANDA',
    label: 'MIRANDA'
  },
  {
    stateKey: 'MS',
    value: 'IGUATEMI',
    label: 'IGUATEMI'
  },
  {
    stateKey: 'MS',
    value: 'ALCINOPOLIS',
    label: 'ALCINOPOLIS'
  },
  {
    stateKey: 'MS',
    value: 'BODOQUENA',
    label: 'BODOQUENA'
  },
  {
    stateKey: 'MS',
    value: 'CHAPADAO DO SUL',
    label: 'CHAPADAO DO SUL'
  },
  {
    stateKey: 'MS',
    value: 'CORONEL SAPUCAIA',
    label: 'CORONEL SAPUCAIA'
  },
  {
    stateKey: 'MS',
    value: 'COSTA RICA',
    label: 'COSTA RICA'
  },
  {
    stateKey: 'MS',
    value: 'DOIS IRMAOS DO BURITI',
    label: 'DOIS IRMAOS DO BURITI'
  },
  {
    stateKey: 'MS',
    value: 'DOURADINA',
    label: 'DOURADINA'
  },
  {
    stateKey: 'MS',
    value: 'ITAQUIRAI',
    label: 'ITAQUIRAI'
  },
  {
    stateKey: 'MS',
    value: 'JAPORA',
    label: 'JAPORA'
  },
  {
    stateKey: 'MS',
    value: 'JUTI',
    label: 'JUTI'
  },
  {
    stateKey: 'MS',
    value: 'LAGUNA CARAPA',
    label: 'LAGUNA CARAPA'
  },
  {
    stateKey: 'MS',
    value: 'NOVA ALVORADA DO SUL',
    label: 'NOVA ALVORADA DO SUL'
  },
  {
    stateKey: 'MS',
    value: 'NOVO HORIZONTE DO SUL',
    label: 'NOVO HORIZONTE DO SUL'
  },
  {
    stateKey: 'MS',
    value: 'PARANHOS',
    label: 'PARANHOS'
  },
  {
    stateKey: 'MS',
    value: 'SANTA RITA DO PARDO',
    label: 'SANTA RITA DO PARDO'
  },
  {
    stateKey: 'MS',
    value: 'SAO GABRIEL DO OESTE',
    label: 'SAO GABRIEL DO OESTE'
  },
  {
    stateKey: 'MS',
    value: 'SELVIRIA',
    label: 'SELVIRIA'
  },
  {
    stateKey: 'MS',
    value: 'SETE QUEDAS',
    label: 'SETE QUEDAS'
  },
  {
    stateKey: 'MS',
    value: 'SONORA',
    label: 'SONORA'
  },
  {
    stateKey: 'MS',
    value: 'TACURU',
    label: 'TACURU'
  },
  {
    stateKey: 'MS',
    value: 'TAQUARUSSU',
    label: 'TAQUARUSSU'
  },
  {
    stateKey: 'MS',
    value: 'VICENTINA',
    label: 'VICENTINA'
  },
  {
    stateKey: 'MS',
    value: 'CARACOL',
    label: 'CARACOL'
  },
  {
    stateKey: 'MS',
    value: 'Bela Vista',
    label: 'Bela Vista'
  },
  {
    stateKey: 'MS',
    value: 'FIGUEIRAO',
    label: 'FIGUEIRAO'
  },
  {
    stateKey: 'MS',
    value: 'Guia Lopes da Laguna',
    label: 'Guia Lopes da Laguna'
  },
  {
    stateKey: 'MS',
    value: 'Jaraguari',
    label: 'Jaraguari'
  },
  {
    stateKey: 'MS',
    value: 'Porto Murtinho',
    label: 'Porto Murtinho'
  },
  {
    stateKey: 'MS',
    value: 'Rochedo',
    label: 'Rochedo'
  },
  {
    stateKey: 'MS',
    value: 'Colniza',
    label: 'Colniza'
  },
  {
    stateKey: 'MS',
    value: 'ELDORADO',
    label: 'ELDORADO'
  },
  {
    stateKey: 'MS',
    value: 'NIOAQUE',
    label: 'NIOAQUE'
  },
  {
    stateKey: 'MS',
    value: 'NOVA ANDRADINA',
    label: 'NOVA ANDRADINA'
  },
  {
    stateKey: 'MS',
    value: 'TRES LAGOAS',
    label: 'TRES LAGOAS'
  },
  {
    stateKey: 'MS',
    value: 'MARACAJU',
    label: 'MARACAJU'
  },
  {
    stateKey: 'MS',
    value: 'DOURADOS',
    label: 'DOURADOS'
  },
  {
    stateKey: 'MS',
    value: 'DEODAPOLIS',
    label: 'DEODAPOLIS'
  },
  {
    stateKey: 'MS',
    value: 'FATIMA DO SUL',
    label: 'FATIMA DO SUL'
  },
  {
    stateKey: 'MS',
    value: 'CAARAPO',
    label: 'CAARAPO'
  },
  {
    stateKey: 'MS',
    value: 'AMAMBAI',
    label: 'AMAMBAI'
  },
  {
    stateKey: 'MS',
    value: 'ANGELICA',
    label: 'ANGELICA'
  },
  {
    stateKey: 'MS',
    value: 'ANTONIO JOAO',
    label: 'ANTONIO JOAO'
  },
  {
    stateKey: 'MS',
    value: 'GLORIA DE DOURADOS',
    label: 'GLORIA DE DOURADOS'
  },
  {
    stateKey: 'MS',
    value: 'IGUATEMI',
    label: 'IGUATEMI'
  },
  {
    stateKey: 'MS',
    value: 'ITAPORA',
    label: 'ITAPORA'
  },
  {
    stateKey: 'MS',
    value: 'IVINHEMA',
    label: 'IVINHEMA'
  },
  {
    stateKey: 'MS',
    value: 'JATEI',
    label: 'JATEI'
  },
  {
    stateKey: 'MS',
    value: 'MUNDO NOVO',
    label: 'MUNDO NOVO'
  },
  {
    stateKey: 'MS',
    value: 'PONTA PORA',
    label: 'PONTA PORA'
  },
  {
    stateKey: 'MS',
    value: 'RIO BRILHANTE',
    label: 'RIO BRILHANTE'
  },
  {
    stateKey: 'MS',
    value: 'CAMPO GRANDE',
    label: 'CAMPO GRANDE'
  },
  {
    stateKey: 'MS',
    value: 'SIDROLANDIA',
    label: 'SIDROLANDIA'
  },
  {
    stateKey: 'MS',
    value: 'CAMAPUA',
    label: 'CAMAPUA'
  },
  {
    stateKey: 'MS',
    value: 'BONITO',
    label: 'BONITO'
  },
  {
    stateKey: 'MS',
    value: 'JARDIM',
    label: 'JARDIM'
  },
  {
    stateKey: 'MS',
    value: 'RIBAS DO RIO PARDO',
    label: 'RIBAS DO RIO PARDO'
  },
  {
    stateKey: 'MS',
    value: 'BATAYPORA',
    label: 'BATAYPORA'
  },
  {
    stateKey: 'MS',
    value: 'PARANAIBA',
    label: 'PARANAIBA'
  },
  {
    stateKey: 'MS',
    value: 'COXIM',
    label: 'COXIM'
  },
  {
    stateKey: 'MS',
    value: 'APARECIDA DO TABOADO',
    label: 'APARECIDA DO TABOADO'
  },
  {
    stateKey: 'MS',
    value: 'INOCENCIA',
    label: 'INOCENCIA'
  },
  {
    stateKey: 'MS',
    value: 'CORUMBA',
    label: 'CORUMBA'
  },
  {
    stateKey: 'MS',
    value: 'ANAURILANDIA',
    label: 'ANAURILANDIA'
  },
  {
    stateKey: 'MS',
    value: 'AGUA CLARA',
    label: 'AGUA CLARA'
  },
  {
    stateKey: 'MS',
    value: 'NAVIRAI',
    label: 'NAVIRAI'
  },
  {
    stateKey: 'MS',
    value: 'NOVA ANDRADINA',
    label: 'NOVA ANDRADINA'
  },
  {
    stateKey: 'MS',
    value: 'BATAGUASSU',
    label: 'BATAGUASSU'
  },
  {
    stateKey: 'MS',
    value: 'ANASTACIO',
    label: 'ANASTACIO'
  },
  {
    stateKey: 'MS',
    value: 'PEDRO GOMES',
    label: 'PEDRO GOMES'
  },
  {
    stateKey: 'MS',
    value: 'RIO VERDE DE MATO GROSSO',
    label: 'RIO VERDE DE MATO GROSSO'
  },
  {
    stateKey: 'MS',
    value: 'NIOAQUE',
    label: 'NIOAQUE'
  },
  {
    stateKey: 'MS',
    value: 'ARAL MOREIRA',
    label: 'ARAL MOREIRA'
  },
  {
    stateKey: 'MS',
    value: 'BANDEIRANTES',
    label: 'BANDEIRANTES'
  },
  {
    stateKey: 'MS',
    value: 'BRASILANDIA',
    label: 'BRASILANDIA'
  },
  {
    stateKey: 'MS',
    value: 'AQUIDAUANA',
    label: 'AQUIDAUANA'
  },
  {
    stateKey: 'MS',
    value: 'CASSILANDIA',
    label: 'CASSILANDIA'
  },
  {
    stateKey: 'MS',
    value: 'CORGUINHO',
    label: 'CORGUINHO'
  },
  {
    stateKey: 'MS',
    value: 'Guia Lopes Laguna',
    label: 'Guia Lopes Laguna'
  },
  {
    stateKey: 'MS',
    value: 'FIGUEIRAO',
    label: 'FIGUEIRAO'
  },
  {
    stateKey: 'MS',
    value: 'BELA VISTA',
    label: 'BELA VISTA'
  },
  {
    stateKey: 'MS',
    value: 'RIO NRGO',
    label: 'RIO NRGO'
  },
  {
    stateKey: 'MS',
    value: 'Paraíso das Aguas',
    label: 'Paraíso das Aguas'
  },
  {
    stateKey: 'MS',
    value: 'Paraíso das Aguas',
    label: 'Paraíso das Aguas'
  },
  {
    stateKey: 'MS',
    value: 'PARAISO DAS AGUAS',
    label: 'PARAISO DAS AGUAS'
  },
  {
    stateKey: 'MS',
    value: 'RIO NEGRO',
    label: 'RIO NEGRO'
  },
  {
    stateKey: 'MG',
    value: 'STO ANTONIO DO AVENTUREIRO',
    label: 'STO ANTONIO DO AVENTUREIRO'
  },
  {
    stateKey: 'MG',
    value: 'CONCEIÇÃO BARRA DE MINAS',
    label: 'CONCEIÇÃO BARRA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'ALTO JEQUITIBA',
    label: 'ALTO JEQUITIBA'
  },
  {
    stateKey: 'MG',
    value: 'NOVA UNIAO',
    label: 'NOVA UNIAO'
  },
  {
    stateKey: 'MG',
    value: 'BREJO BONITO CRUZEIRO FORTALEZ',
    label: 'BREJO BONITO CRUZEIRO FORTALEZ'
  },
  {
    stateKey: 'MG',
    value: 'ABADIA DOS DOURADOS',
    label: 'ABADIA DOS DOURADOS'
  },
  {
    stateKey: 'MG',
    value: 'ABAETE',
    label: 'ABAETE'
  },
  {
    stateKey: 'MG',
    value: 'ABRE CAMPO',
    label: 'ABRE CAMPO'
  },
  {
    stateKey: 'MG',
    value: 'ACAIACA',
    label: 'ACAIACA'
  },
  {
    stateKey: 'MG',
    value: 'ACUCENA',
    label: 'ACUCENA'
  },
  {
    stateKey: 'MG',
    value: 'AGUA BOA',
    label: 'AGUA BOA'
  },
  {
    stateKey: 'MG',
    value: 'AGUA COMPRIDA',
    label: 'AGUA COMPRIDA'
  },
  {
    stateKey: 'MG',
    value: 'AGUANIL',
    label: 'AGUANIL'
  },
  {
    stateKey: 'MG',
    value: 'AGUAS FORMOSAS',
    label: 'AGUAS FORMOSAS'
  },
  {
    stateKey: 'MG',
    value: 'AGUAS VERMELHAS',
    label: 'AGUAS VERMELHAS'
  },
  {
    stateKey: 'MG',
    value: 'AIMORES',
    label: 'AIMORES'
  },
  {
    stateKey: 'MG',
    value: 'AIURUOCA',
    label: 'AIURUOCA'
  },
  {
    stateKey: 'MG',
    value: 'ALAGOA',
    label: 'ALAGOA'
  },
  {
    stateKey: 'MG',
    value: 'ALBERTINA',
    label: 'ALBERTINA'
  },
  {
    stateKey: 'MG',
    value: 'ALEM PARAIBA',
    label: 'ALEM PARAIBA'
  },
  {
    stateKey: 'MG',
    value: 'ALFENAS',
    label: 'ALFENAS'
  },
  {
    stateKey: 'MG',
    value: 'ALFREDO VASCONCELOS',
    label: 'ALFREDO VASCONCELOS'
  },
  {
    stateKey: 'MG',
    value: 'ALMENARA',
    label: 'ALMENARA'
  },
  {
    stateKey: 'MG',
    value: 'ALPERCATA',
    label: 'ALPERCATA'
  },
  {
    stateKey: 'MG',
    value: 'ALPINOPOLIS',
    label: 'ALPINOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'ALTEROSA',
    label: 'ALTEROSA'
  },
  {
    stateKey: 'MG',
    value: 'ALTO CAPARAO',
    label: 'ALTO CAPARAO'
  },
  {
    stateKey: 'MG',
    value: 'ALTO RIO DOCE',
    label: 'ALTO RIO DOCE'
  },
  {
    stateKey: 'MG',
    value: 'ALVARENGA',
    label: 'ALVARENGA'
  },
  {
    stateKey: 'MG',
    value: 'ALVINOPOLIS',
    label: 'ALVINOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'ALVORADA DE MINAS',
    label: 'ALVORADA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'AMPARO DA SERRA',
    label: 'AMPARO DA SERRA'
  },
  {
    stateKey: 'MG',
    value: 'ANDRADAS',
    label: 'ANDRADAS'
  },
  {
    stateKey: 'MG',
    value: 'ANDRELANDIA',
    label: 'ANDRELANDIA'
  },
  {
    stateKey: 'MG',
    value: 'ANGELANDIA',
    label: 'ANGELANDIA'
  },
  {
    stateKey: 'MG',
    value: 'ANTONIO CARLOS',
    label: 'ANTONIO CARLOS'
  },
  {
    stateKey: 'MG',
    value: 'ANTONIO DIAS',
    label: 'ANTONIO DIAS'
  },
  {
    stateKey: 'MG',
    value: 'ANTONIO PRADO DE MINAS',
    label: 'ANTONIO PRADO DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'ARACAI',
    label: 'ARACAI'
  },
  {
    stateKey: 'MG',
    value: 'ARACITABA',
    label: 'ARACITABA'
  },
  {
    stateKey: 'MG',
    value: 'ARACUAI',
    label: 'ARACUAI'
  },
  {
    stateKey: 'MG',
    value: 'ARAGUARI',
    label: 'ARAGUARI'
  },
  {
    stateKey: 'MG',
    value: 'ARANTINA',
    label: 'ARANTINA'
  },
  {
    stateKey: 'MG',
    value: 'ARAPONGA',
    label: 'ARAPONGA'
  },
  {
    stateKey: 'MG',
    value: 'ARAPORA',
    label: 'ARAPORA'
  },
  {
    stateKey: 'MG',
    value: 'ARAPUA',
    label: 'ARAPUA'
  },
  {
    stateKey: 'MG',
    value: 'ARAUJOS',
    label: 'ARAUJOS'
  },
  {
    stateKey: 'MG',
    value: 'ARAXA',
    label: 'ARAXA'
  },
  {
    stateKey: 'MG',
    value: 'ARCEBURGO',
    label: 'ARCEBURGO'
  },
  {
    stateKey: 'MG',
    value: 'ARCOS',
    label: 'ARCOS'
  },
  {
    stateKey: 'MG',
    value: 'AREADO',
    label: 'AREADO'
  },
  {
    stateKey: 'MG',
    value: 'ARGIRITA',
    label: 'ARGIRITA'
  },
  {
    stateKey: 'MG',
    value: 'ARICANDUVA',
    label: 'ARICANDUVA'
  },
  {
    stateKey: 'MG',
    value: 'ARINOS',
    label: 'ARINOS'
  },
  {
    stateKey: 'MG',
    value: 'ASTOLFO DUTRA',
    label: 'ASTOLFO DUTRA'
  },
  {
    stateKey: 'MG',
    value: 'ATALEIA',
    label: 'ATALEIA'
  },
  {
    stateKey: 'MG',
    value: 'AUGUSTO DE LIMA',
    label: 'AUGUSTO DE LIMA'
  },
  {
    stateKey: 'MG',
    value: 'BAEPENDI',
    label: 'BAEPENDI'
  },
  {
    stateKey: 'MG',
    value: 'BALDIM',
    label: 'BALDIM'
  },
  {
    stateKey: 'MG',
    value: 'BAMBUI',
    label: 'BAMBUI'
  },
  {
    stateKey: 'MG',
    value: 'BANDEIRA',
    label: 'BANDEIRA'
  },
  {
    stateKey: 'MG',
    value: 'BANDEIRA DO SUL',
    label: 'BANDEIRA DO SUL'
  },
  {
    stateKey: 'MG',
    value: 'BARAO DE COCAIS',
    label: 'BARAO DE COCAIS'
  },
  {
    stateKey: 'MG',
    value: 'BARAO DE MONTE ALTO',
    label: 'BARAO DE MONTE ALTO'
  },
  {
    stateKey: 'MG',
    value: 'BARBACENA',
    label: 'BARBACENA'
  },
  {
    stateKey: 'MG',
    value: 'BARRA LONGA',
    label: 'BARRA LONGA'
  },
  {
    stateKey: 'MG',
    value: 'BARROSO',
    label: 'BARROSO'
  },
  {
    stateKey: 'MG',
    value: 'BELA VISTA DE MINAS',
    label: 'BELA VISTA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'BELMIRO BRAGA',
    label: 'BELMIRO BRAGA'
  },
  {
    stateKey: 'MG',
    value: 'BELO HORIZONTE',
    label: 'BELO HORIZONTE'
  },
  {
    stateKey: 'MG',
    value: 'BELO ORIENTE',
    label: 'BELO ORIENTE'
  },
  {
    stateKey: 'MG',
    value: 'BELO VALE',
    label: 'BELO VALE'
  },
  {
    stateKey: 'MG',
    value: 'BERILO',
    label: 'BERILO'
  },
  {
    stateKey: 'MG',
    value: 'BERIZAL',
    label: 'BERIZAL'
  },
  {
    stateKey: 'MG',
    value: 'BERTOPOLIS',
    label: 'BERTOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'BETIM',
    label: 'BETIM'
  },
  {
    stateKey: 'MG',
    value: 'BIAS FORTES',
    label: 'BIAS FORTES'
  },
  {
    stateKey: 'MG',
    value: 'BICAS',
    label: 'BICAS'
  },
  {
    stateKey: 'MG',
    value: 'BIQUINHAS',
    label: 'BIQUINHAS'
  },
  {
    stateKey: 'MG',
    value: 'BOA ESPERANCA',
    label: 'BOA ESPERANCA'
  },
  {
    stateKey: 'MG',
    value: 'BOCAINA DE MINAS',
    label: 'BOCAINA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'BOCAIUVA',
    label: 'BOCAIUVA'
  },
  {
    stateKey: 'MG',
    value: 'BOM DESPACHO',
    label: 'BOM DESPACHO'
  },
  {
    stateKey: 'MG',
    value: 'BOM JARDIM DE MINAS',
    label: 'BOM JARDIM DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'BOM JESUS DA PENHA',
    label: 'BOM JESUS DA PENHA'
  },
  {
    stateKey: 'MG',
    value: 'BOM JESUS DO AMPARO',
    label: 'BOM JESUS DO AMPARO'
  },
  {
    stateKey: 'MG',
    value: 'BOM JESUS DO GALHO',
    label: 'BOM JESUS DO GALHO'
  },
  {
    stateKey: 'MG',
    value: 'BOM REPOUSO',
    label: 'BOM REPOUSO'
  },
  {
    stateKey: 'MG',
    value: 'BOM SUCESSO',
    label: 'BOM SUCESSO'
  },
  {
    stateKey: 'MG',
    value: 'BONFIM',
    label: 'BONFIM'
  },
  {
    stateKey: 'MG',
    value: 'BONFINOPOLIS DE MINAS',
    label: 'BONFINOPOLIS DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'BONITO DE MINAS',
    label: 'BONITO DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'BORDA DA MATA',
    label: 'BORDA DA MATA'
  },
  {
    stateKey: 'MG',
    value: 'BOTELHOS',
    label: 'BOTELHOS'
  },
  {
    stateKey: 'MG',
    value: 'BOTUMIRIM',
    label: 'BOTUMIRIM'
  },
  {
    stateKey: 'MG',
    value: 'BRAS PIRES',
    label: 'BRAS PIRES'
  },
  {
    stateKey: 'MG',
    value: 'BRASILANDIA DE MINAS',
    label: 'BRASILANDIA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'BRASILIA DE MINAS',
    label: 'BRASILIA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'BRAUNAS',
    label: 'BRAUNAS'
  },
  {
    stateKey: 'MG',
    value: 'BRUMADINHO',
    label: 'BRUMADINHO'
  },
  {
    stateKey: 'MG',
    value: 'BUENO BRANDAO',
    label: 'BUENO BRANDAO'
  },
  {
    stateKey: 'MG',
    value: 'BUENOPOLIS',
    label: 'BUENOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'BUGRE',
    label: 'BUGRE'
  },
  {
    stateKey: 'MG',
    value: 'BURITIS',
    label: 'BURITIS'
  },
  {
    stateKey: 'MG',
    value: 'BURITIZEIRO',
    label: 'BURITIZEIRO'
  },
  {
    stateKey: 'MG',
    value: 'CABECEIRA GRANDE',
    label: 'CABECEIRA GRANDE'
  },
  {
    stateKey: 'MG',
    value: 'CABO VERDE',
    label: 'CABO VERDE'
  },
  {
    stateKey: 'MG',
    value: 'CACHOEIRA DA PRATA',
    label: 'CACHOEIRA DA PRATA'
  },
  {
    stateKey: 'MG',
    value: 'CACHOEIRA DE MINAS',
    label: 'CACHOEIRA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'CACHOEIRA DOURADA',
    label: 'CACHOEIRA DOURADA'
  },
  {
    stateKey: 'MG',
    value: 'CAETANOPOLIS',
    label: 'CAETANOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'CAETE',
    label: 'CAETE'
  },
  {
    stateKey: 'MG',
    value: 'CAIANA',
    label: 'CAIANA'
  },
  {
    stateKey: 'MG',
    value: 'CAJURI',
    label: 'CAJURI'
  },
  {
    stateKey: 'MG',
    value: 'CALDAS',
    label: 'CALDAS'
  },
  {
    stateKey: 'MG',
    value: 'CAMACHO',
    label: 'CAMACHO'
  },
  {
    stateKey: 'MG',
    value: 'CAMANDUCAIA',
    label: 'CAMANDUCAIA'
  },
  {
    stateKey: 'MG',
    value: 'CAMBUI',
    label: 'CAMBUI'
  },
  {
    stateKey: 'MG',
    value: 'CAMBUQUIRA',
    label: 'CAMBUQUIRA'
  },
  {
    stateKey: 'MG',
    value: 'CAMPANARIO',
    label: 'CAMPANARIO'
  },
  {
    stateKey: 'MG',
    value: 'CAMPANHA',
    label: 'CAMPANHA'
  },
  {
    stateKey: 'MG',
    value: 'CAMPINA VERDE',
    label: 'CAMPINA VERDE'
  },
  {
    stateKey: 'MG',
    value: 'CAMPO AZUL',
    label: 'CAMPO AZUL'
  },
  {
    stateKey: 'MG',
    value: 'CAMPO BELO',
    label: 'CAMPO BELO'
  },
  {
    stateKey: 'MG',
    value: 'CAMPO DO MEIO',
    label: 'CAMPO DO MEIO'
  },
  {
    stateKey: 'MG',
    value: 'CAMPO FLORIDO',
    label: 'CAMPO FLORIDO'
  },
  {
    stateKey: 'MG',
    value: 'CAMPOS ALTOS',
    label: 'CAMPOS ALTOS'
  },
  {
    stateKey: 'MG',
    value: 'CAMPOS GERAIS',
    label: 'CAMPOS GERAIS'
  },
  {
    stateKey: 'MG',
    value: 'CANA VERDE',
    label: 'CANA VERDE'
  },
  {
    stateKey: 'MG',
    value: 'CANAA',
    label: 'CANAA'
  },
  {
    stateKey: 'MG',
    value: 'CANAPOLIS',
    label: 'CANAPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'CANDEIAS',
    label: 'CANDEIAS'
  },
  {
    stateKey: 'MG',
    value: 'CANTAGALO',
    label: 'CANTAGALO'
  },
  {
    stateKey: 'MG',
    value: 'CAPARAO',
    label: 'CAPARAO'
  },
  {
    stateKey: 'MG',
    value: 'CAPELA NOVA',
    label: 'CAPELA NOVA'
  },
  {
    stateKey: 'MG',
    value: 'CAPELINHA',
    label: 'CAPELINHA'
  },
  {
    stateKey: 'MG',
    value: 'CAPETINGA',
    label: 'CAPETINGA'
  },
  {
    stateKey: 'MG',
    value: 'CAPIM BRANCO',
    label: 'CAPIM BRANCO'
  },
  {
    stateKey: 'MG',
    value: 'CAPINOPOLIS',
    label: 'CAPINOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'CAPITAO ANDRADE',
    label: 'CAPITAO ANDRADE'
  },
  {
    stateKey: 'MG',
    value: 'CAPITAO ENEAS',
    label: 'CAPITAO ENEAS'
  },
  {
    stateKey: 'MG',
    value: 'CAPITOLIO',
    label: 'CAPITOLIO'
  },
  {
    stateKey: 'MG',
    value: 'CAPUTIRA',
    label: 'CAPUTIRA'
  },
  {
    stateKey: 'MG',
    value: 'CARAI',
    label: 'CARAI'
  },
  {
    stateKey: 'MG',
    value: 'CARANAIBA',
    label: 'CARANAIBA'
  },
  {
    stateKey: 'MG',
    value: 'CARANDAI',
    label: 'CARANDAI'
  },
  {
    stateKey: 'MG',
    value: 'CARANGOLA',
    label: 'CARANGOLA'
  },
  {
    stateKey: 'MG',
    value: 'CARATINGA',
    label: 'CARATINGA'
  },
  {
    stateKey: 'MG',
    value: 'CARBONITA',
    label: 'CARBONITA'
  },
  {
    stateKey: 'MG',
    value: 'CAREACU',
    label: 'CAREACU'
  },
  {
    stateKey: 'MG',
    value: 'CARLOS CHAGAS',
    label: 'CARLOS CHAGAS'
  },
  {
    stateKey: 'MG',
    value: 'CARMESIA',
    label: 'CARMESIA'
  },
  {
    stateKey: 'MG',
    value: 'CARMO DA CACHOEIRA',
    label: 'CARMO DA CACHOEIRA'
  },
  {
    stateKey: 'MG',
    value: 'CARMO DA MATA',
    label: 'CARMO DA MATA'
  },
  {
    stateKey: 'MG',
    value: 'CARMO DE MINAS',
    label: 'CARMO DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'CARMO DO CAJURU',
    label: 'CARMO DO CAJURU'
  },
  {
    stateKey: 'MG',
    value: 'CARMO DO PARANAIBA',
    label: 'CARMO DO PARANAIBA'
  },
  {
    stateKey: 'MG',
    value: 'CARMO DO RIO CLARO',
    label: 'CARMO DO RIO CLARO'
  },
  {
    stateKey: 'MG',
    value: 'CARMOPOLIS DE MINAS',
    label: 'CARMOPOLIS DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'CARNEIRINHO',
    label: 'CARNEIRINHO'
  },
  {
    stateKey: 'MG',
    value: 'CARRANCAS',
    label: 'CARRANCAS'
  },
  {
    stateKey: 'MG',
    value: 'CARVALHOPOLIS',
    label: 'CARVALHOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'CARVALHOS',
    label: 'CARVALHOS'
  },
  {
    stateKey: 'MG',
    value: 'CASA GRANDE',
    label: 'CASA GRANDE'
  },
  {
    stateKey: 'MG',
    value: 'CASCALHO RICO',
    label: 'CASCALHO RICO'
  },
  {
    stateKey: 'MG',
    value: 'CASSIA ',
    label: 'CASSIA'
  },
  {
    stateKey: 'MG',
    value: 'CATAGUASES',
    label: 'CATAGUASES'
  },
  {
    stateKey: 'MG',
    value: 'CATAS ALTAS',
    label: 'CATAS ALTAS'
  },
  {
    stateKey: 'MG',
    value: 'CATAS ALTAS DA NORUEGA',
    label: 'CATAS ALTAS DA NORUEGA'
  },
  {
    stateKey: 'MG',
    value: 'CATUJI',
    label: 'CATUJI'
  },
  {
    stateKey: 'MG',
    value: 'CATUTI',
    label: 'CATUTI'
  },
  {
    stateKey: 'MG',
    value: 'CAXAMBU',
    label: 'CAXAMBU'
  },
  {
    stateKey: 'MG',
    value: 'CEDRO DO ABAETE',
    label: 'CEDRO DO ABAETE'
  },
  {
    stateKey: 'MG',
    value: 'CENTRAL DE MINAS',
    label: 'CENTRAL DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'CENTRALINA',
    label: 'CENTRALINA'
  },
  {
    stateKey: 'MG',
    value: 'CHACARA',
    label: 'CHACARA'
  },
  {
    stateKey: 'MG',
    value: 'CHALE',
    label: 'CHALE'
  },
  {
    stateKey: 'MG',
    value: 'CHAPADA DO NORTE',
    label: 'CHAPADA DO NORTE'
  },
  {
    stateKey: 'MG',
    value: 'CHAPADA GAUCHA',
    label: 'CHAPADA GAUCHA'
  },
  {
    stateKey: 'MG',
    value: 'CHIADOR',
    label: 'CHIADOR'
  },
  {
    stateKey: 'MG',
    value: 'CIPOTANEA',
    label: 'CIPOTANEA'
  },
  {
    stateKey: 'MG',
    value: 'CLARAVAL',
    label: 'CLARAVAL'
  },
  {
    stateKey: 'MG',
    value: 'CLARO DOS POCOES',
    label: 'CLARO DOS POCOES'
  },
  {
    stateKey: 'MG',
    value: 'CLAUDIO',
    label: 'CLAUDIO'
  },
  {
    stateKey: 'MG',
    value: 'COIMBRA',
    label: 'COIMBRA'
  },
  {
    stateKey: 'MG',
    value: 'COLUNA',
    label: 'COLUNA'
  },
  {
    stateKey: 'MG',
    value: 'COMENDADOR GOMES',
    label: 'COMENDADOR GOMES'
  },
  {
    stateKey: 'MG',
    value: 'COMERCINHO',
    label: 'COMERCINHO'
  },
  {
    stateKey: 'MG',
    value: 'CONCEICAO DA APARECIDA',
    label: 'CONCEICAO DA APARECIDA'
  },
  {
    stateKey: 'MG',
    value: 'CONCEICAO DAS ALAGOAS',
    label: 'CONCEICAO DAS ALAGOAS'
  },
  {
    stateKey: 'MG',
    value: 'CONCEICAO DE IPANEMA',
    label: 'CONCEICAO DE IPANEMA'
  },
  {
    stateKey: 'MG',
    value: 'CONCEICAO DO MATO DENTRO',
    label: 'CONCEICAO DO MATO DENTRO'
  },
  {
    stateKey: 'MG',
    value: 'CONCEICAO DO PARA',
    label: 'CONCEICAO DO PARA'
  },
  {
    stateKey: 'MG',
    value: 'CONCEICAO DO RIO VERDE',
    label: 'CONCEICAO DO RIO VERDE'
  },
  {
    stateKey: 'MG',
    value: 'CONCEICAO DOS OUROS',
    label: 'CONCEICAO DOS OUROS'
  },
  {
    stateKey: 'MG',
    value: 'CONEGO MARINHO',
    label: 'CONEGO MARINHO'
  },
  {
    stateKey: 'MG',
    value: 'CONFINS',
    label: 'CONFINS'
  },
  {
    stateKey: 'MG',
    value: 'CONGONHAL',
    label: 'CONGONHAL'
  },
  {
    stateKey: 'MG',
    value: 'CONGONHAS',
    label: 'CONGONHAS'
  },
  {
    stateKey: 'MG',
    value: 'CONGONHAS DO NORTE',
    label: 'CONGONHAS DO NORTE'
  },
  {
    stateKey: 'MG',
    value: 'CONQUISTA',
    label: 'CONQUISTA'
  },
  {
    stateKey: 'MG',
    value: 'CONSELHEIRO LAFAIETE',
    label: 'CONSELHEIRO LAFAIETE'
  },
  {
    stateKey: 'MG',
    value: 'CONSELHEIRO PENA',
    label: 'CONSELHEIRO PENA'
  },
  {
    stateKey: 'MG',
    value: 'CONSOLACAO',
    label: 'CONSOLACAO'
  },
  {
    stateKey: 'MG',
    value: 'CONTAGEM',
    label: 'CONTAGEM'
  },
  {
    stateKey: 'MG',
    value: 'COQUEIRAL',
    label: 'COQUEIRAL'
  },
  {
    stateKey: 'MG',
    value: 'CORACAO DE JESUS',
    label: 'CORACAO DE JESUS'
  },
  {
    stateKey: 'MG',
    value: 'CORDISBURGO',
    label: 'CORDISBURGO'
  },
  {
    stateKey: 'MG',
    value: 'CORDISLANDIA',
    label: 'CORDISLANDIA'
  },
  {
    stateKey: 'MG',
    value: 'CORINTO',
    label: 'CORINTO'
  },
  {
    stateKey: 'MG',
    value: 'COROACI',
    label: 'COROACI'
  },
  {
    stateKey: 'MG',
    value: 'COROMANDEL',
    label: 'COROMANDEL'
  },
  {
    stateKey: 'MG',
    value: 'CORONEL FABRICIANO',
    label: 'CORONEL FABRICIANO'
  },
  {
    stateKey: 'MG',
    value: 'CORONEL MURTA',
    label: 'CORONEL MURTA'
  },
  {
    stateKey: 'MG',
    value: 'CORONEL PACHECO',
    label: 'CORONEL PACHECO'
  },
  {
    stateKey: 'MG',
    value: 'CORONEL XAVIER CHAVES',
    label: 'CORONEL XAVIER CHAVES'
  },
  {
    stateKey: 'MG',
    value: 'CORREGO DANTA',
    label: 'CORREGO DANTA'
  },
  {
    stateKey: 'MG',
    value: 'CORREGO DO BOM JESUS',
    label: 'CORREGO DO BOM JESUS'
  },
  {
    stateKey: 'MG',
    value: 'CORREGO FUNDO',
    label: 'CORREGO FUNDO'
  },
  {
    stateKey: 'MG',
    value: 'CORREGO NOVO',
    label: 'CORREGO NOVO'
  },
  {
    stateKey: 'MG',
    value: 'CRISOLITA',
    label: 'CRISOLITA'
  },
  {
    stateKey: 'MG',
    value: 'CRISTAIS',
    label: 'CRISTAIS'
  },
  {
    stateKey: 'MG',
    value: 'CRISTALIA',
    label: 'CRISTALIA'
  },
  {
    stateKey: 'MG',
    value: 'CRISTIANO OTONI',
    label: 'CRISTIANO OTONI'
  },
  {
    stateKey: 'MG',
    value: 'CRISTINA',
    label: 'CRISTINA'
  },
  {
    stateKey: 'MG',
    value: 'CRUCILANDIA',
    label: 'CRUCILANDIA'
  },
  {
    stateKey: 'MG',
    value: 'CRUZEIRO DA FORTALEZA',
    label: 'CRUZEIRO DA FORTALEZA'
  },
  {
    stateKey: 'MG',
    value: 'CRUZILIA',
    label: 'CRUZILIA'
  },
  {
    stateKey: 'MG',
    value: 'CUPARAQUE',
    label: 'CUPARAQUE'
  },
  {
    stateKey: 'MG',
    value: 'CURRAL DE DENTRO',
    label: 'CURRAL DE DENTRO'
  },
  {
    stateKey: 'MG',
    value: 'CURVELO',
    label: 'CURVELO'
  },
  {
    stateKey: 'MG',
    value: 'DATAS',
    label: 'DATAS'
  },
  {
    stateKey: 'MG',
    value: 'DELFIM MOREIRA',
    label: 'DELFIM MOREIRA'
  },
  {
    stateKey: 'MG',
    value: 'DELFINOPOLIS',
    label: 'DELFINOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'DELTA',
    label: 'DELTA'
  },
  {
    stateKey: 'MG',
    value: 'DESCOBERTO',
    label: 'DESCOBERTO'
  },
  {
    stateKey: 'MG',
    value: 'DESTERRO DE ENTRE RIOS',
    label: 'DESTERRO DE ENTRE RIOS'
  },
  {
    stateKey: 'MG',
    value: 'DESTERRO DO MELO',
    label: 'DESTERRO DO MELO'
  },
  {
    stateKey: 'MG',
    value: 'DIAMANTINA',
    label: 'DIAMANTINA'
  },
  {
    stateKey: 'MG',
    value: 'DIOGO DE VASCONCELOS',
    label: 'DIOGO DE VASCONCELOS'
  },
  {
    stateKey: 'MG',
    value: 'DIONISIO',
    label: 'DIONISIO '
  },
  {
    stateKey: 'MG',
    value: 'DIVINESIA',
    label: 'DIVINESIA'
  },
  {
    stateKey: 'MG',
    value: 'DIVINO',
    label: 'DIVINO'
  },
  {
    stateKey: 'MG',
    value: 'DIVINO DAS LARANJEIRAS',
    label: 'DIVINO DAS LARANJEIRAS'
  },
  {
    stateKey: 'MG',
    value: 'DIVINOLANDIA DE MINAS',
    label: 'DIVINOLANDIA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'DIVINOPOLIS',
    label: 'DIVINOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'DIVISA ALEGRE',
    label: 'DIVISA ALEGRE'
  },
  {
    stateKey: 'MG',
    value: 'DIVISA NOVA',
    label: 'DIVISA NOVA'
  },
  {
    stateKey: 'MG',
    value: 'DIVISOPOLIS',
    label: 'DIVISOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'DOM BOSCO',
    label: 'DOM BOSCO'
  },
  {
    stateKey: 'MG',
    value: 'DOM CAVATI',
    label: 'DOM CAVATI'
  },
  {
    stateKey: 'MG',
    value: 'DOM JOAQUIM',
    label: 'DOM JOAQUIM'
  },
  {
    stateKey: 'MG',
    value: 'DOM SILVERIO',
    label: 'DOM SILVERIO'
  },
  {
    stateKey: 'MG',
    value: 'DOM VICOSO',
    label: 'DOM VICOSO'
  },
  {
    stateKey: 'MG',
    value: 'DONA EUZEBIA',
    label: 'DONA EUZEBIA'
  },
  {
    stateKey: 'MG',
    value: 'DORES DE CAMPOS',
    label: 'DORES DE CAMPOS'
  },
  {
    stateKey: 'MG',
    value: 'DORES DE GUANHAES',
    label: 'DORES DE GUANHAES'
  },
  {
    stateKey: 'MG',
    value: 'DORES DO INDAIA',
    label: 'DORES DO INDAIA'
  },
  {
    stateKey: 'MG',
    value: 'DORES DO TURVO',
    label: 'DORES DO TURVO'
  },
  {
    stateKey: 'MG',
    value: 'DORESOPOLIS',
    label: 'DORESOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'DOURADOQUARA',
    label: 'DOURADOQUARA'
  },
  {
    stateKey: 'MG',
    value: 'DURANDE',
    label: 'DURANDE'
  },
  {
    stateKey: 'MG',
    value: 'ELOI MENDES',
    label: 'ELOI MENDES'
  },
  {
    stateKey: 'MG',
    value: 'ENGENHEIRO CALDAS',
    label: 'ENGENHEIRO CALDAS'
  },
  {
    stateKey: 'MG',
    value: 'ENGENHEIRO NAVARRO',
    label: 'ENGENHEIRO NAVARRO'
  },
  {
    stateKey: 'MG',
    value: 'ENTRE FOLHAS',
    label: 'ENTRE FOLHAS'
  },
  {
    stateKey: 'MG',
    value: 'ENTRE RIOS DE MINAS',
    label: 'ENTRE RIOS DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'ERVALIA',
    label: 'ERVALIA'
  },
  {
    stateKey: 'MG',
    value: 'ESMERALDAS',
    label: 'ESMERALDAS'
  },
  {
    stateKey: 'MG',
    value: 'ESPERA FELIZ',
    label: 'ESPERA FELIZ'
  },
  {
    stateKey: 'MG',
    value: 'ESPINOSA',
    label: 'ESPINOSA'
  },
  {
    stateKey: 'MG',
    value: 'ESPIRITO SANTO DO DOURADO',
    label: 'ESPIRITO SANTO DO DOURADO'
  },
  {
    stateKey: 'MG',
    value: 'ESTIVA',
    label: 'ESTIVA'
  },
  {
    stateKey: 'MG',
    value: 'ESTRELA DALVA',
    label: 'ESTRELA DALVA'
  },
  {
    stateKey: 'MG',
    value: 'ESTRELA DO INDAIA',
    label: 'ESTRELA DO INDAIA'
  },
  {
    stateKey: 'MG',
    value: 'ESTRELA DO SUL',
    label: 'ESTRELA DO SUL'
  },
  {
    stateKey: 'MG',
    value: 'EUGENOPOLIS',
    label: 'EUGENOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'EWBANK DA CAMARA',
    label: 'EWBANK DA CAMARA'
  },
  {
    stateKey: 'MG',
    value: 'EXTREMA',
    label: 'EXTREMA'
  },
  {
    stateKey: 'MG',
    value: 'FAMA',
    label: 'FAMA'
  },
  {
    stateKey: 'MG',
    value: 'FARIA LEMOS',
    label: 'FARIA LEMOS'
  },
  {
    stateKey: 'MG',
    value: 'FELICIO DOS SANTOS',
    label: 'FELICIO DOS SANTOS'
  },
  {
    stateKey: 'MG',
    value: 'FELISBURGO',
    label: 'FELISBURGO'
  },
  {
    stateKey: 'MG',
    value: 'FELIXLANDIA',
    label: 'FELIXLANDIA'
  },
  {
    stateKey: 'MG',
    value: 'FERNANDES TOURINHO',
    label: 'FERNANDES TOURINHO'
  },
  {
    stateKey: 'MG',
    value: 'FERROS',
    label: 'FERROS'
  },
  {
    stateKey: 'MG',
    value: 'FERVEDOURO',
    label: 'FERVEDOURO'
  },
  {
    stateKey: 'MG',
    value: 'FLORESTAL',
    label: 'FLORESTAL'
  },
  {
    stateKey: 'MG',
    value: 'FORMIGA',
    label: 'FORMIGA'
  },
  {
    stateKey: 'MG',
    value: 'FORMOSO',
    label: 'FORMOSO'
  },
  {
    stateKey: 'MG',
    value: 'FORTALEZA DE MINAS',
    label: 'FORTALEZA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'FORTUNA DE MINAS',
    label: 'FORTUNA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'FRANCISCO BADARO',
    label: 'FRANCISCO BADARO'
  },
  {
    stateKey: 'MG',
    value: 'FRANCISCO DUMONT',
    label: 'FRANCISCO DUMONT'
  },
  {
    stateKey: 'MG',
    value: 'FRANCISCO SA',
    label: 'FRANCISCO SA'
  },
  {
    stateKey: 'MG',
    value: 'FRANCISCOPOLIS',
    label: 'FRANCISCOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'FREI GASPAR',
    label: 'FREI GASPAR'
  },
  {
    stateKey: 'MG',
    value: 'FREI INOCENCIO',
    label: 'FREI INOCENCIO'
  },
  {
    stateKey: 'MG',
    value: 'FREI LAGONEGRO',
    label: 'FREI LAGONEGRO'
  },
  {
    stateKey: 'MG',
    value: 'FRONTEIRA',
    label: 'FRONTEIRA'
  },
  {
    stateKey: 'MG',
    value: 'FRUTA DE LEITE',
    label: 'FRUTA DE LEITE'
  },
  {
    stateKey: 'MG',
    value: 'FRUTAL',
    label: 'FRUTAL'
  },
  {
    stateKey: 'MG',
    value: 'FUNILANDIA',
    label: 'FUNILANDIA'
  },
  {
    stateKey: 'MG',
    value: 'GALILEIA',
    label: 'GALILEIA'
  },
  {
    stateKey: 'MG',
    value: 'GAMELEIRAS',
    label: 'GAMELEIRAS'
  },
  {
    stateKey: 'MG',
    value: 'GLAUCILANDIA',
    label: 'GLAUCILANDIA'
  },
  {
    stateKey: 'MG',
    value: 'GOIABEIRA',
    label: 'GOIABEIRA'
  },
  {
    stateKey: 'MG',
    value: 'GOIANA',
    label: 'GOIANA'
  },
  {
    stateKey: 'MG',
    value: 'GONCALVES',
    label: 'GONCALVES'
  },
  {
    stateKey: 'MG',
    value: 'GONZAGA',
    label: 'GONZAGA'
  },
  {
    stateKey: 'MG',
    value: 'GOUVEA',
    label: 'GOUVEA'
  },
  {
    stateKey: 'MG',
    value: 'GOVERNADOR VALADARES',
    label: 'GOVERNADOR VALADARES'
  },
  {
    stateKey: 'MG',
    value: 'GRAO MOGOL',
    label: 'GRAO MOGOL'
  },
  {
    stateKey: 'MG',
    value: 'GRUPIARA',
    label: 'GRUPIARA'
  },
  {
    stateKey: 'MG',
    value: 'GUANHAES',
    label: 'GUANHAES'
  },
  {
    stateKey: 'MG',
    value: 'GUAPE',
    label: 'GUAPE'
  },
  {
    stateKey: 'MG',
    value: 'GUARACIABA',
    label: 'GUARACIABA'
  },
  {
    stateKey: 'MG',
    value: 'GUARACIAMA',
    label: 'GUARACIAMA'
  },
  {
    stateKey: 'MG',
    value: 'GUARANESIA',
    label: 'GUARANESIA'
  },
  {
    stateKey: 'MG',
    value: 'GUARANI',
    label: 'GUARANI'
  },
  {
    stateKey: 'MG',
    value: 'GUARARA',
    label: 'GUARARA'
  },
  {
    stateKey: 'MG',
    value: 'GUARDA-MOR',
    label: 'GUARDA-MOR'
  },
  {
    stateKey: 'MG',
    value: 'GUAXUPE',
    label: 'GUAXUPE'
  },
  {
    stateKey: 'MG',
    value: 'GUIDOVAL',
    label: 'GUIDOVAL'
  },
  {
    stateKey: 'MG',
    value: 'GUIMARANIA',
    label: 'GUIMARANIA'
  },
  {
    stateKey: 'MG',
    value: 'GUIRICEMA',
    label: 'GUIRICEMA'
  },
  {
    stateKey: 'MG',
    value: 'GURINHATA',
    label: 'GURINHATA'
  },
  {
    stateKey: 'MG',
    value: 'HELIODORA',
    label: 'HELIODORA'
  },
  {
    stateKey: 'MG',
    value: 'IAPU',
    label: 'IAPU'
  },
  {
    stateKey: 'MG',
    value: 'IBERTIOGA',
    label: 'IBERTIOGA'
  },
  {
    stateKey: 'MG',
    value: 'IBIA',
    label: 'IBIA'
  },
  {
    stateKey: 'MG',
    value: 'IBIAI',
    label: 'IBIAI'
  },
  {
    stateKey: 'MG',
    value: 'IBIRACATU',
    label: 'IBIRACATU'
  },
  {
    stateKey: 'MG',
    value: 'IBIRACI',
    label: 'IBIRACI'
  },
  {
    stateKey: 'MG',
    value: 'IBIRITE',
    label: 'IBIRITE'
  },
  {
    stateKey: 'MG',
    value: 'IBITIURA DE MINAS',
    label: 'IBITIURA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'IBITURUNA',
    label: 'IBITURUNA'
  },
  {
    stateKey: 'MG',
    value: 'ICARAI DE MINAS',
    label: 'ICARAI DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'IGARAPE',
    label: 'IGARAPE'
  },
  {
    stateKey: 'MG',
    value: 'IGARATINGA',
    label: 'IGARATINGA'
  },
  {
    stateKey: 'MG',
    value: 'IGUATAMA',
    label: 'IGUATAMA'
  },
  {
    stateKey: 'MG',
    value: 'IJACI',
    label: 'IJACI'
  },
  {
    stateKey: 'MG',
    value: 'ILICINEA',
    label: 'ILICINEA'
  },
  {
    stateKey: 'MG',
    value: 'IMBE DE MINAS',
    label: 'IMBE DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'INCONFIDENTES',
    label: 'INCONFIDENTES'
  },
  {
    stateKey: 'MG',
    value: 'INDAIABIRA',
    label: 'INDAIABIRA'
  },
  {
    stateKey: 'MG',
    value: 'INDIANOPOLIS',
    label: 'INDIANOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'INGAI',
    label: 'INGAI'
  },
  {
    stateKey: 'MG',
    value: 'INHAPIM',
    label: 'INHAPIM'
  },
  {
    stateKey: 'MG',
    value: 'INHAUMA',
    label: 'INHAUMA'
  },
  {
    stateKey: 'MG',
    value: 'INIMUTABA',
    label: 'INIMUTABA'
  },
  {
    stateKey: 'MG',
    value: 'IPABA',
    label: 'IPABA'
  },
  {
    stateKey: 'MG',
    value: 'IPANEMA',
    label: 'IPANEMA'
  },
  {
    stateKey: 'MG',
    value: 'IPATINGA',
    label: 'IPATINGA'
  },
  {
    stateKey: 'MG',
    value: 'IPIACU',
    label: 'IPIACU'
  },
  {
    stateKey: 'MG',
    value: 'IPUIUNA',
    label: 'IPUIUNA'
  },
  {
    stateKey: 'MG',
    value: 'IRAI DE MINAS',
    label: 'IRAI DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'ITABIRA',
    label: 'ITABIRA'
  },
  {
    stateKey: 'MG',
    value: 'ITABIRINHA DE MANTENA',
    label: 'ITABIRINHA DE MANTENA'
  },
  {
    stateKey: 'MG',
    value: 'ITABIRITO',
    label: 'ITABIRITO'
  },
  {
    stateKey: 'MG',
    value: 'ITACAMBIRA',
    label: 'ITACAMBIRA'
  },
  {
    stateKey: 'MG',
    value: 'ITACARAMBI',
    label: 'ITACARAMBI'
  },
  {
    stateKey: 'MG',
    value: 'ITAGUARA',
    label: 'ITAGUARA'
  },
  {
    stateKey: 'MG',
    value: 'ITAIPE',
    label: 'ITAIPE'
  },
  {
    stateKey: 'MG',
    value: 'ITAJUBA',
    label: 'ITAJUBA'
  },
  {
    stateKey: 'MG',
    value: 'ITAMARANDIBA',
    label: 'ITAMARANDIBA'
  },
  {
    stateKey: 'MG',
    value: 'ITAMARATI DE MINAS',
    label: 'ITAMARATI DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'ITAMBACURI',
    label: 'ITAMBACURI'
  },
  {
    stateKey: 'MG',
    value: 'ITAMBE DO MATO DENTRO',
    label: 'ITAMBE DO MATO DENTRO'
  },
  {
    stateKey: 'MG',
    value: 'ITAMOGI',
    label: 'ITAMOGI'
  },
  {
    stateKey: 'MG',
    value: 'ITAMONTE',
    label: 'ITAMONTE'
  },
  {
    stateKey: 'MG',
    value: 'ITANHANDU',
    label: 'ITANHANDU'
  },
  {
    stateKey: 'MG',
    value: 'ITANHOMI',
    label: 'ITANHOMI'
  },
  {
    stateKey: 'MG',
    value: 'ITAOBIM',
    label: 'ITAOBIM'
  },
  {
    stateKey: 'MG',
    value: 'ITAPAGIPE',
    label: 'ITAPAGIPE'
  },
  {
    stateKey: 'MG',
    value: 'ITAPECERICA',
    label: 'ITAPECERICA'
  },
  {
    stateKey: 'MG',
    value: 'ITAPEVA',
    label: 'ITAPEVA'
  },
  {
    stateKey: 'MG',
    value: 'ITATIAIUCU',
    label: 'ITATIAIUCU'
  },
  {
    stateKey: 'MG',
    value: 'ITAU DE MINAS',
    label: 'ITAU DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'ITAUNA',
    label: 'ITAUNA'
  },
  {
    stateKey: 'MG',
    value: 'ITAVERAVA',
    label: 'ITAVERAVA'
  },
  {
    stateKey: 'MG',
    value: 'ITINGA',
    label: 'ITINGA'
  },
  {
    stateKey: 'MG',
    value: 'ITUETA',
    label: 'ITUETA'
  },
  {
    stateKey: 'MG',
    value: 'ITUIUTABA',
    label: 'ITUIUTABA'
  },
  {
    stateKey: 'MG',
    value: 'ITUMIRIM',
    label: 'ITUMIRIM'
  },
  {
    stateKey: 'MG',
    value: 'ITURAMA',
    label: 'ITURAMA'
  },
  {
    stateKey: 'MG',
    value: 'ITUTINGA',
    label: 'ITUTINGA'
  },
  {
    stateKey: 'MG',
    value: 'JABOTICATUBAS',
    label: 'JABOTICATUBAS'
  },
  {
    stateKey: 'MG',
    value: 'JACINTO',
    label: 'JACINTO'
  },
  {
    stateKey: 'MG',
    value: 'JACUI',
    label: 'JACUI'
  },
  {
    stateKey: 'MG',
    value: 'JACUTINGA',
    label: 'JACUTINGA'
  },
  {
    stateKey: 'MG',
    value: 'JAGUARACU',
    label: 'JAGUARACU'
  },
  {
    stateKey: 'MG',
    value: 'JAIBA',
    label: 'JAIBA'
  },
  {
    stateKey: 'MG',
    value: 'JAMPRUCA',
    label: 'JAMPRUCA'
  },
  {
    stateKey: 'MG',
    value: 'JANAUBA',
    label: 'JANAUBA'
  },
  {
    stateKey: 'MG',
    value: 'JANUARIA',
    label: 'JANUARIA'
  },
  {
    stateKey: 'MG',
    value: 'JAPARAIBA',
    label: 'JAPARAIBA'
  },
  {
    stateKey: 'MG',
    value: 'JAPONVAR',
    label: 'JAPONVAR'
  },
  {
    stateKey: 'MG',
    value: 'JECEABA',
    label: 'JECEABA'
  },
  {
    stateKey: 'MG',
    value: 'JENIPAPO DE MINAS',
    label: 'JENIPAPO DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'JEQUERI',
    label: 'JEQUERI'
  },
  {
    stateKey: 'MG',
    value: 'JEQUITAI',
    label: 'JEQUITAI'
  },
  {
    stateKey: 'MG',
    value: 'JEQUITIBA',
    label: 'JEQUITIBA'
  },
  {
    stateKey: 'MG',
    value: 'JEQUITINHONHA',
    label: 'JEQUITINHONHA'
  },
  {
    stateKey: 'MG',
    value: 'JESUANIA',
    label: 'JESUANIA'
  },
  {
    stateKey: 'MG',
    value: 'JOAIMA',
    label: 'JOAIMA'
  },
  {
    stateKey: 'MG',
    value: 'JOANESIA',
    label: 'JOANESIA'
  },
  {
    stateKey: 'MG',
    value: 'JOAO MONLEVADE',
    label: 'JOAO MONLEVADE'
  },
  {
    stateKey: 'MG',
    value: 'JOAO PINHEIRO',
    label: 'JOAO PINHEIRO'
  },
  {
    stateKey: 'MG',
    value: 'JOAQUIM FELICIO',
    label: 'JOAQUIM FELICIO'
  },
  {
    stateKey: 'MG',
    value: 'JORDANIA',
    label: 'JORDANIA'
  },
  {
    stateKey: 'MG',
    value: 'JOSE GONCALVES DE MINAS',
    label: 'JOSE GONCALVES DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'JOSE RAYDAN',
    label: 'JOSE RAYDAN'
  },
  {
    stateKey: 'MG',
    value: 'JOSENOPOLIS',
    label: 'JOSENOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'JUATUBA',
    label: 'JUATUBA'
  },
  {
    stateKey: 'MG',
    value: 'JUIZ DE FORA',
    label: 'JUIZ DE FORA'
  },
  {
    stateKey: 'MG',
    value: 'JURAMENTO',
    label: 'JURAMENTO'
  },
  {
    stateKey: 'MG',
    value: 'JURUAIA',
    label: 'JURUAIA'
  },
  {
    stateKey: 'MG',
    value: 'JUVENILIA',
    label: 'JUVENILIA'
  },
  {
    stateKey: 'MG',
    value: 'LADAINHA',
    label: 'LADAINHA'
  },
  {
    stateKey: 'MG',
    value: 'LAGAMAR',
    label: 'LAGAMAR'
  },
  {
    stateKey: 'MG',
    value: 'LAGOA DA PRATA',
    label: 'LAGOA DA PRATA'
  },
  {
    stateKey: 'MG',
    value: 'LAGOA DOS PATOS',
    label: 'LAGOA DOS PATOS'
  },
  {
    stateKey: 'MG',
    value: 'LAGOA DOURADA',
    label: 'LAGOA DOURADA'
  },
  {
    stateKey: 'MG',
    value: 'LAGOA FORMOSA',
    label: 'LAGOA FORMOSA'
  },
  {
    stateKey: 'MG',
    value: 'LAGOA GRANDE',
    label: 'LAGOA GRANDE'
  },
  {
    stateKey: 'MG',
    value: 'LAGOA SANTA',
    label: 'LAGOA SANTA'
  },
  {
    stateKey: 'MG',
    value: 'LAJINHA',
    label: 'LAJINHA'
  },
  {
    stateKey: 'MG',
    value: 'LAMBARI',
    label: 'LAMBARI'
  },
  {
    stateKey: 'MG',
    value: 'LAMIM',
    label: 'LAMIM'
  },
  {
    stateKey: 'MG',
    value: 'LARANJAL',
    label: 'LARANJAL'
  },
  {
    stateKey: 'MG',
    value: 'LASSANCE',
    label: 'LASSANCE'
  },
  {
    stateKey: 'MG',
    value: 'LAVRAS',
    label: 'LAVRAS'
  },
  {
    stateKey: 'MG',
    value: 'LEANDRO FERREIRA',
    label: 'LEANDRO FERREIRA'
  },
  {
    stateKey: 'MG',
    value: 'LEME DO PRADO',
    label: 'LEME DO PRADO'
  },
  {
    stateKey: 'MG',
    value: 'LEOPOLDINA',
    label: 'LEOPOLDINA'
  },
  {
    stateKey: 'MG',
    value: 'LIBERDADE',
    label: 'LIBERDADE'
  },
  {
    stateKey: 'MG',
    value: 'LIMA DUARTE',
    label: 'LIMA DUARTE'
  },
  {
    stateKey: 'MG',
    value: "LIMEIRA D'OESTE",
    label: "LIMEIRA D'OESTE"
  },
  {
    stateKey: 'MG',
    value: 'LONTRA',
    label: 'LONTRA'
  },
  {
    stateKey: 'MG',
    value: 'LUISBURGO',
    label: 'LUISBURGO'
  },
  {
    stateKey: 'MG',
    value: 'LUISLANDIA',
    label: 'LUISLANDIA '
  },
  {
    stateKey: 'MG',
    value: 'LUMINARIAS',
    label: 'LUMINARIAS'
  },
  {
    stateKey: 'MG',
    value: 'LUZ',
    label: 'LUZ'
  },
  {
    stateKey: 'MG',
    value: 'MACHACALIS',
    label: 'MACHACALIS'
  },
  {
    stateKey: 'MG',
    value: 'MACHADO',
    label: 'MACHADO'
  },
  {
    stateKey: 'MG',
    value: 'MADRE DE DEUS DE MINAS',
    label: 'MADRE DE DEUS DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'MALACACHETA',
    label: 'MALACACHETA'
  },
  {
    stateKey: 'MG',
    value: 'MAMONAS',
    label: 'MAMONAS'
  },
  {
    stateKey: 'MG',
    value: 'MANGA',
    label: 'MANGA'
  },
  {
    stateKey: 'MG',
    value: 'MANHUACU',
    label: 'MANHUACU'
  },
  {
    stateKey: 'MG',
    value: 'MANHUMIRIM',
    label: 'MANHUMIRIM'
  },
  {
    stateKey: 'MG',
    value: 'MANTENA',
    label: 'MANTENA'
  },
  {
    stateKey: 'MG',
    value: 'MAR DE ESPANHA',
    label: 'MAR DE ESPANHA'
  },
  {
    stateKey: 'MG',
    value: 'MARAVILHAS',
    label: 'MARAVILHAS'
  },
  {
    stateKey: 'MG',
    value: 'MARIA DA FE',
    label: 'MARIA DA FE'
  },
  {
    stateKey: 'MG',
    value: 'MARIANA',
    label: 'MARIANA'
  },
  {
    stateKey: 'MG',
    value: 'MARILAC',
    label: 'MARILAC'
  },
  {
    stateKey: 'MG',
    value: 'MARIO CAMPOS',
    label: 'MARIO CAMPOS'
  },
  {
    stateKey: 'MG',
    value: 'MARIPA DE MINAS',
    label: 'MARIPA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'MARLIERIA',
    label: 'MARLIERIA'
  },
  {
    stateKey: 'MG',
    value: 'MARMELOPOLIS',
    label: 'MARMELOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'MARTINHO CAMPOS',
    label: 'MARTINHO CAMPOS'
  },
  {
    stateKey: 'MG',
    value: 'MARTINS SOARES',
    label: 'MARTINS SOARES'
  },
  {
    stateKey: 'MG',
    value: 'MATA VERDE',
    label: 'MATA VERDE'
  },
  {
    stateKey: 'MG',
    value: 'MATERLANDIA',
    label: 'MATERLANDIA'
  },
  {
    stateKey: 'MG',
    value: 'MATEUS LEME',
    label: 'MATEUS LEME'
  },
  {
    stateKey: 'MG',
    value: 'MATIAS BARBOSA',
    label: 'MATIAS BARBOSA'
  },
  {
    stateKey: 'MG',
    value: 'MATIAS CARDOSO',
    label: 'MATIAS CARDOSO'
  },
  {
    stateKey: 'MG',
    value: 'MATIPO',
    label: 'MATIPO'
  },
  {
    stateKey: 'MG',
    value: 'MATO VERDE',
    label: 'MATO VERDE'
  },
  {
    stateKey: 'MG',
    value: 'MATOZINHOS',
    label: 'MATOZINHOS'
  },
  {
    stateKey: 'MG',
    value: 'MATUTINA',
    label: 'MATUTINA'
  },
  {
    stateKey: 'MG',
    value: 'MEDEIROS',
    label: 'MEDEIROS'
  },
  {
    stateKey: 'MG',
    value: 'MEDINA',
    label: 'MEDINA'
  },
  {
    stateKey: 'MG',
    value: 'MENDES PIMENTEL',
    label: 'MENDES PIMENTEL'
  },
  {
    stateKey: 'MG',
    value: 'MERCES',
    label: 'MERCES'
  },
  {
    stateKey: 'MG',
    value: 'MESQUITA',
    label: 'MESQUITA'
  },
  {
    stateKey: 'MG',
    value: 'MINAS NOVAS',
    label: 'MINAS NOVAS'
  },
  {
    stateKey: 'MG',
    value: 'MINDURI',
    label: 'MINDURI'
  },
  {
    stateKey: 'MG',
    value: 'MIRABELA',
    label: 'MIRABELA'
  },
  {
    stateKey: 'MG',
    value: 'MIRADOURO',
    label: 'MIRADOURO'
  },
  {
    stateKey: 'MG',
    value: 'MIRAI',
    label: 'MIRAI'
  },
  {
    stateKey: 'MG',
    value: 'MIRAVANIA',
    label: 'MIRAVANIA'
  },
  {
    stateKey: 'MG',
    value: 'MOEDA',
    label: 'MOEDA'
  },
  {
    stateKey: 'MG',
    value: 'MOEMA',
    label: 'MOEMA'
  },
  {
    stateKey: 'MG',
    value: 'MONJOLOS',
    label: 'MONJOLOS'
  },
  {
    stateKey: 'MG',
    value: 'MONSENHOR PAULO',
    label: 'MONSENHOR PAULO'
  },
  {
    stateKey: 'MG',
    value: 'MONTALVANIA',
    label: 'MONTALVANIA'
  },
  {
    stateKey: 'MG',
    value: 'MONTE ALEGRE DE MINAS',
    label: 'MONTE ALEGRE DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'MONTE AZUL',
    label: 'MONTE AZUL'
  },
  {
    stateKey: 'MG',
    value: 'MONTE BELO',
    label: 'MONTE BELO'
  },
  {
    stateKey: 'MG',
    value: 'MONTE CARMELO',
    label: 'MONTE CARMELO'
  },
  {
    stateKey: 'MG',
    value: 'MONTE FORMOSO',
    label: 'MONTE FORMOSO'
  },
  {
    stateKey: 'MG',
    value: 'MONTE SANTO DE MINAS',
    label: 'MONTE SANTO DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'MONTE SIAO',
    label: 'MONTE SIAO'
  },
  {
    stateKey: 'MG',
    value: 'MONTES CLAROS',
    label: 'MONTES CLAROS'
  },
  {
    stateKey: 'MG',
    value: 'MONTEZUMA',
    label: 'MONTEZUMA'
  },
  {
    stateKey: 'MG',
    value: 'MORADA NOVA DE MINAS',
    label: 'MORADA NOVA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'MORRO DA GARCA',
    label: 'MORRO DA GARCA'
  },
  {
    stateKey: 'MG',
    value: 'MORRO DO PILAR',
    label: 'MORRO DO PILAR'
  },
  {
    stateKey: 'MG',
    value: 'MUNHOZ',
    label: 'MUNHOZ'
  },
  {
    stateKey: 'MG',
    value: 'MURIAE',
    label: 'MURIAE'
  },
  {
    stateKey: 'MG',
    value: 'MUTUM',
    label: 'MUTUM'
  },
  {
    stateKey: 'MG',
    value: 'MUZAMBINHO',
    label: 'MUZAMBINHO'
  },
  {
    stateKey: 'MG',
    value: 'NACIP RAYDAN',
    label: 'NACIP RAYDAN'
  },
  {
    stateKey: 'MG',
    value: 'NANUQUE',
    label: 'NANUQUE'
  },
  {
    stateKey: 'MG',
    value: 'NAQUE',
    label: 'NAQUE'
  },
  {
    stateKey: 'MG',
    value: 'NATALANDIA',
    label: 'NATALANDIA'
  },
  {
    stateKey: 'MG',
    value: 'NATERCIA',
    label: 'NATERCIA'
  },
  {
    stateKey: 'MG',
    value: 'NAZARENO',
    label: 'NAZARENO'
  },
  {
    stateKey: 'MG',
    value: 'NEPOMUCENO',
    label: 'NEPOMUCENO'
  },
  {
    stateKey: 'MG',
    value: 'NINHEIRA',
    label: 'NINHEIRA'
  },
  {
    stateKey: 'MG',
    value: 'NOVA BELEM',
    label: 'NOVA BELEM'
  },
  {
    stateKey: 'MG',
    value: 'NOVA ERA',
    label: 'NOVA ERA'
  },
  {
    stateKey: 'MG',
    value: 'NOVA MODICA',
    label: 'NOVA MODICA'
  },
  {
    stateKey: 'MG',
    value: 'NOVA PONTE',
    label: 'NOVA PONTE'
  },
  {
    stateKey: 'MG',
    value: 'NOVA PORTEIRINHA',
    label: 'NOVA PORTEIRINHA'
  },
  {
    stateKey: 'MG',
    value: 'NOVA RESENDE',
    label: 'NOVA RESENDE'
  },
  {
    stateKey: 'MG',
    value: 'NOVA SERRANA',
    label: 'NOVA SERRANA'
  },
  {
    stateKey: 'MG',
    value: 'NOVO CRUZEIRO',
    label: 'NOVO CRUZEIRO'
  },
  {
    stateKey: 'MG',
    value: 'NOVO ORIENTE DE MINAS',
    label: 'NOVO ORIENTE DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'NOVORIZONTE',
    label: 'NOVORIZONTE'
  },
  {
    stateKey: 'MG',
    value: 'OLARIA',
    label: 'OLARIA'
  },
  {
    stateKey: 'MG',
    value: "OLHOS-D'AGUA",
    label: "OLHOS-D'AGUA"
  },
  {
    stateKey: 'MG',
    value: 'OLIMPIO NORONHA',
    label: 'OLIMPIO NORONHA'
  },
  {
    stateKey: 'MG',
    value: 'OLIVEIRA',
    label: 'OLIVEIRA'
  },
  {
    stateKey: 'MG',
    value: 'OLIVEIRA FORTES',
    label: 'OLIVEIRA FORTES'
  },
  {
    stateKey: 'MG',
    value: 'ONCA DE PITANGUI',
    label: 'ONCA DE PITANGUI'
  },
  {
    stateKey: 'MG',
    value: 'ORATORIOS',
    label: 'ORATORIOS'
  },
  {
    stateKey: 'MG',
    value: 'ORIZANIA',
    label: 'ORIZANIA'
  },
  {
    stateKey: 'MG',
    value: 'OURO BRANCO',
    label: 'OURO BRANCO'
  },
  {
    stateKey: 'MG',
    value: 'OURO FINO',
    label: 'OURO FINO'
  },
  {
    stateKey: 'MG',
    value: 'OURO PRETO',
    label: 'OURO PRETO'
  },
  {
    stateKey: 'MG',
    value: 'OURO VERDE DE MINAS',
    label: 'OURO VERDE DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'PADRE CARVALHO',
    label: 'PADRE CARVALHO'
  },
  {
    stateKey: 'MG',
    value: 'PADRE PARAISO',
    label: 'PADRE PARAISO'
  },
  {
    stateKey: 'MG',
    value: 'PAI PEDRO',
    label: 'PAI PEDRO'
  },
  {
    stateKey: 'MG',
    value: 'PAINEIRAS',
    label: 'PAINEIRAS'
  },
  {
    stateKey: 'MG',
    value: 'PAINS',
    label: 'PAINS'
  },
  {
    stateKey: 'MG',
    value: 'PAIVA',
    label: 'PAIVA'
  },
  {
    stateKey: 'MG',
    value: 'PALMA',
    label: 'PALMA'
  },
  {
    stateKey: 'MG',
    value: 'PALMOPOLIS',
    label: 'PALMOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'PAPAGAIOS',
    label: 'PAPAGAIOS'
  },
  {
    stateKey: 'MG',
    value: 'PARA DE MINAS',
    label: 'PARA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'PARACATU',
    label: 'PARACATU'
  },
  {
    stateKey: 'MG',
    value: 'PARAGUACU',
    label: 'PARAGUACU'
  },
  {
    stateKey: 'MG',
    value: 'PARAISOPOLIS',
    label: 'PARAISOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'PARAOPEBA',
    label: 'PARAOPEBA'
  },
  {
    stateKey: 'MG',
    value: 'PASSA QUATRO',
    label: 'PASSA QUATRO'
  },
  {
    stateKey: 'MG',
    value: 'PASSA TEMPO',
    label: 'PASSA TEMPO'
  },
  {
    stateKey: 'MG',
    value: 'PASSA VINTE',
    label: 'PASSA VINTE'
  },
  {
    stateKey: 'MG',
    value: 'PASSABEM',
    label: 'PASSABEM'
  },
  {
    stateKey: 'MG',
    value: 'PASSOS',
    label: 'PASSOS'
  },
  {
    stateKey: 'MG',
    value: 'PATIS',
    label: 'PATIS'
  },
  {
    stateKey: 'MG',
    value: 'PATOS DE MINAS',
    label: 'PATOS DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'PATROCINIO',
    label: 'PATROCINIO'
  },
  {
    stateKey: 'MG',
    value: 'PATROCINIO DO MURIAE',
    label: 'PATROCINIO DO MURIAE'
  },
  {
    stateKey: 'MG',
    value: 'PAULA CANDIDO',
    label: 'PAULA CANDIDO'
  },
  {
    stateKey: 'MG',
    value: 'PAULISTAS',
    label: 'PAULISTAS'
  },
  {
    stateKey: 'MG',
    value: 'PAVAO',
    label: 'PAVAO'
  },
  {
    stateKey: 'MG',
    value: 'PECANHA',
    label: 'PECANHA'
  },
  {
    stateKey: 'MG',
    value: 'PEDRA AZUL',
    label: 'PEDRA AZUL'
  },
  {
    stateKey: 'MG',
    value: 'PEDRA BONITA',
    label: 'PEDRA BONITA'
  },
  {
    stateKey: 'MG',
    value: 'PEDRA DO ANTA',
    label: 'PEDRA DO ANTA'
  },
  {
    stateKey: 'MG',
    value: 'PEDRA DO INDAIA',
    label: 'PEDRA DO INDAIA'
  },
  {
    stateKey: 'MG',
    value: 'PEDRA DOURADA',
    label: 'PEDRA DOURADA '
  },
  {
    stateKey: 'MG',
    value: 'PEDRALVA',
    label: 'PEDRALVA'
  },
  {
    stateKey: 'MG',
    value: 'PEDRAS DE MARIA DA CRUZ',
    label: 'PEDRAS DE MARIA DA CRUZ'
  },
  {
    stateKey: 'MG',
    value: 'PEDRINOPOLIS',
    label: 'PEDRINOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'PEDRO LEOPOLDO',
    label: 'PEDRO LEOPOLDO'
  },
  {
    stateKey: 'MG',
    value: 'PEDRO TEIXEIRA',
    label: 'PEDRO TEIXEIRA'
  },
  {
    stateKey: 'MG',
    value: 'PEQUERI',
    label: 'PEQUERI'
  },
  {
    stateKey: 'MG',
    value: 'PEQUI',
    label: 'PEQUI'
  },
  {
    stateKey: 'MG',
    value: 'PERDIGAO',
    label: 'PERDIGAO'
  },
  {
    stateKey: 'MG',
    value: 'PERDIZES',
    label: 'PERDIZES'
  },
  {
    stateKey: 'MG',
    value: 'PERDOES',
    label: 'PERDOES'
  },
  {
    stateKey: 'MG',
    value: 'PERIQUITO',
    label: 'PERIQUITO'
  },
  {
    stateKey: 'MG',
    value: 'PESCADOR',
    label: 'PESCADOR'
  },
  {
    stateKey: 'MG',
    value: 'PIAU',
    label: 'PIAU'
  },
  {
    stateKey: 'MG',
    value: 'PIEDADE DE CARATINGA',
    label: 'PIEDADE DE CARATINGA'
  },
  {
    stateKey: 'MG',
    value: 'PIEDADE DE PONTE NOVA',
    label: 'PIEDADE DE PONTE NOVA'
  },
  {
    stateKey: 'MG',
    value: 'PIEDADE DO RIO GRANDE',
    label: 'PIEDADE DO RIO GRANDE'
  },
  {
    stateKey: 'MG',
    value: 'PIEDADE DOS GERAIS',
    label: 'PIEDADE DOS GERAIS'
  },
  {
    stateKey: 'MG',
    value: 'PIMENTA',
    label: 'PIMENTA'
  },
  {
    stateKey: 'MG',
    value: "PINGO-D'AGUA",
    label: "PINGO-D'AGUA"
  },
  {
    stateKey: 'MG',
    value: 'PINTOPOLIS',
    label: 'PINTOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'PIRACEMA',
    label: 'PIRACEMA'
  },
  {
    stateKey: 'MG',
    value: 'PIRAJUBA',
    label: 'PIRAJUBA'
  },
  {
    stateKey: 'MG',
    value: 'PIRANGA',
    label: 'PIRANGA'
  },
  {
    stateKey: 'MG',
    value: 'PIRANGUCU',
    label: 'PIRANGUCU'
  },
  {
    stateKey: 'MG',
    value: 'PIRANGUINHO',
    label: 'PIRANGUINHO'
  },
  {
    stateKey: 'MG',
    value: 'PIRAPETINGA',
    label: 'PIRAPETINGA'
  },
  {
    stateKey: 'MG',
    value: 'PIRAPORA',
    label: 'PIRAPORA'
  },
  {
    stateKey: 'MG',
    value: 'PIRAUBA',
    label: 'PIRAUBA'
  },
  {
    stateKey: 'MG',
    value: 'PITANGUI',
    label: 'PITANGUI'
  },
  {
    stateKey: 'MG',
    value: 'PIUMHI',
    label: 'PIUMHI'
  },
  {
    stateKey: 'MG',
    value: 'PLANURA',
    label: 'PLANURA'
  },
  {
    stateKey: 'MG',
    value: 'POCO FUNDO',
    label: 'POCO FUNDO'
  },
  {
    stateKey: 'MG',
    value: 'POCOS DE CALDAS',
    label: 'POCOS DE CALDAS'
  },
  {
    stateKey: 'MG',
    value: 'POCRANE',
    label: 'POCRANE'
  },
  {
    stateKey: 'MG',
    value: 'POMPEU',
    label: 'POMPEU'
  },
  {
    stateKey: 'MG',
    value: 'PONTE NOVA',
    label: 'PONTE NOVA'
  },
  {
    stateKey: 'MG',
    value: 'PONTO CHIQUE',
    label: 'PONTO CHIQUE'
  },
  {
    stateKey: 'MG',
    value: 'PONTO DOS VOLANTES',
    label: 'PONTO DOS VOLANTES'
  },
  {
    stateKey: 'MG',
    value: 'PORTEIRINHA',
    label: 'PORTEIRINHA'
  },
  {
    stateKey: 'MG',
    value: 'PORTO FIRME',
    label: 'PORTO FIRME'
  },
  {
    stateKey: 'MG',
    value: 'POTE',
    label: 'POTE'
  },
  {
    stateKey: 'MG',
    value: 'POUSO ALEGRE',
    label: 'POUSO ALEGRE'
  },
  {
    stateKey: 'MG',
    value: 'POUSO ALTO',
    label: 'POUSO ALTO'
  },
  {
    stateKey: 'MG',
    value: 'PRADOS',
    label: 'PRADOS'
  },
  {
    stateKey: 'MG',
    value: 'PRATA',
    label: 'PRATA'
  },
  {
    stateKey: 'MG',
    value: 'PRATAPOLIS',
    label: 'PRATAPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'PRATINHA',
    label: 'PRATINHA'
  },
  {
    stateKey: 'MG',
    value: 'PRESIDENTE JUSCELINO',
    label: 'PRESIDENTE JUSCELINO'
  },
  {
    stateKey: 'MG',
    value: 'PRESIDENTE KUBITSCHEK',
    label: 'PRESIDENTE KUBITSCHEK'
  },
  {
    stateKey: 'MG',
    value: 'PRESIDENTE OLEGARIO',
    label: 'PRESIDENTE OLEGARIO'
  },
  {
    stateKey: 'MG',
    value: 'PRUDENTE DE MORAIS',
    label: 'PRUDENTE DE MORAIS'
  },
  {
    stateKey: 'MG',
    value: 'QUARTEL GERAL',
    label: 'QUARTEL GERAL'
  },
  {
    stateKey: 'MG',
    value: 'QUELUZITO',
    label: 'QUELUZITO'
  },
  {
    stateKey: 'MG',
    value: 'RAPOSOS',
    label: 'RAPOSOS'
  },
  {
    stateKey: 'MG',
    value: 'RAUL SOARES',
    label: 'RAUL SOARES'
  },
  {
    stateKey: 'MG',
    value: 'RECREIO',
    label: 'RECREIO'
  },
  {
    stateKey: 'MG',
    value: 'REDUTO',
    label: 'REDUTO'
  },
  {
    stateKey: 'MG',
    value: 'RESENDE COSTA',
    label: 'RESENDE COSTA'
  },
  {
    stateKey: 'MG',
    value: 'RESPLENDOR',
    label: 'RESPLENDOR'
  },
  {
    stateKey: 'MG',
    value: 'RESSAQUINHA',
    label: 'RESSAQUINHA'
  },
  {
    stateKey: 'MG',
    value: 'RIACHINHO',
    label: 'RIACHINHO'
  },
  {
    stateKey: 'MG',
    value: 'RIACHO DOS MACHADOS',
    label: 'RIACHO DOS MACHADOS'
  },
  {
    stateKey: 'MG',
    value: 'RIBEIRAO DAS NEVES',
    label: 'RIBEIRAO DAS NEVES'
  },
  {
    stateKey: 'MG',
    value: 'RIBEIRAO VERMELHO',
    label: 'RIBEIRAO VERMELHO'
  },
  {
    stateKey: 'MG',
    value: 'RIO ACIMA',
    label: 'RIO ACIMA'
  },
  {
    stateKey: 'MG',
    value: 'RIO CASCA',
    label: 'RIO CASCA'
  },
  {
    stateKey: 'MG',
    value: 'RIO DO PRADO',
    label: 'RIO DO PRADO'
  },
  {
    stateKey: 'MG',
    value: 'RIO DOCE',
    label: 'RIO DOCE'
  },
  {
    stateKey: 'MG',
    value: 'RIO ESPERA',
    label: 'RIO ESPERA'
  },
  {
    stateKey: 'MG',
    value: 'RIO MANSO',
    label: 'RIO MANSO'
  },
  {
    stateKey: 'MG',
    value: 'RIO NOVO',
    label: 'RIO NOVO'
  },
  {
    stateKey: 'MG',
    value: 'RIO PARANAIBA',
    label: 'RIO PARANAIBA'
  },
  {
    stateKey: 'MG',
    value: 'RIO PARDO DE MINAS',
    label: 'RIO PARDO DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'RIO PIRACICABA',
    label: 'RIO PIRACICABA'
  },
  {
    stateKey: 'MG',
    value: 'RIO POMBA',
    label: 'RIO POMBA'
  },
  {
    stateKey: 'MG',
    value: 'RIO PRETO',
    label: 'RIO PRETO'
  },
  {
    stateKey: 'MG',
    value: 'RIO VERMELHO',
    label: 'RIO VERMELHO'
  },
  {
    stateKey: 'MG',
    value: 'RITAPOLIS',
    label: 'RITAPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'ROCHEDO DE MINAS',
    label: 'ROCHEDO DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'RODEIRO',
    label: 'RODEIRO'
  },
  {
    stateKey: 'MG',
    value: 'ROMARIA',
    label: 'ROMARIA'
  },
  {
    stateKey: 'MG',
    value: 'ROSARIO DA LIMEIRA',
    label: 'ROSARIO DA LIMEIRA'
  },
  {
    stateKey: 'MG',
    value: 'RUBELITA',
    label: 'RUBELITA'
  },
  {
    stateKey: 'MG',
    value: 'RUBIM',
    label: 'RUBIM'
  },
  {
    stateKey: 'MG',
    value: 'SABARA',
    label: 'SABARA'
  },
  {
    stateKey: 'MG',
    value: 'SABINOPOLIS',
    label: 'SABINOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'SACRAMENTO',
    label: 'SACRAMENTO'
  },
  {
    stateKey: 'MG',
    value: 'SALINAS',
    label: 'SALINAS'
  },
  {
    stateKey: 'MG',
    value: 'SALTO DA DIVISA',
    label: 'SALTO DA DIVISA'
  },
  {
    stateKey: 'MG',
    value: 'SANTA BARBARA',
    label: 'SANTA BARBARA'
  },
  {
    stateKey: 'MG',
    value: 'SANTA BARBARA DO LESTE',
    label: 'SANTA BARBARA DO LESTE'
  },
  {
    stateKey: 'MG',
    value: 'SANTA BARBARA DO MONTE VER',
    label: 'SANTA BARBARA DO MONTE VER'
  },
  {
    stateKey: 'MG',
    value: 'SANTA BARBARA DO TUGURIO',
    label: 'SANTA BARBARA DO TUGURIO'
  },
  {
    stateKey: 'MG',
    value: 'SANTA CRUZ DE MINAS',
    label: 'SANTA CRUZ DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'SANTA CRUZ DE SALINAS',
    label: 'SANTA CRUZ DE SALINAS'
  },
  {
    stateKey: 'MG',
    value: 'SANTA CRUZ DO ESCALVADO',
    label: 'SANTA CRUZ DO ESCALVADO'
  },
  {
    stateKey: 'MG',
    value: 'SANTA EFIGENIA DE MINAS',
    label: 'SANTA EFIGENIA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'SANTA FE DE MINAS',
    label: 'SANTA FE DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'SANTA HELENA DE MINAS',
    label: 'SANTA HELENA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'SANTA JULIANA',
    label: 'SANTA JULIANA'
  },
  {
    stateKey: 'MG',
    value: 'SANTA LUZIA',
    label: 'SANTA LUZIA'
  },
  {
    stateKey: 'MG',
    value: 'SANTA MARGARIDA',
    label: 'SANTA MARGARIDA'
  },
  {
    stateKey: 'MG',
    value: 'SANTA MARIA DE ITABIRA',
    label: 'SANTA MARIA DE ITABIRA'
  },
  {
    stateKey: 'MG',
    value: 'SANTA MARIA DO SALTO',
    label: 'SANTA MARIA DO SALTO'
  },
  {
    stateKey: 'MG',
    value: 'SANTA MARIA DO SUACUI',
    label: 'SANTA MARIA DO SUACUI'
  },
  {
    stateKey: 'MG',
    value: 'SANTA RITA DE CALDAS',
    label: 'SANTA RITA DE CALDAS'
  },
  {
    stateKey: 'MG',
    value: 'SANTA RITA DE JACUTINGA',
    label: 'SANTA RITA DE JACUTINGA'
  },
  {
    stateKey: 'MG',
    value: 'SANTA RITA DE MINAS',
    label: 'SANTA RITA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'SANTA RITA DO IBITIPOCA',
    label: 'SANTA RITA DO IBITIPOCA'
  },
  {
    stateKey: 'MG',
    value: 'SANTA RITA DO ITUETO',
    label: 'SANTA RITA DO ITUETO'
  },
  {
    stateKey: 'MG',
    value: 'SANTA RITA DO SAPUCAI',
    label: 'SANTA RITA DO SAPUCAI'
  },
  {
    stateKey: 'MG',
    value: 'SANTA ROSA DA SERRA',
    label: 'SANTA ROSA DA SERRA'
  },
  {
    stateKey: 'MG',
    value: 'SANTA VITORIA',
    label: 'SANTA VITORIA'
  },
  {
    stateKey: 'MG',
    value: 'SANTANA DA VARGEM',
    label: 'SANTANA DA VARGEM'
  },
  {
    stateKey: 'MG',
    value: 'SANTANA DE CATAGUASES',
    label: 'SANTANA DE CATAGUASES'
  },
  {
    stateKey: 'MG',
    value: 'SANTANA DE PIRAPAMA',
    label: 'SANTANA DE PIRAPAMA'
  },
  {
    stateKey: 'MG',
    value: 'SANTANA DO DESERTO',
    label: 'SANTANA DO DESERTO'
  },
  {
    stateKey: 'MG',
    value: 'SANTANA DO GARAMBEU',
    label: 'SANTANA DO GARAMBEU'
  },
  {
    stateKey: 'MG',
    value: 'SANTANA DO JACARE',
    label: 'SANTANA DO JACARE'
  },
  {
    stateKey: 'MG',
    value: 'SANTANA DO MANHUACU',
    label: 'SANTANA DO MANHUACU'
  },
  {
    stateKey: 'MG',
    value: 'SANTANA DO PARAISO',
    label: 'SANTANA DO PARAISO'
  },
  {
    stateKey: 'MG',
    value: 'SANTANA DO RIACHO',
    label: 'SANTANA DO RIACHO'
  },
  {
    stateKey: 'MG',
    value: 'SANTANA DOS MONTES',
    label: 'SANTANA DOS MONTES'
  },
  {
    stateKey: 'MG',
    value: 'SANTO ANTONIO DO AMPARO',
    label: 'SANTO ANTONIO DO AMPARO'
  },
  {
    stateKey: 'MG',
    value: 'SANTO ANTONIO DO GRAMA',
    label: 'SANTO ANTONIO DO GRAMA'
  },
  {
    stateKey: 'MG',
    value: 'SANTO ANTONIO DO ITAMBE',
    label: 'SANTO ANTONIO DO ITAMBE'
  },
  {
    stateKey: 'MG',
    value: 'SANTO ANTONIO DO JACINTO',
    label: 'SANTO ANTONIO DO JACINTO'
  },
  {
    stateKey: 'MG',
    value: 'SANTO ANTONIO DO MONTE',
    label: 'SANTO ANTONIO DO MONTE'
  },
  {
    stateKey: 'MG',
    value: 'SANTO ANTONIO DO RETIRO',
    label: 'SANTO ANTONIO DO RETIRO'
  },
  {
    stateKey: 'MG',
    value: 'SANTO ANTONIO DO RIO ABAIX',
    label: 'SANTO ANTONIO DO RIO ABAIX'
  },
  {
    stateKey: 'MG',
    value: 'SANTO HIPOLITO',
    label: 'SANTO HIPOLITO'
  },
  {
    stateKey: 'MG',
    value: 'SANTOS DUMONT',
    label: 'SANTOS DUMONT'
  },
  {
    stateKey: 'MG',
    value: 'SAO BENTO ABADE',
    label: 'SAO BENTO ABADE'
  },
  {
    stateKey: 'MG',
    value: 'SAO BRAS DO SUACUI',
    label: 'SAO BRAS DO SUACUI'
  },
  {
    stateKey: 'MG',
    value: 'SAO DOMINGOS DAS DORES',
    label: 'SAO DOMINGOS DAS DORES'
  },
  {
    stateKey: 'MG',
    value: 'SAO DOMINGOS DO PRATA',
    label: 'SAO DOMINGOS DO PRATA'
  },
  {
    stateKey: 'MG',
    value: 'SAO FELIX DE MINAS',
    label: 'SAO FELIX DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'SAO FRANCISCO',
    label: 'SAO FRANCISCO'
  },
  {
    stateKey: 'MG',
    value: 'SAO FRANCISCO DE PAULA',
    label: 'SAO FRANCISCO DE PAULA'
  },
  {
    stateKey: 'MG',
    value: 'SAO FRANCISCO DE SALES',
    label: 'SAO FRANCISCO DE SALES'
  },
  {
    stateKey: 'MG',
    value: 'SAO FRANCISCO DO GLORIA',
    label: 'SAO FRANCISCO DO GLORIA'
  },
  {
    stateKey: 'MG',
    value: 'SAO GERALDO',
    label: 'SAO GERALDO'
  },
  {
    stateKey: 'MG',
    value: 'SAO GERALDO DA PIEDADE',
    label: 'SAO GERALDO DA PIEDADE'
  },
  {
    stateKey: 'MG',
    value: 'SAO GERALDO DO BAIXIO',
    label: 'SAO GERALDO DO BAIXIO'
  },
  {
    stateKey: 'MG',
    value: 'SAO GONCALO DO ABAETE',
    label: 'SAO GONCALO DO ABAETE'
  },
  {
    stateKey: 'MG',
    value: 'SAO GONCALO DO PARA',
    label: 'SAO GONCALO DO PARA'
  },
  {
    stateKey: 'MG',
    value: 'SAO GONCALO DO RIO ABAIXO',
    label: 'SAO GONCALO DO RIO ABAIXO'
  },
  {
    stateKey: 'MG',
    value: 'SAO GONCALO DO SAPUCAI',
    label: 'SAO GONCALO DO SAPUCAI'
  },
  {
    stateKey: 'MG',
    value: 'SAO GOTARDO',
    label: 'SAO GOTARDO'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOAO BATISTA DO GLORIA',
    label: 'SAO JOAO BATISTA DO GLORIA'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOAO DA LAGOA',
    label: 'SAO JOAO DA LAGOA'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOAO DA MATA',
    label: 'SAO JOAO DA MATA'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOAO DA PONTE',
    label: 'SAO JOAO DA PONTE'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOAO DAS MISSOES',
    label: 'SAO JOAO DAS MISSOES'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOAO DEL REI',
    label: 'SAO JOAO DEL REI'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOAO DO MANHUACU',
    label: 'SAO JOAO DO MANHUACU'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOAO DO ORIENTE',
    label: 'SAO JOAO DO ORIENTE'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOAO DO PACUI',
    label: 'SAO JOAO DO PACUI'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOAO DO PARAISO',
    label: 'SAO JOAO DO PARAISO'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOAO EVANGELISTA',
    label: 'SAO JOAO EVANGELISTA'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOAO NEPOMUCENO',
    label: 'SAO JOAO NEPOMUCENO'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOAQUIM DE BICAS',
    label: 'SAO JOAQUIM DE BICAS'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOSE DA BARRA',
    label: 'SAO JOSE DA BARRA'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOSE DA LAPA',
    label: 'SAO JOSE DA LAPA'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOSE DA SAFIRA',
    label: 'SAO JOSE DA SAFIRA'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOSE DA VARGINHA',
    label: 'SAO JOSE DA VARGINHA'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOSE DO ALEGRE',
    label: 'SAO JOSE DO ALEGRE'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOSE DO DIVINO',
    label: 'SAO JOSE DO DIVINO'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOSE DO GOIABAL',
    label: 'SAO JOSE DO GOIABAL'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOSE DO JACURI',
    label: 'SAO JOSE DO JACURI'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOSE DO MANTIMENTO',
    label: 'SAO JOSE DO MANTIMENTO'
  },
  {
    stateKey: 'MG',
    value: 'SAO LOURENCO',
    label: 'SAO LOURENCO'
  },
  {
    stateKey: 'MG',
    value: 'SAO MIGUEL DO ANTA',
    label: 'SAO MIGUEL DO ANTA'
  },
  {
    stateKey: 'MG',
    value: 'SAO PEDRO DA UNIAO',
    label: 'SAO PEDRO DA UNIAO'
  },
  {
    stateKey: 'MG',
    value: 'SAO PEDRO DO SUACUI',
    label: 'SAO PEDRO DO SUACUI'
  },
  {
    stateKey: 'MG',
    value: 'SAO PEDRO DOS FERROS',
    label: 'SAO PEDRO DOS FERROS'
  },
  {
    stateKey: 'MG',
    value: 'SAO ROMAO',
    label: 'SAO ROMAO'
  },
  {
    stateKey: 'MG',
    value: 'SAO ROQUE DE MINAS',
    label: 'SAO ROQUE DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'SAO SEBASTIAO DA BELA VIST',
    label: 'SAO SEBASTIAO DA BELA VIST'
  },
  {
    stateKey: 'MG',
    value: 'SAO SEBASTIAO DA VARGEM AL',
    label: 'SAO SEBASTIAO DA VARGEM AL'
  },
  {
    stateKey: 'MG',
    value: 'SAO SEBASTIAO DO ANTA',
    label: 'SAO SEBASTIAO DO ANTA'
  },
  {
    stateKey: 'MG',
    value: 'SAO SEBASTIAO DO MARANHAO',
    label: 'SAO SEBASTIAO DO MARANHAO'
  },
  {
    stateKey: 'MG',
    value: 'SAO SEBASTIAO DO OESTE',
    label: 'SAO SEBASTIAO DO OESTE'
  },
  {
    stateKey: 'MG',
    value: 'SAO SEBASTIAO DO PARAISO',
    label: 'SAO SEBASTIAO DO PARAISO'
  },
  {
    stateKey: 'MG',
    value: 'SAO SEBASTIAO DO RIO PRETO',
    label: 'SAO SEBASTIAO DO RIO PRETO'
  },
  {
    stateKey: 'MG',
    value: 'SAO SEBASTIAO DO RIO VERDE',
    label: 'SAO SEBASTIAO DO RIO VERDE'
  },
  {
    stateKey: 'MG',
    value: 'SAO TIAGO',
    label: 'SAO TIAGO'
  },
  {
    stateKey: 'MG',
    value: 'SAO TOMAS DE AQUINO',
    label: 'SAO TOMAS DE AQUINO'
  },
  {
    stateKey: 'MG',
    value: 'SAO TOME DAS LETRAS',
    label: 'SAO TOME DAS LETRAS'
  },
  {
    stateKey: 'MG',
    value: 'SAO VICENTE DE MINAS',
    label: 'SAO VICENTE DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'SAPUCAI-MIRIM',
    label: 'SAPUCAI-MIRIM'
  },
  {
    stateKey: 'MG',
    value: 'SARDOA',
    label: 'SARDOA'
  },
  {
    stateKey: 'MG',
    value: 'SARZEDO',
    label: 'SARZEDO'
  },
  {
    stateKey: 'MG',
    value: 'SEM IXE',
    label: 'SEM IXE'
  },
  {
    stateKey: 'MG',
    value: 'SENADOR AMARAL',
    label: 'SENADOR AMARAL'
  },
  {
    stateKey: 'MG',
    value: 'SENADOR CORTES',
    label: 'SENADOR CORTES'
  },
  {
    stateKey: 'MG',
    value: 'SENADOR FIRMINO',
    label: 'SENADOR FIRMINO'
  },
  {
    stateKey: 'MG',
    value: 'SENADOR JOSE BENTO',
    label: 'SENADOR JOSE BENTO'
  },
  {
    stateKey: 'MG',
    value: 'SENADOR MODESTINO GONCALVE',
    label: 'SENADOR MODESTINO GONCALVE'
  },
  {
    stateKey: 'MG',
    value: 'SENHORA DE OLIVEIRA',
    label: 'SENHORA DE OLIVEIRA'
  },
  {
    stateKey: 'MG',
    value: 'SENHORA DO PORTO',
    label: 'SENHORA DO PORTO'
  },
  {
    stateKey: 'MG',
    value: 'SENHORA DOS REMEDIOS',
    label: 'SENHORA DOS REMEDIOS'
  },
  {
    stateKey: 'MG',
    value: 'SERICITA',
    label: 'SERICITA'
  },
  {
    stateKey: 'MG',
    value: 'SERITINGA',
    label: 'SERITINGA'
  },
  {
    stateKey: 'MG',
    value: 'SERRA AZUL DE MINAS',
    label: 'SERRA AZUL DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'SERRA DA SAUDADE',
    label: 'SERRA DA SAUDADE'
  },
  {
    stateKey: 'MG',
    value: 'SERRA DO SALITRE',
    label: 'SERRA DO SALITRE'
  },
  {
    stateKey: 'MG',
    value: 'SERRA DOS AIMORES',
    label: 'SERRA DOS AIMORES'
  },
  {
    stateKey: 'MG',
    value: 'SERRANIA',
    label: 'SERRANIA'
  },
  {
    stateKey: 'MG',
    value: 'SERRANOPOLIS DE MINAS',
    label: 'SERRANOPOLIS DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'SERRANOS',
    label: 'SERRANOS'
  },
  {
    stateKey: 'MG',
    value: 'SERRO',
    label: 'SERRO'
  },
  {
    stateKey: 'MG',
    value: 'SETE LAGOAS',
    label: 'SETE LAGOAS'
  },
  {
    stateKey: 'MG',
    value: 'SETUBINHA',
    label: 'SETUBINHA'
  },
  {
    stateKey: 'MG',
    value: 'SILVEIRANIA',
    label: 'SILVEIRANIA'
  },
  {
    stateKey: 'MG',
    value: 'SILVIANOPOLIS',
    label: 'SILVIANOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'SIMAO PEREIRA',
    label: 'SIMAO PEREIRA'
  },
  {
    stateKey: 'MG',
    value: 'SIMONESIA',
    label: 'SIMONESIA'
  },
  {
    stateKey: 'MG',
    value: 'SOBRALIA',
    label: 'SOBRALIA'
  },
  {
    stateKey: 'MG',
    value: 'SOLEDADE DE MINAS',
    label: 'SOLEDADE DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'TABULEIRO',
    label: 'TABULEIRO'
  },
  {
    stateKey: 'MG',
    value: 'TAIOBEIRAS',
    label: 'TAIOBEIRAS'
  },
  {
    stateKey: 'MG',
    value: 'TAPARUBA',
    label: 'TAPARUBA'
  },
  {
    stateKey: 'MG',
    value: 'TAPIRA',
    label: 'TAPIRA'
  },
  {
    stateKey: 'MG',
    value: 'TAPIRAI',
    label: 'TAPIRAI'
  },
  {
    stateKey: 'MG',
    value: 'TAQUARACU DE MINAS',
    label: 'TAQUARACU DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'TARUMIRIM',
    label: 'TARUMIRIM'
  },
  {
    stateKey: 'MG',
    value: 'TEIXEIRAS',
    label: 'TEIXEIRAS'
  },
  {
    stateKey: 'MG',
    value: 'TEOFILO OTONI',
    label: 'TEOFILO OTONI'
  },
  {
    stateKey: 'MG',
    value: 'TIMOTEO',
    label: 'TIMOTEO'
  },
  {
    stateKey: 'MG',
    value: 'TIRADENTES',
    label: 'TIRADENTES'
  },
  {
    stateKey: 'MG',
    value: 'TIROS',
    label: 'TIROS'
  },
  {
    stateKey: 'MG',
    value: 'TOCANTINS',
    label: 'TOCANTINS'
  },
  {
    stateKey: 'MG',
    value: 'TOCOS DO MOJI',
    label: 'TOCOS DO MOJI'
  },
  {
    stateKey: 'MG',
    value: 'TOLEDO',
    label: 'TOLEDO'
  },
  {
    stateKey: 'MG',
    value: 'TOMBOS',
    label: 'TOMBOS'
  },
  {
    stateKey: 'MG',
    value: 'TRES CORACOES',
    label: 'TRES CORACOES'
  },
  {
    stateKey: 'MG',
    value: 'TRES MARIAS',
    label: 'TRES MARIAS'
  },
  {
    stateKey: 'MG',
    value: 'TRES PONTAS',
    label: 'TRES PONTAS'
  },
  {
    stateKey: 'MG',
    value: 'TUMIRITINGA',
    label: 'TUMIRITINGA'
  },
  {
    stateKey: 'MG',
    value: 'TUPACIGUARA',
    label: 'TUPACIGUARA'
  },
  {
    stateKey: 'MG',
    value: 'TURMALINA',
    label: 'TURMALINA'
  },
  {
    stateKey: 'MG',
    value: 'TURVOLANDIA',
    label: 'TURVOLANDIA'
  },
  {
    stateKey: 'MG',
    value: 'UBA',
    label: 'UBA'
  },
  {
    stateKey: 'MG',
    value: 'UBAI',
    label: 'UBAI'
  },
  {
    stateKey: 'MG',
    value: 'UBAPORANGA',
    label: 'UBAPORANGA'
  },
  {
    stateKey: 'MG',
    value: 'UBERABA',
    label: 'UBERABA'
  },
  {
    stateKey: 'MG',
    value: 'UBERLANDIA',
    label: 'UBERLANDIA'
  },
  {
    stateKey: 'MG',
    value: 'UMBURATIBA',
    label: 'UMBURATIBA'
  },
  {
    stateKey: 'MG',
    value: 'UNAI',
    label: 'UNAI'
  },
  {
    stateKey: 'MG',
    value: 'UNIAO DE MINAS',
    label: 'UNIAO DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'URUANA DE MINAS',
    label: 'URUANA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'URUCANIA',
    label: 'URUCANIA'
  },
  {
    stateKey: 'MG',
    value: 'URUCUIA',
    label: 'URUCUIA'
  },
  {
    stateKey: 'MG',
    value: 'VARGEM ALEGRE',
    label: 'VARGEM ALEGRE'
  },
  {
    stateKey: 'MG',
    value: 'VARGEM BONITA',
    label: 'VARGEM BONITA'
  },
  {
    stateKey: 'MG',
    value: 'VARGEM GRANDE DO RIO PARDO',
    label: 'VARGEM GRANDE DO RIO PARDO'
  },
  {
    stateKey: 'MG',
    value: 'VARGINHA',
    label: 'VARGINHA'
  },
  {
    stateKey: 'MG',
    value: 'VARJAO DE MINAS',
    label: 'VARJAO DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'VARZEA DA PALMA',
    label: 'VARZEA DA PALMA'
  },
  {
    stateKey: 'MG',
    value: 'VARZELANDIA',
    label: 'VARZELANDIA'
  },
  {
    stateKey: 'MG',
    value: 'VAZANTE',
    label: 'VAZANTE'
  },
  {
    stateKey: 'MG',
    value: 'VERDELANDIA',
    label: 'VERDELANDIA'
  },
  {
    stateKey: 'MG',
    value: 'VEREDINHA',
    label: 'VEREDINHA'
  },
  {
    stateKey: 'MG',
    value: 'VERISSIMO',
    label: 'VERISSIMO'
  },
  {
    stateKey: 'MG',
    value: 'VERMELHO NOVO',
    label: 'VERMELHO NOVO'
  },
  {
    stateKey: 'MG',
    value: 'VESPASIANO',
    label: 'VESPASIANO'
  },
  {
    stateKey: 'MG',
    value: 'VICOSA',
    label: 'VICOSA'
  },
  {
    stateKey: 'MG',
    value: 'VIEIRAS',
    label: 'VIEIRAS'
  },
  {
    stateKey: 'MG',
    value: 'VIRGEM DA LAPA',
    label: 'VIRGEM DA LAPA'
  },
  {
    stateKey: 'MG',
    value: 'VIRGINIA',
    label: 'VIRGINIA'
  },
  {
    stateKey: 'MG',
    value: 'VIRGINOPOLIS',
    label: 'VIRGINOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'VIRGOLANDIA',
    label: 'VIRGOLANDIA'
  },
  {
    stateKey: 'MG',
    value: 'VISCONDE DO RIO BRANCO',
    label: 'VISCONDE DO RIO BRANCO'
  },
  {
    stateKey: 'MG',
    value: 'VOLTA GRANDE',
    label: 'VOLTA GRANDE'
  },
  {
    stateKey: 'MG',
    value: 'UBA',
    label: 'UBA'
  },
  {
    stateKey: 'MG',
    value: 'ALTO JEQUITIBA',
    label: 'ALTO JEQUITIBA'
  },
  {
    stateKey: 'MG',
    value: 'Cachoeira de Pajeú',
    label: 'Cachoeira de Pajeú'
  },
  {
    stateKey: 'MG',
    value: 'Conceição das Pedras',
    label: 'Conceição das Pedras'
  },
  {
    stateKey: 'MG',
    value: 'Couto de Magalhães de Min',
    label: 'Couto de Magalhães de Min'
  },
  {
    stateKey: 'MG',
    value: 'São Gonçalo do Rio Preto',
    label: 'São Gonçalo do Rio Preto'
  },
  {
    stateKey: 'MG',
    value: 'Fronteira dos Vales',
    label: 'Fronteira dos Vales'
  },
  {
    stateKey: 'MG',
    value: 'Presidente Bernardes',
    label: 'Presidente Bernardes'
  },
  {
    stateKey: 'MG',
    value: 'São Tiago',
    label: 'São Tiago'
  },
  {
    stateKey: 'MG',
    value: 'Mathias Lobato',
    label: 'Mathias Lobato'
  },
  {
    stateKey: 'MG',
    value: 'SÃO JOÃO DE MANTEINHA',
    label: 'SÃO JOÃO DE MANTEINHA'
  },
  {
    stateKey: 'MG',
    value: 'CONCEIÇAO BARRA DE MINAS',
    label: 'CONCEIÇAO BARRA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'Conceição da Barra de Minas MG',
    label: 'Conceição da Barra de Minas MG'
  },
  {
    stateKey: 'MG',
    value: 'CAMPESTRE',
    label: 'CAMPESTRE'
  },
  {
    stateKey: 'MG',
    value: 'SANTO ANTONIO AVENTUREIRO',
    label: 'SANTO ANTONIO AVENTUREIRO'
  },
  {
    stateKey: 'MG',
    value: 'BRAZOPOLIS',
    label: 'BRAZOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'CONCEIÇÃO DA BARRA DE MINAS',
    label: 'CONCEIÇÃO DA BARRA DE MINAS'
  },
  {
    stateKey: 'MG',
    value: 'SAO SEBASTIAO DAS ESTRELAS',
    label: 'SAO SEBASTIAO DAS ESTRELAS'
  },
  {
    stateKey: 'MG',
    value: 'SÃO JOÃO DO MANTENINHA',
    label: 'SÃO JOÃO DO MANTENINHA'
  },
  {
    stateKey: 'MG',
    value: 'BRASOPOLIS',
    label: 'BRASOPOLIS'
  },
  {
    stateKey: 'MG',
    value: 'PRESIDENTE BERNARDES',
    label: 'PRESIDENTE BERNARDES'
  },
  {
    stateKey: 'MG',
    value: 'NOVA LIMA',
    label: 'NOVA LIMA'
  },
  {
    stateKey: 'MG',
    value: 'SAO JOAO DO MANTENINHA',
    label: 'SAO JOAO DO MANTENINHA'
  },
  {
    stateKey: 'MG',
    value: 'WENCESLAU BRAZ',
    label: 'WENCESLAU BRAZ'
  },
  {
    stateKey: 'PA',
    value: 'ABAETETUBA',
    label: 'ABAETETUBA'
  },
  {
    stateKey: 'PA',
    value: 'ABEL FIGUEREDO',
    label: 'ABEL FIGUEREDO'
  },
  {
    stateKey: 'PA',
    value: 'ACARA',
    label: 'ACARA'
  },
  {
    stateKey: 'PA',
    value: 'AFUA',
    label: 'AFUA'
  },
  {
    stateKey: 'PA',
    value: 'AGUA AZUL DO NORTE',
    label: 'AGUA AZUL DO NORTE'
  },
  {
    stateKey: 'PA',
    value: 'ALENQUER',
    label: 'ALENQUER'
  },
  {
    stateKey: 'PA',
    value: 'ALMEIRIM',
    label: 'ALMEIRIM'
  },
  {
    stateKey: 'PA',
    value: 'ANAJAS',
    label: 'ANAJAS'
  },
  {
    stateKey: 'PA',
    value: 'ANANINDEUA',
    label: 'ANANINDEUA'
  },
  {
    stateKey: 'PA',
    value: 'ANAPU',
    label: 'ANAPU'
  },
  {
    stateKey: 'PA',
    value: 'AUGUSTO CORREA',
    label: 'AUGUSTO CORREA'
  },
  {
    stateKey: 'PA',
    value: 'AURORA DO PARA',
    label: 'AURORA DO PARA'
  },
  {
    stateKey: 'PA',
    value: 'AVEIRO',
    label: 'AVEIRO'
  },
  {
    stateKey: 'PA',
    value: 'BAGRE',
    label: 'BAGRE'
  },
  {
    stateKey: 'PA',
    value: 'BAIAO',
    label: 'BAIAO'
  },
  {
    stateKey: 'PA',
    value: 'BANNACH',
    label: 'BANNACH'
  },
  {
    stateKey: 'PA',
    value: 'BARCARENA',
    label: 'BARCARENA'
  },
  {
    stateKey: 'PA',
    value: 'BELTERRA',
    label: 'BELTERRA'
  },
  {
    stateKey: 'PA',
    value: 'BENEVIDES',
    label: 'BENEVIDES'
  },
  {
    stateKey: 'PA',
    value: 'BOM JESUS DO TOCANTINS',
    label: 'BOM JESUS DO TOCANTINS'
  },
  {
    stateKey: 'PA',
    value: 'BONITO',
    label: 'BONITO'
  },
  {
    stateKey: 'PA',
    value: 'BRAGANCA',
    label: 'BRAGANCA'
  },
  {
    stateKey: 'PA',
    value: 'BRASIL NOVO',
    label: 'BRASIL NOVO'
  },
  {
    stateKey: 'PA',
    value: 'BREJO GRANDE DO ARAGUAIA',
    label: 'BREJO GRANDE DO ARAGUAIA'
  },
  {
    stateKey: 'PA',
    value: 'BREU BRANCO',
    label: 'BREU BRANCO'
  },
  {
    stateKey: 'PA',
    value: 'BREVES',
    label: 'BREVES'
  },
  {
    stateKey: 'PA',
    value: 'BUJARU',
    label: 'BUJARU'
  },
  {
    stateKey: 'PA',
    value: 'CACHOEIRA DO PIRIA',
    label: 'CACHOEIRA DO PIRIA'
  },
  {
    stateKey: 'PA',
    value: 'CACHOEIRA DO ARARI',
    label: 'CACHOEIRA DO ARARI'
  },
  {
    stateKey: 'PA',
    value: 'CAMETA',
    label: 'CAMETA '
  },
  {
    stateKey: 'PA',
    value: 'CANAA DOS CARAJAS',
    label: 'CANAA DOS CARAJAS'
  },
  {
    stateKey: 'PA',
    value: 'CAPANEMA',
    label: 'CAPANEMA'
  },
  {
    stateKey: 'PA',
    value: 'CAPITAO POCO',
    label: 'CAPITAO POCO'
  },
  {
    stateKey: 'PA',
    value: 'CASTANHAL',
    label: 'CASTANHAL'
  },
  {
    stateKey: 'PA',
    value: 'CHAVES',
    label: 'CHAVES'
  },
  {
    stateKey: 'PA',
    value: 'COLARES',
    label: 'COLARES'
  },
  {
    stateKey: 'PA',
    value: 'CONCEICAO DO ARAGUAIA',
    label: 'CONCEICAO DO ARAGUAIA'
  },
  {
    stateKey: 'PA',
    value: 'CONCORDIA DO PARA',
    label: 'CONCORDIA DO PARA'
  },
  {
    stateKey: 'PA',
    value: 'CUMARU DO NORTE',
    label: 'CUMARU DO NORTE'
  },
  {
    stateKey: 'PA',
    value: 'CURIONOPOLIS',
    label: 'CURIONOPOLIS'
  },
  {
    stateKey: 'PA',
    value: 'CURRALINHO',
    label: 'CURRALINHO'
  },
  {
    stateKey: 'PA',
    value: 'CURUA',
    label: 'CURUA'
  },
  {
    stateKey: 'PA',
    value: 'CURUCA',
    label: 'CURUCA'
  },
  {
    stateKey: 'PA',
    value: 'DOM ELISEU',
    label: 'DOM ELISEU'
  },
  {
    stateKey: 'PA',
    value: 'ELDORADO DO CARAJAS',
    label: 'ELDORADO DO CARAJAS'
  },
  {
    stateKey: 'PA',
    value: 'FARO',
    label: 'FARO'
  },
  {
    stateKey: 'PA',
    value: 'FLORESTA DO ARAGUAIA',
    label: 'FLORESTA DO ARAGUAIA'
  },
  {
    stateKey: 'PA',
    value: 'GARRAFAO DO NORTE',
    label: 'GARRAFAO DO NORTE'
  },
  {
    stateKey: 'PA',
    value: 'GOIANESIA DO PARA',
    label: 'GOIANESIA DO PARA'
  },
  {
    stateKey: 'PA',
    value: 'GURUPA',
    label: 'GURUPA'
  },
  {
    stateKey: 'PA',
    value: 'IGARAPE-ACU',
    label: 'IGARAPE-ACU'
  },
  {
    stateKey: 'PA',
    value: 'IGARAPE-MIRI',
    label: 'IGARAPE-MIRI'
  },
  {
    stateKey: 'PA',
    value: 'INHANGAPI',
    label: 'INHANGAPI'
  },
  {
    stateKey: 'PA',
    value: 'IPIXUNA DO PARA',
    label: 'IPIXUNA DO PARA'
  },
  {
    stateKey: 'PA',
    value: 'IRITUIA',
    label: 'IRITUIA'
  },
  {
    stateKey: 'PA',
    value: 'ITAITUBA',
    label: 'ITAITUBA '
  },
  {
    stateKey: 'PA',
    value: 'ITUPIRANGA',
    label: 'ITUPIRANGA'
  },
  {
    stateKey: 'PA',
    value: 'JACAREACANGA',
    label: 'JACAREACANGA'
  },
  {
    stateKey: 'PA',
    value: 'JACUNDA',
    label: 'JACUNDA'
  },
  {
    stateKey: 'PA',
    value: 'JURUTI',
    label: 'JURUTI'
  },
  {
    stateKey: 'PA',
    value: 'LIMOEIRO DO AJURU',
    label: 'LIMOEIRO DO AJURU'
  },
  {
    stateKey: 'PA',
    value: 'MAE DO RIO',
    label: 'MAE DO RIO'
  },
  {
    stateKey: 'PA',
    value: 'MAGALHAES BARATA',
    label: 'MAGALHAES BARATA'
  },
  {
    stateKey: 'PA',
    value: 'MARABA',
    label: 'MARABA'
  },
  {
    stateKey: 'PA',
    value: 'MARACANA',
    label: 'MARACANA'
  },
  {
    stateKey: 'PA',
    value: 'MARAPANIM',
    label: 'MARAPANIM'
  },
  {
    stateKey: 'PA',
    value: 'MARITUBA',
    label: 'MARITUBA'
  },
  {
    stateKey: 'PA',
    value: 'MELGACO',
    label: 'MELGACO'
  },
  {
    stateKey: 'PA',
    value: 'MOCAJUBA',
    label: 'MOCAJUBA'
  },
  {
    stateKey: 'PA',
    value: 'MOJU',
    label: 'MOJU'
  },
  {
    stateKey: 'PA',
    value: 'MONTE ALEGRE',
    label: 'MONTE ALEGRE'
  },
  {
    stateKey: 'PA',
    value: 'MUANA',
    label: 'MUANA'
  },
  {
    stateKey: 'PA',
    value: 'NOVA ESPERANCA DO PIRIA',
    label: 'NOVA ESPERANCA DO PIRIA'
  },
  {
    stateKey: 'PA',
    value: 'NOVA IPIXUNA',
    label: 'NOVA IPIXUNA'
  },
  {
    stateKey: 'PA',
    value: 'NOVA TIMBOTEUA',
    label: 'NOVA TIMBOTEUA'
  },
  {
    stateKey: 'PA',
    value: 'NOVO PROGRESSO',
    label: 'NOVO PROGRESSO'
  },
  {
    stateKey: 'PA',
    value: 'NOVO REPARTIMENTO',
    label: 'NOVO REPARTIMENTO'
  },
  {
    stateKey: 'PA',
    value: 'OBIDOS',
    label: 'OBIDOS'
  },
  {
    stateKey: 'PA',
    value: 'OEIRAS DO PARA',
    label: 'OEIRAS DO PARA'
  },
  {
    stateKey: 'PA',
    value: 'ORIXIMINA',
    label: 'ORIXIMINA'
  },
  {
    stateKey: 'PA',
    value: 'OUREM',
    label: 'OUREM'
  },
  {
    stateKey: 'PA',
    value: 'OURILANDIA DO NORTE',
    label: 'OURILANDIA DO NORTE'
  },
  {
    stateKey: 'PA',
    value: 'PACAJA',
    label: 'PACAJA'
  },
  {
    stateKey: 'PA',
    value: 'PALESTINA DO PARA',
    label: 'PALESTINA DO PARA'
  },
  {
    stateKey: 'PA',
    value: 'PARAGOMINAS',
    label: 'PARAGOMINAS'
  },
  {
    stateKey: 'PA',
    value: 'PARAUAPEBAS',
    label: 'PARAUAPEBAS'
  },
  {
    stateKey: 'PA',
    value: "PAU D'ARCO",
    label: "PAU D'ARCO"
  },
  {
    stateKey: 'PA',
    value: 'PEIXE-BOI',
    label: 'PEIXE-BOI'
  },
  {
    stateKey: 'PA',
    value: 'PICARRA',
    label: 'PICARRA'
  },
  {
    stateKey: 'PA',
    value: 'PLACAS',
    label: 'PLACAS'
  },
  {
    stateKey: 'PA',
    value: 'PONTA DE PEDRAS',
    label: 'PONTA DE PEDRAS'
  },
  {
    stateKey: 'PA',
    value: 'PORTEL',
    label: 'PORTEL'
  },
  {
    stateKey: 'PA',
    value: 'PORTO DE MOZ',
    label: 'PORTO DE MOZ'
  },
  {
    stateKey: 'PA',
    value: 'PRAINHA',
    label: 'PRAINHA'
  },
  {
    stateKey: 'PA',
    value: 'PRIMAVERA',
    label: 'PRIMAVERA'
  },
  {
    stateKey: 'PA',
    value: 'QUATIPURU',
    label: 'QUATIPURU'
  },
  {
    stateKey: 'PA',
    value: 'REDENCAO',
    label: 'REDENCAO'
  },
  {
    stateKey: 'PA',
    value: 'RIO MARIA',
    label: 'RIO MARIA'
  },
  {
    stateKey: 'PA',
    value: 'RONDON DO PARA',
    label: 'RONDON DO PARA'
  },
  {
    stateKey: 'PA',
    value: 'RUROPOLIS',
    label: 'RUROPOLIS'
  },
  {
    stateKey: 'PA',
    value: 'SALINOPOLIS',
    label: 'SALINOPOLIS'
  },
  {
    stateKey: 'PA',
    value: 'SALVATERRA',
    label: 'SALVATERRA'
  },
  {
    stateKey: 'PA',
    value: 'SANTA BARBARA DO PARA',
    label: 'SANTA BARBARA DO PARA'
  },
  {
    stateKey: 'PA',
    value: 'SANTA CRUZ DO ARARI',
    label: 'SANTA CRUZ DO ARARI'
  },
  {
    stateKey: 'PA',
    value: 'SANTA ISABEL DO PARA',
    label: 'SANTA ISABEL DO PARA'
  },
  {
    stateKey: 'PA',
    value: 'SANTA LUZIA DO PARA',
    label: 'SANTA LUZIA DO PARA'
  },
  {
    stateKey: 'PA',
    value: 'SANTA MARIA DAS BARREIRAS',
    label: 'SANTA MARIA DAS BARREIRAS'
  },
  {
    stateKey: 'PA',
    value: 'SANTA MARIA DO PARA',
    label: 'SANTA MARIA DO PARA'
  },
  {
    stateKey: 'PA',
    value: 'SANTANA DO ARAGUAIA',
    label: 'SANTANA DO ARAGUAIA'
  },
  {
    stateKey: 'PA',
    value: 'SANTAREM',
    label: 'SANTAREM'
  },
  {
    stateKey: 'PA',
    value: 'SANTAREM NOVO',
    label: 'SANTAREM NOVO'
  },
  {
    stateKey: 'PA',
    value: 'SANTO ANTONIO DO TAUA',
    label: 'SANTO ANTONIO DO TAUA'
  },
  {
    stateKey: 'PA',
    value: 'SAO CAETANO DE ODIVELAS',
    label: 'SAO CAETANO DE ODIVELAS'
  },
  {
    stateKey: 'PA',
    value: 'SAO DOMINGOS DO ARAGUAIA',
    label: 'SAO DOMINGOS DO ARAGUAIA'
  },
  {
    stateKey: 'PA',
    value: 'SAO DOMINGOS DO CAPIM',
    label: 'SAO DOMINGOS DO CAPIM'
  },
  {
    stateKey: 'PA',
    value: 'SAO FELIX DO XINGU',
    label: 'SAO FELIX DO XINGU'
  },
  {
    stateKey: 'PA',
    value: 'SAO FRANCISCO DO PARA',
    label: 'SAO FRANCISCO DO PARA'
  },
  {
    stateKey: 'PA',
    value: 'SAO GERALDO DO ARAGUAIA',
    label: 'SAO GERALDO DO ARAGUAIA'
  },
  {
    stateKey: 'PA',
    value: 'SAO JOAO DA PONTA',
    label: 'SAO JOAO DA PONTA'
  },
  {
    stateKey: 'PA',
    value: 'SAO JOAO DE PIRABAS',
    label: 'SAO JOAO DE PIRABAS'
  },
  {
    stateKey: 'PA',
    value: 'SAO JOAO DO ARAGUAIA',
    label: 'SAO JOAO DO ARAGUAIA'
  },
  {
    stateKey: 'PA',
    value: 'SAO MIGUEL DO GUAMA',
    label: 'SAO MIGUEL DO GUAMA'
  },
  {
    stateKey: 'PA',
    value: 'SAO SEBASTIAO DA BOA VISTA',
    label: 'SAO SEBASTIAO DA BOA VISTA'
  },
  {
    stateKey: 'PA',
    value: 'SAPUCAIA',
    label: 'SAPUCAIA'
  },
  {
    stateKey: 'PA',
    value: 'SENADOR JOSE PORFIRIO',
    label: 'SENADOR JOSE PORFIRIO'
  },
  {
    stateKey: 'PA',
    value: 'SOURE',
    label: 'SOURE'
  },
  {
    stateKey: 'PA',
    value: 'TAILANDIA',
    label: 'TAILANDIA'
  },
  {
    stateKey: 'PA',
    value: 'TERRA ALTA',
    label: 'TERRA ALTA'
  },
  {
    stateKey: 'PA',
    value: 'TERRA SANTA',
    label: 'TERRA SANTA'
  },
  {
    stateKey: 'PA',
    value: 'TOME-ACU',
    label: 'TOME-ACU'
  },
  {
    stateKey: 'PA',
    value: 'TRACUATEUA',
    label: 'TRACUATEUA'
  },
  {
    stateKey: 'PA',
    value: 'TRAIRAO',
    label: 'TRAIRAO'
  },
  {
    stateKey: 'PA',
    value: 'TUCUMA',
    label: 'TUCUMA'
  },
  {
    stateKey: 'PA',
    value: 'TUCURUI',
    label: 'TUCURUI'
  },
  {
    stateKey: 'PA',
    value: 'ULIANOPOLIS',
    label: 'ULIANOPOLIS'
  },
  {
    stateKey: 'PA',
    value: 'VIGIA',
    label: 'VIGIA'
  },
  {
    stateKey: 'PA',
    value: 'VISEU',
    label: 'VISEU'
  },
  {
    stateKey: 'PA',
    value: 'VITORIA DO XINGU',
    label: 'VITORIA DO XINGU'
  },
  {
    stateKey: 'PA',
    value: 'XINGUARA',
    label: 'XINGUARA'
  },
  {
    stateKey: 'PA',
    value: 'BELEM',
    label: 'BELEM'
  },
  {
    stateKey: 'PA',
    value: 'Mojui dos Campos',
    label: 'Mojui dos Campos'
  },
  {
    stateKey: 'PA',
    value: 'ALTAMIRA',
    label: 'ALTAMIRA'
  },
  {
    stateKey: 'PA',
    value: 'MEDICILANDIA',
    label: 'MEDICILANDIA'
  },
  {
    stateKey: 'PA',
    value: 'URUARA',
    label: 'URUARA'
  },
  {
    stateKey: 'PA',
    value: 'MOJUÍ DOS CAMPOS',
    label: 'MOJUÍ DOS CAMPOS'
  },
  {
    stateKey: 'PB',
    value: 'São João do Rio do Peixe',
    label: 'São João do Rio do Peixe'
  },
  {
    stateKey: 'PB',
    value: 'Princesa Isabel',
    label: 'Princesa Isabel'
  },
  {
    stateKey: 'PB',
    value: 'Riachão do Bacamarte',
    label: 'Riachão do Bacamarte'
  },
  {
    stateKey: 'PB',
    value: 'São Bentinho',
    label: 'São Bentinho'
  },
  {
    stateKey: 'PB',
    value: 'Campo de Santana',
    label: 'Campo de Santana'
  },
  {
    stateKey: 'PB',
    value: 'AGUIAR',
    label: 'AGUIAR'
  },
  {
    stateKey: 'PB',
    value: 'ALAGOA GRANDE',
    label: 'ALAGOA GRANDE'
  },
  {
    stateKey: 'PB',
    value: 'ALAGOA NOVA',
    label: 'ALAGOA NOVA'
  },
  {
    stateKey: 'PB',
    value: 'ALAGOINHA',
    label: 'ALAGOINHA'
  },
  {
    stateKey: 'PB',
    value: 'ALCANTIL',
    label: 'ALCANTIL'
  },
  {
    stateKey: 'PB',
    value: 'ALGODAO DE JANDAIRA',
    label: 'ALGODAO DE JANDAIRA'
  },
  {
    stateKey: 'PB',
    value: 'ALHANDRA',
    label: 'ALHANDRA'
  },
  {
    stateKey: 'PB',
    value: 'AMPARO',
    label: 'AMPARO'
  },
  {
    stateKey: 'PB',
    value: 'APARECIDA',
    label: 'APARECIDA'
  },
  {
    stateKey: 'PB',
    value: 'ARACAGI',
    label: 'ARACAGI'
  },
  {
    stateKey: 'PB',
    value: 'ARARA',
    label: 'ARARA'
  },
  {
    stateKey: 'PB',
    value: 'ARARUNA',
    label: 'ARARUNA'
  },
  {
    stateKey: 'PB',
    value: 'AREIA',
    label: 'AREIA'
  },
  {
    stateKey: 'PB',
    value: 'AREIA DE BARAUNA',
    label: 'AREIA DE BARAUNA'
  },
  {
    stateKey: 'PB',
    value: 'AREIAL',
    label: 'AREIAL'
  },
  {
    stateKey: 'PB',
    value: 'AROEIRAS',
    label: 'AROEIRAS'
  },
  {
    stateKey: 'PB',
    value: 'ASSUNCAO',
    label: 'ASSUNCAO'
  },
  {
    stateKey: 'PB',
    value: 'BAIA DA TRAICAO',
    label: 'BAIA DA TRAICAO'
  },
  {
    stateKey: 'PB',
    value: 'BANANEIRAS',
    label: 'BANANEIRAS'
  },
  {
    stateKey: 'PB',
    value: 'BARAUNAS',
    label: 'BARAUNAS'
  },
  {
    stateKey: 'PB',
    value: 'BARRA DE SANTA ROSA',
    label: 'BARRA DE SANTA ROSA'
  },
  {
    stateKey: 'PB',
    value: 'BARRA DE SANTANA',
    label: 'BARRA DE SANTANA'
  },
  {
    stateKey: 'PB',
    value: 'BAYEUX',
    label: 'BAYEUX'
  },
  {
    stateKey: 'PB',
    value: 'BELEM DO BREJO DO CRUZ',
    label: 'BELEM DO BREJO DO CRUZ'
  },
  {
    stateKey: 'PB',
    value: 'BERNARDINO BATISTA',
    label: 'BERNARDINO BATISTA'
  },
  {
    stateKey: 'PB',
    value: 'BOA VENTURA',
    label: 'BOA VENTURA'
  },
  {
    stateKey: 'PB',
    value: 'BOA VISTA',
    label: 'BOA VISTA'
  },
  {
    stateKey: 'PB',
    value: 'BOM JESUS',
    label: 'BOM JESUS'
  },
  {
    stateKey: 'PB',
    value: 'BOM SUCESSO',
    label: 'BOM SUCESSO'
  },
  {
    stateKey: 'PB',
    value: 'BONITO DE SANTA FE',
    label: 'BONITO DE SANTA FE'
  },
  {
    stateKey: 'PB',
    value: 'BOQUEIRAO',
    label: 'BOQUEIRAO'
  },
  {
    stateKey: 'PB',
    value: 'BORBOREMA',
    label: 'BORBOREMA'
  },
  {
    stateKey: 'PB',
    value: 'BREJO DO CRUZ',
    label: 'BREJO DO CRUZ'
  },
  {
    stateKey: 'PB',
    value: 'BREJO DOS SANTOS',
    label: 'BREJO DOS SANTOS'
  },
  {
    stateKey: 'PB',
    value: 'CAAPORA',
    label: 'CAAPORA'
  },
  {
    stateKey: 'PB',
    value: 'CABACEIRAS',
    label: 'CABACEIRAS'
  },
  {
    stateKey: 'PB',
    value: 'CABEDELO',
    label: 'CABEDELO'
  },
  {
    stateKey: 'PB',
    value: 'CACHOEIRA DOS INDIOS',
    label: 'CACHOEIRA DOS INDIOS'
  },
  {
    stateKey: 'PB',
    value: 'CACIMBA DE AREIA',
    label: 'CACIMBA DE AREIA'
  },
  {
    stateKey: 'PB',
    value: 'CACIMBA DE DENTRO',
    label: 'CACIMBA DE DENTRO'
  },
  {
    stateKey: 'PB',
    value: 'CACIMBAS',
    label: 'CACIMBAS'
  },
  {
    stateKey: 'PB',
    value: 'CAICARA',
    label: 'CAICARA'
  },
  {
    stateKey: 'PB',
    value: 'CAJAZEIRAS',
    label: 'CAJAZEIRAS'
  },
  {
    stateKey: 'PB',
    value: 'CAJAZEIRINHA',
    label: 'CAJAZEIRINHA'
  },
  {
    stateKey: 'PB',
    value: 'CALDAS BRANDAO',
    label: 'CALDAS BRANDAO'
  },
  {
    stateKey: 'PB',
    value: 'CAMALAU',
    label: 'CAMALAU'
  },
  {
    stateKey: 'PB',
    value: 'CAMPINA GRANDE',
    label: 'CAMPINA GRANDE'
  },
  {
    stateKey: 'PB',
    value: 'CAPIM',
    label: 'CAPIM'
  },
  {
    stateKey: 'PB',
    value: 'CARAUBAS',
    label: 'CARAUBAS'
  },
  {
    stateKey: 'PB',
    value: 'CARRAPATEIRA',
    label: 'CARRAPATEIRA'
  },
  {
    stateKey: 'PB',
    value: 'CASSERENGUE',
    label: 'CASSERENGUE'
  },
  {
    stateKey: 'PB',
    value: 'CATINGUEIRA',
    label: 'CATINGUEIRA'
  },
  {
    stateKey: 'PB',
    value: 'CATOLE DO ROCHA',
    label: 'CATOLE DO ROCHA'
  },
  {
    stateKey: 'PB',
    value: 'CATURITE',
    label: 'CATURITE'
  },
  {
    stateKey: 'PB',
    value: 'CONCEICAO',
    label: 'CONCEICAO'
  },
  {
    stateKey: 'PB',
    value: 'CONDADO',
    label: 'CONDADO'
  },
  {
    stateKey: 'PB',
    value: 'CONDE',
    label: 'CONDE'
  },
  {
    stateKey: 'PB',
    value: 'CONGO',
    label: 'CONGO'
  },
  {
    stateKey: 'PB',
    value: 'COREMAS',
    label: 'COREMAS'
  },
  {
    stateKey: 'PB',
    value: 'COXIXOLA',
    label: 'COXIXOLA'
  },
  {
    stateKey: 'PB',
    value: 'CRUZ DO ESPIRITO SANTO',
    label: 'CRUZ DO ESPIRITO SANTO'
  },
  {
    stateKey: 'PB',
    value: 'CUBATI',
    label: 'CUBATI'
  },
  {
    stateKey: 'PB',
    value: 'CUITE',
    label: 'CUITE'
  },
  {
    stateKey: 'PB',
    value: 'CUITE DE MAMANGUAPE',
    label: 'CUITE DE MAMANGUAPE'
  },
  {
    stateKey: 'PB',
    value: 'CUITEGI',
    label: 'CUITEGI'
  },
  {
    stateKey: 'PB',
    value: 'CURRAL DE CIMA',
    label: 'CURRAL DE CIMA'
  },
  {
    stateKey: 'PB',
    value: 'CURRAL VELHO',
    label: 'CURRAL VELHO'
  },
  {
    stateKey: 'PB',
    value: 'DAMIAO',
    label: 'DAMIAO'
  },
  {
    stateKey: 'PB',
    value: 'DESTERRO',
    label: 'DESTERRO'
  },
  {
    stateKey: 'PB',
    value: 'DIAMANTE',
    label: 'DIAMANTE'
  },
  {
    stateKey: 'PB',
    value: 'DONA INES',
    label: 'DONA INES'
  },
  {
    stateKey: 'PB',
    value: 'DUAS ESTRADAS',
    label: 'DUAS ESTRADAS'
  },
  {
    stateKey: 'PB',
    value: 'EMAS',
    label: 'EMAS'
  },
  {
    stateKey: 'PB',
    value: 'ESPERANCA',
    label: 'ESPERANCA'
  },
  {
    stateKey: 'PB',
    value: 'FAGUNDES',
    label: 'FAGUNDES'
  },
  {
    stateKey: 'PB',
    value: 'FREI MARTINHO',
    label: 'FREI MARTINHO'
  },
  {
    stateKey: 'PB',
    value: 'GADO BRAVO',
    label: 'GADO BRAVO'
  },
  {
    stateKey: 'PB',
    value: 'GUARABIRA',
    label: 'GUARABIRA'
  },
  {
    stateKey: 'PB',
    value: 'GURINHEM',
    label: 'GURINHEM'
  },
  {
    stateKey: 'PB',
    value: 'GURJAO',
    label: 'GURJAO'
  },
  {
    stateKey: 'PB',
    value: 'IBIARA',
    label: 'IBIARA'
  },
  {
    stateKey: 'PB',
    value: 'IGARACY',
    label: 'IGARACY'
  },
  {
    stateKey: 'PB',
    value: 'IMACULADA',
    label: 'IMACULADA'
  },
  {
    stateKey: 'PB',
    value: 'INGA',
    label: 'INGA'
  },
  {
    stateKey: 'PB',
    value: 'ITABAIANA',
    label: 'ITABAIANA'
  },
  {
    stateKey: 'PB',
    value: 'ITAPORANGA',
    label: 'ITAPORANGA'
  },
  {
    stateKey: 'PB',
    value: 'ITAPOROROCA',
    label: 'ITAPOROROCA'
  },
  {
    stateKey: 'PB',
    value: 'ITATUBA',
    label: 'ITATUBA'
  },
  {
    stateKey: 'PB',
    value: 'JACARAU',
    label: 'JACARAU'
  },
  {
    stateKey: 'PB',
    value: 'JERICO',
    label: 'JERICO'
  },
  {
    stateKey: 'PB',
    value: 'JOAO PESSOA',
    label: 'JOAO PESSOA'
  },
  {
    stateKey: 'PB',
    value: 'JUAREZ TAVORA',
    label: 'JUAREZ TAVORA'
  },
  {
    stateKey: 'PB',
    value: 'JUAZEIRINHO',
    label: 'JUAZEIRINHO'
  },
  {
    stateKey: 'PB',
    value: 'JUNCO DO SERIDO',
    label: 'JUNCO DO SERIDO'
  },
  {
    stateKey: 'PB',
    value: 'JURIPIRANGA',
    label: 'JURIPIRANGA'
  },
  {
    stateKey: 'PB',
    value: 'JURU',
    label: 'JURU'
  },
  {
    stateKey: 'PB',
    value: 'LAGOA',
    label: 'LAGOA'
  },
  {
    stateKey: 'PB',
    value: 'LAGOA DE DENTRO',
    label: 'LAGOA DE DENTRO'
  },
  {
    stateKey: 'PB',
    value: 'LAGOA SECA',
    label: 'LAGOA SECA'
  },
  {
    stateKey: 'PB',
    value: 'LASTRO',
    label: 'LASTRO'
  },
  {
    stateKey: 'PB',
    value: 'LIVRAMENTO',
    label: 'LIVRAMENTO'
  },
  {
    stateKey: 'PB',
    value: 'LOGRADOURO',
    label: 'LOGRADOURO'
  },
  {
    stateKey: 'PB',
    value: 'LUCENA',
    label: 'LUCENA'
  },
  {
    stateKey: 'PB',
    value: "MAE D'AGUA",
    label: "MAE D'AGUA"
  },
  {
    stateKey: 'PB',
    value: 'MALTA',
    label: 'MALTA'
  },
  {
    stateKey: 'PB',
    value: 'MAMANGUAPE',
    label: 'MAMANGUAPE'
  },
  {
    stateKey: 'PB',
    value: 'MANAIRA',
    label: 'MANAIRA'
  },
  {
    stateKey: 'PB',
    value: 'MARCACAO',
    label: 'MARCACAO'
  },
  {
    stateKey: 'PB',
    value: 'MARI',
    label: 'MARI'
  },
  {
    stateKey: 'PB',
    value: 'MARIZOPOLIS',
    label: 'MARIZOPOLIS'
  },
  {
    stateKey: 'PB',
    value: 'MASSARANDUBA',
    label: 'MASSARANDUBA'
  },
  {
    stateKey: 'PB',
    value: 'MATARACA',
    label: 'MATARACA'
  },
  {
    stateKey: 'PB',
    value: 'MATINHAS',
    label: 'MATINHAS'
  },
  {
    stateKey: 'PB',
    value: 'MATO GROSSO',
    label: 'MATO GROSSO'
  },
  {
    stateKey: 'PB',
    value: 'MATUREIA',
    label: 'MATUREIA'
  },
  {
    stateKey: 'PB',
    value: 'MOGEIRO',
    label: 'MOGEIRO'
  },
  {
    stateKey: 'PB',
    value: 'MONTADAS',
    label: 'MONTADAS'
  },
  {
    stateKey: 'PB',
    value: 'MONTE HOREBE',
    label: 'MONTE HOREBE'
  },
  {
    stateKey: 'PB',
    value: 'MONTEIRO',
    label: 'MONTEIRO'
  },
  {
    stateKey: 'PB',
    value: 'MULUNGU',
    label: 'MULUNGU '
  },
  {
    stateKey: 'PB',
    value: 'NATUBA',
    label: 'NATUBA'
  },
  {
    stateKey: 'PB',
    value: 'NAZAREZINHO',
    label: 'NAZAREZINHO'
  },
  {
    stateKey: 'PB',
    value: 'NOVA FLORESTA',
    label: 'NOVA FLORESTA'
  },
  {
    stateKey: 'PB',
    value: 'NOVA OLINDA',
    label: 'NOVA OLINDA'
  },
  {
    stateKey: 'PB',
    value: 'NOVA PALMEIRA',
    label: 'NOVA PALMEIRA'
  },
  {
    stateKey: 'PB',
    value: "OLHO D'AGUA",
    label: "OLHO D'AGUA"
  },
  {
    stateKey: 'PB',
    value: 'OLIVEDOS',
    label: 'OLIVEDOS'
  },
  {
    stateKey: 'PB',
    value: 'OURO VELHO',
    label: 'OURO VELHO'
  },
  {
    stateKey: 'PB',
    value: 'PARARI',
    label: 'PARARI'
  },
  {
    stateKey: 'PB',
    value: 'PASSAGEM',
    label: 'PASSAGEM'
  },
  {
    stateKey: 'PB',
    value: 'PATOS',
    label: 'PATOS'
  },
  {
    stateKey: 'PB',
    value: 'PAULISTA',
    label: 'PAULISTA'
  },
  {
    stateKey: 'PB',
    value: 'PEDRA BRANCA',
    label: 'PEDRA BRANCA'
  },
  {
    stateKey: 'PB',
    value: 'PEDRA LAVRADA',
    label: 'PEDRA LAVRADA'
  },
  {
    stateKey: 'PB',
    value: 'PEDRAS DE FOGO',
    label: 'PEDRAS DE FOGO'
  },
  {
    stateKey: 'PB',
    value: 'PEDRO REGIO',
    label: 'PEDRO REGIO'
  },
  {
    stateKey: 'PB',
    value: 'PIANCO',
    label: 'PIANCO'
  },
  {
    stateKey: 'PB',
    value: 'PICUI',
    label: 'PICUI'
  },
  {
    stateKey: 'PB',
    value: 'PILAR',
    label: 'PILAR'
  },
  {
    stateKey: 'PB',
    value: 'PILOES',
    label: 'PILOES'
  },
  {
    stateKey: 'PB',
    value: 'PILOEZINHOS',
    label: 'PILOEZINHOS'
  },
  {
    stateKey: 'PB',
    value: 'PIRPIRITUBA',
    label: 'PIRPIRITUBA'
  },
  {
    stateKey: 'PB',
    value: 'PITIMBU',
    label: 'PITIMBU'
  },
  {
    stateKey: 'PB',
    value: 'POCINHOS',
    label: 'POCINHOS'
  },
  {
    stateKey: 'PB',
    value: 'POCO DANTAS',
    label: 'POCO DANTAS'
  },
  {
    stateKey: 'PB',
    value: 'POCO DE JOSE DE MOURA',
    label: 'POCO DE JOSE DE MOURA'
  },
  {
    stateKey: 'PB',
    value: 'POMBAL',
    label: 'POMBAL'
  },
  {
    stateKey: 'PB',
    value: 'PRATA',
    label: 'PRATA'
  },
  {
    stateKey: 'PB',
    value: 'PUXINANA',
    label: 'PUXINANA'
  },
  {
    stateKey: 'PB',
    value: 'QUEIMADAS',
    label: 'QUEIMADAS'
  },
  {
    stateKey: 'PB',
    value: 'QUIXABA',
    label: 'QUIXABA'
  },
  {
    stateKey: 'PB',
    value: 'REMIGIO',
    label: 'REMIGIO'
  },
  {
    stateKey: 'PB',
    value: 'RIACHAO',
    label: 'RIACHAO'
  },
  {
    stateKey: 'PB',
    value: 'RIACHAO DO POCO',
    label: 'RIACHAO DO POCO'
  },
  {
    stateKey: 'PB',
    value: 'RIACHO DE SANTO ANTONIO',
    label: 'RIACHO DE SANTO ANTONIO'
  },
  {
    stateKey: 'PB',
    value: 'RIACHO DOS CAVALOS',
    label: 'RIACHO DOS CAVALOS'
  },
  {
    stateKey: 'PB',
    value: 'RIO TINTO',
    label: 'RIO TINTO'
  },
  {
    stateKey: 'PB',
    value: 'SALGADINHO',
    label: 'SALGADINHO'
  },
  {
    stateKey: 'PB',
    value: 'SALGADO DE SAO FELIX',
    label: 'SALGADO DE SAO FELIX'
  },
  {
    stateKey: 'PB',
    value: 'SANTA CECILIA',
    label: 'SANTA CECILIA'
  },
  {
    stateKey: 'PB',
    value: 'SANTA CRUZ',
    label: 'SANTA CRUZ'
  },
  {
    stateKey: 'PB',
    value: 'SANTA HELENA',
    label: 'SANTA HELENA'
  },
  {
    stateKey: 'PB',
    value: 'SANTA INES',
    label: 'SANTA INES'
  },
  {
    stateKey: 'PB',
    value: 'SANTA LUZIA',
    label: 'SANTA LUZIA'
  },
  {
    stateKey: 'PB',
    value: 'SANTA RITA',
    label: 'SANTA RITA'
  },
  {
    stateKey: 'PB',
    value: 'SANTA TERESINHA',
    label: 'SANTA TERESINHA'
  },
  {
    stateKey: 'PB',
    value: 'SANTANA DE MANGUEIRA',
    label: 'SANTANA DE MANGUEIRA'
  },
  {
    stateKey: 'PB',
    value: 'SANTANA DOS GARROTES',
    label: 'SANTANA DOS GARROTES'
  },
  {
    stateKey: 'PB',
    value: 'JOCA CLAUDINO',
    label: 'JOCA CLAUDINO'
  },
  {
    stateKey: 'PB',
    value: 'SANTO ANDRE',
    label: 'SANTO ANDRE'
  },
  {
    stateKey: 'PB',
    value: 'SAO BENTO',
    label: 'SAO BENTO'
  },
  {
    stateKey: 'PB',
    value: 'SAO BENTO DE POMBAL',
    label: 'SAO BENTO DE POMBAL'
  },
  {
    stateKey: 'PB',
    value: 'SAO DOMINGOS DE POMBAL',
    label: 'SAO DOMINGOS DE POMBAL'
  },
  {
    stateKey: 'PB',
    value: 'SAO DOMINGOS DO CARIRI',
    label: 'SAO DOMINGOS DO CARIRI'
  },
  {
    stateKey: 'PB',
    value: 'SAO FRANCISCO',
    label: 'SAO FRANCISCO'
  },
  {
    stateKey: 'PB',
    value: 'SAO JOAO DO CARIRI',
    label: 'SAO JOAO DO CARIRI'
  },
  {
    stateKey: 'PB',
    value: 'SAO JOAO DO TIGRE',
    label: 'SAO JOAO DO TIGRE'
  },
  {
    stateKey: 'PB',
    value: 'SAO JOSE DA LAGOA TAPADA',
    label: 'SAO JOSE DA LAGOA TAPADA'
  },
  {
    stateKey: 'PB',
    value: 'SAO JOSE DE CAIANA',
    label: 'SAO JOSE DE CAIANA'
  },
  {
    stateKey: 'PB',
    value: 'SAO JOSE DE ESPINHARAS',
    label: 'SAO JOSE DE ESPINHARAS'
  },
  {
    stateKey: 'PB',
    value: 'SAO JOSE DE PIRANHAS',
    label: 'SAO JOSE DE PIRANHAS'
  },
  {
    stateKey: 'PB',
    value: 'SAO JOSE DE PRINCESA',
    label: 'SAO JOSE DE PRINCESA'
  },
  {
    stateKey: 'PB',
    value: 'SAO JOSE DO BONFIM',
    label: 'SAO JOSE DO BONFIM'
  },
  {
    stateKey: 'PB',
    value: 'SAO JOSE DO BREJO DO CRUZ',
    label: 'SAO JOSE DO BREJO DO CRUZ'
  },
  {
    stateKey: 'PB',
    value: 'SAO JOSE DO SABUGI',
    label: 'SAO JOSE DO SABUGI'
  },
  {
    stateKey: 'PB',
    value: 'SAO JOSE DOS CORDEIROS',
    label: 'SAO JOSE DOS CORDEIROS'
  },
  {
    stateKey: 'PB',
    value: 'SAO JOSE DOS RAMOS',
    label: 'SAO JOSE DOS RAMOS'
  },
  {
    stateKey: 'PB',
    value: 'SAO MAMEDE',
    label: 'SAO MAMEDE'
  },
  {
    stateKey: 'PB',
    value: 'SAO MIGUEL DE TAIPU',
    label: 'SAO MIGUEL DE TAIPU'
  },
  {
    stateKey: 'PB',
    value: 'SAO SEBASTIAO LAGOA DE ROC',
    label: 'SAO SEBASTIAO LAGOA DE ROC'
  },
  {
    stateKey: 'PB',
    value: 'SAO SEBASTIAO DO UMBUZEIRO',
    label: 'SAO SEBASTIAO DO UMBUZEIRO'
  },
  {
    stateKey: 'PB',
    value: 'SAPE',
    label: 'SAPE'
  },
  {
    stateKey: 'PB',
    value: 'SAO VICENTE DO SERIDO',
    label: 'SAO VICENTE DO SERIDO'
  },
  {
    stateKey: 'PB',
    value: 'SERRA BRANCA',
    label: 'SERRA BRANCA'
  },
  {
    stateKey: 'PB',
    value: 'SERRA DA RAIZ',
    label: 'SERRA DA RAIZ'
  },
  {
    stateKey: 'PB',
    value: 'SERRA GRANDE',
    label: 'SERRA GRANDE'
  },
  {
    stateKey: 'PB',
    value: 'SERRA REDONDA',
    label: 'SERRA REDONDA'
  },
  {
    stateKey: 'PB',
    value: 'SERRARIA',
    label: 'SERRARIA'
  },
  {
    stateKey: 'PB',
    value: 'SERTAOZINHO',
    label: 'SERTAOZINHO'
  },
  {
    stateKey: 'PB',
    value: 'SOBRADO',
    label: 'SOBRADO'
  },
  {
    stateKey: 'PB',
    value: 'SOLANEA',
    label: 'SOLANEA'
  },
  {
    stateKey: 'PB',
    value: 'SOLEDADE',
    label: 'SOLEDADE'
  },
  {
    stateKey: 'PB',
    value: 'SOSSEGO',
    label: 'SOSSEGO'
  },
  {
    stateKey: 'PB',
    value: 'SOUSA',
    label: 'SOUSA'
  },
  {
    stateKey: 'PB',
    value: 'SUME',
    label: 'SUME'
  },
  {
    stateKey: 'PB',
    value: 'TACIMA',
    label: 'TACIMA'
  },
  {
    stateKey: 'PB',
    value: 'TAPEROA',
    label: 'TAPEROA'
  },
  {
    stateKey: 'PB',
    value: 'TAVARES',
    label: 'TAVARES'
  },
  {
    stateKey: 'PB',
    value: 'TEIXEIRA',
    label: 'TEIXEIRA'
  },
  {
    stateKey: 'PB',
    value: 'TENORIO',
    label: 'TENORIO'
  },
  {
    stateKey: 'PB',
    value: 'TRIUNFO',
    label: 'TRIUNFO'
  },
  {
    stateKey: 'PB',
    value: 'UIRAUNA',
    label: 'UIRAUNA'
  },
  {
    stateKey: 'PB',
    value: 'UMBUZEIRO',
    label: 'UMBUZEIRO'
  },
  {
    stateKey: 'PB',
    value: 'VARZEA',
    label: 'VARZEA'
  },
  {
    stateKey: 'PB',
    value: 'VIEIROPOLIS',
    label: 'VIEIROPOLIS'
  },
  {
    stateKey: 'PB',
    value: 'VISTA SERRANA',
    label: 'VISTA SERRANA'
  },
  {
    stateKey: 'PB',
    value: 'ZABELE',
    label: 'ZABELE'
  },
  {
    stateKey: 'PB',
    value: 'BARRA DO CAMARATUBA',
    label: 'BARRA DO CAMARATUBA'
  },
  {
    stateKey: 'PB',
    value: 'CASINHA DO HOMEM',
    label: 'CASINHA DO HOMEM'
  },
  {
    stateKey: 'PB',
    value: 'CORONEL MAIA',
    label: 'CORONEL MAIA'
  },
  {
    stateKey: 'PB',
    value: 'CUPISSURA',
    label: 'CUPISSURA'
  },
  {
    stateKey: 'PB',
    value: 'ENGENHEIRO AVIDOS',
    label: 'ENGENHEIRO AVIDOS'
  },
  {
    stateKey: 'PB',
    value: 'MATA LIMPA',
    label: 'MATA LIMPA'
  },
  {
    stateKey: 'PB',
    value: 'PELO SINAL',
    label: 'PELO SINAL'
  },
  {
    stateKey: 'PB',
    value: 'SERIDO',
    label: 'SERIDO'
  },
  {
    stateKey: 'PB',
    value: 'VARZEA COMPRIDA',
    label: 'VARZEA COMPRIDA'
  },
  {
    stateKey: 'PB',
    value: 'AGUA BRANCA',
    label: 'AGUA BRANCA'
  },
  {
    stateKey: 'PB',
    value: 'BARRA DE SAO MIGUEL',
    label: 'BARRA DE SAO MIGUEL'
  },
  {
    stateKey: 'PB',
    value: 'BELEM',
    label: 'BELEM'
  },
  {
    stateKey: 'PB',
    value: 'BOQUEIRAO DOS COCHOS',
    label: 'BOQUEIRAO DOS COCHOS'
  },
  {
    stateKey: 'PB',
    value: 'DESTERRO DE MALTA',
    label: 'DESTERRO DE MALTA'
  },
  {
    stateKey: 'PR',
    value: 'a',
    label: 'Formosa do Oeste'
  },
  {
    stateKey: 'PR',
    value: 'Nova Prata do Iguaçu',
    label: 'Nova Prata do Iguaçu'
  },
  {
    stateKey: 'PR',
    value: 'SANTA CRUZ DE MONTE CASTELO',
    label: 'SANTA CRUZ DE MONTE CASTELO'
  },
  {
    stateKey: 'PR',
    value: 'Novo Itacolomi',
    label: 'Novo Itacolomi'
  },
  {
    stateKey: 'PR',
    value: 'Santa Izabel do Oeste',
    label: 'Santa Izabel do Oeste'
  },
  {
    stateKey: 'PR',
    value: 'Doutor Ulysses',
    label: 'Doutor Ulysses'
  },
  {
    stateKey: 'PR',
    value: 'TOMAZINA',
    label: 'TOMAZINA'
  },
  {
    stateKey: 'PR',
    value: 'BOA ESPERANÇA',
    label: 'BOA ESPERANÇA'
  },
  {
    stateKey: 'PR',
    value: 'ABATIA',
    label: 'ABATIA'
  },
  {
    stateKey: 'PR',
    value: 'ADRIANOPOLIS',
    label: 'ADRIANOPOLIS'
  },
  {
    stateKey: 'PR',
    value: 'AGUDOS DO SUL',
    label: 'AGUDOS DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'ALMIRANTE TAMANDARE',
    label: 'ALMIRANTE TAMANDARE'
  },
  {
    stateKey: 'PR',
    value: 'ALTAMIRA DO PARANA',
    label: 'ALTAMIRA DO PARANA'
  },
  {
    stateKey: 'PR',
    value: 'ALTO PARANA',
    label: 'ALTO PARANA'
  },
  {
    stateKey: 'PR',
    value: 'ALTO PIQUIRI',
    label: 'ALTO PIQUIRI'
  },
  {
    stateKey: 'PR',
    value: 'ALTONIA',
    label: 'ALTONIA'
  },
  {
    stateKey: 'PR',
    value: 'ALVORADA DO SUL',
    label: 'ALVORADA DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'AMAPORA',
    label: 'AMAPORA'
  },
  {
    stateKey: 'PR',
    value: 'AMPERE',
    label: 'AMPERE'
  },
  {
    stateKey: 'PR',
    value: 'ANAHY',
    label: 'ANAHY'
  },
  {
    stateKey: 'PR',
    value: 'ANDIRA',
    label: 'ANDIRA'
  },
  {
    stateKey: 'PR',
    value: 'ANGULO',
    label: 'ANGULO'
  },
  {
    stateKey: 'PR',
    value: 'ANTONINA',
    label: 'ANTONINA'
  },
  {
    stateKey: 'PR',
    value: 'ANTONIO OLINTO',
    label: 'ANTONIO OLINTO'
  },
  {
    stateKey: 'PR',
    value: 'APUCARANA',
    label: 'APUCARANA'
  },
  {
    stateKey: 'PR',
    value: 'ARAPONGAS',
    label: 'ARAPONGAS'
  },
  {
    stateKey: 'PR',
    value: 'ARAPOTI',
    label: 'ARAPOTI'
  },
  {
    stateKey: 'PR',
    value: 'ARAPUA',
    label: 'ARAPUA'
  },
  {
    stateKey: 'PR',
    value: 'ARARUNA',
    label: 'ARARUNA'
  },
  {
    stateKey: 'PR',
    value: 'ARAUCARIA',
    label: 'ARAUCARIA'
  },
  {
    stateKey: 'PR',
    value: 'ARIRANHA DO IVAI',
    label: 'ARIRANHA DO IVAI'
  },
  {
    stateKey: 'PR',
    value: 'ASSAI',
    label: 'ASSAI'
  },
  {
    stateKey: 'PR',
    value: 'ASSIS CHATEAUBRIAND',
    label: 'ASSIS CHATEAUBRIAND'
  },
  {
    stateKey: 'PR',
    value: 'ASTORGA',
    label: 'ASTORGA'
  },
  {
    stateKey: 'PR',
    value: 'BALSA NOVA',
    label: 'BALSA NOVA'
  },
  {
    stateKey: 'PR',
    value: 'BANDEIRANTES',
    label: 'BANDEIRANTES'
  },
  {
    stateKey: 'PR',
    value: 'BARBOSA FERRAZ',
    label: 'BARBOSA FERRAZ'
  },
  {
    stateKey: 'PR',
    value: 'BARRA DO JACARE',
    label: 'BARRA DO JACARE'
  },
  {
    stateKey: 'PR',
    value: 'BARRACAO',
    label: 'BARRACAO'
  },
  {
    stateKey: 'PR',
    value: 'BELA VISTA DA CAROBA',
    label: 'BELA VISTA DA CAROBA'
  },
  {
    stateKey: 'PR',
    value: 'BELA VISTA DO PARAISO',
    label: 'BELA VISTA DO PARAISO'
  },
  {
    stateKey: 'PR',
    value: 'BITURUNA',
    label: 'BITURUNA '
  },
  {
    stateKey: 'PR',
    value: 'BOA ESPERANCA DO IGUAÇU',
    label: 'BOA ESPERANCA DO IGUAÇU'
  },
  {
    stateKey: 'PR',
    value: 'BOA VENTURA DE SAO ROQUE',
    label: 'BOA VENTURA DE SAO ROQUE'
  },
  {
    stateKey: 'PR',
    value: 'BOA VISTA DA APARECIDA',
    label: 'BOA VISTA DA APARECIDA'
  },
  {
    stateKey: 'PR',
    value: 'BOCAIUVA DO SUL',
    label: 'BOCAIUVA DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'BOM JESUS DO SUL',
    label: 'BOM JESUS DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'BOM SUCESSO',
    label: 'BOM SUCESSO'
  },
  {
    stateKey: 'PR',
    value: 'BOM SUCESSO DO SUL',
    label: 'BOM SUCESSO DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'BORRAZOPOLIS',
    label: 'BORRAZOPOLIS'
  },
  {
    stateKey: 'PR',
    value: 'BRAGANEY',
    label: 'BRAGANEY'
  },
  {
    stateKey: 'PR',
    value: 'BRASILANDIA DO SUL',
    label: 'BRASILANDIA DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'CAFEARA',
    label: 'CAFEARA'
  },
  {
    stateKey: 'PR',
    value: 'CAFELANDIA',
    label: 'CAFELANDIA'
  },
  {
    stateKey: 'PR',
    value: 'CAFEZAL DO SUL',
    label: 'CAFEZAL DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'CALIFORNIA',
    label: 'CALIFORNIA'
  },
  {
    stateKey: 'PR',
    value: 'CAMBARA',
    label: 'CAMBARA'
  },
  {
    stateKey: 'PR',
    value: 'CAMBE',
    label: 'CAMBE'
  },
  {
    stateKey: 'PR',
    value: 'CAMBIRA',
    label: 'CAMBIRA'
  },
  {
    stateKey: 'PR',
    value: 'CAMPINA DA LAGOA',
    label: 'CAMPINA DA LAGOA'
  },
  {
    stateKey: 'PR',
    value: 'CAMPINA DO SIMAO',
    label: 'CAMPINA DO SIMAO'
  },
  {
    stateKey: 'PR',
    value: 'CAMPINA GRANDE DO SUL',
    label: 'CAMPINA GRANDE DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'CAMPO BONITO',
    label: 'CAMPO BONITO'
  },
  {
    stateKey: 'PR',
    value: 'CAMPO DO TENENTE',
    label: 'CAMPO DO TENENTE'
  },
  {
    stateKey: 'PR',
    value: 'CAMPO LARGO',
    label: 'CAMPO LARGO'
  },
  {
    stateKey: 'PR',
    value: 'CAMPO MAGRO',
    label: 'CAMPO MAGRO'
  },
  {
    stateKey: 'PR',
    value: 'CAMPO MOURAO',
    label: 'CAMPO MOURAO'
  },
  {
    stateKey: 'PR',
    value: 'CANDIDO DE ABREU',
    label: 'CANDIDO DE ABREU'
  },
  {
    stateKey: 'PR',
    value: 'CANDOI',
    label: 'CANDOI'
  },
  {
    stateKey: 'PR',
    value: 'CANTAGALO',
    label: 'CANTAGALO'
  },
  {
    stateKey: 'PR',
    value: 'CAPANEMA',
    label: 'CAPANEMA'
  },
  {
    stateKey: 'PR',
    value: 'CAPITAO LEONIDAS MARQUES',
    label: 'CAPITAO LEONIDAS MARQUES'
  },
  {
    stateKey: 'PR',
    value: 'CARAMBEI',
    label: 'CARAMBEI'
  },
  {
    stateKey: 'PR',
    value: 'CARLOPOLIS',
    label: 'CARLOPOLIS'
  },
  {
    stateKey: 'PR',
    value: 'CASCAVEL',
    label: 'CASCAVEL'
  },
  {
    stateKey: 'PR',
    value: 'CASTRO',
    label: 'CASTRO'
  },
  {
    stateKey: 'PR',
    value: 'CATANDUVAS',
    label: 'CATANDUVAS'
  },
  {
    stateKey: 'PR',
    value: 'CENTENARIO DO SUL',
    label: 'CENTENARIO DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'CERRO AZUL',
    label: 'CERRO AZUL'
  },
  {
    stateKey: 'PR',
    value: 'CEU AZUL',
    label: 'CEU AZUL'
  },
  {
    stateKey: 'PR',
    value: 'CHOPINZINHO',
    label: 'CHOPINZINHO'
  },
  {
    stateKey: 'PR',
    value: 'CIANORTE',
    label: 'CIANORTE'
  },
  {
    stateKey: 'PR',
    value: 'CIDADE GAUCHA',
    label: 'CIDADE GAUCHA'
  },
  {
    stateKey: 'PR',
    value: 'CLEVELANDIA',
    label: 'CLEVELANDIA'
  },
  {
    stateKey: 'PR',
    value: 'COLOMBO',
    label: 'COLOMBO'
  },
  {
    stateKey: 'PR',
    value: 'COLORADO',
    label: 'COLORADO'
  },
  {
    stateKey: 'PR',
    value: 'CONGONHINHAS',
    label: 'CONGONHINHAS'
  },
  {
    stateKey: 'PR',
    value: 'CONSELHEIRO MAIRINK',
    label: 'CONSELHEIRO MAIRINK'
  },
  {
    stateKey: 'PR',
    value: 'CONTENDA',
    label: 'CONTENDA'
  },
  {
    stateKey: 'PR',
    value: 'CORBELIA',
    label: 'CORBELIA'
  },
  {
    stateKey: 'PR',
    value: 'CORNELIO PROCOPIO',
    label: 'CORNELIO PROCOPIO'
  },
  {
    stateKey: 'PR',
    value: 'CORONEL DOMINGOS SOARES',
    label: 'CORONEL DOMINGOS SOARES'
  },
  {
    stateKey: 'PR',
    value: 'CORONEL VIVIDA',
    label: 'CORONEL VIVIDA'
  },
  {
    stateKey: 'PR',
    value: 'CORUMBATAI DO SUL',
    label: 'CORUMBATAI DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'CRUZ MACHADO',
    label: 'CRUZ MACHADO'
  },
  {
    stateKey: 'PR',
    value: 'CRUZEIRO DO IGUACU',
    label: 'CRUZEIRO DO IGUACU'
  },
  {
    stateKey: 'PR',
    value: 'CRUZEIRO DO OESTE',
    label: 'CRUZEIRO DO OESTE'
  },
  {
    stateKey: 'PR',
    value: 'CRUZMALTINA',
    label: 'CRUZMALTINA'
  },
  {
    stateKey: 'PR',
    value: 'CURITIBA',
    label: 'CURITIBA'
  },
  {
    stateKey: 'PR',
    value: 'CURIUVA',
    label: 'CURIUVA'
  },
  {
    stateKey: 'PR',
    value: "DIAMANTE D'OESTE",
    label: "DIAMANTE D'OESTE"
  },
  {
    stateKey: 'PR',
    value: 'DIAMANTE DO NORTE',
    label: 'DIAMANTE DO NORTE'
  },
  {
    stateKey: 'PR',
    value: 'DIAMANTE DO SUL',
    label: 'DIAMANTE DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'DOIS VIZINHOS',
    label: 'DOIS VIZINHOS'
  },
  {
    stateKey: 'PR',
    value: 'DOURADINA',
    label: 'DOURADINA'
  },
  {
    stateKey: 'PR',
    value: 'DOUTOR CAMARGO',
    label: 'DOUTOR CAMARGO'
  },
  {
    stateKey: 'PR',
    value: 'ENEAS MARQUES',
    label: 'ENEAS MARQUES'
  },
  {
    stateKey: 'PR',
    value: 'ENGENHEIRO BELTRAO',
    label: 'ENGENHEIRO BELTRAO'
  },
  {
    stateKey: 'PR',
    value: 'ENTRE RIOS DO OESTE',
    label: 'ENTRE RIOS DO OESTE'
  },
  {
    stateKey: 'PR',
    value: 'ESPERANCA NOVA',
    label: 'ESPERANCA NOVA'
  },
  {
    stateKey: 'PR',
    value: 'ESPIGAO ALTO DO IGUACU',
    label: 'ESPIGAO ALTO DO IGUACU'
  },
  {
    stateKey: 'PR',
    value: 'FAROL',
    label: 'FAROL'
  },
  {
    stateKey: 'PR',
    value: 'FAXINAL',
    label: 'FAXINAL'
  },
  {
    stateKey: 'PR',
    value: 'FAZENDA RIO GRANDE',
    label: 'FAZENDA RIO GRANDE'
  },
  {
    stateKey: 'PR',
    value: 'FENIX',
    label: 'FENIX'
  },
  {
    stateKey: 'PR',
    value: 'FERNANDES PINHEIRO',
    label: 'FERNANDES PINHEIRO'
  },
  {
    stateKey: 'PR',
    value: 'FIGUEIRA',
    label: 'FIGUEIRA'
  },
  {
    stateKey: 'PR',
    value: 'FLOR DA SERRA DO SUL',
    label: 'FLOR DA SERRA DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'FLORAI',
    label: 'FLORAI'
  },
  {
    stateKey: 'PR',
    value: 'FLORESTA',
    label: 'FLORESTA'
  },
  {
    stateKey: 'PR',
    value: 'FLORESTOPOLIS',
    label: 'FLORESTOPOLIS'
  },
  {
    stateKey: 'PR',
    value: 'FLORIDA',
    label: 'FLORIDA'
  },
  {
    stateKey: 'PR',
    value: 'FOZ DO IGUACU',
    label: 'FOZ DO IGUACU'
  },
  {
    stateKey: 'PR',
    value: 'FOZ DO JORDAO',
    label: 'FOZ DO JORDAO'
  },
  {
    stateKey: 'PR',
    value: 'FRANCISCO ALVES',
    label: 'FRANCISCO ALVES'
  },
  {
    stateKey: 'PR',
    value: 'FRANCISCO BELTRAO',
    label: 'FRANCISCO BELTRAO'
  },
  {
    stateKey: 'PR',
    value: 'GENERAL CARNEIRO',
    label: 'GENERAL CARNEIRO'
  },
  {
    stateKey: 'PR',
    value: 'GODOY MOREIRA',
    label: 'GODOY MOREIRA'
  },
  {
    stateKey: 'PR',
    value: 'GOIOERE',
    label: 'GOIOERE'
  },
  {
    stateKey: 'PR',
    value: 'GOIOXIM',
    label: 'GOIOXIM'
  },
  {
    stateKey: 'PR',
    value: 'GRANDES RIOS',
    label: 'GRANDES RIOS'
  },
  {
    stateKey: 'PR',
    value: 'GUAIRA',
    label: 'GUAIRA'
  },
  {
    stateKey: 'PR',
    value: 'GUAIRACA',
    label: 'GUAIRACA'
  },
  {
    stateKey: 'PR',
    value: 'GUAMIRANGA',
    label: 'GUAMIRANGA'
  },
  {
    stateKey: 'PR',
    value: 'GUAPIRAMA',
    label: 'GUAPIRAMA'
  },
  {
    stateKey: 'PR',
    value: 'GUAPOREMA',
    label: 'GUAPOREMA'
  },
  {
    stateKey: 'PR',
    value: 'GUARACI',
    label: 'GUARACI'
  },
  {
    stateKey: 'PR',
    value: 'GUARANIACU',
    label: 'GUARANIACU'
  },
  {
    stateKey: 'PR',
    value: 'GUARAPUAVA',
    label: 'GUARAPUAVA'
  },
  {
    stateKey: 'PR',
    value: 'GUARAQUECABA',
    label: 'GUARAQUECABA'
  },
  {
    stateKey: 'PR',
    value: 'GUARATUBA',
    label: 'GUARATUBA'
  },
  {
    stateKey: 'PR',
    value: 'HONORIO SERPA',
    label: 'HONORIO SERPA'
  },
  {
    stateKey: 'PR',
    value: 'IBAITI',
    label: 'IBAITI'
  },
  {
    stateKey: 'PR',
    value: 'IBEMA',
    label: 'IBEMA'
  },
  {
    stateKey: 'PR',
    value: 'IBIPORA',
    label: 'IBIPORA'
  },
  {
    stateKey: 'PR',
    value: 'ICARAIMA',
    label: 'ICARAIMA'
  },
  {
    stateKey: 'PR',
    value: 'IGUARACU',
    label: 'IGUARACU'
  },
  {
    stateKey: 'PR',
    value: 'IGUATU',
    label: 'IGUATU'
  },
  {
    stateKey: 'PR',
    value: 'IMBAU',
    label: 'IMBAU'
  },
  {
    stateKey: 'PR',
    value: 'IMBITUVA',
    label: 'IMBITUVA'
  },
  {
    stateKey: 'PR',
    value: 'INACIO MARTINS',
    label: 'INACIO MARTINS'
  },
  {
    stateKey: 'PR',
    value: 'INAJA',
    label: 'INAJA'
  },
  {
    stateKey: 'PR',
    value: 'INDIANOPOLIS',
    label: 'INDIANOPOLIS'
  },
  {
    stateKey: 'PR',
    value: 'IPIRANGA',
    label: 'IPIRANGA'
  },
  {
    stateKey: 'PR',
    value: 'IPORA',
    label: 'IPORA'
  },
  {
    stateKey: 'PR',
    value: 'IRACEMA DO OESTE',
    label: 'IRACEMA DO OESTE'
  },
  {
    stateKey: 'PR',
    value: 'IRATI',
    label: 'IRATI'
  },
  {
    stateKey: 'PR',
    value: 'IRETAMA',
    label: 'IRETAMA'
  },
  {
    stateKey: 'PR',
    value: 'ITAGUAJE',
    label: 'ITAGUAJE'
  },
  {
    stateKey: 'PR',
    value: 'ITAIPULANDIA',
    label: 'ITAIPULANDIA'
  },
  {
    stateKey: 'PR',
    value: 'ITAMBARACA',
    label: 'ITAMBARACA'
  },
  {
    stateKey: 'PR',
    value: 'ITAMBE',
    label: 'ITAMBE'
  },
  {
    stateKey: 'PR',
    value: "ITAPEJARA D'OESTE",
    label: "ITAPEJARA D'OESTE"
  },
  {
    stateKey: 'PR',
    value: 'ITAPERUCU',
    label: 'ITAPERUCU'
  },
  {
    stateKey: 'PR',
    value: 'ITAUNA DO SUL',
    label: 'ITAUNA DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'IVAI',
    label: 'IVAI'
  },
  {
    stateKey: 'PR',
    value: 'IVAIPORA',
    label: 'IVAIPORA'
  },
  {
    stateKey: 'PR',
    value: 'IVATE',
    label: 'IVATE'
  },
  {
    stateKey: 'PR',
    value: 'IVATUBA',
    label: 'IVATUBA'
  },
  {
    stateKey: 'PR',
    value: 'JABOTI',
    label: 'JABOTI '
  },
  {
    stateKey: 'PR',
    value: 'JACAREZINHO',
    label: 'JACAREZINHO'
  },
  {
    stateKey: 'PR',
    value: 'JAGUAPITA',
    label: 'JAGUAPITA'
  },
  {
    stateKey: 'PR',
    value: 'JAGUARIAIVA',
    label: 'JAGUARIAIVA'
  },
  {
    stateKey: 'PR',
    value: 'JANDAIA DO SUL',
    label: 'JANDAIA DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'JANIOPOLIS',
    label: 'JANIOPOLIS'
  },
  {
    stateKey: 'PR',
    value: 'JAPIRA',
    label: 'JAPIRA'
  },
  {
    stateKey: 'PR',
    value: 'JAPURA',
    label: 'JAPURA'
  },
  {
    stateKey: 'PR',
    value: 'JARDIM ALEGRE',
    label: 'JARDIM ALEGRE'
  },
  {
    stateKey: 'PR',
    value: 'JARDIM OLINDA',
    label: 'JARDIM OLINDA'
  },
  {
    stateKey: 'PR',
    value: 'JATAIZINHO',
    label: 'JATAIZINHO'
  },
  {
    stateKey: 'PR',
    value: 'JESUITAS',
    label: 'JESUITAS'
  },
  {
    stateKey: 'PR',
    value: 'JOAQUIM TAVORA',
    label: 'JOAQUIM TAVORA'
  },
  {
    stateKey: 'PR',
    value: 'JUNDIAI DO SUL',
    label: 'JUNDIAI DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'JURANDA',
    label: 'JURANDA'
  },
  {
    stateKey: 'PR',
    value: 'JUSSARA',
    label: 'JUSSARA'
  },
  {
    stateKey: 'PR',
    value: 'KALORE',
    label: 'KALORE'
  },
  {
    stateKey: 'PR',
    value: 'LAPA',
    label: 'LAPA'
  },
  {
    stateKey: 'PR',
    value: 'LARANJAL',
    label: 'LARANJAL'
  },
  {
    stateKey: 'PR',
    value: 'LARANJEIRAS DO SUL',
    label: 'LARANJEIRAS DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'LEOPOLIS',
    label: 'LEOPOLIS'
  },
  {
    stateKey: 'PR',
    value: 'LIDIANOPOLIS',
    label: 'LIDIANOPOLIS'
  },
  {
    stateKey: 'PR',
    value: 'LINDOESTE',
    label: 'LINDOESTE'
  },
  {
    stateKey: 'PR',
    value: 'LOANDA',
    label: 'LOANDA'
  },
  {
    stateKey: 'PR',
    value: 'LOBATO',
    label: 'LOBATO'
  },
  {
    stateKey: 'PR',
    value: 'LONDRINA',
    label: 'LONDRINA'
  },
  {
    stateKey: 'PR',
    value: 'LUIZIANA ',
    label: 'LUIZIANA'
  },
  {
    stateKey: 'PR',
    value: 'LUNARDELLI',
    label: 'LUNARDELLI'
  },
  {
    stateKey: 'PR',
    value: 'LUPIONOPOLIS',
    label: 'LUPIONOPOLIS'
  },
  {
    stateKey: 'PR',
    value: 'MALLET',
    label: 'MALLET'
  },
  {
    stateKey: 'PR',
    value: 'MAMBORE',
    label: 'MAMBORE'
  },
  {
    stateKey: 'PR',
    value: 'MANDAGUACU',
    label: 'MANDAGUACU'
  },
  {
    stateKey: 'PR',
    value: 'MANDAGUARI',
    label: 'MANDAGUARI'
  },
  {
    stateKey: 'PR',
    value: 'MANDIRITUBA',
    label: 'MANDIRITUBA'
  },
  {
    stateKey: 'PR',
    value: 'MANFRINOPOLIS',
    label: 'MANFRINOPOLIS'
  },
  {
    stateKey: 'PR',
    value: 'MANGUEIRINHA',
    label: 'MANGUEIRINHA'
  },
  {
    stateKey: 'PR',
    value: 'MARECHAL CANDIDO RONDON',
    label: 'MARECHAL CANDIDO RONDON'
  },
  {
    stateKey: 'PR',
    value: 'MARIA HELENA',
    label: 'MARIA HELENA'
  },
  {
    stateKey: 'PR',
    value: 'MARIALVA',
    label: 'MARIALVA'
  },
  {
    stateKey: 'PR',
    value: 'MARILANDIA DO SUL',
    label: 'MARILANDIA DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'MARILENA',
    label: 'MARILENA'
  },
  {
    stateKey: 'PR',
    value: 'MARILUZ',
    label: 'MARILUZ'
  },
  {
    stateKey: 'PR',
    value: 'MARINGA',
    label: 'MARINGA'
  },
  {
    stateKey: 'PR',
    value: 'MARIOPOLIS',
    label: 'MARIOPOLIS'
  },
  {
    stateKey: 'PR',
    value: 'MARIPA',
    label: 'MARIPA'
  },
  {
    stateKey: 'PR',
    value: 'MARMELEIRO',
    label: 'MARMELEIRO'
  },
  {
    stateKey: 'PR',
    value: 'MARQUINHO',
    label: 'MARQUINHO'
  },
  {
    stateKey: 'PR',
    value: 'MARUMBI',
    label: 'MARUMBI'
  },
  {
    stateKey: 'PR',
    value: 'MATELANDIA',
    label: 'MATELANDIA'
  },
  {
    stateKey: 'PR',
    value: 'MATINHOS',
    label: 'MATINHOS'
  },
  {
    stateKey: 'PR',
    value: 'MATO RICO',
    label: 'MATO RICO'
  },
  {
    stateKey: 'PR',
    value: 'MAUA DA SERRA',
    label: 'MAUA DA SERRA'
  },
  {
    stateKey: 'PR',
    value: 'MEDIANEIRA',
    label: 'MEDIANEIRA'
  },
  {
    stateKey: 'PR',
    value: 'MERCEDES',
    label: 'MERCEDES'
  },
  {
    stateKey: 'PR',
    value: 'MIRADOR',
    label: 'MIRADOR'
  },
  {
    stateKey: 'PR',
    value: 'MIRASELVA',
    label: 'MIRASELVA'
  },
  {
    stateKey: 'PR',
    value: 'MISSAL',
    label: 'MISSAL'
  },
  {
    stateKey: 'PR',
    value: 'MOREIRA SALES',
    label: 'MOREIRA SALES'
  },
  {
    stateKey: 'PR',
    value: 'MORRETES',
    label: 'MORRETES'
  },
  {
    stateKey: 'PR',
    value: 'MUNHOZ DE MELO',
    label: 'MUNHOZ DE MELO'
  },
  {
    stateKey: 'PR',
    value: 'NOSSA SENHORA DAS GRACAS',
    label: 'NOSSA SENHORA DAS GRACAS'
  },
  {
    stateKey: 'PR',
    value: 'NOVA ALIANCA DO IVAI',
    label: 'NOVA ALIANCA DO IVAI'
  },
  {
    stateKey: 'PR',
    value: 'NOVA AMERICA DA COLINA',
    label: 'NOVA AMERICA DA COLINA'
  },
  {
    stateKey: 'PR',
    value: 'NOVA AURORA',
    label: 'NOVA AURORA'
  },
  {
    stateKey: 'PR',
    value: 'NOVA CANTU',
    label: 'NOVA CANTU'
  },
  {
    stateKey: 'PR',
    value: 'NOVA ESPERANCA',
    label: 'NOVA ESPERANCA'
  },
  {
    stateKey: 'PR',
    value: 'NOVA ESPERANCA DO SUDOESTE',
    label: 'NOVA ESPERANCA DO SUDOESTE'
  },
  {
    stateKey: 'PR',
    value: 'NOVA FATIMA',
    label: 'NOVA FATIMA'
  },
  {
    stateKey: 'PR',
    value: 'NOVA LARANJEIRAS',
    label: 'NOVA LARANJEIRAS'
  },
  {
    stateKey: 'PR',
    value: 'NOVA LONDRINA',
    label: 'NOVA LONDRINA'
  },
  {
    stateKey: 'PR',
    value: 'NOVA OLIMPIA',
    label: 'NOVA OLIMPIA'
  },
  {
    stateKey: 'PR',
    value: 'NOVA SANTA BARBARA',
    label: 'NOVA SANTA BARBARA'
  },
  {
    stateKey: 'PR',
    value: 'NOVA SANTA ROSA',
    label: 'NOVA SANTA ROSA'
  },
  {
    stateKey: 'PR',
    value: 'NOVA TEBAS',
    label: 'NOVA TEBAS'
  },
  {
    stateKey: 'PR',
    value: 'ORTIGUEIRA',
    label: 'ORTIGUEIRA'
  },
  {
    stateKey: 'PR',
    value: 'OURIZONA',
    label: 'OURIZONA'
  },
  {
    stateKey: 'PR',
    value: 'OURO VERDE DO OESTE',
    label: 'OURO VERDE DO OESTE'
  },
  {
    stateKey: 'PR',
    value: 'PAICANDU',
    label: 'PAICANDU'
  },
  {
    stateKey: 'PR',
    value: 'PALMAS',
    label: 'PALMAS'
  },
  {
    stateKey: 'PR',
    value: 'PALMEIRA',
    label: 'PALMEIRA'
  },
  {
    stateKey: 'PR',
    value: 'PALMITAL',
    label: 'PALMITAL'
  },
  {
    stateKey: 'PR',
    value: 'PALOTINA',
    label: 'PALOTINA'
  },
  {
    stateKey: 'PR',
    value: 'PARAISO DO NORTE',
    label: 'PARAISO DO NORTE'
  },
  {
    stateKey: 'PR',
    value: 'PARANACITY',
    label: 'PARANACITY'
  },
  {
    stateKey: 'PR',
    value: 'PARANAGUA',
    label: 'PARANAGUA'
  },
  {
    stateKey: 'PR',
    value: 'PARANAPOEMA',
    label: 'PARANAPOEMA'
  },
  {
    stateKey: 'PR',
    value: 'PARANAVAI',
    label: 'PARANAVAI'
  },
  {
    stateKey: 'PR',
    value: 'PATO BRAGADO',
    label: 'PATO BRAGADO'
  },
  {
    stateKey: 'PR',
    value: 'PATO BRANCO',
    label: 'PATO BRANCO'
  },
  {
    stateKey: 'PR',
    value: 'PAULA FREITAS',
    label: 'PAULA FREITAS'
  },
  {
    stateKey: 'PR',
    value: 'PAULO FRONTIN ',
    label: 'PAULO FRONTIN'
  },
  {
    stateKey: 'PR',
    value: 'PEABIRU',
    label: 'PEABIRU'
  },
  {
    stateKey: 'PR',
    value: 'PEROBAL',
    label: 'PEROBAL'
  },
  {
    stateKey: 'PR',
    value: 'PEROLA',
    label: 'PEROLA'
  },
  {
    stateKey: 'PR',
    value: 'PIEN',
    label: 'PIEN'
  },
  {
    stateKey: 'PR',
    value: 'PINHAIS',
    label: 'PINHAIS'
  },
  {
    stateKey: 'PR',
    value: 'PINHAL DE SAO BENTO',
    label: 'PINHAL DE SAO BENTO'
  },
  {
    stateKey: 'PR',
    value: 'PINHALAO',
    label: 'PINHALAO'
  },
  {
    stateKey: 'PR',
    value: 'PINHAO',
    label: 'PINHAO'
  },
  {
    stateKey: 'PR',
    value: 'PIRAI DO SUL',
    label: 'PIRAI DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'PIRAQUARA',
    label: 'PIRAQUARA'
  },
  {
    stateKey: 'PR',
    value: 'PITANGA',
    label: 'PITANGA'
  },
  {
    stateKey: 'PR',
    value: 'PITANGUEIRAS',
    label: 'PITANGUEIRAS'
  },
  {
    stateKey: 'PR',
    value: 'PLANALTINA DO PARANA',
    label: 'PLANALTINA DO PARANA'
  },
  {
    stateKey: 'PR',
    value: 'PLANALTO',
    label: 'PLANALTO'
  },
  {
    stateKey: 'PR',
    value: 'PONTA GROSSA',
    label: 'PONTA GROSSA'
  },
  {
    stateKey: 'PR',
    value: 'PONTAL DO PARANA',
    label: 'PONTAL DO PARANA'
  },
  {
    stateKey: 'PR',
    value: 'PORECATU',
    label: 'PORECATU'
  },
  {
    stateKey: 'PR',
    value: 'PORTO AMAZONAS',
    label: 'PORTO AMAZONAS'
  },
  {
    stateKey: 'PR',
    value: 'PORTO BARREIRO',
    label: 'PORTO BARREIRO'
  },
  {
    stateKey: 'PR',
    value: 'PORTO RICO',
    label: 'PORTO RICO'
  },
  {
    stateKey: 'PR',
    value: 'PORTO VITORIA',
    label: 'PORTO VITORIA'
  },
  {
    stateKey: 'PR',
    value: 'PRADO FERREIRA',
    label: 'PRADO FERREIRA'
  },
  {
    stateKey: 'PR',
    value: 'PRANCHITA',
    label: 'PRANCHITA'
  },
  {
    stateKey: 'PR',
    value: 'PRESIDENTE CASTELO BRANCO',
    label: 'PRESIDENTE CASTELO BRANCO'
  },
  {
    stateKey: 'PR',
    value: 'PRIMEIRO DE MAIO',
    label: 'PRIMEIRO DE MAIO'
  },
  {
    stateKey: 'PR',
    value: 'PRUDENTOPOLIS',
    label: 'PRUDENTOPOLIS'
  },
  {
    stateKey: 'PR',
    value: 'QUATIGUA',
    label: 'QUATIGUA'
  },
  {
    stateKey: 'PR',
    value: 'QUATRO BARRAS',
    label: 'QUATRO BARRAS'
  },
  {
    stateKey: 'PR',
    value: 'QUATRO PONTES',
    label: 'QUATRO PONTES'
  },
  {
    stateKey: 'PR',
    value: 'QUEDAS DO IGUACU',
    label: 'QUEDAS DO IGUACU'
  },
  {
    stateKey: 'PR',
    value: 'QUERENCIA DO NORTE',
    label: 'QUERENCIA DO NORTE'
  },
  {
    stateKey: 'PR',
    value: 'QUINTA DO SOL',
    label: 'QUINTA DO SOL'
  },
  {
    stateKey: 'PR',
    value: 'QUITANDINHA',
    label: 'QUITANDINHA'
  },
  {
    stateKey: 'PR',
    value: 'RAMILANDIA',
    label: 'RAMILANDIA'
  },
  {
    stateKey: 'PR',
    value: 'RANCHO ALEGRE',
    label: 'RANCHO ALEGRE'
  },
  {
    stateKey: 'PR',
    value: "RANCHO ALEGRE D'OESTE",
    label: "RANCHO ALEGRE D'OESTE"
  },
  {
    stateKey: 'PR',
    value: 'REALEZA',
    label: 'REALEZA'
  },
  {
    stateKey: 'PR',
    value: 'REBOUCAS',
    label: 'REBOUCAS'
  },
  {
    stateKey: 'PR',
    value: 'RENASCENCA',
    label: 'RENASCENCA'
  },
  {
    stateKey: 'PR',
    value: 'RESERVA',
    label: 'RESERVA'
  },
  {
    stateKey: 'PR',
    value: 'RESERVA DO IGUACU',
    label: 'RESERVA DO IGUACU'
  },
  {
    stateKey: 'PR',
    value: 'RIBEIRAO CLARO',
    label: 'RIBEIRAO CLARO'
  },
  {
    stateKey: 'PR',
    value: 'RIBEIRAO DO PINHAL',
    label: 'RIBEIRAO DO PINHAL'
  },
  {
    stateKey: 'PR',
    value: 'RIO AZUL',
    label: 'RIO AZUL'
  },
  {
    stateKey: 'PR',
    value: 'RIO BOM',
    label: 'RIO BOM'
  },
  {
    stateKey: 'PR',
    value: 'RIO BONITO DO IGUACU',
    label: 'RIO BONITO DO IGUACU'
  },
  {
    stateKey: 'PR',
    value: 'RIO BRANCO DO IVAI',
    label: 'RIO BRANCO DO IVAI'
  },
  {
    stateKey: 'PR',
    value: 'RIO BRANCO DO SUL',
    label: 'RIO BRANCO DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'RIO NEGRO',
    label: 'RIO NEGRO'
  },
  {
    stateKey: 'PR',
    value: 'ROLANDIA',
    label: 'ROLANDIA'
  },
  {
    stateKey: 'PR',
    value: 'RONCADOR',
    label: 'RONCADOR'
  },
  {
    stateKey: 'PR',
    value: 'RONDON',
    label: 'RONDON'
  },
  {
    stateKey: 'PR',
    value: 'ROSARIO',
    label: 'ROSARIO'
  },
  {
    stateKey: 'PR',
    value: 'SABAUDIA',
    label: 'SABAUDIA'
  },
  {
    stateKey: 'PR',
    value: 'SALGADO FILHO',
    label: 'SALGADO FILHO'
  },
  {
    stateKey: 'PR',
    value: 'SALTO DO ITARARE',
    label: 'SALTO DO ITARARE'
  },
  {
    stateKey: 'PR',
    value: 'SALTO DO LONTRA',
    label: 'SALTO DO LONTRA'
  },
  {
    stateKey: 'PR',
    value: 'SANTA AMELIA',
    label: 'SANTA AMELIA'
  },
  {
    stateKey: 'PR',
    value: 'SANTA CECILIA DO PAVAO',
    label: 'SANTA CECILIA DO PAVAO'
  },
  {
    stateKey: 'PR',
    value: 'SANTA FE',
    label: 'SANTA FE'
  },
  {
    stateKey: 'PR',
    value: 'SANTA HELENA',
    label: 'SANTA HELENA'
  },
  {
    stateKey: 'PR',
    value: 'SANTA INES',
    label: 'SANTA INES'
  },
  {
    stateKey: 'PR',
    value: 'SANTA ISABEL DO IVAI',
    label: 'SANTA ISABEL DO IVAI'
  },
  {
    stateKey: 'PR',
    value: 'SANTA LUCIA',
    label: 'SANTA LUCIA'
  },
  {
    stateKey: 'PR',
    value: 'SANTA MARIA DO OESTE',
    label: 'SANTA MARIA DO OESTE'
  },
  {
    stateKey: 'PR',
    value: 'SANTA MARIANA',
    label: 'SANTA MARIANA'
  },
  {
    stateKey: 'PR',
    value: 'SANTA MONICA',
    label: 'SANTA MONICA'
  },
  {
    stateKey: 'PR',
    value: 'SANTA TEREZA DO OESTE',
    label: 'SANTA TEREZA DO OESTE'
  },
  {
    stateKey: 'PR',
    value: 'SANTA TEREZINHA DE ITAIPU',
    label: 'SANTA TEREZINHA DE ITAIPU'
  },
  {
    stateKey: 'PR',
    value: 'SANTANA DO ITARARE',
    label: 'SANTANA DO ITARARE'
  },
  {
    stateKey: 'PR',
    value: 'SANTO ANTONIO DA PLATINA',
    label: 'SANTO ANTONIO DA PLATINA'
  },
  {
    stateKey: 'PR',
    value: 'SANTO ANTONIO DO CAIUA',
    label: 'SANTO ANTONIO DO CAIUA'
  },
  {
    stateKey: 'PR',
    value: 'SANTO ANTONIO DO PARAISO',
    label: 'SANTO ANTONIO DO PARAISO'
  },
  {
    stateKey: 'PR',
    value: 'SANTO ANTONIO DO SUDOESTE',
    label: 'SANTO ANTONIO DO SUDOESTE'
  },
  {
    stateKey: 'PR',
    value: 'SANTO INACIO',
    label: 'SANTO INACIO'
  },
  {
    stateKey: 'PR',
    value: 'SAO CARLOS DO IVAI',
    label: 'SAO CARLOS DO IVAI'
  },
  {
    stateKey: 'PR',
    value: 'SAO JERONIMO DA SERRA',
    label: 'SAO JERONIMO DA SERRA'
  },
  {
    stateKey: 'PR',
    value: 'SAO JOAO',
    label: 'SAO JOAO'
  },
  {
    stateKey: 'PR',
    value: 'SAO JOAO DO CAIUA',
    label: 'SAO JOAO DO CAIUA'
  },
  {
    stateKey: 'PR',
    value: 'SAO JOAO DO IVAI',
    label: 'SAO JOAO DO IVAI'
  },
  {
    stateKey: 'PR',
    value: 'SAO JOAO DO TRIUNFO',
    label: 'SAO JOAO DO TRIUNFO'
  },
  {
    stateKey: 'PR',
    value: "SAO JORGE D'OESTE",
    label: "SAO JORGE D'OESTE"
  },
  {
    stateKey: 'PR',
    value: 'SAO JORGE DO IVAI',
    label: 'SAO JORGE DO IVAI'
  },
  {
    stateKey: 'PR',
    value: 'SAO JORGE DO PATROCINIO',
    label: 'SAO JORGE DO PATROCINIO'
  },
  {
    stateKey: 'PR',
    value: 'SAO JOSE DA BOA VISTA',
    label: 'SAO JOSE DA BOA VISTA'
  },
  {
    stateKey: 'PR',
    value: 'SAO JOSE DAS PALMEIRAS',
    label: 'SAO JOSE DAS PALMEIRAS'
  },
  {
    stateKey: 'PR',
    value: 'SAO JOSE DOS PINHAIS',
    label: 'SAO JOSE DOS PINHAIS'
  },
  {
    stateKey: 'PR',
    value: 'SAO MANOEL DO PARANA',
    label: 'SAO MANOEL DO PARANA'
  },
  {
    stateKey: 'PR',
    value: 'SAO MATEUS DO SUL',
    label: 'SAO MATEUS DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'SAO MIGUEL DO IGUACU',
    label: 'SAO MIGUEL DO IGUACU'
  },
  {
    stateKey: 'PR',
    value: 'SAO PEDRO DO IGUACU',
    label: 'SAO PEDRO DO IGUACU'
  },
  {
    stateKey: 'PR',
    value: 'SAO PEDRO DO IVAI',
    label: 'SAO PEDRO DO IVAI'
  },
  {
    stateKey: 'PR',
    value: 'SAO PEDRO DO PARANA',
    label: 'SAO PEDRO DO PARANA'
  },
  {
    stateKey: 'PR',
    value: 'SAO SEBASTIAO DA AMOREIRA',
    label: 'SAO SEBASTIAO DA AMOREIRA'
  },
  {
    stateKey: 'PR',
    value: 'SAO TOME',
    label: 'SAO TOME'
  },
  {
    stateKey: 'PR',
    value: 'SAPOPEMA',
    label: 'SAPOPEMA'
  },
  {
    stateKey: 'PR',
    value: 'SARANDI',
    label: 'SARANDI'
  },
  {
    stateKey: 'PR',
    value: 'SAUDADE DO IGUACU',
    label: 'SAUDADE DO IGUACU'
  },
  {
    stateKey: 'PR',
    value: 'SENGES',
    label: 'SENGES'
  },
  {
    stateKey: 'PR',
    value: 'SERRANOPOLIS DO IGUACU',
    label: 'SERRANOPOLIS DO IGUACU'
  },
  {
    stateKey: 'PR',
    value: 'SERTANEJA',
    label: 'SERTANEJA'
  },
  {
    stateKey: 'PR',
    value: 'SERTANOPOLIS',
    label: 'SERTANOPOLIS'
  },
  {
    stateKey: 'PR',
    value: 'SIQUEIRA CAMPOS',
    label: 'SIQUEIRA CAMPOS'
  },
  {
    stateKey: 'PR',
    value: 'SULINA',
    label: 'SULINA'
  },
  {
    stateKey: 'PR',
    value: 'TAMARANA',
    label: 'TAMARANA'
  },
  {
    stateKey: 'PR',
    value: 'TAMBOARA',
    label: 'TAMBOARA'
  },
  {
    stateKey: 'PR',
    value: 'TAPEJARA',
    label: 'TAPEJARA'
  },
  {
    stateKey: 'PR',
    value: 'TAPIRA',
    label: 'TAPIRA'
  },
  {
    stateKey: 'PR',
    value: 'TEIXEIRA SOARES',
    label: 'TEIXEIRA SOARES'
  },
  {
    stateKey: 'PR',
    value: 'TELEMACO BORBA',
    label: 'TELEMACO BORBA'
  },
  {
    stateKey: 'PR',
    value: 'TERRA BOA',
    label: 'TERRA BOA'
  },
  {
    stateKey: 'PR',
    value: 'TERRA RICA',
    label: 'TERRA RICA'
  },
  {
    stateKey: 'PR',
    value: 'TERRA ROXA',
    label: 'TERRA ROXA'
  },
  {
    stateKey: 'PR',
    value: 'TIBAGI',
    label: 'TIBAGI'
  },
  {
    stateKey: 'PR',
    value: 'TIJUCAS DO SUL',
    label: 'TIJUCAS DO SUL'
  },
  {
    stateKey: 'PR',
    value: 'TOLEDO',
    label: 'TOLEDO'
  },
  {
    stateKey: 'PR',
    value: 'TRES BARRAS DO PARANA',
    label: 'TRES BARRAS DO PARANA'
  },
  {
    stateKey: 'PR',
    value: 'TUNAS DO PARANA',
    label: 'TUNAS DO PARANA'
  },
  {
    stateKey: 'PR',
    value: 'TUNEIRAS DO OESTE',
    label: 'TUNEIRAS DO OESTE'
  },
  {
    stateKey: 'PR',
    value: 'TUPASSI',
    label: 'TUPASSI'
  },
  {
    stateKey: 'PR',
    value: 'TURVO',
    label: 'TURVO'
  },
  {
    stateKey: 'PR',
    value: 'UBIRATA',
    label: 'UBIRATA'
  },
  {
    stateKey: 'PR',
    value: 'UMUARAMA',
    label: 'UMUARAMA'
  },
  {
    stateKey: 'PR',
    value: 'UNIAO DA VITORIA',
    label: 'UNIAO DA VITORIA'
  },
  {
    stateKey: 'PR',
    value: 'UNIFLOR',
    label: 'UNIFLOR'
  },
  {
    stateKey: 'PR',
    value: 'URAI',
    label: 'URAI'
  },
  {
    stateKey: 'PR',
    value: 'VENTANIA',
    label: 'VENTANIA'
  },
  {
    stateKey: 'PR',
    value: 'VERA CRUZ DO OESTE ',
    label: 'VERA CRUZ DO OESTE'
  },
  {
    stateKey: 'PR',
    value: 'VERE',
    label: 'VERE'
  },
  {
    stateKey: 'PR',
    value: 'ALTO PARAISO',
    label: 'ALTO PARAISO'
  },
  {
    stateKey: 'PR',
    value: 'VIRMOND',
    label: 'VIRMOND'
  },
  {
    stateKey: 'PR',
    value: 'VITORINO',
    label: 'VITORINO'
  },
  {
    stateKey: 'PR',
    value: 'XAMBRE',
    label: 'XAMBRE'
  },
  {
    stateKey: 'PR',
    value: 'BRAGANTINA',
    label: 'BRAGANTINA'
  },
  {
    stateKey: 'PR',
    value: 'DOUTOR ANTONIO PARANHOS',
    label: 'DOUTOR ANTONIO PARANHOS'
  },
  {
    stateKey: 'PR',
    value: 'ENCANTADO DO OESTE',
    label: 'ENCANTADO DO OESTE'
  },
  {
    stateKey: 'PR',
    value: 'GUARAITUBA',
    label: 'GUARAITUBA'
  },
  {
    stateKey: 'PR',
    value: 'SAO JOSE DO IVAI',
    label: 'SAO JOSE DO IVAI'
  },
  {
    stateKey: 'PR',
    value: 'FORMOSA DO OESTE',
    label: 'FORMOSA DO OESTE'
  },
  {
    stateKey: 'PR',
    value: 'ATALAIA',
    label: 'ATALAIA'
  },
  {
    stateKey: 'PR',
    value: 'CRUZEIRO DO SUL',
    label: 'CRUZEIRO DO SUL'
  },
  {
    stateKey: 'PR',
    value: "PEROLA D'OESTE",
    label: "PEROLA D'OESTE"
  },
  {
    stateKey: 'PR',
    value: 'FLOR DA SERRA',
    label: 'FLOR DA SERRA'
  },
  {
    stateKey: 'PR',
    value: 'QUARTO CENTENARIO',
    label: 'QUARTO CENTENARIO'
  },
  {
    stateKey: 'PR',
    value: 'MANOEL RIBAS',
    label: 'MANOEL RIBAS'
  },
  {
    stateKey: 'PR',
    value: 'WENCESLAU BRAZ',
    label: 'WENCESLAU BRAZ'
  },
  {
    stateKey: 'PR',
    value: 'NOVA PRATA DO IGUAGU',
    label: 'NOVA PRATA DO IGUAGU'
  },
  {
    stateKey: 'PR',
    value: 'ROSARIO DO IVAI',
    label: 'ROSARIO DO IVAI'
  },
  {
    stateKey: 'PE',
    value: 'Fernando de Noronha',
    label: 'Fernando de Noronha'
  },
  {
    stateKey: 'PE',
    value: 'Moreilândia',
    label: 'Moreilândia'
  },
  {
    stateKey: 'PE',
    value: 'BREJAO',
    label: 'BREJAO'
  },
  {
    stateKey: 'PE',
    value: 'ABREU E LIMA',
    label: 'ABREU E LIMA'
  },
  {
    stateKey: 'PE',
    value: 'AFOGADOS DA INGAZEIRA',
    label: 'AFOGADOS DA INGAZEIRA'
  },
  {
    stateKey: 'PE',
    value: 'AFRANIO',
    label: 'AFRANIO'
  },
  {
    stateKey: 'PE',
    value: 'AGRESTINA',
    label: 'AGRESTINA'
  },
  {
    stateKey: 'PE',
    value: 'AGUA PRETA',
    label: 'AGUA PRETA'
  },
  {
    stateKey: 'PE',
    value: 'AGUAS BELAS',
    label: 'AGUAS BELAS'
  },
  {
    stateKey: 'PE',
    value: 'ALAGOINHA',
    label: 'ALAGOINHA'
  },
  {
    stateKey: 'PE',
    value: 'ALIANCA',
    label: 'ALIANCA'
  },
  {
    stateKey: 'PE',
    value: 'ALTINHO',
    label: 'ALTINHO'
  },
  {
    stateKey: 'PE',
    value: 'AMARAJI',
    label: 'AMARAJI'
  },
  {
    stateKey: 'PE',
    value: 'ANGELIM',
    label: 'ANGELIM'
  },
  {
    stateKey: 'PE',
    value: 'ARACOIABA',
    label: 'ARACOIABA'
  },
  {
    stateKey: 'PE',
    value: 'ARARIPINA',
    label: 'ARARIPINA'
  },
  {
    stateKey: 'PE',
    value: 'ARCOVERDE',
    label: 'ARCOVERDE'
  },
  {
    stateKey: 'PE',
    value: 'BARRA DE GUABIRABA',
    label: 'BARRA DE GUABIRABA'
  },
  {
    stateKey: 'PE',
    value: 'BARREIROS',
    label: 'BARREIROS'
  },
  {
    stateKey: 'PE',
    value: 'BELEM DE MARIA',
    label: 'BELEM DE MARIA'
  },
  {
    stateKey: 'PE',
    value: 'BELEM DE SAO FRANCISCO',
    label: 'BELEM DE SAO FRANCISCO'
  },
  {
    stateKey: 'PE',
    value: 'BELO JARDIM',
    label: 'BELO JARDIM'
  },
  {
    stateKey: 'PE',
    value: 'BETANIA',
    label: 'BETANIA'
  },
  {
    stateKey: 'PE',
    value: 'BEZERROS',
    label: 'BEZERROS'
  },
  {
    stateKey: 'PE',
    value: 'BODOCO',
    label: 'BODOCO'
  },
  {
    stateKey: 'PE',
    value: 'BOM CONSELHO',
    label: 'BOM CONSELHO'
  },
  {
    stateKey: 'PE',
    value: 'BOM JARDIM',
    label: 'BOM JARDIM'
  },
  {
    stateKey: 'PE',
    value: 'BONITO',
    label: 'BONITO'
  },
  {
    stateKey: 'PE',
    value: 'BREJINHO',
    label: 'BREJINHO'
  },
  {
    stateKey: 'PE',
    value: 'BREJO DA MADRE DE DEUS',
    label: 'BREJO DA MADRE DE DEUS'
  },
  {
    stateKey: 'PE',
    value: 'BUENOS AIRES',
    label: 'BUENOS AIRES'
  },
  {
    stateKey: 'PE',
    value: 'BUIQUE',
    label: 'BUIQUE'
  },
  {
    stateKey: 'PE',
    value: 'CABO',
    label: 'CABO'
  },
  {
    stateKey: 'PE',
    value: 'CABROBO',
    label: 'CABROBO'
  },
  {
    stateKey: 'PE',
    value: 'CACHOEIRINHA',
    label: 'CACHOEIRINHA'
  },
  {
    stateKey: 'PE',
    value: 'CAETES',
    label: 'CAETES'
  },
  {
    stateKey: 'PE',
    value: 'CALCADO',
    label: 'CALCADO'
  },
  {
    stateKey: 'PE',
    value: 'CALUMBI',
    label: 'CALUMBI'
  },
  {
    stateKey: 'PE',
    value: 'CAMARAGIBE',
    label: 'CAMARAGIBE'
  },
  {
    stateKey: 'PE',
    value: 'CAMOCIM DE SAO FELIX',
    label: 'CAMOCIM DE SAO FELIX'
  },
  {
    stateKey: 'PE',
    value: 'CAMUTANGA',
    label: 'CAMUTANGA'
  },
  {
    stateKey: 'PE',
    value: 'CANHOTINHO',
    label: 'CANHOTINHO'
  },
  {
    stateKey: 'PE',
    value: 'CAPOEIRAS',
    label: 'CAPOEIRAS'
  },
  {
    stateKey: 'PE',
    value: 'CARNAIBA',
    label: 'CARNAIBA'
  },
  {
    stateKey: 'PE',
    value: 'CARNAUBEIRA DA PENHA',
    label: 'CARNAUBEIRA DA PENHA'
  },
  {
    stateKey: 'PE',
    value: 'CARPINA',
    label: 'CARPINA'
  },
  {
    stateKey: 'PE',
    value: 'CARUARU',
    label: 'CARUARU'
  },
  {
    stateKey: 'PE',
    value: 'CASINHAS',
    label: 'CASINHAS'
  },
  {
    stateKey: 'PE',
    value: 'CATENDE',
    label: 'CATENDE'
  },
  {
    stateKey: 'PE',
    value: 'CEDRO',
    label: 'CEDRO'
  },
  {
    stateKey: 'PE',
    value: 'CHA DE ALEGRIA',
    label: 'CHA DE ALEGRIA'
  },
  {
    stateKey: 'PE',
    value: 'CHA GRANDE',
    label: 'CHA GRANDE'
  },
  {
    stateKey: 'PE',
    value: 'CONDADO',
    label: 'CONDADO'
  },
  {
    stateKey: 'PE',
    value: 'CORRENTES',
    label: 'CORRENTES'
  },
  {
    stateKey: 'PE',
    value: 'CORTES',
    label: 'CORTES'
  },
  {
    stateKey: 'PE',
    value: 'CUMARU',
    label: 'CUMARU'
  },
  {
    stateKey: 'PE',
    value: 'CUPIRA',
    label: 'CUPIRA'
  },
  {
    stateKey: 'PE',
    value: 'CUSTODIA',
    label: 'CUSTODIA'
  },
  {
    stateKey: 'PE',
    value: 'DORMENTES',
    label: 'DORMENTES'
  },
  {
    stateKey: 'PE',
    value: 'ESCADA',
    label: 'ESCADA'
  },
  {
    stateKey: 'PE',
    value: 'EXU',
    label: 'EXU'
  },
  {
    stateKey: 'PE',
    value: 'FEIRA NOVA',
    label: 'FEIRA NOVA'
  },
  {
    stateKey: 'PE',
    value: 'FERREIROS',
    label: 'FERREIROS'
  },
  {
    stateKey: 'PE',
    value: 'FLORES',
    label: 'FLORES'
  },
  {
    stateKey: 'PE',
    value: 'FLORESTA',
    label: 'FLORESTA'
  },
  {
    stateKey: 'PE',
    value: 'FREI MIGUELINHO',
    label: 'FREI MIGUELINHO'
  },
  {
    stateKey: 'PE',
    value: 'GAMELEIRA',
    label: 'GAMELEIRA'
  },
  {
    stateKey: 'PE',
    value: 'GARANHUNS',
    label: 'GARANHUNS'
  },
  {
    stateKey: 'PE',
    value: 'GLORIA DO GOITA',
    label: 'GLORIA DO GOITA'
  },
  {
    stateKey: 'PE',
    value: 'GOIANA',
    label: 'GOIANA'
  },
  {
    stateKey: 'PE',
    value: 'GRANITO',
    label: 'GRANITO'
  },
  {
    stateKey: 'PE',
    value: 'GRAVATA',
    label: 'GRAVATA'
  },
  {
    stateKey: 'PE',
    value: 'IATI',
    label: 'IATI'
  },
  {
    stateKey: 'PE',
    value: 'IBIMIRIM',
    label: 'IBIMIRIM'
  },
  {
    stateKey: 'PE',
    value: 'IBIRAJUBA',
    label: 'IBIRAJUBA'
  },
  {
    stateKey: 'PE',
    value: 'IGARASSU',
    label: 'IGARASSU'
  },
  {
    stateKey: 'PE',
    value: 'IGUARACI',
    label: 'IGUARACI'
  },
  {
    stateKey: 'PE',
    value: 'INAJA',
    label: 'INAJA'
  },
  {
    stateKey: 'PE',
    value: 'INGAZEIRA',
    label: 'INGAZEIRA'
  },
  {
    stateKey: 'PE',
    value: 'IPOJUCA',
    label: 'IPOJUCA'
  },
  {
    stateKey: 'PE',
    value: 'IPUBI',
    label: 'IPUBI'
  },
  {
    stateKey: 'PE',
    value: 'ITACURUBA',
    label: 'ITACURUBA'
  },
  {
    stateKey: 'PE',
    value: 'ITAIBA',
    label: 'ITAIBA'
  },
  {
    stateKey: 'PE',
    value: 'ITAMARACA',
    label: 'ITAMARACA'
  },
  {
    stateKey: 'PE',
    value: 'ITAMBE',
    label: 'ITAMBE'
  },
  {
    stateKey: 'PE',
    value: 'ITAPETIM',
    label: 'ITAPETIM'
  },
  {
    stateKey: 'PE',
    value: 'ITAPISSUMA',
    label: 'ITAPISSUMA'
  },
  {
    stateKey: 'PE',
    value: 'ITAQUITINGA',
    label: 'ITAQUITINGA'
  },
  {
    stateKey: 'PE',
    value: 'JAQUEIRA',
    label: 'JAQUEIRA'
  },
  {
    stateKey: 'PE',
    value: 'JATAUBA',
    label: 'JATAUBA'
  },
  {
    stateKey: 'PE',
    value: 'JATOBA',
    label: 'JATOBA'
  },
  {
    stateKey: 'PE',
    value: 'JOAO ALFREDO',
    label: 'JOAO ALFREDO'
  },
  {
    stateKey: 'PE',
    value: 'JOAQUIM NABUCO',
    label: 'JOAQUIM NABUCO'
  },
  {
    stateKey: 'PE',
    value: 'JUCATI',
    label: 'JUCATI'
  },
  {
    stateKey: 'PE',
    value: 'JUPI',
    label: 'JUPI'
  },
  {
    stateKey: 'PE',
    value: 'JUREMA',
    label: 'JUREMA'
  },
  {
    stateKey: 'PE',
    value: 'LAGOA DO CARRO',
    label: 'LAGOA DO CARRO'
  },
  {
    stateKey: 'PE',
    value: 'LAGOA DO ITAENGA',
    label: 'LAGOA DO ITAENGA'
  },
  {
    stateKey: 'PE',
    value: 'LAGOA DO OURO',
    label: 'LAGOA DO OURO'
  },
  {
    stateKey: 'PE',
    value: 'LAGOA DOS GATOS',
    label: 'LAGOA DOS GATOS'
  },
  {
    stateKey: 'PE',
    value: 'LAGOA GRANDE',
    label: 'LAGOA GRANDE'
  },
  {
    stateKey: 'PE',
    value: 'LAJEDO',
    label: 'LAJEDO'
  },
  {
    stateKey: 'PE',
    value: 'LIMOEIRO',
    label: 'LIMOEIRO'
  },
  {
    stateKey: 'PE',
    value: 'MACAPARANA',
    label: 'MACAPARANA'
  },
  {
    stateKey: 'PE',
    value: 'MACHADOS',
    label: 'MACHADOS'
  },
  {
    stateKey: 'PE',
    value: 'MANARI ',
    label: 'MANARI'
  },
  {
    stateKey: 'PE',
    value: 'MARAIAL',
    label: 'MARAIAL'
  },
  {
    stateKey: 'PE',
    value: 'MIRANDIBA',
    label: 'MIRANDIBA'
  },
  {
    stateKey: 'PE',
    value: 'MORENO',
    label: 'MORENO'
  },
  {
    stateKey: 'PE',
    value: 'NAZARE DA MATA',
    label: 'NAZARE DA MATA'
  },
  {
    stateKey: 'PE',
    value: 'OLINDA',
    label: 'OLINDA'
  },
  {
    stateKey: 'PE',
    value: 'OROBO',
    label: 'OROBO'
  },
  {
    stateKey: 'PE',
    value: 'OROCO',
    label: 'OROCO'
  },
  {
    stateKey: 'PE',
    value: 'OURICURI',
    label: 'OURICURI'
  },
  {
    stateKey: 'PE',
    value: 'PALMARES',
    label: 'PALMARES'
  },
  {
    stateKey: 'PE',
    value: 'PALMEIRINA',
    label: 'PALMEIRINA'
  },
  {
    stateKey: 'PE',
    value: 'PANELAS',
    label: 'PANELAS'
  },
  {
    stateKey: 'PE',
    value: 'PARANATAMA',
    label: 'PARANATAMA'
  },
  {
    stateKey: 'PE',
    value: 'PARNAMIRIM',
    label: 'PARNAMIRIM'
  },
  {
    stateKey: 'PE',
    value: 'PASSIRA',
    label: 'PASSIRA'
  },
  {
    stateKey: 'PE',
    value: 'PAUDALHO',
    label: 'PAUDALHO'
  },
  {
    stateKey: 'PE',
    value: 'PAULISTA',
    label: 'PAULISTA'
  },
  {
    stateKey: 'PE',
    value: 'PEDRA',
    label: 'PEDRA'
  },
  {
    stateKey: 'PE',
    value: 'PESQUEIRA',
    label: 'PESQUEIRA'
  },
  {
    stateKey: 'PE',
    value: 'PETROLANDIA',
    label: 'PETROLANDIA'
  },
  {
    stateKey: 'PE',
    value: 'PETROLINA',
    label: 'PETROLINA'
  },
  {
    stateKey: 'PE',
    value: 'POCAO',
    label: 'POCAO'
  },
  {
    stateKey: 'PE',
    value: 'POMBOS',
    label: 'POMBOS'
  },
  {
    stateKey: 'PE',
    value: 'PRIMAVERA',
    label: 'PRIMAVERA'
  },
  {
    stateKey: 'PE',
    value: 'QUIPAPA',
    label: 'QUIPAPA'
  },
  {
    stateKey: 'PE',
    value: 'QUIXABA',
    label: 'QUIXABA'
  },
  {
    stateKey: 'PE',
    value: 'RECIFE',
    label: 'RECIFE'
  },
  {
    stateKey: 'PE',
    value: 'RIACHO DAS ALMAS',
    label: 'RIACHO DAS ALMAS'
  },
  {
    stateKey: 'PE',
    value: 'RIBEIRAO',
    label: 'RIBEIRAO'
  },
  {
    stateKey: 'PE',
    value: 'RIO FORMOSO',
    label: 'RIO FORMOSO'
  },
  {
    stateKey: 'PE',
    value: 'SAIRE',
    label: 'SAIRE'
  },
  {
    stateKey: 'PE',
    value: 'SALGADINHO',
    label: 'SALGADINHO'
  },
  {
    stateKey: 'PE',
    value: 'SALGUEIRO',
    label: 'SALGUEIRO'
  },
  {
    stateKey: 'PE',
    value: 'SALOA',
    label: 'SALOA'
  },
  {
    stateKey: 'PE',
    value: 'SANHARO',
    label: 'SANHARO'
  },
  {
    stateKey: 'PE',
    value: 'SANTA CRUZ',
    label: 'SANTA CRUZ'
  },
  {
    stateKey: 'PE',
    value: 'SANTA CRUZ DA BAIXA VERDE',
    label: 'SANTA CRUZ DA BAIXA VERDE'
  },
  {
    stateKey: 'PE',
    value: 'SANTA CRUZ DO CAPIBARIBE',
    label: 'SANTA CRUZ DO CAPIBARIBE'
  },
  {
    stateKey: 'PE',
    value: 'SANTA FILOMENA',
    label: 'SANTA FILOMENA'
  },
  {
    stateKey: 'PE',
    value: 'SANTA MARIA DA BOA VISTA',
    label: 'SANTA MARIA DA BOA VISTA'
  },
  {
    stateKey: 'PE',
    value: 'SANTA MARIA DO CAMBUCA',
    label: 'SANTA MARIA DO CAMBUCA'
  },
  {
    stateKey: 'PE',
    value: 'SANTA TEREZINHA',
    label: 'SANTA TEREZINHA'
  },
  {
    stateKey: 'PE',
    value: 'SAO BENEDITO DO SUL',
    label: 'SAO BENEDITO DO SUL'
  },
  {
    stateKey: 'PE',
    value: 'SAO BENTO DO UNA',
    label: 'SAO BENTO DO UNA'
  },
  {
    stateKey: 'PE',
    value: 'SAO CAITANO',
    label: 'SAO CAITANO'
  },
  {
    stateKey: 'PE',
    value: 'SAO JOAO',
    label: 'SAO JOAO'
  },
  {
    stateKey: 'PE',
    value: 'SAO JOAQUIM DO MONTE',
    label: 'SAO JOAQUIM DO MONTE'
  },
  {
    stateKey: 'PE',
    value: 'SAO JOSE DA COROA GRANDE',
    label: 'SAO JOSE DA COROA GRANDE'
  },
  {
    stateKey: 'PE',
    value: 'SAO JOSE DO BELMONTE',
    label: 'SAO JOSE DO BELMONTE'
  },
  {
    stateKey: 'PE',
    value: 'SAO JOSE DO EGITO',
    label: 'SAO JOSE DO EGITO'
  },
  {
    stateKey: 'PE',
    value: 'SAO LOURENCO DA MATA',
    label: 'SAO LOURENCO DA MATA'
  },
  {
    stateKey: 'PE',
    value: 'SAO VICENTE FERRER',
    label: 'SAO VICENTE FERRER'
  },
  {
    stateKey: 'PE',
    value: 'SERRA TALHADA',
    label: 'SERRA TALHADA'
  },
  {
    stateKey: 'PE',
    value: 'SERRITA',
    label: 'SERRITA'
  },
  {
    stateKey: 'PE',
    value: 'SERTANIA',
    label: 'SERTANIA'
  },
  {
    stateKey: 'PE',
    value: 'SIRINHAEM',
    label: 'SIRINHAEM'
  },
  {
    stateKey: 'PE',
    value: 'SOLIDAO',
    label: 'SOLIDAO'
  },
  {
    stateKey: 'PE',
    value: 'SURUBIM',
    label: 'SURUBIM'
  },
  {
    stateKey: 'PE',
    value: 'TABIRA',
    label: 'TABIRA'
  },
  {
    stateKey: 'PE',
    value: 'TACAIMBO',
    label: 'TACAIMBO'
  },
  {
    stateKey: 'PE',
    value: 'TACARATU',
    label: 'TACARATU'
  },
  {
    stateKey: 'PE',
    value: 'TAMANDARE',
    label: 'TAMANDARE'
  },
  {
    stateKey: 'PE',
    value: 'TAQUARITINGA DO NORTE',
    label: 'TAQUARITINGA DO NORTE'
  },
  {
    stateKey: 'PE',
    value: 'TEREZINHA',
    label: 'TEREZINHA'
  },
  {
    stateKey: 'PE',
    value: 'TERRA NOVA',
    label: 'TERRA NOVA'
  },
  {
    stateKey: 'PE',
    value: 'TIMBAUBA',
    label: 'TIMBAUBA'
  },
  {
    stateKey: 'PE',
    value: 'TORITAMA',
    label: 'TORITAMA'
  },
  {
    stateKey: 'PE',
    value: 'TRACUNHAEM',
    label: 'TRACUNHAEM'
  },
  {
    stateKey: 'PE',
    value: 'TRINDADE',
    label: 'TRINDADE'
  },
  {
    stateKey: 'PE',
    value: 'TRIUNFO',
    label: 'TRIUNFO'
  },
  {
    stateKey: 'PE',
    value: 'TUPANATINGA',
    label: 'TUPANATINGA'
  },
  {
    stateKey: 'PE',
    value: 'TUPARETAMA',
    label: 'TUPARETAMA'
  },
  {
    stateKey: 'PE',
    value: 'VENTUROSA',
    label: 'VENTUROSA'
  },
  {
    stateKey: 'PE',
    value: 'VERDEJANTE',
    label: 'VERDEJANTE'
  },
  {
    stateKey: 'PE',
    value: 'VERTENTE DO LERIO',
    label: 'VERTENTE DO LERIO'
  },
  {
    stateKey: 'PE',
    value: 'VERTENTES',
    label: 'VERTENTES'
  },
  {
    stateKey: 'PE',
    value: 'VICENCIA',
    label: 'VICENCIA'
  },
  {
    stateKey: 'PE',
    value: 'VITORIA DE SANTO ANTAO',
    label: 'VITORIA DE SANTO ANTAO'
  },
  {
    stateKey: 'PE',
    value: 'XEXEU',
    label: 'XEXEU'
  },
  {
    stateKey: 'PE',
    value: 'JABOATAO DOS GUARARAPES',
    label: 'JABOATAO DOS GUARARAPES'
  },
  {
    stateKey: 'PE',
    value: 'CABO DE SANTO AGOSTINHO',
    label: 'CABO DE SANTO AGOSTINHO'
  },
  {
    stateKey: 'PI',
    value: 'ALTO LONGA',
    label: 'ALTO LONGA'
  },
  {
    stateKey: 'PI',
    value: 'CAMPO MAIOR',
    label: 'CAMPO MAIOR'
  },
  {
    stateKey: 'PI',
    value: 'Alegrete do PI',
    label: 'Alegrete do PI'
  },
  {
    stateKey: 'PI',
    value: 'Aroeiras do Itaim',
    label: 'Aroeiras do Itaim'
  },
  {
    stateKey: 'PI',
    value: "Pau D'Arco do PI",
    label: "Pau D'Arco do PI"
  },
  {
    stateKey: 'PI',
    value: 'Nova Santa Rita',
    label: 'Nova Santa Rita'
  },
  {
    stateKey: 'PI',
    value: 'ACAUA',
    label: 'ACAUA'
  },
  {
    stateKey: 'PI',
    value: 'AGRICOLANDIA',
    label: 'AGRICOLANDIA'
  },
  {
    stateKey: 'PI',
    value: 'ALAGOINHA DO PIAUI',
    label: 'ALAGOINHA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'ALTOS',
    label: 'ALTOS'
  },
  {
    stateKey: 'PI',
    value: 'ALVORADA DO GURGUEIA',
    label: 'ALVORADA DO GURGUEIA'
  },
  {
    stateKey: 'PI',
    value: 'AMARANTE',
    label: 'AMARANTE'
  },
  {
    stateKey: 'PI',
    value: 'ANGICAL DO PIAUI',
    label: 'ANGICAL DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'ANISIO DE ABREU',
    label: 'ANISIO DE ABREU'
  },
  {
    stateKey: 'PI',
    value: 'ANTONIO ALMEIDA',
    label: 'ANTONIO ALMEIDA'
  },
  {
    stateKey: 'PI',
    value: 'AROAZES',
    label: 'AROAZES'
  },
  {
    stateKey: 'PI',
    value: 'ARRAIAL',
    label: 'ARRAIAL'
  },
  {
    stateKey: 'PI',
    value: 'ASSUNCAO',
    label: 'ASSUNCAO'
  },
  {
    stateKey: 'PI',
    value: 'AVELINO LOPES',
    label: 'AVELINO LOPES'
  },
  {
    stateKey: 'PI',
    value: 'BAIXA GRANDE DO RIBEIRO',
    label: 'BAIXA GRANDE DO RIBEIRO'
  },
  {
    stateKey: 'PI',
    value: 'BARRA DALCANTARA',
    label: 'BARRA DALCANTARA'
  },
  {
    stateKey: 'PI',
    value: 'BARRAS',
    label: 'BARRAS'
  },
  {
    stateKey: 'PI',
    value: 'BARREIRAS DO PIAUI',
    label: 'BARREIRAS DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'BARRO DURO',
    label: 'BARRO DURO'
  },
  {
    stateKey: 'PI',
    value: 'BELA VISTA DO PIAUI',
    label: 'BELA VISTA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'BELEM DO PIAUI',
    label: 'BELEM DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'BENEDITINOS',
    label: 'BENEDITINOS'
  },
  {
    stateKey: 'PI',
    value: 'BERTOLINIA',
    label: 'BERTOLINIA'
  },
  {
    stateKey: 'PI',
    value: 'BETANIA DO PIAUI',
    label: 'BETANIA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'BOA HORA',
    label: 'BOA HORA'
  },
  {
    stateKey: 'PI',
    value: 'BOCAINA',
    label: 'BOCAINA'
  },
  {
    stateKey: 'PI',
    value: 'BOM JESUS',
    label: 'BOM JESUS'
  },
  {
    stateKey: 'PI',
    value: 'BOM PRINCIPIO DO PIAUI',
    label: 'BOM PRINCIPIO DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'BONFIM DO PIAUI',
    label: 'BONFIM DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'BOQUEIRAO',
    label: 'BOQUEIRAO'
  },
  {
    stateKey: 'PI',
    value: 'BRASILEIRA',
    label: 'BRASILEIRA'
  },
  {
    stateKey: 'PI',
    value: 'BREJO DO PIAUI',
    label: 'BREJO DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'BURITI DOS LOPES',
    label: 'BURITI DOS LOPES'
  },
  {
    stateKey: 'PI',
    value: 'BURITI DOS MONTES',
    label: 'BURITI DOS MONTES'
  },
  {
    stateKey: 'PI',
    value: 'CABECEIRAS',
    label: 'CABECEIRAS'
  },
  {
    stateKey: 'PI',
    value: 'CAJAZEIRAS DO PIAUI',
    label: 'CAJAZEIRAS DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'CAJUEIRO DA PRAIA',
    label: 'CAJUEIRO DA PRAIA'
  },
  {
    stateKey: 'PI',
    value: 'CALDEIRAO GRANDE DO PIAUI',
    label: 'CALDEIRAO GRANDE DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'CAMPINAS DO PIAUI',
    label: 'CAMPINAS DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'CAMPO ALEGRE DO FIDALGO',
    label: 'CAMPO ALEGRE DO FIDALGO'
  },
  {
    stateKey: 'PI',
    value: 'CAMPO GRANDE DO PIAUI',
    label: 'CAMPO GRANDE DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'CAMPO LARGO DO PIAUI',
    label: 'CAMPO LARGO DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'CANAVIEIRA',
    label: 'CANAVIEIRA'
  },
  {
    stateKey: 'PI',
    value: 'CANTO DO BURITI',
    label: 'CANTO DO BURITI'
  },
  {
    stateKey: 'PI',
    value: 'CAPITAO DE CAMPOS',
    label: 'CAPITAO DE CAMPOS'
  },
  {
    stateKey: 'PI',
    value: 'CAPITAO GERVASIO OLIVEIRA',
    label: 'CAPITAO GERVASIO OLIVEIRA'
  },
  {
    stateKey: 'PI',
    value: 'CARACOL',
    label: 'CARACOL'
  },
  {
    stateKey: 'PI',
    value: 'CARAUBAS DO PIAUI',
    label: 'CARAUBAS DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'CARIDADE DO PIAUI',
    label: 'CARIDADE DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'CASTELO DO PIAUI',
    label: 'CASTELO DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'CAXINGO',
    label: 'CAXINGO'
  },
  {
    stateKey: 'PI',
    value: 'COCAL',
    label: 'COCAL'
  },
  {
    stateKey: 'PI',
    value: 'COCAL DE TELHA',
    label: 'COCAL DE TELHA'
  },
  {
    stateKey: 'PI',
    value: 'COIVARAS',
    label: 'COIVARAS'
  },
  {
    stateKey: 'PI',
    value: 'COLONIA DO GURGUEIA',
    label: 'COLONIA DO GURGUEIA'
  },
  {
    stateKey: 'PI',
    value: 'COLONIA DO PIAUI',
    label: 'COLONIA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'CONCEICAO DO CANINDE',
    label: 'CONCEICAO DO CANINDE'
  },
  {
    stateKey: 'PI',
    value: 'CORONEL JOSE DIAS',
    label: 'CORONEL JOSE DIAS'
  },
  {
    stateKey: 'PI',
    value: 'CORRENTE',
    label: 'CORRENTE'
  },
  {
    stateKey: 'PI',
    value: 'CRISTALANDIA DO PIAUI',
    label: 'CRISTALANDIA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'CRISTINO CASTRO',
    label: 'CRISTINO CASTRO'
  },
  {
    stateKey: 'PI',
    value: 'CURIMATA',
    label: 'CURIMATA'
  },
  {
    stateKey: 'PI',
    value: 'CURRAIS',
    label: 'CURRAIS'
  },
  {
    stateKey: 'PI',
    value: 'CURRAL NOVO DO PIAUI',
    label: 'CURRAL NOVO DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'CURRALINHOS',
    label: 'CURRALINHOS'
  },
  {
    stateKey: 'PI',
    value: 'DEMERVAL LOBAO',
    label: 'DEMERVAL LOBAO'
  },
  {
    stateKey: 'PI',
    value: 'DIRCEU ARCOVERDE',
    label: 'DIRCEU ARCOVERDE'
  },
  {
    stateKey: 'PI',
    value: 'DOM EXPEDITO LOPES',
    label: 'DOM EXPEDITO LOPES'
  },
  {
    stateKey: 'PI',
    value: 'DOM INOCENCIO',
    label: 'DOM INOCENCIO'
  },
  {
    stateKey: 'PI',
    value: 'DOMINGOS MOURAO',
    label: 'DOMINGOS MOURAO'
  },
  {
    stateKey: 'PI',
    value: 'ELESBAO VELOSO',
    label: 'ELESBAO VELOSO'
  },
  {
    stateKey: 'PI',
    value: 'ELISEU MARTINS',
    label: 'ELISEU MARTINS'
  },
  {
    stateKey: 'PI',
    value: 'ESPERANTINA',
    label: 'ESPERANTINA'
  },
  {
    stateKey: 'PI',
    value: 'FARTURA DO PIAUI',
    label: 'FARTURA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'FLORES DO PIAUI',
    label: 'FLORES DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'FLORESTA DO PIAUI',
    label: 'FLORESTA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'FLORIANO',
    label: 'FLORIANO'
  },
  {
    stateKey: 'PI',
    value: 'FRANCINOPOLIS',
    label: 'FRANCINOPOLIS'
  },
  {
    stateKey: 'PI',
    value: 'FRANCISCO AYRES',
    label: 'FRANCISCO AYRES'
  },
  {
    stateKey: 'PI',
    value: 'FRANCISCO MACEDO',
    label: 'FRANCISCO MACEDO'
  },
  {
    stateKey: 'PI',
    value: 'FRANCISCO SANTOS',
    label: 'FRANCISCO SANTOS'
  },
  {
    stateKey: 'PI',
    value: 'FRONTEIRAS',
    label: 'FRONTEIRAS'
  },
  {
    stateKey: 'PI',
    value: 'GEMINIANO',
    label: 'GEMINIANO'
  },
  {
    stateKey: 'PI',
    value: 'GILBUES',
    label: 'GILBUES'
  },
  {
    stateKey: 'PI',
    value: 'GUADALUPE',
    label: 'GUADALUPE'
  },
  {
    stateKey: 'PI',
    value: 'GUARIBAS',
    label: 'GUARIBAS'
  },
  {
    stateKey: 'PI',
    value: 'HUGO NAPOLEAO',
    label: 'HUGO NAPOLEAO'
  },
  {
    stateKey: 'PI',
    value: 'ILHA GRANDE',
    label: 'ILHA GRANDE'
  },
  {
    stateKey: 'PI',
    value: 'INHUMA',
    label: 'INHUMA'
  },
  {
    stateKey: 'PI',
    value: 'IPIRANGA DO PIAUI',
    label: 'IPIRANGA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'ISAIAS COELHO',
    label: 'ISAIAS COELHO'
  },
  {
    stateKey: 'PI',
    value: 'ITAINOPOLIS',
    label: 'ITAINOPOLIS'
  },
  {
    stateKey: 'PI',
    value: 'ITAUEIRA',
    label: 'ITAUEIRA'
  },
  {
    stateKey: 'PI',
    value: 'JACOBINA DO PIAUI',
    label: 'JACOBINA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'JAICOS',
    label: 'JAICOS'
  },
  {
    stateKey: 'PI',
    value: 'JARDIM DO MULATO',
    label: 'JARDIM DO MULATO'
  },
  {
    stateKey: 'PI',
    value: 'JATOBA DO PIAUI',
    label: 'JATOBA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'JERUMENHA',
    label: 'JERUMENHA'
  },
  {
    stateKey: 'PI',
    value: 'JOAO COSTA',
    label: 'JOAO COSTA'
  },
  {
    stateKey: 'PI',
    value: 'JOAQUIM PIRES',
    label: 'JOAQUIM PIRES'
  },
  {
    stateKey: 'PI',
    value: 'JOCA MARQUES',
    label: 'JOCA MARQUES'
  },
  {
    stateKey: 'PI',
    value: 'JOSE DE FREITAS',
    label: 'JOSE DE FREITAS'
  },
  {
    stateKey: 'PI',
    value: 'JUAZEIRO DO PIAUI',
    label: 'JUAZEIRO DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'JULIO BORGES',
    label: 'JULIO BORGES'
  },
  {
    stateKey: 'PI',
    value: 'JUREMA',
    label: 'JUREMA'
  },
  {
    stateKey: 'PI',
    value: 'LAGOA ALEGRE',
    label: 'LAGOA ALEGRE'
  },
  {
    stateKey: 'PI',
    value: 'LAGOA DE SAO FRANCISCO',
    label: 'LAGOA DE SAO FRANCISCO'
  },
  {
    stateKey: 'PI',
    value: 'LAGOA DO BARRO DO PIAUI',
    label: 'LAGOA DO BARRO DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'LAGOA DO PIAUI',
    label: 'LAGOA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'LAGOA DO SITIO',
    label: 'LAGOA DO SITIO'
  },
  {
    stateKey: 'PI',
    value: 'LAGOINHA DO PIAUI',
    label: 'LAGOINHA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'LANDRI SALES',
    label: 'LANDRI SALES'
  },
  {
    stateKey: 'PI',
    value: 'LUIS CORREIA',
    label: 'LUIS CORREIA'
  },
  {
    stateKey: 'PI',
    value: 'LUZILANDIA',
    label: 'LUZILANDIA'
  },
  {
    stateKey: 'PI',
    value: 'MADEIRO',
    label: 'MADEIRO'
  },
  {
    stateKey: 'PI',
    value: 'MANOEL EMIDIO',
    label: 'MANOEL EMIDIO'
  },
  {
    stateKey: 'PI',
    value: 'MARCOLANDIA',
    label: 'MARCOLANDIA'
  },
  {
    stateKey: 'PI',
    value: 'MARCOS PARENTE',
    label: 'MARCOS PARENTE'
  },
  {
    stateKey: 'PI',
    value: 'MASSAPE DO PIAUI',
    label: 'MASSAPE DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'MATIAS OLIMPIO',
    label: 'MATIAS OLIMPIO'
  },
  {
    stateKey: 'PI',
    value: 'MIGUEL ALVES',
    label: 'MIGUEL ALVES'
  },
  {
    stateKey: 'PI',
    value: 'MIGUEL LEAO',
    label: 'MIGUEL LEAO'
  },
  {
    stateKey: 'PI',
    value: 'MILTON BRANDAO',
    label: 'MILTON BRANDAO'
  },
  {
    stateKey: 'PI',
    value: 'MONSENHOR GIL',
    label: 'MONSENHOR GIL'
  },
  {
    stateKey: 'PI',
    value: 'MONSENHOR HIPOLITO',
    label: 'MONSENHOR HIPOLITO'
  },
  {
    stateKey: 'PI',
    value: 'MONTE ALEGRE DO PIAUI',
    label: 'MONTE ALEGRE DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'MORRO CABECA NO TEMPO',
    label: 'MORRO CABECA NO TEMPO'
  },
  {
    stateKey: 'PI',
    value: 'MORRO DO CHAPEU DO PIAUI',
    label: 'MORRO DO CHAPEU DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'MURICI DOS PORTELA',
    label: 'MURICI DOS PORTELA'
  },
  {
    stateKey: 'PI',
    value: 'NAZARE DO PIAUI',
    label: 'NAZARE DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'NOSSA SENHORA DE NAZARE',
    label: 'NOSSA SENHORA DE NAZARE'
  },
  {
    stateKey: 'PI',
    value: 'NOSSA SENHORA DOS REMEDIOS',
    label: 'NOSSA SENHORA DOS REMEDIOS'
  },
  {
    stateKey: 'PI',
    value: 'NOVO ORIENTE DO PIAUI',
    label: 'NOVO ORIENTE DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'NOVO SANTO ANTONIO',
    label: 'NOVO SANTO ANTONIO'
  },
  {
    stateKey: 'PI',
    value: 'OEIRAS',
    label: 'OEIRAS'
  },
  {
    stateKey: 'PI',
    value: 'OLHO DAGUA DO PIAUI',
    label: 'OLHO DAGUA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'PADRE MARCOS',
    label: 'PADRE MARCOS'
  },
  {
    stateKey: 'PI',
    value: 'PAES LANDIM',
    label: 'PAES LANDIM'
  },
  {
    stateKey: 'PI',
    value: 'PAJEU DO PIAUI',
    label: 'PAJEU DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'PALMEIRA DO PIAUI',
    label: 'PALMEIRA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'PALMEIRAIS',
    label: 'PALMEIRAIS'
  },
  {
    stateKey: 'PI',
    value: 'PAQUETA',
    label: 'PAQUETA'
  },
  {
    stateKey: 'PI',
    value: 'PARNAGUA',
    label: 'PARNAGUA'
  },
  {
    stateKey: 'PI',
    value: 'PARNAIBA',
    label: 'PARNAIBA'
  },
  {
    stateKey: 'PI',
    value: 'PASSAGEM FRANCA DO PIAUI',
    label: 'PASSAGEM FRANCA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'PATOS DO PIAUI',
    label: 'PATOS DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'PAULISTANA',
    label: 'PAULISTANA'
  },
  {
    stateKey: 'PI',
    value: 'PAVUSSU',
    label: 'PAVUSSU'
  },
  {
    stateKey: 'PI',
    value: 'PEDRO II',
    label: 'PEDRO II'
  },
  {
    stateKey: 'PI',
    value: 'PEDRO LAURENTINO',
    label: 'PEDRO LAURENTINO'
  },
  {
    stateKey: 'PI',
    value: 'PICOS',
    label: 'PICOS'
  },
  {
    stateKey: 'PI',
    value: 'PIMENTEIRAS',
    label: 'PIMENTEIRAS'
  },
  {
    stateKey: 'PI',
    value: 'PIO IX',
    label: 'PIO IX'
  },
  {
    stateKey: 'PI',
    value: 'PIRACURUCA',
    label: 'PIRACURUCA'
  },
  {
    stateKey: 'PI',
    value: 'PIRIPIRI',
    label: 'PIRIPIRI'
  },
  {
    stateKey: 'PI',
    value: 'PORTO',
    label: 'PORTO'
  },
  {
    stateKey: 'PI',
    value: 'PORTO ALEGRE DO PIAUI',
    label: 'PORTO ALEGRE DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'PRATA DO PIAUI',
    label: 'PRATA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'QUEIMADA NOVA',
    label: 'QUEIMADA NOVA'
  },
  {
    stateKey: 'PI',
    value: 'REDENCAO DO GURGUEIA',
    label: 'REDENCAO DO GURGUEIA'
  },
  {
    stateKey: 'PI',
    value: 'REGENERACAO',
    label: 'REGENERACAO'
  },
  {
    stateKey: 'PI',
    value: 'RIACHO FRIO',
    label: 'RIACHO FRIO'
  },
  {
    stateKey: 'PI',
    value: 'RIBEIRA DO PIAUI',
    label: 'RIBEIRA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'RIBEIRO GONCALVES',
    label: 'RIBEIRO GONCALVES'
  },
  {
    stateKey: 'PI',
    value: 'RIO GRANDE DO PIAUI',
    label: 'RIO GRANDE DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'SANTA CRUZ DO PIAUI',
    label: 'SANTA CRUZ DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'SANTA CRUZ DOS MILAGRES',
    label: 'SANTA CRUZ DOS MILAGRES'
  },
  {
    stateKey: 'PI',
    value: 'SANTA FILOMENA',
    label: 'SANTA FILOMENA'
  },
  {
    stateKey: 'PI',
    value: 'SANTA LUZ',
    label: 'SANTA LUZ'
  },
  {
    stateKey: 'PI',
    value: 'SANTA ROSA DO PIAUI',
    label: 'SANTA ROSA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'SANTANA DO PIAUI',
    label: 'SANTANA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'SANTO ANTONIO DE LISBOA',
    label: 'SANTO ANTONIO DE LISBOA'
  },
  {
    stateKey: 'PI',
    value: 'SANTO ANTONIO DOS MILAGRES',
    label: 'SANTO ANTONIO DOS MILAGRES'
  },
  {
    stateKey: 'PI',
    value: 'SANTO INACIO DO PIAUI',
    label: 'SANTO INACIO DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'SAO BRAZ DO PIAUI',
    label: 'SAO BRAZ DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'SAO FELIX DO PIAUI',
    label: 'SAO FELIX DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'SAO FRANCISCO DE ASSIS DO',
    label: 'SAO FRANCISCO DE ASSIS DO'
  },
  {
    stateKey: 'PI',
    value: 'SAO FRANCISCO DO PIAUI',
    label: 'SAO FRANCISCO DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'SAO GONCALO DO GURGUEIA',
    label: 'SAO GONCALO DO GURGUEIA'
  },
  {
    stateKey: 'PI',
    value: 'SAO GONCALO DO PIAUI',
    label: 'SAO GONCALO DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'SAO JOAO DA CANABRAVA',
    label: 'SAO JOAO DA CANABRAVA'
  },
  {
    stateKey: 'PI',
    value: 'SAO JOAO DA FRONTEIRA',
    label: 'SAO JOAO DA FRONTEIRA'
  },
  {
    stateKey: 'PI',
    value: 'SAO JOAO DA SERRA',
    label: 'SAO JOAO DA SERRA'
  },
  {
    stateKey: 'PI',
    value: 'SAO JOAO DA VARJOTA',
    label: 'SAO JOAO DA VARJOTA'
  },
  {
    stateKey: 'PI',
    value: 'SAO JOAO DO ARRAIAL',
    label: 'SAO JOAO DO ARRAIAL'
  },
  {
    stateKey: 'PI',
    value: 'SAO JOAO DO PIAUI',
    label: 'SAO JOAO DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'SAO JOSE DO DIVINO',
    label: 'SAO JOSE DO DIVINO'
  },
  {
    stateKey: 'PI',
    value: 'SAO JOSE DO PEIXE',
    label: 'SAO JOSE DO PEIXE'
  },
  {
    stateKey: 'PI',
    value: 'SAO JOSE DO PIAUI',
    label: 'SAO JOSE DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'SAO JULIAO',
    label: 'SAO JULIAO'
  },
  {
    stateKey: 'PI',
    value: 'SAO LOURENCO DO PIAUI',
    label: 'SAO LOURENCO DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'SAO LUIS DO PIAUI',
    label: 'SAO LUIS DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'SAO MIGUEL DA BAIXA GRANDE',
    label: 'SAO MIGUEL DA BAIXA GRANDE'
  },
  {
    stateKey: 'PI',
    value: 'SAO MIGUEL DO FIDALGO',
    label: 'SAO MIGUEL DO FIDALGO'
  },
  {
    stateKey: 'PI',
    value: 'SAO MIGUEL DO TAPUIO',
    label: 'SAO MIGUEL DO TAPUIO'
  },
  {
    stateKey: 'PI',
    value: 'SAO PEDRO DO PIAUI',
    label: 'SAO PEDRO DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'SAO RAIMUNDO NONATO',
    label: 'SAO RAIMUNDO NONATO'
  },
  {
    stateKey: 'PI',
    value: 'SEBASTIAO BARROS',
    label: 'SEBASTIAO BARROS'
  },
  {
    stateKey: 'PI',
    value: 'SEBASTIAO LEAL',
    label: 'SEBASTIAO LEAL'
  },
  {
    stateKey: 'PI',
    value: 'SIGEFREDO PACHECO',
    label: 'SIGEFREDO PACHECO'
  },
  {
    stateKey: 'PI',
    value: 'SIMOES',
    label: 'SIMOES'
  },
  {
    stateKey: 'PI',
    value: 'SIMPLICIO MENDES',
    label: 'SIMPLICIO MENDES'
  },
  {
    stateKey: 'PI',
    value: 'SOCORRO DO PIAUI',
    label: 'SOCORRO DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'SUSSUAPARA',
    label: 'SUSSUAPARA'
  },
  {
    stateKey: 'PI',
    value: 'TAMBORIL DO PIAUI',
    label: 'TAMBORIL DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'TANQUE DO PIAUI',
    label: 'TANQUE DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'TERESINA',
    label: 'TERESINA'
  },
  {
    stateKey: 'PI',
    value: 'UNIAO',
    label: 'UNIAO'
  },
  {
    stateKey: 'PI',
    value: 'URUCUI',
    label: 'URUCUI'
  },
  {
    stateKey: 'PI',
    value: 'VALENCA DO PIAUI',
    label: 'VALENCA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'VARZEA BRANCA',
    label: 'VARZEA BRANCA'
  },
  {
    stateKey: 'PI',
    value: 'VARZEA GRANDE',
    label: 'VARZEA GRANDE'
  },
  {
    stateKey: 'PI',
    value: 'VERA MENDES',
    label: 'VERA MENDES'
  },
  {
    stateKey: 'PI',
    value: 'VILA NOVA DO PIAUI',
    label: 'VILA NOVA DO PIAUI'
  },
  {
    stateKey: 'PI',
    value: 'WALL FERRAZ',
    label: 'WALL FERRAZ'
  },
  {
    stateKey: 'PI',
    value: 'COCAL DO ALVES',
    label: 'COCAL DO ALVES'
  },
  {
    stateKey: 'PI',
    value: 'AGUA BRANCA',
    label: 'AGUA BRANCA'
  },
  {
    stateKey: 'PI',
    value: 'BATALHA',
    label: 'BATALHA'
  },
  {
    stateKey: 'PI',
    value: 'NAZARIA',
    label: 'NAZARIA'
  },
  {
    stateKey: 'RJ',
    value: 'MESQUITA',
    label: 'MESQUITA'
  },
  {
    stateKey: 'RJ',
    value: 'ANGRA DOS REIS',
    label: 'ANGRA DOS REIS'
  },
  {
    stateKey: 'RJ',
    value: 'APERIBE',
    label: 'APERIBE'
  },
  {
    stateKey: 'RJ',
    value: 'ARARUAMA',
    label: 'ARARUAMA'
  },
  {
    stateKey: 'RJ',
    value: 'AREAL',
    label: 'AREAL'
  },
  {
    stateKey: 'RJ',
    value: 'ARRAIAL DO CABO',
    label: 'ARRAIAL DO CABO'
  },
  {
    stateKey: 'RJ',
    value: 'BARRA DO PIRAI',
    label: 'BARRA DO PIRAI'
  },
  {
    stateKey: 'RJ',
    value: 'BARRA MANSA',
    label: 'BARRA MANSA'
  },
  {
    stateKey: 'RJ',
    value: 'BELFORD ROXO',
    label: 'BELFORD ROXO'
  },
  {
    stateKey: 'RJ',
    value: 'BOM JARDIM',
    label: 'BOM JARDIM'
  },
  {
    stateKey: 'RJ',
    value: 'BOM JESUS DO ITABAPOANA',
    label: 'BOM JESUS DO ITABAPOANA'
  },
  {
    stateKey: 'RJ',
    value: 'CABO FRIO',
    label: 'CABO FRIO'
  },
  {
    stateKey: 'RJ',
    value: 'CACHOEIRAS DE MACACU',
    label: 'CACHOEIRAS DE MACACU'
  },
  {
    stateKey: 'RJ',
    value: 'CAMBUCI',
    label: 'CAMBUCI'
  },
  {
    stateKey: 'RJ',
    value: 'CANTAGALO',
    label: 'CANTAGALO'
  },
  {
    stateKey: 'RJ',
    value: 'CARAPEBUS',
    label: 'CARAPEBUS'
  },
  {
    stateKey: 'RJ',
    value: 'CARDOSO MOREIRA',
    label: 'CARDOSO MOREIRA'
  },
  {
    stateKey: 'RJ',
    value: 'CARMO',
    label: 'CARMO'
  },
  {
    stateKey: 'RJ',
    value: 'CASIMIRO DE ABREU',
    label: 'CASIMIRO DE ABREU'
  },
  {
    stateKey: 'RJ',
    value: 'COMENDADOR LEVY GASPARIAN',
    label: 'COMENDADOR LEVY GASPARIAN'
  },
  {
    stateKey: 'RJ',
    value: 'CONCEICAO DE MACABU',
    label: 'CONCEICAO DE MACABU'
  },
  {
    stateKey: 'RJ',
    value: 'CORDEIRO',
    label: 'CORDEIRO'
  },
  {
    stateKey: 'RJ',
    value: 'DUAS BARRAS',
    label: 'DUAS BARRAS'
  },
  {
    stateKey: 'RJ',
    value: 'DUQUE DE CAXIAS',
    label: 'DUQUE DE CAXIAS'
  },
  {
    stateKey: 'RJ',
    value: 'ENGENHEIRO PAULO DE FRONTI',
    label: 'ENGENHEIRO PAULO DE FRONTI'
  },
  {
    stateKey: 'RJ',
    value: 'GUAPIMIRIM',
    label: 'GUAPIMIRIM'
  },
  {
    stateKey: 'RJ',
    value: 'IGUABA GRANDE',
    label: 'IGUABA GRANDE'
  },
  {
    stateKey: 'RJ',
    value: 'ITABORAI',
    label: 'ITABORAI'
  },
  {
    stateKey: 'RJ',
    value: 'ITAGUAI',
    label: 'ITAGUAI'
  },
  {
    stateKey: 'RJ',
    value: 'ITALVA',
    label: 'ITALVA'
  },
  {
    stateKey: 'RJ',
    value: 'ITAOCARA',
    label: 'ITAOCARA'
  },
  {
    stateKey: 'RJ',
    value: 'ITAPERUNA',
    label: 'ITAPERUNA'
  },
  {
    stateKey: 'RJ',
    value: 'ITATIAIA',
    label: 'ITATIAIA'
  },
  {
    stateKey: 'RJ',
    value: 'JAPERI',
    label: 'JAPERI'
  },
  {
    stateKey: 'RJ',
    value: 'LAJE DO MURIAE',
    label: 'LAJE DO MURIAE'
  },
  {
    stateKey: 'RJ',
    value: 'MACAE',
    label: 'MACAE'
  },
  {
    stateKey: 'RJ',
    value: 'MACUCO',
    label: 'MACUCO'
  },
  {
    stateKey: 'RJ',
    value: 'MAGE',
    label: 'MAGE'
  },
  {
    stateKey: 'RJ',
    value: 'MANGARATIBA',
    label: 'MANGARATIBA'
  },
  {
    stateKey: 'RJ',
    value: 'MARICA',
    label: 'MARICA'
  },
  {
    stateKey: 'RJ',
    value: 'MENDES',
    label: 'MENDES'
  },
  {
    stateKey: 'RJ',
    value: 'MIGUEL PEREIRA',
    label: 'MIGUEL PEREIRA'
  },
  {
    stateKey: 'RJ',
    value: 'MIRACEMA',
    label: 'MIRACEMA'
  },
  {
    stateKey: 'RJ',
    value: 'NATIVIDADE',
    label: 'NATIVIDADE'
  },
  {
    stateKey: 'RJ',
    value: 'NILOPOLIS',
    label: 'NILOPOLIS'
  },
  {
    stateKey: 'RJ',
    value: 'NITEROI',
    label: 'NITEROI'
  },
  {
    stateKey: 'RJ',
    value: 'NOVA FRIBURGO',
    label: 'NOVA FRIBURGO'
  },
  {
    stateKey: 'RJ',
    value: 'NOVA IGUACU',
    label: 'NOVA IGUACU'
  },
  {
    stateKey: 'RJ',
    value: 'PARACAMBI',
    label: 'PARACAMBI'
  },
  {
    stateKey: 'RJ',
    value: 'PARAIBA DO SUL',
    label: 'PARAIBA DO SUL'
  },
  {
    stateKey: 'RJ',
    value: 'PARATI',
    label: 'PARATI'
  },
  {
    stateKey: 'RJ',
    value: 'PETROPOLIS',
    label: 'PETROPOLIS'
  },
  {
    stateKey: 'RJ',
    value: 'PINHEIRAL',
    label: 'PINHEIRAL'
  },
  {
    stateKey: 'RJ',
    value: 'PIRAI',
    label: 'PIRAI'
  },
  {
    stateKey: 'RJ',
    value: 'PORCIUNCULA',
    label: 'PORCIUNCULA'
  },
  {
    stateKey: 'RJ',
    value: 'PORTO REAL',
    label: 'PORTO REAL'
  },
  {
    stateKey: 'RJ',
    value: 'QUATIS',
    label: 'QUATIS'
  },
  {
    stateKey: 'RJ',
    value: 'QUEIMADOS',
    label: 'QUEIMADOS'
  },
  {
    stateKey: 'RJ',
    value: 'QUISSAMA',
    label: 'QUISSAMA'
  },
  {
    stateKey: 'RJ',
    value: 'RESENDE',
    label: 'RESENDE'
  },
  {
    stateKey: 'RJ',
    value: 'RIO BONITO',
    label: 'RIO BONITO'
  },
  {
    stateKey: 'RJ',
    value: 'RIO CLARO',
    label: 'RIO CLARO'
  },
  {
    stateKey: 'RJ',
    value: 'RIO DAS FLORES',
    label: 'RIO DAS FLORES'
  },
  {
    stateKey: 'RJ',
    value: 'RIO DAS OSTRAS',
    label: 'RIO DAS OSTRAS'
  },
  {
    stateKey: 'RJ',
    value: 'RIO DE JANEIRO',
    label: 'RIO DE JANEIRO'
  },
  {
    stateKey: 'RJ',
    value: 'SANTA MARIA MADALENA',
    label: 'SANTA MARIA MADALENA'
  },
  {
    stateKey: 'RJ',
    value: 'SANTO ANTONIO DE PADUA',
    label: 'SANTO ANTONIO DE PADUA'
  },
  {
    stateKey: 'RJ',
    value: 'SAO FIDELIS',
    label: 'SAO FIDELIS'
  },
  {
    stateKey: 'RJ',
    value: 'SAO FRANCISCO DE ITABAPOAN',
    label: 'SAO FRANCISCO DE ITABAPOAN'
  },
  {
    stateKey: 'RJ',
    value: 'SAO GONCALO',
    label: 'SAO GONCALO'
  },
  {
    stateKey: 'RJ',
    value: 'SAO JOAO DA BARRA',
    label: 'SAO JOAO DA BARRA'
  },
  {
    stateKey: 'RJ',
    value: 'SAO JOAO DE MERITI',
    label: 'SAO JOAO DE MERITI'
  },
  {
    stateKey: 'RJ',
    value: 'SAO JOSE DE UBA',
    label: 'SAO JOSE DE UBA'
  },
  {
    stateKey: 'RJ',
    value: 'SAO JOSE DO VALE DO RIO PR',
    label: 'SAO JOSE DO VALE DO RIO PR'
  },
  {
    stateKey: 'RJ',
    value: 'SAO PEDRO DA ALDEIA',
    label: 'SAO PEDRO DA ALDEIA'
  },
  {
    stateKey: 'RJ',
    value: 'SAO SEBASTIAO DO ALTO',
    label: 'SAO SEBASTIAO DO ALTO'
  },
  {
    stateKey: 'RJ',
    value: 'SAPUCAIA',
    label: 'SAPUCAIA'
  },
  {
    stateKey: 'RJ',
    value: 'SAQUAREMA',
    label: 'SAQUAREMA'
  },
  {
    stateKey: 'RJ',
    value: 'SEROPEDICA',
    label: 'SEROPEDICA'
  },
  {
    stateKey: 'RJ',
    value: 'SILVA JARDIM',
    label: 'SILVA JARDIM'
  },
  {
    stateKey: 'RJ',
    value: 'SUMIDOURO',
    label: 'SUMIDOURO'
  },
  {
    stateKey: 'RJ',
    value: 'TANGUA',
    label: 'TANGUA'
  },
  {
    stateKey: 'RJ',
    value: 'TERESOPOLIS',
    label: 'TERESOPOLIS'
  },
  {
    stateKey: 'RJ',
    value: 'TRAJANO DE MORAIS',
    label: 'TRAJANO DE MORAIS'
  },
  {
    stateKey: 'RJ',
    value: 'TRES RIOS',
    label: 'TRES RIOS'
  },
  {
    stateKey: 'RJ',
    value: 'VALENCA',
    label: 'VALENCA'
  },
  {
    stateKey: 'RJ',
    value: 'VARRE-SAI',
    label: 'VARRE-SAI'
  },
  {
    stateKey: 'RJ',
    value: 'VASSOURAS',
    label: 'VASSOURAS'
  },
  {
    stateKey: 'RJ',
    value: 'VOLTA REDONDA',
    label: 'VOLTA REDONDA'
  },
  {
    stateKey: 'RJ',
    value: 'ARMACAO DOS BUZIOS',
    label: 'ARMACAO DOS BUZIOS'
  },
  {
    stateKey: 'RJ',
    value: 'CAMPOS DOS GOYTACAZES',
    label: 'CAMPOS DOS GOYTACAZES'
  },
  {
    stateKey: 'RJ',
    value: 'PATY DO ALFERES',
    label: 'PATY DO ALFERES'
  },
  {
    stateKey: 'RN',
    value: 'Augusto Severo',
    label: 'Augusto Severo'
  },
  {
    stateKey: 'RN',
    value: 'Januário Cicco',
    label: 'Januário Cicco'
  },
  {
    stateKey: 'RN',
    value: 'Jundiá',
    label: 'Jundiá'
  },
  {
    stateKey: 'RN',
    value: 'Paraú',
    label: 'Paraú'
  },
  {
    stateKey: 'RN',
    value: 'Presidente Juscelino',
    label: 'Presidente Juscelino'
  },
  {
    stateKey: 'RN',
    value: 'ACARI',
    label: 'ACARI'
  },
  {
    stateKey: 'RN',
    value: 'ACU',
    label: 'ACU'
  },
  {
    stateKey: 'RN',
    value: 'AFONSO BEZERRA',
    label: 'AFONSO BEZERRA'
  },
  {
    stateKey: 'RN',
    value: 'AGUA NOVA',
    label: 'AGUA NOVA'
  },
  {
    stateKey: 'RN',
    value: 'ALEXANDRIA',
    label: 'ALEXANDRIA'
  },
  {
    stateKey: 'RN',
    value: 'ALMINO AFONSO',
    label: 'ALMINO AFONSO'
  },
  {
    stateKey: 'RN',
    value: 'ALTO DO RODRIGUES',
    label: 'ALTO DO RODRIGUES'
  },
  {
    stateKey: 'RN',
    value: 'ANGICOS',
    label: 'ANGICOS'
  },
  {
    stateKey: 'RN',
    value: 'ANTONIO MARTINS',
    label: 'ANTONIO MARTINS'
  },
  {
    stateKey: 'RN',
    value: 'APODI',
    label: 'APODI'
  },
  {
    stateKey: 'RN',
    value: 'AREIA BRANCA',
    label: 'AREIA BRANCA'
  },
  {
    stateKey: 'RN',
    value: 'ARES',
    label: 'ARES'
  },
  {
    stateKey: 'RN',
    value: 'BAIA FORMOSA',
    label: 'BAIA FORMOSA'
  },
  {
    stateKey: 'RN',
    value: 'BARAUNA',
    label: 'BARAUNA'
  },
  {
    stateKey: 'RN',
    value: 'BARCELONA',
    label: 'BARCELONA'
  },
  {
    stateKey: 'RN',
    value: 'BENTO FERNANDES',
    label: 'BENTO FERNANDES'
  },
  {
    stateKey: 'RN',
    value: 'BODO',
    label: 'BODO'
  },
  {
    stateKey: 'RN',
    value: 'BOM JESUS',
    label: 'BOM JESUS'
  },
  {
    stateKey: 'RN',
    value: 'BREJINHO',
    label: 'BREJINHO'
  },
  {
    stateKey: 'RN',
    value: 'CAICARA DO NORTE',
    label: 'CAICARA DO NORTE'
  },
  {
    stateKey: 'RN',
    value: 'CAICARA DO RIO DO VENTO',
    label: 'CAICARA DO RIO DO VENTO'
  },
  {
    stateKey: 'RN',
    value: 'CAICO',
    label: 'CAICO'
  },
  {
    stateKey: 'RN',
    value: 'CAMPO REDONDO',
    label: 'CAMPO REDONDO'
  },
  {
    stateKey: 'RN',
    value: 'CANGUARETAMA',
    label: 'CANGUARETAMA'
  },
  {
    stateKey: 'RN',
    value: 'CARAUBAS',
    label: 'CARAUBAS'
  },
  {
    stateKey: 'RN',
    value: 'CARNAUBA DOS DANTAS',
    label: 'CARNAUBA DOS DANTAS'
  },
  {
    stateKey: 'RN',
    value: 'CARNAUBAIS',
    label: 'CARNAUBAIS'
  },
  {
    stateKey: 'RN',
    value: 'CEARA-MIRIM',
    label: 'CEARA-MIRIM'
  },
  {
    stateKey: 'RN',
    value: 'CERRO CORA',
    label: 'CERRO CORA'
  },
  {
    stateKey: 'RN',
    value: 'CORONEL EZEQUIEL',
    label: 'CORONEL EZEQUIEL'
  },
  {
    stateKey: 'RN',
    value: 'CORONEL JOAO PESSOA',
    label: 'CORONEL JOAO PESSOA'
  },
  {
    stateKey: 'RN',
    value: 'CRUZETA',
    label: 'CRUZETA'
  },
  {
    stateKey: 'RN',
    value: 'CURRAIS NOVOS',
    label: 'CURRAIS NOVOS'
  },
  {
    stateKey: 'RN',
    value: 'DOUTOR SEVERIANO',
    label: 'DOUTOR SEVERIANO'
  },
  {
    stateKey: 'RN',
    value: 'ENCANTO',
    label: 'ENCANTO'
  },
  {
    stateKey: 'RN',
    value: 'EQUADOR',
    label: 'EQUADOR'
  },
  {
    stateKey: 'RN',
    value: 'ESPIRITO SANTO',
    label: 'ESPIRITO SANTO'
  },
  {
    stateKey: 'RN',
    value: 'EXTREMOZ',
    label: 'EXTREMOZ'
  },
  {
    stateKey: 'RN',
    value: 'FELIPE GUERRA',
    label: 'FELIPE GUERRA'
  },
  {
    stateKey: 'RN',
    value: 'FERNANDO PEDROSA',
    label: 'FERNANDO PEDROSA'
  },
  {
    stateKey: 'RN',
    value: 'FLORANIA',
    label: 'FLORANIA '
  },
  {
    stateKey: 'RN',
    value: 'FRANCISCO DANTAS',
    label: 'FRANCISCO DANTAS'
  },
  {
    stateKey: 'RN',
    value: 'FRUTUOSO GOMES',
    label: 'FRUTUOSO GOMES'
  },
  {
    stateKey: 'RN',
    value: 'GALINHOS',
    label: 'GALINHOS'
  },
  {
    stateKey: 'RN',
    value: 'GOIANINHA',
    label: 'GOIANINHA'
  },
  {
    stateKey: 'RN',
    value: 'GOVERNADOR DIX-SEPT ROSADO',
    label: 'GOVERNADOR DIX-SEPT ROSADO'
  },
  {
    stateKey: 'RN',
    value: 'GROSSOS',
    label: 'GROSSOS'
  },
  {
    stateKey: 'RN',
    value: 'GUAMARE',
    label: 'GUAMARE'
  },
  {
    stateKey: 'RN',
    value: 'IELMO MARINHO',
    label: 'IELMO MARINHO'
  },
  {
    stateKey: 'RN',
    value: 'IPANGUACU',
    label: 'IPANGUACU'
  },
  {
    stateKey: 'RN',
    value: 'IPUEIRA',
    label: 'IPUEIRA'
  },
  {
    stateKey: 'RN',
    value: 'ITAJA',
    label: 'ITAJA'
  },
  {
    stateKey: 'RN',
    value: 'ITAU',
    label: 'ITAU'
  },
  {
    stateKey: 'RN',
    value: 'JACANA',
    label: 'JACANA'
  },
  {
    stateKey: 'RN',
    value: 'JANDAIRA',
    label: 'JANDAIRA'
  },
  {
    stateKey: 'RN',
    value: 'JANDUIS',
    label: 'JANDUIS'
  },
  {
    stateKey: 'RN',
    value: 'JAPI',
    label: 'JAPI'
  },
  {
    stateKey: 'RN',
    value: 'JARDIM DE ANGICOS',
    label: 'JARDIM DE ANGICOS'
  },
  {
    stateKey: 'RN',
    value: 'JARDIM DE PIRANHAS',
    label: 'JARDIM DE PIRANHAS'
  },
  {
    stateKey: 'RN',
    value: 'JARDIM DO SERIDO',
    label: 'JARDIM DO SERIDO'
  },
  {
    stateKey: 'RN',
    value: 'JOAO CAMARA',
    label: 'JOAO CAMARA'
  },
  {
    stateKey: 'RN',
    value: 'JOAO DIAS',
    label: 'JOAO DIAS'
  },
  {
    stateKey: 'RN',
    value: 'JOSE DA PENHA',
    label: 'JOSE DA PENHA'
  },
  {
    stateKey: 'RN',
    value: 'JUCURUTU',
    label: 'JUCURUTU'
  },
  {
    stateKey: 'RN',
    value: "LAGOA D'ANTA",
    label: "LAGOA D'ANTA"
  },
  {
    stateKey: 'RN',
    value: 'LAGOA DE PEDRAS',
    label: 'LAGOA DE PEDRAS'
  },
  {
    stateKey: 'RN',
    value: 'LAGOA DE VELHOS',
    label: 'LAGOA DE VELHOS'
  },
  {
    stateKey: 'RN',
    value: 'LAGOA NOVA',
    label: 'LAGOA NOVA'
  },
  {
    stateKey: 'RN',
    value: 'LAGOA SALGADA',
    label: 'LAGOA SALGADA'
  },
  {
    stateKey: 'RN',
    value: 'LAJES',
    label: 'LAJES'
  },
  {
    stateKey: 'RN',
    value: 'LAJES PINTADAS',
    label: 'LAJES PINTADAS'
  },
  {
    stateKey: 'RN',
    value: 'LUCRECIA',
    label: 'LUCRECIA'
  },
  {
    stateKey: 'RN',
    value: 'LUIS GOMES',
    label: 'LUIS GOMES'
  },
  {
    stateKey: 'RN',
    value: 'MACAIBA',
    label: 'MACAIBA'
  },
  {
    stateKey: 'RN',
    value: 'MACAU',
    label: 'MACAU'
  },
  {
    stateKey: 'RN',
    value: 'MAJOR SALES',
    label: 'MAJOR SALES'
  },
  {
    stateKey: 'RN',
    value: 'MARCELINO VIEIRA',
    label: 'MARCELINO VIEIRA'
  },
  {
    stateKey: 'RN',
    value: 'MARTINS',
    label: 'MARTINS'
  },
  {
    stateKey: 'RN',
    value: 'MAXARANGUAPE',
    label: 'MAXARANGUAPE'
  },
  {
    stateKey: 'RN',
    value: 'MESSIAS TARGINO',
    label: 'MESSIAS TARGINO'
  },
  {
    stateKey: 'RN',
    value: 'MONTANHAS',
    label: 'MONTANHAS'
  },
  {
    stateKey: 'RN',
    value: 'MONTE ALEGRE',
    label: 'MONTE ALEGRE'
  },
  {
    stateKey: 'RN',
    value: 'MONTE DAS GAMELEIRAS',
    label: 'MONTE DAS GAMELEIRAS'
  },
  {
    stateKey: 'RN',
    value: 'MOSSORO',
    label: 'MOSSORO'
  },
  {
    stateKey: 'RN',
    value: 'NATAL',
    label: 'NATAL'
  },
  {
    stateKey: 'RN',
    value: 'NISIA FLORESTA',
    label: 'NISIA FLORESTA'
  },
  {
    stateKey: 'RN',
    value: 'NOVA CRUZ',
    label: 'NOVA CRUZ'
  },
  {
    stateKey: 'RN',
    value: "OLHO D'AGUA DO BORGES",
    label: "OLHO D'AGUA DO BORGES"
  },
  {
    stateKey: 'RN',
    value: 'OURO BRANCO',
    label: 'OURO BRANCO'
  },
  {
    stateKey: 'RN',
    value: 'PARANA',
    label: 'PARANA'
  },
  {
    stateKey: 'RN',
    value: 'PARAZINHO',
    label: 'PARAZINHO'
  },
  {
    stateKey: 'RN',
    value: 'PARELHAS',
    label: 'PARELHAS'
  },
  {
    stateKey: 'RN',
    value: 'PARNAMIRIM',
    label: 'PARNAMIRIM'
  },
  {
    stateKey: 'RN',
    value: 'PASSA E FICA',
    label: 'PASSA E FICA'
  },
  {
    stateKey: 'RN',
    value: 'PASSAGEM',
    label: 'PASSAGEM'
  },
  {
    stateKey: 'RN',
    value: 'PATU',
    label: 'PATU'
  },
  {
    stateKey: 'RN',
    value: 'PAU DOS FERROS',
    label: 'PAU DOS FERROS'
  },
  {
    stateKey: 'RN',
    value: 'PEDRA GRANDE',
    label: 'PEDRA GRANDE'
  },
  {
    stateKey: 'RN',
    value: 'PEDRA PRETA',
    label: 'PEDRA PRETA'
  },
  {
    stateKey: 'RN',
    value: 'PEDRO AVELINO',
    label: 'PEDRO AVELINO'
  },
  {
    stateKey: 'RN',
    value: 'PEDRO VELHO',
    label: 'PEDRO VELHO'
  },
  {
    stateKey: 'RN',
    value: 'PENDENCIAS',
    label: 'PENDENCIAS'
  },
  {
    stateKey: 'RN',
    value: 'PILOES',
    label: 'PILOES'
  },
  {
    stateKey: 'RN',
    value: 'POCO BRANCO',
    label: 'POCO BRANCO'
  },
  {
    stateKey: 'RN',
    value: 'PORTALEGRE',
    label: 'PORTALEGRE'
  },
  {
    stateKey: 'RN',
    value: 'PORTO DO MANGUE',
    label: 'PORTO DO MANGUE'
  },
  {
    stateKey: 'RN',
    value: 'PUREZA',
    label: 'PUREZA'
  },
  {
    stateKey: 'RN',
    value: 'RAFAEL FERNANDES',
    label: 'RAFAEL FERNANDES'
  },
  {
    stateKey: 'RN',
    value: 'RAFAEL GODEIRO',
    label: 'RAFAEL GODEIRO'
  },
  {
    stateKey: 'RN',
    value: 'RIACHO DA CRUZ',
    label: 'RIACHO DA CRUZ'
  },
  {
    stateKey: 'RN',
    value: 'RIACHO DE SANTANA',
    label: 'RIACHO DE SANTANA'
  },
  {
    stateKey: 'RN',
    value: 'RIACHUELO',
    label: 'RIACHUELO'
  },
  {
    stateKey: 'RN',
    value: 'RIO DO FOGO',
    label: 'RIO DO FOGO'
  },
  {
    stateKey: 'RN',
    value: 'RODOLFO FERNANDES',
    label: 'RODOLFO FERNANDES'
  },
  {
    stateKey: 'RN',
    value: 'RUY BARBOSA',
    label: 'RUY BARBOSA'
  },
  {
    stateKey: 'RN',
    value: 'SANTA CRUZ',
    label: 'SANTA CRUZ'
  },
  {
    stateKey: 'RN',
    value: 'SANTA MARIA',
    label: 'SANTA MARIA'
  },
  {
    stateKey: 'RN',
    value: 'SANTANA DO MATOS',
    label: 'SANTANA DO MATOS'
  },
  {
    stateKey: 'RN',
    value: 'SANTANA DO SERIDO',
    label: 'SANTANA DO SERIDO'
  },
  {
    stateKey: 'RN',
    value: 'SANTO ANTONIO',
    label: 'SANTO ANTONIO'
  },
  {
    stateKey: 'RN',
    value: 'SAO BENTO DO NORTE',
    label: 'SAO BENTO DO NORTE'
  },
  {
    stateKey: 'RN',
    value: 'SAO BENTO DO TRAIRI',
    label: 'SAO BENTO DO TRAIRI'
  },
  {
    stateKey: 'RN',
    value: 'SAO FERNANDO',
    label: 'SAO FERNANDO'
  },
  {
    stateKey: 'RN',
    value: 'SAO FRANCISCO DO OESTE',
    label: 'SAO FRANCISCO DO OESTE'
  },
  {
    stateKey: 'RN',
    value: 'SAO GONCALO DO AMARANTE',
    label: 'SAO GONCALO DO AMARANTE'
  },
  {
    stateKey: 'RN',
    value: 'SAO JOAO DO SABUGI',
    label: 'SAO JOAO DO SABUGI'
  },
  {
    stateKey: 'RN',
    value: 'SAO JOSE DE MIPIBU',
    label: 'SAO JOSE DE MIPIBU'
  },
  {
    stateKey: 'RN',
    value: 'SAO JOSE DO CAMPESTRE',
    label: 'SAO JOSE DO CAMPESTRE'
  },
  {
    stateKey: 'RN',
    value: 'SAO JOSE DO SERIDO',
    label: 'SAO JOSE DO SERIDO'
  },
  {
    stateKey: 'RN',
    value: 'SAO MIGUEL',
    label: 'SAO MIGUEL'
  },
  {
    stateKey: 'RN',
    value: 'SAO MIGUEL DE TOUROS',
    label: 'SAO MIGUEL DE TOUROS'
  },
  {
    stateKey: 'RN',
    value: 'SAO PAULO DO POTENGI',
    label: 'SAO PAULO DO POTENGI'
  },
  {
    stateKey: 'RN',
    value: 'SAO PEDRO',
    label: 'SAO PEDRO'
  },
  {
    stateKey: 'RN',
    value: 'SAO RAFAEL',
    label: 'SAO RAFAEL'
  },
  {
    stateKey: 'RN',
    value: 'SAO TOME',
    label: 'SAO TOME'
  },
  {
    stateKey: 'RN',
    value: 'SAO VICENTE',
    label: 'SAO VICENTE'
  },
  {
    stateKey: 'RN',
    value: 'SENADOR ELOI DE SOUZA',
    label: 'SENADOR ELOI DE SOUZA'
  },
  {
    stateKey: 'RN',
    value: 'SENADOR GEORGINO AVELINO',
    label: 'SENADOR GEORGINO AVELINO'
  },
  {
    stateKey: 'RN',
    value: 'SERRA DE SAO BENTO',
    label: 'SERRA DE SAO BENTO'
  },
  {
    stateKey: 'RN',
    value: 'SERRA DO MEL',
    label: 'SERRA DO MEL'
  },
  {
    stateKey: 'RN',
    value: 'SERRA NEGRA DO NORTE',
    label: 'SERRA NEGRA DO NORTE'
  },
  {
    stateKey: 'RN',
    value: 'SERRINHA',
    label: 'SERRINHA'
  },
  {
    stateKey: 'RN',
    value: 'SERRINHA DOS PINTOS',
    label: 'SERRINHA DOS PINTOS'
  },
  {
    stateKey: 'RN',
    value: 'SEVERIANO MELO',
    label: 'SEVERIANO MELO'
  },
  {
    stateKey: 'RN',
    value: 'SITIO NOVO',
    label: 'SITIO NOVO'
  },
  {
    stateKey: 'RN',
    value: 'TABOLEIRO GRANDE',
    label: 'TABOLEIRO GRANDE'
  },
  {
    stateKey: 'RN',
    value: 'TAIPU',
    label: 'TAIPU'
  },
  {
    stateKey: 'RN',
    value: 'TANGARA',
    label: 'TANGARA'
  },
  {
    stateKey: 'RN',
    value: 'TENENTE ANANIAS',
    label: 'TENENTE ANANIAS'
  },
  {
    stateKey: 'RN',
    value: 'TENENTE LAURENTINO CRUZ',
    label: 'TENENTE LAURENTINO CRUZ'
  },
  {
    stateKey: 'RN',
    value: 'TIBAU',
    label: 'TIBAU'
  },
  {
    stateKey: 'RN',
    value: 'TIBAU DO SUL',
    label: 'TIBAU DO SUL'
  },
  {
    stateKey: 'RN',
    value: 'TIMBAUBA DOS BATISTAS',
    label: 'TIMBAUBA DOS BATISTAS'
  },
  {
    stateKey: 'RN',
    value: 'TOUROS',
    label: 'TOUROS'
  },
  {
    stateKey: 'RN',
    value: 'TRIUNFO POTIGUAR',
    label: 'TRIUNFO POTIGUAR'
  },
  {
    stateKey: 'RN',
    value: 'UMARIZAL',
    label: 'UMARIZAL'
  },
  {
    stateKey: 'RN',
    value: 'UPANEMA',
    label: 'UPANEMA'
  },
  {
    stateKey: 'RN',
    value: 'VARZEA',
    label: 'VARZEA'
  },
  {
    stateKey: 'RN',
    value: 'VENHA VER',
    label: 'VENHA VER'
  },
  {
    stateKey: 'RN',
    value: 'VERA CRUZ',
    label: 'VERA CRUZ'
  },
  {
    stateKey: 'RN',
    value: 'VICOSA',
    label: 'VICOSA'
  },
  {
    stateKey: 'RN',
    value: 'VILA FLOR',
    label: 'VILA FLOR'
  },
  {
    stateKey: 'RN',
    value: 'ASSU',
    label: 'ASSU'
  },
  {
    stateKey: 'RS',
    value: 'SANTA CRUZ DO SUL',
    label: 'SANTA CRUZ DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'ARROIO DO PADRE',
    label: 'ARROIO DO PADRE'
  },
  {
    stateKey: 'RS',
    value: 'SÃO JOSÉ DO SUL',
    label: 'SÃO JOSÉ DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'SAO LUIZ GONZAGA',
    label: 'SAO LUIZ GONZAGA'
  },
  {
    stateKey: 'RS',
    value: 'Barra do Quarai',
    label: 'Barra do Quarai'
  },
  {
    stateKey: 'RS',
    value: 'SANTA CECILIA DO SUL',
    label: 'SANTA CECILIA DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'Canudos do Vale',
    label: 'Canudos do Vale'
  },
  {
    stateKey: 'RS',
    value: 'Coqueiro Baixo',
    label: 'Coqueiro Baixo'
  },
  {
    stateKey: 'RS',
    value: 'Coronel Pilar',
    label: 'Coronel Pilar'
  },
  {
    stateKey: 'RS',
    value: 'Forquetinha',
    label: 'Forquetinha'
  },
  {
    stateKey: 'RS',
    value: 'Itati',
    label: 'Itati '
  },
  {
    stateKey: 'RS',
    value: 'Lagoa Bonita do Sul',
    label: 'Lagoa Bonita do Sul'
  },
  {
    stateKey: 'RS',
    value: 'Novo Xingu',
    label: 'Novo Xingu'
  },
  {
    stateKey: 'RS',
    value: 'São Pedro das Missões',
    label: 'São Pedro das Missões'
  },
  {
    stateKey: 'RS',
    value: 'Westfalia',
    label: 'Westfalia'
  },
  {
    stateKey: 'RS',
    value: 'AGUA SANTA',
    label: 'AGUA SANTA'
  },
  {
    stateKey: 'RS',
    value: 'AGUDO',
    label: 'AGUDO'
  },
  {
    stateKey: 'RS',
    value: 'AJURICABA',
    label: 'AJURICABA'
  },
  {
    stateKey: 'RS',
    value: 'ALECRIM',
    label: 'ALECRIM'
  },
  {
    stateKey: 'RS',
    value: 'ALEGRETE',
    label: 'ALEGRETE'
  },
  {
    stateKey: 'RS',
    value: 'ALEGRIA',
    label: 'ALEGRIA'
  },
  {
    stateKey: 'RS',
    value: 'ALPESTRE',
    label: 'ALPESTRE'
  },
  {
    stateKey: 'RS',
    value: 'ALTO ALEGRE',
    label: 'ALTO ALEGRE'
  },
  {
    stateKey: 'RS',
    value: 'ALTO FELIZ',
    label: 'ALTO FELIZ'
  },
  {
    stateKey: 'RS',
    value: 'ALVORADA',
    label: 'ALVORADA'
  },
  {
    stateKey: 'RS',
    value: 'AMARAL FERRADOR',
    label: 'AMARAL FERRADOR'
  },
  {
    stateKey: 'RS',
    value: 'AMETISTA DO SUL',
    label: 'AMETISTA DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'ANDRE DA ROCHA',
    label: 'ANDRE DA ROCHA'
  },
  {
    stateKey: 'RS',
    value: 'ANTA GORDA',
    label: 'ANTA GORDA'
  },
  {
    stateKey: 'RS',
    value: 'ANTONIO PRADO',
    label: 'ANTONIO PRADO'
  },
  {
    stateKey: 'RS',
    value: 'ARAMBARE',
    label: 'ARAMBARE'
  },
  {
    stateKey: 'RS',
    value: 'ARARICA',
    label: 'ARARICA'
  },
  {
    stateKey: 'RS',
    value: 'ARATIBA',
    label: 'ARATIBA'
  },
  {
    stateKey: 'RS',
    value: 'ARROIO DO MEIO',
    label: 'ARROIO DO MEIO'
  },
  {
    stateKey: 'RS',
    value: 'ARROIO DO SAL',
    label: 'ARROIO DO SAL'
  },
  {
    stateKey: 'RS',
    value: 'ARROIO DO TIGRE',
    label: 'ARROIO DO TIGRE'
  },
  {
    stateKey: 'RS',
    value: 'ARROIO DOS RATOS',
    label: 'ARROIO DOS RATOS'
  },
  {
    stateKey: 'RS',
    value: 'ARROIO GRANDE',
    label: 'ARROIO GRANDE'
  },
  {
    stateKey: 'RS',
    value: 'ARVOREZINHA',
    label: 'ARVOREZINHA'
  },
  {
    stateKey: 'RS',
    value: 'AUGUSTO PESTANA',
    label: 'AUGUSTO PESTANA'
  },
  {
    stateKey: 'RS',
    value: 'AUREA',
    label: 'AUREA'
  },
  {
    stateKey: 'RS',
    value: 'BAGE',
    label: 'BAGE'
  },
  {
    stateKey: 'RS',
    value: 'BALNEARIO PINHAL',
    label: 'BALNEARIO PINHAL'
  },
  {
    stateKey: 'RS',
    value: 'BARAO',
    label: 'BARAO'
  },
  {
    stateKey: 'RS',
    value: 'BARAO DE COTEGIPE',
    label: 'BARAO DE COTEGIPE'
  },
  {
    stateKey: 'RS',
    value: 'BARAO DO TRIUNFO',
    label: 'BARAO DO TRIUNFO'
  },
  {
    stateKey: 'RS',
    value: 'BARRA DO GUARITA',
    label: 'BARRA DO GUARITA'
  },
  {
    stateKey: 'RS',
    value: 'BARRA DO RIBEIRO',
    label: 'BARRA DO RIBEIRO'
  },
  {
    stateKey: 'RS',
    value: 'BARRA DO RIO AZUL',
    label: 'BARRA DO RIO AZUL'
  },
  {
    stateKey: 'RS',
    value: 'BARRA FUNDA',
    label: 'BARRA FUNDA'
  },
  {
    stateKey: 'RS',
    value: 'BARRACAO',
    label: 'BARRACAO'
  },
  {
    stateKey: 'RS',
    value: 'BARROS CASSAL',
    label: 'BARROS CASSAL'
  },
  {
    stateKey: 'RS',
    value: 'BENJAMIN CONSTANT DO SUL',
    label: 'BENJAMIN CONSTANT DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'BENTO GONCALVES',
    label: 'BENTO GONCALVES'
  },
  {
    stateKey: 'RS',
    value: 'BOA VISTA DAS MISSOES',
    label: 'BOA VISTA DAS MISSOES'
  },
  {
    stateKey: 'RS',
    value: 'BOA VISTA DO BURICA',
    label: 'BOA VISTA DO BURICA'
  },
  {
    stateKey: 'RS',
    value: 'BOA VISTA DO SUL',
    label: 'BOA VISTA DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'BOM JESUS',
    label: 'BOM JESUS'
  },
  {
    stateKey: 'RS',
    value: 'BOM PRINCIPIO',
    label: 'BOM PRINCIPIO'
  },
  {
    stateKey: 'RS',
    value: 'BOM PROGRESSO',
    label: 'BOM PROGRESSO'
  },
  {
    stateKey: 'RS',
    value: 'BOM RETIRO DO SUL',
    label: 'BOM RETIRO DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'BOQUEIRAO DO LEAO',
    label: 'BOQUEIRAO DO LEAO'
  },
  {
    stateKey: 'RS',
    value: 'BOSSOROCA',
    label: 'BOSSOROCA'
  },
  {
    stateKey: 'RS',
    value: 'BRAGA',
    label: 'BRAGA'
  },
  {
    stateKey: 'RS',
    value: 'BROCHIER',
    label: 'BROCHIER'
  },
  {
    stateKey: 'RS',
    value: 'BUTIA',
    label: 'BUTIA'
  },
  {
    stateKey: 'RS',
    value: 'CACAPAVA DO SUL',
    label: 'CACAPAVA DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'CACEQUI',
    label: 'CACEQUI'
  },
  {
    stateKey: 'RS',
    value: 'CACHOEIRA DO SUL',
    label: 'CACHOEIRA DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'CACHOEIRINHA',
    label: 'CACHOEIRINHA'
  },
  {
    stateKey: 'RS',
    value: 'CACIQUE DOBLE',
    label: 'CACIQUE DOBLE'
  },
  {
    stateKey: 'RS',
    value: 'CAIBATE',
    label: 'CAIBATE'
  },
  {
    stateKey: 'RS',
    value: 'CAICARA',
    label: 'CAICARA'
  },
  {
    stateKey: 'RS',
    value: 'CAMAQUA',
    label: 'CAMAQUA'
  },
  {
    stateKey: 'RS',
    value: 'CAMARGO',
    label: 'CAMARGO'
  },
  {
    stateKey: 'RS',
    value: 'CAMBARA DO SUL',
    label: 'CAMBARA DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'CAMPESTRE DA SERRA',
    label: 'CAMPESTRE DA SERRA'
  },
  {
    stateKey: 'RS',
    value: 'CAMPINA DAS MISSOES',
    label: 'CAMPINA DAS MISSOES'
  },
  {
    stateKey: 'RS',
    value: 'CAMPINAS DO SUL',
    label: 'CAMPINAS DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'CAMPO BOM',
    label: 'CAMPO BOM'
  },
  {
    stateKey: 'RS',
    value: 'CAMPO NOVO',
    label: 'CAMPO NOVO'
  },
  {
    stateKey: 'RS',
    value: 'CAMPOS BORGES',
    label: 'CAMPOS BORGES'
  },
  {
    stateKey: 'RS',
    value: 'CANDELARIA',
    label: 'CANDELARIA'
  },
  {
    stateKey: 'RS',
    value: 'CANDIDO GODOI',
    label: 'CANDIDO GODOI'
  },
  {
    stateKey: 'RS',
    value: 'CANDIOTA',
    label: 'CANDIOTA'
  },
  {
    stateKey: 'RS',
    value: 'CANELA',
    label: 'CANELA'
  },
  {
    stateKey: 'RS',
    value: 'CANGUCU',
    label: 'CANGUCU'
  },
  {
    stateKey: 'RS',
    value: 'CANOAS',
    label: 'CANOAS'
  },
  {
    stateKey: 'RS',
    value: 'CAPAO DA CANOA',
    label: 'CAPAO DA CANOA'
  },
  {
    stateKey: 'RS',
    value: 'CAPAO DO LEAO',
    label: 'CAPAO DO LEAO'
  },
  {
    stateKey: 'RS',
    value: 'CAPELA DE SANTANA',
    label: 'CAPELA DE SANTANA'
  },
  {
    stateKey: 'RS',
    value: 'CAPITAO',
    label: 'CAPITAO'
  },
  {
    stateKey: 'RS',
    value: 'CAPIVARI DO SUL',
    label: 'CAPIVARI DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'CARAA',
    label: 'CARAA'
  },
  {
    stateKey: 'RS',
    value: 'CARAZINHO',
    label: 'CARAZINHO'
  },
  {
    stateKey: 'RS',
    value: 'CARLOS BARBOSA',
    label: 'CARLOS BARBOSA'
  },
  {
    stateKey: 'RS',
    value: 'CARLOS GOMES',
    label: 'CARLOS GOMES'
  },
  {
    stateKey: 'RS',
    value: 'CASCA',
    label: 'CASCA'
  },
  {
    stateKey: 'RS',
    value: 'CASEIROS',
    label: 'CASEIROS'
  },
  {
    stateKey: 'RS',
    value: 'CATUIPE',
    label: 'CATUIPE'
  },
  {
    stateKey: 'RS',
    value: 'CAXIAS DO SUL',
    label: 'CAXIAS DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'CENTENARIO',
    label: 'CENTENARIO'
  },
  {
    stateKey: 'RS',
    value: 'CERRITO',
    label: 'CERRITO'
  },
  {
    stateKey: 'RS',
    value: 'CERRO BRANCO',
    label: 'CERRO BRANCO'
  },
  {
    stateKey: 'RS',
    value: 'CERRO GRANDE',
    label: 'CERRO GRANDE'
  },
  {
    stateKey: 'RS',
    value: 'CERRO GRANDE DO SUL',
    label: 'CERRO GRANDE DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'CERRO LARGO',
    label: 'CERRO LARGO'
  },
  {
    stateKey: 'RS',
    value: 'CHAPADA',
    label: 'CHAPADA'
  },
  {
    stateKey: 'RS',
    value: 'CHARQUEADAS',
    label: 'CHARQUEADAS'
  },
  {
    stateKey: 'RS',
    value: 'CHARRUA',
    label: 'CHARRUA'
  },
  {
    stateKey: 'RS',
    value: 'SANTA MARGARIDA DO SUL',
    label: 'SANTA MARGARIDA DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'CHUI',
    label: 'CHUI'
  },
  {
    stateKey: 'RS',
    value: 'CHUVISCA',
    label: 'CHUVISCA'
  },
  {
    stateKey: 'RS',
    value: 'CIDREIRA',
    label: 'CIDREIRA'
  },
  {
    stateKey: 'RS',
    value: 'CIRIACO',
    label: 'CIRIACO'
  },
  {
    stateKey: 'RS',
    value: 'COLINAS',
    label: 'COLINAS'
  },
  {
    stateKey: 'RS',
    value: 'COLORADO',
    label: 'COLORADO'
  },
  {
    stateKey: 'RS',
    value: 'CONDOR',
    label: 'CONDOR'
  },
  {
    stateKey: 'RS',
    value: 'CONSTANTINA',
    label: 'CONSTANTINA'
  },
  {
    stateKey: 'RS',
    value: 'COQUEIROS DO SUL',
    label: 'COQUEIROS DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'CORONEL BARROS',
    label: 'CORONEL BARROS'
  },
  {
    stateKey: 'RS',
    value: 'CORONEL BICACO',
    label: 'CORONEL BICACO'
  },
  {
    stateKey: 'RS',
    value: 'COTIPORA',
    label: 'COTIPORA'
  },
  {
    stateKey: 'RS',
    value: 'COXILHA',
    label: 'COXILHA'
  },
  {
    stateKey: 'RS',
    value: 'CRISSIUMAL',
    label: 'CRISSIUMAL'
  },
  {
    stateKey: 'RS',
    value: 'CRISTAL',
    label: 'CRISTAL'
  },
  {
    stateKey: 'RS',
    value: 'CRISTAL DO SUL',
    label: 'CRISTAL DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'CRUZ ALTA',
    label: 'CRUZ ALTA'
  },
  {
    stateKey: 'RS',
    value: 'DAVID CANABARRO',
    label: 'DAVID CANABARRO'
  },
  {
    stateKey: 'RS',
    value: 'DERRUBADAS',
    label: 'DERRUBADAS'
  },
  {
    stateKey: 'RS',
    value: 'DEZESSEIS DE NOVEMBRO',
    label: 'DEZESSEIS DE NOVEMBRO'
  },
  {
    stateKey: 'RS',
    value: 'DILERMANDO DE AGUIAR',
    label: 'DILERMANDO DE AGUIAR'
  },
  {
    stateKey: 'RS',
    value: 'DOIS IRMAOS',
    label: 'DOIS IRMAOS'
  },
  {
    stateKey: 'RS',
    value: 'DOIS IRMAOS DAS MISSOES',
    label: 'DOIS IRMAOS DAS MISSOES'
  },
  {
    stateKey: 'RS',
    value: 'DOIS LAJEADOS',
    label: 'DOIS LAJEADOS'
  },
  {
    stateKey: 'RS',
    value: 'DOM FELICIANO',
    label: 'DOM FELICIANO'
  },
  {
    stateKey: 'RS',
    value: 'DOM PEDRITO',
    label: 'DOM PEDRITO'
  },
  {
    stateKey: 'RS',
    value: 'DOM PEDRO DE ALCANTARA',
    label: 'DOM PEDRO DE ALCANTARA'
  },
  {
    stateKey: 'RS',
    value: 'DONA FRANCISCA',
    label: 'DONA FRANCISCA'
  },
  {
    stateKey: 'RS',
    value: 'DOUTOR MAURICIO CARDOSO',
    label: 'DOUTOR MAURICIO CARDOSO'
  },
  {
    stateKey: 'RS',
    value: 'DOUTOR RICARDO',
    label: 'DOUTOR RICARDO'
  },
  {
    stateKey: 'RS',
    value: 'ENCANTADO',
    label: 'ENCANTADO'
  },
  {
    stateKey: 'RS',
    value: 'ENCRUZILHADA DO SUL',
    label: 'ENCRUZILHADA DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'ENGENHO VELHO',
    label: 'ENGENHO VELHO'
  },
  {
    stateKey: 'RS',
    value: 'ENTRE RIOS DO SUL',
    label: 'ENTRE RIOS DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'ENTRE-IJUIS',
    label: 'ENTRE-IJUIS'
  },
  {
    stateKey: 'RS',
    value: 'EREBANGO',
    label: 'EREBANGO'
  },
  {
    stateKey: 'RS',
    value: 'ERECHIM',
    label: 'ERECHIM'
  },
  {
    stateKey: 'RS',
    value: 'ERNESTINA',
    label: 'ERNESTINA'
  },
  {
    stateKey: 'RS',
    value: 'ERVAL GRANDE',
    label: 'ERVAL GRANDE'
  },
  {
    stateKey: 'RS',
    value: 'ERVAL SECO',
    label: 'ERVAL SECO'
  },
  {
    stateKey: 'RS',
    value: 'ESMERALDA',
    label: 'ESMERALDA'
  },
  {
    stateKey: 'RS',
    value: 'ESPERANCA DO SUL',
    label: 'ESPERANCA DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'ESPUMOSO',
    label: 'ESPUMOSO'
  },
  {
    stateKey: 'RS',
    value: 'ESTACAO',
    label: 'ESTACAO'
  },
  {
    stateKey: 'RS',
    value: 'ESTANCIA VELHA',
    label: 'ESTANCIA VELHA'
  },
  {
    stateKey: 'RS',
    value: 'ESTEIO',
    label: 'ESTEIO'
  },
  {
    stateKey: 'RS',
    value: 'ESTRELA',
    label: 'ESTRELA'
  },
  {
    stateKey: 'RS',
    value: 'ESTRELA VELHA',
    label: 'ESTRELA VELHA'
  },
  {
    stateKey: 'RS',
    value: 'EUGENIO DE CASTRO',
    label: 'EUGENIO DE CASTRO'
  },
  {
    stateKey: 'RS',
    value: 'FAGUNDES VARELA',
    label: 'FAGUNDES VARELA'
  },
  {
    stateKey: 'RS',
    value: 'FARROUPILHA',
    label: 'FARROUPILHA'
  },
  {
    stateKey: 'RS',
    value: 'FAXINAL DO SOTURNO',
    label: 'FAXINAL DO SOTURNO'
  },
  {
    stateKey: 'RS',
    value: 'FAXINALZINHO',
    label: 'FAXINALZINHO'
  },
  {
    stateKey: 'RS',
    value: 'FAZENDA VILA NOVA',
    label: 'FAZENDA VILA NOVA'
  },
  {
    stateKey: 'RS',
    value: 'FELIZ',
    label: 'FELIZ'
  },
  {
    stateKey: 'RS',
    value: 'FLORES DA CUNHA',
    label: 'FLORES DA CUNHA'
  },
  {
    stateKey: 'RS',
    value: 'FLORIANO PEIXOTO',
    label: 'FLORIANO PEIXOTO'
  },
  {
    stateKey: 'RS',
    value: 'FONTOURA XAVIER',
    label: 'FONTOURA XAVIER'
  },
  {
    stateKey: 'RS',
    value: 'FORMIGUEIRO',
    label: 'FORMIGUEIRO'
  },
  {
    stateKey: 'RS',
    value: 'FORTALEZA DOS VALOS',
    label: 'FORTALEZA DOS VALOS'
  },
  {
    stateKey: 'RS',
    value: 'FREDERICO WESTPHALEN',
    label: 'FREDERICO WESTPHALEN'
  },
  {
    stateKey: 'RS',
    value: 'GARIBALDI',
    label: 'GARIBALDI'
  },
  {
    stateKey: 'RS',
    value: 'GARRUCHOS',
    label: 'GARRUCHOS'
  },
  {
    stateKey: 'RS',
    value: 'GAURAMA',
    label: 'GAURAMA'
  },
  {
    stateKey: 'RS',
    value: 'GENERAL CAMARA',
    label: 'GENERAL CAMARA'
  },
  {
    stateKey: 'RS',
    value: 'GENTIL',
    label: 'GENTIL'
  },
  {
    stateKey: 'RS',
    value: 'GETULIO VARGAS',
    label: 'GETULIO VARGAS'
  },
  {
    stateKey: 'RS',
    value: 'GIRUA',
    label: 'GIRUA'
  },
  {
    stateKey: 'RS',
    value: 'GLORINHA ',
    label: 'GLORINHA'
  },
  {
    stateKey: 'RS',
    value: 'GRAMADO',
    label: 'GRAMADO'
  },
  {
    stateKey: 'RS',
    value: 'GRAMADO DOS LOUREIROS',
    label: 'GRAMADO DOS LOUREIROS'
  },
  {
    stateKey: 'RS',
    value: 'GRAMADO XAVIER',
    label: 'GRAMADO XAVIER'
  },
  {
    stateKey: 'RS',
    value: 'GRAVATAI',
    label: 'GRAVATAI'
  },
  {
    stateKey: 'RS',
    value: 'GUABIJU',
    label: 'GUABIJU'
  },
  {
    stateKey: 'RS',
    value: 'GUAIBA',
    label: 'GUAIBA'
  },
  {
    stateKey: 'RS',
    value: 'GUAPORE',
    label: 'GUAPORE'
  },
  {
    stateKey: 'RS',
    value: 'GUARANI DAS MISSOES',
    label: 'GUARANI DAS MISSOES'
  },
  {
    stateKey: 'RS',
    value: 'HARMONIA',
    label: 'HARMONIA'
  },
  {
    stateKey: 'RS',
    value: 'HERVAL',
    label: 'HERVAL'
  },
  {
    stateKey: 'RS',
    value: 'HERVEIRAS',
    label: 'HERVEIRAS'
  },
  {
    stateKey: 'RS',
    value: 'HORIZONTINA',
    label: 'HORIZONTINA'
  },
  {
    stateKey: 'RS',
    value: 'HULHA NEGRA',
    label: 'HULHA NEGRA'
  },
  {
    stateKey: 'RS',
    value: 'HUMAITA',
    label: 'HUMAITA'
  },
  {
    stateKey: 'RS',
    value: 'IBARAMA',
    label: 'IBARAMA'
  },
  {
    stateKey: 'RS',
    value: 'IBIACA',
    label: 'IBIACA'
  },
  {
    stateKey: 'RS',
    value: 'IBIRAIARAS',
    label: 'IBIRAIARAS'
  },
  {
    stateKey: 'RS',
    value: 'IBIRAPUITA',
    label: 'IBIRAPUITA'
  },
  {
    stateKey: 'RS',
    value: 'IBIRUBA',
    label: 'IBIRUBA'
  },
  {
    stateKey: 'RS',
    value: 'IGREJINHA',
    label: 'IGREJINHA'
  },
  {
    stateKey: 'RS',
    value: 'IJUI',
    label: 'IJUI'
  },
  {
    stateKey: 'RS',
    value: 'ILOPOLIS',
    label: 'ILOPOLIS'
  },
  {
    stateKey: 'RS',
    value: 'IMBE',
    label: 'IMBE'
  },
  {
    stateKey: 'RS',
    value: 'IMIGRANTE',
    label: 'IMIGRANTE'
  },
  {
    stateKey: 'RS',
    value: 'INDEPENDENCIA',
    label: 'INDEPENDENCIA'
  },
  {
    stateKey: 'RS',
    value: 'INHACORA',
    label: 'INHACORA'
  },
  {
    stateKey: 'RS',
    value: 'IPE',
    label: 'IPE'
  },
  {
    stateKey: 'RS',
    value: 'IPIRANGA DO SUL',
    label: 'IPIRANGA DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'IRAI',
    label: 'IRAI'
  },
  {
    stateKey: 'RS',
    value: 'ITAARA',
    label: 'ITAARA'
  },
  {
    stateKey: 'RS',
    value: 'ITACURUBI',
    label: 'ITACURUBI'
  },
  {
    stateKey: 'RS',
    value: 'ITAPUCA',
    label: 'ITAPUCA'
  },
  {
    stateKey: 'RS',
    value: 'ITAQUI',
    label: 'ITAQUI'
  },
  {
    stateKey: 'RS',
    value: 'ITATIBA DO SUL',
    label: 'ITATIBA DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'IVORA',
    label: 'IVORA'
  },
  {
    stateKey: 'RS',
    value: 'IVOTI',
    label: 'IVOTI'
  },
  {
    stateKey: 'RS',
    value: 'JABOTICABA',
    label: 'JABOTICABA'
  },
  {
    stateKey: 'RS',
    value: 'JACUTINGA',
    label: 'JACUTINGA'
  },
  {
    stateKey: 'RS',
    value: 'JAGUARAO',
    label: 'JAGUARAO'
  },
  {
    stateKey: 'RS',
    value: 'JAGUARI',
    label: 'JAGUARI'
  },
  {
    stateKey: 'RS',
    value: 'JAQUIRANA',
    label: 'JAQUIRANA'
  },
  {
    stateKey: 'RS',
    value: 'JARI',
    label: 'JARI'
  },
  {
    stateKey: 'RS',
    value: 'JOIA',
    label: 'JOIA'
  },
  {
    stateKey: 'RS',
    value: 'JULIO DE CASTILHOS',
    label: 'JULIO DE CASTILHOS'
  },
  {
    stateKey: 'RS',
    value: 'LAGOA DOS TRES CANTOS',
    label: 'LAGOA DOS TRES CANTOS'
  },
  {
    stateKey: 'RS',
    value: 'LAGOA VERMELHA',
    label: 'LAGOA VERMELHA'
  },
  {
    stateKey: 'RS',
    value: 'LAGOAO',
    label: 'LAGOAO'
  },
  {
    stateKey: 'RS',
    value: 'LAJEADO',
    label: 'LAJEADO'
  },
  {
    stateKey: 'RS',
    value: 'LAJEADO DO BUGRE',
    label: 'LAJEADO DO BUGRE'
  },
  {
    stateKey: 'RS',
    value: 'LAVRAS DO SUL',
    label: 'LAVRAS DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'LIBERATO SALZANO',
    label: 'LIBERATO SALZANO'
  },
  {
    stateKey: 'RS',
    value: 'LINDOLFO COLLOR',
    label: 'LINDOLFO COLLOR'
  },
  {
    stateKey: 'RS',
    value: 'LINHA NOVA',
    label: 'LINHA NOVA'
  },
  {
    stateKey: 'RS',
    value: 'MACAMBARA',
    label: 'MACAMBARA'
  },
  {
    stateKey: 'RS',
    value: 'MACHADINHO',
    label: 'MACHADINHO'
  },
  {
    stateKey: 'RS',
    value: 'MAMPITUBA',
    label: 'MAMPITUBA'
  },
  {
    stateKey: 'RS',
    value: 'MANOEL VIANA',
    label: 'MANOEL VIANA'
  },
  {
    stateKey: 'RS',
    value: 'MAQUINE',
    label: 'MAQUINE'
  },
  {
    stateKey: 'RS',
    value: 'MARATA',
    label: 'MARATA'
  },
  {
    stateKey: 'RS',
    value: 'MARAU',
    label: 'MARAU'
  },
  {
    stateKey: 'RS',
    value: 'MARCELINO RAMOS',
    label: 'MARCELINO RAMOS'
  },
  {
    stateKey: 'RS',
    value: 'MARIANA PIMENTEL',
    label: 'MARIANA PIMENTEL'
  },
  {
    stateKey: 'RS',
    value: 'MARIANO MORO',
    label: 'MARIANO MORO'
  },
  {
    stateKey: 'RS',
    value: 'MARQUES DE SOUZA',
    label: 'MARQUES DE SOUZA'
  },
  {
    stateKey: 'RS',
    value: 'MATA',
    label: 'MATA'
  },
  {
    stateKey: 'RS',
    value: 'MATO CASTELHANO',
    label: 'MATO CASTELHANO'
  },
  {
    stateKey: 'RS',
    value: 'MATO LEITAO',
    label: 'MATO LEITAO'
  },
  {
    stateKey: 'RS',
    value: 'MAXIMILIANO DE ALMEIDA',
    label: 'MAXIMILIANO DE ALMEIDA'
  },
  {
    stateKey: 'RS',
    value: 'MINAS DO LEAO',
    label: 'MINAS DO LEAO'
  },
  {
    stateKey: 'RS',
    value: 'MIRAGUAI',
    label: 'MIRAGUAI'
  },
  {
    stateKey: 'RS',
    value: 'MONTAURI',
    label: 'MONTAURI'
  },
  {
    stateKey: 'RS',
    value: 'MONTE ALEGRE DOS CAMPOS',
    label: 'MONTE ALEGRE DOS CAMPOS'
  },
  {
    stateKey: 'RS',
    value: 'MONTE BELO DO SUL',
    label: 'MONTE BELO DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'MONTENEGRO',
    label: 'MONTENEGRO'
  },
  {
    stateKey: 'RS',
    value: 'MORMACO',
    label: 'MORMACO'
  },
  {
    stateKey: 'RS',
    value: 'MORRINHOS DO SUL',
    label: 'MORRINHOS DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'MORRO REDONDO',
    label: 'MORRO REDONDO'
  },
  {
    stateKey: 'RS',
    value: 'MORRO REUTER',
    label: 'MORRO REUTER'
  },
  {
    stateKey: 'RS',
    value: 'MOSTARDAS',
    label: 'MOSTARDAS'
  },
  {
    stateKey: 'RS',
    value: 'MUCUM',
    label: 'MUCUM'
  },
  {
    stateKey: 'RS',
    value: 'MUITOS CAPOES',
    label: 'MUITOS CAPOES'
  },
  {
    stateKey: 'RS',
    value: 'MULITERNO',
    label: 'MULITERNO'
  },
  {
    stateKey: 'RS',
    value: 'NAO-ME-TOQUE',
    label: 'NAO-ME-TOQUE'
  },
  {
    stateKey: 'RS',
    value: 'NICOLAU VERGUEIRO',
    label: 'NICOLAU VERGUEIRO'
  },
  {
    stateKey: 'RS',
    value: 'NONOAI',
    label: 'NONOAI'
  },
  {
    stateKey: 'RS',
    value: 'NOVA ALVORADA',
    label: 'NOVA ALVORADA'
  },
  {
    stateKey: 'RS',
    value: 'NOVA ARACA',
    label: 'NOVA ARACA'
  },
  {
    stateKey: 'RS',
    value: 'NOVA BASSANO',
    label: 'NOVA BASSANO'
  },
  {
    stateKey: 'RS',
    value: 'NOVA BOA VISTA',
    label: 'NOVA BOA VISTA'
  },
  {
    stateKey: 'RS',
    value: 'NOVA BRESCIA',
    label: 'NOVA BRESCIA'
  },
  {
    stateKey: 'RS',
    value: 'NOVA CANDELARIA',
    label: 'NOVA CANDELARIA'
  },
  {
    stateKey: 'RS',
    value: 'NOVA ESPERANCA DO SUL',
    label: 'NOVA ESPERANCA DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'NOVA HARTZ',
    label: 'NOVA HARTZ'
  },
  {
    stateKey: 'RS',
    value: 'NOVA PADUA',
    label: 'NOVA PADUA'
  },
  {
    stateKey: 'RS',
    value: 'NOVA PALMA',
    label: 'NOVA PALMA'
  },
  {
    stateKey: 'RS',
    value: 'NOVA PETROPOLIS',
    label: 'NOVA PETROPOLIS '
  },
  {
    stateKey: 'RS',
    value: 'NOVA PRATA',
    label: 'NOVA PRATA'
  },
  {
    stateKey: 'RS',
    value: 'NOVA RAMADA',
    label: 'NOVA RAMADA'
  },
  {
    stateKey: 'RS',
    value: 'NOVA ROMA DO SUL',
    label: 'NOVA ROMA DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'NOVA SANTA RITA',
    label: 'NOVA SANTA RITA'
  },
  {
    stateKey: 'RS',
    value: 'NOVO BARREIRO',
    label: 'NOVO BARREIRO'
  },
  {
    stateKey: 'RS',
    value: 'NOVO CABRAIS',
    label: 'NOVO CABRAIS'
  },
  {
    stateKey: 'RS',
    value: 'NOVO HAMBURGO',
    label: 'NOVO HAMBURGO'
  },
  {
    stateKey: 'RS',
    value: 'NOVO MACHADO',
    label: 'NOVO MACHADO'
  },
  {
    stateKey: 'RS',
    value: 'NOVO TIRADENTES',
    label: 'NOVO TIRADENTES'
  },
  {
    stateKey: 'RS',
    value: 'OSORIO',
    label: 'OSORIO'
  },
  {
    stateKey: 'RS',
    value: 'PAIM FILHO',
    label: 'PAIM FILHO'
  },
  {
    stateKey: 'RS',
    value: 'PALMARES DO SUL',
    label: 'PALMARES DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'PALMEIRA DAS MISSOES',
    label: 'PALMEIRA DAS MISSOES'
  },
  {
    stateKey: 'RS',
    value: 'PALMITINHO',
    label: 'PALMITINHO'
  },
  {
    stateKey: 'RS',
    value: 'PANAMBI',
    label: 'PANAMBI'
  },
  {
    stateKey: 'RS',
    value: 'PANTANO GRANDE',
    label: 'PANTANO GRANDE'
  },
  {
    stateKey: 'RS',
    value: 'PARAI',
    label: 'PARAI'
  },
  {
    stateKey: 'RS',
    value: 'PARAISO DO SUL',
    label: 'PARAISO DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'PARECI NOVO',
    label: 'PARECI NOVO'
  },
  {
    stateKey: 'RS',
    value: 'PAROBE',
    label: 'PAROBE'
  },
  {
    stateKey: 'RS',
    value: 'PASSA SETE',
    label: 'PASSA SETE'
  },
  {
    stateKey: 'RS',
    value: 'PASSO DO SOBRADO',
    label: 'PASSO DO SOBRADO'
  },
  {
    stateKey: 'RS',
    value: 'PASSO FUNDO',
    label: 'PASSO FUNDO'
  },
  {
    stateKey: 'RS',
    value: 'PAVERAMA',
    label: 'PAVERAMA'
  },
  {
    stateKey: 'RS',
    value: 'PEDRO OSORIO',
    label: 'PEDRO OSORIO'
  },
  {
    stateKey: 'RS',
    value: 'PEJUCARA',
    label: 'PEJUCARA'
  },
  {
    stateKey: 'RS',
    value: 'PELOTAS',
    label: 'PELOTAS'
  },
  {
    stateKey: 'RS',
    value: 'PICADA CAFE',
    label: 'PICADA CAFE'
  },
  {
    stateKey: 'RS',
    value: 'PINHAL',
    label: 'PINHAL'
  },
  {
    stateKey: 'RS',
    value: 'PINHAL GRANDE',
    label: 'PINHAL GRANDE'
  },
  {
    stateKey: 'RS',
    value: 'PINHEIRINHO DO VALE',
    label: 'PINHEIRINHO DO VALE'
  },
  {
    stateKey: 'RS',
    value: 'PINHEIRO MACHADO',
    label: 'PINHEIRO MACHADO'
  },
  {
    stateKey: 'RS',
    value: 'PIRAPO',
    label: 'PIRAPO'
  },
  {
    stateKey: 'RS',
    value: 'PIRATINI',
    label: 'PIRATINI'
  },
  {
    stateKey: 'RS',
    value: 'PLANALTO',
    label: 'PLANALTO'
  },
  {
    stateKey: 'RS',
    value: 'POCO DAS ANTAS',
    label: 'POCO DAS ANTAS'
  },
  {
    stateKey: 'RS',
    value: 'PONTAO',
    label: 'PONTAO'
  },
  {
    stateKey: 'RS',
    value: 'PONTE PRETA',
    label: 'PONTE PRETA'
  },
  {
    stateKey: 'RS',
    value: 'PORTAO',
    label: 'PORTAO'
  },
  {
    stateKey: 'RS',
    value: 'PORTO ALEGRE',
    label: 'PORTO ALEGRE'
  },
  {
    stateKey: 'RS',
    value: 'PORTO LUCENA',
    label: 'PORTO LUCENA'
  },
  {
    stateKey: 'RS',
    value: 'PORTO MAUA',
    label: 'PORTO MAUA'
  },
  {
    stateKey: 'RS',
    value: 'PORTO VERA CRUZ',
    label: 'PORTO VERA CRUZ'
  },
  {
    stateKey: 'RS',
    value: 'PORTO XAVIER',
    label: 'PORTO XAVIER'
  },
  {
    stateKey: 'RS',
    value: 'POUSO NOVO ',
    label: 'POUSO NOVO'
  },
  {
    stateKey: 'RS',
    value: 'PRESIDENTE LUCENA',
    label: 'PRESIDENTE LUCENA'
  },
  {
    stateKey: 'RS',
    value: 'PROGRESSO',
    label: 'PROGRESSO'
  },
  {
    stateKey: 'RS',
    value: 'PROTASIO ALVES',
    label: 'PROTASIO ALVES'
  },
  {
    stateKey: 'RS',
    value: 'PUTINGA',
    label: 'PUTINGA'
  },
  {
    stateKey: 'RS',
    value: 'QUARAI',
    label: 'QUARAI'
  },
  {
    stateKey: 'RS',
    value: 'QUEVEDOS',
    label: 'QUEVEDOS'
  },
  {
    stateKey: 'RS',
    value: 'QUINZE DE NOVEMBRO',
    label: 'QUINZE DE NOVEMBRO'
  },
  {
    stateKey: 'RS',
    value: 'REDENTORA',
    label: 'REDENTORA'
  },
  {
    stateKey: 'RS',
    value: 'RELVADO',
    label: 'RELVADO'
  },
  {
    stateKey: 'RS',
    value: 'RESTINGA SECA',
    label: 'RESTINGA SECA'
  },
  {
    stateKey: 'RS',
    value: 'RIO DOS INDIOS',
    label: 'RIO DOS INDIOS'
  },
  {
    stateKey: 'RS',
    value: 'RIO GRANDE',
    label: 'RIO GRANDE'
  },
  {
    stateKey: 'RS',
    value: 'RIO PARDO',
    label: 'RIO PARDO'
  },
  {
    stateKey: 'RS',
    value: 'RIOZINHO',
    label: 'RIOZINHO'
  },
  {
    stateKey: 'RS',
    value: 'ROCA SALES',
    label: 'ROCA SALES'
  },
  {
    stateKey: 'RS',
    value: 'RODEIO BONITO',
    label: 'RODEIO BONITO'
  },
  {
    stateKey: 'RS',
    value: 'ROLANTE',
    label: 'ROLANTE'
  },
  {
    stateKey: 'RS',
    value: 'RONDA ALTA',
    label: 'RONDA ALTA'
  },
  {
    stateKey: 'RS',
    value: 'RONDINHA',
    label: 'RONDINHA'
  },
  {
    stateKey: 'RS',
    value: 'ROQUE GONZALES',
    label: 'ROQUE GONZALES'
  },
  {
    stateKey: 'RS',
    value: 'ROSARIO DO SUL',
    label: 'ROSARIO DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'SAGRADA FAMILIA',
    label: 'SAGRADA FAMILIA'
  },
  {
    stateKey: 'RS',
    value: 'SALDANHA MARINHO',
    label: 'SALDANHA MARINHO'
  },
  {
    stateKey: 'RS',
    value: 'SALTO DO JACUI',
    label: 'SALTO DO JACUI'
  },
  {
    stateKey: 'RS',
    value: 'SALVADOR DAS MISSOES',
    label: 'SALVADOR DAS MISSOES'
  },
  {
    stateKey: 'RS',
    value: 'SALVADOR DO SUL',
    label: 'SALVADOR DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'SANANDUVA',
    label: 'SANANDUVA'
  },
  {
    stateKey: 'RS',
    value: 'SANTA BARBARA DO SUL',
    label: 'SANTA BARBARA DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'SANTA CLARA DO SUL',
    label: 'SANTA CLARA DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'SANTA CRUZ DO SUL',
    label: 'SANTA CRUZ DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'SANTA MARIA',
    label: 'SANTA MARIA'
  },
  {
    stateKey: 'RS',
    value: 'SANTA MARIA DO HERVAL',
    label: 'SANTA MARIA DO HERVAL'
  },
  {
    stateKey: 'RS',
    value: 'SANTA TEREZA',
    label: 'SANTA TEREZA'
  },
  {
    stateKey: 'RS',
    value: 'SANTA VITORIA DO PALMAR',
    label: 'SANTA VITORIA DO PALMAR'
  },
  {
    stateKey: 'RS',
    value: 'SANTANA DA BOA VISTA',
    label: 'SANTANA DA BOA VISTA'
  },
  {
    stateKey: 'RS',
    value: 'SANTANA DO LIVRAMENTO',
    label: 'SANTANA DO LIVRAMENTO'
  },
  {
    stateKey: 'RS',
    value: 'SANTIAGO',
    label: 'SANTIAGO'
  },
  {
    stateKey: 'RS',
    value: 'SANTO ANGELO',
    label: 'SANTO ANGELO'
  },
  {
    stateKey: 'RS',
    value: 'SANTO ANTONIO DA PATRULHA',
    label: 'SANTO ANTONIO DA PATRULHA'
  },
  {
    stateKey: 'RS',
    value: 'SANTO ANTONIO DAS MISSOES',
    label: 'SANTO ANTONIO DAS MISSOES'
  },
  {
    stateKey: 'RS',
    value: 'SANTO ANTONIO DO PALMA',
    label: 'SANTO ANTONIO DO PALMA'
  },
  {
    stateKey: 'RS',
    value: 'SANTO ANTONIO DO PLANALTO',
    label: 'SANTO ANTONIO DO PLANALTO'
  },
  {
    stateKey: 'RS',
    value: 'SANTO AUGUSTO',
    label: 'SANTO AUGUSTO'
  },
  {
    stateKey: 'RS',
    value: 'SANTO CRISTO',
    label: 'SANTO CRISTO'
  },
  {
    stateKey: 'RS',
    value: 'SANTO EXPEDITO DO SUL',
    label: 'SANTO EXPEDITO DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'SAO BORJA',
    label: 'SAO BORJA'
  },
  {
    stateKey: 'RS',
    value: 'SAO DOMINGOS DO SUL',
    label: 'SAO DOMINGOS DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'SAO FRANCISCO DE ASSIS',
    label: 'SAO FRANCISCO DE ASSIS'
  },
  {
    stateKey: 'RS',
    value: 'SAO FRANCISCO DE PAULA',
    label: 'SAO FRANCISCO DE PAULA'
  },
  {
    stateKey: 'RS',
    value: 'SAO GABRIEL',
    label: 'SAO GABRIEL'
  },
  {
    stateKey: 'RS',
    value: 'SAO JERONIMO',
    label: 'SAO JERONIMO'
  },
  {
    stateKey: 'RS',
    value: 'SAO JOAO DA URTIGA',
    label: 'SAO JOAO DA URTIGA'
  },
  {
    stateKey: 'RS',
    value: 'SAO JOAO DO POLESINE',
    label: 'SAO JOAO DO POLESINE'
  },
  {
    stateKey: 'RS',
    value: 'SAO JORGE',
    label: 'SAO JORGE'
  },
  {
    stateKey: 'RS',
    value: 'SAO JOSE DAS MISSOES',
    label: 'SAO JOSE DAS MISSOES'
  },
  {
    stateKey: 'RS',
    value: 'SAO JOSE DO HERVAL',
    label: 'SAO JOSE DO HERVAL'
  },
  {
    stateKey: 'RS',
    value: 'SAO JOSE DO HORTENCIO',
    label: 'SAO JOSE DO HORTENCIO'
  },
  {
    stateKey: 'RS',
    value: 'SAO JOSE DO INHACORA',
    label: 'SAO JOSE DO INHACORA'
  },
  {
    stateKey: 'RS',
    value: 'SAO JOSE DO NORTE',
    label: 'SAO JOSE DO NORTE'
  },
  {
    stateKey: 'RS',
    value: 'SAO JOSE DO OURO',
    label: 'SAO JOSE DO OURO'
  },
  {
    stateKey: 'RS',
    value: 'SAO JOSE DOS AUSENTES',
    label: 'SAO JOSE DOS AUSENTES'
  },
  {
    stateKey: 'RS',
    value: 'SAO LEOPOLDO',
    label: 'SAO LEOPOLDO'
  },
  {
    stateKey: 'RS',
    value: 'SAO LOURENCO DO SUL',
    label: 'SAO LOURENCO DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'SAO MARCOS',
    label: 'SAO MARCOS'
  },
  {
    stateKey: 'RS',
    value: 'SAO MARTINHO',
    label: 'SAO MARTINHO'
  },
  {
    stateKey: 'RS',
    value: 'SAO MARTINHO DA SERRA',
    label: 'SAO MARTINHO DA SERRA'
  },
  {
    stateKey: 'RS',
    value: 'SAO MIGUEL DAS MISSOES',
    label: 'SAO MIGUEL DAS MISSOES'
  },
  {
    stateKey: 'RS',
    value: 'SAO NICOLAU',
    label: 'SAO NICOLAU'
  },
  {
    stateKey: 'RS',
    value: 'SAO PAULO DAS MISSOES',
    label: 'SAO PAULO DAS MISSOES'
  },
  {
    stateKey: 'RS',
    value: 'SAO PEDRO DA SERRA',
    label: 'SAO PEDRO DA SERRA'
  },
  {
    stateKey: 'RS',
    value: 'SAO PEDRO DO BUTIA',
    label: 'SAO PEDRO DO BUTIA'
  },
  {
    stateKey: 'RS',
    value: 'SAO PEDRO DO SUL',
    label: 'SAO PEDRO DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'SAO SEBASTIAO DO CAI',
    label: 'SAO SEBASTIAO DO CAI'
  },
  {
    stateKey: 'RS',
    value: 'SAO SEPE',
    label: 'SAO SEPE'
  },
  {
    stateKey: 'RS',
    value: 'SAO VALENTIM',
    label: 'SAO VALENTIM'
  },
  {
    stateKey: 'RS',
    value: 'SAO VALENTIM DO SUL',
    label: 'SAO VALENTIM DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'SAO VALERIO DO SUL',
    label: 'SAO VALERIO DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'SAO VENDELINO',
    label: 'SAO VENDELINO'
  },
  {
    stateKey: 'RS',
    value: 'SAO VICENTE DO SUL',
    label: 'SAO VICENTE DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'SAPIRANGA',
    label: 'SAPIRANGA'
  },
  {
    stateKey: 'RS',
    value: 'SAPUCAIA DO SUL',
    label: 'SAPUCAIA DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'SARANDI',
    label: 'SARANDI'
  },
  {
    stateKey: 'RS',
    value: 'SEBERI',
    label: 'SEBERI'
  },
  {
    stateKey: 'RS',
    value: 'SEDE NOVA',
    label: 'SEDE NOVA'
  },
  {
    stateKey: 'RS',
    value: 'SEGREDO',
    label: 'SEGREDO'
  },
  {
    stateKey: 'RS',
    value: 'SELBACH',
    label: 'SELBACH'
  },
  {
    stateKey: 'RS',
    value: 'SENADOR SALGADO FILHO',
    label: 'SENADOR SALGADO FILHO'
  },
  {
    stateKey: 'RS',
    value: 'SENTINELA DO SUL',
    label: 'SENTINELA DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'SERAFINA CORREA',
    label: 'SERAFINA CORREA'
  },
  {
    stateKey: 'RS',
    value: 'SERIO',
    label: 'SERIO'
  },
  {
    stateKey: 'RS',
    value: 'SERTAO',
    label: 'SERTAO'
  },
  {
    stateKey: 'RS',
    value: 'SERTAO SANTANA',
    label: 'SERTAO SANTANA'
  },
  {
    stateKey: 'RS',
    value: 'SETE DE SETEMBRO',
    label: 'SETE DE SETEMBRO'
  },
  {
    stateKey: 'RS',
    value: 'SEVERIANO DE ALMEIDA',
    label: 'SEVERIANO DE ALMEIDA'
  },
  {
    stateKey: 'RS',
    value: 'SILVEIRA MARTINS',
    label: 'SILVEIRA MARTINS'
  },
  {
    stateKey: 'RS',
    value: 'SINIMBU',
    label: 'SINIMBU '
  },
  {
    stateKey: 'RS',
    value: 'SOBRADINHO',
    label: 'SOBRADINHO'
  },
  {
    stateKey: 'RS',
    value: 'SOLEDADE',
    label: 'SOLEDADE'
  },
  {
    stateKey: 'RS',
    value: 'TABAI',
    label: 'TABAI'
  },
  {
    stateKey: 'RS',
    value: 'TAPEJARA',
    label: 'TAPEJARA'
  },
  {
    stateKey: 'RS',
    value: 'TAPERA',
    label: 'TAPERA'
  },
  {
    stateKey: 'RS',
    value: 'TAPES',
    label: 'TAPES'
  },
  {
    stateKey: 'RS',
    value: 'TAQUARA',
    label: 'TAQUARA'
  },
  {
    stateKey: 'RS',
    value: 'TAQUARI',
    label: 'TAQUARI'
  },
  {
    stateKey: 'RS',
    value: 'TAQUARUCU DO SUL',
    label: 'TAQUARUCU DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'TAVARES',
    label: 'TAVARES'
  },
  {
    stateKey: 'RS',
    value: 'TENENTE PORTELA',
    label: 'TENENTE PORTELA'
  },
  {
    stateKey: 'RS',
    value: 'TERRA DE AREIA',
    label: 'TERRA DE AREIA'
  },
  {
    stateKey: 'RS',
    value: 'TEUTONIA',
    label: 'TEUTONIA'
  },
  {
    stateKey: 'RS',
    value: 'TIRADENTES DO SUL',
    label: 'TIRADENTES DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'TOROPI',
    label: 'TOROPI'
  },
  {
    stateKey: 'RS',
    value: 'TORRES',
    label: 'TORRES'
  },
  {
    stateKey: 'RS',
    value: 'TRAMANDAI',
    label: 'TRAMANDAI'
  },
  {
    stateKey: 'RS',
    value: 'TRAVESSEIRO',
    label: 'TRAVESSEIRO'
  },
  {
    stateKey: 'RS',
    value: 'TRES ARROIOS',
    label: 'TRES ARROIOS'
  },
  {
    stateKey: 'RS',
    value: 'TRES CACHOEIRAS',
    label: 'TRES CACHOEIRAS'
  },
  {
    stateKey: 'RS',
    value: 'TRES COROAS',
    label: 'TRES COROAS'
  },
  {
    stateKey: 'RS',
    value: 'TRES DE MAIO',
    label: 'TRES DE MAIO'
  },
  {
    stateKey: 'RS',
    value: 'TRES FORQUILHAS',
    label: 'TRES FORQUILHAS'
  },
  {
    stateKey: 'RS',
    value: 'TRES PALMEIRAS',
    label: 'TRES PALMEIRAS'
  },
  {
    stateKey: 'RS',
    value: 'TRES PASSOS',
    label: 'TRES PASSOS'
  },
  {
    stateKey: 'RS',
    value: 'TRINDADE DO SUL',
    label: 'TRINDADE DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'TRIUNFO',
    label: 'TRIUNFO'
  },
  {
    stateKey: 'RS',
    value: 'TUCUNDUVA',
    label: 'TUCUNDUVA'
  },
  {
    stateKey: 'RS',
    value: 'TUNAS',
    label: 'TUNAS'
  },
  {
    stateKey: 'RS',
    value: 'TUPANCI DO SUL',
    label: 'TUPANCI DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'TUPANCIRETA',
    label: 'TUPANCIRETA'
  },
  {
    stateKey: 'RS',
    value: 'TUPANDI',
    label: 'TUPANDI'
  },
  {
    stateKey: 'RS',
    value: 'TUPARENDI',
    label: 'TUPARENDI'
  },
  {
    stateKey: 'RS',
    value: 'TURUCU',
    label: 'TURUCU'
  },
  {
    stateKey: 'RS',
    value: 'UBIRETAMA',
    label: 'UBIRETAMA'
  },
  {
    stateKey: 'RS',
    value: 'UNIAO DA SERRA',
    label: 'UNIAO DA SERRA'
  },
  {
    stateKey: 'RS',
    value: 'UNISTALDA',
    label: 'UNISTALDA'
  },
  {
    stateKey: 'RS',
    value: 'URUGUAIANA',
    label: 'URUGUAIANA'
  },
  {
    stateKey: 'RS',
    value: 'VACARIA',
    label: 'VACARIA'
  },
  {
    stateKey: 'RS',
    value: 'VALE DO SOL',
    label: 'VALE DO SOL'
  },
  {
    stateKey: 'RS',
    value: 'VALE REAL',
    label: 'VALE REAL'
  },
  {
    stateKey: 'RS',
    value: 'VALE VERDE',
    label: 'VALE VERDE'
  },
  {
    stateKey: 'RS',
    value: 'VANINI',
    label: 'VANINI'
  },
  {
    stateKey: 'RS',
    value: 'VERA CRUZ',
    label: 'VERA CRUZ'
  },
  {
    stateKey: 'RS',
    value: 'VERANOPOLIS',
    label: 'VERANOPOLIS'
  },
  {
    stateKey: 'RS',
    value: 'VESPASIANO CORREA',
    label: 'VESPASIANO CORREA'
  },
  {
    stateKey: 'RS',
    value: 'VIADUTOS',
    label: 'VIADUTOS'
  },
  {
    stateKey: 'RS',
    value: 'VIAMAO',
    label: 'VIAMAO'
  },
  {
    stateKey: 'RS',
    value: 'VICENTE DUTRA',
    label: 'VICENTE DUTRA'
  },
  {
    stateKey: 'RS',
    value: 'VICTOR GRAEFF',
    label: 'VICTOR GRAEFF'
  },
  {
    stateKey: 'RS',
    value: 'VILA FLORES',
    label: 'VILA FLORES'
  },
  {
    stateKey: 'RS',
    value: 'VILA LANGARO',
    label: 'VILA LANGARO'
  },
  {
    stateKey: 'RS',
    value: 'VILA MARIA',
    label: 'VILA MARIA'
  },
  {
    stateKey: 'RS',
    value: 'VILA NOVA DO SUL',
    label: 'VILA NOVA DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'VISTA ALEGRE',
    label: 'VISTA ALEGRE'
  },
  {
    stateKey: 'RS',
    value: 'VISTA ALEGRE DO PRATA',
    label: 'VISTA ALEGRE DO PRATA'
  },
  {
    stateKey: 'RS',
    value: 'VISTA GAUCHA',
    label: 'VISTA GAUCHA'
  },
  {
    stateKey: 'RS',
    value: 'VITORIA DAS MISSOES',
    label: 'VITORIA DAS MISSOES'
  },
  {
    stateKey: 'RS',
    value: 'XANGRI-LA',
    label: 'XANGRI-LA'
  },
  {
    stateKey: 'RS',
    value: 'Pinhal da Serra',
    label: 'Pinhal da Serra'
  },
  {
    stateKey: 'RS',
    value: 'PEDRAS ALTAS',
    label: 'PEDRAS ALTAS'
  },
  {
    stateKey: 'RS',
    value: 'CRUZEIRO DO SUL',
    label: 'CRUZEIRO DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'SANTA ROSA',
    label: 'SANTA ROSA'
  },
  {
    stateKey: 'RS',
    value: 'ERVAL',
    label: 'ERVAL'
  },
  {
    stateKey: 'RS',
    value: 'CHIAPETA',
    label: 'CHIAPETA'
  },
  {
    stateKey: 'RS',
    value: 'TRINDADE',
    label: 'TRINDADE'
  },
  {
    stateKey: 'RS',
    value: 'BROCHIER DO MARATA',
    label: 'BROCHIER DO MARATA'
  },
  {
    stateKey: 'RS',
    value: 'ELDORADO DO SUL',
    label: 'ELDORADO DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'PAULO BENTO',
    label: 'PAULO BENTO'
  },
  {
    stateKey: 'RS',
    value: 'BOZANO',
    label: 'BOZANO'
  },
  {
    stateKey: 'RS',
    value: 'JACUIZINHO',
    label: 'JACUIZINHO'
  },
  {
    stateKey: 'RS',
    value: 'QUATRO IRMAOS',
    label: 'QUATRO IRMAOS'
  },
  {
    stateKey: 'RS',
    value: 'BOA VISTA DO CADEADO',
    label: 'BOA VISTA DO CADEADO'
  },
  {
    stateKey: 'RS',
    value: 'BOA VISTA DO INCRA',
    label: 'BOA VISTA DO INCRA'
  },
  {
    stateKey: 'RS',
    value: 'ALMIRANTE TAMANDARE DO SUL',
    label: 'ALMIRANTE TAMANDARE DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'CAPAO DO CIPO',
    label: 'CAPAO DO CIPO'
  },
  {
    stateKey: 'RS',
    value: 'CRUZALTENSE',
    label: 'CRUZALTENSE'
  },
  {
    stateKey: 'RS',
    value: 'ROLADOR',
    label: 'ROLADOR'
  },
  {
    stateKey: 'RS',
    value: 'ACEGUA',
    label: 'ACEGUA'
  },
  {
    stateKey: 'RS',
    value: 'CAPAO BONITO DO SUL',
    label: 'CAPAO BONITO DO SUL'
  },
  {
    stateKey: 'RS',
    value: 'MATO QUEIMADO',
    label: 'MATO QUEIMADO'
  },
  {
    stateKey: 'RS',
    value: 'TIO HUGO',
    label: 'TIO HUGO'
  },
  {
    stateKey: 'RS',
    value: 'TIO HUGO',
    label: 'TIO HUGO'
  },
  {
    stateKey: 'RS',
    value: 'VENANCIO AIRES',
    label: 'VENANCIO AIRES'
  },
  {
    stateKey: 'RO',
    value: 'ITAPUÃ DO OESTE',
    label: 'ITAPUÃ DO OESTE'
  },
  {
    stateKey: 'RO',
    value: 'ITAPUA DO OESTE',
    label: 'ITAPUA DO OESTE'
  },
  {
    stateKey: 'RO',
    value: "Nova Brasilândia D'Oeste",
    label: "Nova Brasilândia D'Oeste"
  },
  {
    stateKey: 'RO',
    value: 'ALTO ALEGRE DOS PARECIS',
    label: 'ALTO ALEGRE DOS PARECIS'
  },
  {
    stateKey: 'RO',
    value: 'ALTA FLORESTA DO OESTE',
    label: 'ALTA FLORESTA DO OESTE'
  },
  {
    stateKey: 'RO',
    value: 'ALTO PARAISO',
    label: 'ALTO PARAISO'
  },
  {
    stateKey: 'RO',
    value: 'ALVORADA DO OESTE',
    label: 'ALVORADA DO OESTE'
  },
  {
    stateKey: 'RO',
    value: 'ARIQUEMES',
    label: 'ARIQUEMES'
  },
  {
    stateKey: 'RO',
    value: 'BURITIS',
    label: 'BURITIS'
  },
  {
    stateKey: 'RO',
    value: 'CABIXI',
    label: 'CABIXI'
  },
  {
    stateKey: 'RO',
    value: 'CACAULANDIA',
    label: 'CACAULANDIA'
  },
  {
    stateKey: 'RO',
    value: 'CACOAL',
    label: 'CACOAL'
  },
  {
    stateKey: 'RO',
    value: 'CAMPO NOVO DE RONDONIA',
    label: 'CAMPO NOVO DE RONDONIA'
  },
  {
    stateKey: 'RO',
    value: 'CANDEIAS DO JAMARI',
    label: 'CANDEIAS DO JAMARI'
  },
  {
    stateKey: 'RO',
    value: 'CASTANHEIRAS',
    label: 'CASTANHEIRAS'
  },
  {
    stateKey: 'RO',
    value: 'CEREJEIRAS',
    label: 'CEREJEIRAS'
  },
  {
    stateKey: 'RO',
    value: 'CHUPINGUAIA',
    label: 'CHUPINGUAIA'
  },
  {
    stateKey: 'RO',
    value: 'COLORADO DO OESTE',
    label: 'COLORADO DO OESTE'
  },
  {
    stateKey: 'RO',
    value: 'CORUMBIARA',
    label: 'CORUMBIARA'
  },
  {
    stateKey: 'RO',
    value: 'COSTA MARQUES',
    label: 'COSTA MARQUES'
  },
  {
    stateKey: 'RO',
    value: 'CUJUBIM',
    label: 'CUJUBIM'
  },
  {
    stateKey: 'RO',
    value: "ESPIGAO D'OESTE",
    label: "ESPIGAO D'OESTE"
  },
  {
    stateKey: 'RO',
    value: 'GOVERNADOR JORGE TEIXEIRA',
    label: 'GOVERNADOR JORGE TEIXEIRA'
  },
  {
    stateKey: 'RO',
    value: 'GUAJARA MIRIM',
    label: 'GUAJARA MIRIM'
  },
  {
    stateKey: 'RO',
    value: 'JAMARI',
    label: 'JAMARI'
  },
  {
    stateKey: 'RO',
    value: 'JARU',
    label: 'JARU'
  },
  {
    stateKey: 'RO',
    value: 'JI-PARANA',
    label: 'JI-PARANA'
  },
  {
    stateKey: 'RO',
    value: "MACHADINHO D'OESTE",
    label: "MACHADINHO D'OESTE"
  },
  {
    stateKey: 'RO',
    value: 'MINISTRO ANDREAZZA',
    label: 'MINISTRO ANDREAZZA'
  },
  {
    stateKey: 'RO',
    value: 'MIRANTE DA SERRA',
    label: 'MIRANTE DA SERRA'
  },
  {
    stateKey: 'RO',
    value: 'MONTE NEGRO',
    label: 'MONTE NEGRO'
  },
  {
    stateKey: 'RO',
    value: 'NOVA MAMORE',
    label: 'NOVA MAMORE'
  },
  {
    stateKey: 'RO',
    value: 'NOVA UNIAO',
    label: 'NOVA UNIAO'
  },
  {
    stateKey: 'RO',
    value: 'NOVO HORIZONTE DO OESTE',
    label: 'NOVO HORIZONTE DO OESTE'
  },
  {
    stateKey: 'RO',
    value: 'OURO PRETO DO OESTE',
    label: 'OURO PRETO DO OESTE'
  },
  {
    stateKey: 'RO',
    value: 'PARECIS',
    label: 'PARECIS'
  },
  {
    stateKey: 'RO',
    value: 'PIMENTA BUENO',
    label: 'PIMENTA BUENO'
  },
  {
    stateKey: 'RO',
    value: "PIMENTEIRAS D'OESTE",
    label: "PIMENTEIRAS D'OESTE"
  },
  {
    stateKey: 'RO',
    value: 'PORTO VELHO',
    label: 'PORTO VELHO'
  },
  {
    stateKey: 'RO',
    value: 'PRESIDENTE MEDICI',
    label: 'PRESIDENTE MEDICI'
  },
  {
    stateKey: 'RO',
    value: 'PRIMAVERA DE RONDONIA',
    label: 'PRIMAVERA DE RONDONIA'
  },
  {
    stateKey: 'RO',
    value: 'RIO CRESPO',
    label: 'RIO CRESPO'
  },
  {
    stateKey: 'RO',
    value: 'ROLIM DE MOURA',
    label: 'ROLIM DE MOURA'
  },
  {
    stateKey: 'RO',
    value: 'SANTA LUZIA DO OESTE',
    label: 'SANTA LUZIA DO OESTE'
  },
  {
    stateKey: 'RO',
    value: "SAO FELIPE D'OESTE",
    label: "SAO FELIPE D'OESTE"
  },
  {
    stateKey: 'RO',
    value: 'SAO FRANCISCO DO GUAROPE',
    label: 'SAO FRANCISCO DO GUAROPE'
  },
  {
    stateKey: 'RO',
    value: 'SAO MIGUEL DO GUAPORE',
    label: 'SAO MIGUEL DO GUAPORE'
  },
  {
    stateKey: 'RO',
    value: 'SERINGUEIRAS',
    label: 'SERINGUEIRAS'
  },
  {
    stateKey: 'RO',
    value: 'TEIXEIROPOLIS',
    label: 'TEIXEIROPOLIS'
  },
  {
    stateKey: 'RO',
    value: 'THEOBROMA',
    label: 'THEOBROMA'
  },
  {
    stateKey: 'RO',
    value: 'URUPA',
    label: 'URUPA'
  },
  {
    stateKey: 'RO',
    value: 'VALE DO ANARI',
    label: 'VALE DO ANARI'
  },
  {
    stateKey: 'RO',
    value: 'VALE DO PARAISO',
    label: 'VALE DO PARAISO'
  },
  {
    stateKey: 'RO',
    value: 'VILHENA',
    label: 'VILHENA'
  },
  {
    stateKey: 'RO',
    value: 'VILA NOVA DO MAMORE',
    label: 'VILA NOVA DO MAMORE'
  },
  {
    stateKey: 'RO',
    value: 'APIDIA',
    label: 'APIDIA'
  },
  {
    stateKey: 'RO',
    value: 'EXTREMA DE RONDONIA',
    label: 'EXTREMA DE RONDONIA'
  },
  {
    stateKey: 'RO',
    value: 'CACAIEIROS',
    label: 'CACAIEIROS'
  },
  {
    stateKey: 'RR',
    value: 'ALTO ALEGRE',
    label: 'ALTO ALEGRE'
  },
  {
    stateKey: 'RR',
    value: 'AMAJARI',
    label: 'AMAJARI'
  },
  {
    stateKey: 'RR',
    value: 'BOA VISTA',
    label: 'BOA VISTA'
  },
  {
    stateKey: 'RR',
    value: 'BONFIM',
    label: 'BONFIM'
  },
  {
    stateKey: 'RR',
    value: 'CANTA',
    label: 'CANTA'
  },
  {
    stateKey: 'RR',
    value: 'CARACARAI',
    label: 'CARACARAI'
  },
  {
    stateKey: 'RR',
    value: 'CAROEBE',
    label: 'CAROEBE'
  },
  {
    stateKey: 'RR',
    value: 'IRACEMA',
    label: 'IRACEMA'
  },
  {
    stateKey: 'RR',
    value: 'MUCAJAI',
    label: 'MUCAJAI'
  },
  {
    stateKey: 'RR',
    value: 'NORMANDIA',
    label: 'NORMANDIA'
  },
  {
    stateKey: 'RR',
    value: 'PACARAIMA',
    label: 'PACARAIMA'
  },
  {
    stateKey: 'RR',
    value: 'RORAINOPOLIS',
    label: 'RORAINOPOLIS'
  },
  {
    stateKey: 'RR',
    value: 'SAO JOAO DA BALIZA',
    label: 'SAO JOAO DA BALIZA'
  },
  {
    stateKey: 'RR',
    value: 'SAO LUIZ',
    label: 'SAO LUIZ'
  },
  {
    stateKey: 'RR',
    value: 'UIRAMUTA',
    label: 'UIRAMUTA'
  },
  {
    stateKey: 'SC',
    value: 'NOVA ITABERABA',
    label: 'NOVA ITABERABA'
  },
  {
    stateKey: 'SC',
    value: 'São Lourenço do Oeste',
    label: 'São Lourenço do Oeste'
  },
  {
    stateKey: 'SC',
    value: 'Balneário Camboriú',
    label: 'Balneário Camboriú'
  },
  {
    stateKey: 'SC',
    value: 'Mirim Doce',
    label: 'Mirim Doce'
  },
  {
    stateKey: 'SC',
    value: 'São Miguel da Boa Vista',
    label: 'São Miguel da Boa Vista'
  },
  {
    stateKey: 'SC',
    value: 'Almirante Tamandaré do Sul- SC',
    label: 'Almirante Tamandaré do Sul- SC'
  },
  {
    stateKey: 'SC',
    value: 'ABDON BATISTA',
    label: 'ABDON BATISTA'
  },
  {
    stateKey: 'SC',
    value: 'ABELARDO LUZ',
    label: 'ABELARDO LUZ'
  },
  {
    stateKey: 'SC',
    value: 'AGROLANDIA',
    label: 'AGROLANDIA'
  },
  {
    stateKey: 'SC',
    value: 'AGRONOMICA',
    label: 'AGRONOMICA'
  },
  {
    stateKey: 'SC',
    value: 'AGUA DOCE',
    label: 'AGUA DOCE'
  },
  {
    stateKey: 'SC',
    value: 'AGUAS DE CHAPECO',
    label: 'AGUAS DE CHAPECO'
  },
  {
    stateKey: 'SC',
    value: 'AGUAS FRIAS',
    label: 'AGUAS FRIAS'
  },
  {
    stateKey: 'SC',
    value: 'AGUAS MORNAS',
    label: 'AGUAS MORNAS'
  },
  {
    stateKey: 'SC',
    value: 'ALFREDO WAGNER',
    label: 'ALFREDO WAGNER'
  },
  {
    stateKey: 'SC',
    value: 'ALTO BELA VISTA',
    label: 'ALTO BELA VISTA'
  },
  {
    stateKey: 'SC',
    value: 'ANCHIETA',
    label: 'ANCHIETA'
  },
  {
    stateKey: 'SC',
    value: 'ANGELINA',
    label: 'ANGELINA'
  },
  {
    stateKey: 'SC',
    value: 'ANITA GARIBALDI',
    label: 'ANITA GARIBALDI'
  },
  {
    stateKey: 'SC',
    value: 'ANITAPOLIS',
    label: 'ANITAPOLIS'
  },
  {
    stateKey: 'SC',
    value: 'ANTONIO CARLOS',
    label: 'ANTONIO CARLOS'
  },
  {
    stateKey: 'SC',
    value: 'APIUNA',
    label: 'APIUNA'
  },
  {
    stateKey: 'SC',
    value: 'ARABUTA',
    label: 'ARABUTA'
  },
  {
    stateKey: 'SC',
    value: 'ARAQUARI',
    label: 'ARAQUARI'
  },
  {
    stateKey: 'SC',
    value: 'ARARANGUA',
    label: 'ARARANGUA'
  },
  {
    stateKey: 'SC',
    value: 'ARMAZEM',
    label: 'ARMAZEM'
  },
  {
    stateKey: 'SC',
    value: 'ARROIO TRINTA',
    label: 'ARROIO TRINTA'
  },
  {
    stateKey: 'SC',
    value: 'ARVOREDO',
    label: 'ARVOREDO'
  },
  {
    stateKey: 'SC',
    value: 'ASCURRA',
    label: 'ASCURRA'
  },
  {
    stateKey: 'SC',
    value: 'ATALANTA',
    label: 'ATALANTA'
  },
  {
    stateKey: 'SC',
    value: 'AURORA',
    label: 'AURORA'
  },
  {
    stateKey: 'SC',
    value: 'BALNEARIO ARROIO DO SILVA',
    label: 'BALNEARIO ARROIO DO SILVA'
  },
  {
    stateKey: 'SC',
    value: 'BALNEARIO BARRA DO SUL',
    label: 'BALNEARIO BARRA DO SUL'
  },
  {
    stateKey: 'SC',
    value: 'SAO LOURENCO DO OESTE',
    label: 'SAO LOURENCO DO OESTE'
  },
  {
    stateKey: 'SC',
    value: 'BALNEARIO GAIVOTA',
    label: 'BALNEARIO GAIVOTA'
  },
  {
    stateKey: 'SC',
    value: 'BANDEIRANTE',
    label: 'BANDEIRANTE'
  },
  {
    stateKey: 'SC',
    value: 'BARRA BONITA',
    label: 'BARRA BONITA'
  },
  {
    stateKey: 'SC',
    value: 'BARRA VELHA',
    label: 'BARRA VELHA'
  },
  {
    stateKey: 'SC',
    value: 'BELA VISTA DO TOLDO',
    label: 'BELA VISTA DO TOLDO'
  },
  {
    stateKey: 'SC',
    value: 'BELMONTE',
    label: 'BELMONTE'
  },
  {
    stateKey: 'SC',
    value: 'BENEDITO NOVO',
    label: 'BENEDITO NOVO'
  },
  {
    stateKey: 'SC',
    value: 'BIGUACU',
    label: 'BIGUACU'
  },
  {
    stateKey: 'SC',
    value: 'BLUMENAU',
    label: 'BLUMENAU'
  },
  {
    stateKey: 'SC',
    value: 'BOCAINA DO SUL',
    label: 'BOCAINA DO SUL'
  },
  {
    stateKey: 'SC',
    value: 'BOM JARDIM DA SERRA',
    label: 'BOM JARDIM DA SERRA'
  },
  {
    stateKey: 'SC',
    value: 'BOM JESUS',
    label: 'BOM JESUS'
  },
  {
    stateKey: 'SC',
    value: 'BOM JESUS DO OESTE',
    label: 'BOM JESUS DO OESTE'
  },
  {
    stateKey: 'SC',
    value: 'BOM RETIRO',
    label: 'BOM RETIRO'
  },
  {
    stateKey: 'SC',
    value: 'BOMBINHAS',
    label: 'BOMBINHAS'
  },
  {
    stateKey: 'SC',
    value: 'BOTUVERA',
    label: 'BOTUVERA'
  },
  {
    stateKey: 'SC',
    value: 'BRACO DO NORTE',
    label: 'BRACO DO NORTE'
  },
  {
    stateKey: 'SC',
    value: 'BRACO DO TROMBUDO',
    label: 'BRACO DO TROMBUDO'
  },
  {
    stateKey: 'SC',
    value: 'BRUNOPOLIS',
    label: 'BRUNOPOLIS'
  },
  {
    stateKey: 'SC',
    value: 'BRUSQUE',
    label: 'BRUSQUE'
  },
  {
    stateKey: 'SC',
    value: 'CACADOR',
    label: 'CACADOR'
  },
  {
    stateKey: 'SC',
    value: 'CAIBI',
    label: 'CAIBI'
  },
  {
    stateKey: 'SC',
    value: 'CALMON',
    label: 'CALMON'
  },
  {
    stateKey: 'SC',
    value: 'CAMBORIU',
    label: 'CAMBORIU'
  },
  {
    stateKey: 'SC',
    value: 'CAMPO BELO DO SUL',
    label: 'CAMPO BELO DO SUL'
  },
  {
    stateKey: 'SC',
    value: 'CAMPO ERE',
    label: 'CAMPO ERE'
  },
  {
    stateKey: 'SC',
    value: 'CAMPOS NOVOS',
    label: 'CAMPOS NOVOS'
  },
  {
    stateKey: 'SC',
    value: 'CANELINHA',
    label: 'CANELINHA'
  },
  {
    stateKey: 'SC',
    value: 'CANOINHAS',
    label: 'CANOINHAS'
  },
  {
    stateKey: 'SC',
    value: 'CAPAO ALTO',
    label: 'CAPAO ALTO'
  },
  {
    stateKey: 'SC',
    value: 'CAPINZAL',
    label: 'CAPINZAL'
  },
  {
    stateKey: 'SC',
    value: 'CAPIVARI DE BAIXO',
    label: 'CAPIVARI DE BAIXO'
  },
  {
    stateKey: 'SC',
    value: 'CATANDUVAS',
    label: 'CATANDUVAS'
  },
  {
    stateKey: 'SC',
    value: 'CAXAMBU DO SUL',
    label: 'CAXAMBU DO SUL'
  },
  {
    stateKey: 'SC',
    value: 'CELSO RAMOS',
    label: 'CELSO RAMOS'
  },
  {
    stateKey: 'SC',
    value: 'CERRO NEGRO',
    label: 'CERRO NEGRO'
  },
  {
    stateKey: 'SC',
    value: 'CHAPADAO DO LAGEADO',
    label: 'CHAPADAO DO LAGEADO'
  },
  {
    stateKey: 'SC',
    value: 'CHAPECO',
    label: 'CHAPECO'
  },
  {
    stateKey: 'SC',
    value: 'COCAL DO SUL',
    label: 'COCAL DO SUL'
  },
  {
    stateKey: 'SC',
    value: 'CONCORDIA',
    label: 'CONCORDIA'
  },
  {
    stateKey: 'SC',
    value: 'CORDILHEIRA ALTA',
    label: 'CORDILHEIRA ALTA'
  },
  {
    stateKey: 'SC',
    value: 'CORONEL FREITAS',
    label: 'CORONEL FREITAS'
  },
  {
    stateKey: 'SC',
    value: 'CORONEL MARTINS',
    label: 'CORONEL MARTINS'
  },
  {
    stateKey: 'SC',
    value: 'CORREIA PINTO',
    label: 'CORREIA PINTO'
  },
  {
    stateKey: 'SC',
    value: 'CORUPA',
    label: 'CORUPA'
  },
  {
    stateKey: 'SC',
    value: 'CRICIUMA',
    label: 'CRICIUMA'
  },
  {
    stateKey: 'SC',
    value: 'CUNHA PORA',
    label: 'CUNHA PORA'
  },
  {
    stateKey: 'SC',
    value: 'CUNHATAI',
    label: 'CUNHATAI'
  },
  {
    stateKey: 'SC',
    value: 'CURITIBANOS',
    label: 'CURITIBANOS'
  },
  {
    stateKey: 'SC',
    value: 'DESCANSO',
    label: 'DESCANSO'
  },
  {
    stateKey: 'SC',
    value: 'DIONISIO CERQUEIRA',
    label: 'DIONISIO CERQUEIRA'
  },
  {
    stateKey: 'SC',
    value: 'DONA EMMA',
    label: 'DONA EMMA'
  },
  {
    stateKey: 'SC',
    value: 'DOUTOR PEDRINHO',
    label: 'DOUTOR PEDRINHO'
  },
  {
    stateKey: 'SC',
    value: 'ENTRE RIOS',
    label: 'ENTRE RIOS'
  },
  {
    stateKey: 'SC',
    value: 'ERMO',
    label: 'ERMO'
  },
  {
    stateKey: 'SC',
    value: 'ERVAL VELHO',
    label: 'ERVAL VELHO'
  },
  {
    stateKey: 'SC',
    value: 'FLOR DO SERTAO',
    label: 'FLOR DO SERTAO'
  },
  {
    stateKey: 'SC',
    value: 'FLORIANOPOLIS',
    label: 'FLORIANOPOLIS'
  },
  {
    stateKey: 'SC',
    value: 'FORMOSA DO SUL',
    label: 'FORMOSA DO SUL'
  },
  {
    stateKey: 'SC',
    value: 'FORQUILHINHA',
    label: 'FORQUILHINHA'
  },
  {
    stateKey: 'SC',
    value: 'FRAIBURGO',
    label: 'FRAIBURGO'
  },
  {
    stateKey: 'SC',
    value: 'FREI ROGERIO',
    label: 'FREI ROGERIO'
  },
  {
    stateKey: 'SC',
    value: 'GALVAO',
    label: 'GALVAO'
  },
  {
    stateKey: 'SC',
    value: 'GAROPABA',
    label: 'GAROPABA'
  },
  {
    stateKey: 'SC',
    value: 'GARUVA',
    label: 'GARUVA'
  },
  {
    stateKey: 'SC',
    value: 'GASPAR',
    label: 'GASPAR'
  },
  {
    stateKey: 'SC',
    value: 'GOVERNADOR CELSO RAMOS',
    label: 'GOVERNADOR CELSO RAMOS'
  },
  {
    stateKey: 'SC',
    value: 'GRAO PARA',
    label: 'GRAO PARA'
  },
  {
    stateKey: 'SC',
    value: 'GRAVATAL',
    label: 'GRAVATAL'
  },
  {
    stateKey: 'SC',
    value: 'GUABIRUBA',
    label: 'GUABIRUBA'
  },
  {
    stateKey: 'SC',
    value: 'GUARACIABA',
    label: 'GUARACIABA'
  },
  {
    stateKey: 'SC',
    value: 'GUARAMIRIM',
    label: 'GUARAMIRIM'
  },
  {
    stateKey: 'SC',
    value: 'GUARUJA DO SUL',
    label: 'GUARUJA DO SUL'
  },
  {
    stateKey: 'SC',
    value: 'GUATAMBU',
    label: 'GUATAMBU'
  },
  {
    stateKey: 'SC',
    value: "HERVAL D'OESTE",
    label: "HERVAL D'OESTE"
  },
  {
    stateKey: 'SC',
    value: 'IBIAM',
    label: 'IBIAM'
  },
  {
    stateKey: 'SC',
    value: 'IBICARE',
    label: 'IBICARE'
  },
  {
    stateKey: 'SC',
    value: 'IBIRAMA',
    label: 'IBIRAMA'
  },
  {
    stateKey: 'SC',
    value: 'ICARA',
    label: 'ICARA'
  },
  {
    stateKey: 'SC',
    value: 'ILHOTA',
    label: 'ILHOTA'
  },
  {
    stateKey: 'SC',
    value: 'IMARUI',
    label: 'IMARUI'
  },
  {
    stateKey: 'SC',
    value: 'IMBITUBA',
    label: 'IMBITUBA'
  },
  {
    stateKey: 'SC',
    value: 'IMBUIA',
    label: 'IMBUIA'
  },
  {
    stateKey: 'SC',
    value: 'INDAIAL',
    label: 'INDAIAL'
  },
  {
    stateKey: 'SC',
    value: 'IOMERE',
    label: 'IOMERE'
  },
  {
    stateKey: 'SC',
    value: 'IPIRA',
    label: 'IPIRA'
  },
  {
    stateKey: 'SC',
    value: 'IPORA DO OESTE',
    label: 'IPORA DO OESTE'
  },
  {
    stateKey: 'SC',
    value: 'IPUACU',
    label: 'IPUACU'
  },
  {
    stateKey: 'SC',
    value: 'IPUMIRIM',
    label: 'IPUMIRIM'
  },
  {
    stateKey: 'SC',
    value: 'IRACEMINHA',
    label: 'IRACEMINHA'
  },
  {
    stateKey: 'SC',
    value: 'IRANI',
    label: 'IRANI'
  },
  {
    stateKey: 'SC',
    value: 'IRATI',
    label: 'IRATI'
  },
  {
    stateKey: 'SC',
    value: 'IRINEOPOLIS',
    label: 'IRINEOPOLIS'
  },
  {
    stateKey: 'SC',
    value: 'ITA',
    label: 'ITA'
  },
  {
    stateKey: 'SC',
    value: 'ITAIOPOLIS',
    label: 'ITAIOPOLIS'
  },
  {
    stateKey: 'SC',
    value: 'ITAJAI',
    label: 'ITAJAI'
  },
  {
    stateKey: 'SC',
    value: 'ITAPEMA',
    label: 'ITAPEMA'
  },
  {
    stateKey: 'SC',
    value: 'ITAPIRANGA',
    label: 'ITAPIRANGA'
  },
  {
    stateKey: 'SC',
    value: 'ITAPOA',
    label: 'ITAPOA'
  },
  {
    stateKey: 'SC',
    value: 'ITUPORANGA',
    label: 'ITUPORANGA'
  },
  {
    stateKey: 'SC',
    value: 'JABORA',
    label: 'JABORA'
  },
  {
    stateKey: 'SC',
    value: 'JACINTO MACHADO',
    label: 'JACINTO MACHADO'
  },
  {
    stateKey: 'SC',
    value: 'JAGUARUNA',
    label: 'JAGUARUNA'
  },
  {
    stateKey: 'SC',
    value: 'JARAGUA DO SUL',
    label: 'JARAGUA DO SUL'
  },
  {
    stateKey: 'SC',
    value: 'JARDINOPOLIS',
    label: 'JARDINOPOLIS'
  },
  {
    stateKey: 'SC',
    value: 'JOACABA',
    label: 'JOACABA'
  },
  {
    stateKey: 'SC',
    value: 'JOINVILLE',
    label: 'JOINVILLE'
  },
  {
    stateKey: 'SC',
    value: 'JOSE BOITEUX',
    label: 'JOSE BOITEUX'
  },
  {
    stateKey: 'SC',
    value: 'JUPIA',
    label: 'JUPIA'
  },
  {
    stateKey: 'SC',
    value: 'LACERDOPOLIS',
    label: 'LACERDOPOLIS'
  },
  {
    stateKey: 'SC',
    value: 'LAGES',
    label: 'LAGES'
  },
  {
    stateKey: 'SC',
    value: 'LAGUNA',
    label: 'LAGUNA'
  },
  {
    stateKey: 'SC',
    value: 'LAJEADO GRANDE',
    label: 'LAJEADO GRANDE'
  },
  {
    stateKey: 'SC',
    value: 'LAURENTINO',
    label: 'LAURENTINO'
  },
  {
    stateKey: 'SC',
    value: 'LAURO MULLER',
    label: 'LAURO MULLER'
  },
  {
    stateKey: 'SC',
    value: 'LEBON REGIS',
    label: 'LEBON REGIS'
  },
  {
    stateKey: 'SC',
    value: 'LEOBERTO LEAL',
    label: 'LEOBERTO LEAL'
  },
  {
    stateKey: 'SC',
    value: 'LINDOIA DO SUL',
    label: 'LINDOIA DO SUL'
  },
  {
    stateKey: 'SC',
    value: 'LONTRAS',
    label: 'LONTRAS'
  },
  {
    stateKey: 'SC',
    value: 'LUZERNA',
    label: 'LUZERNA'
  },
  {
    stateKey: 'SC',
    value: 'MACIEIRA',
    label: 'MACIEIRA'
  },
  {
    stateKey: 'SC',
    value: 'MAFRA',
    label: 'MAFRA'
  },
  {
    stateKey: 'SC',
    value: 'MAJOR GERCINO',
    label: 'MAJOR GERCINO'
  },
  {
    stateKey: 'SC',
    value: 'MAJOR VIEIRA',
    label: 'MAJOR VIEIRA'
  },
  {
    stateKey: 'SC',
    value: 'MARACAJA',
    label: 'MARACAJA'
  },
  {
    stateKey: 'SC',
    value: 'MARAVILHA',
    label: 'MARAVILHA'
  },
  {
    stateKey: 'SC',
    value: 'MAREMA',
    label: 'MAREMA'
  },
  {
    stateKey: 'SC',
    value: 'MASSARANDUBA',
    label: 'MASSARANDUBA'
  },
  {
    stateKey: 'SC',
    value: 'MATOS COSTA',
    label: 'MATOS COSTA'
  },
  {
    stateKey: 'SC',
    value: 'MELEIRO',
    label: 'MELEIRO'
  },
  {
    stateKey: 'SC',
    value: 'MODELO',
    label: 'MODELO'
  },
  {
    stateKey: 'SC',
    value: 'MONDAI',
    label: 'MONDAI'
  },
  {
    stateKey: 'SC',
    value: 'MONTE CARLO',
    label: 'MONTE CARLO'
  },
  {
    stateKey: 'SC',
    value: 'MONTE CASTELO',
    label: 'MONTE CASTELO'
  },
  {
    stateKey: 'SC',
    value: 'MORRO DA FUMACA',
    label: 'MORRO DA FUMACA'
  },
  {
    stateKey: 'SC',
    value: 'MORRO GRANDE',
    label: 'MORRO GRANDE'
  },
  {
    stateKey: 'SC',
    value: 'NAVEGANTES',
    label: 'NAVEGANTES'
  },
  {
    stateKey: 'SC',
    value: 'NOVA ERECHIM',
    label: 'NOVA ERECHIM'
  },
  {
    stateKey: 'SC',
    value: 'NOVA TRENTO',
    label: 'NOVA TRENTO'
  },
  {
    stateKey: 'SC',
    value: 'NOVA VENEZA',
    label: 'NOVA VENEZA'
  },
  {
    stateKey: 'SC',
    value: 'NOVO HORIZONTE',
    label: 'NOVO HORIZONTE'
  },
  {
    stateKey: 'SC',
    value: 'ORLEANS',
    label: 'ORLEANS'
  },
  {
    stateKey: 'SC',
    value: 'OTACILIO COSTA',
    label: 'OTACILIO COSTA'
  },
  {
    stateKey: 'SC',
    value: 'OURO',
    label: 'OURO'
  },
  {
    stateKey: 'SC',
    value: 'OURO VERDE',
    label: 'OURO VERDE'
  },
  {
    stateKey: 'SC',
    value: 'PAIAL',
    label: 'PAIAL'
  },
  {
    stateKey: 'SC',
    value: 'PAINEL',
    label: 'PAINEL'
  },
  {
    stateKey: 'SC',
    value: 'PALHOCA',
    label: 'PALHOCA'
  },
  {
    stateKey: 'SC',
    value: 'PALMA SOLA',
    label: 'PALMA SOLA'
  },
  {
    stateKey: 'SC',
    value: 'PALMEIRA',
    label: 'PALMEIRA'
  },
  {
    stateKey: 'SC',
    value: 'PALMITOS',
    label: 'PALMITOS'
  },
  {
    stateKey: 'SC',
    value: 'PAPANDUVA',
    label: 'PAPANDUVA'
  },
  {
    stateKey: 'SC',
    value: 'PARAISO',
    label: 'PARAISO'
  },
  {
    stateKey: 'SC',
    value: 'PASSO DE TORRES',
    label: 'PASSO DE TORRES'
  },
  {
    stateKey: 'SC',
    value: 'PASSOS MAIA',
    label: 'PASSOS MAIA'
  },
  {
    stateKey: 'SC',
    value: 'PAULO LOPES',
    label: 'PAULO LOPES'
  },
  {
    stateKey: 'SC',
    value: 'PEDRAS GRANDES',
    label: 'PEDRAS GRANDES'
  },
  {
    stateKey: 'SC',
    value: 'PENHA',
    label: 'PENHA'
  },
  {
    stateKey: 'SC',
    value: 'PERITIBA',
    label: 'PERITIBA '
  },
  {
    stateKey: 'SC',
    value: 'PETROLANDIA',
    label: 'PETROLANDIA'
  },
  {
    stateKey: 'SC',
    value: 'PICARRAS',
    label: 'PICARRAS'
  },
  {
    stateKey: 'SC',
    value: 'PINHALZINHO',
    label: 'PINHALZINHO'
  },
  {
    stateKey: 'SC',
    value: 'PINHEIRO PRETO',
    label: 'PINHEIRO PRETO'
  },
  {
    stateKey: 'SC',
    value: 'PIRATUBA',
    label: 'PIRATUBA'
  },
  {
    stateKey: 'SC',
    value: 'PLANALTO ALEGRE',
    label: 'PLANALTO ALEGRE'
  },
  {
    stateKey: 'SC',
    value: 'POMERODE',
    label: 'POMERODE'
  },
  {
    stateKey: 'SC',
    value: 'PONTE ALTA',
    label: 'PONTE ALTA'
  },
  {
    stateKey: 'SC',
    value: 'PONTE ALTA DO NORTE',
    label: 'PONTE ALTA DO NORTE'
  },
  {
    stateKey: 'SC',
    value: 'PONTE SERRADA',
    label: 'PONTE SERRADA'
  },
  {
    stateKey: 'SC',
    value: 'PORTO BELO',
    label: 'PORTO BELO'
  },
  {
    stateKey: 'SC',
    value: 'PORTO UNIAO',
    label: 'PORTO UNIAO'
  },
  {
    stateKey: 'SC',
    value: 'POUSO REDONDO',
    label: 'POUSO REDONDO'
  },
  {
    stateKey: 'SC',
    value: 'PRAIA GRANDE',
    label: 'PRAIA GRANDE'
  },
  {
    stateKey: 'SC',
    value: 'PRESIDENTE CASTELO BRANCO',
    label: 'PRESIDENTE CASTELO BRANCO'
  },
  {
    stateKey: 'SC',
    value: 'PRESIDENTE GETULIO',
    label: 'PRESIDENTE GETULIO'
  },
  {
    stateKey: 'SC',
    value: 'PRESIDENTE NEREU',
    label: 'PRESIDENTE NEREU'
  },
  {
    stateKey: 'SC',
    value: 'PRINCESA',
    label: 'PRINCESA'
  },
  {
    stateKey: 'SC',
    value: 'QUILOMBO',
    label: 'QUILOMBO'
  },
  {
    stateKey: 'SC',
    value: 'RANCHO QUEIMADO',
    label: 'RANCHO QUEIMADO'
  },
  {
    stateKey: 'SC',
    value: 'RIO DAS ANTAS',
    label: 'RIO DAS ANTAS'
  },
  {
    stateKey: 'SC',
    value: 'RIO DO CAMPO',
    label: 'RIO DO CAMPO'
  },
  {
    stateKey: 'SC',
    value: 'RIO DO OESTE',
    label: 'RIO DO OESTE'
  },
  {
    stateKey: 'SC',
    value: 'RIO DO SUL',
    label: 'RIO DO SUL'
  },
  {
    stateKey: 'SC',
    value: 'RIO DOS CEDROS',
    label: 'RIO DOS CEDROS'
  },
  {
    stateKey: 'SC',
    value: 'RIO FORTUNA',
    label: 'RIO FORTUNA'
  },
  {
    stateKey: 'SC',
    value: 'RIO NEGRINHO',
    label: 'RIO NEGRINHO'
  },
  {
    stateKey: 'SC',
    value: 'RIO RUFINO',
    label: 'RIO RUFINO'
  },
  {
    stateKey: 'SC',
    value: 'RIQUEZA',
    label: 'RIQUEZA'
  },
  {
    stateKey: 'SC',
    value: 'RODEIO',
    label: 'RODEIO'
  },
  {
    stateKey: 'SC',
    value: 'ROMELANDIA',
    label: 'ROMELANDIA'
  },
  {
    stateKey: 'SC',
    value: 'SALETE',
    label: 'SALETE'
  },
  {
    stateKey: 'SC',
    value: 'SALTINHO',
    label: 'SALTINHO'
  },
  {
    stateKey: 'SC',
    value: 'SALTO VELOSO',
    label: 'SALTO VELOSO'
  },
  {
    stateKey: 'SC',
    value: 'SANGAO',
    label: 'SANGAO'
  },
  {
    stateKey: 'SC',
    value: 'SANTA CECILIA',
    label: 'SANTA CECILIA'
  },
  {
    stateKey: 'SC',
    value: 'SANTA HELENA',
    label: 'SANTA HELENA'
  },
  {
    stateKey: 'SC',
    value: 'SANTA ROSA DE LIMA',
    label: 'SANTA ROSA DE LIMA'
  },
  {
    stateKey: 'SC',
    value: 'SANTA ROSA DO SUL',
    label: 'SANTA ROSA DO SUL'
  },
  {
    stateKey: 'SC',
    value: 'SANTA TEREZINHA',
    label: 'SANTA TEREZINHA'
  },
  {
    stateKey: 'SC',
    value: 'SANTA TEREZINHA DO PROGRES- SC',
    label: 'SANTA TEREZINHA DO PROGRES- SC'
  },
  {
    stateKey: 'SC',
    value: 'SANTIAGO DO SUL',
    label: 'SANTIAGO DO SUL'
  },
  {
    stateKey: 'SC',
    value: 'SANTO AMARO DA IMPERATRIZ',
    label: 'SANTO AMARO DA IMPERATRIZ'
  },
  {
    stateKey: 'SC',
    value: 'SAO BENTO DO SUL',
    label: 'SAO BENTO DO SUL'
  },
  {
    stateKey: 'SC',
    value: 'SAO BERNARDINO',
    label: 'SAO BERNARDINO'
  },
  {
    stateKey: 'SC',
    value: 'SAO BONIFACIO',
    label: 'SAO BONIFACIO'
  },
  {
    stateKey: 'SC',
    value: 'SAO CARLOS',
    label: 'SAO CARLOS'
  },
  {
    stateKey: 'SC',
    value: 'SAO CRISTOVAO DO SUL',
    label: 'SAO CRISTOVAO DO SUL'
  },
  {
    stateKey: 'SC',
    value: 'SAO DOMINGOS',
    label: 'SAO DOMINGOS'
  },
  {
    stateKey: 'SC',
    value: 'SAO FRANCISCO DO SUL',
    label: 'SAO FRANCISCO DO SUL'
  },
  {
    stateKey: 'SC',
    value: 'SAO JOAO BATISTA',
    label: 'SAO JOAO BATISTA'
  },
  {
    stateKey: 'SC',
    value: 'SAO JOAO DO ITAPERIU',
    label: 'SAO JOAO DO ITAPERIU'
  },
  {
    stateKey: 'SC',
    value: 'SAO JOAO DO OESTE',
    label: 'SAO JOAO DO OESTE'
  },
  {
    stateKey: 'SC',
    value: 'SAO JOAO DO SUL',
    label: 'SAO JOAO DO SUL'
  },
  {
    stateKey: 'SC',
    value: 'SAO JOAQUIM',
    label: 'SAO JOAQUIM'
  },
  {
    stateKey: 'SC',
    value: 'SAO JOSE',
    label: 'SAO JOSE'
  },
  {
    stateKey: 'SC',
    value: 'SAO JOSE DO CEDRO',
    label: 'SAO JOSE DO CEDRO'
  },
  {
    stateKey: 'SC',
    value: 'SAO JOSE DO CERRITO',
    label: 'SAO JOSE DO CERRITO'
  },
  {
    stateKey: 'SC',
    value: 'SAO LUDGERO',
    label: 'SAO LUDGERO'
  },
  {
    stateKey: 'SC',
    value: 'SAO MARTINHO',
    label: 'SAO MARTINHO'
  },
  {
    stateKey: 'SC',
    value: 'SAO MIGUEL DO OESTE',
    label: 'SAO MIGUEL DO OESTE'
  },
  {
    stateKey: 'SC',
    value: 'SAO PEDRO DE ALCANTARA',
    label: 'SAO PEDRO DE ALCANTARA'
  },
  {
    stateKey: 'SC',
    value: 'SAUDADES',
    label: 'SAUDADES'
  },
  {
    stateKey: 'SC',
    value: 'SCHROEDER',
    label: 'SCHROEDER'
  },
  {
    stateKey: 'SC',
    value: 'SEARA',
    label: 'SEARA'
  },
  {
    stateKey: 'SC',
    value: 'SERRA ALTA',
    label: 'SERRA ALTA'
  },
  {
    stateKey: 'SC',
    value: 'SIDEROPOLIS',
    label: 'SIDEROPOLIS'
  },
  {
    stateKey: 'SC',
    value: 'SOMBRIO',
    label: 'SOMBRIO'
  },
  {
    stateKey: 'SC',
    value: 'SUL BRASIL',
    label: 'SUL BRASIL'
  },
  {
    stateKey: 'SC',
    value: 'TAIO',
    label: 'TAIO'
  },
  {
    stateKey: 'SC',
    value: 'TANGARA',
    label: 'TANGARA'
  },
  {
    stateKey: 'SC',
    value: 'TIGRINHOS',
    label: 'TIGRINHOS'
  },
  {
    stateKey: 'SC',
    value: 'TIJUCAS',
    label: 'TIJUCAS'
  },
  {
    stateKey: 'SC',
    value: 'TIMBE DO SUL',
    label: 'TIMBE DO SUL'
  },
  {
    stateKey: 'SC',
    value: 'TIMBO',
    label: 'TIMBO'
  },
  {
    stateKey: 'SC',
    value: 'TIMBO GRANDE',
    label: 'TIMBO GRANDE'
  },
  {
    stateKey: 'SC',
    value: 'TRES BARRAS',
    label: 'TRES BARRAS'
  },
  {
    stateKey: 'SC',
    value: 'TREVISO',
    label: 'TREVISO'
  },
  {
    stateKey: 'SC',
    value: 'TREZE DE MAIO',
    label: 'TREZE DE MAIO'
  },
  {
    stateKey: 'SC',
    value: 'TREZE TILIAS',
    label: 'TREZE TILIAS'
  },
  {
    stateKey: 'SC',
    value: 'TROMBUDO CENTRAL',
    label: 'TROMBUDO CENTRAL'
  },
  {
    stateKey: 'SC',
    value: 'TUBARAO',
    label: 'TUBARAO'
  },
  {
    stateKey: 'SC',
    value: 'TUNAPOLIS',
    label: 'TUNAPOLIS'
  },
  {
    stateKey: 'SC',
    value: 'TURVO',
    label: 'TURVO'
  },
  {
    stateKey: 'SC',
    value: 'UNIAO DO OESTE',
    label: 'UNIAO DO OESTE'
  },
  {
    stateKey: 'SC',
    value: 'URUBICI',
    label: 'URUBICI'
  },
  {
    stateKey: 'SC',
    value: 'URUPEMA',
    label: 'URUPEMA'
  },
  {
    stateKey: 'SC',
    value: 'URUSSANGA',
    label: 'URUSSANGA'
  },
  {
    stateKey: 'SC',
    value: 'VARGEAO',
    label: 'VARGEAO'
  },
  {
    stateKey: 'SC',
    value: 'VARGEM',
    label: 'VARGEM'
  },
  {
    stateKey: 'SC',
    value: 'VARGEM BONITA',
    label: 'VARGEM BONITA'
  },
  {
    stateKey: 'SC',
    value: 'VIDAL RAMOS',
    label: 'VIDAL RAMOS'
  },
  {
    stateKey: 'SC',
    value: 'VIDEIRA',
    label: 'VIDEIRA'
  },
  {
    stateKey: 'SC',
    value: 'VITOR MEIRELES',
    label: 'VITOR MEIRELES'
  },
  {
    stateKey: 'SC',
    value: 'WITMARSUM',
    label: 'WITMARSUM'
  },
  {
    stateKey: 'SC',
    value: 'XANXERE',
    label: 'XANXERE'
  },
  {
    stateKey: 'SC',
    value: 'XAVANTINA',
    label: 'XAVANTINA'
  },
  {
    stateKey: 'SC',
    value: 'XAXIM',
    label: 'XAXIM'
  },
  {
    stateKey: 'SC',
    value: 'ZORTEA',
    label: 'ZORTEA'
  },
  {
    stateKey: 'SC',
    value: 'FAXINAL DOS GUEDES',
    label: 'FAXINAL DOS GUEDES'
  },
  {
    stateKey: 'SC',
    value: 'BALNEARIO DE PICARRAS',
    label: 'BALNEARIO DE PICARRAS'
  },
  {
    stateKey: 'SC',
    value: 'CAMPO ALEGRE',
    label: 'CAMPO ALEGRE'
  },
  {
    stateKey: 'SC',
    value: 'LUIS ALVES',
    label: 'LUIS ALVES'
  },
  {
    stateKey: 'SC',
    value: 'LUIZ ALVES',
    label: 'LUIZ ALVES'
  },
  {
    stateKey: 'SC',
    value: 'BALNEÁRIO CAMBORIÚ',
    label: 'BALNEÁRIO CAMBORIÚ'
  },
  {
    stateKey: 'SC',
    value: 'PESCARIA BRAVA',
    label: 'PESCARIA BRAVA'
  },
  {
    stateKey: 'SP',
    value: 'RIVERSUL',
    label: 'RIVERSUL'
  },
  {
    stateKey: 'SP',
    value: 'ADAMANTINA',
    label: 'ADAMANTINA'
  },
  {
    stateKey: 'SP',
    value: 'ADOLFO',
    label: 'ADOLFO'
  },
  {
    stateKey: 'SP',
    value: 'AGUAI',
    label: 'AGUAI'
  },
  {
    stateKey: 'SP',
    value: 'AGUAS DA PRATA',
    label: 'AGUAS DA PRATA'
  },
  {
    stateKey: 'SP',
    value: 'AGUAS DE LINDOIA',
    label: 'AGUAS DE LINDOIA'
  },
  {
    stateKey: 'SP',
    value: 'AGUAS DE SANTA BARBARA',
    label: 'AGUAS DE SANTA BARBARA'
  },
  {
    stateKey: 'SP',
    value: 'AGUAS DE SAO PEDRO',
    label: 'AGUAS DE SAO PEDRO'
  },
  {
    stateKey: 'SP',
    value: 'AGUDOS',
    label: 'AGUDOS'
  },
  {
    stateKey: 'SP',
    value: 'ALAMBARI',
    label: 'ALAMBARI'
  },
  {
    stateKey: 'SP',
    value: 'ALFREDO MARCONDES',
    label: 'ALFREDO MARCONDES'
  },
  {
    stateKey: 'SP',
    value: 'ALTAIR',
    label: 'ALTAIR'
  },
  {
    stateKey: 'SP',
    value: 'ALTINOPOLIS',
    label: 'ALTINOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'ALTO ALEGRE',
    label: 'ALTO ALEGRE'
  },
  {
    stateKey: 'SP',
    value: 'ALUMINIO',
    label: 'ALUMINIO'
  },
  {
    stateKey: 'SP',
    value: 'ALVARES FLORENCE',
    label: 'ALVARES FLORENCE'
  },
  {
    stateKey: 'SP',
    value: 'ALVARES MACHADO',
    label: 'ALVARES MACHADO'
  },
  {
    stateKey: 'SP',
    value: 'ALVARO DE CARVALHO',
    label: 'ALVARO DE CARVALHO'
  },
  {
    stateKey: 'SP',
    value: 'ALVINLANDIA',
    label: 'ALVINLANDIA'
  },
  {
    stateKey: 'SP',
    value: 'AMERICANA',
    label: 'AMERICANA'
  },
  {
    stateKey: 'SP',
    value: 'AMERICO BRASILIENSE',
    label: 'AMERICO BRASILIENSE'
  },
  {
    stateKey: 'SP',
    value: 'AMERICO DE CAMPOS',
    label: 'AMERICO DE CAMPOS'
  },
  {
    stateKey: 'SP',
    value: 'AMPARO',
    label: 'AMPARO'
  },
  {
    stateKey: 'SP',
    value: 'ANALANDIA',
    label: 'ANALANDIA'
  },
  {
    stateKey: 'SP',
    value: 'ANDRADINA',
    label: 'ANDRADINA'
  },
  {
    stateKey: 'SP',
    value: 'ANGATUBA',
    label: 'ANGATUBA'
  },
  {
    stateKey: 'SP',
    value: 'ANHEMBI',
    label: 'ANHEMBI'
  },
  {
    stateKey: 'SP',
    value: 'ANHUMAS',
    label: 'ANHUMAS'
  },
  {
    stateKey: 'SP',
    value: 'APARECIDA',
    label: 'APARECIDA'
  },
  {
    stateKey: 'SP',
    value: "APARECIDA D'OESTE",
    label: "APARECIDA D'OESTE"
  },
  {
    stateKey: 'SP',
    value: 'APIAI',
    label: 'APIAI'
  },
  {
    stateKey: 'SP',
    value: 'ARACARIGUAMA',
    label: 'ARACARIGUAMA'
  },
  {
    stateKey: 'SP',
    value: 'ARACATUBA',
    label: 'ARACATUBA'
  },
  {
    stateKey: 'SP',
    value: 'ARACOIABA DA SERRA',
    label: 'ARACOIABA DA SERRA'
  },
  {
    stateKey: 'SP',
    value: 'ARAMINA',
    label: 'ARAMINA'
  },
  {
    stateKey: 'SP',
    value: 'ARANDU',
    label: 'ARANDU'
  },
  {
    stateKey: 'SP',
    value: 'ARAPEI',
    label: 'ARAPEI'
  },
  {
    stateKey: 'SP',
    value: 'ARARAQUARA',
    label: 'ARARAQUARA'
  },
  {
    stateKey: 'SP',
    value: 'ARARAS',
    label: 'ARARAS'
  },
  {
    stateKey: 'SP',
    value: 'ARCO-IRIS',
    label: 'ARCO-IRIS'
  },
  {
    stateKey: 'SP',
    value: 'AREALVA',
    label: 'AREALVA'
  },
  {
    stateKey: 'SP',
    value: 'AREIAS',
    label: 'AREIAS'
  },
  {
    stateKey: 'SP',
    value: 'AREIOPOLIS',
    label: 'AREIOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'ARIRANHA',
    label: 'ARIRANHA '
  },
  {
    stateKey: 'SP',
    value: 'ARTUR NOGUEIRA',
    label: 'ARTUR NOGUEIRA'
  },
  {
    stateKey: 'SP',
    value: 'ARUJA',
    label: 'ARUJA'
  },
  {
    stateKey: 'SP',
    value: 'ASPASIA',
    label: 'ASPASIA'
  },
  {
    stateKey: 'SP',
    value: 'ASSIS',
    label: 'ASSIS'
  },
  {
    stateKey: 'SP',
    value: 'ATIBAIA',
    label: 'ATIBAIA'
  },
  {
    stateKey: 'SP',
    value: 'AURIFLAMA',
    label: 'AURIFLAMA'
  },
  {
    stateKey: 'SP',
    value: 'AVAI',
    label: 'AVAI'
  },
  {
    stateKey: 'SP',
    value: 'AVANHANDAVA',
    label: 'AVANHANDAVA'
  },
  {
    stateKey: 'SP',
    value: 'AVARE',
    label: 'AVARE'
  },
  {
    stateKey: 'SP',
    value: 'BADY BASSITT',
    label: 'BADY BASSITT'
  },
  {
    stateKey: 'SP',
    value: 'BALBINOS',
    label: 'BALBINOS'
  },
  {
    stateKey: 'SP',
    value: 'BALSAMO',
    label: 'BALSAMO'
  },
  {
    stateKey: 'SP',
    value: 'BANANAL',
    label: 'BANANAL'
  },
  {
    stateKey: 'SP',
    value: 'BARAO DE ANTONINA',
    label: 'BARAO DE ANTONINA'
  },
  {
    stateKey: 'SP',
    value: 'BARBOSA',
    label: 'BARBOSA'
  },
  {
    stateKey: 'SP',
    value: 'BARIRI',
    label: 'BARIRI'
  },
  {
    stateKey: 'SP',
    value: 'BARRA BONITA',
    label: 'BARRA BONITA'
  },
  {
    stateKey: 'SP',
    value: 'BARRA DO CHAPEU',
    label: 'BARRA DO CHAPEU'
  },
  {
    stateKey: 'SP',
    value: 'BARRA DO TURVO',
    label: 'BARRA DO TURVO'
  },
  {
    stateKey: 'SP',
    value: 'BARRETOS',
    label: 'BARRETOS'
  },
  {
    stateKey: 'SP',
    value: 'BARRINHA',
    label: 'BARRINHA'
  },
  {
    stateKey: 'SP',
    value: 'BARUERI',
    label: 'BARUERI'
  },
  {
    stateKey: 'SP',
    value: 'BASTOS',
    label: 'BASTOS'
  },
  {
    stateKey: 'SP',
    value: 'BATATAIS',
    label: 'BATATAIS'
  },
  {
    stateKey: 'SP',
    value: 'BAURU',
    label: 'BAURU'
  },
  {
    stateKey: 'SP',
    value: 'BEBEDOURO',
    label: 'BEBEDOURO'
  },
  {
    stateKey: 'SP',
    value: 'BENTO DE ABREU',
    label: 'BENTO DE ABREU'
  },
  {
    stateKey: 'SP',
    value: 'BERNARDINO DE CAMPOS',
    label: 'BERNARDINO DE CAMPOS'
  },
  {
    stateKey: 'SP',
    value: 'BERTIOGA',
    label: 'BERTIOGA'
  },
  {
    stateKey: 'SP',
    value: 'BILAC',
    label: 'BILAC'
  },
  {
    stateKey: 'SP',
    value: 'BIRIGUI',
    label: 'BIRIGUI'
  },
  {
    stateKey: 'SP',
    value: 'BIRITIBA-MIRIM',
    label: 'BIRITIBA-MIRIM'
  },
  {
    stateKey: 'SP',
    value: 'BOA ESPERANCA DO SUL',
    label: 'BOA ESPERANCA DO SUL'
  },
  {
    stateKey: 'SP',
    value: 'BOCAINA',
    label: 'BOCAINA'
  },
  {
    stateKey: 'SP',
    value: 'BOFETE',
    label: 'BOFETE'
  },
  {
    stateKey: 'SP',
    value: 'BOITUVA',
    label: 'BOITUVA'
  },
  {
    stateKey: 'SP',
    value: 'BOM JESUS DOS PERDOES',
    label: 'BOM JESUS DOS PERDOES'
  },
  {
    stateKey: 'SP',
    value: 'BOM SUCESSO DE ITARARE',
    label: 'BOM SUCESSO DE ITARARE'
  },
  {
    stateKey: 'SP',
    value: 'BORA',
    label: 'BORA'
  },
  {
    stateKey: 'SP',
    value: 'BORACEIA',
    label: 'BORACEIA'
  },
  {
    stateKey: 'SP',
    value: 'BORBOREMA',
    label: 'BORBOREMA'
  },
  {
    stateKey: 'SP',
    value: 'BOREBI',
    label: 'BOREBI'
  },
  {
    stateKey: 'SP',
    value: 'BOTUCATU',
    label: 'BOTUCATU'
  },
  {
    stateKey: 'SP',
    value: 'BRAGANCA PAULISTA',
    label: 'BRAGANCA PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'BRAUNA',
    label: 'BRAUNA'
  },
  {
    stateKey: 'SP',
    value: 'BREJO ALEGRE',
    label: 'BREJO ALEGRE'
  },
  {
    stateKey: 'SP',
    value: 'BROTAS',
    label: 'BROTAS'
  },
  {
    stateKey: 'SP',
    value: 'BURI',
    label: 'BURI'
  },
  {
    stateKey: 'SP',
    value: 'BURITAMA',
    label: 'BURITAMA'
  },
  {
    stateKey: 'SP',
    value: 'BURITIZAL',
    label: 'BURITIZAL'
  },
  {
    stateKey: 'SP',
    value: 'CABRALIA PAULISTA',
    label: 'CABRALIA PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'CABREUVA',
    label: 'CABREUVA'
  },
  {
    stateKey: 'SP',
    value: 'CACAPAVA',
    label: 'CACAPAVA'
  },
  {
    stateKey: 'SP',
    value: 'CACHOEIRA PAULISTA',
    label: 'CACHOEIRA PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'CACONDE',
    label: 'CACONDE'
  },
  {
    stateKey: 'SP',
    value: 'CAFELANDIA',
    label: 'CAFELANDIA'
  },
  {
    stateKey: 'SP',
    value: 'CAIABU',
    label: 'CAIABU'
  },
  {
    stateKey: 'SP',
    value: 'CAIEIRAS',
    label: 'CAIEIRAS'
  },
  {
    stateKey: 'SP',
    value: 'CAIUA',
    label: 'CAIUA'
  },
  {
    stateKey: 'SP',
    value: 'CAJAMAR',
    label: 'CAJAMAR'
  },
  {
    stateKey: 'SP',
    value: 'CAJATI',
    label: 'CAJATI'
  },
  {
    stateKey: 'SP',
    value: 'CAJOBI',
    label: 'CAJOBI'
  },
  {
    stateKey: 'SP',
    value: 'CAJURU',
    label: 'CAJURU'
  },
  {
    stateKey: 'SP',
    value: 'CAMPINA DO MONTE ALEGRE',
    label: 'CAMPINA DO MONTE ALEGRE'
  },
  {
    stateKey: 'SP',
    value: 'CAMPINAS',
    label: 'CAMPINAS'
  },
  {
    stateKey: 'SP',
    value: 'CAMPO LIMPO PAULISTA',
    label: 'CAMPO LIMPO PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'CAMPOS DO JORDAO',
    label: 'CAMPOS DO JORDAO'
  },
  {
    stateKey: 'SP',
    value: 'CAMPOS NOVOS PAULISTA',
    label: 'CAMPOS NOVOS PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'CANAS',
    label: 'CANAS'
  },
  {
    stateKey: 'SP',
    value: 'CANDIDO MOTA',
    label: 'CANDIDO MOTA'
  },
  {
    stateKey: 'SP',
    value: 'CANDIDO RODRIGUES',
    label: 'CANDIDO RODRIGUES'
  },
  {
    stateKey: 'SP',
    value: 'CANITAR',
    label: 'CANITAR'
  },
  {
    stateKey: 'SP',
    value: 'CAPAO BONITO',
    label: 'CAPAO BONITO'
  },
  {
    stateKey: 'SP',
    value: 'CAPELA DO ALTO',
    label: 'CAPELA DO ALTO'
  },
  {
    stateKey: 'SP',
    value: 'CAPIVARI',
    label: 'CAPIVARI'
  },
  {
    stateKey: 'SP',
    value: 'CARAGUATATUBA',
    label: 'CARAGUATATUBA'
  },
  {
    stateKey: 'SP',
    value: 'CARAPICUIBA',
    label: 'CARAPICUIBA'
  },
  {
    stateKey: 'SP',
    value: 'CARDOSO',
    label: 'CARDOSO'
  },
  {
    stateKey: 'SP',
    value: 'CASA BRANCA',
    label: 'CASA BRANCA'
  },
  {
    stateKey: 'SP',
    value: 'CASSIA DOS COQUEIROS',
    label: 'CASSIA DOS COQUEIROS'
  },
  {
    stateKey: 'SP',
    value: 'CASTILHO',
    label: 'CASTILHO'
  },
  {
    stateKey: 'SP',
    value: 'CATANDUVA',
    label: 'CATANDUVA'
  },
  {
    stateKey: 'SP',
    value: 'CATIGUA',
    label: 'CATIGUA'
  },
  {
    stateKey: 'SP',
    value: 'CEDRAL',
    label: 'CEDRAL'
  },
  {
    stateKey: 'SP',
    value: 'CERQUEIRA CESAR',
    label: 'CERQUEIRA CESAR'
  },
  {
    stateKey: 'SP',
    value: 'CERQUILHO',
    label: 'CERQUILHO'
  },
  {
    stateKey: 'SP',
    value: 'CESARIO LANGE',
    label: 'CESARIO LANGE'
  },
  {
    stateKey: 'SP',
    value: 'CHARQUEADA',
    label: 'CHARQUEADA'
  },
  {
    stateKey: 'SP',
    value: 'CLEMENTINA',
    label: 'CLEMENTINA'
  },
  {
    stateKey: 'SP',
    value: 'COLINA',
    label: 'COLINA'
  },
  {
    stateKey: 'SP',
    value: 'COLOMBIA',
    label: 'COLOMBIA'
  },
  {
    stateKey: 'SP',
    value: 'CONCHAL',
    label: 'CONCHAL'
  },
  {
    stateKey: 'SP',
    value: 'CONCHAS',
    label: 'CONCHAS'
  },
  {
    stateKey: 'SP',
    value: 'CORDEIROPOLIS',
    label: 'CORDEIROPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'COROADOS',
    label: 'COROADOS'
  },
  {
    stateKey: 'SP',
    value: 'CORONEL MACEDO',
    label: 'CORONEL MACEDO'
  },
  {
    stateKey: 'SP',
    value: 'CORUMBATAI',
    label: 'CORUMBATAI'
  },
  {
    stateKey: 'SP',
    value: 'COSMOPOLIS',
    label: 'COSMOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'COSMORAMA',
    label: 'COSMORAMA'
  },
  {
    stateKey: 'SP',
    value: 'COTIA',
    label: 'COTIA'
  },
  {
    stateKey: 'SP',
    value: 'CRAVINHOS',
    label: 'CRAVINHOS'
  },
  {
    stateKey: 'SP',
    value: 'CRISTAIS PAULISTA',
    label: 'CRISTAIS PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'CRUZALIA',
    label: 'CRUZALIA'
  },
  {
    stateKey: 'SP',
    value: 'CRUZEIRO',
    label: 'CRUZEIRO'
  },
  {
    stateKey: 'SP',
    value: 'CUBATAO',
    label: 'CUBATAO'
  },
  {
    stateKey: 'SP',
    value: 'CUNHA',
    label: 'CUNHA'
  },
  {
    stateKey: 'SP',
    value: 'DESCALVADO',
    label: 'DESCALVADO'
  },
  {
    stateKey: 'SP',
    value: 'DIADEMA',
    label: 'DIADEMA'
  },
  {
    stateKey: 'SP',
    value: 'DIRCE REIS',
    label: 'DIRCE REIS'
  },
  {
    stateKey: 'SP',
    value: 'DIVINOLANDIA',
    label: 'DIVINOLANDIA'
  },
  {
    stateKey: 'SP',
    value: 'DOBRADA',
    label: 'DOBRADA'
  },
  {
    stateKey: 'SP',
    value: 'DOIS CORREGOS',
    label: 'DOIS CORREGOS'
  },
  {
    stateKey: 'SP',
    value: 'DOLCINOPOLIS',
    label: 'DOLCINOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'DOURADO',
    label: 'DOURADO'
  },
  {
    stateKey: 'SP',
    value: 'DRACENA',
    label: 'DRACENA'
  },
  {
    stateKey: 'SP',
    value: 'DUARTINA',
    label: 'DUARTINA'
  },
  {
    stateKey: 'SP',
    value: 'DUMONT',
    label: 'DUMONT'
  },
  {
    stateKey: 'SP',
    value: 'ECHAPORA',
    label: 'ECHAPORA'
  },
  {
    stateKey: 'SP',
    value: 'ELDORADO',
    label: 'ELDORADO'
  },
  {
    stateKey: 'SP',
    value: 'ELIAS FAUSTO',
    label: 'ELIAS FAUSTO'
  },
  {
    stateKey: 'SP',
    value: 'ELISIARIO',
    label: 'ELISIARIO'
  },
  {
    stateKey: 'SP',
    value: 'EMBAUBA',
    label: 'EMBAUBA'
  },
  {
    stateKey: 'SP',
    value: 'EMBU',
    label: 'EMBU'
  },
  {
    stateKey: 'SP',
    value: 'EMBU-GUACU',
    label: 'EMBU-GUACU'
  },
  {
    stateKey: 'SP',
    value: 'EMILIANOPOLIS',
    label: 'EMILIANOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'ENGENHEIRO COELHO',
    label: 'ENGENHEIRO COELHO'
  },
  {
    stateKey: 'SP',
    value: 'ESPIRITO SANTO DO PINHAL',
    label: 'ESPIRITO SANTO DO PINHAL'
  },
  {
    stateKey: 'SP',
    value: 'ESPIRITO SANTO DO TURVO',
    label: 'ESPIRITO SANTO DO TURVO'
  },
  {
    stateKey: 'SP',
    value: 'ESTIVA GERBI',
    label: 'ESTIVA GERBI'
  },
  {
    stateKey: 'SP',
    value: "ESTRELA D'OESTE",
    label: "ESTRELA D'OESTE"
  },
  {
    stateKey: 'SP',
    value: 'ESTRELA DO NORTE',
    label: 'ESTRELA DO NORTE'
  },
  {
    stateKey: 'SP',
    value: 'EUCLIDES DA CUNHA PAULISTA- SP',
    label: 'EUCLIDES DA CUNHA PAULISTA- SP'
  },
  {
    stateKey: 'SP',
    value: 'FARTURA',
    label: 'FARTURA'
  },
  {
    stateKey: 'SP',
    value: 'FERNANDO PRESTES',
    label: 'FERNANDO PRESTES'
  },
  {
    stateKey: 'SP',
    value: 'FERNANDOPOLIS',
    label: 'FERNANDOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'FERNAO',
    label: 'FERNAO'
  },
  {
    stateKey: 'SP',
    value: 'FERRAZ DE VASCONCELOS',
    label: 'FERRAZ DE VASCONCELOS'
  },
  {
    stateKey: 'SP',
    value: 'FLORA RICA',
    label: 'FLORA RICA'
  },
  {
    stateKey: 'SP',
    value: 'FLOREAL',
    label: 'FLOREAL'
  },
  {
    stateKey: 'SP',
    value: 'FLORIDA PAULISTA',
    label: 'FLORIDA PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'FLORINEA',
    label: 'FLORINEA'
  },
  {
    stateKey: 'SP',
    value: 'FRANCA',
    label: 'FRANCA'
  },
  {
    stateKey: 'SP',
    value: 'FRANCISCO MORATO',
    label: 'FRANCISCO MORATO'
  },
  {
    stateKey: 'SP',
    value: 'FRANCO DA ROCHA',
    label: 'FRANCO DA ROCHA'
  },
  {
    stateKey: 'SP',
    value: 'GABRIEL MONTEIRO',
    label: 'GABRIEL MONTEIRO'
  },
  {
    stateKey: 'SP',
    value: 'GALIA',
    label: 'GALIA'
  },
  {
    stateKey: 'SP',
    value: 'GARCA',
    label: 'GARCA'
  },
  {
    stateKey: 'SP',
    value: 'GASTAO VIDIGAL',
    label: 'GASTAO VIDIGAL'
  },
  {
    stateKey: 'SP',
    value: 'GAVIAO PEIXOTO',
    label: 'GAVIAO PEIXOTO'
  },
  {
    stateKey: 'SP',
    value: 'GENERAL SALGADO',
    label: 'GENERAL SALGADO'
  },
  {
    stateKey: 'SP',
    value: 'GETULINA',
    label: 'GETULINA'
  },
  {
    stateKey: 'SP',
    value: 'GLICERIO',
    label: 'GLICERIO'
  },
  {
    stateKey: 'SP',
    value: 'GUAICARA',
    label: 'GUAICARA'
  },
  {
    stateKey: 'SP',
    value: 'GUAIMBE',
    label: 'GUAIMBE'
  },
  {
    stateKey: 'SP',
    value: 'GUAIRA',
    label: 'GUAIRA'
  },
  {
    stateKey: 'SP',
    value: 'GUAPIACU',
    label: 'GUAPIACU'
  },
  {
    stateKey: 'SP',
    value: 'GUAPIARA',
    label: 'GUAPIARA'
  },
  {
    stateKey: 'SP',
    value: 'GUARA',
    label: 'GUARA'
  },
  {
    stateKey: 'SP',
    value: 'GUARACAI',
    label: 'GUARACAI'
  },
  {
    stateKey: 'SP',
    value: 'GUARACI',
    label: 'GUARACI'
  },
  {
    stateKey: 'SP',
    value: "GUARANI D'OESTE",
    label: "GUARANI D'OESTE"
  },
  {
    stateKey: 'SP',
    value: 'GUARANTA',
    label: 'GUARANTA'
  },
  {
    stateKey: 'SP',
    value: 'GUARARAPES',
    label: 'GUARARAPES'
  },
  {
    stateKey: 'SP',
    value: 'GUARAREMA',
    label: 'GUARAREMA'
  },
  {
    stateKey: 'SP',
    value: 'GUARATINGUETA',
    label: 'GUARATINGUETA'
  },
  {
    stateKey: 'SP',
    value: 'GUAREI',
    label: 'GUAREI'
  },
  {
    stateKey: 'SP',
    value: 'GUARIBA',
    label: 'GUARIBA'
  },
  {
    stateKey: 'SP',
    value: 'GUARUJA',
    label: 'GUARUJA'
  },
  {
    stateKey: 'SP',
    value: 'GUARULHOS',
    label: 'GUARULHOS'
  },
  {
    stateKey: 'SP',
    value: 'GUATAPARA',
    label: 'GUATAPARA'
  },
  {
    stateKey: 'SP',
    value: 'GUZOLANDIA',
    label: 'GUZOLANDIA'
  },
  {
    stateKey: 'SP',
    value: 'HERCULANDIA',
    label: 'HERCULANDIA'
  },
  {
    stateKey: 'SP',
    value: 'HOLAMBRA',
    label: 'HOLAMBRA'
  },
  {
    stateKey: 'SP',
    value: 'HORTOLANDIA',
    label: 'HORTOLANDIA'
  },
  {
    stateKey: 'SP',
    value: 'IACANGA',
    label: 'IACANGA'
  },
  {
    stateKey: 'SP',
    value: 'IACRI',
    label: 'IACRI'
  },
  {
    stateKey: 'SP',
    value: 'IARAS',
    label: 'IARAS'
  },
  {
    stateKey: 'SP',
    value: 'IBATE',
    label: 'IBATE'
  },
  {
    stateKey: 'SP',
    value: 'IBIRA',
    label: 'IBIRA'
  },
  {
    stateKey: 'SP',
    value: 'IBIRAREMA',
    label: 'IBIRAREMA'
  },
  {
    stateKey: 'SP',
    value: 'IBITINGA',
    label: 'IBITINGA'
  },
  {
    stateKey: 'SP',
    value: 'IBIUNA',
    label: 'IBIUNA'
  },
  {
    stateKey: 'SP',
    value: 'ICEM',
    label: 'ICEM'
  },
  {
    stateKey: 'SP',
    value: 'IEPE',
    label: 'IEPE'
  },
  {
    stateKey: 'SP',
    value: 'IGARACU DO TIETE',
    label: 'IGARACU DO TIETE'
  },
  {
    stateKey: 'SP',
    value: 'IGARAPAVA',
    label: 'IGARAPAVA'
  },
  {
    stateKey: 'SP',
    value: 'IGARATA',
    label: 'IGARATA'
  },
  {
    stateKey: 'SP',
    value: 'IGUAPE',
    label: 'IGUAPE'
  },
  {
    stateKey: 'SP',
    value: 'ILHA COMPRIDA',
    label: 'ILHA COMPRIDA'
  },
  {
    stateKey: 'SP',
    value: 'ILHA SOLTEIRA',
    label: 'ILHA SOLTEIRA'
  },
  {
    stateKey: 'SP',
    value: 'ILHABELA',
    label: 'ILHABELA'
  },
  {
    stateKey: 'SP',
    value: 'INDAIATUBA',
    label: 'INDAIATUBA'
  },
  {
    stateKey: 'SP',
    value: 'INDIANA',
    label: 'INDIANA'
  },
  {
    stateKey: 'SP',
    value: 'INDIAPORA',
    label: 'INDIAPORA'
  },
  {
    stateKey: 'SP',
    value: 'INUBIA PAULISTA',
    label: 'INUBIA PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'IPAUCU',
    label: 'IPAUCU'
  },
  {
    stateKey: 'SP',
    value: 'IPERO',
    label: 'IPERO'
  },
  {
    stateKey: 'SP',
    value: 'IPEUNA',
    label: 'IPEUNA'
  },
  {
    stateKey: 'SP',
    value: 'IPIGUA',
    label: 'IPIGUA'
  },
  {
    stateKey: 'SP',
    value: 'IPORANGA',
    label: 'IPORANGA'
  },
  {
    stateKey: 'SP',
    value: 'IPUA',
    label: 'IPUA'
  },
  {
    stateKey: 'SP',
    value: 'IRACEMAPOLIS',
    label: 'IRACEMAPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'IRAPUA',
    label: 'IRAPUA'
  },
  {
    stateKey: 'SP',
    value: 'IRAPURU',
    label: 'IRAPURU'
  },
  {
    stateKey: 'SP',
    value: 'ITABERA',
    label: 'ITABERA'
  },
  {
    stateKey: 'SP',
    value: 'ITAI',
    label: 'ITAI'
  },
  {
    stateKey: 'SP',
    value: 'ITAJOBI',
    label: 'ITAJOBI '
  },
  {
    stateKey: 'SP',
    value: 'ITAJU',
    label: 'ITAJU'
  },
  {
    stateKey: 'SP',
    value: 'ITANHAEM',
    label: 'ITANHAEM'
  },
  {
    stateKey: 'SP',
    value: 'ITAOCA',
    label: 'ITAOCA'
  },
  {
    stateKey: 'SP',
    value: 'ITAPECERICA DA SERRA',
    label: 'ITAPECERICA DA SERRA'
  },
  {
    stateKey: 'SP',
    value: 'ITAPETININGA',
    label: 'ITAPETININGA'
  },
  {
    stateKey: 'SP',
    value: 'ITAPEVA',
    label: 'ITAPEVA'
  },
  {
    stateKey: 'SP',
    value: 'ITAPEVI',
    label: 'ITAPEVI'
  },
  {
    stateKey: 'SP',
    value: 'ITAPIRA',
    label: 'ITAPIRA'
  },
  {
    stateKey: 'SP',
    value: 'ITAPIRAPUA PAULISTA',
    label: 'ITAPIRAPUA PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'ITAPOLIS',
    label: 'ITAPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'ITAPORANGA',
    label: 'ITAPORANGA'
  },
  {
    stateKey: 'SP',
    value: 'ITAPUI',
    label: 'ITAPUI'
  },
  {
    stateKey: 'SP',
    value: 'ITAPURA',
    label: 'ITAPURA'
  },
  {
    stateKey: 'SP',
    value: 'ITAQUAQUECETUBA',
    label: 'ITAQUAQUECETUBA'
  },
  {
    stateKey: 'SP',
    value: 'ITARARE',
    label: 'ITARARE'
  },
  {
    stateKey: 'SP',
    value: 'ITARIRI',
    label: 'ITARIRI'
  },
  {
    stateKey: 'SP',
    value: 'ITATIBA',
    label: 'ITATIBA'
  },
  {
    stateKey: 'SP',
    value: 'ITATINGA',
    label: 'ITATINGA'
  },
  {
    stateKey: 'SP',
    value: 'ITIRAPINA',
    label: 'ITIRAPINA'
  },
  {
    stateKey: 'SP',
    value: 'ITIRAPUA',
    label: 'ITIRAPUA'
  },
  {
    stateKey: 'SP',
    value: 'ITOBI',
    label: 'ITOBI'
  },
  {
    stateKey: 'SP',
    value: 'ITU',
    label: 'ITU'
  },
  {
    stateKey: 'SP',
    value: 'ITUPEVA',
    label: 'ITUPEVA'
  },
  {
    stateKey: 'SP',
    value: 'ITUVERAVA',
    label: 'ITUVERAVA'
  },
  {
    stateKey: 'SP',
    value: 'JABORANDI',
    label: 'JABORANDI'
  },
  {
    stateKey: 'SP',
    value: 'JABOTICABAL',
    label: 'JABOTICABAL'
  },
  {
    stateKey: 'SP',
    value: 'JACAREI',
    label: 'JACAREI'
  },
  {
    stateKey: 'SP',
    value: 'JACI',
    label: 'JACI'
  },
  {
    stateKey: 'SP',
    value: 'JACUPIRANGA',
    label: 'JACUPIRANGA'
  },
  {
    stateKey: 'SP',
    value: 'JAGUARIUNA',
    label: 'JAGUARIUNA'
  },
  {
    stateKey: 'SP',
    value: 'JALES',
    label: 'JALES'
  },
  {
    stateKey: 'SP',
    value: 'JAMBEIRO',
    label: 'JAMBEIRO'
  },
  {
    stateKey: 'SP',
    value: 'JANDIRA',
    label: 'JANDIRA'
  },
  {
    stateKey: 'SP',
    value: 'JARDINOPOLIS',
    label: 'JARDINOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'JARINU',
    label: 'JARINU'
  },
  {
    stateKey: 'SP',
    value: 'JAU',
    label: 'JAU'
  },
  {
    stateKey: 'SP',
    value: 'JERIQUARA',
    label: 'JERIQUARA'
  },
  {
    stateKey: 'SP',
    value: 'JOANOPOLIS',
    label: 'JOANOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'JOAO RAMALHO',
    label: 'JOAO RAMALHO'
  },
  {
    stateKey: 'SP',
    value: 'JOSE BONIFACIO',
    label: 'JOSE BONIFACIO'
  },
  {
    stateKey: 'SP',
    value: 'JULIO MESQUITA',
    label: 'JULIO MESQUITA'
  },
  {
    stateKey: 'SP',
    value: 'JUMIRIM',
    label: 'JUMIRIM'
  },
  {
    stateKey: 'SP',
    value: 'JUNDIAI',
    label: 'JUNDIAI'
  },
  {
    stateKey: 'SP',
    value: 'JUNQUEIROPOLIS',
    label: 'JUNQUEIROPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'JUQUIA',
    label: 'JUQUIA'
  },
  {
    stateKey: 'SP',
    value: 'JUQUITIBA',
    label: 'JUQUITIBA'
  },
  {
    stateKey: 'SP',
    value: 'LAGOINHA',
    label: 'LAGOINHA'
  },
  {
    stateKey: 'SP',
    value: 'LARANJAL PAULISTA',
    label: 'LARANJAL PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'LAVINIA',
    label: 'LAVINIA'
  },
  {
    stateKey: 'SP',
    value: 'LAVRINHAS',
    label: 'LAVRINHAS'
  },
  {
    stateKey: 'SP',
    value: 'LEME',
    label: 'LEME'
  },
  {
    stateKey: 'SP',
    value: 'LENCOIS PAULISTA',
    label: 'LENCOIS PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'LIMEIRA',
    label: 'LIMEIRA'
  },
  {
    stateKey: 'SP',
    value: 'LINDOIA',
    label: 'LINDOIA'
  },
  {
    stateKey: 'SP',
    value: 'LINS',
    label: 'LINS'
  },
  {
    stateKey: 'SP',
    value: 'LORENA',
    label: 'LORENA'
  },
  {
    stateKey: 'SP',
    value: 'LOURDES',
    label: 'LOURDES'
  },
  {
    stateKey: 'SP',
    value: 'LOUVEIRA',
    label: 'LOUVEIRA'
  },
  {
    stateKey: 'SP',
    value: 'LUCELIA',
    label: 'LUCELIA'
  },
  {
    stateKey: 'SP',
    value: 'LUCIANOPOLIS',
    label: 'LUCIANOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'LUIS ANTONIO',
    label: 'LUIS ANTONIO'
  },
  {
    stateKey: 'SP',
    value: 'LUPERCIO',
    label: 'LUPERCIO'
  },
  {
    stateKey: 'SP',
    value: 'LUTECIA',
    label: 'LUTECIA'
  },
  {
    stateKey: 'SP',
    value: 'MACATUBA',
    label: 'MACATUBA'
  },
  {
    stateKey: 'SP',
    value: 'MACAUBAL',
    label: 'MACAUBAL'
  },
  {
    stateKey: 'SP',
    value: 'MACEDONIA',
    label: 'MACEDONIA'
  },
  {
    stateKey: 'SP',
    value: 'MAGDA',
    label: 'MAGDA'
  },
  {
    stateKey: 'SP',
    value: 'MAIRINQUE',
    label: 'MAIRINQUE'
  },
  {
    stateKey: 'SP',
    value: 'MAIRIPORA',
    label: 'MAIRIPORA'
  },
  {
    stateKey: 'SP',
    value: 'MANDURI',
    label: 'MANDURI'
  },
  {
    stateKey: 'SP',
    value: 'MARABA PAULISTA',
    label: 'MARABA PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'MARACAI',
    label: 'MARACAI'
  },
  {
    stateKey: 'SP',
    value: 'MARAPOAMA',
    label: 'MARAPOAMA'
  },
  {
    stateKey: 'SP',
    value: 'MARIAPOLIS',
    label: 'MARIAPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'MARILIA',
    label: 'MARILIA'
  },
  {
    stateKey: 'SP',
    value: 'MARINOPOLIS',
    label: 'MARINOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'MARTINOPOLIS',
    label: 'MARTINOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'MATAO',
    label: 'MATAO'
  },
  {
    stateKey: 'SP',
    value: 'MAUA',
    label: 'MAUA'
  },
  {
    stateKey: 'SP',
    value: 'MENDONCA',
    label: 'MENDONCA'
  },
  {
    stateKey: 'SP',
    value: 'MERIDIANO',
    label: 'MERIDIANO'
  },
  {
    stateKey: 'SP',
    value: 'MESOPOLIS',
    label: 'MESOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'MIGUELOPOLIS',
    label: 'MIGUELOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'MINEIROS DO TIETE',
    label: 'MINEIROS DO TIETE'
  },
  {
    stateKey: 'SP',
    value: 'MIRA ESTRELA',
    label: 'MIRA ESTRELA'
  },
  {
    stateKey: 'SP',
    value: 'MIRACATU',
    label: 'MIRACATU'
  },
  {
    stateKey: 'SP',
    value: 'MIRANDOPOLIS',
    label: 'MIRANDOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'MIRANTE DO PARANAPANEMA',
    label: 'MIRANTE DO PARANAPANEMA'
  },
  {
    stateKey: 'SP',
    value: 'MIRASSOL',
    label: 'MIRASSOL'
  },
  {
    stateKey: 'SP',
    value: 'MIRASSOLANDIA',
    label: 'MIRASSOLANDIA'
  },
  {
    stateKey: 'SP',
    value: 'MOCOCA',
    label: 'MOCOCA'
  },
  {
    stateKey: 'SP',
    value: 'MOGI DAS CRUZES',
    label: 'MOGI DAS CRUZES'
  },
  {
    stateKey: 'SP',
    value: 'MOGI-GUACU',
    label: 'MOGI-GUACU'
  },
  {
    stateKey: 'SP',
    value: 'MOGI-MIRIM',
    label: 'MOGI-MIRIM'
  },
  {
    stateKey: 'SP',
    value: 'MOMBUCA',
    label: 'MOMBUCA'
  },
  {
    stateKey: 'SP',
    value: 'MONCOES',
    label: 'MONCOES'
  },
  {
    stateKey: 'SP',
    value: 'MONGAGUA',
    label: 'MONGAGUA'
  },
  {
    stateKey: 'SP',
    value: 'MONTE ALEGRE DO SUL',
    label: 'MONTE ALEGRE DO SUL'
  },
  {
    stateKey: 'SP',
    value: 'MONTE ALTO',
    label: 'MONTE ALTO'
  },
  {
    stateKey: 'SP',
    value: 'MONTE APRAZIVEL',
    label: 'MONTE APRAZIVEL'
  },
  {
    stateKey: 'SP',
    value: 'MONTE AZUL PAULISTA',
    label: 'MONTE AZUL PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'MONTE CASTELO',
    label: 'MONTE CASTELO'
  },
  {
    stateKey: 'SP',
    value: 'MONTE MOR',
    label: 'MONTE MOR'
  },
  {
    stateKey: 'SP',
    value: 'MONTEIRO LOBATO',
    label: 'MONTEIRO LOBATO'
  },
  {
    stateKey: 'SP',
    value: 'MORRO AGUDO',
    label: 'MORRO AGUDO'
  },
  {
    stateKey: 'SP',
    value: 'MORUNGABA',
    label: 'MORUNGABA'
  },
  {
    stateKey: 'SP',
    value: 'MOTUCA',
    label: 'MOTUCA'
  },
  {
    stateKey: 'SP',
    value: 'MURUTINGA DO SUL',
    label: 'MURUTINGA DO SUL'
  },
  {
    stateKey: 'SP',
    value: 'NANTES',
    label: 'NANTES'
  },
  {
    stateKey: 'SP',
    value: 'NARANDIBA',
    label: 'NARANDIBA'
  },
  {
    stateKey: 'SP',
    value: 'NATIVIDADE DA SERRA',
    label: 'NATIVIDADE DA SERRA'
  },
  {
    stateKey: 'SP',
    value: 'NAZARE PAULISTA',
    label: 'NAZARE PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'NEVES PAULISTA',
    label: 'NEVES PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'NHANDEARA',
    label: 'NHANDEARA'
  },
  {
    stateKey: 'SP',
    value: 'NIPOA',
    label: 'NIPOA'
  },
  {
    stateKey: 'SP',
    value: 'NOVA ALIANCA',
    label: 'NOVA ALIANCA'
  },
  {
    stateKey: 'SP',
    value: 'NOVA CAMPINA',
    label: 'NOVA CAMPINA'
  },
  {
    stateKey: 'SP',
    value: 'NOVA CANAA PAULISTA',
    label: 'NOVA CANAA PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'NOVA CASTILHO',
    label: 'NOVA CASTILHO'
  },
  {
    stateKey: 'SP',
    value: 'NOVA EUROPA',
    label: 'NOVA EUROPA'
  },
  {
    stateKey: 'SP',
    value: 'NOVA GRANADA',
    label: 'NOVA GRANADA'
  },
  {
    stateKey: 'SP',
    value: 'NOVA GUATAPORANGA',
    label: 'NOVA GUATAPORANGA'
  },
  {
    stateKey: 'SP',
    value: 'NOVA INDEPENDENCIA',
    label: 'NOVA INDEPENDENCIA'
  },
  {
    stateKey: 'SP',
    value: 'NOVA ODESSA',
    label: 'NOVA ODESSA'
  },
  {
    stateKey: 'SP',
    value: 'NOVAIS',
    label: 'NOVAIS'
  },
  {
    stateKey: 'SP',
    value: 'NOVO HORIZONTE',
    label: 'NOVO HORIZONTE'
  },
  {
    stateKey: 'SP',
    value: 'NUPORANGA',
    label: 'NUPORANGA'
  },
  {
    stateKey: 'SP',
    value: 'OCAUCU',
    label: 'OCAUCU'
  },
  {
    stateKey: 'SP',
    value: 'OLEO',
    label: 'OLEO'
  },
  {
    stateKey: 'SP',
    value: 'OLIMPIA',
    label: 'OLIMPIA'
  },
  {
    stateKey: 'SP',
    value: 'ONDA VERDE',
    label: 'ONDA VERDE'
  },
  {
    stateKey: 'SP',
    value: 'ORIENTE',
    label: 'ORIENTE'
  },
  {
    stateKey: 'SP',
    value: 'ORINDIUVA',
    label: 'ORINDIUVA'
  },
  {
    stateKey: 'SP',
    value: 'ORLANDIA',
    label: 'ORLANDIA'
  },
  {
    stateKey: 'SP',
    value: 'OSASCO',
    label: 'OSASCO'
  },
  {
    stateKey: 'SP',
    value: 'OSCAR BRESSANE',
    label: 'OSCAR BRESSANE'
  },
  {
    stateKey: 'SP',
    value: 'OSVALDO CRUZ',
    label: 'OSVALDO CRUZ'
  },
  {
    stateKey: 'SP',
    value: 'OURINHOS',
    label: 'OURINHOS'
  },
  {
    stateKey: 'SP',
    value: 'OURO VERDE',
    label: 'OURO VERDE'
  },
  {
    stateKey: 'SP',
    value: 'OUROESTE',
    label: 'OUROESTE'
  },
  {
    stateKey: 'SP',
    value: 'PACAEMBU',
    label: 'PACAEMBU'
  },
  {
    stateKey: 'SP',
    value: 'PALESTINA',
    label: 'PALESTINA'
  },
  {
    stateKey: 'SP',
    value: 'PALMARES PAULISTA',
    label: 'PALMARES PAULISTA'
  },
  {
    stateKey: 'SP',
    value: "PALMEIRA D'OESTE",
    label: "PALMEIRA D'OESTE"
  },
  {
    stateKey: 'SP',
    value: 'PALMITAL',
    label: 'PALMITAL'
  },
  {
    stateKey: 'SP',
    value: 'PANORAMA',
    label: 'PANORAMA'
  },
  {
    stateKey: 'SP',
    value: 'PARAGUACU PAULISTA',
    label: 'PARAGUACU PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'PARAIBUNA',
    label: 'PARAIBUNA'
  },
  {
    stateKey: 'SP',
    value: 'PARAISO',
    label: 'PARAISO'
  },
  {
    stateKey: 'SP',
    value: 'PARANAPANEMA',
    label: 'PARANAPANEMA'
  },
  {
    stateKey: 'SP',
    value: 'PARANAPUA',
    label: 'PARANAPUA'
  },
  {
    stateKey: 'SP',
    value: 'PARAPUA',
    label: 'PARAPUA'
  },
  {
    stateKey: 'SP',
    value: 'PARDINHO ',
    label: 'PARDINHO'
  },
  {
    stateKey: 'SP',
    value: 'PARIQUERA-ACU',
    label: 'PARIQUERA-ACU'
  },
  {
    stateKey: 'SP',
    value: 'PARISI',
    label: 'PARISI'
  },
  {
    stateKey: 'SP',
    value: 'PATROCINIO PAULISTA',
    label: 'PATROCINIO PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'PAULICEIA',
    label: 'PAULICEIA'
  },
  {
    stateKey: 'SP',
    value: 'PAULINIA',
    label: 'PAULINIA'
  },
  {
    stateKey: 'SP',
    value: 'PAULISTANIA',
    label: 'PAULISTANIA'
  },
  {
    stateKey: 'SP',
    value: 'PAULO DE FARIA',
    label: 'PAULO DE FARIA'
  },
  {
    stateKey: 'SP',
    value: 'PEDERNEIRAS',
    label: 'PEDERNEIRAS'
  },
  {
    stateKey: 'SP',
    value: 'PEDRA BELA',
    label: 'PEDRA BELA'
  },
  {
    stateKey: 'SP',
    value: 'PEDRANOPOLIS',
    label: 'PEDRANOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'PEDREGULHO',
    label: 'PEDREGULHO'
  },
  {
    stateKey: 'SP',
    value: 'PEDREIRA',
    label: 'PEDREIRA'
  },
  {
    stateKey: 'SP',
    value: 'PEDRINHAS PAULISTA',
    label: 'PEDRINHAS PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'PEDRO DE TOLEDO',
    label: 'PEDRO DE TOLEDO'
  },
  {
    stateKey: 'SP',
    value: 'PENAPOLIS',
    label: 'PENAPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'PEREIRA BARRETO',
    label: 'PEREIRA BARRETO'
  },
  {
    stateKey: 'SP',
    value: 'PEREIRAS',
    label: 'PEREIRAS'
  },
  {
    stateKey: 'SP',
    value: 'PERUIBE',
    label: 'PERUIBE'
  },
  {
    stateKey: 'SP',
    value: 'PIACATU',
    label: 'PIACATU'
  },
  {
    stateKey: 'SP',
    value: 'PIEDADE',
    label: 'PIEDADE'
  },
  {
    stateKey: 'SP',
    value: 'PILAR DO SUL',
    label: 'PILAR DO SUL'
  },
  {
    stateKey: 'SP',
    value: 'PINDAMONHANGABA',
    label: 'PINDAMONHANGABA'
  },
  {
    stateKey: 'SP',
    value: 'PINDORAMA',
    label: 'PINDORAMA'
  },
  {
    stateKey: 'SP',
    value: 'PINHALZINHO',
    label: 'PINHALZINHO'
  },
  {
    stateKey: 'SP',
    value: 'PIQUEROBI',
    label: 'PIQUEROBI'
  },
  {
    stateKey: 'SP',
    value: 'PIQUETE',
    label: 'PIQUETE'
  },
  {
    stateKey: 'SP',
    value: 'PIRACAIA',
    label: 'PIRACAIA'
  },
  {
    stateKey: 'SP',
    value: 'PIRACICABA',
    label: 'PIRACICABA'
  },
  {
    stateKey: 'SP',
    value: 'PIRAJU',
    label: 'PIRAJU'
  },
  {
    stateKey: 'SP',
    value: 'PIRAJUI',
    label: 'PIRAJUI'
  },
  {
    stateKey: 'SP',
    value: 'PIRANGI',
    label: 'PIRANGI'
  },
  {
    stateKey: 'SP',
    value: 'PIRAPORA DO BOM JESUS',
    label: 'PIRAPORA DO BOM JESUS'
  },
  {
    stateKey: 'SP',
    value: 'PIRAPOZINHO',
    label: 'PIRAPOZINHO'
  },
  {
    stateKey: 'SP',
    value: 'PIRASSUNUNGA',
    label: 'PIRASSUNUNGA'
  },
  {
    stateKey: 'SP',
    value: 'PIRATININGA',
    label: 'PIRATININGA'
  },
  {
    stateKey: 'SP',
    value: 'PITANGUEIRAS',
    label: 'PITANGUEIRAS'
  },
  {
    stateKey: 'SP',
    value: 'PLANALTO',
    label: 'PLANALTO'
  },
  {
    stateKey: 'SP',
    value: 'PLATINA',
    label: 'PLATINA'
  },
  {
    stateKey: 'SP',
    value: 'POA',
    label: 'POA'
  },
  {
    stateKey: 'SP',
    value: 'POLONI',
    label: 'POLONI'
  },
  {
    stateKey: 'SP',
    value: 'POMPEIA',
    label: 'POMPEIA'
  },
  {
    stateKey: 'SP',
    value: 'PONGAI',
    label: 'PONGAI'
  },
  {
    stateKey: 'SP',
    value: 'PONTAL',
    label: 'PONTAL'
  },
  {
    stateKey: 'SP',
    value: 'PONTALINDA',
    label: 'PONTALINDA'
  },
  {
    stateKey: 'SP',
    value: 'PONTES GESTAL',
    label: 'PONTES GESTAL'
  },
  {
    stateKey: 'SP',
    value: 'POPULINA',
    label: 'POPULINA'
  },
  {
    stateKey: 'SP',
    value: 'PORANGABA',
    label: 'PORANGABA'
  },
  {
    stateKey: 'SP',
    value: 'PORTO FELIZ',
    label: 'PORTO FELIZ'
  },
  {
    stateKey: 'SP',
    value: 'PORTO FERREIRA',
    label: 'PORTO FERREIRA'
  },
  {
    stateKey: 'SP',
    value: 'POTIM',
    label: 'POTIM'
  },
  {
    stateKey: 'SP',
    value: 'POTIRENDABA',
    label: 'POTIRENDABA'
  },
  {
    stateKey: 'SP',
    value: 'PRACINHA',
    label: 'PRACINHA'
  },
  {
    stateKey: 'SP',
    value: 'PRADOPOLIS',
    label: 'PRADOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'PRAIA GRANDE',
    label: 'PRAIA GRANDE'
  },
  {
    stateKey: 'SP',
    value: 'PRATANIA',
    label: 'PRATANIA'
  },
  {
    stateKey: 'SP',
    value: 'PRESIDENTE ALVES',
    label: 'PRESIDENTE ALVES'
  },
  {
    stateKey: 'SP',
    value: 'PRESIDENTE BERNARDES',
    label: 'PRESIDENTE BERNARDES'
  },
  {
    stateKey: 'SP',
    value: 'PRESIDENTE EPITACIO',
    label: 'PRESIDENTE EPITACIO'
  },
  {
    stateKey: 'SP',
    value: 'PRESIDENTE PRUDENTE',
    label: 'PRESIDENTE PRUDENTE'
  },
  {
    stateKey: 'SP',
    value: 'PRESIDENTE VENCESLAU',
    label: 'PRESIDENTE VENCESLAU'
  },
  {
    stateKey: 'SP',
    value: 'PROMISSAO',
    label: 'PROMISSAO'
  },
  {
    stateKey: 'SP',
    value: 'QUADRA',
    label: 'QUADRA'
  },
  {
    stateKey: 'SP',
    value: 'QUATA',
    label: 'QUATA'
  },
  {
    stateKey: 'SP',
    value: 'QUEIROZ',
    label: 'QUEIROZ'
  },
  {
    stateKey: 'SP',
    value: 'QUELUZ',
    label: 'QUELUZ'
  },
  {
    stateKey: 'SP',
    value: 'QUINTANA',
    label: 'QUINTANA'
  },
  {
    stateKey: 'SP',
    value: 'RAFARD',
    label: 'RAFARD'
  },
  {
    stateKey: 'SP',
    value: 'RANCHARIA',
    label: 'RANCHARIA'
  },
  {
    stateKey: 'SP',
    value: 'REDENCAO DA SERRA',
    label: 'REDENCAO DA SERRA'
  },
  {
    stateKey: 'SP',
    value: 'REGENTE FEIJO',
    label: 'REGENTE FEIJO'
  },
  {
    stateKey: 'SP',
    value: 'REGINOPOLIS',
    label: 'REGINOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'REGISTRO',
    label: 'REGISTRO'
  },
  {
    stateKey: 'SP',
    value: 'RESTINGA',
    label: 'RESTINGA'
  },
  {
    stateKey: 'SP',
    value: 'RIBEIRA',
    label: 'RIBEIRA'
  },
  {
    stateKey: 'SP',
    value: 'RIBEIRAO BONITO',
    label: 'RIBEIRAO BONITO'
  },
  {
    stateKey: 'SP',
    value: 'RIBEIRAO BRANCO',
    label: 'RIBEIRAO BRANCO'
  },
  {
    stateKey: 'SP',
    value: 'RIBEIRAO CORRENTE',
    label: 'RIBEIRAO CORRENTE'
  },
  {
    stateKey: 'SP',
    value: 'RIBEIRAO DO SUL',
    label: 'RIBEIRAO DO SUL'
  },
  {
    stateKey: 'SP',
    value: 'RIBEIRAO DOS INDIOS',
    label: 'RIBEIRAO DOS INDIOS'
  },
  {
    stateKey: 'SP',
    value: 'RIBEIRAO GRANDE',
    label: 'RIBEIRAO GRANDE'
  },
  {
    stateKey: 'SP',
    value: 'RIBEIRAO PIRES',
    label: 'RIBEIRAO PIRES'
  },
  {
    stateKey: 'SP',
    value: 'RIBEIRAO PRETO',
    label: 'RIBEIRAO PRETO'
  },
  {
    stateKey: 'SP',
    value: 'RIFAINA',
    label: 'RIFAINA'
  },
  {
    stateKey: 'SP',
    value: 'RINCAO',
    label: 'RINCAO'
  },
  {
    stateKey: 'SP',
    value: 'RINOPOLIS',
    label: 'RINOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'RIO CLARO',
    label: 'RIO CLARO'
  },
  {
    stateKey: 'SP',
    value: 'RIO DAS PEDRAS',
    label: 'RIO DAS PEDRAS'
  },
  {
    stateKey: 'SP',
    value: 'RIO GRANDE DA SERRA',
    label: 'RIO GRANDE DA SERRA'
  },
  {
    stateKey: 'SP',
    value: 'RIOLANDIA',
    label: 'RIOLANDIA'
  },
  {
    stateKey: 'SP',
    value: 'ROSANA',
    label: 'ROSANA'
  },
  {
    stateKey: 'SP',
    value: 'ROSEIRA',
    label: 'ROSEIRA'
  },
  {
    stateKey: 'SP',
    value: 'RUBIACEA',
    label: 'RUBIACEA'
  },
  {
    stateKey: 'SP',
    value: 'RUBINEIA',
    label: 'RUBINEIA'
  },
  {
    stateKey: 'SP',
    value: 'SABINO',
    label: 'SABINO'
  },
  {
    stateKey: 'SP',
    value: 'SAGRES',
    label: 'SAGRES'
  },
  {
    stateKey: 'SP',
    value: 'SALES',
    label: 'SALES'
  },
  {
    stateKey: 'SP',
    value: 'SALES OLIVEIRA',
    label: 'SALES OLIVEIRA'
  },
  {
    stateKey: 'SP',
    value: 'SALESOPOLIS',
    label: 'SALESOPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'SALTINHO',
    label: 'SALTINHO'
  },
  {
    stateKey: 'SP',
    value: 'SALTO',
    label: 'SALTO'
  },
  {
    stateKey: 'SP',
    value: 'SALTO DE PIRAPORA',
    label: 'SALTO DE PIRAPORA'
  },
  {
    stateKey: 'SP',
    value: 'SALTO GRANDE',
    label: 'SALTO GRANDE'
  },
  {
    stateKey: 'SP',
    value: 'SANDOVALINA',
    label: 'SANDOVALINA'
  },
  {
    stateKey: 'SP',
    value: 'SANTA ADELIA',
    label: 'SANTA ADELIA'
  },
  {
    stateKey: 'SP',
    value: 'SANTA ALBERTINA',
    label: 'SANTA ALBERTINA'
  },
  {
    stateKey: 'SP',
    value: "SANTA BARBARA D'OESTE",
    label: "SANTA BARBARA D'OESTE"
  },
  {
    stateKey: 'SP',
    value: 'SANTA BRANCA',
    label: 'SANTA BRANCA'
  },
  {
    stateKey: 'SP',
    value: "SANTA CLARA D'OESTE",
    label: "SANTA CLARA D'OESTE"
  },
  {
    stateKey: 'SP',
    value: 'SANTA CRUZ DA CONCEICAO',
    label: 'SANTA CRUZ DA CONCEICAO'
  },
  {
    stateKey: 'SP',
    value: 'SANTA CRUZ DA ESPERANCA',
    label: 'SANTA CRUZ DA ESPERANCA'
  },
  {
    stateKey: 'SP',
    value: 'SANTA CRUZ DAS PALMEIRAS',
    label: 'SANTA CRUZ DAS PALMEIRAS'
  },
  {
    stateKey: 'SP',
    value: 'SANTA CRUZ DO RIO PARDO',
    label: 'SANTA CRUZ DO RIO PARDO'
  },
  {
    stateKey: 'SP',
    value: 'SANTA ERNESTINA',
    label: 'SANTA ERNESTINA'
  },
  {
    stateKey: 'SP',
    value: 'SANTA FE DO SUL',
    label: 'SANTA FE DO SUL'
  },
  {
    stateKey: 'SP',
    value: 'SANTA GERTRUDES',
    label: 'SANTA GERTRUDES'
  },
  {
    stateKey: 'SP',
    value: 'SANTA ISABEL',
    label: 'SANTA ISABEL'
  },
  {
    stateKey: 'SP',
    value: 'SANTA LUCIA',
    label: 'SANTA LUCIA'
  },
  {
    stateKey: 'SP',
    value: 'SANTA MARIA DA SERRA',
    label: 'SANTA MARIA DA SERRA'
  },
  {
    stateKey: 'SP',
    value: 'SANTA MERCEDES',
    label: 'SANTA MERCEDES'
  },
  {
    stateKey: 'SP',
    value: "SANTA RITA D'OESTE",
    label: "SANTA RITA D'OESTE"
  },
  {
    stateKey: 'SP',
    value: 'SANTA RITA DO PASSA QUATRO- SP',
    label: 'SANTA RITA DO PASSA QUATRO- SP'
  },
  {
    stateKey: 'SP',
    value: 'SANTA ROSA DE VITERBO',
    label: 'SANTA ROSA DE VITERBO'
  },
  {
    stateKey: 'SP',
    value: 'SANTA SALETE',
    label: 'SANTA SALETE'
  },
  {
    stateKey: 'SP',
    value: 'SANTANA DA PONTE PENSA',
    label: 'SANTANA DA PONTE PENSA'
  },
  {
    stateKey: 'SP',
    value: 'SANTANA DE PARNAIBA',
    label: 'SANTANA DE PARNAIBA'
  },
  {
    stateKey: 'SP',
    value: 'SANTO ANASTACIO',
    label: 'SANTO ANASTACIO'
  },
  {
    stateKey: 'SP',
    value: 'SANTO ANDRE',
    label: 'SANTO ANDRE'
  },
  {
    stateKey: 'SP',
    value: 'SANTO ANTONIO DA ALEGRIA',
    label: 'SANTO ANTONIO DA ALEGRIA'
  },
  {
    stateKey: 'SP',
    value: 'SANTO ANTONIO DE POSSE',
    label: 'SANTO ANTONIO DE POSSE'
  },
  {
    stateKey: 'SP',
    value: 'SANTO ANTONIO DO ARACANGUA- SP',
    label: 'SANTO ANTONIO DO ARACANGUA- SP'
  },
  {
    stateKey: 'SP',
    value: 'SANTO ANTONIO DO JARDIM',
    label: 'SANTO ANTONIO DO JARDIM'
  },
  {
    stateKey: 'SP',
    value: 'SANTO ANTONIO DO PINHAL',
    label: 'SANTO ANTONIO DO PINHAL'
  },
  {
    stateKey: 'SP',
    value: 'SANTO EXPEDITO',
    label: 'SANTO EXPEDITO'
  },
  {
    stateKey: 'SP',
    value: 'SANTOPOLIS DO AGUAPEI',
    label: 'SANTOPOLIS DO AGUAPEI'
  },
  {
    stateKey: 'SP',
    value: 'SANTOS',
    label: 'SANTOS'
  },
  {
    stateKey: 'SP',
    value: 'SAO BENTO DO SAPUCAI',
    label: 'SAO BENTO DO SAPUCAI'
  },
  {
    stateKey: 'SP',
    value: 'SAO BERNARDO DO CAMPO',
    label: 'SAO BERNARDO DO CAMPO'
  },
  {
    stateKey: 'SP',
    value: 'SAO CAETANO DO SUL',
    label: 'SAO CAETANO DO SUL'
  },
  {
    stateKey: 'SP',
    value: 'SAO CARLOS',
    label: 'SAO CARLOS'
  },
  {
    stateKey: 'SP',
    value: 'SAO FRANCISCO',
    label: 'SAO FRANCISCO'
  },
  {
    stateKey: 'SP',
    value: 'SAO JOAO DA BOA VISTA',
    label: 'SAO JOAO DA BOA VISTA'
  },
  {
    stateKey: 'SP',
    value: 'SAO JOAO DAS DUAS PONTES',
    label: 'SAO JOAO DAS DUAS PONTES'
  },
  {
    stateKey: 'SP',
    value: 'SAO JOAO DE IRACEMA',
    label: 'SAO JOAO DE IRACEMA'
  },
  {
    stateKey: 'SP',
    value: "SAO JOAO DO PAU D'ALHO",
    label: "SAO JOAO DO PAU D'ALHO"
  },
  {
    stateKey: 'SP',
    value: 'SAO JOAQUIM DA BARRA',
    label: 'SAO JOAQUIM DA BARRA'
  },
  {
    stateKey: 'SP',
    value: 'SAO JOSE DA BELA VISTA',
    label: 'SAO JOSE DA BELA VISTA'
  },
  {
    stateKey: 'SP',
    value: 'SAO JOSE DO BARREIRO',
    label: 'SAO JOSE DO BARREIRO'
  },
  {
    stateKey: 'SP',
    value: 'SAO JOSE DO RIO PARDO',
    label: 'SAO JOSE DO RIO PARDO'
  },
  {
    stateKey: 'SP',
    value: 'SAO JOSE DO RIO PRETO',
    label: 'SAO JOSE DO RIO PRETO'
  },
  {
    stateKey: 'SP',
    value: 'SAO JOSE DOS CAMPOS',
    label: 'SAO JOSE DOS CAMPOS'
  },
  {
    stateKey: 'SP',
    value: 'SAO LOURENCO DA SERRA',
    label: 'SAO LOURENCO DA SERRA'
  },
  {
    stateKey: 'SP',
    value: 'SAO LUIS DO PARAITINGA',
    label: 'SAO LUIS DO PARAITINGA'
  },
  {
    stateKey: 'SP',
    value: 'SAO MANUEL',
    label: 'SAO MANUEL'
  },
  {
    stateKey: 'SP',
    value: 'SAO MIGUEL ARCANJO',
    label: 'SAO MIGUEL ARCANJO'
  },
  {
    stateKey: 'SP',
    value: 'SAO PAULO',
    label: 'SAO PAULO'
  },
  {
    stateKey: 'SP',
    value: 'SAO PEDRO',
    label: 'SAO PEDRO'
  },
  {
    stateKey: 'SP',
    value: 'SAO ROQUE',
    label: 'SAO ROQUE'
  },
  {
    stateKey: 'SP',
    value: 'SAO SEBASTIAO',
    label: 'SAO SEBASTIAO'
  },
  {
    stateKey: 'SP',
    value: 'SAO SEBASTIAO DA GRAMA',
    label: 'SAO SEBASTIAO DA GRAMA'
  },
  {
    stateKey: 'SP',
    value: 'SAO SIMAO',
    label: 'SAO SIMAO'
  },
  {
    stateKey: 'SP',
    value: 'SAO VICENTE',
    label: 'SAO VICENTE'
  },
  {
    stateKey: 'SP',
    value: 'SARAPUI',
    label: 'SARAPUI'
  },
  {
    stateKey: 'SP',
    value: 'SARUTAIA',
    label: 'SARUTAIA'
  },
  {
    stateKey: 'SP',
    value: 'SEBASTIANOPOLIS DO SUL',
    label: 'SEBASTIANOPOLIS DO SUL'
  },
  {
    stateKey: 'SP',
    value: 'SERRA AZUL',
    label: 'SERRA AZUL'
  },
  {
    stateKey: 'SP',
    value: 'SERRA NEGRA',
    label: 'SERRA NEGRA'
  },
  {
    stateKey: 'SP',
    value: 'SERRANA',
    label: 'SERRANA'
  },
  {
    stateKey: 'SP',
    value: 'SERTAOZINHO',
    label: 'SERTAOZINHO'
  },
  {
    stateKey: 'SP',
    value: 'SETE BARRAS',
    label: 'SETE BARRAS'
  },
  {
    stateKey: 'SP',
    value: 'SEVERINIA',
    label: 'SEVERINIA'
  },
  {
    stateKey: 'SP',
    value: 'SILVEIRAS',
    label: 'SILVEIRAS'
  },
  {
    stateKey: 'SP',
    value: 'SOCORRO',
    label: 'SOCORRO'
  },
  {
    stateKey: 'SP',
    value: 'SOROCABA',
    label: 'SOROCABA'
  },
  {
    stateKey: 'SP',
    value: 'SUMARE',
    label: 'SUMARE'
  },
  {
    stateKey: 'SP',
    value: 'SUZANAPOLIS',
    label: 'SUZANAPOLIS'
  },
  {
    stateKey: 'SP',
    value: 'TABAPUA',
    label: 'TABAPUA'
  },
  {
    stateKey: 'SP',
    value: 'TABATINGA',
    label: 'TABATINGA'
  },
  {
    stateKey: 'SP',
    value: 'TABOAO DA SERRA',
    label: 'TABOAO DA SERRA'
  },
  {
    stateKey: 'SP',
    value: 'TACIBA',
    label: 'TACIBA'
  },
  {
    stateKey: 'SP',
    value: 'TAGUAI',
    label: 'TAGUAI'
  },
  {
    stateKey: 'SP',
    value: 'TAIACU',
    label: 'TAIACU'
  },
  {
    stateKey: 'SP',
    value: 'TAIUVA',
    label: 'TAIUVA'
  },
  {
    stateKey: 'SP',
    value: 'TAMBAU',
    label: 'TAMBAU'
  },
  {
    stateKey: 'SP',
    value: 'TANABI',
    label: 'TANABI'
  },
  {
    stateKey: 'SP',
    value: 'TAPIRAI',
    label: 'TAPIRAI'
  },
  {
    stateKey: 'SP',
    value: 'TAPIRATIBA',
    label: 'TAPIRATIBA'
  },
  {
    stateKey: 'SP',
    value: 'TAQUARAL',
    label: 'TAQUARAL'
  },
  {
    stateKey: 'SP',
    value: 'TAQUARITINGA',
    label: 'TAQUARITINGA'
  },
  {
    stateKey: 'SP',
    value: 'TAQUARITUBA',
    label: 'TAQUARITUBA'
  },
  {
    stateKey: 'SP',
    value: 'TAQUARIVAI',
    label: 'TAQUARIVAI'
  },
  {
    stateKey: 'SP',
    value: 'TARABAI',
    label: 'TARABAI'
  },
  {
    stateKey: 'SP',
    value: 'TARUMA',
    label: 'TARUMA'
  },
  {
    stateKey: 'SP',
    value: 'TATUI',
    label: 'TATUI'
  },
  {
    stateKey: 'SP',
    value: 'TAUBATE',
    label: 'TAUBATE'
  },
  {
    stateKey: 'SP',
    value: 'TEJUPA',
    label: 'TEJUPA'
  },
  {
    stateKey: 'SP',
    value: 'TEODORO SAMPAIO',
    label: 'TEODORO SAMPAIO'
  },
  {
    stateKey: 'SP',
    value: 'TERRA ROXA',
    label: 'TERRA ROXA'
  },
  {
    stateKey: 'SP',
    value: 'TIETE',
    label: 'TIETE'
  },
  {
    stateKey: 'SP',
    value: 'TIMBURI',
    label: 'TIMBURI'
  },
  {
    stateKey: 'SP',
    value: 'TORRE DE PEDRA',
    label: 'TORRE DE PEDRA'
  },
  {
    stateKey: 'SP',
    value: 'TORRINHA',
    label: 'TORRINHA'
  },
  {
    stateKey: 'SP',
    value: 'TRABIJU',
    label: 'TRABIJU'
  },
  {
    stateKey: 'SP',
    value: 'TREMEMBE',
    label: 'TREMEMBE '
  },
  {
    stateKey: 'SP',
    value: 'TRES FRONTEIRAS',
    label: 'TRES FRONTEIRAS'
  },
  {
    stateKey: 'SP',
    value: 'TUIUTI',
    label: 'TUIUTI'
  },
  {
    stateKey: 'SP',
    value: 'TUPA',
    label: 'TUPA'
  },
  {
    stateKey: 'SP',
    value: 'TUPI PAULISTA',
    label: 'TUPI PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'TURIUBA',
    label: 'TURIUBA'
  },
  {
    stateKey: 'SP',
    value: 'TURMALINA',
    label: 'TURMALINA'
  },
  {
    stateKey: 'SP',
    value: 'UBARANA',
    label: 'UBARANA'
  },
  {
    stateKey: 'SP',
    value: 'UBATUBA',
    label: 'UBATUBA'
  },
  {
    stateKey: 'SP',
    value: 'UBIRAJARA',
    label: 'UBIRAJARA'
  },
  {
    stateKey: 'SP',
    value: 'UCHOA',
    label: 'UCHOA'
  },
  {
    stateKey: 'SP',
    value: 'UNIAO PAULISTA',
    label: 'UNIAO PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'URANIA',
    label: 'URANIA'
  },
  {
    stateKey: 'SP',
    value: 'URU',
    label: 'URU'
  },
  {
    stateKey: 'SP',
    value: 'URUPES',
    label: 'URUPES'
  },
  {
    stateKey: 'SP',
    value: 'VALENTIM GENTIL',
    label: 'VALENTIM GENTIL'
  },
  {
    stateKey: 'SP',
    value: 'VALINHOS',
    label: 'VALINHOS'
  },
  {
    stateKey: 'SP',
    value: 'VALPARAISO',
    label: 'VALPARAISO'
  },
  {
    stateKey: 'SP',
    value: 'VARGEM',
    label: 'VARGEM'
  },
  {
    stateKey: 'SP',
    value: 'VARGEM GRANDE DO SUL',
    label: 'VARGEM GRANDE DO SUL'
  },
  {
    stateKey: 'SP',
    value: 'VARGEM GRANDE PAULISTA',
    label: 'VARGEM GRANDE PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'VARZEA PAULISTA',
    label: 'VARZEA PAULISTA'
  },
  {
    stateKey: 'SP',
    value: 'VERA CRUZ',
    label: 'VERA CRUZ'
  },
  {
    stateKey: 'SP',
    value: 'VINHEDO',
    label: 'VINHEDO'
  },
  {
    stateKey: 'SP',
    value: 'VIRADOURO',
    label: 'VIRADOURO'
  },
  {
    stateKey: 'SP',
    value: 'VISTA ALEGRE DO ALTO',
    label: 'VISTA ALEGRE DO ALTO'
  },
  {
    stateKey: 'SP',
    value: 'VITORIA BRASIL',
    label: 'VITORIA BRASIL'
  },
  {
    stateKey: 'SP',
    value: 'VOTORANTIM',
    label: 'VOTORANTIM'
  },
  {
    stateKey: 'SP',
    value: 'VOTUPORANGA',
    label: 'VOTUPORANGA'
  },
  {
    stateKey: 'SP',
    value: 'ZACARIAS',
    label: 'ZACARIAS'
  },
  {
    stateKey: 'SP',
    value: 'BRODOWSKI',
    label: 'BRODOWSKI'
  },
  {
    stateKey: 'SP',
    value: 'IPAUSSU',
    label: 'IPAUSSU'
  },
  {
    stateKey: 'SP',
    value: 'IBITIUVA',
    label: 'IBITIUVA'
  },
  {
    stateKey: 'SP',
    value: 'SUD MENNUCCI',
    label: 'SUD MENNUCCI'
  },
  {
    stateKey: 'SP',
    value: 'BRODOSQUI',
    label: 'BRODOSQUI'
  },
  {
    stateKey: 'SP',
    value: 'SALMORAO',
    label: 'SALMORAO'
  },
  {
    stateKey: 'SP',
    value: 'LUISIANIA',
    label: 'LUISIANIA'
  },
  {
    stateKey: 'SP',
    value: 'RIVERSUL',
    label: 'RIVERSUL'
  },
  {
    stateKey: 'SP',
    value: 'SUZANO',
    label: 'SUZANO'
  },
  {
    stateKey: 'SP',
    value: 'NOVA LUZITANIA',
    label: 'NOVA LUZITANIA'
  },
  {
    stateKey: 'SP',
    value: 'LUIZIANIA',
    label: 'LUIZIANIA'
  },
  {
    stateKey: 'SP',
    value: 'CHAVANTES',
    label: 'CHAVANTES'
  },
  {
    stateKey: 'SP',
    value: 'EMBU DAS ARTES',
    label: 'EMBU DAS ARTES'
  },
  {
    stateKey: 'SP',
    value: 'CANANEIA',
    label: 'CANANEIA'
  },
  {
    stateKey: 'SP',
    value: 'SAO PEDRO DO TURVO',
    label: 'SAO PEDRO DO TURVO'
  },
  {
    stateKey: 'SE',
    value: 'AMPARO DE SAO FRANCISCO',
    label: 'AMPARO DE SAO FRANCISCO'
  },
  {
    stateKey: 'SE',
    value: 'AQUIDABA',
    label: 'AQUIDABA'
  },
  {
    stateKey: 'SE',
    value: 'ARACAJU',
    label: 'ARACAJU'
  },
  {
    stateKey: 'SE',
    value: 'ARAUA',
    label: 'ARAUA'
  },
  {
    stateKey: 'SE',
    value: 'AREIA BRANCA',
    label: 'AREIA BRANCA'
  },
  {
    stateKey: 'SE',
    value: 'BARRA DOS COQUEIROS',
    label: 'BARRA DOS COQUEIROS'
  },
  {
    stateKey: 'SE',
    value: 'BOQUIM',
    label: 'BOQUIM'
  },
  {
    stateKey: 'SE',
    value: 'BREJO GRANDE',
    label: 'BREJO GRANDE'
  },
  {
    stateKey: 'SE',
    value: 'CAMPO DO BRITO',
    label: 'CAMPO DO BRITO'
  },
  {
    stateKey: 'SE',
    value: 'CANHOBA',
    label: 'CANHOBA'
  },
  {
    stateKey: 'SE',
    value: 'CANINDE DO SAO FRANCISCO',
    label: 'CANINDE DO SAO FRANCISCO'
  },
  {
    stateKey: 'SE',
    value: 'CARIRA',
    label: 'CARIRA'
  },
  {
    stateKey: 'SE',
    value: 'CARMOPOLIS',
    label: 'CARMOPOLIS'
  },
  {
    stateKey: 'SE',
    value: 'CEDRO DE SAO JOAO',
    label: 'CEDRO DE SAO JOAO'
  },
  {
    stateKey: 'SE',
    value: 'CRISTINAPOLIS',
    label: 'CRISTINAPOLIS'
  },
  {
    stateKey: 'SE',
    value: 'CUMBE',
    label: 'CUMBE'
  },
  {
    stateKey: 'SE',
    value: 'DIVINA PASTORA',
    label: 'DIVINA PASTORA'
  },
  {
    stateKey: 'SE',
    value: 'ESTANCIA',
    label: 'ESTANCIA'
  },
  {
    stateKey: 'SE',
    value: 'FEIRA NOVA',
    label: 'FEIRA NOVA'
  },
  {
    stateKey: 'SE',
    value: 'FREI PAULO',
    label: 'FREI PAULO'
  },
  {
    stateKey: 'SE',
    value: 'GARARU',
    label: 'GARARU'
  },
  {
    stateKey: 'SE',
    value: 'GENERAL MAYNARD',
    label: 'GENERAL MAYNARD'
  },
  {
    stateKey: 'SE',
    value: 'ILHA DAS FLORES',
    label: 'ILHA DAS FLORES'
  },
  {
    stateKey: 'SE',
    value: 'INDIAROBA',
    label: 'INDIAROBA'
  },
  {
    stateKey: 'SE',
    value: 'ITABAIANA',
    label: 'ITABAIANA'
  },
  {
    stateKey: 'SE',
    value: 'ITABAIANINHA',
    label: 'ITABAIANINHA'
  },
  {
    stateKey: 'SE',
    value: 'ITABI',
    label: 'ITABI'
  },
  {
    stateKey: 'SE',
    value: "ITAPORANGA D'AJUDA",
    label: "ITAPORANGA D'AJUDA"
  },
  {
    stateKey: 'SE',
    value: 'JAPARATUBA',
    label: 'JAPARATUBA'
  },
  {
    stateKey: 'SE',
    value: 'JAPOATA',
    label: 'JAPOATA'
  },
  {
    stateKey: 'SE',
    value: 'LAGARTO',
    label: 'LAGARTO'
  },
  {
    stateKey: 'SE',
    value: 'LARANJEIRAS',
    label: 'LARANJEIRAS'
  },
  {
    stateKey: 'SE',
    value: 'MACAMBIRA',
    label: 'MACAMBIRA'
  },
  {
    stateKey: 'SE',
    value: 'MALHADA DOS BOIS',
    label: 'MALHADA DOS BOIS'
  },
  {
    stateKey: 'SE',
    value: 'MALHADOR',
    label: 'MALHADOR'
  },
  {
    stateKey: 'SE',
    value: 'MARUIM',
    label: 'MARUIM'
  },
  {
    stateKey: 'SE',
    value: 'MOITA BONITA',
    label: 'MOITA BONITA'
  },
  {
    stateKey: 'SE',
    value: 'MONTE ALEGRE DE SERGIPE',
    label: 'MONTE ALEGRE DE SERGIPE'
  },
  {
    stateKey: 'SE',
    value: 'MURIBECA',
    label: 'MURIBECA'
  },
  {
    stateKey: 'SE',
    value: 'NEOPOLIS',
    label: 'NEOPOLIS'
  },
  {
    stateKey: 'SE',
    value: 'NOSSA SENHORA APARECIDA',
    label: 'NOSSA SENHORA APARECIDA'
  },
  {
    stateKey: 'SE',
    value: 'NOSSA SENHORA DA GLORIA',
    label: 'NOSSA SENHORA DA GLORIA'
  },
  {
    stateKey: 'SE',
    value: 'NOSSA SENHORA DAS DORES',
    label: 'NOSSA SENHORA DAS DORES'
  },
  {
    stateKey: 'SE',
    value: 'NOSSA SENHORA DE LOURDES',
    label: 'NOSSA SENHORA DE LOURDES'
  },
  {
    stateKey: 'SE',
    value: 'NOSSA SENHORA DO SOCORRO',
    label: 'NOSSA SENHORA DO SOCORRO'
  },
  {
    stateKey: 'SE',
    value: 'PACATUBA',
    label: 'PACATUBA'
  },
  {
    stateKey: 'SE',
    value: 'PEDRA MOLE',
    label: 'PEDRA MOLE'
  },
  {
    stateKey: 'SE',
    value: 'PEDRINHAS',
    label: 'PEDRINHAS'
  },
  {
    stateKey: 'SE',
    value: 'PINHAO',
    label: 'PINHAO'
  },
  {
    stateKey: 'SE',
    value: 'PIRAMBU',
    label: 'PIRAMBU'
  },
  {
    stateKey: 'SE',
    value: 'POCO REDONDO',
    label: 'POCO REDONDO'
  },
  {
    stateKey: 'SE',
    value: 'POCO VERDE',
    label: 'POCO VERDE'
  },
  {
    stateKey: 'SE',
    value: 'PORTO DA FOLHA',
    label: 'PORTO DA FOLHA '
  },
  {
    stateKey: 'SE',
    value: 'PROPRIA',
    label: 'PROPRIA'
  },
  {
    stateKey: 'SE',
    value: 'RIACHAO DO DANTAS',
    label: 'RIACHAO DO DANTAS'
  },
  {
    stateKey: 'SE',
    value: 'RIACHUELO',
    label: 'RIACHUELO'
  },
  {
    stateKey: 'SE',
    value: 'RIBEIROPOLIS',
    label: 'RIBEIROPOLIS'
  },
  {
    stateKey: 'SE',
    value: 'ROSARIO DO CATETE',
    label: 'ROSARIO DO CATETE'
  },
  {
    stateKey: 'SE',
    value: 'SALGADO',
    label: 'SALGADO'
  },
  {
    stateKey: 'SE',
    value: 'SANTA LUZIA DO ITANHY',
    label: 'SANTA LUZIA DO ITANHY'
  },
  {
    stateKey: 'SE',
    value: 'SANTA ROSA DE LIMA',
    label: 'SANTA ROSA DE LIMA'
  },
  {
    stateKey: 'SE',
    value: 'SANTO AMARO DAS BROTAS',
    label: 'SANTO AMARO DAS BROTAS'
  },
  {
    stateKey: 'SE',
    value: 'SAO CRISTOVAO',
    label: 'SAO CRISTOVAO'
  },
  {
    stateKey: 'SE',
    value: 'SAO DOMINGOS',
    label: 'SAO DOMINGOS'
  },
  {
    stateKey: 'SE',
    value: 'SAO FRANCISCO',
    label: 'SAO FRANCISCO'
  },
  {
    stateKey: 'SE',
    value: 'SAO MIGUEL DO ALEIXO',
    label: 'SAO MIGUEL DO ALEIXO'
  },
  {
    stateKey: 'SE',
    value: 'SIMAO DIAS',
    label: 'SIMAO DIAS'
  },
  {
    stateKey: 'SE',
    value: 'SIRIRI',
    label: 'SIRIRI'
  },
  {
    stateKey: 'SE',
    value: 'TELHA',
    label: 'TELHA'
  },
  {
    stateKey: 'SE',
    value: 'TOBIAS BARRETO',
    label: 'TOBIAS BARRETO'
  },
  {
    stateKey: 'SE',
    value: 'TOMAR DO GERU',
    label: 'TOMAR DO GERU'
  },
  {
    stateKey: 'SE',
    value: 'UMBAUBA',
    label: 'UMBAUBA'
  },
  {
    stateKey: 'SE',
    value: 'CAPELA',
    label: 'CAPELA'
  },
  {
    stateKey: 'SE',
    value: 'GRACHO CARDOSO',
    label: 'GRACHO CARDOSO'
  },
  {
    stateKey: 'SE',
    value: 'CAMPINAS DE PACATUBA',
    label: 'CAMPINAS DE PACATUBA'
  },
  {
    stateKey: 'SE',
    value: 'SANTANA DE SAO FRANCISCO',
    label: 'SANTANA DE SAO FRANCISCO'
  },
  {
    stateKey: 'TO',
    value: 'RIO SONO',
    label: 'RIO SONO'
  },
  {
    stateKey: 'TO',
    value: 'CASEARA',
    label: 'CASEARA'
  },
  {
    stateKey: 'TO',
    value: 'MIRACEMA DO TOCANTINS',
    label: 'MIRACEMA DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'PARAISO DO TOCANTINS',
    label: 'PARAISO DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'TOCANTINOPOLIS',
    label: 'TOCANTINOPOLIS'
  },
  {
    stateKey: 'TO',
    value: 'Taguatinga',
    label: 'Taguatinga'
  },
  {
    stateKey: 'TO',
    value: 'Rio Sono',
    label: 'Rio Sono'
  },
  {
    stateKey: 'TO',
    value: 'ITACAJA',
    label: 'ITACAJA'
  },
  {
    stateKey: 'TO',
    value: 'PARANÃ',
    label: 'PARANÃ'
  },
  {
    stateKey: 'TO',
    value: 'Almas',
    label: 'Almas'
  },
  {
    stateKey: 'TO',
    value: 'Ananás',
    label: 'Ananás'
  },
  {
    stateKey: 'TO',
    value: 'Araguatins',
    label: 'Araguatins'
  },
  {
    stateKey: 'TO',
    value: 'Aurora do TO',
    label: 'Aurora do TO'
  },
  {
    stateKey: 'TO',
    value: 'Babaçulândia',
    label: 'Babaçulândia'
  },
  {
    stateKey: 'TO',
    value: 'Barrolândia',
    label: 'Barrolândia'
  },
  {
    stateKey: 'TO',
    value: 'Bernardo Sayão',
    label: 'Bernardo Sayão'
  },
  {
    stateKey: 'TO',
    value: 'Buriti do TO',
    label: 'Buriti do TO'
  },
  {
    stateKey: 'TO',
    value: 'Combinado',
    label: 'Combinado'
  },
  {
    stateKey: 'TO',
    value: 'Conceição do TO',
    label: 'Conceição do TO'
  },
  {
    stateKey: 'TO',
    value: 'Couto Magalhães',
    label: 'Couto Magalhães'
  },
  {
    stateKey: 'TO',
    value: 'Dois Irmãos do TO',
    label: 'Dois Irmãos do TO'
  },
  {
    stateKey: 'TO',
    value: 'Itaguatins',
    label: 'Itaguatins'
  },
  {
    stateKey: 'TO',
    value: 'Itaporã do TO',
    label: 'Itaporã do TO'
  },
  {
    stateKey: 'TO',
    value: 'Lizarda',
    label: 'Lizarda'
  },
  {
    stateKey: 'TO',
    value: 'Marianópolis do TO',
    label: 'Marianópolis do TO'
  },
  {
    stateKey: 'TO',
    value: 'Monte do Carmo',
    label: 'Monte do Carmo'
  },
  {
    stateKey: 'TO',
    value: 'Palmeiras do TO',
    label: 'Palmeiras do TO'
  },
  {
    stateKey: 'TO',
    value: 'Natividade',
    label: 'Natividade'
  },
  {
    stateKey: 'TO',
    value: 'Nazaré ',
    label: 'Nazaré'
  },
  {
    stateKey: 'TO',
    value: 'Nova Olinda',
    label: 'Nova Olinda'
  },
  {
    stateKey: 'TO',
    value: 'Nova Rosalândia',
    label: 'Nova Rosalândia'
  },
  {
    stateKey: 'TO',
    value: 'Novo Acordo',
    label: 'Novo Acordo'
  },
  {
    stateKey: 'TO',
    value: 'Novo Alegre',
    label: 'Novo Alegre'
  },
  {
    stateKey: 'TO',
    value: 'Pindorama do TO',
    label: 'Pindorama do TO'
  },
  {
    stateKey: 'TO',
    value: 'Ponte Alta do Bom Jesus',
    label: 'Ponte Alta do Bom Jesus'
  },
  {
    stateKey: 'TO',
    value: 'Praia Norte',
    label: 'Praia Norte'
  },
  {
    stateKey: 'TO',
    value: 'Sampaio',
    label: 'Sampaio'
  },
  {
    stateKey: 'TO',
    value: 'Santa Rosa do TO',
    label: 'Santa Rosa do TO'
  },
  {
    stateKey: 'TO',
    value: 'Santa Terezinha do Tocanti',
    label: 'Santa Terezinha do Tocanti'
  },
  {
    stateKey: 'TO',
    value: 'São Sebastião do TO',
    label: 'São Sebastião do TO'
  },
  {
    stateKey: 'TO',
    value: 'São Valério da Natividade',
    label: 'São Valério da Natividade'
  },
  {
    stateKey: 'TO',
    value: 'Sítio Novo do TO',
    label: 'Sítio Novo do TO'
  },
  {
    stateKey: 'TO',
    value: 'Tocantínia',
    label: 'Tocantínia'
  },
  {
    stateKey: 'TO',
    value: 'Wanderlândia',
    label: 'Wanderlândia'
  },
  {
    stateKey: 'TO',
    value: 'ITACAJÁ',
    label: 'ITACAJÁ'
  },
  {
    stateKey: 'TO',
    value: 'ARAGUACEMA',
    label: 'ARAGUACEMA'
  },
  {
    stateKey: 'TO',
    value: 'PEQUIZEIRO',
    label: 'PEQUIZEIRO'
  },
  {
    stateKey: 'TO',
    value: 'GOIANORTE',
    label: 'GOIANORTE'
  },
  {
    stateKey: 'TO',
    value: 'ARRAIAS',
    label: 'ARRAIAS'
  },
  {
    stateKey: 'TO',
    value: 'Porto Alegre do TO',
    label: 'Porto Alegre do TO'
  },
  {
    stateKey: 'TO',
    value: 'ABREULANDIA',
    label: 'ABREULANDIA'
  },
  {
    stateKey: 'TO',
    value: 'AGUIARNOPOLIS',
    label: 'AGUIARNOPOLIS'
  },
  {
    stateKey: 'TO',
    value: 'ANGICO',
    label: 'ANGICO'
  },
  {
    stateKey: 'TO',
    value: 'ARAGOMINAS',
    label: 'ARAGOMINAS'
  },
  {
    stateKey: 'TO',
    value: 'ARAGUANA',
    label: 'ARAGUANA'
  },
  {
    stateKey: 'TO',
    value: 'BANDEIRANTES DO TOCANTINS',
    label: 'BANDEIRANTES DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'BARRA DO OURO',
    label: 'BARRA DO OURO'
  },
  {
    stateKey: 'TO',
    value: 'BOM JESUS DO TOCANTINS',
    label: 'BOM JESUS DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'BRASILANDIA DO TOCANTINS',
    label: 'BRASILANDIA DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'CACHOEIRINHA',
    label: 'CACHOEIRINHA'
  },
  {
    stateKey: 'TO',
    value: 'CAMPOS LINDOS',
    label: 'CAMPOS LINDOS'
  },
  {
    stateKey: 'TO',
    value: 'CARIRI DO TOCANTINS',
    label: 'CARIRI DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'CARMOLANDIA',
    label: 'CARMOLANDIA'
  },
  {
    stateKey: 'TO',
    value: 'CARRASCO BONITO',
    label: 'CARRASCO BONITO'
  },
  {
    stateKey: 'TO',
    value: 'CENTENARIO',
    label: 'CENTENARIO'
  },
  {
    stateKey: 'TO',
    value: 'CHAPADA DE AREIA',
    label: 'CHAPADA DE AREIA'
  },
  {
    stateKey: 'TO',
    value: 'CHAPADA DA NATIVIDADE',
    label: 'CHAPADA DA NATIVIDADE'
  },
  {
    stateKey: 'TO',
    value: 'CRIXAS DO TOCANTINS',
    label: 'CRIXAS DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'DARCINOPOLIS',
    label: 'DARCINOPOLIS'
  },
  {
    stateKey: 'TO',
    value: 'ESPERANTINA',
    label: 'ESPERANTINA'
  },
  {
    stateKey: 'TO',
    value: 'FORTALEZA DO TABOCAO',
    label: 'FORTALEZA DO TABOCAO'
  },
  {
    stateKey: 'TO',
    value: 'IPUEIRAS',
    label: 'IPUEIRAS'
  },
  {
    stateKey: 'TO',
    value: 'ITAPIRATINS',
    label: 'ITAPIRATINS'
  },
  {
    stateKey: 'TO',
    value: 'JAU DO TOCANTINS',
    label: 'JAU DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'JUARINA',
    label: 'JUARINA'
  },
  {
    stateKey: 'TO',
    value: 'LAGOA DA CONFUSAO',
    label: 'LAGOA DA CONFUSAO'
  },
  {
    stateKey: 'TO',
    value: 'LAGOA DO TOCANTINS',
    label: 'LAGOA DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'LAJEADO',
    label: 'LAJEADO'
  },
  {
    stateKey: 'TO',
    value: 'LAVANDEIRAS',
    label: 'LAVANDEIRAS'
  },
  {
    stateKey: 'TO',
    value: 'LUZINOPOLIS',
    label: 'LUZINOPOLIS'
  },
  {
    stateKey: 'TO',
    value: 'MATEIROS',
    label: 'MATEIROS'
  },
  {
    stateKey: 'TO',
    value: 'MAURILANDIA DO TOCANTINS',
    label: 'MAURILANDIA DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'PIUM',
    label: 'PIUM'
  },
  {
    stateKey: 'TO',
    value: 'TOCANTINOPOLIS',
    label: 'TOCANTINOPOLIS'
  },
  {
    stateKey: 'TO',
    value: 'MONTE SANTO',
    label: 'MONTE SANTO'
  },
  {
    stateKey: 'TO',
    value: 'MURICILANDIA',
    label: 'MURICILANDIA'
  },
  {
    stateKey: 'TO',
    value: 'NOVO JARDIM',
    label: 'NOVO JARDIM'
  },
  {
    stateKey: 'TO',
    value: 'OLIVEIRA DE FATIMA',
    label: 'OLIVEIRA DE FATIMA'
  },
  {
    stateKey: 'TO',
    value: 'PALMAS',
    label: 'PALMAS'
  },
  {
    stateKey: 'TO',
    value: 'PALMEIRANTE',
    label: 'PALMEIRANTE'
  },
  {
    stateKey: 'TO',
    value: "PAU D'ARCO",
    label: "PAU D'ARCO"
  },
  {
    stateKey: 'TO',
    value: 'PIRAQUE',
    label: 'PIRAQUE'
  },
  {
    stateKey: 'TO',
    value: 'PUGMIL',
    label: 'PUGMIL'
  },
  {
    stateKey: 'TO',
    value: 'RECURSOLANDIA',
    label: 'RECURSOLANDIA'
  },
  {
    stateKey: 'TO',
    value: 'RIACHINHO',
    label: 'RIACHINHO'
  },
  {
    stateKey: 'TO',
    value: 'RIO DA CONCEICAO',
    label: 'RIO DA CONCEICAO'
  },
  {
    stateKey: 'TO',
    value: 'RIO DOS BOIS',
    label: 'RIO DOS BOIS'
  },
  {
    stateKey: 'TO',
    value: 'SANDOLANDIA',
    label: 'SANDOLANDIA'
  },
  {
    stateKey: 'TO',
    value: 'SANTA FE DO ARAGUAIA',
    label: 'SANTA FE DO ARAGUAIA'
  },
  {
    stateKey: 'TO',
    value: 'SANTA MARIA DO TOCANTINS',
    label: 'SANTA MARIA DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'SANTA RITA DO TOCANTINS',
    label: 'SANTA RITA DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'Presidente Kennedy',
    label: 'Presidente Kennedy'
  },
  {
    stateKey: 'TO',
    value: 'SANTA TEREZINHA',
    label: 'SANTA TEREZINHA'
  },
  {
    stateKey: 'TO',
    value: 'SAO BENTO DO TOCANTINS',
    label: 'SAO BENTO DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'SAO FELIX DO TOCANTINS',
    label: 'SAO FELIX DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'SAO MIGUEL DO TOCANTINS',
    label: 'SAO MIGUEL DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'SAO SALVADOR DO TOCANTINS',
    label: 'SAO SALVADOR DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'DIVINOPOLIS',
    label: 'DIVINOPOLIS'
  },
  {
    stateKey: 'TO',
    value: 'DUERE',
    label: 'DUERE'
  },
  {
    stateKey: 'TO',
    value: 'SUCUPIRA',
    label: 'SUCUPIRA'
  },
  {
    stateKey: 'TO',
    value: 'TAIPAS DO TOCANTINS',
    label: 'TAIPAS DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'TALISMA',
    label: 'TALISMA'
  },
  {
    stateKey: 'TO',
    value: 'ARAGUAÇU',
    label: 'ARAGUAÇU'
  },
  {
    stateKey: 'TO',
    value: 'TUPIRAMA',
    label: 'TUPIRAMA'
  },
  {
    stateKey: 'TO',
    value: 'TUPIRATINS',
    label: 'TUPIRATINS'
  },
  {
    stateKey: 'TO',
    value: 'ARAPOEMA',
    label: 'ARAPOEMA'
  },
  {
    stateKey: 'TO',
    value: 'ALVORADA',
    label: 'ALVORADA'
  },
  {
    stateKey: 'TO',
    value: 'PALMEIRÓPOLIS',
    label: 'PALMEIRÓPOLIS'
  },
  {
    stateKey: 'TO',
    value: 'ALIANÇA DO TOCANTINS',
    label: 'ALIANÇA DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'COLMÉIA',
    label: 'COLMÉIA'
  },
  {
    stateKey: 'TO',
    value: 'CASEARA',
    label: 'CASEARA'
  },
  {
    stateKey: 'TO',
    value: 'TAQUARALTO',
    label: 'TAQUARALTO'
  },
  {
    stateKey: 'TO',
    value: 'TAQUARUSSU DO TOCANTINS',
    label: 'TAQUARUSSU DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'ARAGUAIA',
    label: 'ARAGUAIA'
  },
  {
    stateKey: 'TO',
    value: 'DIANOPOLIS',
    label: 'DIANOPOLIS'
  },
  {
    stateKey: 'TO',
    value: 'GURUPI',
    label: 'GURUPI'
  },
  {
    stateKey: 'TO',
    value: 'ARAGUAINA',
    label: 'ARAGUAINA'
  },
  {
    stateKey: 'TO',
    value: 'PEIXE',
    label: 'PEIXE'
  },
  {
    stateKey: 'TO',
    value: 'FIGUEIROPOLIS',
    label: 'FIGUEIROPOLIS'
  },
  {
    stateKey: 'TO',
    value: 'XAMBIOA',
    label: 'XAMBIOA'
  },
  {
    stateKey: 'TO',
    value: 'PORTO NACIONAL',
    label: 'PORTO NACIONAL'
  },
  {
    stateKey: 'TO',
    value: 'PARAISO DO TOCANTINS',
    label: 'PARAISO DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'FORMOSO DO ARAGUAIA',
    label: 'FORMOSO DO ARAGUAIA'
  },
  {
    stateKey: 'TO',
    value: 'BREJINHO DE NAZARE',
    label: 'BREJINHO DE NAZARE'
  },
  {
    stateKey: 'TO',
    value: 'COLINAS DO TOCANTINS',
    label: 'COLINAS DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'APARECIDA DO RIO NEGRO',
    label: 'APARECIDA DO RIO NEGRO'
  },
  {
    stateKey: 'TO',
    value: 'RIO NEGRO',
    label: 'RIO NEGRO'
  },
  {
    stateKey: 'TO',
    value: 'GUARAI',
    label: 'GUARAI'
  },
  {
    stateKey: 'TO',
    value: 'MIRANORTE',
    label: 'MIRANORTE'
  },
  {
    stateKey: 'TO',
    value: 'FATIMA',
    label: 'FATIMA'
  },
  {
    stateKey: 'TO',
    value: 'MIRACEMA',
    label: 'MIRACEMA'
  },
  {
    stateKey: 'TO',
    value: 'PONTE ALTA DO TOCANTINS',
    label: 'PONTE ALTA DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'AUGUSTINOPOLIS',
    label: 'AUGUSTINOPOLIS'
  },
  {
    stateKey: 'TO',
    value: 'AXIXA DO TOCANTINS',
    label: 'AXIXA DO TOCANTINS'
  },
  {
    stateKey: 'TO',
    value: 'GOIATINS',
    label: 'GOIATINS'
  },
  {
    stateKey: 'TO',
    value: 'SILVANOPOLIS',
    label: 'SILVANOPOLIS'
  },
  {
    stateKey: 'TO',
    value: 'CRISTALANDIA',
    label: 'CRISTALANDIA'
  },
  {
    stateKey: 'TO',
    value: 'ALMAS',
    label: 'ALMAS'
  },
  {
    stateKey: 'TO',
    value: 'Taguatinga',
    label: 'Taguatinga'
  },
  {
    stateKey: 'TO',
    value: 'PEDRO AFONSO',
    label: 'PEDRO AFONSO'
  }
];

export const states = [
  {
    countryKey: 'AR',
    value: '00',
    label: 'Capital Federal'
  },
  {
    countryKey: 'AR',
    value: '01',
    label: 'Buenos Aires'
  },
  {
    countryKey: 'AR',
    value: '02',
    label: 'Catamarca'
  },
  {
    countryKey: 'AR',
    value: '03',
    label: 'Cordoba'
  },
  {
    countryKey: 'AR',
    value: '04',
    label: 'Corrientes'
  },
  {
    countryKey: 'AR',
    value: '05',
    label: 'Entre Rios'
  },
  {
    countryKey: 'AR',
    value: '06',
    label: 'Jujuy'
  },
  {
    countryKey: 'AR',
    value: '07',
    label: 'Mendoza'
  },
  {
    countryKey: 'AR',
    value: '08',
    label: 'La Rioja'
  },
  {
    countryKey: 'AR',
    value: '09',
    label: 'Salta'
  },
  {
    countryKey: 'AR',
    value: '10',
    label: 'San Juan'
  },
  {
    countryKey: 'AR',
    value: '11',
    label: 'San Luis'
  },
  {
    countryKey: 'AR',
    value: '12',
    label: 'Santa Fe'
  },
  {
    countryKey: 'AR',
    value: '13',
    label: 'Santiago del Estero'
  },
  {
    countryKey: 'AR',
    value: '14',
    label: 'Tucuman'
  },
  {
    countryKey: 'AR',
    value: '16',
    label: 'Chaco'
  },
  {
    countryKey: 'AR',
    value: '17',
    label: 'Chubut'
  },
  {
    countryKey: 'AR',
    value: '18',
    label: 'Formosa'
  },
  {
    countryKey: 'AR',
    value: '19',
    label: 'Misiones'
  },
  {
    countryKey: 'AR',
    value: '20',
    label: 'Neuquen'
  },
  {
    countryKey: 'AR',
    value: '21',
    label: 'La Pampa'
  },
  {
    countryKey: 'AR',
    value: '22',
    label: 'Rio Negro'
  },
  {
    countryKey: 'AR',
    value: '23',
    label: 'Santa Cruz'
  },
  {
    countryKey: 'AR',
    value: '24',
    label: 'Tierra de Fuego'
  },
  {
    countryKey: 'AR',
    value: '25',
    label: 'Rosario'
  },
  {
    countryKey: 'AT',
    value: 'B',
    label: 'Burgenland'
  },
  {
    countryKey: 'AT',
    value: 'K',
    label: 'Carinthia'
  },
  {
    countryKey: 'AT',
    value: 'NOE',
    label: 'Lower Austria'
  },
  {
    countryKey: 'AT',
    value: 'OOE',
    label: 'Upper Austria'
  },
  {
    countryKey: 'AT',
    value: 'S',
    label: 'Salzburg'
  },
  {
    countryKey: 'AT',
    value: 'ST',
    label: 'Styria'
  },
  {
    countryKey: 'AT',
    value: 'T',
    label: 'Tyrol'
  },
  {
    countryKey: 'AT',
    value: 'V',
    label: 'Vorarlberg'
  },
  {
    countryKey: 'AT',
    value: 'W',
    label: 'Vienna'
  },
  {
    countryKey: 'AU',
    value: 'ACT',
    label: 'Aust Capital Terr'
  },
  {
    countryKey: 'AU',
    value: 'NSW',
    label: 'New South Wales'
  },
  {
    countryKey: 'AU',
    value: 'NT',
    label: 'Northern Territory'
  },
  {
    countryKey: 'AU',
    value: 'QLD',
    label: 'Queensland'
  },
  {
    countryKey: 'AU',
    value: 'SA',
    label: 'South Australia'
  },
  {
    countryKey: 'AU',
    value: 'TAS',
    label: 'Tasmania'
  },
  {
    countryKey: 'AU',
    value: 'VIC',
    label: 'Victoria'
  },
  {
    countryKey: 'AU',
    value: 'WA',
    label: 'Western Australia'
  },
  {
    countryKey: 'BE',
    value: '01',
    label: 'Antwerp'
  },
  {
    countryKey: 'BE',
    value: '02',
    label: 'Brabant (Flemish)'
  },
  {
    countryKey: 'BE',
    value: '03',
    label: 'Hainaut'
  },
  {
    countryKey: 'BE',
    value: '04',
    label: 'Liege'
  },
  {
    countryKey: 'BE',
    value: '05',
    label: 'Limburg'
  },
  {
    countryKey: 'BE',
    value: '06',
    label: 'Luxembourg'
  },
  {
    countryKey: 'BE',
    value: '07',
    label: 'Namur'
  },
  {
    countryKey: 'BE',
    value: '08',
    label: 'Oost-Vlaanderen'
  },
  {
    countryKey: 'BE',
    value: '09',
    label: 'West-Vlaanderen'
  },
  {
    countryKey: 'BE',
    value: '10',
    label: 'Brabant (Walloon)'
  },
  {
    countryKey: 'BE',
    value: '11',
    label: 'Brussels (Capital)'
  },
  {
    countryKey: 'BG',
    value: 'BGS',
    label: 'Burgas'
  },
  {
    countryKey: 'BG',
    value: 'BLG',
    label: 'Blagoevgrad'
  },
  {
    countryKey: 'BG',
    value: 'DOB',
    label: 'Dobrich'
  },
  {
    countryKey: 'BG',
    value: 'GAB',
    label: 'Gabrovo'
  },
  {
    countryKey: 'BG',
    value: 'HKV',
    label: 'Haskovo'
  },
  {
    countryKey: 'BG',
    value: 'JAM',
    label: 'Yambol'
  },
  {
    countryKey: 'BG',
    value: 'KNL',
    label: 'Kyustendil'
  },
  {
    countryKey: 'BG',
    value: 'KRZ',
    label: 'Kurdzhali'
  },
  {
    countryKey: 'BG',
    value: 'LOV',
    label: 'Lovech'
  },
  {
    countryKey: 'BG',
    value: 'MON',
    label: 'Montana'
  },
  {
    countryKey: 'BG',
    value: 'PAZ',
    label: 'Pazardzhik'
  },
  {
    countryKey: 'BG',
    value: 'PDV',
    label: 'Plovdiv'
  },
  {
    countryKey: 'BG',
    value: 'PER',
    label: 'Pemik'
  },
  {
    countryKey: 'BG',
    value: 'PVN',
    label: 'Pleven'
  },
  {
    countryKey: 'BG',
    value: 'RAZ',
    label: 'Razgrad'
  },
  {
    countryKey: 'BG',
    value: 'RSE',
    label: 'Ruse'
  },
  {
    countryKey: 'BG',
    value: 'SFO',
    label: 'Sofia ( province )'
  },
  {
    countryKey: 'BG',
    value: 'SHU',
    label: 'Shumen'
  },
  {
    countryKey: 'BG',
    value: 'SLS',
    label: 'Silistra'
  },
  {
    countryKey: 'BG',
    value: 'SLV',
    label: 'Sliven'
  },
  {
    countryKey: 'BG',
    value: 'SML',
    label: 'Smolyan'
  },
  {
    countryKey: 'BG',
    value: 'SOF',
    label: 'Sofia City'
  },
  {
    countryKey: 'BG',
    value: 'SZR',
    label: 'Stara Zagora'
  },
  {
    countryKey: 'BG',
    value: 'TGV',
    label: 'Targovishte'
  },
  {
    countryKey: 'BG',
    value: 'VAR',
    label: 'Varna'
  },
  {
    countryKey: 'BG',
    value: 'VID',
    label: 'Vidin'
  },
  {
    countryKey: 'BG',
    value: 'VRC',
    label: 'Vratsa'
  },
  {
    countryKey: 'BG',
    value: 'VTR',
    label: 'Veliko Turnovo'
  },
  {
    countryKey: 'BG',
    value: 'XXX',
    label: 'The whole country'
  },
  {
    countryKey: 'BG',
    value: 'ZZZ',
    label: 'Outside the country'
  },
  {
    countryKey: 'BM',
    value: 'BE',
    label: 'Bermudas'
  },
  {
    countryKey: 'BR',
    value: 'AC',
    label: 'Acre'
  },
  {
    countryKey: 'BR',
    value: 'AL',
    label: 'Alagoas'
  },
  {
    countryKey: 'BR',
    value: 'AM',
    label: 'Amazonas'
  },
  {
    countryKey: 'BR',
    value: 'AP',
    label: 'Amapá'
  },
  {
    countryKey: 'BR',
    value: 'BA',
    label: 'Bahia'
  },
  {
    countryKey: 'BR',
    value: 'CE',
    label: 'Ceará'
  },
  {
    countryKey: 'BR',
    value: 'DF',
    label: 'Distrito Federal'
  },
  {
    countryKey: 'BR',
    value: 'ES',
    label: 'Espírito Santo'
  },
  {
    countryKey: 'BR',
    value: 'GO',
    label: 'Goiás'
  },
  {
    countryKey: 'BR',
    value: 'MA',
    label: 'Maranhão'
  },
  {
    countryKey: 'BR',
    value: 'MG',
    label: 'Minas Gerais'
  },
  {
    countryKey: 'BR',
    value: 'MS',
    label: 'MT do Sul'
  },
  {
    countryKey: 'BR',
    value: 'MT',
    label: 'Mato Grosso'
  },
  {
    countryKey: 'BR',
    value: 'PA',
    label: 'Pará'
  },
  {
    countryKey: 'BR',
    value: 'PB',
    label: 'Paraíba'
  },
  {
    countryKey: 'BR',
    value: 'PE',
    label: 'Pernambuco'
  },
  {
    countryKey: 'BR',
    value: 'PI',
    label: 'Piauí'
  },
  {
    countryKey: 'BR',
    value: 'PR',
    label: 'Paraná'
  },
  {
    countryKey: 'BR',
    value: 'RJ',
    label: 'Rio de Janeiro'
  },
  {
    countryKey: 'BR',
    value: 'RN',
    label: 'Rio Grande do Norte'
  },
  {
    countryKey: 'BR',
    value: 'RO',
    label: 'Rondônia'
  },
  {
    countryKey: 'BR',
    value: 'RR',
    label: 'Roraima'
  },
  {
    countryKey: 'BR',
    value: 'RS',
    label: 'Rio Grande do Sul'
  },
  {
    countryKey: 'BR',
    value: 'SC',
    label: 'Santa Catarina'
  },
  {
    countryKey: 'BR',
    value: 'SE',
    label: 'Sergipe'
  },
  {
    countryKey: 'BR',
    value: 'SP',
    label: 'São Paulo'
  },
  {
    countryKey: 'BR',
    value: 'TO',
    label: 'Tocantins'
  },
  {
    countryKey: 'CA',
    value: 'AB',
    label: 'Alberta'
  },
  {
    countryKey: 'CA',
    value: 'BC',
    label: 'British Columbia'
  },
  {
    countryKey: 'CA',
    value: 'MB',
    label: 'Manitoba'
  },
  {
    countryKey: 'CA',
    value: 'NB',
    label: 'New Brunswick'
  },
  {
    countryKey: 'CA',
    value: 'NL',
    label: 'Newfoundland & Labr.'
  },
  {
    countryKey: 'CA',
    value: 'NS',
    label: 'Nova Scotia'
  },
  {
    countryKey: 'CA',
    value: 'NT',
    label: 'Northwest Terr.'
  },
  {
    countryKey: 'CA',
    value: 'NU',
    label: 'Nunavut'
  },
  {
    countryKey: 'CA',
    value: 'ON',
    label: 'Ontario'
  },
  {
    countryKey: 'CA',
    value: 'PE',
    label: 'Prince Edward Island'
  },
  {
    countryKey: 'CA',
    value: 'QC',
    label: 'Quebec'
  },
  {
    countryKey: 'CA',
    value: 'SK',
    label: 'Saskatchewan'
  },
  {
    countryKey: 'CA',
    value: 'YT',
    label: 'Yukon Territory'
  },
  {
    countryKey: 'CH',
    value: 'AG',
    label: 'Aargau'
  },
  {
    countryKey: 'CH',
    value: 'AI',
    label: 'Inner-Rhoden'
  },
  {
    countryKey: 'CH',
    value: 'AR',
    label: 'Ausser-Rhoden'
  },
  {
    countryKey: 'CH',
    value: 'BE',
    label: 'Bern'
  },
  {
    countryKey: 'CH',
    value: 'BL',
    label: 'Basel Land'
  },
  {
    countryKey: 'CH',
    value: 'BS',
    label: 'Basel Stadt'
  },
  {
    countryKey: 'CH',
    value: 'FR',
    label: 'Fribourg'
  },
  {
    countryKey: 'CH',
    value: 'GE',
    label: 'Geneva'
  },
  {
    countryKey: 'CH',
    value: 'GL',
    label: 'Glarus'
  },
  {
    countryKey: 'CH',
    value: 'GR',
    label: 'Graubuenden'
  },
  {
    countryKey: 'CH',
    value: 'JU',
    label: 'Jura'
  },
  {
    countryKey: 'CH',
    value: 'LU',
    label: 'Lucerne'
  },
  {
    countryKey: 'CH',
    value: 'NE',
    label: 'Neuchatel'
  },
  {
    countryKey: 'CH',
    value: 'NW',
    label: 'Nidwalden'
  },
  {
    countryKey: 'CH',
    value: 'OW',
    label: 'Obwalden'
  },
  {
    countryKey: 'CH',
    value: 'SG',
    label: 'St. Gallen'
  },
  {
    countryKey: 'CH',
    value: 'SH',
    label: 'Schaffhausen'
  },
  {
    countryKey: 'CH',
    value: 'SO',
    label: 'Solothurn'
  },
  {
    countryKey: 'CH',
    value: 'SZ',
    label: 'Schwyz'
  },
  {
    countryKey: 'CH',
    value: 'TG',
    label: 'Thurgau'
  },
  {
    countryKey: 'CH',
    value: 'TI',
    label: 'Ticino'
  },
  {
    countryKey: 'CH',
    value: 'UR',
    label: 'Uri'
  },
  {
    countryKey: 'CH',
    value: 'VD',
    label: 'Vaud'
  },
  {
    countryKey: 'CH',
    value: 'VS',
    label: 'Valais'
  },
  {
    countryKey: 'CH',
    value: 'ZG',
    label: 'Zug'
  },
  {
    countryKey: 'CH',
    value: 'ZH',
    label: 'Zurich'
  },
  {
    countryKey: 'CL',
    value: '01',
    label: 'I - Iquique'
  },
  {
    countryKey: 'CL',
    value: '02',
    label: 'II - Antofagasta'
  },
  {
    countryKey: 'CL',
    value: '03',
    label: 'III - Copiapo'
  },
  {
    countryKey: 'CL',
    value: '04',
    label: 'IV - La Serena'
  },
  {
    countryKey: 'CL',
    value: '05',
    label: 'V - Valparaiso'
  },
  {
    countryKey: 'CL',
    value: '06',
    label: 'VI - Rancagua'
  },
  {
    countryKey: 'CL',
    value: '07',
    label: 'VII - Talca'
  },
  {
    countryKey: 'CL',
    value: '08',
    label: 'VIII - Concepcion'
  },
  {
    countryKey: 'CL',
    value: '09',
    label: 'IX - Temuco'
  },
  {
    countryKey: 'CL',
    value: '10',
    label: 'X - Puerto Montt'
  },
  {
    countryKey: 'CL',
    value: '11',
    label: 'XI - Coyhaique'
  },
  {
    countryKey: 'CL',
    value: '12',
    label: 'XII - Punta Arenas'
  },
  {
    countryKey: 'CL',
    value: '13',
    label: 'RM - Santiago'
  },
  {
    countryKey: 'CL',
    value: '16',
    label: 'Araucania'
  },
  {
    countryKey: 'CN',
    value: '010',
    label: 'Beijing'
  },
  {
    countryKey: 'CN',
    value: '020',
    label: 'Shanghai'
  },
  {
    countryKey: 'CN',
    value: '030',
    label: 'Tianjin'
  },
  {
    countryKey: 'CN',
    value: '040',
    label: 'Nei Mongol'
  },
  {
    countryKey: 'CN',
    value: '050',
    label: 'Shanxi'
  },
  {
    countryKey: 'CN',
    value: '060',
    label: 'Hebei'
  },
  {
    countryKey: 'CN',
    value: '070',
    label: 'Liaoning'
  },
  {
    countryKey: 'CN',
    value: '080',
    label: 'Jilin'
  },
  {
    countryKey: 'CN',
    value: '090',
    label: 'Heilongjiang'
  },
  {
    countryKey: 'CN',
    value: '100',
    label: 'Jiangsu'
  },
  {
    countryKey: 'CN',
    value: '110',
    label: 'Anhui'
  },
  {
    countryKey: 'CN',
    value: '120',
    label: 'Shandong'
  },
  {
    countryKey: 'CN',
    value: '130',
    label: 'Zhejiang'
  },
  {
    countryKey: 'CN',
    value: '140',
    label: 'Jiangxi'
  },
  {
    countryKey: 'CN',
    value: '150',
    label: 'Fujian'
  },
  {
    countryKey: 'CN',
    value: '160',
    label: 'Hunan'
  },
  {
    countryKey: 'CN',
    value: '170',
    label: 'Hubei'
  },
  {
    countryKey: 'CN',
    value: '180',
    label: 'Henan'
  },
  {
    countryKey: 'CN',
    value: '190',
    label: 'Guangdong'
  },
  {
    countryKey: 'CN',
    value: '200',
    label: 'Hainan'
  },
  {
    countryKey: 'CN',
    value: '210',
    label: 'Guangxi'
  },
  {
    countryKey: 'CN',
    value: '220',
    label: 'Guizhou'
  },
  {
    countryKey: 'CN',
    value: '230',
    label: 'Sichuan'
  },
  {
    countryKey: 'CN',
    value: '240',
    label: 'Yunnan'
  },
  {
    countryKey: 'CN',
    value: '250',
    label: 'Shaanxi'
  },
  {
    countryKey: 'CN',
    value: '260',
    label: 'Gansu'
  },
  {
    countryKey: 'CN',
    value: '270',
    label: 'Ningxia'
  },
  {
    countryKey: 'CN',
    value: '280',
    label: 'Qinghai'
  },
  {
    countryKey: 'CN',
    value: '290',
    label: 'Xinjiang'
  },
  {
    countryKey: 'CN',
    value: '300',
    label: 'Xizang'
  },
  {
    countryKey: 'CN',
    value: '320',
    label: 'Chong Qing'
  },
  {
    countryKey: 'CO',
    value: '05',
    label: 'ANTIOQUIA'
  },
  {
    countryKey: 'CO',
    value: '08',
    label: 'ATLANTICO'
  },
  {
    countryKey: 'CO',
    value: '11',
    label: 'BOGOTA'
  },
  {
    countryKey: 'CO',
    value: '13',
    label: 'BOLIVAR'
  },
  {
    countryKey: 'CO',
    value: '15',
    label: 'BOYACA'
  },
  {
    countryKey: 'CO',
    value: '17',
    label: 'CALDAS'
  },
  {
    countryKey: 'CO',
    value: '18',
    label: 'CAQUETA'
  },
  {
    countryKey: 'CO',
    value: '19',
    label: 'CAUCA'
  },
  {
    countryKey: 'CO',
    value: '20',
    label: 'CESAR'
  },
  {
    countryKey: 'CO',
    value: '23',
    label: 'CORDOBA'
  },
  {
    countryKey: 'CO',
    value: '25',
    label: 'CUNDINAMARCA'
  },
  {
    countryKey: 'CO',
    value: '27',
    label: 'CHOCO'
  },
  {
    countryKey: 'CO',
    value: '41',
    label: 'HUILA'
  },
  {
    countryKey: 'CO',
    value: '44',
    label: 'LA GUAJIRA'
  },
  {
    countryKey: 'CO',
    value: '47',
    label: 'MAGDALENA'
  },
  {
    countryKey: 'CO',
    value: '50',
    label: 'META'
  },
  {
    countryKey: 'CO',
    value: '52',
    label: 'NARINO'
  },
  {
    countryKey: 'CO',
    value: '54',
    label: 'NORTE SANTANDER'
  },
  {
    countryKey: 'CO',
    value: '63',
    label: 'QUINDIO'
  },
  {
    countryKey: 'CO',
    value: '66',
    label: 'RISARALDA'
  },
  {
    countryKey: 'CO',
    value: '68',
    label: 'SANTANDER'
  },
  {
    countryKey: 'CO',
    value: '70',
    label: 'SUCRE'
  },
  {
    countryKey: 'CO',
    value: '73',
    label: 'TOLIMA'
  },
  {
    countryKey: 'CO',
    value: '76',
    label: 'VALLE'
  },
  {
    countryKey: 'CO',
    value: '81',
    label: 'ARAUCA'
  },
  {
    countryKey: 'CO',
    value: '85',
    label: 'CASANARE'
  },
  {
    countryKey: 'CO',
    value: '86',
    label: 'PUTUMAYO'
  },
  {
    countryKey: 'CO',
    value: '88',
    label: 'SAN ANDRES'
  },
  {
    countryKey: 'CO',
    value: '91',
    label: 'AMAZONAS'
  },
  {
    countryKey: 'CO',
    value: '94',
    label: 'GUAINIA'
  },
  {
    countryKey: 'CO',
    value: '95',
    label: 'GUAVIARE'
  },
  {
    countryKey: 'CO',
    value: '97',
    label: 'VAUPES'
  },
  {
    countryKey: 'CO',
    value: '99',
    label: 'VICHADA'
  },
  {
    countryKey: 'CR',
    value: '1',
    label: 'San Jose'
  },
  {
    countryKey: 'CR',
    value: '2',
    label: 'Alajuela'
  },
  {
    countryKey: 'CR',
    value: '3',
    label: 'Cartago'
  },
  {
    countryKey: 'CR',
    value: '4',
    label: 'Heredia'
  },
  {
    countryKey: 'CR',
    value: '5',
    label: 'Guanacaste'
  },
  {
    countryKey: 'CR',
    value: '6',
    label: 'Puntarenas'
  },
  {
    countryKey: 'CR',
    value: '7',
    label: 'Limón'
  },
  {
    countryKey: 'CY',
    value: 'CN',
    label: 'Northern Cyprus'
  },
  {
    countryKey: 'CY',
    value: 'CS',
    label: 'Southern Cyprus'
  },
  {
    countryKey: 'CZ',
    value: '11',
    label: 'Praha'
  },
  {
    countryKey: 'CZ',
    value: '21',
    label: 'Stredocesky'
  },
  {
    countryKey: 'CZ',
    value: '31',
    label: 'Jihocesky'
  },
  {
    countryKey: 'CZ',
    value: '32',
    label: 'Plzensky'
  },
  {
    countryKey: 'CZ',
    value: '41',
    label: 'Karlovarsky'
  },
  {
    countryKey: 'CZ',
    value: '42',
    label: 'Ustecky'
  },
  {
    countryKey: 'CZ',
    value: '51',
    label: 'Liberecky'
  },
  {
    countryKey: 'CZ',
    value: '52',
    label: 'Kralovehradecky'
  },
  {
    countryKey: 'CZ',
    value: '53',
    label: 'Pardubicky'
  },
  {
    countryKey: 'CZ',
    value: '61',
    label: 'Vysocina'
  },
  {
    countryKey: 'CZ',
    value: '62',
    label: 'Jihomoravsky'
  },
  {
    countryKey: 'CZ',
    value: '63',
    label: 'Vysocina'
  },
  {
    countryKey: 'CZ',
    value: '64',
    label: 'Jihomoravsky'
  },
  {
    countryKey: 'CZ',
    value: '71',
    label: 'Olomoucky'
  },
  {
    countryKey: 'CZ',
    value: '72',
    label: 'Zlinsky'
  },
  {
    countryKey: 'CZ',
    value: '81',
    label: 'Moravskoslezsky'
  },
  {
    countryKey: 'CZ',
    value: 'BME',
    label: 'Bohemia Meridional'
  },
  {
    countryKey: 'DE',
    value: '01',
    label: 'Schleswig-Holstein'
  },
  {
    countryKey: 'DE',
    value: '02',
    label: 'Hamburg'
  },
  {
    countryKey: 'DE',
    value: '03',
    label: 'Lower Saxony'
  },
  {
    countryKey: 'DE',
    value: '04',
    label: 'Bremen'
  },
  {
    countryKey: 'DE',
    value: '05',
    label: 'Nrth Rhine Westfalia'
  },
  {
    countryKey: 'DE',
    value: '06',
    label: 'Hessen'
  },
  {
    countryKey: 'DE',
    value: '07',
    label: 'Rhineland Palatinate'
  },
  {
    countryKey: 'DE',
    value: '08',
    label: 'Baden-Wurttemberg'
  },
  {
    countryKey: 'DE',
    value: '09',
    label: 'Bavaria'
  },
  {
    countryKey: 'DE',
    value: '10',
    label: 'Saarland'
  },
  {
    countryKey: 'DE',
    value: '11',
    label: 'Berlin'
  },
  {
    countryKey: 'DE',
    value: '12',
    label: 'Brandenburg'
  },
  {
    countryKey: 'DE',
    value: '13.',
    label: 'Mecklenburg-Vorpomm.'
  },
  {
    countryKey: 'DE',
    value: '14',
    label: 'Saxony'
  },
  {
    countryKey: 'DE',
    value: '15',
    label: 'Saxony-Anhalt'
  },
  {
    countryKey: 'DE',
    value: '16',
    label: 'Thuringia'
  },
  {
    countryKey: 'DE',
    value: '17',
    label: 'Munchen'
  },
  {
    countryKey: 'DK',
    value: '001',
    label: 'Copenhagen'
  },
  {
    countryKey: 'DK',
    value: '002',
    label: 'Aarhus County'
  },
  {
    countryKey: 'DK',
    value: '003',
    label: 'Bornholm County'
  },
  {
    countryKey: 'DK',
    value: '004',
    label: 'Frederiksborg County'
  },
  {
    countryKey: 'DK',
    value: '005',
    label: 'Funen County'
  },
  {
    countryKey: 'DK',
    value: '006',
    label: 'Copenhagen County'
  },
  {
    countryKey: 'DK',
    value: '007',
    label: 'North Jutland County'
  },
  {
    countryKey: 'DK',
    value: '008',
    label: 'Ribe County'
  },
  {
    countryKey: 'DK',
    value: '009',
    label: 'Ringkjoebing County'
  },
  {
    countryKey: 'DK',
    value: '010',
    label: 'Roskilde County'
  },
  {
    countryKey: 'DK',
    value: '011',
    label: 'South Jutland County'
  },
  {
    countryKey: 'DK',
    value: '012',
    label: 'Storstroem County'
  },
  {
    countryKey: 'DK',
    value: '013',
    label: 'Vejle County'
  },
  {
    countryKey: 'DK',
    value: '014',
    label: 'West Zealand County'
  },
  {
    countryKey: 'DK',
    value: '015',
    label: 'Viborg County'
  },
  {
    countryKey: 'DK',
    value: '016',
    label: 'Greenland'
  },
  {
    countryKey: 'DK',
    value: '018',
    label: 'SOUTHERN DINAMARCA'
  },
  {
    countryKey: 'DO',
    value: '01',
    label: 'Santo Domingo'
  },
  {
    countryKey: 'EC',
    value: '01',
    label: 'GUAYAQUIL'
  },
  {
    countryKey: 'ES',
    value: '01',
    label: 'Alava'
  },
  {
    countryKey: 'ES',
    value: '02',
    label: 'Albacete'
  },
  {
    countryKey: 'ES',
    value: '03',
    label: 'Alicante'
  },
  {
    countryKey: 'ES',
    value: '04',
    label: 'Almeria'
  },
  {
    countryKey: 'ES',
    value: '05',
    label: 'Avila'
  },
  {
    countryKey: 'ES',
    value: '06',
    label: 'Badajoz'
  },
  {
    countryKey: 'ES',
    value: '07',
    label: 'Baleares'
  },
  {
    countryKey: 'ES',
    value: '08',
    label: 'Barcelona'
  },
  {
    countryKey: 'ES',
    value: '09',
    label: 'Burgos'
  },
  {
    countryKey: 'ES',
    value: '10',
    label: 'Caceres'
  },
  {
    countryKey: 'ES',
    value: '11',
    label: 'Cadiz'
  },
  {
    countryKey: 'ES',
    value: '12',
    label: 'Castellon'
  },
  {
    countryKey: 'ES',
    value: '13',
    label: 'Ciudad Real'
  },
  {
    countryKey: 'ES',
    value: '14',
    label: 'Cordoba'
  },
  {
    countryKey: 'ES',
    value: '15',
    label: 'La Coruna'
  },
  {
    countryKey: 'ES',
    value: '16',
    label: 'Cuenca'
  },
  {
    countryKey: 'ES',
    value: '17',
    label: 'Gerona'
  },
  {
    countryKey: 'ES',
    value: '18',
    label: 'Granada'
  },
  {
    countryKey: 'ES',
    value: '19',
    label: 'Guadalajara'
  },
  {
    countryKey: 'ES',
    value: '20',
    label: 'Guipuzcoa'
  },
  {
    countryKey: 'ES',
    value: '21',
    label: 'Huelva'
  },
  {
    countryKey: 'ES',
    value: '22',
    label: 'Huesca'
  },
  {
    countryKey: 'ES',
    value: '23',
    label: 'Jaen'
  },
  {
    countryKey: 'ES',
    value: '24',
    label: 'Leon'
  },
  {
    countryKey: 'ES',
    value: '25',
    label: 'Lerida'
  },
  {
    countryKey: 'ES',
    value: '26',
    label: 'La Rioja'
  },
  {
    countryKey: 'ES',
    value: '27',
    label: 'Lugo'
  },
  {
    countryKey: 'ES',
    value: '28',
    label: 'Madrid'
  },
  {
    countryKey: 'ES',
    value: '29',
    label: 'Malaga'
  },
  {
    countryKey: 'ES',
    value: '30',
    label: 'Murcia'
  },
  {
    countryKey: 'ES',
    value: '31',
    label: 'Navarra'
  },
  {
    countryKey: 'ES',
    value: '32',
    label: 'Orense'
  },
  {
    countryKey: 'ES',
    value: '33',
    label: 'Asturias'
  },
  {
    countryKey: 'ES',
    value: '34',
    label: 'Palencia'
  },
  {
    countryKey: 'ES',
    value: '35',
    label: 'Las Palmas'
  },
  {
    countryKey: 'ES',
    value: '36',
    label: 'Pontevedra'
  },
  {
    countryKey: 'ES',
    value: '37',
    label: 'Salamanca'
  },
  {
    countryKey: 'ES',
    value: '38',
    label: 'Sta. Cruz Tenerife'
  },
  {
    countryKey: 'ES',
    value: '39',
    label: 'Cantabria'
  },
  {
    countryKey: 'ES',
    value: '40',
    label: 'Segovia'
  },
  {
    countryKey: 'ES',
    value: '41',
    label: 'Sevilla'
  },
  {
    countryKey: 'ES',
    value: '42',
    label: 'Soria'
  },
  {
    countryKey: 'ES',
    value: '43',
    label: 'Tarragona'
  },
  {
    countryKey: 'ES',
    value: '44',
    label: 'Teruel'
  },
  {
    countryKey: 'ES',
    value: '45',
    label: 'Toledo'
  },
  {
    countryKey: 'ES',
    value: '46',
    label: 'Valencia'
  },
  {
    countryKey: 'ES',
    value: '47',
    label: 'Valladolid'
  },
  {
    countryKey: 'ES',
    value: '48',
    label: 'Vizcaya'
  },
  {
    countryKey: 'ES',
    value: '49',
    label: 'Zamora'
  },
  {
    countryKey: 'ES',
    value: '50',
    label: 'Zaragoza'
  },
  {
    countryKey: 'FI',
    value: '001',
    label: 'Ahvenanmaa'
  },
  {
    countryKey: 'FI',
    value: '002',
    label: 'Southern Finnland'
  },
  {
    countryKey: 'FI',
    value: '003',
    label: 'Eastern Finnland'
  },
  {
    countryKey: 'FI',
    value: '004',
    label: 'Lappi'
  },
  {
    countryKey: 'FI',
    value: '005',
    label: 'Western Finnland'
  },
  {
    countryKey: 'FI',
    value: '006',
    label: 'Oulu'
  },
  {
    countryKey: 'FR',
    value: '01',
    label: 'Ain'
  },
  {
    countryKey: 'FR',
    value: '02',
    label: 'Aisne'
  },
  {
    countryKey: 'FR',
    value: '03',
    label: 'Allier'
  },
  {
    countryKey: 'FR',
    value: '04',
    label: 'Alpes (Hte-Provence)'
  },
  {
    countryKey: 'FR',
    value: '05',
    label: 'Alpes (Hautes)'
  },
  {
    countryKey: 'FR',
    value: '06',
    label: 'Alpes-Maritimes'
  },
  {
    countryKey: 'FR',
    value: '07',
    label: 'Ardeche'
  },
  {
    countryKey: 'FR',
    value: '08',
    label: 'Ardennes'
  },
  {
    countryKey: 'FR',
    value: '09',
    label: 'Ariege'
  },
  {
    countryKey: 'FR',
    value: '10',
    label: 'Aube'
  },
  {
    countryKey: 'FR',
    value: '11',
    label: 'Aude'
  },
  {
    countryKey: 'FR',
    value: '12',
    label: 'Aveyron'
  },
  {
    countryKey: 'FR',
    value: '13',
    label: 'Bouches-du-Rhone'
  },
  {
    countryKey: 'FR',
    value: '14',
    label: 'Calvados'
  },
  {
    countryKey: 'FR',
    value: '15',
    label: 'Cantal'
  },
  {
    countryKey: 'FR',
    value: '16',
    label: 'Charente'
  },
  {
    countryKey: 'FR',
    value: '17',
    label: 'Charente-Maritime'
  },
  {
    countryKey: 'FR',
    value: '18',
    label: 'Cher'
  },
  {
    countryKey: 'FR',
    value: '19',
    label: 'Correze'
  },
  {
    countryKey: 'FR',
    value: '21',
    label: "Cote-d'Or"
  },
  {
    countryKey: 'FR',
    value: '22',
    label: "Cotes-d'Armor"
  },
  {
    countryKey: 'FR',
    value: '23',
    label: 'Creuse'
  },
  {
    countryKey: 'FR',
    value: '24',
    label: 'Dordogne'
  },
  {
    countryKey: 'FR',
    value: '25',
    label: 'Doubs'
  },
  {
    countryKey: 'FR',
    value: '26',
    label: 'Drome'
  },
  {
    countryKey: 'FR',
    value: '27',
    label: 'Eure'
  },
  {
    countryKey: 'FR',
    value: '28',
    label: 'Eure-et-Loir'
  },
  {
    countryKey: 'FR',
    value: '29',
    label: 'Finistere'
  },
  {
    countryKey: 'FR',
    value: '2A',
    label: 'Corse-du-Sud'
  },
  {
    countryKey: 'FR',
    value: '2B',
    label: 'Corse-du-Nord'
  },
  {
    countryKey: 'FR',
    value: '30',
    label: 'Gard'
  },
  {
    countryKey: 'FR',
    value: '31',
    label: 'Garonne (Haute)'
  },
  {
    countryKey: 'FR',
    value: 'Gers32',
    label: 'Gers'
  },
  {
    countryKey: 'FR',
    value: '33',
    label: 'Gironde'
  },
  {
    countryKey: 'FR',
    value: '34',
    label: 'Herault'
  },
  {
    countryKey: 'FR',
    value: '35',
    label: 'Ille-et-Vilaine'
  },
  {
    countryKey: 'FR',
    value: '36',
    label: 'Indre'
  },
  {
    countryKey: 'FR',
    value: '37',
    label: 'Indre-et-Loire'
  },
  {
    countryKey: 'FR',
    value: '38',
    label: 'Isere'
  },
  {
    countryKey: 'FR',
    value: '39',
    label: 'Jura'
  },
  {
    countryKey: 'FR',
    value: '40',
    label: 'Landes'
  },
  {
    countryKey: 'FR',
    value: '41',
    label: 'Loir-et-Cher'
  },
  {
    countryKey: 'FR',
    value: '42',
    label: 'Loire'
  },
  {
    countryKey: 'FR',
    value: '43',
    label: 'Loire (Haute)'
  },
  {
    countryKey: 'FR',
    value: '44',
    label: 'Loire-Atlantique'
  },
  {
    countryKey: 'FR',
    value: '45',
    label: 'Loiret'
  },
  {
    countryKey: 'FR',
    value: '46',
    label: 'Lot'
  },
  {
    countryKey: 'FR',
    value: '47',
    label: 'Lot-et-Garonne'
  },
  {
    countryKey: 'FR',
    value: '48',
    label: 'Lozere'
  },
  {
    countryKey: 'FR',
    value: '49',
    label: 'Maine-et-Loire'
  },
  {
    countryKey: 'FR',
    value: '50',
    label: 'Manche'
  },
  {
    countryKey: 'FR',
    value: '51',
    label: 'Marne'
  },
  {
    countryKey: 'FR',
    value: '52',
    label: 'Marne (Haute)'
  },
  {
    countryKey: 'FR',
    value: '53',
    label: 'Mayenne'
  },
  {
    countryKey: 'FR',
    value: '54',
    label: 'Meurthe-et-Moselle'
  },
  {
    countryKey: 'FR',
    value: '55',
    label: 'Meuse'
  },
  {
    countryKey: 'FR',
    value: '56',
    label: 'Morbihan'
  },
  {
    countryKey: 'FR',
    value: '57',
    label: 'Moselle'
  },
  {
    countryKey: 'FR',
    value: '58',
    label: 'Nievre'
  },
  {
    countryKey: 'FR',
    value: '59',
    label: 'Nord'
  },
  {
    countryKey: 'FR',
    value: '60',
    label: 'Oise'
  },
  {
    countryKey: 'FR',
    value: '61',
    label: 'Orne'
  },
  {
    countryKey: 'FR',
    value: '62',
    label: 'Pas-de-Calais'
  },
  {
    countryKey: 'FR',
    value: '63',
    label: 'Puy-de-Dome'
  },
  {
    countryKey: 'FR',
    value: '64',
    label: 'Pyrenees-Atlantiques'
  },
  {
    countryKey: 'FR',
    value: '65',
    label: 'Pyrenees (Hautes)'
  },
  {
    countryKey: 'FR',
    value: '66',
    label: 'Pyrenees-Orientales'
  },
  {
    countryKey: 'FR',
    value: '67',
    label: 'Bas-Rhin'
  },
  {
    countryKey: 'FR',
    value: '68',
    label: 'Haut-Rhin'
  },
  {
    countryKey: 'FR',
    value: '69',
    label: 'Rhone'
  },
  {
    countryKey: 'FR',
    value: '70',
    label: 'Saone (Haute)'
  },
  {
    countryKey: 'FR',
    value: '71',
    label: 'Saone-et-Loire'
  },
  {
    countryKey: 'FR',
    value: '72',
    label: 'Sarthe'
  },
  {
    countryKey: 'FR',
    value: '73',
    label: 'Savoie'
  },
  {
    countryKey: 'FR',
    value: '74',
    label: 'Savoie (Haute)'
  },
  {
    countryKey: 'FR',
    value: '75',
    label: 'Paris'
  },
  {
    countryKey: 'FR',
    value: '76',
    label: 'Seine-Maritime'
  },
  {
    countryKey: 'FR',
    value: '77',
    label: 'Seine-et-Marne'
  },
  {
    countryKey: 'FR',
    value: '78',
    label: 'Yvelines'
  },
  {
    countryKey: 'FR',
    value: '79',
    label: 'Sevres (Deux)'
  },
  {
    countryKey: 'FR',
    value: '80',
    label: 'Somme'
  },
  {
    countryKey: 'FR',
    value: '81',
    label: 'Tarn'
  },
  {
    countryKey: 'FR',
    value: '82',
    label: 'Tarn-et-Garonne'
  },
  {
    countryKey: 'FR',
    value: '83',
    label: 'Var'
  },
  {
    countryKey: 'FR',
    value: '84',
    label: 'Vaucluse'
  },
  {
    countryKey: 'FR',
    value: '85',
    label: 'Vendee'
  },
  {
    countryKey: 'FR',
    value: '86',
    label: 'Vienne'
  },
  {
    countryKey: 'FR',
    value: '87',
    label: 'Vienne (Haute)'
  },
  {
    countryKey: 'FR',
    value: '88',
    label: 'Vosges'
  },
  {
    countryKey: 'FR',
    value: '89',
    label: 'Yonne'
  },
  {
    countryKey: 'FR',
    value: '90',
    label: 'Territ.-de-Belfort'
  },
  {
    countryKey: 'FR',
    value: '91',
    label: 'Essonne'
  },
  {
    countryKey: 'FR',
    value: '92',
    label: 'Hauts-de-Seine'
  },
  {
    countryKey: 'FR',
    value: '93',
    label: 'Seine-Saint-Denis'
  },
  {
    countryKey: 'FR',
    value: '94',
    label: 'Val-de-Marne'
  },
  {
    countryKey: 'FR',
    value: '95',
    label: "Val-d'Oise"
  },
  {
    countryKey: 'FR',
    value: '97',
    label: 'D.O.M.-T.O.M.'
  },
  {
    countryKey: 'FR',
    value: '971',
    label: 'Guadeloupe'
  },
  {
    countryKey: 'FR',
    value: '972',
    label: 'Martinique'
  },
  {
    countryKey: 'FR',
    value: '973',
    label: 'Guyane'
  },
  {
    countryKey: 'FR',
    value: '974',
    label: 'Reunion'
  },
  {
    countryKey: 'FR',
    value: '975',
    label: 'Saint-Pierre-et-Miq.'
  },
  {
    countryKey: 'FR',
    value: '976',
    label: 'Wallis-et-Futuna'
  },
  {
    countryKey: 'FR',
    value: '99',
    label: 'Hors-France'
  },
  {
    countryKey: 'GB',
    value: 'AB',
    label: 'Aberdeenshire'
  },
  {
    countryKey: 'GB',
    value: 'AG',
    label: 'Argyllshire'
  },
  {
    countryKey: 'GB',
    value: 'AL',
    label: 'Anglesey'
  },
  {
    countryKey: 'GB',
    value: 'AM',
    label: 'Armagh'
  },
  {
    countryKey: 'GB',
    value: 'AN',
    label: 'Angus/Forfarshire'
  },
  {
    countryKey: 'GB',
    value: 'AT',
    label: 'Antrim'
  },
  {
    countryKey: 'GB',
    value: 'AY',
    label: 'Ayrshire'
  },
  {
    countryKey: 'GB',
    value: 'BE',
    label: 'Bedfordshire'
  },
  {
    countryKey: 'GB',
    value: 'BF',
    label: 'Banffshire'
  },
  {
    countryKey: 'GB',
    value: 'BK',
    label: 'Berkshire'
  },
  {
    countryKey: 'GB',
    value: 'BR',
    label: 'Brecknockshire'
  },
  {
    countryKey: 'GB',
    value: 'BS',
    label: 'Bath&NthEstSomerset'
  },
  {
    countryKey: 'GB',
    value: 'BT',
    label: 'Buteshire'
  },
  {
    countryKey: 'GB',
    value: 'BU',
    label: 'Buckinghamshire'
  },
  {
    countryKey: 'GB',
    value: 'BW',
    label: 'Berwickshire'
  },
  {
    countryKey: 'GB',
    value: 'CA',
    label: 'Cambridgeshire'
  },
  {
    countryKey: 'GB',
    value: 'CB',
    label: 'Carmarthenshire'
  },
  {
    countryKey: 'GB',
    value: 'CD',
    label: 'Cardiganshire'
  },
  {
    countryKey: 'GB',
    value: 'CF',
    label: 'Caernarfonshire'
  },
  {
    countryKey: 'GB',
    value: 'CH',
    label: 'Cheshire'
  },
  {
    countryKey: 'GB',
    value: 'CM',
    label: 'Cromartyshire'
  },
  {
    countryKey: 'GB',
    value: 'CN',
    label: 'Clackmannanshire'
  },
  {
    countryKey: 'GB',
    value: 'CO',
    label: 'Cornwall'
  },
  {
    countryKey: 'GB',
    value: 'CT',
    label: 'Caithness'
  },
  {
    countryKey: 'GB',
    value: 'CU',
    label: 'Cumberland'
  },
  {
    countryKey: 'GB',
    value: 'DB',
    label: 'Derbyshire'
  },
  {
    countryKey: 'GB',
    value: 'DD',
    label: 'Denbighshire'
  },
  {
    countryKey: 'GB',
    value: 'DF',
    label: 'Dumfriesshire'
  },
  {
    countryKey: 'GB',
    value: 'DN',
    label: 'Down'
  },
  {
    countryKey: 'GB',
    value: 'DO',
    label: 'Dorset'
  },
  {
    countryKey: 'GB',
    value: 'DT',
    label: 'Dunbartonshire'
  },
  {
    countryKey: 'GB',
    value: 'DU',
    label: 'Durham'
  },
  {
    countryKey: 'GB',
    value: 'DV',
    label: 'Devon'
  },
  {
    countryKey: 'GB',
    value: 'EL',
    label: 'East Lothian'
  },
  {
    countryKey: 'GB',
    value: 'ES',
    label: 'Essex'
  },
  {
    countryKey: 'GB',
    value: 'FI',
    label: 'Fife'
  },
  {
    countryKey: 'GB',
    value: 'FL',
    label: 'Flintshire'
  },
  {
    countryKey: 'GB',
    value: 'FM',
    label: 'Fermanagh'
  },
  {
    countryKey: 'GB',
    value: 'GL',
    label: 'Gloucestershire'
  },
  {
    countryKey: 'GB',
    value: 'HA',
    label: 'Hampshire'
  },
  {
    countryKey: 'GB',
    value: 'HM',
    label: 'Herm'
  },
  {
    countryKey: 'GB',
    value: 'HT',
    label: 'Hertfordshire'
  },
  {
    countryKey: 'GB',
    value: 'HU',
    label: 'Huntingdonshire'
  },
  {
    countryKey: 'GB',
    value: 'HW.',
    label: 'Hereford and Worcs.'
  },
  {
    countryKey: 'GB',
    value: 'IN',
    label: 'Invernesshire'
  },
  {
    countryKey: 'GB',
    value: 'IW',
    label: 'Isle of Wight'
  },
  {
    countryKey: 'GB',
    value: 'JY',
    label: 'Jersey'
  },
  {
    countryKey: 'GB',
    value: 'KE',
    label: 'Kent'
  },
  {
    countryKey: 'GB',
    value: 'KI',
    label: 'Kincardineshire'
  },
  {
    countryKey: 'GB',
    value: 'KK',
    label: 'Kirkcudbrightshire'
  },
  {
    countryKey: 'GB',
    value: 'KN',
    label: 'Kinross-shire'
  },
  {
    countryKey: 'GB',
    value: 'LA',
    label: 'Lancashire'
  },
  {
    countryKey: 'GB',
    value: 'LD',
    label: 'Londonderry'
  },
  {
    countryKey: 'GB',
    value: 'LE',
    label: 'Leicestershire'
  },
  {
    countryKey: 'GB',
    value: 'LI',
    label: 'Lincolnshire'
  },
  {
    countryKey: 'GB',
    value: 'LN',
    label: 'Lanarkshire'
  },
  {
    countryKey: 'GB',
    value: 'LS',
    label: 'Les Minquires'
  },
  {
    countryKey: 'GB',
    value: 'MD',
    label: 'Midlothian'
  },
  {
    countryKey: 'GB',
    value: 'ME',
    label: 'Merioneth'
  },
  {
    countryKey: 'GB',
    value: 'MG',
    label: 'Mid Glamorgan'
  },
  {
    countryKey: 'GB',
    value: 'MM',
    label: 'Monmouthshire'
  },
  {
    countryKey: 'GB',
    value: 'MR',
    label: 'Morayshire'
  },
  {
    countryKey: 'GB',
    value: 'MT',
    label: 'Montgomeryshire'
  },
  {
    countryKey: 'GB',
    value: 'MX',
    label: 'Middlesex'
  },
  {
    countryKey: 'GB',
    value: 'NH',
    label: 'Northamptonshire'
  },
  {
    countryKey: 'GB',
    value: 'NK',
    label: 'Norfolk'
  },
  {
    countryKey: 'GB',
    value: 'NR',
    label: 'Nairnshire'
  },
  {
    countryKey: 'GB',
    value: 'NT',
    label: 'Nottinghamshire'
  },
  {
    countryKey: 'GB',
    value: 'NU',
    label: 'Northumberland'
  },
  {
    countryKey: 'GB',
    value: 'OR',
    label: 'Orkney'
  },
  {
    countryKey: 'GB',
    value: 'OX',
    label: 'Oxfordshire'
  },
  {
    countryKey: 'GB',
    value: 'PE',
    label: 'Peeblesshire'
  },
  {
    countryKey: 'GB',
    value: 'PM',
    label: 'Pembrokeshire'
  },
  {
    countryKey: 'GB',
    value: 'PR',
    label: 'Perthshire'
  },
  {
    countryKey: 'GB',
    value: 'RA',
    label: 'Radnorshire'
  },
  {
    countryKey: 'GB',
    value: 'RE',
    label: 'Renfrewshire'
  },
  {
    countryKey: 'GB',
    value: 'RO',
    label: 'Ross-shire'
  },
  {
    countryKey: 'GB',
    value: 'RU',
    label: 'Rutland'
  },
  {
    countryKey: 'GB',
    value: 'RX',
    label: 'Roxburghshire'
  },
  {
    countryKey: 'GB',
    value: 'SA',
    label: 'Sark'
  },
  {
    countryKey: 'GB',
    value: 'SE',
    label: 'East Sussex'
  },
  {
    countryKey: 'GB',
    value: 'SF',
    label: 'Selkirkshire'
  },
  {
    countryKey: 'GB',
    value: 'SG',
    label: 'South Glamorgan'
  },
  {
    countryKey: 'GB',
    value: 'SH',
    label: 'Shropshire'
  },
  {
    countryKey: 'GB',
    value: 'SK',
    label: 'Suffolk'
  },
  {
    countryKey: 'GB',
    value: 'SL',
    label: 'Shetland'
  },
  {
    countryKey: 'GB',
    value: 'SO',
    label: 'Somerset'
  },
  {
    countryKey: 'GB',
    value: 'ST',
    label: 'Staffordshire'
  },
  {
    countryKey: 'GB',
    value: 'SU',
    label: 'Sutherland'
  },
  {
    countryKey: 'GB',
    value: 'SV',
    label: 'Stirlingshire'
  },
  {
    countryKey: 'GB',
    value: 'SW',
    label: 'West Sussex'
  },
  {
    countryKey: 'GB',
    value: 'SY',
    label: 'Surrey'
  },
  {
    countryKey: 'GB',
    value: 'TY',
    label: 'Tyrone'
  },
  {
    countryKey: 'GB',
    value: 'WA',
    label: 'Warwickshire'
  },
  {
    countryKey: 'GB',
    value: 'WC',
    label: 'Worcestershire'
  },
  {
    countryKey: 'GB',
    value: 'WE',
    label: 'Westmorland'
  },
  {
    countryKey: 'GB',
    value: 'WG',
    label: 'West Glamorgan'
  },
  {
    countryKey: 'GB',
    value: 'WI',
    label: 'Wiltshire'
  },
  {
    countryKey: 'GB',
    value: 'WK',
    label: 'West Lothian'
  },
  {
    countryKey: 'GB',
    value: 'WT',
    label: 'Wigtownshire'
  },
  {
    countryKey: 'GB',
    value: 'YN',
    label: 'North Yorkshire'
  },
  {
    countryKey: 'GB',
    value: 'YS',
    label: 'South Yorkshire'
  },
  {
    countryKey: 'GB',
    value: 'YW',
    label: 'West Yorkshire'
  },
  {
    countryKey: 'GR',
    value: '01',
    label: 'Aitolia kai Akarnan.'
  },
  {
    countryKey: 'GR',
    value: '02',
    label: 'Akhaia'
  },
  {
    countryKey: 'GR',
    value: '03',
    label: 'Argolis'
  },
  {
    countryKey: 'GR',
    value: '04',
    label: 'Arkadhia'
  },
  {
    countryKey: 'GR',
    value: '05',
    label: 'Arta'
  },
  {
    countryKey: 'GR',
    value: '06',
    label: 'Attiki'
  },
  {
    countryKey: 'GR',
    value: '07',
    label: 'Dhodhekanisos'
  },
  {
    countryKey: 'GR',
    value: '08',
    label: 'Dhrama'
  },
  {
    countryKey: 'GR',
    value: '09',
    label: 'Evritania'
  },
  {
    countryKey: 'GR',
    value: '10',
    label: 'Evros'
  },
  {
    countryKey: 'GR',
    value: '11',
    label: 'Evvoia'
  },
  {
    countryKey: 'GR',
    value: '12',
    label: 'Florina'
  },
  {
    countryKey: 'GR',
    value: '13',
    label: 'Fokis'
  },
  {
    countryKey: 'GR',
    value: '14',
    label: 'Fthiotis'
  },
  {
    countryKey: 'GR',
    value: '15',
    label: 'Grevena'
  },
  {
    countryKey: 'GR',
    value: '16',
    label: 'Ilia'
  },
  {
    countryKey: 'GR',
    value: '17',
    label: 'Imathia'
  },
  {
    countryKey: 'GR',
    value: '18',
    label: 'Ioannina'
  },
  {
    countryKey: 'GR',
    value: '19',
    label: 'Iraklion'
  },
  {
    countryKey: 'GR',
    value: '20',
    label: 'Kardhitsa'
  },
  {
    countryKey: 'GR',
    value: '21',
    label: 'Kastoria'
  },
  {
    countryKey: 'GR',
    value: '22',
    label: 'Kavala'
  },
  {
    countryKey: 'GR',
    value: '23',
    label: 'Kefallinia'
  },
  {
    countryKey: 'GR',
    value: '24',
    label: 'Kerkira'
  },
  {
    countryKey: 'GR',
    value: '25',
    label: 'Khalkidhiki'
  },
  {
    countryKey: 'GR',
    value: '26',
    label: 'Khania'
  },
  {
    countryKey: 'GR',
    value: '27',
    label: 'Khios'
  },
  {
    countryKey: 'GR',
    value: '28',
    label: 'Kikladhes'
  },
  {
    countryKey: 'GR',
    value: '29',
    label: 'Kilkis'
  },
  {
    countryKey: 'GR',
    value: '30',
    label: 'Korinthia'
  },
  {
    countryKey: 'GR',
    value: '31',
    label: 'Kozani'
  },
  {
    countryKey: 'GR',
    value: '32',
    label: 'Lakonia'
  },
  {
    countryKey: 'GR',
    value: '33',
    label: 'Larisa'
  },
  {
    countryKey: 'GR',
    value: '34',
    label: 'Lasithi'
  },
  {
    countryKey: 'GR',
    value: '35',
    label: 'Lesvos'
  },
  {
    countryKey: 'GR',
    value: '36',
    label: 'Levkas'
  },
  {
    countryKey: 'GR',
    value: '37',
    label: 'Magnisia'
  },
  {
    countryKey: 'GR',
    value: '38',
    label: 'Messinia'
  },
  {
    countryKey: 'GR',
    value: '39',
    label: 'Pella'
  },
  {
    countryKey: 'GR',
    value: '40',
    label: 'Pieria'
  },
  {
    countryKey: 'GR',
    value: '41',
    label: 'Piraievs'
  },
  {
    countryKey: 'GR',
    value: '42',
    label: 'Preveza'
  },
  {
    countryKey: 'GR',
    value: '43',
    label: 'Rethimni'
  },
  {
    countryKey: 'GR',
    value: '44',
    label: 'Rodhopi'
  },
  {
    countryKey: 'GR',
    value: '45',
    label: 'Samos'
  },
  {
    countryKey: 'GR',
    value: '46',
    label: 'Serrai'
  },
  {
    countryKey: 'GR',
    value: '47',
    label: 'Thesprotia'
  },
  {
    countryKey: 'GR',
    value: '48',
    label: 'Thessaloniki'
  },
  {
    countryKey: 'GR',
    value: '49',
    label: 'Trikala'
  },
  {
    countryKey: 'GR',
    value: '50',
    label: 'Voiotia'
  },
  {
    countryKey: 'GR',
    value: '51',
    label: 'Xanthi'
  },
  {
    countryKey: 'GR',
    value: '52',
    label: 'Zakinthos'
  },
  {
    countryKey: 'GR',
    value: '53',
    label: 'Mount Athos'
  },
  {
    countryKey: 'GT',
    value: '1',
    label: 'GUATEMALA'
  },
  {
    countryKey: 'GT',
    value: '10',
    label: 'SUCHITEPEQUEZ'
  },
  {
    countryKey: 'GT',
    value: '11',
    label: 'RETALHULEU'
  },
  {
    countryKey: 'GT',
    value: '12',
    label: 'SAN MARCOS'
  },
  {
    countryKey: 'GT',
    value: '13',
    label: 'HUEHUETENTANGO'
  },
  {
    countryKey: 'GT',
    value: '14',
    label: 'QUICHE'
  },
  {
    countryKey: 'GT',
    value: '15',
    label: 'BAJA VERAPAZ'
  },
  {
    countryKey: 'GT',
    value: '16',
    label: 'ALTA VERAPAZ'
  },
  {
    countryKey: 'GT',
    value: '17',
    label: 'PETEN'
  },
  {
    countryKey: 'GT',
    value: '18',
    label: 'IZABAL'
  },
  {
    countryKey: 'GT',
    value: '19',
    label: 'ZACAPA'
  },
  {
    countryKey: 'GT',
    value: '2',
    label: 'EL PROGRESO'
  },
  {
    countryKey: 'GT',
    value: '20',
    label: 'CHIQUIMULA'
  },
  {
    countryKey: 'GT',
    value: '21',
    label: 'JALAPA'
  },
  {
    countryKey: 'GT',
    value: '22',
    label: 'JUTIAPA'
  },
  {
    countryKey: 'GT',
    value: '3',
    label: 'SACATEPEQUEZ'
  },
  {
    countryKey: 'GT',
    value: '4',
    label: 'CHIMALTENANGO'
  },
  {
    countryKey: 'GT',
    value: '5',
    label: 'ESCUINTLA'
  },
  {
    countryKey: 'GT',
    value: '6',
    label: 'SANTA ROSA'
  },
  {
    countryKey: 'GT',
    value: '7',
    label: 'SOLOLA'
  },
  {
    countryKey: 'GT',
    value: '8',
    label: 'TOTONICAPAN'
  },
  {
    countryKey: 'GT',
    value: '9',
    label: 'QUETZALTENANGO'
  },
  {
    countryKey: 'HK',
    value: 'HK',
    label: 'Hong Kong Island'
  },
  {
    countryKey: 'HK',
    value: 'KLN',
    label: 'Kowloon'
  },
  {
    countryKey: 'HK',
    value: 'NT',
    label: 'New Territories'
  },
  {
    countryKey: 'HN',
    value: '1',
    label: 'Atlantida'
  },
  {
    countryKey: 'HN',
    value: '10',
    label: 'Intibuca'
  },
  {
    countryKey: 'HN',
    value: '11',
    label: 'Islas de la BA'
  },
  {
    countryKey: 'HN',
    value: '12',
    label: 'La Paz'
  },
  {
    countryKey: 'HN',
    value: '13',
    label: 'Lempira'
  },
  {
    countryKey: 'HN',
    value: '14',
    label: 'Ocotepeque'
  },
  {
    countryKey: 'HN',
    value: '15',
    label: 'Olancho'
  },
  {
    countryKey: 'HN',
    value: '16',
    label: 'Santa Bárbara'
  },
  {
    countryKey: 'HN',
    value: '17',
    label: 'Valle'
  },
  {
    countryKey: 'HN',
    value: '18',
    label: 'Yoro'
  },
  {
    countryKey: 'HN',
    value: '19',
    label: 'NO USAR'
  },
  {
    countryKey: 'HN',
    value: '2',
    label: 'Colón'
  },
  {
    countryKey: 'HN',
    value: '3',
    label: 'Comayagua'
  },
  {
    countryKey: 'HN',
    value: '4',
    label: 'Copan'
  },
  {
    countryKey: 'HN',
    value: '5',
    label: 'Cortes'
  },
  {
    countryKey: 'HN',
    value: '6',
    label: 'Choluteca'
  },
  {
    countryKey: 'HN',
    value: '7',
    label: 'El Paraíso'
  },
  {
    countryKey: 'HN',
    value: '8',
    label: 'Francisco Morazan'
  },
  {
    countryKey: 'HN',
    value: '9',
    label: 'Gracias a Dios'
  },
  {
    countryKey: 'HN',
    value: '11',
    label: 'Islas de la Bahia'
  },
  {
    countryKey: 'HN',
    value: '13',
    label: 'Lempira'
  },
  {
    countryKey: 'HN',
    value: '14',
    label: 'Ocotepeque'
  },
  {
    countryKey: 'HN',
    value: '15',
    label: 'Olancho'
  },
  {
    countryKey: 'HR',
    value: 'A00',
    label: 'Zagrebacka'
  },
  {
    countryKey: 'HR',
    value: 'B00',
    label: 'Krapinsko-zagorska'
  },
  {
    countryKey: 'HR',
    value: 'C00',
    label: 'Sisacko-moslavacka'
  },
  {
    countryKey: 'HR',
    value: 'D00',
    label: 'Karlovacka'
  },
  {
    countryKey: 'HR',
    value: 'E00',
    label: 'Varazdinska'
  },
  {
    countryKey: 'HR',
    value: 'F00',
    label: 'Koprivnicko-krizevac'
  },
  {
    countryKey: 'HR',
    value: 'G00',
    label: 'Bjelovarsko-bilogors'
  },
  {
    countryKey: 'HR',
    value: 'H00',
    label: 'Rijecko-goranska'
  },
  {
    countryKey: 'HR',
    value: 'I00',
    label: 'Licko-senjska'
  },
  {
    countryKey: 'HR',
    value: 'J00',
    label: 'Viroviticko-podravac'
  },
  {
    countryKey: 'HR',
    value: 'K00',
    label: 'Pozesko-slavonska'
  },
  {
    countryKey: 'HR',
    value: 'L00',
    label: 'Slavonskobrodska'
  },
  {
    countryKey: 'HR',
    value: 'M00',
    label: 'Zadarska'
  },
  {
    countryKey: 'HR',
    value: 'N00',
    label: 'Osjecko-baranjska'
  },
  {
    countryKey: 'HR',
    value: 'O00',
    label: 'Sibensko-kninska'
  },
  {
    countryKey: 'HR',
    value: 'P00',
    label: 'Vukovarsko-srijemska'
  },
  {
    countryKey: 'HR',
    value: 'R00',
    label: 'Splitsko-dalmatinska'
  },
  {
    countryKey: 'HR',
    value: 'S00',
    label: 'Istarska'
  },
  {
    countryKey: 'HR',
    value: 'T00',
    label: 'Dubrovacko-neretvans'
  },
  {
    countryKey: 'HR',
    value: 'U00',
    label: 'Medjimurska'
  },
  {
    countryKey: 'HR',
    value: 'V00',
    label: 'Zagreb'
  },
  {
    countryKey: 'HU',
    value: '01',
    label: 'Bacs-Kiskun'
  },
  {
    countryKey: 'HU',
    value: '02',
    label: 'Baranya'
  },
  {
    countryKey: 'HU',
    value: '03',
    label: 'Bekes'
  },
  {
    countryKey: 'HU',
    value: '05',
    label: 'Borsod-Abauj-Zemplen'
  },
  {
    countryKey: 'HU',
    value: '06',
    label: 'Budapest'
  },
  {
    countryKey: 'HU',
    value: '07',
    label: 'Csongrad'
  },
  {
    countryKey: 'HU',
    value: '11',
    label: 'Fejer'
  },
  {
    countryKey: 'HU',
    value: '13',
    label: 'Gyor-Moson-Sopron'
  },
  {
    countryKey: 'HU',
    value: '14',
    label: 'Hajdu-Bihar'
  },
  {
    countryKey: 'HU',
    value: '15',
    label: 'Heves'
  },
  {
    countryKey: 'HU',
    value: '17',
    label: 'Jasz-Nagykun-Szolnok'
  },
  {
    countryKey: 'HU',
    value: '20',
    label: 'Komarom-Esztergom'
  },
  {
    countryKey: 'HU',
    value: '23',
    label: 'Nograd'
  },
  {
    countryKey: 'HU',
    value: '26',
    label: 'Pest'
  },
  {
    countryKey: 'HU',
    value: '27',
    label: 'Somogy'
  },
  {
    countryKey: 'HU',
    value: '29',
    label: 'Szabolcs-Szat.-Bereg'
  },
  {
    countryKey: 'HU',
    value: '35',
    label: 'Tolna'
  },
  {
    countryKey: 'HU',
    value: '36',
    label: 'Vas'
  },
  {
    countryKey: 'HU',
    value: '37',
    label: 'Veszprem'
  },
  {
    countryKey: 'HU',
    value: '38',
    label: 'Zala'
  },
  {
    countryKey: 'ID',
    value: '01',
    label: 'DKI Jakarta Jakarta'
  },
  {
    countryKey: 'ID',
    value: '02',
    label: 'Jawa Barat West Java'
  },
  {
    countryKey: 'ID',
    value: '03',
    label: 'Jawa Tengah Central'
  },
  {
    countryKey: 'ID',
    value: '04',
    label: 'Jawa Timur East Java'
  },
  {
    countryKey: 'ID',
    value: '05',
    label: 'DI Yogyakarta Yogyak'
  },
  {
    countryKey: 'ID',
    value: '06',
    label: 'DI Aceh Aceh'
  },
  {
    countryKey: 'ID',
    value: '07',
    label: 'Sumatera Utara North'
  },
  {
    countryKey: 'ID',
    value: '08',
    label: 'Sumatera Barat West'
  },
  {
    countryKey: 'ID',
    value: '09',
    label: 'Riau Riau'
  },
  {
    countryKey: 'ID',
    value: '10',
    label: 'Jambi Jambi'
  },
  {
    countryKey: 'ID',
    value: '11',
    label: 'Sumatera Selatan Sou'
  },
  {
    countryKey: 'ID',
    value: '12',
    label: 'Bengkulu Bengkulu'
  },
  {
    countryKey: 'ID',
    value: '13',
    label: 'Lampung Lampung'
  },
  {
    countryKey: 'ID',
    value: '14',
    label: 'Kalimantan Selatan S'
  },
  {
    countryKey: 'ID',
    value: '15',
    label: 'Kalimantan Barat Wes'
  },
  {
    countryKey: 'ID',
    value: '16',
    label: 'Kalimantan Tengah Ce'
  },
  {
    countryKey: 'ID',
    value: '17',
    label: 'Kalimantan Timur Eas'
  },
  {
    countryKey: 'ID',
    value: '18',
    label: 'Sulawesi Selatan Sou'
  },
  {
    countryKey: 'ID',
    value: '19',
    label: 'Sulawesi Tenggara So'
  },
  {
    countryKey: 'ID',
    value: '20',
    label: 'Sulawesi Tengah Cent'
  },
  {
    countryKey: 'ID',
    value: '21',
    label: 'Sulawesi Utara North'
  },
  {
    countryKey: 'ID',
    value: '22',
    label: 'Bali Bali'
  },
  {
    countryKey: 'ID',
    value: '23',
    label: 'Nusa Tenggara Barat'
  },
  {
    countryKey: 'ID',
    value: '24',
    label: 'Nusa Tenggara Timur'
  },
  {
    countryKey: 'ID',
    value: '25',
    label: 'Maluku Maluku'
  },
  {
    countryKey: 'ID',
    value: '26',
    label: 'Irian Jaya Irian Jay'
  },
  {
    countryKey: 'ID',
    value: '27',
    label: 'Timor Timur East Tim'
  },
  {
    countryKey: 'IE',
    value: 'C',
    label: 'Cork'
  },
  {
    countryKey: 'IE',
    value: 'CE',
    label: 'Clare'
  },
  {
    countryKey: 'IE',
    value: 'CV',
    label: 'Cavan'
  },
  {
    countryKey: 'IE',
    value: 'CW',
    label: 'Carlow'
  },
  {
    countryKey: 'IE',
    value: 'DB',
    label: 'Dublin'
  },
  {
    countryKey: 'IE',
    value: 'Donegal',
    label: 'Donegal'
  },
  {
    countryKey: 'IE',
    value: 'Galway',
    label: 'Galway'
  },
  {
    countryKey: 'IE',
    value: 'Kildare',
    label: 'Kildare'
  },
  {
    countryKey: 'IE',
    value: 'Kilkenny',
    label: 'Kilkenny'
  },
  {
    countryKey: 'IE',
    value: 'Kerry',
    label: 'Kerry'
  },
  {
    countryKey: 'IE',
    value: 'Longford',
    label: 'Longford'
  },
  {
    countryKey: 'IE',
    value: 'Limerick',
    label: 'Limerick'
  },
  {
    countryKey: 'IE',
    value: 'Leitrim',
    label: 'Leitrim'
  },
  {
    countryKey: 'IE',
    value: 'Laois',
    label: 'Laois'
  },
  {
    countryKey: 'IE',
    value: 'Louth',
    label: 'Louth'
  },
  {
    countryKey: 'IE',
    value: 'Monaghan',
    label: 'Monaghan'
  },
  {
    countryKey: 'IE',
    value: 'Mayo',
    label: 'Mayo'
  },
  {
    countryKey: 'IE',
    value: 'Meath',
    label: 'Meath'
  },
  {
    countryKey: 'IE',
    value: 'Offaly',
    label: 'Offaly'
  },
  {
    countryKey: 'IE',
    value: 'Rosscommon',
    label: 'Rosscommon'
  },
  {
    countryKey: 'IE',
    value: 'Roscommon',
    label: 'Roscommon'
  },
  {
    countryKey: 'IE',
    value: 'Sligo',
    label: 'Sligo'
  },
  {
    countryKey: 'IE',
    value: 'Tipperary',
    label: 'Tipperary'
  },
  {
    countryKey: 'IE',
    value: 'Waterford',
    label: 'Waterford'
  },
  {
    countryKey: 'IE',
    value: 'Westmeath',
    label: 'Westmeath'
  },
  {
    countryKey: 'IE',
    value: 'Wicklow',
    label: 'Wicklow'
  },
  {
    countryKey: 'IE',
    value: 'Wexford',
    label: 'Wexford'
  },
  {
    countryKey: 'IL',
    value: '01',
    label: 'Central'
  },
  {
    countryKey: 'IL',
    value: '02',
    label: 'Haifa'
  },
  {
    countryKey: 'IL',
    value: '03',
    label: 'Jerusalem'
  },
  {
    countryKey: 'IL',
    value: '04',
    label: 'Northern'
  },
  {
    countryKey: 'IL',
    value: '05',
    label: 'Southern'
  },
  {
    countryKey: 'IL',
    value: '06',
    label: 'Tel Aviv'
  },
  {
    countryKey: 'IN',
    value: '01',
    label: 'Andra Pradesh'
  },
  {
    countryKey: 'IN',
    value: '02',
    label: 'Arunachal Pradesh'
  },
  {
    countryKey: 'IN',
    value: '03',
    label: 'Assam'
  },
  {
    countryKey: 'IN',
    value: '04',
    label: 'Bihar'
  },
  {
    countryKey: 'IN',
    value: '05',
    label: 'Goa'
  },
  {
    countryKey: 'IN',
    value: '06',
    label: 'Gujarat'
  },
  {
    countryKey: 'IN',
    value: '07',
    label: 'Haryana'
  },
  {
    countryKey: 'IN',
    value: '08',
    label: 'Himachal Pradesh'
  },
  {
    countryKey: 'IN',
    value: '09',
    label: 'Jammu und Kashmir'
  },
  {
    countryKey: 'IN',
    value: '10',
    label: 'Karnataka'
  },
  {
    countryKey: 'IN',
    value: '11',
    label: 'Kerala'
  },
  {
    countryKey: 'IN',
    value: '12',
    label: 'Madhya Pradesh'
  },
  {
    countryKey: 'IN',
    value: '13',
    label: 'Maharashtra'
  },
  {
    countryKey: 'IN',
    value: '14',
    label: 'Manipur'
  },
  {
    countryKey: 'IN',
    value: '15',
    label: 'Megalaya'
  },
  {
    countryKey: 'IN',
    value: '16',
    label: 'Mizoram'
  },
  {
    countryKey: 'IN',
    value: '17',
    label: 'Nagaland'
  },
  {
    countryKey: 'IN',
    value: '18',
    label: 'Orissa'
  },
  {
    countryKey: 'IN',
    value: '19',
    label: 'Punjab'
  },
  {
    countryKey: 'IN',
    value: '20',
    label: 'Rajasthan'
  },
  {
    countryKey: 'IN',
    value: '21',
    label: 'Sikkim'
  },
  {
    countryKey: 'IN',
    value: '22',
    label: 'Tamil Nadu'
  },
  {
    countryKey: 'IN',
    value: '23',
    label: 'Tripura'
  },
  {
    countryKey: 'IN',
    value: '24',
    label: 'Uttar Pradesh'
  },
  {
    countryKey: 'IN',
    value: '25',
    label: 'West Bengal'
  },
  {
    countryKey: 'IN',
    value: '26',
    label: 'Andaman und Nico.In.'
  },
  {
    countryKey: 'IN',
    value: '27',
    label: 'Chandigarh'
  },
  {
    countryKey: 'IN',
    value: '28',
    label: 'Dadra und Nagar Hav.'
  },
  {
    countryKey: 'IN',
    value: '29',
    label: 'Daman und Diu'
  },
  {
    countryKey: 'IN',
    value: '30',
    label: 'Delhi'
  },
  {
    countryKey: 'IN',
    value: '31',
    label: 'Lakshadweep'
  },
  {
    countryKey: 'IN',
    value: '32',
    label: 'Pondicherry'
  },
  {
    countryKey: 'IN',
    value: '33',
    label: 'Chhaattisgarh'
  },
  {
    countryKey: 'IN',
    value: '34',
    label: 'Jharkhand'
  },
  {
    countryKey: 'IN',
    value: '35',
    label: 'Uttarakhand'
  },
  {
    countryKey: 'IN',
    value: 'Uttaranchal',
    label: 'Uttaranchal'
  },
  {
    countryKey: 'IN',
    value: '36',
    label: 'Telangana'
  },
  {
    countryKey: 'IT',
    value: 'AG',
    label: 'Agriento'
  },
  {
    countryKey: 'IT',
    value: 'AL',
    label: 'Alessandria'
  },
  {
    countryKey: 'IT',
    value: 'AN',
    label: 'Ancona'
  },
  {
    countryKey: 'IT',
    value: 'AO',
    label: 'Aosta'
  },
  {
    countryKey: 'IT',
    value: 'AP',
    label: 'Ascoli Piceno'
  },
  {
    countryKey: 'IT',
    value: 'AQ',
    label: "L'Aquila"
  },
  {
    countryKey: 'IT',
    value: 'AR',
    label: 'Arezzo'
  },
  {
    countryKey: 'IT',
    value: 'AT',
    label: 'Asti'
  },
  {
    countryKey: 'IT',
    value: 'AV',
    label: 'Avellino'
  },
  {
    countryKey: 'IT',
    value: 'BA',
    label: 'Bari'
  },
  {
    countryKey: 'IT',
    value: 'BG',
    label: 'Bergamo'
  },
  {
    countryKey: 'IT',
    value: 'BI',
    label: 'Biella'
  },
  {
    countryKey: 'IT',
    value: 'BL',
    label: 'Belluno'
  },
  {
    countryKey: 'IT',
    value: 'BN',
    label: 'Benevento'
  },
  {
    countryKey: 'IT',
    value: 'BO',
    label: 'Bologna'
  },
  {
    countryKey: 'IT',
    value: 'BR',
    label: 'Brindisi'
  },
  {
    countryKey: 'IT',
    value: 'BS',
    label: 'Brescia'
  },
  {
    countryKey: 'IT',
    value: 'BZ',
    label: 'Bolzano'
  },
  {
    countryKey: 'IT',
    value: 'CA',
    label: 'Cagliari'
  },
  {
    countryKey: 'IT',
    value: 'CB',
    label: 'Campobasso'
  },
  {
    countryKey: 'IT',
    value: 'CE',
    label: 'Caserta'
  },
  {
    countryKey: 'IT',
    value: 'CH',
    label: 'Chieti'
  },
  {
    countryKey: 'IT',
    value: 'CI',
    label: 'Carbonia-Iglesias'
  },
  {
    countryKey: 'IT',
    value: 'CL',
    label: 'Caltanisetta'
  },
  {
    countryKey: 'IT',
    value: 'CN',
    label: 'Cuneo'
  },
  {
    countryKey: 'IT',
    value: 'CO',
    label: 'Como'
  },
  {
    countryKey: 'IT',
    value: 'CR',
    label: 'Cremona'
  },
  {
    countryKey: 'IT',
    value: 'CS',
    label: 'Cosenza'
  },
  {
    countryKey: 'IT',
    value: 'CT',
    label: 'Catania'
  },
  {
    countryKey: 'IT',
    value: 'CZ',
    label: 'Catanzaro'
  },
  {
    countryKey: 'IT',
    value: 'EE',
    label: 'Stati Esteri'
  },
  {
    countryKey: 'IT',
    value: 'EN',
    label: 'Enna'
  },
  {
    countryKey: 'IT',
    value: 'FC',
    label: 'Forli/Cesana'
  },
  {
    countryKey: 'IT',
    value: 'FE',
    label: 'Ferrara'
  },
  {
    countryKey: 'IT',
    value: 'FG',
    label: 'Foggia'
  },
  {
    countryKey: 'IT',
    value: 'FI',
    label: 'Florence'
  },
  {
    countryKey: 'IT',
    value: 'FR',
    label: 'Frosinone'
  },
  {
    countryKey: 'IT',
    value: 'FU',
    label: 'Fiume'
  },
  {
    countryKey: 'IT',
    value: 'GE',
    label: 'Genova'
  },
  {
    countryKey: 'IT',
    value: 'GO',
    label: 'Gorizia'
  },
  {
    countryKey: 'IT',
    value: 'GR',
    label: 'Grosseto'
  },
  {
    countryKey: 'IT',
    value: 'IM',
    label: 'Imperia'
  },
  {
    countryKey: 'IT',
    value: 'IS',
    label: 'Isernia'
  },
  {
    countryKey: 'IT',
    value: 'KR',
    label: 'Crotone'
  },
  {
    countryKey: 'IT',
    value: 'LC',
    label: 'Lecco'
  },
  {
    countryKey: 'IT',
    value: 'LE',
    label: 'Lecce'
  },
  {
    countryKey: 'IT',
    value: 'LI',
    label: 'Livorno'
  },
  {
    countryKey: 'IT',
    value: 'LO',
    label: 'Lodi'
  },
  {
    countryKey: 'IT',
    value: 'LT',
    label: 'Latina'
  },
  {
    countryKey: 'IT',
    value: 'LU',
    label: 'Lucca'
  },
  {
    countryKey: 'IT',
    value: 'MB',
    label: 'Monza e Brianza'
  },
  {
    countryKey: 'IT',
    value: 'MC',
    label: 'Macerata'
  },
  {
    countryKey: 'IT',
    value: 'ME',
    label: 'Messina'
  },
  {
    countryKey: 'IT',
    value: 'MI',
    label: 'Milan'
  },
  {
    countryKey: 'IT',
    value: 'MN',
    label: 'Mantova'
  },
  {
    countryKey: 'IT',
    value: 'MO',
    label: 'Modena'
  },
  {
    countryKey: 'IT',
    value: 'MS',
    label: 'Massa Carrara'
  },
  {
    countryKey: 'IT',
    value: 'MT',
    label: 'Matera'
  },
  {
    countryKey: 'IT',
    value: 'NA',
    label: 'Naples'
  },
  {
    countryKey: 'IT',
    value: 'NO',
    label: 'Novara'
  },
  {
    countryKey: 'IT',
    value: 'NU',
    label: 'Nuoro'
  },
  {
    countryKey: 'IT',
    value: 'OG',
    label: 'Ogliastra'
  },
  {
    countryKey: 'IT',
    value: 'OR',
    label: 'Oristano'
  },
  {
    countryKey: 'IT',
    value: 'OT',
    label: 'Olbia-Tempio'
  },
  {
    countryKey: 'IT',
    value: 'PA',
    label: 'Palermo'
  },
  {
    countryKey: 'IT',
    value: 'PC',
    label: 'Piacenza'
  },
  {
    countryKey: 'IT',
    value: 'PD',
    label: 'Padova'
  },
  {
    countryKey: 'IT',
    value: 'PE',
    label: 'Pescara'
  },
  {
    countryKey: 'IT',
    value: 'PG',
    label: 'Perugia'
  },
  {
    countryKey: 'IT',
    value: 'PI',
    label: 'Pisa'
  },
  {
    countryKey: 'IT',
    value: 'PL',
    label: 'Pola'
  },
  {
    countryKey: 'IT',
    value: 'PN',
    label: 'Pordenone'
  },
  {
    countryKey: 'IT',
    value: 'PO',
    label: 'Prato'
  },
  {
    countryKey: 'IT',
    value: 'PR',
    label: 'Parma'
  },
  {
    countryKey: 'IT',
    value: 'PT',
    label: 'Pistoia'
  },
  {
    countryKey: 'IT',
    value: 'PU',
    label: 'Pesaro-Urbino'
  },
  {
    countryKey: 'IT',
    value: 'PV',
    label: 'Pavia'
  },
  {
    countryKey: 'IT',
    value: 'PZ',
    label: 'Potenza'
  },
  {
    countryKey: 'IT',
    value: 'RA',
    label: 'Ravenna'
  },
  {
    countryKey: 'IT',
    value: 'RC',
    label: 'Reggio Calabria'
  },
  {
    countryKey: 'IT',
    value: 'RE',
    label: 'Reggio Emilia'
  },
  {
    countryKey: 'IT',
    value: 'RG',
    label: 'Ragusa'
  },
  {
    countryKey: 'IT',
    value: 'RI',
    label: 'Rieti'
  },
  {
    countryKey: 'IT',
    value: 'RM',
    label: 'Rome'
  },
  {
    countryKey: 'IT',
    value: 'RN',
    label: 'Rimini'
  },
  {
    countryKey: 'IT',
    value: 'RO',
    label: 'Rovigo'
  },
  {
    countryKey: 'IT',
    value: 'SA',
    label: 'Salerno'
  },
  {
    countryKey: 'IT',
    value: 'SI',
    label: 'Siena'
  },
  {
    countryKey: 'IT',
    value: 'SO',
    label: 'Sondrio'
  },
  {
    countryKey: 'IT',
    value: 'SP',
    label: 'La Spezia'
  },
  {
    countryKey: 'IT',
    value: 'SR',
    label: 'Siracusa'
  },
  {
    countryKey: 'IT',
    value: 'SS',
    label: 'Sassari'
  },
  {
    countryKey: 'IT',
    value: 'SV',
    label: 'Savona'
  },
  {
    countryKey: 'IT',
    value: 'TA',
    label: 'Taranto'
  },
  {
    countryKey: 'IT',
    value: 'TE',
    label: 'Teramo'
  },
  {
    countryKey: 'IT',
    value: 'TN',
    label: 'Trento'
  },
  {
    countryKey: 'IT',
    value: 'TO',
    label: 'Turin'
  },
  {
    countryKey: 'IT',
    value: 'TP',
    label: 'Trapani'
  },
  {
    countryKey: 'IT',
    value: 'TR',
    label: 'Terni'
  },
  {
    countryKey: 'IT',
    value: 'TS',
    label: 'Trieste'
  },
  {
    countryKey: 'IT',
    value: 'TV',
    label: 'Treviso'
  },
  {
    countryKey: 'IT',
    value: 'UD',
    label: 'Udine'
  },
  {
    countryKey: 'IT',
    value: 'VA',
    label: 'Varese'
  },
  {
    countryKey: 'IT',
    value: 'VB',
    label: 'Verbania'
  },
  {
    countryKey: 'IT',
    value: 'VC',
    label: 'Vercelli'
  },
  {
    countryKey: 'IT',
    value: 'VE',
    label: 'Venice'
  },
  {
    countryKey: 'IT',
    value: 'VI',
    label: 'Vicenza'
  },
  {
    countryKey: 'IT',
    value: 'VR',
    label: 'Verona'
  },
  {
    countryKey: 'IT',
    value: 'VS',
    label: 'Medio Campidano'
  },
  {
    countryKey: 'IT',
    value: 'VT',
    label: 'Viterbo'
  },
  {
    countryKey: 'IT',
    value: 'VV',
    label: 'Vibo Valentia'
  },
  {
    countryKey: 'IT',
    value: 'ZA',
    label: 'Zara'
  },
  {
    countryKey: 'JP',
    value: '01',
    label: 'Hokkaido'
  },
  {
    countryKey: 'JP',
    value: '02',
    label: 'Aomori'
  },
  {
    countryKey: 'JP',
    value: '03',
    label: 'Iwate'
  },
  {
    countryKey: 'JP',
    value: '04',
    label: 'Miyagi'
  },
  {
    countryKey: 'JP',
    value: '05',
    label: 'Akita'
  },
  {
    countryKey: 'JP',
    value: '06',
    label: 'Yamagata'
  },
  {
    countryKey: 'JP',
    value: '07',
    label: 'Fukushima'
  },
  {
    countryKey: 'JP',
    value: '08',
    label: 'Ibaraki'
  },
  {
    countryKey: 'JP',
    value: '09',
    label: 'Tochigi'
  },
  {
    countryKey: 'JP',
    value: '10',
    label: 'Gunma'
  },
  {
    countryKey: 'JP',
    value: '11',
    label: 'Saitama'
  },
  {
    countryKey: 'JP',
    value: '12',
    label: 'Chiba'
  },
  {
    countryKey: 'JP',
    value: '13',
    label: 'Tokyo'
  },
  {
    countryKey: 'JP',
    value: '14',
    label: 'Kanagawa'
  },
  {
    countryKey: 'JP',
    value: '15',
    label: 'Niigata'
  },
  {
    countryKey: 'JP',
    value: '16',
    label: 'Toyama'
  },
  {
    countryKey: 'JP',
    value: '17',
    label: 'Ishikawa'
  },
  {
    countryKey: 'JP',
    value: '18',
    label: 'Fukui'
  },
  {
    countryKey: 'JP',
    value: '19',
    label: 'Yamanashi'
  },
  {
    countryKey: 'JP',
    value: '20',
    label: 'Nagano'
  },
  {
    countryKey: 'JP',
    value: '21',
    label: 'Gifu'
  },
  {
    countryKey: 'JP',
    value: '22',
    label: 'Shizuoka'
  },
  {
    countryKey: 'JP',
    value: '23',
    label: 'Aichi'
  },
  {
    countryKey: 'JP',
    value: '24',
    label: 'Mie'
  },
  {
    countryKey: 'JP',
    value: '25',
    label: 'Shiga'
  },
  {
    countryKey: 'JP',
    value: '26',
    label: 'Kyoto'
  },
  {
    countryKey: 'JP',
    value: '27',
    label: 'Osaka'
  },
  {
    countryKey: 'JP',
    value: '28',
    label: 'Hyogo'
  },
  {
    countryKey: 'JP',
    value: '29',
    label: 'Nara'
  },
  {
    countryKey: 'JP',
    value: '30',
    label: 'Wakayama'
  },
  {
    countryKey: 'JP',
    value: '31',
    label: 'Tottori'
  },
  {
    countryKey: 'JP',
    value: '32',
    label: 'Shimane'
  },
  {
    countryKey: 'JP',
    value: '33',
    label: 'Okayama'
  },
  {
    countryKey: 'JP',
    value: '34',
    label: 'Hiroshima'
  },
  {
    countryKey: 'JP',
    value: '35',
    label: 'Yamaguchi'
  },
  {
    countryKey: 'JP',
    value: '36',
    label: 'Tokushima'
  },
  {
    countryKey: 'JP',
    value: '37',
    label: 'Kagawa'
  },
  {
    countryKey: 'JP',
    value: '38',
    label: 'Ehime'
  },
  {
    countryKey: 'JP',
    value: '39',
    label: 'Kochi'
  },
  {
    countryKey: 'JP',
    value: '40',
    label: 'Fukuoka'
  },
  {
    countryKey: 'JP',
    value: '41',
    label: 'Saga'
  },
  {
    countryKey: 'JP',
    value: '42',
    label: 'Nagasaki'
  },
  {
    countryKey: 'JP',
    value: '43',
    label: 'Kumamoto'
  },
  {
    countryKey: 'JP',
    value: '44',
    label: 'Oita'
  },
  {
    countryKey: 'JP',
    value: '45',
    label: 'Miyazaki'
  },
  {
    countryKey: 'JP',
    value: '46',
    label: 'Kagoshima'
  },
  {
    countryKey: 'JP',
    value: '47',
    label: 'Okinawa'
  },
  {
    countryKey: 'KR',
    value: '01',
    label: 'Cheju-do'
  },
  {
    countryKey: 'KR',
    value: '02',
    label: 'Cholla-bukto'
  },
  {
    countryKey: 'KR',
    value: '3',
    label: 'Cholla-namdo'
  },
  {
    countryKey: 'KR',
    value: '4',
    label: 'Ch´ungch´ong-bukto'
  },
  {
    countryKey: 'KR',
    value: '5',
    label: 'Ch´ungch´ong-namdo'
  },
  {
    countryKey: 'KR',
    value: '6',
    label: 'Inch´on-jikhalsi'
  },
  {
    countryKey: 'KR',
    value: '7',
    label: 'Kangwon-do'
  },
  {
    countryKey: 'KR',
    value: '8',
    label: 'Kwangju-jikhalsi'
  },
  {
    countryKey: 'KR',
    value: '9',
    label: 'Kyonggi-do'
  },
  {
    countryKey: 'KR',
    value: '10',
    label: 'Kyongsang-bukto'
  },
  {
    countryKey: 'KR',
    value: '11',
    label: 'Kyongsang-namdo'
  },
  {
    countryKey: 'KR',
    value: '12',
    label: 'Pusan-jikhalsi'
  },
  {
    countryKey: 'KR',
    value: '13',
    label: 'Soul-t´ukpyolsi'
  },
  {
    countryKey: 'KR',
    value: '14',
    label: 'Taegu-jikhalsi'
  },
  {
    countryKey: 'KR',
    value: '15',
    label: 'Taejon-jikhalsi'
  },
  {
    countryKey: 'KR',
    value: '16',
    label: 'Ulsan'
  },
  {
    countryKey: 'KR',
    value: '17',
    label: 'Sejong'
  },
  {
    countryKey: 'KZ',
    value: '00',
    label: 'Almatynskaia'
  },
  {
    countryKey: 'KZ',
    value: '01',
    label: 'Kostanaiskaia'
  },
  {
    countryKey: 'KZ',
    value: '02',
    label: 'Severo-Kazakhstansk'
  },
  {
    countryKey: 'KZ',
    value: '03',
    label: 'Pavlodarskaia'
  },
  {
    countryKey: 'KZ',
    value: '04',
    label: 'Akmolinskaia'
  },
  {
    countryKey: 'KZ',
    value: '05',
    label: 'Aktubinskaia'
  },
  {
    countryKey: 'KZ',
    value: '06',
    label: 'Atyrauskaia'
  },
  {
    countryKey: 'KZ',
    value: '07',
    label: 'Zapadno-Kazakhst'
  },
  {
    countryKey: 'KZ',
    value: '08',
    label: 'Mangystayskaia'
  },
  {
    countryKey: 'KZ',
    value: '09',
    label: 'Karagandinskaia'
  },
  {
    countryKey: 'KZ',
    value: '10',
    label: 'Vostochno-Kazakhstan'
  },
  {
    countryKey: 'KZ',
    value: '11',
    label: 'Gambilskaia'
  },
  {
    countryKey: 'KZ',
    value: '12',
    label: 'Kyzilordinskaia'
  },
  {
    countryKey: 'MX',
    value: 'AGS',
    label: 'Aguascalientes'
  },
  {
    countryKey: 'MX',
    value: 'BC',
    label: 'Baja California'
  },
  {
    countryKey: 'MX',
    value: 'BCS',
    label: 'Baja California S'
  },
  {
    countryKey: 'MX',
    value: 'CDM',
    label: 'Cuidad de Mexico'
  },
  {
    countryKey: 'MX',
    value: 'CHI',
    label: 'Chihuahua'
  },
  {
    countryKey: 'MX',
    value: 'CHS',
    label: 'Chiapas'
  },
  {
    countryKey: 'MX',
    value: 'CMP',
    label: 'Campeche'
  },
  {
    countryKey: 'MX',
    value: 'COA',
    label: 'Coahuila'
  },
  {
    countryKey: 'MX',
    value: 'COL',
    label: 'Colima'
  },
  {
    countryKey: 'MX',
    value: 'DF',
    label: 'Distrito Federal'
  },
  {
    countryKey: 'MX',
    value: 'DGO',
    label: 'Durango'
  },
  {
    countryKey: 'MX',
    value: 'GRO',
    label: 'Guerrero'
  },
  {
    countryKey: 'MX',
    value: 'GTO',
    label: 'Guanajuato'
  },
  {
    countryKey: 'MX',
    value: 'HGO',
    label: 'Hidalgo'
  },
  {
    countryKey: 'MX',
    value: 'JAL',
    label: 'Jalisco'
  },
  {
    countryKey: 'MX',
    value: 'MCH',
    label: 'Michoacan'
  },
  {
    countryKey: 'MX',
    value: 'MEX',
    label: 'Estado de Mexico'
  },
  {
    countryKey: 'MX',
    value: 'MOR',
    label: 'Morelos'
  },
  {
    countryKey: 'MX',
    value: 'NAY',
    label: 'Nayarit'
  },
  {
    countryKey: 'MX',
    value: 'NL',
    label: 'Nuevo Leon'
  },
  {
    countryKey: 'MX',
    value: 'OAX',
    label: 'Oaxaca'
  },
  {
    countryKey: 'MX',
    value: 'PUE',
    label: 'Puebla'
  },
  {
    countryKey: 'MX',
    value: 'QR',
    label: 'Quintana Roo'
  },
  {
    countryKey: 'MX',
    value: 'QRO',
    label: 'Queretaro'
  },
  {
    countryKey: 'MX',
    value: 'SIN',
    label: 'Sinaloa'
  },
  {
    countryKey: 'MX',
    value: 'SLP',
    label: 'San Luis Potosi'
  },
  {
    countryKey: 'MX',
    value: 'SON',
    label: 'Sonora'
  },
  {
    countryKey: 'MX',
    value: 'TAB',
    label: 'Tabasco'
  },
  {
    countryKey: 'MX',
    value: 'TAM',
    label: 'Tamaulipas'
  },
  {
    countryKey: 'MX',
    value: 'TLX',
    label: 'Tlaxcala'
  },
  {
    countryKey: 'MX',
    value: 'VER',
    label: 'Veracruz'
  },
  {
    countryKey: 'MX',
    value: 'YUC',
    label: 'Yucatan'
  },
  {
    countryKey: 'MX',
    value: 'ZAC',
    label: 'Zacatecas'
  },
  {
    countryKey: 'MY',
    value: 'JOH',
    label: 'Johor'
  },
  {
    countryKey: 'MY',
    value: 'KED',
    label: 'Kedah'
  },
  {
    countryKey: 'MY',
    value: 'KEL',
    label: 'Kelantan'
  },
  {
    countryKey: 'MY',
    value: 'KUL',
    label: 'Kuala Lumpur'
  },
  {
    countryKey: 'MY',
    value: 'LAB',
    label: 'Labuan'
  },
  {
    countryKey: 'MY',
    value: 'MEL',
    label: 'Melaka'
  },
  {
    countryKey: 'MY',
    value: 'PAH',
    label: 'Pahang'
  },
  {
    countryKey: 'MY',
    value: 'PEL',
    label: 'Perlis'
  },
  {
    countryKey: 'MY',
    value: 'PER',
    label: 'Perak'
  },
  {
    countryKey: 'MY',
    value: 'PIN',
    label: 'Pulau Pinang'
  },
  {
    countryKey: 'MY',
    value: 'PSK',
    label: 'Wil. Persekutuan'
  },
  {
    countryKey: 'MY',
    value: 'SAB',
    label: 'Sabah'
  },
  {
    countryKey: 'MY',
    value: 'SAR',
    label: 'Sarawak'
  },
  {
    countryKey: 'MY',
    value: 'SEL',
    label: 'Selangor'
  },
  {
    countryKey: 'MY',
    value: 'SER',
    label: 'Negeri Sembilan'
  },
  {
    countryKey: 'MY',
    value: 'TRE',
    label: 'Trengganu'
  },
  {
    countryKey: 'NI',
    value: '1',
    label: 'Boaco'
  },
  {
    countryKey: 'NI',
    value: '10',
    label: 'Managua'
  },
  {
    countryKey: 'NI',
    value: '11',
    label: 'Masaya'
  },
  {
    countryKey: 'NI',
    value: '12',
    label: 'Matagalpa'
  },
  {
    countryKey: 'NI',
    value: '13',
    label: 'Nueva Segovia'
  },
  {
    countryKey: 'NI',
    value: '14',
    label: 'Atlántico Norte'
  },
  {
    countryKey: 'NI',
    value: '15',
    label: 'Atlántico Sur'
  },
  {
    countryKey: 'NI',
    value: '16',
    label: 'Río San Juan'
  },
  {
    countryKey: 'NI',
    value: '17',
    label: 'Rivas'
  },
  {
    countryKey: 'NI',
    value: '2',
    label: 'Carazo'
  },
  {
    countryKey: 'NI',
    value: '3',
    label: 'Chinandega'
  },
  {
    countryKey: 'NI',
    value: '4',
    label: 'Chontales'
  },
  {
    countryKey: 'NI',
    value: '5',
    label: 'Estelí'
  },
  {
    countryKey: 'NI',
    value: '6',
    label: 'Granada'
  },
  {
    countryKey: 'NI',
    value: '7',
    label: 'Jinotega'
  },
  {
    countryKey: 'NI',
    value: '8',
    label: 'León'
  },
  {
    countryKey: 'NI',
    value: '9',
    label: 'Madriz'
  },
  {
    countryKey: 'NL',
    value: '01',
    label: 'Drenthe'
  },
  {
    countryKey: 'NL',
    value: '02',
    label: 'Flevoland'
  },
  {
    countryKey: 'NL',
    value: '03',
    label: 'Friesland'
  },
  {
    countryKey: 'NL',
    value: '04',
    label: 'Gelderland'
  },
  {
    countryKey: 'NL',
    value: '05',
    label: 'Groningen'
  },
  {
    countryKey: 'NL',
    value: '06',
    label: 'Limburg'
  },
  {
    countryKey: 'NL',
    value: '07',
    label: 'Noord-Brabant'
  },
  {
    countryKey: 'NL',
    value: '08',
    label: 'Noord-Holland'
  },
  {
    countryKey: 'NL',
    value: '09',
    label: 'Overijssel'
  },
  {
    countryKey: 'NL',
    value: '10',
    label: 'Utrecht'
  },
  {
    countryKey: 'NL',
    value: '11',
    label: 'Zeeland'
  },
  {
    countryKey: 'NL',
    value: '12',
    label: 'Zuid-Holland'
  },
  {
    countryKey: 'NO',
    value: '01',
    label: 'Ostfold County'
  },
  {
    countryKey: 'NO',
    value: '02',
    label: 'Akershus County'
  },
  {
    countryKey: 'NO',
    value: '03',
    label: 'Oslo'
  },
  {
    countryKey: 'NO',
    value: '04',
    label: 'Hedmark County'
  },
  {
    countryKey: 'NO',
    value: '05',
    label: 'Oppland County'
  },
  {
    countryKey: 'NO',
    value: '06',
    label: 'Buskerud County'
  },
  {
    countryKey: 'NO',
    value: '07',
    label: 'Vestfold County'
  },
  {
    countryKey: 'NO',
    value: '08',
    label: 'Telemark County'
  },
  {
    countryKey: 'NO',
    value: '09',
    label: 'Aust-Agder County'
  },
  {
    countryKey: 'NO',
    value: '10',
    label: 'Vest-Agder County'
  },
  {
    countryKey: 'NO',
    value: '11',
    label: 'Rogaland County'
  },
  {
    countryKey: 'NO',
    value: '12',
    label: 'Hordaland County'
  },
  {
    countryKey: 'NO',
    value: '14.',
    label: 'Sogn og Fjordane C.'
  },
  {
    countryKey: 'NO',
    value: '15.',
    label: 'More og Romsdal C.'
  },
  {
    countryKey: 'NO',
    value: '16',
    label: 'Sor-Trondelag County'
  },
  {
    countryKey: 'NO',
    value: '17',
    label: 'Nord-Trondelag Cnty'
  },
  {
    countryKey: 'NO',
    value: '18',
    label: 'Nordland County'
  },
  {
    countryKey: 'NO',
    value: '19',
    label: 'Troms County'
  },
  {
    countryKey: 'NO',
    value: '20',
    label: 'Finnmark County'
  },
  {
    countryKey: 'NZ',
    value: 'AKL',
    label: 'Auckland'
  },
  {
    countryKey: 'NZ',
    value: 'BOP',
    label: 'Bay of Plenty'
  },
  {
    countryKey: 'NZ',
    value: 'CAN',
    label: 'Canterbury'
  },
  {
    countryKey: 'NZ',
    value: 'HAB',
    label: 'Hawke´s Bay'
  },
  {
    countryKey: 'NZ',
    value: 'MAN',
    label: 'Manawatu-Wanganui'
  },
  {
    countryKey: 'NZ',
    value: 'NTL',
    label: 'Northland'
  },
  {
    countryKey: 'NZ',
    value: 'OAT',
    label: 'Otago'
  },
  {
    countryKey: 'NZ',
    value: 'STL',
    label: 'Southland'
  },
  {
    countryKey: 'NZ',
    value: 'TAR',
    label: 'Taranaki'
  },
  {
    countryKey: 'NZ',
    value: 'WAI',
    label: 'Waikato'
  },
  {
    countryKey: 'NZ',
    value: 'WEC',
    label: 'West Coast'
  },
  {
    countryKey: 'NZ',
    value: 'WLG',
    label: 'Wellington'
  },
  {
    countryKey: 'PA',
    value: '01',
    label: 'Ciudad de Panama'
  },
  {
    countryKey: 'PA',
    value: '02',
    label: 'Colon'
  },
  {
    countryKey: 'PA',
    value: '03',
    label: 'Chiriqui'
  },
  {
    countryKey: 'PE',
    value: '01',
    label: 'Tumbes'
  },
  {
    countryKey: 'PE',
    value: '02',
    label: 'Piura'
  },
  {
    countryKey: 'PE',
    value: '03',
    label: 'Lambayeque'
  },
  {
    countryKey: 'PE',
    value: '04',
    label: 'La Libertad'
  },
  {
    countryKey: 'PE',
    value: '05',
    label: 'Ancash'
  },
  {
    countryKey: 'PE',
    value: '06',
    label: 'Lima y Callao'
  },
  {
    countryKey: 'PE',
    value: '07',
    label: 'Ica'
  },
  {
    countryKey: 'PE',
    value: '08',
    label: 'Arequipa'
  },
  {
    countryKey: 'PE',
    value: '09',
    label: 'Moquegua'
  },
  {
    countryKey: 'PE',
    value: '10',
    label: 'Tacna'
  },
  {
    countryKey: 'PE',
    value: '11',
    label: 'Amazon'
  },
  {
    countryKey: 'PE',
    value: '12',
    label: 'Cajamarca'
  },
  {
    countryKey: 'PE',
    value: '13',
    label: 'San Martin'
  },
  {
    countryKey: 'PE',
    value: '14',
    label: 'Huanuco'
  },
  {
    countryKey: 'PE',
    value: '15',
    label: 'Pasco'
  },
  {
    countryKey: 'PE',
    value: '16',
    label: 'Junin'
  },
  {
    countryKey: 'PE',
    value: '17',
    label: 'Huancavelica'
  },
  {
    countryKey: 'PE',
    value: '18',
    label: 'Ayacucho'
  },
  {
    countryKey: 'PE',
    value: '19',
    label: 'Apurimac'
  },
  {
    countryKey: 'PE',
    value: '20',
    label: 'Cuzco'
  },
  {
    countryKey: 'PE',
    value: '21',
    label: 'Puno'
  },
  {
    countryKey: 'PE',
    value: '22',
    label: 'Loreto'
  },
  {
    countryKey: 'PE',
    value: '23',
    label: 'Ucayali'
  },
  {
    countryKey: 'PE',
    value: '24',
    label: 'Madre de Dios'
  },
  {
    countryKey: 'PH',
    value: '01',
    label: 'Ilocos'
  },
  {
    countryKey: 'PH',
    value: 'Cagayan Valley',
    label: 'Cagayan Valley'
  },
  {
    countryKey: 'PH',
    value: 'Central Luzon',
    label: 'Central Luzon'
  },
  {
    countryKey: 'PH',
    value: 'Do Not Use',
    label: 'Do Not Use'
  },
  {
    countryKey: 'PH',
    value: 'Bicol',
    label: 'Bicol'
  },
  {
    countryKey: 'PH',
    value: 'West Visayas',
    label: 'West Visayas'
  },
  {
    countryKey: 'PH',
    value: 'Central Visayas',
    label: 'Central Visayas'
  },
  {
    countryKey: 'PH',
    value: 'Eastern Visayas',
    label: 'Eastern Visayas'
  },
  {
    countryKey: 'PH',
    value: '9',
    label: 'Zamboanga Peninsula'
  },
  {
    countryKey: 'PH',
    value: '10',
    label: 'Northern Mindanao'
  },
  {
    countryKey: 'PH',
    value: '11',
    label: 'SOCCSKSARGEN'
  },
  {
    countryKey: 'PH',
    value: '12',
    label: 'DAVAO REGION'
  },
  {
    countryKey: 'PH',
    value: '13',
    label: 'Caraga'
  },
  {
    countryKey: 'PH',
    value: '14',
    label: 'CAR'
  },
  {
    countryKey: 'PH',
    value: '15',
    label: 'ARMM'
  },
  {
    countryKey: 'PH',
    value: '16',
    label: 'NCR'
  },
  {
    countryKey: 'PH',
    value: '4A',
    label: 'CALABARZON'
  },
  {
    countryKey: 'PH',
    value: '4B',
    label: 'MIMAROPA'
  },
  {
    countryKey: 'PK',
    value: 'Other',
    label: 'Other'
  },
  {
    countryKey: 'PL',
    value: 'DSL',
    label: 'Dolnoslaskie'
  },
  {
    countryKey: 'PL',
    value: 'K-P',
    label: 'Kujawsko-Pomorskie'
  },
  {
    countryKey: 'PL',
    value: 'LBL',
    label: 'Lubelskie'
  },
  {
    countryKey: 'PL',
    value: 'LBS',
    label: 'Lubuskie'
  },
  {
    countryKey: 'PL',
    value: 'LDZ',
    label: 'Lodzkie'
  },
  {
    countryKey: 'PL',
    value: 'Malopolskie',
    label: 'Malopolskie'
  },
  {
    countryKey: 'PL',
    value: 'Mazowieckie',
    label: 'Mazowieckie'
  },
  {
    countryKey: 'PL',
    value: 'Opolskie',
    label: 'Opolskie'
  },
  {
    countryKey: 'PL',
    value: 'Podkarpackie',
    label: 'Podkarpackie'
  },
  {
    countryKey: 'PL',
    value: 'PDL',
    label: 'Podlaskie'
  },
  {
    countryKey: 'PL',
    value: 'POM',
    label: 'Pomorskie'
  },
  {
    countryKey: 'PL',
    value: 'SLS',
    label: 'Slaskie'
  },
  {
    countryKey: 'PL',
    value: 'SWK',
    label: 'Swietokrzyskie'
  },
  {
    countryKey: 'PL',
    value: 'W-M',
    label: 'Warminsko-mazurskie'
  },
  {
    countryKey: 'PL',
    value: 'WLK',
    label: 'Wielkopolskie'
  },
  {
    countryKey: 'PL',
    value: 'Z-P',
    label: 'Zachodnio-Pomorskie'
  },
  {
    countryKey: 'PT',
    value: '10',
    label: 'Minho-Lima'
  },
  {
    countryKey: 'PT',
    value: '11',
    label: 'Cavado'
  },
  {
    countryKey: 'PT',
    value: '12',
    label: 'Ave'
  },
  {
    countryKey: 'PT',
    value: '13',
    label: 'Grande Porto'
  },
  {
    countryKey: 'PT',
    value: '14',
    label: 'Tamega'
  },
  {
    countryKey: 'PT',
    value: '15',
    label: 'Entre Douro e Vouga'
  },
  {
    countryKey: 'PT',
    value: '16',
    label: 'Douro'
  },
  {
    countryKey: 'PT',
    value: '17',
    label: 'Alto Tras-os-Montes'
  },
  {
    countryKey: 'PT',
    value: '20',
    label: 'Baixo Vouga'
  },
  {
    countryKey: 'PT',
    value: '21',
    label: 'Baixo Mondego'
  },
  {
    countryKey: 'PT',
    value: '22',
    label: 'Pinhal Litoral'
  },
  {
    countryKey: 'PT',
    value: '23',
    label: 'Pinhal Interior N.'
  },
  {
    countryKey: 'PT',
    value: '24',
    label: 'Pinhal Interior Sul'
  },
  {
    countryKey: 'PT',
    value: '25',
    label: 'Dao-Lafoes'
  },
  {
    countryKey: 'PT',
    value: '26',
    label: 'Serra da Estrela'
  },
  {
    countryKey: 'PT',
    value: '27',
    label: 'Beira Interior Norte'
  },
  {
    countryKey: 'PT',
    value: '28',
    label: 'Beira Interior Sul'
  },
  {
    countryKey: 'PT',
    value: '29',
    label: 'Cova da Beira'
  },
  {
    countryKey: 'PT',
    value: '30',
    label: 'Oeste'
  },
  {
    countryKey: 'PT',
    value: '31',
    label: 'Grande Lisboa'
  },
  {
    countryKey: 'PT',
    value: '32',
    label: 'Peninsula de Setubal'
  },
  {
    countryKey: 'PT',
    value: '33',
    label: 'Medio Tejo'
  },
  {
    countryKey: 'PT',
    value: '34',
    label: 'Leziria do Tejo'
  },
  {
    countryKey: 'PT',
    value: '40',
    label: 'Alentejo Litoral'
  },
  {
    countryKey: 'PT',
    value: '41',
    label: 'Alto Alentejo'
  },
  {
    countryKey: 'PT',
    value: '42',
    label: 'Alentejo Central'
  },
  {
    countryKey: 'PT',
    value: '43',
    label: 'Baixo Alentejo'
  },
  {
    countryKey: 'PT',
    value: '50',
    label: 'Algarve'
  },
  {
    countryKey: 'PT',
    value: '60',
    label: 'Reg. Aut. dos Açores'
  },
  {
    countryKey: 'PT',
    value: '70',
    label: 'Reg. Aut. da Madeira'
  },
  {
    countryKey: 'RO',
    value: '1',
    label: 'Alba'
  },
  {
    countryKey: 'RO',
    value: '2',
    label: 'Arad'
  },
  {
    countryKey: 'RO',
    value: '3',
    label: 'Arges'
  },
  {
    countryKey: 'RO',
    value: '4',
    label: 'Bacau'
  },
  {
    countryKey: 'RO',
    value: '5',
    label: 'Bihor'
  },
  {
    countryKey: 'RO',
    value: '6',
    label: 'Bistrita-Nasaud'
  },
  {
    countryKey: 'RO',
    value: '7',
    label: 'Botosani'
  },
  {
    countryKey: 'RO',
    value: '8',
    label: 'Braila'
  },
  {
    countryKey: 'RO',
    value: '9',
    label: 'Brasov'
  },
  {
    countryKey: 'RO',
    value: '10',
    label: 'Bucuresti'
  },
  {
    countryKey: 'RO',
    value: '11',
    label: 'Buzau'
  },
  {
    countryKey: 'RO',
    value: '12',
    label: 'Calarasi'
  },
  {
    countryKey: 'RO',
    value: '13',
    label: 'Caras-Severin'
  },
  {
    countryKey: 'RO',
    value: '14',
    label: 'Cluj'
  },
  {
    countryKey: 'RO',
    value: '15',
    label: 'Constanta'
  },
  {
    countryKey: 'RO',
    value: '16',
    label: 'Covasna'
  },
  {
    countryKey: 'RO',
    value: '17',
    label: 'Dimbovita'
  },
  {
    countryKey: 'RO',
    value: '18',
    label: 'Dolj'
  },
  {
    countryKey: 'RO',
    value: '19',
    label: 'Galati'
  },
  {
    countryKey: 'RO',
    value: '20',
    label: 'Gorj'
  },
  {
    countryKey: 'RO',
    value: '21',
    label: 'Giurgiu'
  },
  {
    countryKey: 'RO',
    value: '22',
    label: 'Harghita'
  },
  {
    countryKey: 'RO',
    value: '23',
    label: 'Hunedoara'
  },
  {
    countryKey: 'RO',
    value: '24',
    label: 'Ialomita'
  },
  {
    countryKey: 'RO',
    value: '25',
    label: 'Iasi'
  },
  {
    countryKey: 'RO',
    value: '26',
    label: 'Maramures'
  },
  {
    countryKey: 'RO',
    value: '27',
    label: 'Mehedinti'
  },
  {
    countryKey: 'RO',
    value: '28',
    label: 'Mures'
  },
  {
    countryKey: 'RO',
    value: '29',
    label: 'Neamt'
  },
  {
    countryKey: 'RO',
    value: '30',
    label: 'Olt'
  },
  {
    countryKey: 'RO',
    value: '31',
    label: 'Prahova'
  },
  {
    countryKey: 'RO',
    value: '32',
    label: 'Salaj'
  },
  {
    countryKey: 'RO',
    value: '33',
    label: 'Satu Mare'
  },
  {
    countryKey: 'RO',
    value: '34',
    label: 'Sibiu'
  },
  {
    countryKey: 'RO',
    value: '35',
    label: 'Suceava'
  },
  {
    countryKey: 'RO',
    value: '36',
    label: 'Teleorman'
  },
  {
    countryKey: 'RO',
    value: '37',
    label: 'Timis'
  },
  {
    countryKey: 'RO',
    value: '38',
    label: 'Tulcea'
  },
  {
    countryKey: 'RO',
    value: '39',
    label: 'Vaslui'
  },
  {
    countryKey: 'RO',
    value: '40',
    label: 'Vilcea'
  },
  {
    countryKey: 'RO',
    value: 'Vrancea',
    label: 'Vrancea'
  },
  {
    countryKey: 'RS',
    value: 'Аlекsаndrоvаc',
    label: 'Аlекsаndrоvаc'
  },
  {
    countryKey: 'RS',
    value: 'Аlекsinаc',
    label: 'Аlекsinаc'
  },
  {
    countryKey: 'RS',
    value: 'Аrаndjеlоvаc',
    label: 'Аrаndjеlоvаc'
  },
  {
    countryKey: 'RS',
    value: 'Аriljе',
    label: 'Аriljе'
  },
  {
    countryKey: 'RS',
    value: 'Bаbusnicа',
    label: 'Bаbusnicа'
  },
  {
    countryKey: 'RS',
    value: 'Bајinа Bаstа',
    label: 'Bајinа Bаstа'
  },
  {
    countryKey: 'RS',
    value: 'Bаtоcinа',
    label: 'Bаtоcinа'
  },
  {
    countryKey: 'RS',
    value: 'Bеlа Pаlаnка',
    label: 'Bеlа Pаlаnка'
  },
  {
    countryKey: 'RS',
    value: 'Bаrајеvо',
    label: 'Bаrајеvо'
  },
  {
    countryKey: 'RS',
    value: 'Cuкаricа',
    label: 'Cuкаricа'
  },
  {
    countryKey: 'RS',
    value: 'Grоcка',
    label: 'Grоcка'
  },
  {
    countryKey: 'RS',
    value: 'Nоvi Bеоgrаd',
    label: 'Nоvi Bеоgrаd'
  },
  {
    countryKey: 'RS',
    value: 'Оbrеnоvаc',
    label: 'Оbrеnоvаc'
  },
  {
    countryKey: 'RS',
    value: 'Pаlilulа',
    label: 'Pаlilulа'
  },
  {
    countryKey: 'RS',
    value: 'Sаvsкi Vеnаc',
    label: 'Sаvsкi Vеnаc'
  },
  {
    countryKey: 'RS',
    value: 'Sоpоt',
    label: 'Sоpоt'
  },
  {
    countryKey: 'RS',
    value: 'Stаri Grаd',
    label: 'Stаri Grаd'
  },
  {
    countryKey: 'RS',
    value: 'Vоzdоvаc',
    label: 'Vоzdоvаc'
  },
  {
    countryKey: 'RS',
    value: 'Vrаcаr',
    label: 'Vrаcаr'
  },
  {
    countryKey: 'RS',
    value: 'Zemun',
    label: 'Zemun'
  },
  {
    countryKey: 'RS',
    value: 'Zvеzdаrа',
    label: 'Zvеzdаrа'
  },
  {
    countryKey: 'RS',
    value: 'Blаcе',
    label: 'Blаcе'
  },
  {
    countryKey: 'RS',
    value: 'Bоgаtic',
    label: 'Bоgаtic'
  },
  {
    countryKey: 'RS',
    value: 'Bојniк',
    label: 'Bојniк'
  },
  {
    countryKey: 'RS',
    value: 'Bоljеvаc',
    label: 'Bоljеvаc'
  },
  {
    countryKey: 'RS',
    value: 'Bоr',
    label: 'Bоr'
  },
  {
    countryKey: 'RS',
    value: 'Bоsilеgrаd',
    label: 'Bоsilеgrаd'
  },
  {
    countryKey: 'RS',
    value: 'Brus',
    label: 'Brus'
  },
  {
    countryKey: 'RS',
    value: 'Buјаnоvаc',
    label: 'Buјаnоvаc'
  },
  {
    countryKey: 'RS',
    value: 'Crnа Trаvа',
    label: 'Crnа Trаvа'
  },
  {
    countryKey: 'RS',
    value: 'Cicеvаc',
    label: 'Cicеvаc'
  },
  {
    countryKey: 'RS',
    value: 'Cupriја',
    label: 'Cupriја'
  },
  {
    countryKey: 'RS',
    value: 'grad Cаcак',
    label: 'grad Cаcак'
  },
  {
    countryKey: 'RS',
    value: 'Cајеtinа',
    label: 'Cајеtinа'
  },
  {
    countryKey: 'RS',
    value: 'Dеspоtоvаc',
    label: 'Dеspоtоvаc'
  },
  {
    countryKey: 'RS',
    value: 'Dimitrоvgrаd',
    label: 'Dimitrоvgrаd'
  },
  {
    countryKey: 'RS',
    value: 'Dоljеvаc',
    label: 'Dоljеvаc'
  },
  {
    countryKey: 'RS',
    value: 'Gаdzin Hаn',
    label: 'Gаdzin Hаn'
  },
  {
    countryKey: 'RS',
    value: 'Gоlubаc',
    label: 'Gоlubаc'
  },
  {
    countryKey: 'RS',
    value: 'Gоrnji Milаnоvаc',
    label: 'Gоrnji Milаnоvаc'
  },
  {
    countryKey: 'RS',
    value: 'Ivаnjicа',
    label: 'Ivаnjicа'
  },
  {
    countryKey: 'RS',
    value: 'Кlаdоvо',
    label: 'Кlаdоvо'
  },
  {
    countryKey: 'RS',
    value: 'Кnic',
    label: 'Кnic'
  },
  {
    countryKey: 'RS',
    value: 'Кnjаzеvаc',
    label: 'Кnjаzеvаc'
  },
  {
    countryKey: 'RS',
    value: 'Коcеljеvа',
    label: 'Коcеljеvа'
  },
  {
    countryKey: 'RS',
    value: 'Коsјеric',
    label: 'Коsјеric'
  },
  {
    countryKey: 'RS',
    value: 'Кrаguјеvаc',
    label: 'Кrаguјеvаc'
  },
  {
    countryKey: 'RS',
    value: 'Кrаljеvо',
    label: 'Кrаljеvо'
  },
  {
    countryKey: 'RS',
    value: 'Кrupаnj',
    label: 'Кrupаnj'
  },
  {
    countryKey: 'RS',
    value: 'grad Кrusеvаc',
    label: 'grad Кrusеvаc'
  },
  {
    countryKey: 'RS',
    value: 'Кučеvо',
    label: 'Кučеvо'
  },
  {
    countryKey: 'RS',
    value: 'Кuršumliја',
    label: 'Кuršumliја'
  },
  {
    countryKey: 'RS',
    value: 'Lајкоvаc',
    label: 'Lајкоvаc'
  },
  {
    countryKey: 'RS',
    value: 'Lаzаrеvаc',
    label: 'Lаzаrеvаc'
  },
  {
    countryKey: 'RS',
    value: 'Lеbаnе',
    label: 'Lеbаnе'
  },
  {
    countryKey: 'RS',
    value: 'grad Lеsкоvаc',
    label: 'grad Lеsкоvаc'
  },
  {
    countryKey: 'RS',
    value: 'grad Lоznicа',
    label: 'grad Lоznicа'
  },
  {
    countryKey: 'RS',
    value: 'Lucаni',
    label: 'Lucаni'
  },
  {
    countryKey: 'RS',
    value: 'Ljig',
    label: 'Ljig'
  },
  {
    countryKey: 'RS',
    value: 'Ljubоviја',
    label: 'Ljubоviја'
  },
  {
    countryKey: 'RS',
    value: 'Mајdаnpек',
    label: 'Mајdаnpек'
  },
  {
    countryKey: 'RS',
    value: 'Mаli Zvоrniк',
    label: 'Mаli Zvоrniк'
  },
  {
    countryKey: 'RS',
    value: 'Mаlо Crnicе',
    label: 'Mаlо Crnicе'
  },
  {
    countryKey: 'RS',
    value: 'Mеdvеdjа',
    label: 'Mеdvеdjа'
  },
  {
    countryKey: 'RS',
    value: 'Mеrоsinа',
    label: 'Mеrоsinа'
  },
  {
    countryKey: 'RS',
    value: 'Miоnicа',
    label: 'Miоnicа'
  },
  {
    countryKey: 'RS',
    value: 'Mlаdеnоvаc',
    label: 'Mlаdеnоvаc'
  },
  {
    countryKey: 'RS',
    value: 'Nеgоtin',
    label: 'Nеgоtin'
  },
  {
    countryKey: 'RS',
    value: 'Nоvа Vаrоs',
    label: 'Nоvа Vаrоs'
  },
  {
    countryKey: 'RS',
    value: 'grad Nоvi Pаzаr',
    label: 'grad Nоvi Pаzаr'
  },
  {
    countryKey: 'RS',
    value: 'Оsеčinа',
    label: 'Оsеčinа'
  },
  {
    countryKey: 'RS',
    value: 'Pаrаcin',
    label: 'Pаrаcin'
  },
  {
    countryKey: 'RS',
    value: 'Pеtrоvаc nа Mlаvi',
    label: 'Pеtrоvаc nа Mlаvi'
  },
  {
    countryKey: 'RS',
    value: 'Pirоt',
    label: 'Pirоt'
  },
  {
    countryKey: 'RS',
    value: 'Pоzеgа',
    label: 'Pоzеgа'
  },
  {
    countryKey: 'RS',
    value: 'Prеsеvо',
    label: 'Prеsеvо'
  },
  {
    countryKey: 'RS',
    value: 'Pribој',
    label: 'Pribој'
  },
  {
    countryKey: 'RS',
    value: 'Priјеpоljе',
    label: 'Priјеpоljе'
  },
  {
    countryKey: 'RS',
    value: 'Prокupljе',
    label: 'Prокupljе'
  },
  {
    countryKey: 'RS',
    value: 'Rаcа',
    label: 'Rаcа'
  },
  {
    countryKey: 'RS',
    value: 'Rаsка',
    label: 'Rаsка'
  },
  {
    countryKey: 'RS',
    value: 'Rаzаnj',
    label: 'Rаzаnj'
  },
  {
    countryKey: 'RS',
    value: 'Rекоvаc',
    label: 'Rекоvаc'
  },
  {
    countryKey: 'RS',
    value: 'Sјеnicа',
    label: 'Sјеnicа'
  },
  {
    countryKey: 'RS',
    value: 'grad Smеdеrеvо',
    label: 'grad Smеdеrеvо'
  },
  {
    countryKey: 'RS',
    value: 'Smеdеrеvsка Pаlаnка',
    label: 'Smеdеrеvsка Pаlаnка'
  },
  {
    countryKey: 'RS',
    value: 'Sокоbаnjа',
    label: 'Sокоbаnjа'
  },
  {
    countryKey: 'RS',
    value: 'Surdulicа',
    label: 'Surdulicа'
  },
  {
    countryKey: 'RS',
    value: 'grad Јаgоdinа',
    label: 'grad Јаgоdinа'
  },
  {
    countryKey: 'RS',
    value: 'Svilајnаc',
    label: 'Svilајnаc'
  },
  {
    countryKey: 'RS',
    value: 'Svrljig',
    label: 'Svrljig'
  },
  {
    countryKey: 'RS',
    value: 'grad Sаbаc',
    label: 'grad Sаbаc'
  },
  {
    countryKey: 'RS',
    value: 'grad Uzicе',
    label: 'grad Uzicе'
  },
  {
    countryKey: 'RS',
    value: 'Tоpоlа',
    label: 'Tоpоlа'
  },
  {
    countryKey: 'RS',
    value: 'Trgоvistе',
    label: 'Trgоvistе'
  },
  {
    countryKey: 'RS',
    value: 'Trstеniк',
    label: 'Trstеniк'
  },
  {
    countryKey: 'RS',
    value: '104',
    label: 'Tutin'
  },
  {
    countryKey: 'RS',
    value: '105',
    label: 'Ub'
  },
  {
    countryKey: 'RS',
    value: '106',
    label: 'Vаljеvо'
  },
  {
    countryKey: 'RS',
    value: '107',
    label: 'Vаrvаrin'
  },
  {
    countryKey: 'RS',
    value: '108',
    label: 'Vеliка Plаnа'
  },
  {
    countryKey: 'RS',
    value: '109',
    label: 'Vеliко Grаdistе'
  },
  {
    countryKey: 'RS',
    value: '110',
    label: 'Vlаdicin Hаn'
  },
  {
    countryKey: 'RS',
    value: '111',
    label: 'Vlаdimirci'
  },
  {
    countryKey: 'RS',
    value: '112',
    label: 'Vlаsоtincе'
  },
  {
    countryKey: 'RS',
    value: 'Vrnjаcка Bаnjа',
    label: 'Vrnjаcка Bаnjа'
  },
  {
    countryKey: 'RS',
    value: 'grad Zајеcаr',
    label: 'grad Zајеcаr'
  },
  {
    countryKey: 'RS',
    value: 'Zаbаri',
    label: 'Zаbаri'
  },
  {
    countryKey: 'RS',
    value: 'Zаgubicа',
    label: 'Zаgubicа'
  },
  {
    countryKey: 'RS',
    value: 'Zitоrаdjа',
    label: 'Zitоrаdjа'
  },
  {
    countryKey: 'RS',
    value: 'Rакоvicа',
    label: 'Rакоvicа'
  },
  {
    countryKey: 'RS',
    value: 'Bаtоcinа',
    label: 'Bаtоcinа'
  },
  {
    countryKey: 'RS',
    value: 'Nisка Bаnjа',
    label: 'Nisка Bаnjа'
  },
  {
    countryKey: 'RS',
    value: 'Strаgаri',
    label: 'Strаgаri'
  },
  {
    countryKey: 'RS',
    value: 'Surcin',
    label: 'Surcin'
  },
  {
    countryKey: 'RS',
    value: '125',
    label: 'Pantelej'
  },
  {
    countryKey: 'RS',
    value: '126',
    label: 'Nis Crveni krst'
  },
  {
    countryKey: 'RS',
    value: '127',
    label: 'Nis Palilula'
  },
  {
    countryKey: 'RS',
    value: '128',
    label: 'Medijana'
  },
  {
    countryKey: 'RS',
    value: '129',
    label: 'Kostolac'
  },
  {
    countryKey: 'RS',
    value: 'Аdа',
    label: 'Аdа'
  },
  {
    countryKey: 'RS',
    value: 'Аlibunаr',
    label: 'Аlibunаr'
  },
  {
    countryKey: 'RS',
    value: 'Аpаtin',
    label: 'Аpаtin'
  },
  {
    countryKey: 'RS',
    value: 'Bаc',
    label: 'Bаc'
  },
  {
    countryKey: 'RS',
    value: 'Bаcка Pаlаnка',
    label: 'Bаcка Pаlаnка'
  },
  {
    countryKey: 'RS',
    value: 'Bаcка Tоpоlа',
    label: 'Bаcка Tоpоlа'
  },
  {
    countryKey: 'RS',
    value: 'Bаcкi Pеtrоvаc',
    label: 'Bаcкi Pеtrоvаc'
  },
  {
    countryKey: 'RS',
    value: 'Bеcеј',
    label: 'Bеcеј'
  },
  {
    countryKey: 'RS',
    value: 'Bеlа Crкvа',
    label: 'Bеlа Crкvа'
  },
  {
    countryKey: 'RS',
    value: 'Bеоcin',
    label: 'Bеоcin'
  },
  {
    countryKey: 'RS',
    value: 'Cока',
    label: 'Cока'
  },
  {
    countryKey: 'RS',
    value: 'Indjiја',
    label: 'Indjiја'
  },
  {
    countryKey: 'RS',
    value: 'Irig',
    label: 'Irig'
  },
  {
    countryKey: 'RS',
    value: 'Каnjizа',
    label: 'Каnjizа'
  },
  {
    countryKey: 'RS',
    value: 'Кiкindа',
    label: 'Кiкindа'
  },
  {
    countryKey: 'RS',
    value: 'Коvаcicа',
    label: 'Коvаcicа'
  },
  {
    countryKey: 'RS',
    value: 'Коvin',
    label: 'Коvin'
  },
  {
    countryKey: 'RS',
    value: 'Кulа',
    label: 'Кulа'
  },
  {
    countryKey: 'RS',
    value: 'Mаli Idjos',
    label: 'Mаli Idjos'
  },
  {
    countryKey: 'RS',
    value: 'Nоvа Crnjа',
    label: 'Nоvа Crnjа'
  },
  {
    countryKey: 'RS',
    value: 'Nоvi Bеcеј',
    label: 'Nоvi Bеcеј'
  },
  {
    countryKey: 'RS',
    value: 'Nоvi Кnеzеvаc',
    label: 'Nоvi Кnеzеvаc'
  },
  {
    countryKey: 'RS',
    value: 'Novi Sad',
    label: 'Novi Sad'
  },
  {
    countryKey: 'RS',
    value: 'Odzaci',
    label: 'Odzaci'
  },
  {
    countryKey: 'RS',
    value: 'Opovo',
    label: 'Opovo'
  },
  {
    countryKey: 'RS',
    value: '226',
    label: 'grad Pančevo'
  },
  {
    countryKey: 'RS',
    value: '227',
    label: 'Pecinci'
  },
  {
    countryKey: 'RS',
    value: '228',
    label: 'Plandiste'
  },
  {
    countryKey: 'RS',
    value: '229',
    label: 'Ruma'
  },
  {
    countryKey: 'RS',
    value: '230',
    label: 'Secanj'
  },
  {
    countryKey: 'RS',
    value: '231',
    label: 'Senta'
  },
  {
    countryKey: 'RS',
    value: '232',
    label: 'grad Sombor'
  },
  {
    countryKey: 'RS',
    value: '233',
    label: 'Srbobran'
  },
  {
    countryKey: 'RS',
    value: '234',
    label: 'grad Sremska Mitrovi'
  },
  {
    countryKey: 'RS',
    value: '235',
    label: 'Stara Pazova'
  },
  {
    countryKey: 'RS',
    value: '236',
    label: 'grad Subotica'
  },
  {
    countryKey: 'RS',
    value: '237',
    label: 'Sid'
  },
  {
    countryKey: 'RS',
    value: '238',
    label: 'Temerin'
  },
  {
    countryKey: 'RS',
    value: '239',
    label: 'Titеl'
  },
  {
    countryKey: 'RS',
    value: '240',
    label: 'Vrbаs'
  },
  {
    countryKey: 'RS',
    value: '241',
    label: 'Vrsаc'
  },
  {
    countryKey: 'RS',
    value: '242',
    label: 'grad Zrenjanin'
  },
  {
    countryKey: 'RS',
    value: '243',
    label: 'Zаbаlj'
  },
  {
    countryKey: 'RS',
    value: '244',
    label: 'Zitistе'
  },
  {
    countryKey: 'RS',
    value: '247',
    label: 'Pеtrоvаrаdin'
  },
  {
    countryKey: 'RS',
    value: 'Srеmsкi Каrlоvci',
    label: 'Srеmsкi Каrlоvci'
  },
  {
    countryKey: 'RS',
    value: 'Dеcаni',
    label: 'Dеcаni'
  },
  {
    countryKey: 'RS',
    value: 'Djакоvicа',
    label: 'Djакоvicа'
  },
  {
    countryKey: 'RS',
    value: 'Glоgоvаc',
    label: 'Glоgоvаc'
  },
  {
    countryKey: 'RS',
    value: 'Gnjilаnе',
    label: 'Gnjilаnе'
  },
  {
    countryKey: 'RS',
    value: 'Istок',
    label: 'Istок'
  },
  {
    countryKey: 'RS',
    value: 'Каcаniк',
    label: 'Каcаniк'
  },
  {
    countryKey: 'RS',
    value: 'Кlinа',
    label: 'Кlinа'
  },
  {
    countryKey: 'RS',
    value: 'Коsоvsка Каmеnicа',
    label: 'Коsоvsка Каmеnicа'
  },
  {
    countryKey: 'RS',
    value: 'Коsоvsка Mitrоvicа',
    label: 'Коsоvsка Mitrоvicа'
  },
  {
    countryKey: 'RS',
    value: 'Lеpоsаvic',
    label: 'Lеpоsаvic'
  },
  {
    countryKey: 'RS',
    value: 'Lipljаn',
    label: 'Lipljаn'
  },
  {
    countryKey: 'RS',
    value: 'Оrаhоvаc',
    label: 'Оrаhоvаc'
  },
  {
    countryKey: 'RS',
    value: 'Pеc',
    label: 'Pеc'
  },
  {
    countryKey: 'RS',
    value: 'Pоduјеvо',
    label: 'Pоduјеvо'
  },
  {
    countryKey: 'RS',
    value: 'Pristinа',
    label: 'Pristinа'
  },
  {
    countryKey: 'RS',
    value: 'Prizrеn',
    label: 'Prizrеn'
  },
  {
    countryKey: 'RS',
    value: 'Srbicа',
    label: 'Srbicа'
  },
  {
    countryKey: 'RS',
    value: 'Suvа Rека',
    label: 'Suvа Rека'
  },
  {
    countryKey: 'RS',
    value: 'Urоsеvаc',
    label: 'Urоsеvаc'
  },
  {
    countryKey: 'RS',
    value: 'Gnjilane',
    label: 'Gnjilane'
  },
  {
    countryKey: 'RS',
    value: 'Vucitrn',
    label: 'Vucitrn'
  },
  {
    countryKey: 'RS',
    value: 'Zubin Pоtок',
    label: 'Zubin Pоtок'
  },
  {
    countryKey: 'RS',
    value: 'Stimljе',
    label: 'Stimljе'
  },
  {
    countryKey: 'RS',
    value: 'Strpcе',
    label: 'Strpcе'
  },
  {
    countryKey: 'RS',
    value: 'Оbilic',
    label: 'Оbilic'
  },
  {
    countryKey: 'RS',
    value: 'Коsоvо Pоljе',
    label: 'Коsоvо Pоljе'
  },
  {
    countryKey: 'RS',
    value: 'Nоvо Brdо',
    label: 'Nоvо Brdо'
  },
  {
    countryKey: 'RS',
    value: 'Zvеcаn',
    label: 'Zvеcаn'
  },
  {
    countryKey: 'RS',
    value: 'Gora (sediste Dragaš',
    label: 'Gora (sediste Dragaš'
  },
  {
    countryKey: 'RS',
    value: 'Grаd Bеоgrаd',
    label: 'Grаd Bеоgrаd'
  },
  {
    countryKey: 'RS',
    value: 'Grаd Nоvi Sаd',
    label: 'Grаd Nоvi Sаd'
  },
  {
    countryKey: 'RS',
    value: 'Grаd Nis',
    label: 'Grаd Nis'
  },
  {
    countryKey: 'RS',
    value: 'Grаd Кrаguјеvаc',
    label: 'Grаd Кrаguјеvаc'
  },
  {
    countryKey: 'RS',
    value: 'Grаd Pristinа',
    label: 'Grаd Pristinа'
  },
  {
    countryKey: 'RS',
    value: 'Аp Vојvоdinа',
    label: 'Аp Vојvоdinа'
  },
  {
    countryKey: 'RS',
    value: 'Аp Коsоvо i Mеtоhiја',
    label: 'Аp Коsоvо i Mеtоhiја'
  },
  {
    countryKey: 'RS',
    value: 'Rеpubliка Srbiја',
    label: 'Rеpubliка Srbiја'
  },
  {
    countryKey: 'RU',
    value: '1',
    label: 'Adigeja Republic'
  },
  {
    countryKey: 'RU',
    value: '2',
    label: 'Highlands-Altay Rep.'
  },
  {
    countryKey: 'RU',
    value: '3',
    label: 'Republ.of Bashkortos'
  },
  {
    countryKey: 'RU',
    value: '4',
    label: 'Buryat Republic'
  },
  {
    countryKey: 'RU',
    value: '5',
    label: 'Dagestan Republic'
  },
  {
    countryKey: 'RU',
    value: '6',
    label: 'Ingushetija Republic'
  },
  {
    countryKey: 'RU',
    value: '7',
    label: 'Kabardino-Balkar.Rep'
  },
  {
    countryKey: 'RU',
    value: '8',
    label: 'Kalmyk Republic'
  },
  {
    countryKey: 'RU',
    value: '9',
    label: 'Karach.-Cherkessk Re'
  },
  {
    countryKey: 'RU',
    value: '10',
    label: 'Karelian Republic'
  },
  {
    countryKey: 'RU',
    value: '11',
    label: 'Komi Republic'
  },
  {
    countryKey: 'RU',
    value: '12',
    label: 'Marijskaya Republic'
  },
  {
    countryKey: 'RU',
    value: '13',
    label: 'Mordovian Republic'
  },
  {
    countryKey: 'RU',
    value: '14',
    label: 'Yakutiya-Saha Rrepub'
  },
  {
    countryKey: 'RU',
    value: '15',
    label: 'North-Osetiya Republ'
  },
  {
    countryKey: 'RU',
    value: '16',
    label: 'Tatarstan Republic'
  },
  {
    countryKey: 'RU',
    value: '17',
    label: 'Tuva Republic'
  },
  {
    countryKey: 'RU',
    value: '18',
    label: 'The Udmurt Republic'
  },
  {
    countryKey: 'RU',
    value: '19',
    label: 'Chakassky Republic'
  },
  {
    countryKey: 'RU',
    value: '20.',
    label: 'Chechenskaya Republ.'
  },
  {
    countryKey: 'RU',
    value: '21',
    label: 'Chuvash Republic'
  },
  {
    countryKey: 'RU',
    value: '22',
    label: 'Altay Territory'
  },
  {
    countryKey: 'RU',
    value: '23',
    label: 'Krasnodar Territory'
  },
  {
    countryKey: 'RU',
    value: '24',
    label: 'Krasnoyarsk Territor'
  },
  {
    countryKey: 'RU',
    value: '25',
    label: 'Primorye Territory'
  },
  {
    countryKey: 'RU',
    value: '26',
    label: 'Stavropol Territory'
  },
  {
    countryKey: 'RU',
    value: '27',
    label: 'Khabarovsk Territory'
  },
  {
    countryKey: 'RU',
    value: '28',
    label: 'The Amur Area'
  },
  {
    countryKey: 'RU',
    value: '29',
    label: 'The Arkhangelsk Area'
  },
  {
    countryKey: 'RU',
    value: '30',
    label: 'The Astrakhan Area'
  },
  {
    countryKey: 'RU',
    value: '31',
    label: 'The Belgorod Area'
  },
  {
    countryKey: 'RU',
    value: '32',
    label: 'The Bryansk Area'
  },
  {
    countryKey: 'RU',
    value: '33',
    label: 'The Vladimir Area'
  },
  {
    countryKey: 'RU',
    value: '34',
    label: 'The Volgograd Area'
  },
  {
    countryKey: 'RU',
    value: '35',
    label: 'The Vologda Area'
  },
  {
    countryKey: 'RU',
    value: '36',
    label: 'The Voronezh Area'
  },
  {
    countryKey: 'RU',
    value: '37',
    label: 'The Ivanovo Area'
  },
  {
    countryKey: 'RU',
    value: '38',
    label: 'The Irkutsk Area'
  },
  {
    countryKey: 'RU',
    value: '39',
    label: 'The Kaliningrad Area'
  },
  {
    countryKey: 'RU',
    value: '40',
    label: 'The Kaluga Area'
  },
  {
    countryKey: 'RU',
    value: '41',
    label: 'The Kamchatka Area'
  },
  {
    countryKey: 'RU',
    value: '42',
    label: 'The Kemerovo Area'
  },
  {
    countryKey: 'RU',
    value: '43',
    label: 'The Kirov Area'
  },
  {
    countryKey: 'RU',
    value: '44',
    label: 'The Kostroma Area'
  },
  {
    countryKey: 'RU',
    value: '45',
    label: 'The Kurgan Area'
  },
  {
    countryKey: 'RU',
    value: '46',
    label: 'The Kursk Area'
  },
  {
    countryKey: 'RU',
    value: '47',
    label: 'The Leningrad Area'
  },
  {
    countryKey: 'RU',
    value: '48',
    label: 'The Lipetsk Area'
  },
  {
    countryKey: 'RU',
    value: '49',
    label: 'The Magadan Area'
  },
  {
    countryKey: 'RU',
    value: '50',
    label: 'The Moscow Area'
  },
  {
    countryKey: 'RU',
    value: '51',
    label: 'The Murmansk Area'
  },
  {
    countryKey: 'RU',
    value: '52',
    label: 'The Nizhniy Novgorod'
  },
  {
    countryKey: 'RU',
    value: '53',
    label: 'The Novgorod Area'
  },
  {
    countryKey: 'RU',
    value: '54',
    label: 'The Novosibirsk Area'
  },
  {
    countryKey: 'RU',
    value: '55',
    label: 'The Omsk Area'
  },
  {
    countryKey: 'RU',
    value: '56',
    label: 'The Orenburg Area'
  },
  {
    countryKey: 'RU',
    value: '57',
    label: 'The Oryol Area'
  },
  {
    countryKey: 'RU',
    value: '58',
    label: 'The Penza Area'
  },
  {
    countryKey: 'RU',
    value: '59',
    label: 'The Perm Area'
  },
  {
    countryKey: 'RU',
    value: '60',
    label: 'The Pskov Area'
  },
  {
    countryKey: 'RU',
    value: '61',
    label: 'The Rostov Area'
  },
  {
    countryKey: 'RU',
    value: '62',
    label: 'The Ryazan Area'
  },
  {
    countryKey: 'RU',
    value: '63',
    label: 'The Samara Area'
  },
  {
    countryKey: 'RU',
    value: '64',
    label: 'The Saratov Area'
  },
  {
    countryKey: 'RU',
    value: '65',
    label: 'The Sakhalin Area'
  },
  {
    countryKey: 'RU',
    value: '66',
    label: 'The Sverdlovsk Area'
  },
  {
    countryKey: 'RU',
    value: '67',
    label: 'The Smolensk Area'
  },
  {
    countryKey: 'RU',
    value: '68',
    label: 'The Tambov Area'
  },
  {
    countryKey: 'RU',
    value: '69',
    label: 'The Tver Area'
  },
  {
    countryKey: 'RU',
    value: '70',
    label: 'The Tomsk Area'
  },
  {
    countryKey: 'RU',
    value: '71',
    label: 'The Tula Area'
  },
  {
    countryKey: 'RU',
    value: '72',
    label: 'The Tyumen Area'
  },
  {
    countryKey: 'RU',
    value: '73',
    label: 'The Ulyanovsk Area'
  },
  {
    countryKey: 'RU',
    value: '74',
    label: 'The Chelyabinsk Area'
  },
  {
    countryKey: 'RU',
    value: '75',
    label: 'The Chita Area'
  },
  {
    countryKey: 'RU',
    value: '76',
    label: 'The Yaroslavl Area'
  },
  {
    countryKey: 'RU',
    value: '77',
    label: 'c.Moscow'
  },
  {
    countryKey: 'RU',
    value: '78',
    label: 'c.St-Peterburg'
  },
  {
    countryKey: 'RU',
    value: '79',
    label: 'The Jewish Auton.are'
  },
  {
    countryKey: 'RU',
    value: '80',
    label: 'Aginsk Buryat Aut.di'
  },
  {
    countryKey: 'RU',
    value: '81',
    label: 'Komy Permjats.Aut.di'
  },
  {
    countryKey: 'RU',
    value: '82',
    label: 'Korjacs Auton.distri'
  },
  {
    countryKey: 'RU',
    value: '83',
    label: 'Nenekchky Auton.dist'
  },
  {
    countryKey: 'RU',
    value: '84',
    label: 'The Taymir Auton.dis'
  },
  {
    countryKey: 'RU',
    value: '85',
    label: 'Ust-Ordinsky Buryat'
  },
  {
    countryKey: 'RU',
    value: '86',
    label: 'Chanti-Mansyjsky Aut'
  },
  {
    countryKey: 'RU',
    value: '87',
    label: 'Chukotka Auton. dist'
  },
  {
    countryKey: 'RU',
    value: '88',
    label: 'Evensky Auton.distri'
  },
  {
    countryKey: 'RU',
    value: '89',
    label: 'Jamalo-Nenekchky Aut'
  },
  {
    countryKey: 'SE',
    value: '1',
    label: 'Blekinge County'
  },
  {
    countryKey: 'SE',
    value: '2',
    label: 'Dalarnas County'
  },
  {
    countryKey: 'SE',
    value: '3',
    label: 'Gotland County'
  },
  {
    countryKey: 'SE',
    value: '4',
    label: 'Gaevleborg County'
  },
  {
    countryKey: 'SE',
    value: '5',
    label: 'Halland County'
  },
  {
    countryKey: 'SE',
    value: '6',
    label: 'Jaemtland County'
  },
  {
    countryKey: 'SE',
    value: '7',
    label: 'Joenkoeping County'
  },
  {
    countryKey: 'SE',
    value: '8',
    label: 'Kalmar County'
  },
  {
    countryKey: 'SE',
    value: '9',
    label: 'Kronoberg County'
  },
  {
    countryKey: 'SE',
    value: '10',
    label: 'Norrbotten County'
  },
  {
    countryKey: 'SE',
    value: '11',
    label: 'Skaane County'
  },
  {
    countryKey: 'SE',
    value: '12',
    label: 'Stockholm County'
  },
  {
    countryKey: 'SE',
    value: '13',
    label: 'Soedermanland County'
  },
  {
    countryKey: 'SE',
    value: '14',
    label: 'Uppsala County'
  },
  {
    countryKey: 'SE',
    value: '15',
    label: 'Vaermland County'
  },
  {
    countryKey: 'SE',
    value: '16',
    label: 'Vaesterbotten County'
  },
  {
    countryKey: 'SE',
    value: '17',
    label: 'Vaesternorrland Cnty'
  },
  {
    countryKey: 'SE',
    value: '18',
    label: 'Vaestmanland County'
  },
  {
    countryKey: 'SE',
    value: '19',
    label: 'Vaestra Goetaland C.'
  },
  {
    countryKey: 'SE',
    value: '20',
    label: 'Oerebro County'
  },
  {
    countryKey: 'SE',
    value: '21',
    label: 'Oestergoetland Cnty'
  },
  {
    countryKey: 'SG',
    value: 'SG',
    label: 'Singapore'
  },
  {
    countryKey: 'SI',
    value: '1',
    label: 'Ajdovscina'
  },
  {
    countryKey: 'SI',
    value: '2',
    label: 'Brezice'
  },
  {
    countryKey: 'SI',
    value: '3',
    label: 'Celje'
  },
  {
    countryKey: 'SI',
    value: '4',
    label: 'Cerknica'
  },
  {
    countryKey: 'SI',
    value: '5',
    label: 'Crnomelj'
  },
  {
    countryKey: 'SI',
    value: '6',
    label: 'Dravograd'
  },
  {
    countryKey: 'SI',
    value: '7',
    label: 'Gornja Radgona'
  },
  {
    countryKey: 'SI',
    value: '8',
    label: 'Grosuplje'
  },
  {
    countryKey: 'SI',
    value: '9',
    label: 'Hrastnik Lasko'
  },
  {
    countryKey: 'SI',
    value: '10',
    label: 'Idrija'
  },
  {
    countryKey: 'SI',
    value: '11',
    label: 'Ilirska Bistrica'
  },
  {
    countryKey: 'SI',
    value: '12',
    label: 'Izola'
  },
  {
    countryKey: 'SI',
    value: '13',
    label: 'Jesenice'
  },
  {
    countryKey: 'SI',
    value: '14',
    label: 'Kamnik'
  },
  {
    countryKey: 'SI',
    value: '15',
    label: 'Kocevje'
  },
  {
    countryKey: 'SI',
    value: '16',
    label: 'Koper'
  },
  {
    countryKey: 'SI',
    value: '17',
    label: 'Kranj'
  },
  {
    countryKey: 'SI',
    value: '18',
    label: 'Krsko'
  },
  {
    countryKey: 'SI',
    value: '19',
    label: 'Lenart'
  },
  {
    countryKey: 'SI',
    value: '20',
    label: 'Lendava'
  },
  {
    countryKey: 'SI',
    value: '21',
    label: 'Litija'
  },
  {
    countryKey: 'SI',
    value: '22',
    label: 'Ljubljana-Bezigrad'
  },
  {
    countryKey: 'SI',
    value: '23',
    label: 'Ljubljana-Center'
  },
  {
    countryKey: 'SI',
    value: '24',
    label: 'Ljubljana-Moste-Polj'
  },
  {
    countryKey: 'SI',
    value: '25',
    label: 'Ljubljana-Siska'
  },
  {
    countryKey: 'SI',
    value: '26',
    label: 'Ljubljana-Vic-Rudnik'
  },
  {
    countryKey: 'SI',
    value: '27',
    label: 'Ljutomer'
  },
  {
    countryKey: 'SI',
    value: '28',
    label: 'Logatec'
  },
  {
    countryKey: 'SI',
    value: '29',
    label: 'Maribor'
  },
  {
    countryKey: 'SI',
    value: '30',
    label: 'Metlika'
  },
  {
    countryKey: 'SI',
    value: '31',
    label: 'Mozirje'
  },
  {
    countryKey: 'SI',
    value: '32',
    label: 'Murska Sobota'
  },
  {
    countryKey: 'SI',
    value: '33',
    label: 'Nova Gorica'
  },
  {
    countryKey: 'SI',
    value: '34',
    label: 'Novo Mesto'
  },
  {
    countryKey: 'SI',
    value: '35',
    label: 'Ormoz'
  },
  {
    countryKey: 'SI',
    value: '36',
    label: 'Pesnica'
  },
  {
    countryKey: 'SI',
    value: '37',
    label: 'Piran'
  },
  {
    countryKey: 'SI',
    value: '38',
    label: 'Postojna'
  },
  {
    countryKey: 'SI',
    value: '39',
    label: 'Ptuj'
  },
  {
    countryKey: 'SI',
    value: '40',
    label: 'Radlje Ob Dravi'
  },
  {
    countryKey: 'SI',
    value: '41',
    label: 'Radovljica'
  },
  {
    countryKey: 'SI',
    value: '42',
    label: 'Ravne Na Koroskem'
  },
  {
    countryKey: 'SI',
    value: '43',
    label: 'Ribnica'
  },
  {
    countryKey: 'SI',
    value: '44',
    label: 'Ruse'
  },
  {
    countryKey: 'SI',
    value: '45',
    label: 'Sentjur Pri Celju'
  },
  {
    countryKey: 'SI',
    value: '46',
    label: 'Sevnica'
  },
  {
    countryKey: 'SI',
    value: '47',
    label: 'Sezana'
  },
  {
    countryKey: 'SI',
    value: '48',
    label: 'Skofja Loka'
  },
  {
    countryKey: 'SI',
    value: '49',
    label: 'Slovenj Gradec'
  },
  {
    countryKey: 'SI',
    value: '50',
    label: 'Slovenska Bistrica'
  },
  {
    countryKey: 'SI',
    value: '51',
    label: 'Slovenske Konjice'
  },
  {
    countryKey: 'SI',
    value: '52',
    label: 'Smarje Pri Jelsah'
  },
  {
    countryKey: 'SI',
    value: '53',
    label: 'Tolmin'
  },
  {
    countryKey: 'SI',
    value: '54',
    label: 'Trbovlje'
  },
  {
    countryKey: 'SI',
    value: '55',
    label: 'Trebnje'
  },
  {
    countryKey: 'SI',
    value: '56',
    label: 'Trzic'
  },
  {
    countryKey: 'SI',
    value: '57',
    label: 'Velenje'
  },
  {
    countryKey: 'SI',
    value: '58',
    label: 'Vrhnika'
  },
  {
    countryKey: 'SI',
    value: '59',
    label: 'Zagorje Ob Savi'
  },
  {
    countryKey: 'SI',
    value: '60',
    label: 'Zalec'
  },
  {
    countryKey: 'SK',
    value: '1',
    label: 'Bratislava'
  },
  {
    countryKey: 'SK',
    value: '2',
    label: 'Zapadoslovensky'
  },
  {
    countryKey: 'SK',
    value: '3',
    label: 'Stredoslovensky'
  },
  {
    countryKey: 'SK',
    value: '4',
    label: 'Vychodoslovensky'
  },
  {
    countryKey: 'SV',
    value: '1',
    label: 'San Salvaldor'
  },
  {
    countryKey: 'SV',
    value: 'La Libertad',
    label: 'La Libertad'
  },
  {
    countryKey: 'SV',
    value: '3',
    label: 'Sonsonate'
  },
  {
    countryKey: 'SV',
    value: '4',
    label: 'Ahuachapán'
  },
  {
    countryKey: 'SV',
    value: '5',
    label: 'Cabañas'
  },
  {
    countryKey: 'SV',
    value: '6',
    label: 'Chalatenango'
  },
  {
    countryKey: 'SV',
    value: '7',
    label: 'Cuscatlán'
  },
  {
    countryKey: 'SV',
    value: '8',
    label: 'La Paz'
  },
  {
    countryKey: 'SV',
    value: '9',
    label: 'La Unión'
  },
  {
    countryKey: 'SV',
    value: '10',
    label: 'Morazán'
  },
  {
    countryKey: 'SV',
    value: '11',
    label: 'San Miguel'
  },
  {
    countryKey: 'SV',
    value: '12',
    label: 'San Vicente'
  },
  {
    countryKey: 'SV',
    value: '13',
    label: 'Santa Ana'
  },
  {
    countryKey: 'SV',
    value: '14',
    label: 'Usulután'
  },
  {
    countryKey: 'TH',
    value: '1',
    label: 'Amnat Charoen'
  },
  {
    countryKey: 'TH',
    value: '2',
    label: 'Ang Thong'
  },
  {
    countryKey: 'TH',
    value: '3',
    label: 'Buriram'
  },
  {
    countryKey: 'TH',
    value: '4',
    label: 'Chachoengsao'
  },
  {
    countryKey: 'TH',
    value: '5',
    label: 'Chai Nat'
  },
  {
    countryKey: 'TH',
    value: '6',
    label: 'Chaiyaphum'
  },
  {
    countryKey: 'TH',
    value: '7',
    label: 'Chanthaburi'
  },
  {
    countryKey: 'TH',
    value: '8',
    label: 'Chiang Mai'
  },
  {
    countryKey: 'TH',
    value: '9',
    label: 'Chiang Rai'
  },
  {
    countryKey: 'TH',
    value: '10',
    label: 'Chon Buri'
  },
  {
    countryKey: 'TH',
    value: '11',
    label: 'Chumphon'
  },
  {
    countryKey: 'TH',
    value: '12',
    label: 'Kalasin'
  },
  {
    countryKey: 'TH',
    value: '13',
    label: 'Kamphaeng Phet'
  },
  {
    countryKey: 'TH',
    value: '14',
    label: 'Kanchanaburi'
  },
  {
    countryKey: 'TH',
    value: '15',
    label: 'Khon Kaen'
  },
  {
    countryKey: 'TH',
    value: '16',
    label: 'Krabi'
  },
  {
    countryKey: 'TH',
    value: '17',
    label: 'Krung Thep'
  },
  {
    countryKey: 'TH',
    value: '18',
    label: 'Mahanakhon'
  },
  {
    countryKey: 'TH',
    value: '19',
    label: 'Lampang'
  },
  {
    countryKey: 'TH',
    value: '20',
    label: 'Lamphun'
  },
  {
    countryKey: 'TH',
    value: '21',
    label: 'Loei'
  },
  {
    countryKey: 'TH',
    value: '22',
    label: 'Lop Buri'
  },
  {
    countryKey: 'TH',
    value: '23',
    label: 'Mae Hong Son'
  },
  {
    countryKey: 'TH',
    value: '24',
    label: 'Maha Sarakham'
  },
  {
    countryKey: 'TH',
    value: '25',
    label: 'Mukdahan'
  },
  {
    countryKey: 'TH',
    value: '26',
    label: 'Nakhon Nayok'
  },
  {
    countryKey: 'TH',
    value: '27',
    label: 'Nakhon Pathom'
  },
  {
    countryKey: 'TH',
    value: '28',
    label: 'Nakhon Phanom'
  },
  {
    countryKey: 'TH',
    value: '29',
    label: 'Nakhon Ratchasima'
  },
  {
    countryKey: 'TH',
    value: '30',
    label: 'Nakhon Sawan'
  },
  {
    countryKey: 'TH',
    value: '31',
    label: 'Nakhon Si Thammarat'
  },
  {
    countryKey: 'TH',
    value: '32',
    label: 'Nan'
  },
  {
    countryKey: 'TH',
    value: '33',
    label: 'Narathiwat'
  },
  {
    countryKey: 'TH',
    value: '34',
    label: 'Nong Bua Lamphu'
  },
  {
    countryKey: 'TH',
    value: '35',
    label: 'Nong Khai'
  },
  {
    countryKey: 'TH',
    value: '36',
    label: 'Nonthaburi'
  },
  {
    countryKey: 'TH',
    value: '37',
    label: 'Pathum Thani'
  },
  {
    countryKey: 'TH',
    value: '38',
    label: 'Pattani'
  },
  {
    countryKey: 'TH',
    value: '39',
    label: 'Phangnga'
  },
  {
    countryKey: 'TH',
    value: '40',
    label: 'Phatthalung'
  },
  {
    countryKey: 'TH',
    value: '41',
    label: 'Phayao'
  },
  {
    countryKey: 'TH',
    value: '42',
    label: 'Phetchabun'
  },
  {
    countryKey: 'TH',
    value: '43',
    label: 'Phetchaburi'
  },
  {
    countryKey: 'TH',
    value: '44',
    label: 'Phichit'
  },
  {
    countryKey: 'TH',
    value: '45',
    label: 'Phitsanulok'
  },
  {
    countryKey: 'TH',
    value: '46',
    label: 'Phra Nakhon Si Ayut.'
  },
  {
    countryKey: 'TH',
    value: '47',
    label: 'Phrae'
  },
  {
    countryKey: 'TH',
    value: '48',
    label: 'Phuket'
  },
  {
    countryKey: 'TH',
    value: '49',
    label: 'Prachin Buri'
  },
  {
    countryKey: 'TH',
    value: '50',
    label: 'Bueng Kan'
  },
  {
    countryKey: 'TH',
    value: '51',
    label: 'BANGKOK'
  },
  {
    countryKey: 'TH',
    value: '52',
    label: 'PRACHUAP KHIRI KHAN'
  },
  {
    countryKey: 'TH',
    value: '53',
    label: 'RANONG'
  },
  {
    countryKey: 'TH',
    value: '54',
    label: 'RATCHABURI'
  },
  {
    countryKey: 'TH',
    value: '55',
    label: 'RAYONG'
  },
  {
    countryKey: 'TH',
    value: '56',
    label: 'ROI ET'
  },
  {
    countryKey: 'TH',
    value: '57',
    label: 'SA KAEO'
  },
  {
    countryKey: 'TH',
    value: '58',
    label: 'SAKON NAKHON'
  },
  {
    countryKey: 'TH',
    value: '59',
    label: 'SAMUT PRAKAN'
  },
  {
    countryKey: 'TH',
    value: '60',
    label: 'SAMUT SAKHON'
  },
  {
    countryKey: 'TH',
    value: '61',
    label: 'SAMUT SONGKHRAM'
  },
  {
    countryKey: 'TH',
    value: '62',
    label: 'SARABURI'
  },
  {
    countryKey: 'TH',
    value: '63',
    label: 'SATUN'
  },
  {
    countryKey: 'TH',
    value: '64',
    label: 'SI SA KET'
  },
  {
    countryKey: 'TH',
    value: '65',
    label: 'SING BURI'
  },
  {
    countryKey: 'TH',
    value: '66',
    label: 'SONGKHLA'
  },
  {
    countryKey: 'TH',
    value: '67',
    label: 'SUKHOTHAI'
  },
  {
    countryKey: 'TH',
    value: '68',
    label: 'SUPHAN BURI'
  },
  {
    countryKey: 'TH',
    value: '69',
    label: 'SURAT THANI'
  },
  {
    countryKey: 'TH',
    value: '70',
    label: 'SURIN'
  },
  {
    countryKey: 'TH',
    value: '71',
    label: 'TAK'
  },
  {
    countryKey: 'TH',
    value: '72',
    label: 'TRANG'
  },
  {
    countryKey: 'TH',
    value: '73',
    label: 'TRAT'
  },
  {
    countryKey: 'TH',
    value: '74',
    label: 'UBON RATCHATHANI'
  },
  {
    countryKey: 'TH',
    value: '75',
    label: 'UDON THANI'
  },
  {
    countryKey: 'TH',
    value: '76',
    label: 'UTHAI THANI'
  },
  {
    countryKey: 'TH',
    value: '77',
    label: 'UTTARADIT'
  },
  {
    countryKey: 'TH',
    value: '78',
    label: 'YALA'
  },
  {
    countryKey: 'TH',
    value: '79',
    label: 'YASOTHON'
  },
  {
    countryKey: 'TR',
    value: '1',
    label: 'Adana'
  },
  {
    countryKey: 'TR',
    value: '2',
    label: 'Adiyaman'
  },
  {
    countryKey: 'TR',
    value: '3',
    label: 'Afyonkarahisar'
  },
  {
    countryKey: 'TR',
    value: '4',
    label: 'Ağrı'
  },
  {
    countryKey: 'TR',
    value: '5',
    label: 'Amasya'
  },
  {
    countryKey: 'TR',
    value: '6',
    label: 'Ankara'
  },
  {
    countryKey: 'TR',
    value: '7',
    label: 'Antalya'
  },
  {
    countryKey: 'TR',
    value: '8',
    label: 'Artvin'
  },
  {
    countryKey: 'TR',
    value: '9',
    label: 'Aydin'
  },
  {
    countryKey: 'TR',
    value: '10',
    label: 'Balikesir'
  },
  {
    countryKey: 'TR',
    value: '11',
    label: 'Bilecik'
  },
  {
    countryKey: 'TR',
    value: '12',
    label: 'Bingöl'
  },
  {
    countryKey: 'TR',
    value: '13',
    label: 'Bitlis'
  },
  {
    countryKey: 'TR',
    value: '14',
    label: 'Bolu'
  },
  {
    countryKey: 'TR',
    value: '15',
    label: 'Burdur'
  },
  {
    countryKey: 'TR',
    value: '16',
    label: 'Bursa'
  },
  {
    countryKey: 'TR',
    value: '17',
    label: 'Canakkale'
  },
  {
    countryKey: 'TR',
    value: '18',
    label: 'Cankiri'
  },
  {
    countryKey: 'TR',
    value: '19',
    label: 'Corum'
  },
  {
    countryKey: 'TR',
    value: '20',
    label: 'Denizli'
  },
  {
    countryKey: 'TR',
    value: '21',
    label: 'Diyarbakir'
  },
  {
    countryKey: 'TR',
    value: '22',
    label: 'Edirne'
  },
  {
    countryKey: 'TR',
    value: '23',
    label: 'Elazig'
  },
  {
    countryKey: 'TR',
    value: '24',
    label: 'Erzincan'
  },
  {
    countryKey: 'TR',
    value: '25',
    label: 'Erzurum'
  },
  {
    countryKey: 'TR',
    value: '26',
    label: 'Eskisehir'
  },
  {
    countryKey: 'TR',
    value: '27',
    label: 'Gaziantep'
  },
  {
    countryKey: 'TR',
    value: '28',
    label: 'Giresun'
  },
  {
    countryKey: 'TR',
    value: '29',
    label: 'Guemueshane'
  },
  {
    countryKey: 'TR',
    value: '30',
    label: 'Hakkari'
  },
  {
    countryKey: 'TR',
    value: '31',
    label: 'Hatay'
  },
  {
    countryKey: 'TR',
    value: '32',
    label: 'Isparta'
  },
  {
    countryKey: 'TR',
    value: '33',
    label: 'Mersin'
  },
  {
    countryKey: 'TR',
    value: '34',
    label: 'Istanbul'
  },
  {
    countryKey: 'TR',
    value: '35',
    label: 'Izmir'
  },
  {
    countryKey: 'TR',
    value: '36',
    label: 'Kars'
  },
  {
    countryKey: 'TR',
    value: '37',
    label: 'Kastamonu'
  },
  {
    countryKey: 'TR',
    value: '38',
    label: 'Kayseri'
  },
  {
    countryKey: 'TR',
    value: '39',
    label: 'Kirklareli'
  },
  {
    countryKey: 'TR',
    value: '40',
    label: 'Kirshehir'
  },
  {
    countryKey: 'TR',
    value: '41',
    label: 'Kocaeli'
  },
  {
    countryKey: 'TR',
    value: '42',
    label: 'Konya'
  },
  {
    countryKey: 'TR',
    value: '43',
    label: 'Kuetahya'
  },
  {
    countryKey: 'TR',
    value: '44',
    label: 'Malatya'
  },
  {
    countryKey: 'TR',
    value: '45',
    label: 'Manisa'
  },
  {
    countryKey: 'TR',
    value: '46',
    label: 'Kahramanmaraş'
  },
  {
    countryKey: 'TR',
    value: '47',
    label: 'Mardin'
  },
  {
    countryKey: 'TR',
    value: '48',
    label: 'Mugla'
  },
  {
    countryKey: 'TR',
    value: '49',
    label: 'Mush'
  },
  {
    countryKey: 'TR',
    value: '50',
    label: 'Nevshehir'
  },
  {
    countryKey: 'TR',
    value: '51',
    label: 'Nigde'
  },
  {
    countryKey: 'TR',
    value: '52',
    label: 'Ordu'
  },
  {
    countryKey: 'TR',
    value: '53',
    label: 'Rize'
  },
  {
    countryKey: 'TR',
    value: '54',
    label: 'Sakarya'
  },
  {
    countryKey: 'TR',
    value: '55',
    label: 'Samsun'
  },
  {
    countryKey: 'TR',
    value: '56',
    label: 'Siirt'
  },
  {
    countryKey: 'TR',
    value: '57',
    label: 'Sinop'
  },
  {
    countryKey: 'TR',
    value: '58',
    label: 'Sivas'
  },
  {
    countryKey: 'TR',
    value: '59',
    label: 'Tekirdag'
  },
  {
    countryKey: 'TR',
    value: '60',
    label: 'Tokat'
  },
  {
    countryKey: 'TR',
    value: '61',
    label: 'Trabzon'
  },
  {
    countryKey: 'TR',
    value: '62',
    label: 'Tunceli'
  },
  {
    countryKey: 'TR',
    value: '63',
    label: 'Shanliurfa'
  },
  {
    countryKey: 'TR',
    value: '64',
    label: 'Ushak'
  },
  {
    countryKey: 'TR',
    value: '65',
    label: 'Van'
  },
  {
    countryKey: 'TR',
    value: '66',
    label: 'Yozgat'
  },
  {
    countryKey: 'TR',
    value: '67',
    label: 'Zonguldak'
  },
  {
    countryKey: 'TR',
    value: '68',
    label: 'Aksaray'
  },
  {
    countryKey: 'TR',
    value: '69',
    label: 'Bayburt'
  },
  {
    countryKey: 'TR',
    value: '70',
    label: 'Karaman'
  },
  {
    countryKey: 'TR',
    value: '71',
    label: 'Kirikkale'
  },
  {
    countryKey: 'TR',
    value: '72',
    label: 'Batman'
  },
  {
    countryKey: 'TR',
    value: '73',
    label: 'Shirnak'
  },
  {
    countryKey: 'TR',
    value: '74',
    label: 'Bartin'
  },
  {
    countryKey: 'TR',
    value: '75',
    label: 'Ardahan'
  },
  {
    countryKey: 'TR',
    value: '76',
    label: 'Igdir'
  },
  {
    countryKey: 'TR',
    value: '77',
    label: 'Yalova'
  },
  {
    countryKey: 'TR',
    value: '78',
    label: 'Karabük'
  },
  {
    countryKey: 'TR',
    value: '79',
    label: 'Kilis'
  },
  {
    countryKey: 'TR',
    value: '80',
    label: 'Osmaniye'
  },
  {
    countryKey: 'TR',
    value: '81',
    label: 'Düzce'
  },
  {
    countryKey: 'TW',
    value: 'FJN',
    label: 'Fu-chien'
  },
  {
    countryKey: 'TW',
    value: 'KSH',
    label: 'Kao-hsiung'
  },
  {
    countryKey: 'TW',
    value: 'TPE',
    label: 'T´ai-pei'
  },
  {
    countryKey: 'TW',
    value: 'TWN',
    label: 'Taiwan'
  },
  {
    countryKey: 'UA',
    value: 'CHG',
    label: "Chernigivs'ka"
  },
  {
    countryKey: 'UA',
    value: 'CHR',
    label: "Cherkas'ka"
  },
  {
    countryKey: 'UA',
    value: 'CHV',
    label: "Chernovits'ka"
  },
  {
    countryKey: 'UA',
    value: 'DNP',
    label: "Dnipropetrovs'ka"
  },
  {
    countryKey: 'UA',
    value: 'DON',
    label: "Donets'ka"
  },
  {
    countryKey: 'UA',
    value: 'HAR',
    label: "Harkivs'ka"
  },
  {
    countryKey: 'UA',
    value: 'HML',
    label: "Hmel'nits'ka"
  },
  {
    countryKey: 'UA',
    value: 'HRS',
    label: "Hersons'ka"
  },
  {
    countryKey: 'UA',
    value: 'IVF',
    label: "Ivano-Frankivs'ka"
  },
  {
    countryKey: 'UA',
    value: 'KIE',
    label: "Kievs'ka"
  },
  {
    countryKey: 'UA',
    value: 'KIR',
    label: "Kirovograds'ka"
  },
  {
    countryKey: 'UA',
    value: 'KRM',
    label: 'Respublika Krim'
  },
  {
    countryKey: 'UA',
    value: "L'V",
    label: "L'vivsbka"
  },
  {
    countryKey: 'UA',
    value: 'LUG',
    label: "Lugans'ka"
  },
  {
    countryKey: 'UA',
    value: 'MIK',
    label: "Mikolaivs'ka"
  },
  {
    countryKey: 'UA',
    value: 'M_K',
    label: 'm.Kiev'
  },
  {
    countryKey: 'UA',
    value: "M_S'",
    label: "m.Sevastopil'"
  },
  {
    countryKey: 'UA',
    value: 'ODS',
    label: "Odes'ka"
  },
  {
    countryKey: 'UA',
    value: 'POL',
    label: "Poltavs'ka"
  },
  {
    countryKey: 'UA',
    value: 'RIV',
    label: "Rivnens'ka"
  },
  {
    countryKey: 'UA',
    value: 'SUM',
    label: "Sums'ka"
  },
  {
    countryKey: 'UA',
    value: 'TER',
    label: "Ternopil's'ka"
  },
  {
    countryKey: 'UA',
    value: 'VIN',
    label: "Vinnits'ka"
  },
  {
    countryKey: 'UA',
    value: 'VOL',
    label: "Volins'ka"
  },
  {
    countryKey: 'UA',
    value: 'ZAK',
    label: "Zakarpats'ka"
  },
  {
    countryKey: 'UA',
    value: 'ZAP',
    label: "Zaporiz'ka"
  },
  {
    countryKey: 'UA',
    value: 'ZHI',
    label: "Zhitomirs'ka"
  },
  {
    countryKey: 'US',
    value: 'AL',
    label: 'Alabama'
  },
  {
    countryKey: 'US',
    value: 'AK',
    label: 'Alaska'
  },
  {
    countryKey: 'US',
    value: 'AS',
    label: 'American Samoa'
  },
  {
    countryKey: 'US',
    value: 'AZ',
    label: 'Arizona'
  },
  {
    countryKey: 'US',
    value: 'AR',
    label: 'Arkansas'
  },
  {
    countryKey: 'US',
    value: 'CA',
    label: 'California'
  },
  {
    countryKey: 'US',
    value: 'CO',
    label: 'Colorado'
  },
  {
    countryKey: 'US',
    value: 'CT',
    label: 'Connecticut'
  },
  {
    countryKey: 'US',
    value: 'DE',
    label: 'Delaware'
  },
  {
    countryKey: 'US',
    value: 'DC',
    label: 'District of Columbia'
  },
  {
    countryKey: 'US',
    value: 'FL',
    label: 'Florida'
  },
  {
    countryKey: 'US',
    value: 'GA',
    label: 'Georgia'
  },
  {
    countryKey: 'US',
    value: 'GU',
    label: 'Guam'
  },
  {
    countryKey: 'US',
    value: 'HI',
    label: 'Hawaii'
  },
  {
    countryKey: 'US',
    value: 'ID',
    label: 'Idaho'
  },
  {
    countryKey: 'US',
    value: 'IL',
    label: 'Illinois'
  },
  {
    countryKey: 'US',
    value: 'IN',
    label: 'Indiana'
  },
  {
    countryKey: 'US',
    value: 'IA',
    label: 'Iowa'
  },
  {
    countryKey: 'US',
    value: 'KS',
    label: 'Kansas'
  },
  {
    countryKey: 'US',
    value: 'KY',
    label: 'Kentucky'
  },
  {
    countryKey: 'US',
    value: 'LA',
    label: 'Louisiana'
  },
  {
    countryKey: 'US',
    value: 'ME',
    label: 'Maine'
  },
  {
    countryKey: 'US',
    value: 'MD',
    label: 'Maryland'
  },
  {
    countryKey: 'US',
    value: 'MA',
    label: 'Massachusetts'
  },
  {
    countryKey: 'US',
    value: 'MI',
    label: 'Michigan'
  },
  {
    countryKey: 'US',
    value: 'MN',
    label: 'Minnesota'
  },
  {
    countryKey: 'US',
    value: 'Mississippi',
    label: 'Mississippi'
  },
  {
    countryKey: 'US',
    value: 'MO',
    label: 'Missouri'
  },
  {
    countryKey: 'US',
    value: 'MT',
    label: 'Montana'
  },
  {
    countryKey: 'US',
    value: 'NE',
    label: 'Nebraska'
  },
  {
    countryKey: 'US',
    value: 'NV',
    label: 'Nevada'
  },
  {
    countryKey: 'US',
    value: 'NH',
    label: 'New Hampshire'
  },
  {
    countryKey: 'US',
    value: 'NJ',
    label: 'New Jersey'
  },
  {
    countryKey: 'US',
    value: 'NM',
    label: 'New Mexico'
  },
  {
    countryKey: 'US',
    value: 'NY',
    label: 'New York'
  },
  {
    countryKey: 'US',
    value: 'NC',
    label: 'North Carolina'
  },
  {
    countryKey: 'US',
    value: 'ND',
    label: 'North Dakota'
  },
  {
    countryKey: 'US',
    value: 'MP',
    label: 'Northern Mariana Isl'
  },
  {
    countryKey: 'US',
    value: 'OH',
    label: 'Ohio'
  },
  {
    countryKey: 'US',
    value: 'OK',
    label: 'Oklahoma'
  },
  {
    countryKey: 'US',
    value: 'OR',
    label: 'Oregon'
  },
  {
    countryKey: 'US',
    value: 'PA',
    label: 'Pennsylvania'
  },
  {
    countryKey: 'US',
    value: 'PR',
    label: 'Puerto Rico'
  },
  {
    countryKey: 'US',
    value: 'RI',
    label: 'Rhode Island'
  },
  {
    countryKey: 'US',
    value: 'SC',
    label: 'South Carolina'
  },
  {
    countryKey: 'US',
    value: 'SD',
    label: 'South Dakota'
  },
  {
    countryKey: 'US',
    value: 'TN',
    label: 'Tennessee'
  },
  {
    countryKey: 'US',
    value: 'TX',
    label: 'Texas'
  },
  {
    countryKey: 'US',
    value: 'UT',
    label: 'Utah'
  },
  {
    countryKey: 'US',
    value: 'VT',
    label: 'Vermont'
  },
  {
    countryKey: 'US',
    value: 'VA',
    label: 'Virginia'
  },
  {
    countryKey: 'US',
    value: 'VI',
    label: 'Virgin Islands'
  },
  {
    countryKey: 'US',
    value: 'WA',
    label: 'Washington'
  },
  {
    countryKey: 'US',
    value: 'WV',
    label: 'West Virginia'
  },
  {
    countryKey: 'US',
    value: 'WI',
    label: 'Wisconsin'
  },
  {
    countryKey: 'US',
    value: 'WY',
    label: 'Wyoming'
  },
  {
    countryKey: 'UY',
    value: '1',
    label: 'Montevideo'
  },
  {
    countryKey: 'VE',
    value: 'Amazon',
    label: 'Amazon'
  },
  {
    countryKey: 'VE',
    value: 'ANZ',
    label: 'Anzoategui'
  },
  {
    countryKey: 'VE',
    value: 'APU',
    label: 'Apure'
  },
  {
    countryKey: 'VE',
    value: 'ARA',
    label: 'Aragua'
  },
  {
    countryKey: 'VE',
    value: 'BAR',
    label: 'Barinas'
  },
  {
    countryKey: 'VE',
    value: 'BOL',
    label: 'Bolivar'
  },
  {
    countryKey: 'VE',
    value: 'CAR',
    label: 'Carabobo'
  },
  {
    countryKey: 'VE',
    value: 'COJ',
    label: 'Cojedes'
  },
  {
    countryKey: 'VE',
    value: 'DA',
    label: 'Delta Amacuro'
  },
  {
    countryKey: 'VE',
    value: 'DF',
    label: 'DF'
  },
  {
    countryKey: 'VE',
    value: 'FAL',
    label: 'Falcon'
  },
  {
    countryKey: 'VE',
    value: 'GUA',
    label: 'Guarico'
  },
  {
    countryKey: 'VE',
    value: 'LAR',
    label: 'Lara'
  },
  {
    countryKey: 'VE',
    value: 'MER',
    label: 'Merida'
  },
  {
    countryKey: 'VE',
    value: 'MIR',
    label: 'Miranda'
  },
  {
    countryKey: 'VE',
    value: 'MOR',
    label: 'Monagas'
  },
  {
    countryKey: 'VE',
    value: 'NE',
    label: 'Nueva Esparta'
  },
  {
    countryKey: 'VE',
    value: 'POR',
    label: 'Portuguesa'
  },
  {
    countryKey: 'VE',
    value: 'Sucre',
    label: 'Sucre'
  },
  {
    countryKey: 'VE',
    value: 'TAC',
    label: 'Tachira'
  },
  {
    countryKey: 'VE',
    value: 'TRU',
    label: 'Trujillo'
  },
  {
    countryKey: 'VE',
    value: 'VAR',
    label: 'Vargas'
  },
  {
    countryKey: 'VE',
    value: 'YAR',
    label: 'Yaracuy'
  },
  {
    countryKey: 'VE',
    value: 'ZUL',
    label: 'Zulia'
  },
  {
    countryKey: 'ZA',
    value: 'EC',
    label: 'Eastern Cape'
  },
  {
    countryKey: 'ZA',
    value: 'FS',
    label: 'Freestate'
  },
  {
    countryKey: 'ZA',
    value: 'GP',
    label: 'Gauteng'
  },
  {
    countryKey: 'ZA',
    value: 'KZN',
    label: 'Kwazulu/Natal'
  },
  {
    countryKey: 'ZA',
    value: 'LP',
    label: 'Limpopo'
  },
  {
    countryKey: 'ZA',
    value: 'MP',
    label: 'Mpumalanga'
  },
  {
    countryKey: 'ZA',
    value: 'NC',
    label: 'Northern Cape'
  },
  {
    countryKey: 'ZA',
    value: 'NP',
    label: 'Northern Province'
  },
  {
    countryKey: 'ZA',
    value: 'NW',
    label: 'North-West'
  },
  {
    countryKey: 'ZA',
    value: 'WC',
    label: 'Western Cape'
  },
  {
    countryKey: 'ZA',
    value: 'KwaZulu-Natal',
    label: 'KwaZulu-Natal'
  }
];

export const countryList = [
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'VI', label: 'Amer.Virgin Is.' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AI', label: 'Anguilla' },
  { value: 'AQ', label: 'Antarctica' },
  { value: 'AG', label: 'Antigua/Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AW', label: 'Aruba' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BO', label: 'Bolivia' },
  { value: 'BQ', label: 'Bonaire, Saba' },
  { value: 'BA', label: 'Bosnia-Herz.' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BV', label: 'Bouvet Islands' },
  { value: 'BR', label: 'Brazil' },
  { value: 'IO', label: 'Brit.Ind.Oc.Ter' },
  { value: 'VG', label: 'Brit.Virgin Is.' },
  { value: 'BN', label: 'Brunei Daruss.' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'MM', label: 'Burma' },
  { value: 'BI', label: 'Burundi' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'CA', label: 'Canada' },
  { value: 'CV', label: 'Cape Verde' },
  { value: 'CF', label: 'CAR' },
  { value: 'KY', label: 'Cayman Islands' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CX', label: 'Christmas Islnd' },
  { value: 'CC', label: 'Coconut Islands' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoros' },
  { value: 'CK', label: 'Cook Islands' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'CI', label: "Cote d'Ivoire" },
  { value: 'HR', label: 'Croatia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CW', label: 'Curaçao' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czech Republic' },
  { value: 'CD', label: 'Dem. Rep. Congo' },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Rep.' },
  { value: 'AN', label: 'Dutch Antilles' },
  { value: 'TL', label: 'East Timor' },
  { value: 'TP', label: 'East Timor' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'GQ', label: 'Equatorial Guin' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'EU', label: 'European Union' },
  { value: 'FK', label: 'Falkland Islnds' },
  { value: 'FO', label: 'Faroe Islands' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'PF', label: 'Frenc.Polynesia' },
  { value: 'GF', label: 'French Guayana' },
  { value: 'TF', label: 'French S.Territ' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GM', label: 'Gambia' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GI', label: 'Gibraltar' },
  { value: 'GR', label: 'Greece' },
  { value: 'GL', label: 'Greenland' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GP', label: 'Guadeloupe' },
  { value: 'GU', label: 'Guam' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HM', label: 'Heard/McDon.Isl' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Iran' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'XK', label: 'kosovo' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: 'Laos' },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libya' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MO', label: 'Macau' },
  { value: 'MK', label: 'Macedonia' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islnds' },
  { value: 'MQ', label: 'Martinique' },
  { value: 'MR', label: 'Mauretania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'YT', label: 'Mayotte' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia' },
  { value: 'UM', label: 'Minor Outl.Isl.' },
  { value: 'MD', label: 'Moldova' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MS', label: 'Montserrat' },
  { value: 'MA', label: 'Morocco' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MP', label: 'N.Mariana Islnd' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NT', label: 'NATO' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NC', label: 'New Caledonia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Niger' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NU', label: 'Niue' },
  { value: 'NF', label: 'Norfolk Islands' },
  { value: 'KP', label: 'North Korea' },
  { value: 'NO', label: 'Norway' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PS', label: 'Palestine' },
  { value: 'PA', label: 'Panama' },
  { value: 'PG', label: 'Pap. New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines' },
  { value: 'PN', label: 'Pitcairn Islnds' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'QA', label: 'Qatar' },
  { value: 'CG', label: 'Rep.of Congo' },
  { value: 'RE', label: 'Reunion' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russian Fed.' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'GS', label: 'S. Sandwich Ins' },
  { value: 'ST', label: 'S.Tome,Principe' },
  { value: 'SH', label: 'Saint Helena' },
  { value: 'WS', label: 'Samoa' },
  { value: 'AS', label: 'Samoa, America' },
  { value: 'SM', label: 'San Marino' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'CS', label: 'Serbia/Monten.' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SX', label: 'Sint Marten' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'SO', label: 'Somalia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'KR', label: 'South Korea' },
  { value: 'SS', label: 'South Sudan' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'KN', label: 'St Kitts&Nevis' },
  { value: 'BL', label: 'St. Barthélemy' },
  { value: 'LC', label: 'St. Lucia' },
  { value: 'VC', label: 'St. Vincent' },
  { value: 'PM', label: 'St.Pier,Miquel.' },
  { value: 'SD', label: 'Sudan' },
  { value: 'SR', label: 'Suriname' },
  { value: 'SJ', label: 'Svalbard' },
  { value: 'SZ', label: 'Swaziland' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'SY', label: 'Syria' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TZ', label: 'Tanzania' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TG', label: 'Togo' },
  { value: 'TK', label: 'Tokelau Islands' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad,Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'TC', label: 'Turksh Caicosin' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'GB', label: 'United Kingdom' },
  { value: 'UN', label: 'United Nations' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'US', label: 'USA' },
  { value: 'AE', label: 'Utd.Arab Emir.' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VA', label: 'Vatican City' },
  { value: 'VE', label: 'Venezuela' },
  { value: 'VN', label: 'Vietnam' },
  { value: 'WF', label: 'Wallis,Futuna' },
  { value: 'EH', label: 'West Sahara' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabwe' }
];

export const countries = countryList.filter(country => states.filter(state => state.countryKey === country.value)[0]);
